import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ANY: any;
  DateTime: any;
  JSON: any;
  json: any;
  jsonb: any;
  numeric: any;
  timestamp: any;
  timestamptz: any;
  timetz: any;
  uuid: any;
};


export type AbsentModel = {
  __typename?: 'AbsentModel';
  classDate?: Maybe<Scalars['DateTime']>;
  className?: Maybe<Scalars['String']>;
};

export type AbsentStudentModel = {
  __typename?: 'AbsentStudentModel';
  absents?: Maybe<Array<Maybe<AbsentModel>>>;
  classId?: Maybe<Scalars['String']>;
  emailStatus?: Maybe<Scalars['String']>;
  programName?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['String']>;
  studentName?: Maybe<Scalars['String']>;
  studentParent?: Maybe<Scalars['JSON']>;
};

export type AbsentStudentPaginationModel = {
  __typename?: 'AbsentStudentPaginationModel';
  data?: Maybe<Array<Maybe<AbsentStudentModel>>>;
  page?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  totalCount?: Maybe<Scalars['Float']>;
};

export type AdditionalLesson = {
  __typename?: 'AdditionalLesson';
  pricing?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Float']>;
};

/** expression to compare columns of type Boolean. All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: Maybe<Scalars['Boolean']>;
  _gt?: Maybe<Scalars['Boolean']>;
  _gte?: Maybe<Scalars['Boolean']>;
  _in?: Maybe<Array<Scalars['Boolean']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Boolean']>;
  _lte?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Scalars['Boolean']>;
  _nin?: Maybe<Array<Scalars['Boolean']>>;
};

export type BranchModel = {
  __typename?: 'BranchModel';
  address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ChangeUserAttributeInput = {
  attributeName: Scalars['String'];
  attributeValue: Scalars['ANY'];
  forceChange?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
};

export type ClassBill = {
  __typename?: 'ClassBill';
  data?: Maybe<Array<Maybe<ClassDetail>>>;
  total?: Maybe<Scalars['Float']>;
};

export type ClassBillInfo = {
  __typename?: 'ClassBillInfo';
  classFee?: Maybe<Scalars['Float']>;
  paidLessons?: Maybe<Scalars['Int']>;
  passedLessons?: Maybe<Scalars['Int']>;
  terms?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ClassData = {
  __typename?: 'ClassData';
  additionalDiscount?: Maybe<Scalars['Float']>;
  additionalLesson?: Maybe<AdditionalLesson>;
  classStatus?: Maybe<Scalars['String']>;
  classType?: Maybe<Scalars['String']>;
  discounts?: Maybe<Array<Maybe<DiscountClass>>>;
  id?: Maybe<Scalars['String']>;
  lessonStartDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  period?: Maybe<Period>;
  programId?: Maybe<Scalars['String']>;
  terms?: Maybe<Array<Maybe<TermData>>>;
  total?: Maybe<Scalars['Float']>;
  totalDiscount?: Maybe<Scalars['Float']>;
};

export type ClassDetail = {
  __typename?: 'ClassDetail';
  additionalDiscount?: Maybe<Scalars['Float']>;
  additionalLesson?: Maybe<AdditionalLesson>;
  branch?: Maybe<Scalars['String']>;
  classType?: Maybe<Scalars['String']>;
  curriculums?: Maybe<Array<Maybe<Scalars['String']>>>;
  discounts?: Maybe<Array<Maybe<DiscountClass>>>;
  firstSession?: Maybe<Session>;
  id?: Maybe<Scalars['String']>;
  lessonStartDate?: Maybe<Scalars['DateTime']>;
  levels?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  period?: Maybe<Period>;
  programId?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  terms?: Maybe<Array<Maybe<TermDetail>>>;
  total?: Maybe<Scalars['Float']>;
  totalDiscount?: Maybe<Scalars['Float']>;
};

export type ClassFee = {
  __typename?: 'ClassFee';
  data?: Maybe<Array<Maybe<ClassData>>>;
  total?: Maybe<Scalars['Float']>;
};

export type ClassInformation = {
  __typename?: 'ClassInformation';
  additionalLesson?: Maybe<AdditionalLesson>;
  classStatus?: Maybe<Scalars['String']>;
  classType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lessonStartDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  period?: Maybe<Period>;
  programId?: Maybe<Scalars['String']>;
  terms?: Maybe<Array<Maybe<TermInClassInformation>>>;
  total?: Maybe<Scalars['Float']>;
};

export type ClassInformationCreditNote = {
  __typename?: 'ClassInformationCreditNote';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  terms?: Maybe<Array<Maybe<TermInClassInformation>>>;
};

export type ClassInformationModel = {
  __typename?: 'ClassInformationModel';
  classId?: Maybe<Scalars['String']>;
  classTotal?: Maybe<Scalars['Float']>;
  deduction?: Maybe<OutFee>;
  lastLessonDate?: Maybe<Scalars['DateTime']>;
  leftLessonAmount?: Maybe<Scalars['Int']>;
  leftLessonNo?: Maybe<Scalars['Int']>;
  lessonDates?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  name?: Maybe<Scalars['String']>;
  otherPayments?: Maybe<OutFee>;
  oweLessonNo?: Maybe<Scalars['Int']>;
  receiptId?: Maybe<Scalars['String']>;
  summary?: Maybe<SubTotal>;
  unitPrice?: Maybe<Scalars['Float']>;
};

export type ClassModel = {
  __typename?: 'ClassModel';
  academicYear?: Maybe<Scalars['String']>;
  classPaymentStatus?: Maybe<ClassPaymentStatusModel>;
  classStatus?: Maybe<Scalars['String']>;
  currentStudentStatus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<Scalars['String']>;
  programCategory?: Maybe<Scalars['String']>;
  programType?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type ClassOfStudent = {
  __typename?: 'ClassOfStudent';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ClassPaymentStatusModel = {
  __typename?: 'ClassPaymentStatusModel';
  statusPaid?: Maybe<Array<Maybe<Scalars['String']>>>;
  statusUnpaid?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CreateStudentForm = {
  avatar?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  payOnline?: Maybe<Scalars['Boolean']>;
  phone: InputAnon174;
  username: Scalars['String'];
};

export type CreateUserForm = {
  address?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<Maybe<InputAnon151>>>;
  avatar?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  bankNumber?: Maybe<Scalars['String']>;
  branchId?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  levelIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  phone: InputAnon221;
  role?: Maybe<Scalars['String']>;
  roleIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  subjectIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  username: Scalars['String'];
};

export type CreditNoteModel = {
  __typename?: 'CreditNoteModel';
  approvedAt?: Maybe<Scalars['DateTime']>;
  approverId?: Maybe<Scalars['String']>;
  creditNoteClassId?: Maybe<Scalars['String']>;
  creditNoteFeeId?: Maybe<Scalars['String']>;
  creditNoteStatus?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['JSON']>;
  type?: Maybe<Scalars['String']>;
};

export type CurriculumModel = {
  __typename?: 'CurriculumModel';
  abbreviation?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type DataFee = {
  __typename?: 'DataFee';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};


export type DeleteUserForm = {
  id: Scalars['String'];
};

export type DiscountClass = {
  __typename?: 'DiscountClass';
  amount?: Maybe<Scalars['Float']>;
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
};

export type Fee = {
  __typename?: 'Fee';
  amount?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
};

export type FilterAbsentStudents = {
  filter?: Maybe<InputAnon215>;
  pagination: InputAnon216;
};

export type FilterClassList = {
  filter?: Maybe<InputAnon212>;
  pagination: InputAnon214;
};

export type ForgotPasswordModel = {
  __typename?: 'ForgotPasswordModel';
  email?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  userCognitoId?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type FormAddStudentToLesson = {
  lessonId: Scalars['String'];
  oldLessonId?: Maybe<Scalars['String']>;
  oriLessonId?: Maybe<Scalars['String']>;
  studentId: Scalars['String'];
  type: Scalars['String'];
};

export type FormAddStudentToWaitingList = {
  studentIds: Array<Maybe<Scalars['String']>>;
};

export type FormBatchPaymentAdvice = {
  academyCalendarId: Scalars['String'];
  academyYear: Scalars['String'];
  additionalDoubleLesson: Scalars['Float'];
  additionalRegularLesson: Scalars['Float'];
  applyDiscountIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  checkDiscountIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  curriculumId: Scalars['String'];
  dueDate: Scalars['String'];
  issueDate: Scalars['String'];
  levelIds: Array<Scalars['String']>;
  paymentStatus: Array<Maybe<Scalars['String']>>;
  startDate?: Maybe<Scalars['String']>;
  termId: Scalars['String'];
  termName: Scalars['String'];
};

export type FormCancelTransferClass = {
  transferClassId: Scalars['String'];
};

export type FormChangeClassStatus = {
  classStatus: Scalars['String'];
  forceOpen?: Maybe<Scalars['ANY']>;
};

export type FormChangeCreditNoteStatus = {
  status: Scalars['String'];
};

export type FormChangeUserPassword = {
  id: Scalars['String'];
  password: Scalars['String'];
};

export type FormChangeUsername = {
  id: Scalars['String'];
  username: Scalars['String'];
};

export type FormClassInformation = {
  id: Scalars['String'];
  terms: Array<Maybe<InputAnon102>>;
};

export type FormCreateAcademyCalendar = {
  category: Scalars['String'];
  curriculumId: Scalars['String'];
  levelIds: Array<Scalars['String']>;
  name: Scalars['String'];
  terms?: Maybe<Array<Maybe<FormTerm>>>;
  year: Scalars['String'];
};

export type FormCreateClass = {
  academicCalendarId?: Maybe<Scalars['String']>;
  classStatus?: Maybe<Scalars['String']>;
  enrollStudentIds?: Maybe<Scalars['ANY']>;
  forceOpen?: Maybe<Scalars['ANY']>;
  lessonType?: Maybe<Scalars['String']>;
  lessons: Array<Maybe<FormCreateLesson>>;
  programId: Scalars['String'];
  programTypeDoubleLessonId?: Maybe<Scalars['String']>;
  programTypeGeneralId?: Maybe<Scalars['String']>;
  programTypeRegularId?: Maybe<Scalars['String']>;
  programTypeSpecialId?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  totalLoop?: Maybe<Scalars['ANY']>;
  year: Scalars['String'];
};

export type FormCreateClassroom = {
  capacity: Scalars['Float'];
  name: Scalars['String'];
};

export type FormCreateCreditNote = {
  type: Scalars['String'];
};

export type FormCreateCurriculumAndLevels = {
  curriculumSchema: InputAnon37;
  levelSchema: InputAnon40;
};

export type FormCreateInvoice = {
  paymentAdviceId: Scalars['String'];
};

export type FormCreateLesson = {
  classroomId: Scalars['String'];
  date: Scalars['String'];
  sessions: Array<Maybe<InputAnon3>>;
};

export type FormCreateRefund = {
  type: Scalars['String'];
};

export type FormDeleteStudentInWaitingList = {
  studentId: Scalars['String'];
};

export type FormExtendWaitingPeriod = {
  classId: Scalars['String'];
  waitingTime: Scalars['String'];
};

export type FormFamilyInformation = {
  emergencyContact: InputAnon190;
  parents?: Maybe<Array<Maybe<InputAnon182>>>;
  payOnline?: Maybe<Scalars['Boolean']>;
  referralIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  siblings?: Maybe<Array<Maybe<InputAnon193>>>;
  subscribe?: Maybe<Scalars['Boolean']>;
};

export type FormGetClassInformation = {
  classId: Scalars['String'];
  lessonStartDate?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['String']>;
};

export type FormGetClassInformationForCreditNote = {
  classId: Scalars['String'];
  studentId: Scalars['String'];
};

export type FormGetClassroomAvailable = {
  branchId: Scalars['String'];
  lessonType: Scalars['String'];
  startDate: Array<Scalars['String']>;
  totalLoop?: Maybe<Scalars['ANY']>;
};

export type FormInvoicePartialPayment = {
  amount: Scalars['Float'];
  bankId?: Maybe<Scalars['String']>;
  branchId: Scalars['String'];
  cardNumber?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  creditNoteId?: Maybe<Scalars['String']>;
  invoiceId: Scalars['String'];
  order: Scalars['String'];
  paymentMethod: Scalars['String'];
};

export type FormPaymentAdvice = {
  branchId?: Maybe<Scalars['String']>;
  classInformation?: Maybe<Array<Maybe<InputAnon91>>>;
  deduction?: Maybe<Array<Maybe<InputAnon89>>>;
  deposit?: Maybe<Array<Maybe<InputAnon85>>>;
  dueDate?: Maybe<Scalars['String']>;
  hasExpiryDate?: Maybe<Scalars['Boolean']>;
  isRegistrationFee?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  otherPayments?: Maybe<Array<Maybe<InputAnon87>>>;
  qrExpiryDate?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['String']>;
};

export type FormProgramAndClass = {
  classIds: Array<Maybe<Scalars['String']>>;
  payLaterReason?: Maybe<Scalars['String']>;
  willPayLater?: Maybe<Scalars['Boolean']>;
};

export type FormRefund = {
  creditNote?: Maybe<InputAnon167>;
  deposit?: Maybe<InputAnon164>;
  issuedBy?: Maybe<InputAnon155>;
  payeeDetails?: Maybe<InputAnon145>;
  refund?: Maybe<InputAnon160>;
  refundClass?: Maybe<Array<Maybe<FormRefundClass>>>;
  studentFeedback?: Maybe<InputAnon153>;
};

export type FormRefundClass = {
  classId?: Maybe<Scalars['String']>;
  deduction?: Maybe<Array<Maybe<InputAnon142>>>;
  lastLessonDate?: Maybe<Scalars['String']>;
  leftLessonAmount?: Maybe<Scalars['Float']>;
  otherPayments?: Maybe<Array<Maybe<InputAnon138>>>;
  receiptId?: Maybe<Scalars['String']>;
};

export type FormRemoveStudentFromLesson = {
  lessonId: Scalars['String'];
  studentId: Scalars['String'];
};

export type FormRequestTransferClass = {
  fromClassId: Scalars['String'];
  studentId: Scalars['String'];
  toClassId: Scalars['String'];
};

export type FormSendMailToStudents = {
  isResend?: Maybe<Scalars['Boolean']>;
  recipients: Array<Maybe<InputAnon120>>;
};

export type FormStudentInformation = {
  billing: InputAnon204;
  curriculumId: Scalars['String'];
  gender: Scalars['String'];
  levelId: Scalars['String'];
  mailling: InputAnon201;
  payOnline?: Maybe<Scalars['Boolean']>;
  schoolId: Scalars['String'];
};

export type FormTerm = {
  endDate: Scalars['String'];
  numberOfLessons: Scalars['Float'];
  startDate: Scalars['String'];
};

export type FormTransferStudent = {
  fromClassId: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
  studentIds: Array<Maybe<Scalars['String']>>;
  toClassId: Scalars['String'];
};

export type FormUpdateCreditNote = {
  creditNote?: Maybe<InputAnon114>;
  creditNoteClass?: Maybe<InputAnon107>;
  creditNoteFee?: Maybe<InputAnon116>;
  lastUpdateTimestamp?: Maybe<Scalars['String']>;
  submit?: Maybe<Scalars['Boolean']>;
};

export type FormUpdateSession = {
  tutorIds: Array<Maybe<Scalars['String']>>;
};

export type FormWithdrawalClass = {
  classId: Scalars['String'];
  lastLessonDate?: Maybe<Scalars['String']>;
  studentId: Scalars['String'];
};

export type GantryUserRecordData = {
  __typename?: 'GantryUserRecordData';
  list?: Maybe<Array<Maybe<GantryUserRecordEvent>>>;
  pageNo?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type GantryUserRecordEvent = {
  __typename?: 'GantryUserRecordEvent';
  cardNo?: Maybe<Scalars['String']>;
  checkInAndOutType?: Maybe<Scalars['Int']>;
  deviceTime?: Maybe<Scalars['String']>;
  doorIndexCode?: Maybe<Scalars['String']>;
  doorName?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  eventTime?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['Int']>;
  personId?: Maybe<Scalars['String']>;
  personName?: Maybe<Scalars['String']>;
  picUri?: Maybe<Scalars['String']>;
  temperatureData?: Maybe<Scalars['String']>;
  temperatureStatus?: Maybe<Scalars['Int']>;
  wearMaskStatus?: Maybe<Scalars['Int']>;
};

export type GantryUserRecordsForm = {
  endTime: Scalars['String'];
  page?: Maybe<Scalars['Float']>;
  personName?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  startTime: Scalars['String'];
};

export type GantryUserRecordsModel = {
  __typename?: 'GantryUserRecordsModel';
  code?: Maybe<Scalars['String']>;
  data?: Maybe<GantryUserRecordData>;
  msg?: Maybe<Scalars['String']>;
};

export type GeneralFee = {
  __typename?: 'GeneralFee';
  data?: Maybe<Array<Maybe<DataFee>>>;
  total?: Maybe<Scalars['Float']>;
};

export type GetVerificationCodeForm = {
  attributeName: Scalars['String'];
  userId: Scalars['String'];
};

export type Input = {
  broadcastId: Scalars['String'];
  isResend?: Maybe<Scalars['Boolean']>;
  recipients?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type InputAnon3 = {
  endTime: Scalars['String'];
  startTime: Scalars['String'];
  tutorIds: Array<Scalars['String']>;
};

export type InputAnon37 = {
  abbreviation: Scalars['String'];
  name: Scalars['String'];
};

export type InputAnon40 = {
  ids?: Maybe<Array<Scalars['String']>>;
  levels?: Maybe<Array<Maybe<InputAnon44>>>;
};

export type InputAnon44 = {
  abbreviation?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type InputAnon85 = {
  amount?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type InputAnon87 = {
  amount?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type InputAnon89 = {
  amount?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type InputAnon91 = {
  additionalDiscount?: Maybe<Scalars['Float']>;
  discountIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['String'];
  lessonStartDate: Scalars['String'];
  quantityAdditionalLesson: Scalars['Float'];
  termIds: Array<Maybe<Scalars['String']>>;
};

export type InputAnon102 = {
  lessonIds: Array<Maybe<Scalars['String']>>;
};

export type InputAnon107 = {
  classId: Scalars['String'];
  endDate: Scalars['String'];
  lessonIds: Array<Maybe<Scalars['String']>>;
  startDate: Scalars['String'];
  termId: Scalars['String'];
  termName: Scalars['String'];
};

export type InputAnon114 = {
  reason?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['String']>;
};

export type InputAnon116 = {
  numberOfLesson?: Maybe<Scalars['Float']>;
  overpaidAmount?: Maybe<Scalars['String']>;
  receiptId?: Maybe<Scalars['String']>;
  unitPriceOfClass?: Maybe<Scalars['String']>;
};

export type InputAnon120 = {
  paymentAdviceId: Scalars['String'];
  studentId: Scalars['String'];
};

export type InputAnon138 = {
  amount: Scalars['Float'];
  name: Scalars['String'];
};

export type InputAnon142 = {
  amount: Scalars['Float'];
  name: Scalars['String'];
};

export type InputAnon145 = {
  accountNumber?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<Maybe<InputAnon151>>>;
  bankId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  nameAsOfBank?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<InputAnon146>;
  postalCode?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
};

export type InputAnon146 = {
  code: Scalars['String'];
  number: Scalars['String'];
};

export type InputAnon151 = {
  fileUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  thumbUrl?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
};

export type InputAnon153 = {
  improvement?: Maybe<Scalars['String']>;
  joiningOtherSubjects?: Maybe<Scalars['Boolean']>;
  rate?: Maybe<Scalars['String']>;
  rateReason?: Maybe<Scalars['String']>;
  returnReason?: Maybe<Scalars['String']>;
  studiedTime?: Maybe<Scalars['String']>;
  willReturn?: Maybe<Scalars['Boolean']>;
};

export type InputAnon155 = {
  attachments?: Maybe<Array<Maybe<Scalars['String']>>>;
  chequeNo?: Maybe<Scalars['ANY']>;
  paymentMethod: Scalars['String'];
  transactionId?: Maybe<Scalars['ANY']>;
};

export type InputAnon160 = {
  noticeDate?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['String']>;
};

export type InputAnon164 = {
  ids?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type InputAnon167 = {
  ids?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type InputAnon170 = {
  nextPageToken?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<Scalars['String']>>>;
  page?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type InputAnon172 = {
  code?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
};

export type InputAnon174 = {
  code: Scalars['String'];
  number: Scalars['String'];
};

export type InputAnon182 = {
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  isEmergencyContact: Scalars['Boolean'];
  lastName: Scalars['String'];
  phone: InputAnon187;
  primaryContact: Scalars['Boolean'];
  relationship: Scalars['String'];
};

export type InputAnon187 = {
  code?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
};

export type InputAnon190 = {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<InputAnon172>;
  relationship?: Maybe<Scalars['String']>;
};

export type InputAnon193 = {
  relationships: Scalars['String'];
  studentId: Scalars['String'];
};

export type InputAnon201 = {
  address: Scalars['String'];
  postalCode: Scalars['String'];
};

export type InputAnon204 = {
  address: Scalars['String'];
  postalCode: Scalars['String'];
};

export type InputAnon212 = {
  academicYear?: Maybe<Scalars['String']>;
  curriculumId?: Maybe<Scalars['String']>;
  levelId?: Maybe<Scalars['String']>;
  subjectId?: Maybe<Scalars['String']>;
};

export type InputAnon214 = {
  nextPageToken?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<Scalars['String']>>>;
  page?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type InputAnon215 = {
  curriculumId?: Maybe<Scalars['String']>;
  emailStatus?: Maybe<Scalars['String']>;
  levelId?: Maybe<Scalars['String']>;
  studentName?: Maybe<Scalars['String']>;
};

export type InputAnon216 = {
  page: Scalars['Float'];
  size: Scalars['Float'];
};

export type InputAnon219 = {
  code: Scalars['String'];
  number: Scalars['String'];
};

export type InputAnon221 = {
  code: Scalars['String'];
  number: Scalars['String'];
};

/** expression to compare columns of type Int. All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: Maybe<Scalars['Int']>;
  _gt?: Maybe<Scalars['Int']>;
  _gte?: Maybe<Scalars['Int']>;
  _in?: Maybe<Array<Scalars['Int']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Int']>;
  _lte?: Maybe<Scalars['Int']>;
  _neq?: Maybe<Scalars['Int']>;
  _nin?: Maybe<Array<Scalars['Int']>>;
};

export type InvoiceModel = {
  __typename?: 'InvoiceModel';
  branch?: Maybe<BranchModel>;
  classInformation?: Maybe<ClassBill>;
  deduction?: Maybe<OutFee>;
  deposit?: Maybe<OutFee>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasExpiryDate?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isRegistrationFee?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  otherPayments?: Maybe<OutFee>;
  partials?: Maybe<Partial>;
  paymentStatus?: Maybe<Scalars['String']>;
  qrCodeLink?: Maybe<Scalars['String']>;
  qrExpiryDate?: Maybe<Scalars['DateTime']>;
  qrReferenceNo?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  student?: Maybe<StudentModel>;
  summary?: Maybe<Summary>;
  transferBill?: Maybe<TransferBill>;
};

export type InvoiceRelatedTablesModel = {
  __typename?: 'InvoiceRelatedTablesModel';
  invoicePartialPayments?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type IssuedByModel = {
  __typename?: 'IssuedByModel';
  attachments?: Maybe<Array<Maybe<Scalars['String']>>>;
  chequeNo?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
};


export type LessonsStudentModel = {
  __typename?: 'LessonsStudentModel';
  TypeLessonStudent?: Maybe<Scalars['String']>;
  emailStatus?: Maybe<Scalars['String']>;
  entryTime?: Maybe<Scalars['DateTime']>;
  hasAttended?: Maybe<Scalars['String']>;
  lessonId?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['String']>;
};

export type LevelModel = {
  __typename?: 'LevelModel';
  abbreviation?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type MasterDataAtPaymentAdvice = {
  __typename?: 'MasterDataAtPaymentAdvice';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activeStudentById?: Maybe<Scalars['String']>;
  addClass?: Maybe<Scalars['String']>;
  addLesson?: Maybe<Scalars['String']>;
  addStudentToLesson?: Maybe<Scalars['String']>;
  addStudentToWaitingList?: Maybe<Scalars['String']>;
  cancelLesson?: Maybe<Scalars['String']>;
  cancelTransferClass?: Maybe<Scalars['Boolean']>;
  changeClassStatus?: Maybe<Scalars['String']>;
  changeClassroomForLesson?: Maybe<Scalars['String']>;
  changeCreditNoteStatus?: Maybe<Scalars['String']>;
  changeRefundStatus?: Maybe<Scalars['String']>;
  changeUserAttribute?: Maybe<Scalars['String']>;
  changeUserPassword?: Maybe<Scalars['String']>;
  changeUsername?: Maybe<Scalars['String']>;
  computeEnrollmentListNewByStudentId?: Maybe<Scalars['Boolean']>;
  confirmStudentForgotPassword?: Maybe<Scalars['String']>;
  confirmUser?: Maybe<Scalars['String']>;
  coverDataReceipt?: Maybe<Scalars['String']>;
  createAcademyCalendar?: Maybe<Scalars['String']>;
  createBatchPaymentAdvice?: Maybe<Scalars['String']>;
  createCreditNote?: Maybe<Scalars['String']>;
  createCurriculumAndLevels?: Maybe<Scalars['String']>;
  createInvoice?: Maybe<Scalars['String']>;
  createInvoicePartialPayment?: Maybe<Scalars['String']>;
  createPaymentAdvice?: Maybe<PaymentAdviceModel>;
  createPaymentAdvicePaper?: Maybe<PaymentAdvicePaperModel>;
  createReceipt?: Maybe<Scalars['String']>;
  createRefund?: Maybe<Scalars['String']>;
  createStudent?: Maybe<Scalars['String']>;
  createUser?: Maybe<Scalars['String']>;
  deleteBatchPaymentAdvice?: Maybe<Scalars['String']>;
  deleteCurriculumById?: Maybe<Scalars['String']>;
  deletePaymentAdvice?: Maybe<Scalars['String']>;
  deleteProgramById?: Maybe<Scalars['String']>;
  deleteStudent?: Maybe<Scalars['String']>;
  deleteStudentInWaitingList?: Maybe<Scalars['String']>;
  deleteUser?: Maybe<Scalars['String']>;
  duplicateCreditNote?: Maybe<Scalars['String']>;
  extendWaitingPeriod?: Maybe<Scalars['JSON']>;
  forgotStudentPassword?: Maybe<ForgotPasswordModel>;
  generatePdfFinance?: Maybe<Scalars['String']>;
  getGantryUserRecords?: Maybe<GantryUserRecordsModel>;
  getVerificationCode?: Maybe<Scalars['String']>;
  importDataStudentsFromCsv?: Maybe<Scalars['String']>;
  removeDataStudentsFromCsv?: Maybe<Scalars['String']>;
  removePaymentAdvices?: Maybe<Scalars['String']>;
  removeStudentFromLesson?: Maybe<Scalars['String']>;
  removeStudentsDeleted?: Maybe<Scalars['String']>;
  requestTransferClass?: Maybe<Scalars['String']>;
  resendVerificationCodeUser?: Maybe<Scalars['String']>;
  resetUserPassword?: Maybe<Scalars['String']>;
  sendMailToStudents?: Maybe<Scalars['String']>;
  setDefaultPassword?: Maybe<Scalars['String']>;
  stepFamilyInformation?: Maybe<Scalars['String']>;
  stepProgramAndClass?: Maybe<Scalars['String']>;
  stepStudentInformation?: Maybe<Scalars['String']>;
  suggestionUsername?: Maybe<Scalars['String']>;
  testRequestQRCode?: Maybe<Scalars['Boolean']>;
  transferStudent?: Maybe<Scalars['String']>;
  unlockedAccount?: Maybe<Scalars['Boolean']>;
  updateClassroom?: Maybe<Scalars['String']>;
  updateCreditNote?: Maybe<Scalars['String']>;
  updatePaymentAdvice?: Maybe<PaymentAdviceModel>;
  updatePaymentStatusStudent?: Maybe<Scalars['String']>;
  updateRefund?: Maybe<RefundModel>;
  updateSession?: Maybe<Scalars['String']>;
  updateStudent?: Maybe<Scalars['String']>;
  updateStudentToVms?: Maybe<Scalars['String']>;
  updateTransactionLog?: Maybe<Scalars['String']>;
  updateUserToVms?: Maybe<Scalars['String']>;
  validateClassesCapacity?: Maybe<Scalars['Boolean']>;
  verifyUserAttribute?: Maybe<Scalars['String']>;
  voidUnpaidPaymentAdvice?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MutationActiveStudentByIdArgs = {
  studentId: Scalars['String'];
};


export type MutationAddClassArgs = {
  form: FormCreateClass;
};


export type MutationAddLessonArgs = {
  classId: Scalars['String'];
  form: FormCreateLesson;
};


export type MutationAddStudentToLessonArgs = {
  form: FormAddStudentToLesson;
};


export type MutationAddStudentToWaitingListArgs = {
  classId: Scalars['String'];
  form: FormAddStudentToWaitingList;
};


export type MutationCancelLessonArgs = {
  lessonId: Scalars['String'];
};


export type MutationCancelTransferClassArgs = {
  form?: Maybe<FormCancelTransferClass>;
};


export type MutationChangeClassStatusArgs = {
  classId: Scalars['String'];
  form: FormChangeClassStatus;
};


export type MutationChangeClassroomForLessonArgs = {
  classroomId: Scalars['String'];
  lessonId: Scalars['String'];
};


export type MutationChangeCreditNoteStatusArgs = {
  form: FormChangeCreditNoteStatus;
  id: Scalars['String'];
};


export type MutationChangeRefundStatusArgs = {
  id: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
};


export type MutationChangeUserAttributeArgs = {
  form: ChangeUserAttributeInput;
};


export type MutationChangeUserPasswordArgs = {
  form: FormChangeUserPassword;
};


export type MutationChangeUsernameArgs = {
  form: FormChangeUsername;
};


export type MutationComputeEnrollmentListNewByStudentIdArgs = {
  studentId: Scalars['String'];
};


export type MutationConfirmStudentForgotPasswordArgs = {
  confirmationCode: Scalars['String'];
  newPassword: Scalars['String'];
  username: Scalars['String'];
};


export type MutationConfirmUserArgs = {
  code: Scalars['String'];
  id: Scalars['String'];
};


export type MutationCoverDataReceiptArgs = {
  receiptId: Scalars['String'];
};


export type MutationCreateAcademyCalendarArgs = {
  form: FormCreateAcademyCalendar;
};


export type MutationCreateBatchPaymentAdviceArgs = {
  form?: Maybe<FormBatchPaymentAdvice>;
};


export type MutationCreateCreditNoteArgs = {
  form: FormCreateCreditNote;
};


export type MutationCreateCurriculumAndLevelsArgs = {
  form: FormCreateCurriculumAndLevels;
};


export type MutationCreateInvoiceArgs = {
  form: FormCreateInvoice;
};


export type MutationCreateInvoicePartialPaymentArgs = {
  form: FormInvoicePartialPayment;
};


export type MutationCreatePaymentAdviceArgs = {
  form: FormPaymentAdvice;
};


export type MutationCreatePaymentAdvicePaperArgs = {
  id: Scalars['String'];
};


export type MutationCreateReceiptArgs = {
  invoiceId: Scalars['String'];
};


export type MutationCreateRefundArgs = {
  form: FormCreateRefund;
};


export type MutationCreateStudentArgs = {
  form: CreateStudentForm;
};


export type MutationCreateUserArgs = {
  form: CreateUserForm;
};


export type MutationDeleteBatchPaymentAdviceArgs = {
  batchPaymentAdviceId: Scalars['String'];
};


export type MutationDeleteCurriculumByIdArgs = {
  curriculumId: Scalars['String'];
};


export type MutationDeletePaymentAdviceArgs = {
  paymentAdviceIds: Array<Maybe<Scalars['String']>>;
};


export type MutationDeleteProgramByIdArgs = {
  programId: Scalars['String'];
};


export type MutationDeleteStudentArgs = {
  studentId: Scalars['String'];
};


export type MutationDeleteStudentInWaitingListArgs = {
  classId: Scalars['String'];
  form: FormDeleteStudentInWaitingList;
};


export type MutationDeleteUserArgs = {
  form?: Maybe<DeleteUserForm>;
};


export type MutationDuplicateCreditNoteArgs = {
  creditNoteId: Scalars['String'];
};


export type MutationExtendWaitingPeriodArgs = {
  form: FormExtendWaitingPeriod;
};


export type MutationForgotStudentPasswordArgs = {
  studentEmail: Scalars['String'];
};


export type MutationGeneratePdfFinanceArgs = {
  invoiceId: Scalars['String'];
  type: Scalars['String'];
};


export type MutationGetGantryUserRecordsArgs = {
  form: GantryUserRecordsForm;
};


export type MutationGetVerificationCodeArgs = {
  form: GetVerificationCodeForm;
};


export type MutationImportDataStudentsFromCsvArgs = {
  studentId: Scalars['String'];
};


export type MutationRemoveDataStudentsFromCsvArgs = {
  studentId: Scalars['String'];
};


export type MutationRemovePaymentAdvicesArgs = {
  limit: Scalars['String'];
};


export type MutationRemoveStudentFromLessonArgs = {
  form: FormRemoveStudentFromLesson;
};


export type MutationRemoveStudentsDeletedArgs = {
  limit: Scalars['String'];
};


export type MutationRequestTransferClassArgs = {
  form?: Maybe<FormRequestTransferClass>;
};


export type MutationResendVerificationCodeUserArgs = {
  id: Scalars['String'];
};


export type MutationResetUserPasswordArgs = {
  id: Scalars['String'];
};


export type MutationSendMailToStudentsArgs = {
  form: FormSendMailToStudents;
};


export type MutationSetDefaultPasswordArgs = {
  username: Scalars['String'];
};


export type MutationStepFamilyInformationArgs = {
  form: FormFamilyInformation;
  studentId?: Maybe<Scalars['String']>;
};


export type MutationStepProgramAndClassArgs = {
  form: FormProgramAndClass;
  studentId?: Maybe<Scalars['String']>;
};


export type MutationStepStudentInformationArgs = {
  form: FormStudentInformation;
  studentId?: Maybe<Scalars['String']>;
};


export type MutationSuggestionUsernameArgs = {
  form: SuggestionForm;
};


export type MutationTestRequestQrCodeArgs = {
  user: Scalars['String'];
};


export type MutationTransferStudentArgs = {
  form?: Maybe<FormTransferStudent>;
};


export type MutationUnlockedAccountArgs = {
  userId: Scalars['String'];
};


export type MutationUpdateClassroomArgs = {
  classroomId: Scalars['String'];
  form: FormCreateClassroom;
};


export type MutationUpdateCreditNoteArgs = {
  form: FormUpdateCreditNote;
  id: Scalars['String'];
};


export type MutationUpdatePaymentAdviceArgs = {
  form: FormPaymentAdvice;
  id: Scalars['String'];
  saveForm: Scalars['Boolean'];
};


export type MutationUpdatePaymentStatusStudentArgs = {
  username: Scalars['String'];
};


export type MutationUpdateRefundArgs = {
  form: FormRefund;
  id: Scalars['String'];
  saveForm: Scalars['Boolean'];
};


export type MutationUpdateSessionArgs = {
  form: FormUpdateSession;
  sessionId: Scalars['String'];
};


export type MutationUpdateStudentArgs = {
  form: UpdateStudentForm;
  studentId: Scalars['String'];
};


export type MutationUpdateStudentToVmsArgs = {
  studentId: Scalars['String'];
};


export type MutationUpdateTransactionLogArgs = {
  transaction: Scalars['String'];
};


export type MutationUpdateUserToVmsArgs = {
  userId: Scalars['String'];
};


export type MutationValidateClassesCapacityArgs = {
  form: Array<Maybe<FormClassInformation>>;
};


export type MutationVerifyUserAttributeArgs = {
  form: VerifyUserAttributeInput;
};


export type MutationVoidUnpaidPaymentAdviceArgs = {
  paymentAdviceIds: Array<Maybe<Scalars['String']>>;
};

export type NewsInput = {
  isResend?: Maybe<Scalars['Boolean']>;
  newsId: Scalars['String'];
  recipientIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type NewsOutput = {
  __typename?: 'NewsOutput';
  id: Scalars['String'];
};

export type OtherRelatedTablesModel = {
  __typename?: 'OtherRelatedTablesModel';
  invoiceRelated?: Maybe<InvoiceRelatedTablesModel>;
  paRelated?: Maybe<PaRelatedTablesModel>;
  receiptRelated?: Maybe<ReceiptRelatedTablesModel>;
};

export type OutFee = {
  __typename?: 'OutFee';
  data?: Maybe<Array<Maybe<Fee>>>;
  total?: Maybe<Scalars['Float']>;
};

export type Output = {
  __typename?: 'Output';
  id: Scalars['String'];
};

export type PaRelatedTablesModel = {
  __typename?: 'PaRelatedTablesModel';
  additionalClassTickets?: Maybe<Array<Maybe<Scalars['String']>>>;
  discountBills?: Maybe<Array<Maybe<Scalars['String']>>>;
  paymentAdviceClasses?: Maybe<Array<Maybe<Scalars['String']>>>;
  paymentAdviceLogs?: Maybe<Array<Maybe<Scalars['String']>>>;
  paymentAdviceTermClasses?: Maybe<Array<Maybe<Scalars['String']>>>;
  paymentAdviceTransfers?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PaginationClassModel = {
  __typename?: 'PaginationClassModel';
  data?: Maybe<Array<Maybe<ClassModel>>>;
  pagination?: Maybe<PaginationInfo>;
};

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  nextPageToken?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  size: Scalars['Int'];
  total: Scalars['Int'];
  totalPages?: Maybe<Scalars['Int']>;
  totalPerPage?: Maybe<Scalars['Int']>;
};

export type Partial = {
  __typename?: 'Partial';
  data?: Maybe<Array<Maybe<PartialModel>>>;
  total?: Maybe<Scalars['Float']>;
};

export type PartialModel = {
  __typename?: 'PartialModel';
  amount?: Maybe<Scalars['Float']>;
  bankName?: Maybe<Scalars['String']>;
  branch?: Maybe<BranchModel>;
  cardNumber?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creditNote?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  paymentMethod?: Maybe<Scalars['String']>;
};

export type PayeeDetailsModel = {
  __typename?: 'PayeeDetailsModel';
  accountNumber?: Maybe<Scalars['String']>;
  attachments?: Maybe<Scalars['JSON']>;
  bankId?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  nameAsOfBank?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<PhoneNumber>;
  postalCode?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
};

export type PaymentAdviceModel = {
  __typename?: 'PaymentAdviceModel';
  branch?: Maybe<BranchModel>;
  classInformation?: Maybe<ClassFee>;
  deduction?: Maybe<OutFee>;
  deposit?: Maybe<OutFee>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasExpiryDate?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isRegistrationFee?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  otherPayments?: Maybe<OutFee>;
  paymentStatus?: Maybe<Scalars['String']>;
  qrCodeLink?: Maybe<Scalars['String']>;
  qrExpiryDate?: Maybe<Scalars['DateTime']>;
  qrReferenceNo?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  student?: Maybe<StudentModel>;
  summary?: Maybe<Summary>;
  transferBill?: Maybe<TransferBill>;
};

export type PaymentAdvicePaperModel = {
  __typename?: 'PaymentAdvicePaperModel';
  branch?: Maybe<BranchModel>;
  classInformation?: Maybe<ClassBill>;
  deduction?: Maybe<OutFee>;
  deposit?: Maybe<OutFee>;
  dueDate?: Maybe<Scalars['DateTime']>;
  hasExpiryDate?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isRegistrationFee?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  otherPayments?: Maybe<OutFee>;
  paymentStatus?: Maybe<Scalars['String']>;
  qrCodeLink?: Maybe<Scalars['String']>;
  qrExpiryDate?: Maybe<Scalars['DateTime']>;
  qrReferenceNo?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  student?: Maybe<StudentModel>;
  summary?: Maybe<Summary>;
  transferBill?: Maybe<TransferBill>;
};

export type PaymentAdviceRelationshipsModel = {
  __typename?: 'PaymentAdviceRelationshipsModel';
  attendance?: Maybe<Array<Maybe<LessonsStudentModel>>>;
  classes?: Maybe<Array<Maybe<ClassModel>>>;
  creditNotes?: Maybe<Array<Maybe<CreditNoteModel>>>;
  invoices?: Maybe<Array<Maybe<InvoiceModel>>>;
  others?: Maybe<OtherRelatedTablesModel>;
  pa?: Maybe<PaymentAdviceModel>;
  receipts?: Maybe<Array<Maybe<ReceiptModel>>>;
  refunds?: Maybe<Array<Maybe<RefundModel>>>;
};

export type Period = {
  __typename?: 'Period';
  endDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  code?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  countSpecialClasses?: Maybe<Scalars['JSON']>;
  filterClassByStudentId?: Maybe<PaginationClassModel>;
  getClassInformation?: Maybe<ClassInformation>;
  getClassInformationForCreditNote?: Maybe<ClassInformationCreditNote>;
  getClassInformationForRefund?: Maybe<WithdrawalClass>;
  getClassUpcomingOfStudent?: Maybe<Array<Maybe<Scalars['String']>>>;
  getClassroomAvailable?: Maybe<Array<Maybe<Scalars['String']>>>;
  getDetailInvoice?: Maybe<InvoiceModel>;
  getDetailPaymentAdvice?: Maybe<PaymentAdviceModel>;
  getDetailPaymentAdvicePaper?: Maybe<InvoiceModel>;
  getDetailRefund?: Maybe<RefundModel>;
  getListClassNotRefundByStudent?: Maybe<Array<Maybe<ClassOfStudent>>>;
  getPaRelationships?: Maybe<PaymentAdviceRelationshipsModel>;
  getReceiptListings?: Maybe<Array<Maybe<ReceiptListModel>>>;
  getRoles?: Maybe<Array<Maybe<Role>>>;
  getStudentsWithManyAbsents?: Maybe<AbsentStudentPaginationModel>;
};


export type QueryCountSpecialClassesArgs = {
  programId: Scalars['String'];
};


export type QueryFilterClassByStudentIdArgs = {
  form: FilterClassList;
  studentId: Scalars['String'];
};


export type QueryGetClassInformationArgs = {
  form: FormGetClassInformation;
};


export type QueryGetClassInformationForCreditNoteArgs = {
  form: FormGetClassInformationForCreditNote;
};


export type QueryGetClassInformationForRefundArgs = {
  form: FormWithdrawalClass;
  noticeDate: Scalars['DateTime'];
};


export type QueryGetClassUpcomingOfStudentArgs = {
  studentId: Scalars['String'];
};


export type QueryGetClassroomAvailableArgs = {
  form?: Maybe<FormGetClassroomAvailable>;
};


export type QueryGetDetailInvoiceArgs = {
  id: Scalars['String'];
};


export type QueryGetDetailPaymentAdviceArgs = {
  id: Scalars['String'];
};


export type QueryGetDetailPaymentAdvicePaperArgs = {
  id: Scalars['String'];
  invoiceId?: Maybe<Scalars['String']>;
};


export type QueryGetDetailRefundArgs = {
  id: Scalars['String'];
};


export type QueryGetListClassNotRefundByStudentArgs = {
  studentId: Scalars['String'];
};


export type QueryGetPaRelationshipsArgs = {
  id: Scalars['String'];
};


export type QueryGetReceiptListingsArgs = {
  fromDate: Scalars['DateTime'];
  toDate: Scalars['DateTime'];
};


export type QueryGetStudentsWithManyAbsentsArgs = {
  form: FilterAbsentStudents;
  numberOfAbsents: Scalars['Float'];
};

export type ReceiptClassInformation = {
  __typename?: 'ReceiptClassInformation';
  classBranch?: Maybe<Scalars['String']>;
  classDescription?: Maybe<Scalars['String']>;
  className?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  termDates?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ReceiptDiscountInformation = {
  __typename?: 'ReceiptDiscountInformation';
  classId?: Maybe<Scalars['String']>;
  discounts?: Maybe<Array<Maybe<DiscountClass>>>;
};

export type ReceiptListModel = {
  __typename?: 'ReceiptListModel';
  classDescriptions?: Maybe<Array<Maybe<ReceiptClassInformation>>>;
  classes?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  courseFee?: Maybe<Scalars['Float']>;
  deposit?: Maybe<Scalars['Float']>;
  discountData?: Maybe<Array<Maybe<ReceiptDiscountInformation>>>;
  gst?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  invoiceRefNumber?: Maybe<Scalars['String']>;
  issuedCentre?: Maybe<Scalars['String']>;
  issuedDate?: Maybe<Scalars['DateTime']>;
  issuedTo?: Maybe<Scalars['String']>;
  partialPaymentDetails?: Maybe<Array<Maybe<PartialModel>>>;
  receiptNumber?: Maybe<Scalars['String']>;
  registrationFee?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['String']>;
  subtotal?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  username?: Maybe<Scalars['String']>;
};

export type ReceiptModel = {
  __typename?: 'ReceiptModel';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ReceiptRelatedTablesModel = {
  __typename?: 'ReceiptRelatedTablesModel';
  creditNoteFees?: Maybe<Array<Maybe<Scalars['String']>>>;
  deposits?: Maybe<Array<Maybe<Scalars['String']>>>;
  refundClasses?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type RefundModel = {
  __typename?: 'RefundModel';
  creditNote?: Maybe<GeneralFee>;
  deposit?: Maybe<GeneralFee>;
  issuedBy?: Maybe<IssuedByModel>;
  name?: Maybe<Scalars['String']>;
  noticeDate?: Maybe<Scalars['DateTime']>;
  payeeDetails?: Maybe<PayeeDetailsModel>;
  reason?: Maybe<Scalars['String']>;
  reasonReject?: Maybe<Scalars['JSON']>;
  refundClass?: Maybe<Array<Maybe<ClassInformationModel>>>;
  refundStatus?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  student?: Maybe<StudentModel>;
  studentFeedback?: Maybe<StudentFeedbackModel>;
  summary?: Maybe<RefundSummary>;
  type?: Maybe<Scalars['String']>;
};

export type RefundSummary = {
  __typename?: 'RefundSummary';
  creditNote?: Maybe<Scalars['Float']>;
  deposit?: Maybe<Scalars['Float']>;
  totalAfterGst?: Maybe<Scalars['Float']>;
  totalRefundable?: Maybe<Scalars['Float']>;
};

export type Role = {
  __typename?: 'Role';
  module?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
};

export type SampleOutput = {
  __typename?: 'SampleOutput';
  id: Scalars['String'];
};

export type Session = {
  __typename?: 'Session';
  endTime?: Maybe<Scalars['DateTime']>;
  startTime?: Maybe<Scalars['DateTime']>;
};

/** expression to compare columns of type String. All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  _ilike?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Scalars['String']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _like?: Maybe<Scalars['String']>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  _nilike?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Scalars['String']>>;
  _nlike?: Maybe<Scalars['String']>;
  _nsimilar?: Maybe<Scalars['String']>;
  _similar?: Maybe<Scalars['String']>;
};

export type StudentFeedbackModel = {
  __typename?: 'StudentFeedbackModel';
  improvement?: Maybe<Scalars['String']>;
  joiningOtherSubjects?: Maybe<Scalars['Boolean']>;
  rate?: Maybe<Scalars['String']>;
  rateReason?: Maybe<Scalars['String']>;
  returnReason?: Maybe<Scalars['String']>;
  studiedTime?: Maybe<Scalars['String']>;
  willReturn?: Maybe<Scalars['Boolean']>;
};

export type StudentModel = {
  __typename?: 'StudentModel';
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['String']>;
  studentProfile?: Maybe<StudentProfileModel>;
  username?: Maybe<Scalars['String']>;
};

export type StudentProfileModel = {
  __typename?: 'StudentProfileModel';
  school?: Maybe<MasterDataAtPaymentAdvice>;
  willPayLater?: Maybe<Scalars['Boolean']>;
};

export type SubTotal = {
  __typename?: 'SubTotal';
  gst?: Maybe<Scalars['Float']>;
  gstConfig?: Maybe<Scalars['Float']>;
  subTotalAfterGst?: Maybe<Scalars['Float']>;
  totalBeforGst?: Maybe<Scalars['Float']>;
};

export type SubjectModel = {
  __typename?: 'SubjectModel';
  abbreviation?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type SuggestionForm = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  role: Scalars['String'];
};

export type Summary = {
  __typename?: 'Summary';
  classFee?: Maybe<Scalars['Float']>;
  deduction?: Maybe<Scalars['Float']>;
  deposit?: Maybe<Scalars['Float']>;
  gst?: Maybe<Scalars['Float']>;
  gstConfig?: Maybe<Scalars['Float']>;
  otherPayments?: Maybe<Scalars['Float']>;
  registrationFee?: Maybe<Scalars['Float']>;
  totalAfterGst?: Maybe<Scalars['Float']>;
  totalBeforeGst?: Maybe<Scalars['Float']>;
  totalPaid?: Maybe<Scalars['Float']>;
  totalPayable?: Maybe<Scalars['Float']>;
};

export type TermData = {
  __typename?: 'TermData';
  id?: Maybe<Scalars['String']>;
  lessonIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  lessons?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  name?: Maybe<Scalars['String']>;
  pricing?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

export type TermDetail = {
  __typename?: 'TermDetail';
  academicYear?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  lessons?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  name?: Maybe<Scalars['String']>;
  pricing?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type TermInClassInformation = {
  __typename?: 'TermInClassInformation';
  id?: Maybe<Scalars['String']>;
  lessonIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  lessons?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  name?: Maybe<Scalars['String']>;
  pricing?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

export type TransferBill = {
  __typename?: 'TransferBill';
  classBills?: Maybe<Array<Maybe<ClassBillInfo>>>;
  className?: Maybe<Scalars['String']>;
  mutualTerms?: Maybe<Array<Maybe<Scalars['String']>>>;
  reason?: Maybe<Scalars['String']>;
  transferDate?: Maybe<Scalars['DateTime']>;
};

export type TransferClassDetail = {
  __typename?: 'TransferClassDetail';
  classBills?: Maybe<Array<Maybe<ClassBillInfo>>>;
  mutualPaidTerms?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
};

export type UpdateStudentForm = {
  billing: InputAnon204;
  curriculumId: Scalars['String'];
  emergencyContact: InputAnon190;
  firstName: Scalars['String'];
  gender: Scalars['String'];
  lastName: Scalars['String'];
  levelId: Scalars['String'];
  mailling: InputAnon201;
  parents?: Maybe<Array<Maybe<InputAnon182>>>;
  payOnline?: Maybe<Scalars['Boolean']>;
  referralIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  schoolId: Scalars['String'];
  siblings?: Maybe<Array<Maybe<InputAnon193>>>;
  subscribe?: Maybe<Scalars['Boolean']>;
};

export type VerifyUserAttributeInput = {
  attributeName: Scalars['String'];
  attributeValue: Scalars['ANY'];
  code: Scalars['String'];
  id: Scalars['String'];
};

export type WithdrawalClass = {
  __typename?: 'WithdrawalClass';
  classId?: Maybe<Scalars['String']>;
  lastLessonDate?: Maybe<Scalars['DateTime']>;
  leftLessonNo?: Maybe<Scalars['Int']>;
  lessonDates?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  name?: Maybe<Scalars['String']>;
  oweLessonNo?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "academic_calendars" */
export type Academic_Calendars = {
  __typename?: 'academic_calendars';
  category: Scalars['String'];
  /** An array relationship */
  classes: Array<Classes>;
  /** An aggregated array relationship */
  classes_aggregate: Classes_Aggregate;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  curriculum: Curriculums;
  curriculumId: Scalars['uuid'];
  id: Scalars['uuid'];
  levelIds: Scalars['jsonb'];
  /** A computed field, executes function "academic_calendars_field_levels" */
  levels?: Maybe<Array<Levels>>;
  name: Scalars['String'];
  status: Scalars['String'];
  /** An array relationship */
  terms: Array<Terms>;
  /** An aggregated array relationship */
  terms_aggregate: Terms_Aggregate;
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  year: Scalars['String'];
};


/** columns and relationships of "academic_calendars" */
export type Academic_CalendarsClassesArgs = {
  distinct_on?: Maybe<Array<Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classes_Order_By>>;
  where?: Maybe<Classes_Bool_Exp>;
};


/** columns and relationships of "academic_calendars" */
export type Academic_CalendarsClasses_AggregateArgs = {
  distinct_on?: Maybe<Array<Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classes_Order_By>>;
  where?: Maybe<Classes_Bool_Exp>;
};


/** columns and relationships of "academic_calendars" */
export type Academic_CalendarsLevelIdsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "academic_calendars" */
export type Academic_CalendarsLevelsArgs = {
  distinct_on?: Maybe<Array<Levels_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Levels_Order_By>>;
  where?: Maybe<Levels_Bool_Exp>;
};


/** columns and relationships of "academic_calendars" */
export type Academic_CalendarsTermsArgs = {
  distinct_on?: Maybe<Array<Terms_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Terms_Order_By>>;
  where?: Maybe<Terms_Bool_Exp>;
};


/** columns and relationships of "academic_calendars" */
export type Academic_CalendarsTerms_AggregateArgs = {
  distinct_on?: Maybe<Array<Terms_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Terms_Order_By>>;
  where?: Maybe<Terms_Bool_Exp>;
};

/** aggregated selection of "academic_calendars" */
export type Academic_Calendars_Aggregate = {
  __typename?: 'academic_calendars_aggregate';
  aggregate?: Maybe<Academic_Calendars_Aggregate_Fields>;
  nodes: Array<Academic_Calendars>;
};

/** aggregate fields of "academic_calendars" */
export type Academic_Calendars_Aggregate_Fields = {
  __typename?: 'academic_calendars_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Academic_Calendars_Max_Fields>;
  min?: Maybe<Academic_Calendars_Min_Fields>;
};


/** aggregate fields of "academic_calendars" */
export type Academic_Calendars_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Academic_Calendars_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "academic_calendars" */
export type Academic_Calendars_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Academic_Calendars_Max_Order_By>;
  min?: Maybe<Academic_Calendars_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Academic_Calendars_Append_Input = {
  levelIds?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "academic_calendars" */
export type Academic_Calendars_Arr_Rel_Insert_Input = {
  data: Array<Academic_Calendars_Insert_Input>;
  on_conflict?: Maybe<Academic_Calendars_On_Conflict>;
};

/** Boolean expression to filter rows from the table "academic_calendars". All fields are combined with a logical 'AND'. */
export type Academic_Calendars_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Academic_Calendars_Bool_Exp>>>;
  _not?: Maybe<Academic_Calendars_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Academic_Calendars_Bool_Exp>>>;
  category?: Maybe<String_Comparison_Exp>;
  classes?: Maybe<Classes_Bool_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  curriculum?: Maybe<Curriculums_Bool_Exp>;
  curriculumId?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  levelIds?: Maybe<Jsonb_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  terms?: Maybe<Terms_Bool_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  year?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "academic_calendars" */
export enum Academic_Calendars_Constraint {
  /** unique or primary key constraint */
  AcademicCalendarsPkey = 'academic_calendars_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Academic_Calendars_Delete_At_Path_Input = {
  levelIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Academic_Calendars_Delete_Elem_Input = {
  levelIds?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Academic_Calendars_Delete_Key_Input = {
  levelIds?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "academic_calendars" */
export type Academic_Calendars_Insert_Input = {
  category?: Maybe<Scalars['String']>;
  classes?: Maybe<Classes_Arr_Rel_Insert_Input>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculum?: Maybe<Curriculums_Obj_Rel_Insert_Input>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  levelIds?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  terms?: Maybe<Terms_Arr_Rel_Insert_Input>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Academic_Calendars_Max_Fields = {
  __typename?: 'academic_calendars_max_fields';
  category?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "academic_calendars" */
export type Academic_Calendars_Max_Order_By = {
  category?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  curriculumId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  year?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Academic_Calendars_Min_Fields = {
  __typename?: 'academic_calendars_min_fields';
  category?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "academic_calendars" */
export type Academic_Calendars_Min_Order_By = {
  category?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  curriculumId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  year?: Maybe<Order_By>;
};

/** response of any mutation on the table "academic_calendars" */
export type Academic_Calendars_Mutation_Response = {
  __typename?: 'academic_calendars_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Academic_Calendars>;
};

/** input type for inserting object relation for remote table "academic_calendars" */
export type Academic_Calendars_Obj_Rel_Insert_Input = {
  data: Academic_Calendars_Insert_Input;
  on_conflict?: Maybe<Academic_Calendars_On_Conflict>;
};

/** on conflict condition type for table "academic_calendars" */
export type Academic_Calendars_On_Conflict = {
  constraint: Academic_Calendars_Constraint;
  update_columns: Array<Academic_Calendars_Update_Column>;
  where?: Maybe<Academic_Calendars_Bool_Exp>;
};

/** ordering options when selecting data from "academic_calendars" */
export type Academic_Calendars_Order_By = {
  category?: Maybe<Order_By>;
  classes_aggregate?: Maybe<Classes_Aggregate_Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  curriculum?: Maybe<Curriculums_Order_By>;
  curriculumId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  levelIds?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  terms_aggregate?: Maybe<Terms_Aggregate_Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  year?: Maybe<Order_By>;
};

/** primary key columns input for table: "academic_calendars" */
export type Academic_Calendars_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Academic_Calendars_Prepend_Input = {
  levelIds?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "academic_calendars" */
export enum Academic_Calendars_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CurriculumId = 'curriculumId',
  /** column name */
  Id = 'id',
  /** column name */
  LevelIds = 'levelIds',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Year = 'year'
}

/** input type for updating data in table "academic_calendars" */
export type Academic_Calendars_Set_Input = {
  category?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  levelIds?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['String']>;
};

/** update columns of table "academic_calendars" */
export enum Academic_Calendars_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CurriculumId = 'curriculumId',
  /** column name */
  Id = 'id',
  /** column name */
  LevelIds = 'levelIds',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Year = 'year'
}

/** columns and relationships of "additional_class_tickets" */
export type Additional_Class_Tickets = {
  __typename?: 'additional_class_tickets';
  /** An object relationship */
  class: Classes;
  classId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  paymentAdviceId: Scalars['uuid'];
  /** An object relationship */
  payment_advice: Payment_Advices;
  quantity: Scalars['Int'];
  status: Scalars['String'];
  unitPrice: Scalars['numeric'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  userByCreatedby?: Maybe<Users>;
};

/** aggregated selection of "additional_class_tickets" */
export type Additional_Class_Tickets_Aggregate = {
  __typename?: 'additional_class_tickets_aggregate';
  aggregate?: Maybe<Additional_Class_Tickets_Aggregate_Fields>;
  nodes: Array<Additional_Class_Tickets>;
};

/** aggregate fields of "additional_class_tickets" */
export type Additional_Class_Tickets_Aggregate_Fields = {
  __typename?: 'additional_class_tickets_aggregate_fields';
  avg?: Maybe<Additional_Class_Tickets_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Additional_Class_Tickets_Max_Fields>;
  min?: Maybe<Additional_Class_Tickets_Min_Fields>;
  stddev?: Maybe<Additional_Class_Tickets_Stddev_Fields>;
  stddev_pop?: Maybe<Additional_Class_Tickets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Additional_Class_Tickets_Stddev_Samp_Fields>;
  sum?: Maybe<Additional_Class_Tickets_Sum_Fields>;
  var_pop?: Maybe<Additional_Class_Tickets_Var_Pop_Fields>;
  var_samp?: Maybe<Additional_Class_Tickets_Var_Samp_Fields>;
  variance?: Maybe<Additional_Class_Tickets_Variance_Fields>;
};


/** aggregate fields of "additional_class_tickets" */
export type Additional_Class_Tickets_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Additional_Class_Tickets_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "additional_class_tickets" */
export type Additional_Class_Tickets_Aggregate_Order_By = {
  avg?: Maybe<Additional_Class_Tickets_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Additional_Class_Tickets_Max_Order_By>;
  min?: Maybe<Additional_Class_Tickets_Min_Order_By>;
  stddev?: Maybe<Additional_Class_Tickets_Stddev_Order_By>;
  stddev_pop?: Maybe<Additional_Class_Tickets_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Additional_Class_Tickets_Stddev_Samp_Order_By>;
  sum?: Maybe<Additional_Class_Tickets_Sum_Order_By>;
  var_pop?: Maybe<Additional_Class_Tickets_Var_Pop_Order_By>;
  var_samp?: Maybe<Additional_Class_Tickets_Var_Samp_Order_By>;
  variance?: Maybe<Additional_Class_Tickets_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "additional_class_tickets" */
export type Additional_Class_Tickets_Arr_Rel_Insert_Input = {
  data: Array<Additional_Class_Tickets_Insert_Input>;
  on_conflict?: Maybe<Additional_Class_Tickets_On_Conflict>;
};

/** aggregate avg on columns */
export type Additional_Class_Tickets_Avg_Fields = {
  __typename?: 'additional_class_tickets_avg_fields';
  quantity?: Maybe<Scalars['Float']>;
  unitPrice?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "additional_class_tickets" */
export type Additional_Class_Tickets_Avg_Order_By = {
  quantity?: Maybe<Order_By>;
  unitPrice?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "additional_class_tickets". All fields are combined with a logical 'AND'. */
export type Additional_Class_Tickets_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Additional_Class_Tickets_Bool_Exp>>>;
  _not?: Maybe<Additional_Class_Tickets_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Additional_Class_Tickets_Bool_Exp>>>;
  class?: Maybe<Classes_Bool_Exp>;
  classId?: Maybe<Uuid_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  paymentAdviceId?: Maybe<Uuid_Comparison_Exp>;
  payment_advice?: Maybe<Payment_Advices_Bool_Exp>;
  quantity?: Maybe<Int_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  unitPrice?: Maybe<Numeric_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  userByCreatedby?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "additional_class_tickets" */
export enum Additional_Class_Tickets_Constraint {
  /** unique or primary key constraint */
  AdditionalClassTicketsPkey = 'additional_class_tickets_pkey'
}

/** input type for incrementing integer column in table "additional_class_tickets" */
export type Additional_Class_Tickets_Inc_Input = {
  quantity?: Maybe<Scalars['Int']>;
  unitPrice?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "additional_class_tickets" */
export type Additional_Class_Tickets_Insert_Input = {
  class?: Maybe<Classes_Obj_Rel_Insert_Input>;
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  payment_advice?: Maybe<Payment_Advices_Obj_Rel_Insert_Input>;
  quantity?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  userByCreatedby?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Additional_Class_Tickets_Max_Fields = {
  __typename?: 'additional_class_tickets_max_fields';
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "additional_class_tickets" */
export type Additional_Class_Tickets_Max_Order_By = {
  classId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  quantity?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  unitPrice?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Additional_Class_Tickets_Min_Fields = {
  __typename?: 'additional_class_tickets_min_fields';
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "additional_class_tickets" */
export type Additional_Class_Tickets_Min_Order_By = {
  classId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  quantity?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  unitPrice?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "additional_class_tickets" */
export type Additional_Class_Tickets_Mutation_Response = {
  __typename?: 'additional_class_tickets_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Additional_Class_Tickets>;
};

/** input type for inserting object relation for remote table "additional_class_tickets" */
export type Additional_Class_Tickets_Obj_Rel_Insert_Input = {
  data: Additional_Class_Tickets_Insert_Input;
  on_conflict?: Maybe<Additional_Class_Tickets_On_Conflict>;
};

/** on conflict condition type for table "additional_class_tickets" */
export type Additional_Class_Tickets_On_Conflict = {
  constraint: Additional_Class_Tickets_Constraint;
  update_columns: Array<Additional_Class_Tickets_Update_Column>;
  where?: Maybe<Additional_Class_Tickets_Bool_Exp>;
};

/** ordering options when selecting data from "additional_class_tickets" */
export type Additional_Class_Tickets_Order_By = {
  class?: Maybe<Classes_Order_By>;
  classId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  payment_advice?: Maybe<Payment_Advices_Order_By>;
  quantity?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  unitPrice?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  userByCreatedby?: Maybe<Users_Order_By>;
};

/** primary key columns input for table: "additional_class_tickets" */
export type Additional_Class_Tickets_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "additional_class_tickets" */
export enum Additional_Class_Tickets_Select_Column {
  /** column name */
  ClassId = 'classId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentAdviceId = 'paymentAdviceId',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Status = 'status',
  /** column name */
  UnitPrice = 'unitPrice',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "additional_class_tickets" */
export type Additional_Class_Tickets_Set_Input = {
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Additional_Class_Tickets_Stddev_Fields = {
  __typename?: 'additional_class_tickets_stddev_fields';
  quantity?: Maybe<Scalars['Float']>;
  unitPrice?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "additional_class_tickets" */
export type Additional_Class_Tickets_Stddev_Order_By = {
  quantity?: Maybe<Order_By>;
  unitPrice?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Additional_Class_Tickets_Stddev_Pop_Fields = {
  __typename?: 'additional_class_tickets_stddev_pop_fields';
  quantity?: Maybe<Scalars['Float']>;
  unitPrice?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "additional_class_tickets" */
export type Additional_Class_Tickets_Stddev_Pop_Order_By = {
  quantity?: Maybe<Order_By>;
  unitPrice?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Additional_Class_Tickets_Stddev_Samp_Fields = {
  __typename?: 'additional_class_tickets_stddev_samp_fields';
  quantity?: Maybe<Scalars['Float']>;
  unitPrice?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "additional_class_tickets" */
export type Additional_Class_Tickets_Stddev_Samp_Order_By = {
  quantity?: Maybe<Order_By>;
  unitPrice?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Additional_Class_Tickets_Sum_Fields = {
  __typename?: 'additional_class_tickets_sum_fields';
  quantity?: Maybe<Scalars['Int']>;
  unitPrice?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "additional_class_tickets" */
export type Additional_Class_Tickets_Sum_Order_By = {
  quantity?: Maybe<Order_By>;
  unitPrice?: Maybe<Order_By>;
};

/** update columns of table "additional_class_tickets" */
export enum Additional_Class_Tickets_Update_Column {
  /** column name */
  ClassId = 'classId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentAdviceId = 'paymentAdviceId',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Status = 'status',
  /** column name */
  UnitPrice = 'unitPrice',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** aggregate var_pop on columns */
export type Additional_Class_Tickets_Var_Pop_Fields = {
  __typename?: 'additional_class_tickets_var_pop_fields';
  quantity?: Maybe<Scalars['Float']>;
  unitPrice?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "additional_class_tickets" */
export type Additional_Class_Tickets_Var_Pop_Order_By = {
  quantity?: Maybe<Order_By>;
  unitPrice?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Additional_Class_Tickets_Var_Samp_Fields = {
  __typename?: 'additional_class_tickets_var_samp_fields';
  quantity?: Maybe<Scalars['Float']>;
  unitPrice?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "additional_class_tickets" */
export type Additional_Class_Tickets_Var_Samp_Order_By = {
  quantity?: Maybe<Order_By>;
  unitPrice?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Additional_Class_Tickets_Variance_Fields = {
  __typename?: 'additional_class_tickets_variance_fields';
  quantity?: Maybe<Scalars['Float']>;
  unitPrice?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "additional_class_tickets" */
export type Additional_Class_Tickets_Variance_Order_By = {
  quantity?: Maybe<Order_By>;
  unitPrice?: Maybe<Order_By>;
};

/** columns and relationships of "backup_attendance_logs" */
export type Backup_Attendance_Logs = {
  __typename?: 'backup_attendance_logs';
  /** An object relationship */
  branch?: Maybe<Branches>;
  branchId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  class?: Maybe<Classes>;
  classId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An object relationship */
  paymentAdvice?: Maybe<Payment_Advices>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  status: Scalars['String'];
  /** An object relationship */
  student: Users;
  studentId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "backup_attendance_logs" */
export type Backup_Attendance_Logs_Aggregate = {
  __typename?: 'backup_attendance_logs_aggregate';
  aggregate?: Maybe<Backup_Attendance_Logs_Aggregate_Fields>;
  nodes: Array<Backup_Attendance_Logs>;
};

/** aggregate fields of "backup_attendance_logs" */
export type Backup_Attendance_Logs_Aggregate_Fields = {
  __typename?: 'backup_attendance_logs_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Backup_Attendance_Logs_Max_Fields>;
  min?: Maybe<Backup_Attendance_Logs_Min_Fields>;
};


/** aggregate fields of "backup_attendance_logs" */
export type Backup_Attendance_Logs_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Backup_Attendance_Logs_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "backup_attendance_logs" */
export type Backup_Attendance_Logs_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Backup_Attendance_Logs_Max_Order_By>;
  min?: Maybe<Backup_Attendance_Logs_Min_Order_By>;
};

/** input type for inserting array relation for remote table "backup_attendance_logs" */
export type Backup_Attendance_Logs_Arr_Rel_Insert_Input = {
  data: Array<Backup_Attendance_Logs_Insert_Input>;
  on_conflict?: Maybe<Backup_Attendance_Logs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "backup_attendance_logs". All fields are combined with a logical 'AND'. */
export type Backup_Attendance_Logs_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Backup_Attendance_Logs_Bool_Exp>>>;
  _not?: Maybe<Backup_Attendance_Logs_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Backup_Attendance_Logs_Bool_Exp>>>;
  branch?: Maybe<Branches_Bool_Exp>;
  branchId?: Maybe<Uuid_Comparison_Exp>;
  class?: Maybe<Classes_Bool_Exp>;
  classId?: Maybe<Uuid_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  paymentAdvice?: Maybe<Payment_Advices_Bool_Exp>;
  paymentAdviceId?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  student?: Maybe<Users_Bool_Exp>;
  studentId?: Maybe<Uuid_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "backup_attendance_logs" */
export enum Backup_Attendance_Logs_Constraint {
  /** unique or primary key constraint */
  BackupAttendanceLogsPkey = 'backup_attendance_logs_pkey'
}

/** input type for inserting data into table "backup_attendance_logs" */
export type Backup_Attendance_Logs_Insert_Input = {
  branch?: Maybe<Branches_Obj_Rel_Insert_Input>;
  branchId?: Maybe<Scalars['uuid']>;
  class?: Maybe<Classes_Obj_Rel_Insert_Input>;
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdvice?: Maybe<Payment_Advices_Obj_Rel_Insert_Input>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  student?: Maybe<Users_Obj_Rel_Insert_Input>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Backup_Attendance_Logs_Max_Fields = {
  __typename?: 'backup_attendance_logs_max_fields';
  branchId?: Maybe<Scalars['uuid']>;
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "backup_attendance_logs" */
export type Backup_Attendance_Logs_Max_Order_By = {
  branchId?: Maybe<Order_By>;
  classId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Backup_Attendance_Logs_Min_Fields = {
  __typename?: 'backup_attendance_logs_min_fields';
  branchId?: Maybe<Scalars['uuid']>;
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "backup_attendance_logs" */
export type Backup_Attendance_Logs_Min_Order_By = {
  branchId?: Maybe<Order_By>;
  classId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "backup_attendance_logs" */
export type Backup_Attendance_Logs_Mutation_Response = {
  __typename?: 'backup_attendance_logs_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Backup_Attendance_Logs>;
};

/** input type for inserting object relation for remote table "backup_attendance_logs" */
export type Backup_Attendance_Logs_Obj_Rel_Insert_Input = {
  data: Backup_Attendance_Logs_Insert_Input;
  on_conflict?: Maybe<Backup_Attendance_Logs_On_Conflict>;
};

/** on conflict condition type for table "backup_attendance_logs" */
export type Backup_Attendance_Logs_On_Conflict = {
  constraint: Backup_Attendance_Logs_Constraint;
  update_columns: Array<Backup_Attendance_Logs_Update_Column>;
  where?: Maybe<Backup_Attendance_Logs_Bool_Exp>;
};

/** ordering options when selecting data from "backup_attendance_logs" */
export type Backup_Attendance_Logs_Order_By = {
  branch?: Maybe<Branches_Order_By>;
  branchId?: Maybe<Order_By>;
  class?: Maybe<Classes_Order_By>;
  classId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  paymentAdvice?: Maybe<Payment_Advices_Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  student?: Maybe<Users_Order_By>;
  studentId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "backup_attendance_logs" */
export type Backup_Attendance_Logs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "backup_attendance_logs" */
export enum Backup_Attendance_Logs_Select_Column {
  /** column name */
  BranchId = 'branchId',
  /** column name */
  ClassId = 'classId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentAdviceId = 'paymentAdviceId',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "backup_attendance_logs" */
export type Backup_Attendance_Logs_Set_Input = {
  branchId?: Maybe<Scalars['uuid']>;
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "backup_attendance_logs" */
export enum Backup_Attendance_Logs_Update_Column {
  /** column name */
  BranchId = 'branchId',
  /** column name */
  ClassId = 'classId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentAdviceId = 'paymentAdviceId',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** columns and relationships of "banks" */
export type Banks = {
  __typename?: 'banks';
  abbreviation?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  userByCreatedby?: Maybe<Users>;
};

/** aggregated selection of "banks" */
export type Banks_Aggregate = {
  __typename?: 'banks_aggregate';
  aggregate?: Maybe<Banks_Aggregate_Fields>;
  nodes: Array<Banks>;
};

/** aggregate fields of "banks" */
export type Banks_Aggregate_Fields = {
  __typename?: 'banks_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Banks_Max_Fields>;
  min?: Maybe<Banks_Min_Fields>;
};


/** aggregate fields of "banks" */
export type Banks_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Banks_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "banks" */
export type Banks_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Banks_Max_Order_By>;
  min?: Maybe<Banks_Min_Order_By>;
};

/** input type for inserting array relation for remote table "banks" */
export type Banks_Arr_Rel_Insert_Input = {
  data: Array<Banks_Insert_Input>;
  on_conflict?: Maybe<Banks_On_Conflict>;
};

/** Boolean expression to filter rows from the table "banks". All fields are combined with a logical 'AND'. */
export type Banks_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Banks_Bool_Exp>>>;
  _not?: Maybe<Banks_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Banks_Bool_Exp>>>;
  abbreviation?: Maybe<String_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  userByCreatedby?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "banks" */
export enum Banks_Constraint {
  /** unique or primary key constraint */
  BanksPkey = 'banks_pkey'
}

/** input type for inserting data into table "banks" */
export type Banks_Insert_Input = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  userByCreatedby?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Banks_Max_Fields = {
  __typename?: 'banks_max_fields';
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "banks" */
export type Banks_Max_Order_By = {
  abbreviation?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Banks_Min_Fields = {
  __typename?: 'banks_min_fields';
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "banks" */
export type Banks_Min_Order_By = {
  abbreviation?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "banks" */
export type Banks_Mutation_Response = {
  __typename?: 'banks_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Banks>;
};

/** input type for inserting object relation for remote table "banks" */
export type Banks_Obj_Rel_Insert_Input = {
  data: Banks_Insert_Input;
  on_conflict?: Maybe<Banks_On_Conflict>;
};

/** on conflict condition type for table "banks" */
export type Banks_On_Conflict = {
  constraint: Banks_Constraint;
  update_columns: Array<Banks_Update_Column>;
  where?: Maybe<Banks_Bool_Exp>;
};

/** ordering options when selecting data from "banks" */
export type Banks_Order_By = {
  abbreviation?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  userByCreatedby?: Maybe<Users_Order_By>;
};

/** primary key columns input for table: "banks" */
export type Banks_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "banks" */
export enum Banks_Select_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "banks" */
export type Banks_Set_Input = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "banks" */
export enum Banks_Update_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** columns and relationships of "batch_payment_advices" */
export type Batch_Payment_Advices = {
  __typename?: 'batch_payment_advices';
  /** An object relationship */
  academyCalendar: Academic_Calendars;
  academyCalendarId: Scalars['uuid'];
  academyYear?: Maybe<Scalars['String']>;
  additionalDoubleLesson?: Maybe<Scalars['Int']>;
  additionalRegularLesson?: Maybe<Scalars['Int']>;
  applyDiscountIds?: Maybe<Scalars['jsonb']>;
  /** A computed field, executes function "batch_pa_field_apply_discounts" */
  applyDiscounts?: Maybe<Array<Discounts>>;
  batchStatus: Scalars['String'];
  checkDiscountIds?: Maybe<Scalars['jsonb']>;
  /** A computed field, executes function "batch_pa_field_check_discounts" */
  checkDiscounts?: Maybe<Array<Discounts>>;
  /** An object relationship */
  createUser?: Maybe<Users>;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  curriculum?: Maybe<Curriculums>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  levelIds?: Maybe<Scalars['jsonb']>;
  /** A computed field, executes function "batch_pa_field_levels" */
  levels?: Maybe<Array<Levels>>;
  paymentStatus?: Maybe<Scalars['jsonb']>;
  setDate?: Maybe<Scalars['json']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  status: Scalars['String'];
  /** An object relationship */
  term: Terms;
  termId: Scalars['uuid'];
  termName?: Maybe<Scalars['String']>;
  totalSuccess?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  updater?: Maybe<Users>;
};


/** columns and relationships of "batch_payment_advices" */
export type Batch_Payment_AdvicesApplyDiscountIdsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "batch_payment_advices" */
export type Batch_Payment_AdvicesApplyDiscountsArgs = {
  distinct_on?: Maybe<Array<Discounts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discounts_Order_By>>;
  where?: Maybe<Discounts_Bool_Exp>;
};


/** columns and relationships of "batch_payment_advices" */
export type Batch_Payment_AdvicesCheckDiscountIdsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "batch_payment_advices" */
export type Batch_Payment_AdvicesCheckDiscountsArgs = {
  distinct_on?: Maybe<Array<Discounts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discounts_Order_By>>;
  where?: Maybe<Discounts_Bool_Exp>;
};


/** columns and relationships of "batch_payment_advices" */
export type Batch_Payment_AdvicesLevelIdsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "batch_payment_advices" */
export type Batch_Payment_AdvicesLevelsArgs = {
  distinct_on?: Maybe<Array<Levels_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Levels_Order_By>>;
  where?: Maybe<Levels_Bool_Exp>;
};


/** columns and relationships of "batch_payment_advices" */
export type Batch_Payment_AdvicesPaymentStatusArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "batch_payment_advices" */
export type Batch_Payment_AdvicesSetDateArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "batch_payment_advices" */
export type Batch_Payment_Advices_Aggregate = {
  __typename?: 'batch_payment_advices_aggregate';
  aggregate?: Maybe<Batch_Payment_Advices_Aggregate_Fields>;
  nodes: Array<Batch_Payment_Advices>;
};

/** aggregate fields of "batch_payment_advices" */
export type Batch_Payment_Advices_Aggregate_Fields = {
  __typename?: 'batch_payment_advices_aggregate_fields';
  avg?: Maybe<Batch_Payment_Advices_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Batch_Payment_Advices_Max_Fields>;
  min?: Maybe<Batch_Payment_Advices_Min_Fields>;
  stddev?: Maybe<Batch_Payment_Advices_Stddev_Fields>;
  stddev_pop?: Maybe<Batch_Payment_Advices_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Batch_Payment_Advices_Stddev_Samp_Fields>;
  sum?: Maybe<Batch_Payment_Advices_Sum_Fields>;
  var_pop?: Maybe<Batch_Payment_Advices_Var_Pop_Fields>;
  var_samp?: Maybe<Batch_Payment_Advices_Var_Samp_Fields>;
  variance?: Maybe<Batch_Payment_Advices_Variance_Fields>;
};


/** aggregate fields of "batch_payment_advices" */
export type Batch_Payment_Advices_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Batch_Payment_Advices_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "batch_payment_advices" */
export type Batch_Payment_Advices_Aggregate_Order_By = {
  avg?: Maybe<Batch_Payment_Advices_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Batch_Payment_Advices_Max_Order_By>;
  min?: Maybe<Batch_Payment_Advices_Min_Order_By>;
  stddev?: Maybe<Batch_Payment_Advices_Stddev_Order_By>;
  stddev_pop?: Maybe<Batch_Payment_Advices_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Batch_Payment_Advices_Stddev_Samp_Order_By>;
  sum?: Maybe<Batch_Payment_Advices_Sum_Order_By>;
  var_pop?: Maybe<Batch_Payment_Advices_Var_Pop_Order_By>;
  var_samp?: Maybe<Batch_Payment_Advices_Var_Samp_Order_By>;
  variance?: Maybe<Batch_Payment_Advices_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Batch_Payment_Advices_Append_Input = {
  applyDiscountIds?: Maybe<Scalars['jsonb']>;
  checkDiscountIds?: Maybe<Scalars['jsonb']>;
  levelIds?: Maybe<Scalars['jsonb']>;
  paymentStatus?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "batch_payment_advices" */
export type Batch_Payment_Advices_Arr_Rel_Insert_Input = {
  data: Array<Batch_Payment_Advices_Insert_Input>;
  on_conflict?: Maybe<Batch_Payment_Advices_On_Conflict>;
};

/** aggregate avg on columns */
export type Batch_Payment_Advices_Avg_Fields = {
  __typename?: 'batch_payment_advices_avg_fields';
  additionalDoubleLesson?: Maybe<Scalars['Float']>;
  additionalRegularLesson?: Maybe<Scalars['Float']>;
  totalSuccess?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "batch_payment_advices" */
export type Batch_Payment_Advices_Avg_Order_By = {
  additionalDoubleLesson?: Maybe<Order_By>;
  additionalRegularLesson?: Maybe<Order_By>;
  totalSuccess?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "batch_payment_advices". All fields are combined with a logical 'AND'. */
export type Batch_Payment_Advices_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Batch_Payment_Advices_Bool_Exp>>>;
  _not?: Maybe<Batch_Payment_Advices_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Batch_Payment_Advices_Bool_Exp>>>;
  academyCalendar?: Maybe<Academic_Calendars_Bool_Exp>;
  academyCalendarId?: Maybe<Uuid_Comparison_Exp>;
  academyYear?: Maybe<String_Comparison_Exp>;
  additionalDoubleLesson?: Maybe<Int_Comparison_Exp>;
  additionalRegularLesson?: Maybe<Int_Comparison_Exp>;
  applyDiscountIds?: Maybe<Jsonb_Comparison_Exp>;
  batchStatus?: Maybe<String_Comparison_Exp>;
  checkDiscountIds?: Maybe<Jsonb_Comparison_Exp>;
  createUser?: Maybe<Users_Bool_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  curriculum?: Maybe<Curriculums_Bool_Exp>;
  curriculumId?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  levelIds?: Maybe<Jsonb_Comparison_Exp>;
  paymentStatus?: Maybe<Jsonb_Comparison_Exp>;
  setDate?: Maybe<Json_Comparison_Exp>;
  startDate?: Maybe<Timestamptz_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  term?: Maybe<Terms_Bool_Exp>;
  termId?: Maybe<Uuid_Comparison_Exp>;
  termName?: Maybe<String_Comparison_Exp>;
  totalSuccess?: Maybe<Int_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  updater?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "batch_payment_advices" */
export enum Batch_Payment_Advices_Constraint {
  /** unique or primary key constraint */
  BatchPaymentAdvicesPkey = 'batch_payment_advices_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Batch_Payment_Advices_Delete_At_Path_Input = {
  applyDiscountIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  checkDiscountIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  levelIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  paymentStatus?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Batch_Payment_Advices_Delete_Elem_Input = {
  applyDiscountIds?: Maybe<Scalars['Int']>;
  checkDiscountIds?: Maybe<Scalars['Int']>;
  levelIds?: Maybe<Scalars['Int']>;
  paymentStatus?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Batch_Payment_Advices_Delete_Key_Input = {
  applyDiscountIds?: Maybe<Scalars['String']>;
  checkDiscountIds?: Maybe<Scalars['String']>;
  levelIds?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "batch_payment_advices" */
export type Batch_Payment_Advices_Inc_Input = {
  additionalDoubleLesson?: Maybe<Scalars['Int']>;
  additionalRegularLesson?: Maybe<Scalars['Int']>;
  totalSuccess?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "batch_payment_advices" */
export type Batch_Payment_Advices_Insert_Input = {
  academyCalendar?: Maybe<Academic_Calendars_Obj_Rel_Insert_Input>;
  academyCalendarId?: Maybe<Scalars['uuid']>;
  academyYear?: Maybe<Scalars['String']>;
  additionalDoubleLesson?: Maybe<Scalars['Int']>;
  additionalRegularLesson?: Maybe<Scalars['Int']>;
  applyDiscountIds?: Maybe<Scalars['jsonb']>;
  batchStatus?: Maybe<Scalars['String']>;
  checkDiscountIds?: Maybe<Scalars['jsonb']>;
  createUser?: Maybe<Users_Obj_Rel_Insert_Input>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculum?: Maybe<Curriculums_Obj_Rel_Insert_Input>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  levelIds?: Maybe<Scalars['jsonb']>;
  paymentStatus?: Maybe<Scalars['jsonb']>;
  setDate?: Maybe<Scalars['json']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  term?: Maybe<Terms_Obj_Rel_Insert_Input>;
  termId?: Maybe<Scalars['uuid']>;
  termName?: Maybe<Scalars['String']>;
  totalSuccess?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  updater?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Batch_Payment_Advices_Max_Fields = {
  __typename?: 'batch_payment_advices_max_fields';
  academyCalendarId?: Maybe<Scalars['uuid']>;
  academyYear?: Maybe<Scalars['String']>;
  additionalDoubleLesson?: Maybe<Scalars['Int']>;
  additionalRegularLesson?: Maybe<Scalars['Int']>;
  batchStatus?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  termId?: Maybe<Scalars['uuid']>;
  termName?: Maybe<Scalars['String']>;
  totalSuccess?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "batch_payment_advices" */
export type Batch_Payment_Advices_Max_Order_By = {
  academyCalendarId?: Maybe<Order_By>;
  academyYear?: Maybe<Order_By>;
  additionalDoubleLesson?: Maybe<Order_By>;
  additionalRegularLesson?: Maybe<Order_By>;
  batchStatus?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  curriculumId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  startDate?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  termId?: Maybe<Order_By>;
  termName?: Maybe<Order_By>;
  totalSuccess?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Batch_Payment_Advices_Min_Fields = {
  __typename?: 'batch_payment_advices_min_fields';
  academyCalendarId?: Maybe<Scalars['uuid']>;
  academyYear?: Maybe<Scalars['String']>;
  additionalDoubleLesson?: Maybe<Scalars['Int']>;
  additionalRegularLesson?: Maybe<Scalars['Int']>;
  batchStatus?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  termId?: Maybe<Scalars['uuid']>;
  termName?: Maybe<Scalars['String']>;
  totalSuccess?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "batch_payment_advices" */
export type Batch_Payment_Advices_Min_Order_By = {
  academyCalendarId?: Maybe<Order_By>;
  academyYear?: Maybe<Order_By>;
  additionalDoubleLesson?: Maybe<Order_By>;
  additionalRegularLesson?: Maybe<Order_By>;
  batchStatus?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  curriculumId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  startDate?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  termId?: Maybe<Order_By>;
  termName?: Maybe<Order_By>;
  totalSuccess?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "batch_payment_advices" */
export type Batch_Payment_Advices_Mutation_Response = {
  __typename?: 'batch_payment_advices_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Batch_Payment_Advices>;
};

/** input type for inserting object relation for remote table "batch_payment_advices" */
export type Batch_Payment_Advices_Obj_Rel_Insert_Input = {
  data: Batch_Payment_Advices_Insert_Input;
  on_conflict?: Maybe<Batch_Payment_Advices_On_Conflict>;
};

/** on conflict condition type for table "batch_payment_advices" */
export type Batch_Payment_Advices_On_Conflict = {
  constraint: Batch_Payment_Advices_Constraint;
  update_columns: Array<Batch_Payment_Advices_Update_Column>;
  where?: Maybe<Batch_Payment_Advices_Bool_Exp>;
};

/** ordering options when selecting data from "batch_payment_advices" */
export type Batch_Payment_Advices_Order_By = {
  academyCalendar?: Maybe<Academic_Calendars_Order_By>;
  academyCalendarId?: Maybe<Order_By>;
  academyYear?: Maybe<Order_By>;
  additionalDoubleLesson?: Maybe<Order_By>;
  additionalRegularLesson?: Maybe<Order_By>;
  applyDiscountIds?: Maybe<Order_By>;
  batchStatus?: Maybe<Order_By>;
  checkDiscountIds?: Maybe<Order_By>;
  createUser?: Maybe<Users_Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  curriculum?: Maybe<Curriculums_Order_By>;
  curriculumId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  levelIds?: Maybe<Order_By>;
  paymentStatus?: Maybe<Order_By>;
  setDate?: Maybe<Order_By>;
  startDate?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  term?: Maybe<Terms_Order_By>;
  termId?: Maybe<Order_By>;
  termName?: Maybe<Order_By>;
  totalSuccess?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  updater?: Maybe<Users_Order_By>;
};

/** primary key columns input for table: "batch_payment_advices" */
export type Batch_Payment_Advices_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Batch_Payment_Advices_Prepend_Input = {
  applyDiscountIds?: Maybe<Scalars['jsonb']>;
  checkDiscountIds?: Maybe<Scalars['jsonb']>;
  levelIds?: Maybe<Scalars['jsonb']>;
  paymentStatus?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "batch_payment_advices" */
export enum Batch_Payment_Advices_Select_Column {
  /** column name */
  AcademyCalendarId = 'academyCalendarId',
  /** column name */
  AcademyYear = 'academyYear',
  /** column name */
  AdditionalDoubleLesson = 'additionalDoubleLesson',
  /** column name */
  AdditionalRegularLesson = 'additionalRegularLesson',
  /** column name */
  ApplyDiscountIds = 'applyDiscountIds',
  /** column name */
  BatchStatus = 'batchStatus',
  /** column name */
  CheckDiscountIds = 'checkDiscountIds',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CurriculumId = 'curriculumId',
  /** column name */
  Id = 'id',
  /** column name */
  LevelIds = 'levelIds',
  /** column name */
  PaymentStatus = 'paymentStatus',
  /** column name */
  SetDate = 'setDate',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  Status = 'status',
  /** column name */
  TermId = 'termId',
  /** column name */
  TermName = 'termName',
  /** column name */
  TotalSuccess = 'totalSuccess',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "batch_payment_advices" */
export type Batch_Payment_Advices_Set_Input = {
  academyCalendarId?: Maybe<Scalars['uuid']>;
  academyYear?: Maybe<Scalars['String']>;
  additionalDoubleLesson?: Maybe<Scalars['Int']>;
  additionalRegularLesson?: Maybe<Scalars['Int']>;
  applyDiscountIds?: Maybe<Scalars['jsonb']>;
  batchStatus?: Maybe<Scalars['String']>;
  checkDiscountIds?: Maybe<Scalars['jsonb']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  levelIds?: Maybe<Scalars['jsonb']>;
  paymentStatus?: Maybe<Scalars['jsonb']>;
  setDate?: Maybe<Scalars['json']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  termId?: Maybe<Scalars['uuid']>;
  termName?: Maybe<Scalars['String']>;
  totalSuccess?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Batch_Payment_Advices_Stddev_Fields = {
  __typename?: 'batch_payment_advices_stddev_fields';
  additionalDoubleLesson?: Maybe<Scalars['Float']>;
  additionalRegularLesson?: Maybe<Scalars['Float']>;
  totalSuccess?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "batch_payment_advices" */
export type Batch_Payment_Advices_Stddev_Order_By = {
  additionalDoubleLesson?: Maybe<Order_By>;
  additionalRegularLesson?: Maybe<Order_By>;
  totalSuccess?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Batch_Payment_Advices_Stddev_Pop_Fields = {
  __typename?: 'batch_payment_advices_stddev_pop_fields';
  additionalDoubleLesson?: Maybe<Scalars['Float']>;
  additionalRegularLesson?: Maybe<Scalars['Float']>;
  totalSuccess?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "batch_payment_advices" */
export type Batch_Payment_Advices_Stddev_Pop_Order_By = {
  additionalDoubleLesson?: Maybe<Order_By>;
  additionalRegularLesson?: Maybe<Order_By>;
  totalSuccess?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Batch_Payment_Advices_Stddev_Samp_Fields = {
  __typename?: 'batch_payment_advices_stddev_samp_fields';
  additionalDoubleLesson?: Maybe<Scalars['Float']>;
  additionalRegularLesson?: Maybe<Scalars['Float']>;
  totalSuccess?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "batch_payment_advices" */
export type Batch_Payment_Advices_Stddev_Samp_Order_By = {
  additionalDoubleLesson?: Maybe<Order_By>;
  additionalRegularLesson?: Maybe<Order_By>;
  totalSuccess?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Batch_Payment_Advices_Sum_Fields = {
  __typename?: 'batch_payment_advices_sum_fields';
  additionalDoubleLesson?: Maybe<Scalars['Int']>;
  additionalRegularLesson?: Maybe<Scalars['Int']>;
  totalSuccess?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "batch_payment_advices" */
export type Batch_Payment_Advices_Sum_Order_By = {
  additionalDoubleLesson?: Maybe<Order_By>;
  additionalRegularLesson?: Maybe<Order_By>;
  totalSuccess?: Maybe<Order_By>;
};

/** update columns of table "batch_payment_advices" */
export enum Batch_Payment_Advices_Update_Column {
  /** column name */
  AcademyCalendarId = 'academyCalendarId',
  /** column name */
  AcademyYear = 'academyYear',
  /** column name */
  AdditionalDoubleLesson = 'additionalDoubleLesson',
  /** column name */
  AdditionalRegularLesson = 'additionalRegularLesson',
  /** column name */
  ApplyDiscountIds = 'applyDiscountIds',
  /** column name */
  BatchStatus = 'batchStatus',
  /** column name */
  CheckDiscountIds = 'checkDiscountIds',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CurriculumId = 'curriculumId',
  /** column name */
  Id = 'id',
  /** column name */
  LevelIds = 'levelIds',
  /** column name */
  PaymentStatus = 'paymentStatus',
  /** column name */
  SetDate = 'setDate',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  Status = 'status',
  /** column name */
  TermId = 'termId',
  /** column name */
  TermName = 'termName',
  /** column name */
  TotalSuccess = 'totalSuccess',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** aggregate var_pop on columns */
export type Batch_Payment_Advices_Var_Pop_Fields = {
  __typename?: 'batch_payment_advices_var_pop_fields';
  additionalDoubleLesson?: Maybe<Scalars['Float']>;
  additionalRegularLesson?: Maybe<Scalars['Float']>;
  totalSuccess?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "batch_payment_advices" */
export type Batch_Payment_Advices_Var_Pop_Order_By = {
  additionalDoubleLesson?: Maybe<Order_By>;
  additionalRegularLesson?: Maybe<Order_By>;
  totalSuccess?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Batch_Payment_Advices_Var_Samp_Fields = {
  __typename?: 'batch_payment_advices_var_samp_fields';
  additionalDoubleLesson?: Maybe<Scalars['Float']>;
  additionalRegularLesson?: Maybe<Scalars['Float']>;
  totalSuccess?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "batch_payment_advices" */
export type Batch_Payment_Advices_Var_Samp_Order_By = {
  additionalDoubleLesson?: Maybe<Order_By>;
  additionalRegularLesson?: Maybe<Order_By>;
  totalSuccess?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Batch_Payment_Advices_Variance_Fields = {
  __typename?: 'batch_payment_advices_variance_fields';
  additionalDoubleLesson?: Maybe<Scalars['Float']>;
  additionalRegularLesson?: Maybe<Scalars['Float']>;
  totalSuccess?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "batch_payment_advices" */
export type Batch_Payment_Advices_Variance_Order_By = {
  additionalDoubleLesson?: Maybe<Order_By>;
  additionalRegularLesson?: Maybe<Order_By>;
  totalSuccess?: Maybe<Order_By>;
};

/** columns and relationships of "branches" */
export type Branches = {
  __typename?: 'branches';
  abbreviation?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  /** An array relationship */
  classrooms: Array<Classrooms>;
  /** An aggregated array relationship */
  classrooms_aggregate: Classrooms_Aggregate;
  code?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  payment_advices: Array<Payment_Advices>;
  /** An aggregated array relationship */
  payment_advices_aggregate: Payment_Advices_Aggregate;
  postalCode?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "branches" */
export type BranchesClassroomsArgs = {
  distinct_on?: Maybe<Array<Classrooms_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classrooms_Order_By>>;
  where?: Maybe<Classrooms_Bool_Exp>;
};


/** columns and relationships of "branches" */
export type BranchesClassrooms_AggregateArgs = {
  distinct_on?: Maybe<Array<Classrooms_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classrooms_Order_By>>;
  where?: Maybe<Classrooms_Bool_Exp>;
};


/** columns and relationships of "branches" */
export type BranchesPayment_AdvicesArgs = {
  distinct_on?: Maybe<Array<Payment_Advices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advices_Order_By>>;
  where?: Maybe<Payment_Advices_Bool_Exp>;
};


/** columns and relationships of "branches" */
export type BranchesPayment_Advices_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advices_Order_By>>;
  where?: Maybe<Payment_Advices_Bool_Exp>;
};

/** aggregated selection of "branches" */
export type Branches_Aggregate = {
  __typename?: 'branches_aggregate';
  aggregate?: Maybe<Branches_Aggregate_Fields>;
  nodes: Array<Branches>;
};

/** aggregate fields of "branches" */
export type Branches_Aggregate_Fields = {
  __typename?: 'branches_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Branches_Max_Fields>;
  min?: Maybe<Branches_Min_Fields>;
};


/** aggregate fields of "branches" */
export type Branches_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Branches_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "branches" */
export type Branches_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Branches_Max_Order_By>;
  min?: Maybe<Branches_Min_Order_By>;
};

/** input type for inserting array relation for remote table "branches" */
export type Branches_Arr_Rel_Insert_Input = {
  data: Array<Branches_Insert_Input>;
  on_conflict?: Maybe<Branches_On_Conflict>;
};

/** Boolean expression to filter rows from the table "branches". All fields are combined with a logical 'AND'. */
export type Branches_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Branches_Bool_Exp>>>;
  _not?: Maybe<Branches_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Branches_Bool_Exp>>>;
  abbreviation?: Maybe<String_Comparison_Exp>;
  address?: Maybe<String_Comparison_Exp>;
  city?: Maybe<String_Comparison_Exp>;
  classrooms?: Maybe<Classrooms_Bool_Exp>;
  code?: Maybe<String_Comparison_Exp>;
  country?: Maybe<String_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  payment_advices?: Maybe<Payment_Advices_Bool_Exp>;
  postalCode?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "branches" */
export enum Branches_Constraint {
  /** unique or primary key constraint */
  BranchesPkey = 'branches_pkey'
}

/** input type for inserting data into table "branches" */
export type Branches_Insert_Input = {
  abbreviation?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  classrooms?: Maybe<Classrooms_Arr_Rel_Insert_Input>;
  code?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  payment_advices?: Maybe<Payment_Advices_Arr_Rel_Insert_Input>;
  postalCode?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Branches_Max_Fields = {
  __typename?: 'branches_max_fields';
  abbreviation?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "branches" */
export type Branches_Max_Order_By = {
  abbreviation?: Maybe<Order_By>;
  address?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  code?: Maybe<Order_By>;
  country?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  postalCode?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Branches_Min_Fields = {
  __typename?: 'branches_min_fields';
  abbreviation?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "branches" */
export type Branches_Min_Order_By = {
  abbreviation?: Maybe<Order_By>;
  address?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  code?: Maybe<Order_By>;
  country?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  postalCode?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "branches" */
export type Branches_Mutation_Response = {
  __typename?: 'branches_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Branches>;
};

/** input type for inserting object relation for remote table "branches" */
export type Branches_Obj_Rel_Insert_Input = {
  data: Branches_Insert_Input;
  on_conflict?: Maybe<Branches_On_Conflict>;
};

/** on conflict condition type for table "branches" */
export type Branches_On_Conflict = {
  constraint: Branches_Constraint;
  update_columns: Array<Branches_Update_Column>;
  where?: Maybe<Branches_Bool_Exp>;
};

/** ordering options when selecting data from "branches" */
export type Branches_Order_By = {
  abbreviation?: Maybe<Order_By>;
  address?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  classrooms_aggregate?: Maybe<Classrooms_Aggregate_Order_By>;
  code?: Maybe<Order_By>;
  country?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  payment_advices_aggregate?: Maybe<Payment_Advices_Aggregate_Order_By>;
  postalCode?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "branches" */
export type Branches_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "branches" */
export enum Branches_Select_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  Address = 'address',
  /** column name */
  City = 'city',
  /** column name */
  Code = 'code',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PostalCode = 'postalCode',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "branches" */
export type Branches_Set_Input = {
  abbreviation?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "branches" */
export enum Branches_Update_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  Address = 'address',
  /** column name */
  City = 'city',
  /** column name */
  Code = 'code',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PostalCode = 'postalCode',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** columns and relationships of "broadcast_logs" */
export type Broadcast_Logs = {
  __typename?: 'broadcast_logs';
  /** An object relationship */
  broadcast: Broadcasts;
  broadcastId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  emailResponse?: Maybe<Scalars['jsonb']>;
  emailStatus?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  isViewed: Scalars['Boolean'];
  notificationResponse?: Maybe<Scalars['jsonb']>;
  notificationStatus?: Maybe<Scalars['String']>;
  /** An object relationship */
  recipient: Users;
  recipientId: Scalars['uuid'];
  smsResponse?: Maybe<Scalars['jsonb']>;
  smsStatus?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "broadcast_logs" */
export type Broadcast_LogsEmailResponseArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "broadcast_logs" */
export type Broadcast_LogsNotificationResponseArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "broadcast_logs" */
export type Broadcast_LogsSmsResponseArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "broadcast_logs" */
export type Broadcast_Logs_Aggregate = {
  __typename?: 'broadcast_logs_aggregate';
  aggregate?: Maybe<Broadcast_Logs_Aggregate_Fields>;
  nodes: Array<Broadcast_Logs>;
};

/** aggregate fields of "broadcast_logs" */
export type Broadcast_Logs_Aggregate_Fields = {
  __typename?: 'broadcast_logs_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Broadcast_Logs_Max_Fields>;
  min?: Maybe<Broadcast_Logs_Min_Fields>;
};


/** aggregate fields of "broadcast_logs" */
export type Broadcast_Logs_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Broadcast_Logs_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "broadcast_logs" */
export type Broadcast_Logs_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Broadcast_Logs_Max_Order_By>;
  min?: Maybe<Broadcast_Logs_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Broadcast_Logs_Append_Input = {
  emailResponse?: Maybe<Scalars['jsonb']>;
  notificationResponse?: Maybe<Scalars['jsonb']>;
  smsResponse?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "broadcast_logs" */
export type Broadcast_Logs_Arr_Rel_Insert_Input = {
  data: Array<Broadcast_Logs_Insert_Input>;
  on_conflict?: Maybe<Broadcast_Logs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "broadcast_logs". All fields are combined with a logical 'AND'. */
export type Broadcast_Logs_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Broadcast_Logs_Bool_Exp>>>;
  _not?: Maybe<Broadcast_Logs_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Broadcast_Logs_Bool_Exp>>>;
  broadcast?: Maybe<Broadcasts_Bool_Exp>;
  broadcastId?: Maybe<Uuid_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  emailResponse?: Maybe<Jsonb_Comparison_Exp>;
  emailStatus?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  isViewed?: Maybe<Boolean_Comparison_Exp>;
  notificationResponse?: Maybe<Jsonb_Comparison_Exp>;
  notificationStatus?: Maybe<String_Comparison_Exp>;
  recipient?: Maybe<Users_Bool_Exp>;
  recipientId?: Maybe<Uuid_Comparison_Exp>;
  smsResponse?: Maybe<Jsonb_Comparison_Exp>;
  smsStatus?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "broadcast_logs" */
export enum Broadcast_Logs_Constraint {
  /** unique or primary key constraint */
  BroadcastLogsPkey = 'broadcast_logs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Broadcast_Logs_Delete_At_Path_Input = {
  emailResponse?: Maybe<Array<Maybe<Scalars['String']>>>;
  notificationResponse?: Maybe<Array<Maybe<Scalars['String']>>>;
  smsResponse?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Broadcast_Logs_Delete_Elem_Input = {
  emailResponse?: Maybe<Scalars['Int']>;
  notificationResponse?: Maybe<Scalars['Int']>;
  smsResponse?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Broadcast_Logs_Delete_Key_Input = {
  emailResponse?: Maybe<Scalars['String']>;
  notificationResponse?: Maybe<Scalars['String']>;
  smsResponse?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "broadcast_logs" */
export type Broadcast_Logs_Insert_Input = {
  broadcast?: Maybe<Broadcasts_Obj_Rel_Insert_Input>;
  broadcastId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailResponse?: Maybe<Scalars['jsonb']>;
  emailStatus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  isViewed?: Maybe<Scalars['Boolean']>;
  notificationResponse?: Maybe<Scalars['jsonb']>;
  notificationStatus?: Maybe<Scalars['String']>;
  recipient?: Maybe<Users_Obj_Rel_Insert_Input>;
  recipientId?: Maybe<Scalars['uuid']>;
  smsResponse?: Maybe<Scalars['jsonb']>;
  smsStatus?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Broadcast_Logs_Max_Fields = {
  __typename?: 'broadcast_logs_max_fields';
  broadcastId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailStatus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  notificationStatus?: Maybe<Scalars['String']>;
  recipientId?: Maybe<Scalars['uuid']>;
  smsStatus?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "broadcast_logs" */
export type Broadcast_Logs_Max_Order_By = {
  broadcastId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  emailStatus?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  notificationStatus?: Maybe<Order_By>;
  recipientId?: Maybe<Order_By>;
  smsStatus?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Broadcast_Logs_Min_Fields = {
  __typename?: 'broadcast_logs_min_fields';
  broadcastId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailStatus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  notificationStatus?: Maybe<Scalars['String']>;
  recipientId?: Maybe<Scalars['uuid']>;
  smsStatus?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "broadcast_logs" */
export type Broadcast_Logs_Min_Order_By = {
  broadcastId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  emailStatus?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  notificationStatus?: Maybe<Order_By>;
  recipientId?: Maybe<Order_By>;
  smsStatus?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "broadcast_logs" */
export type Broadcast_Logs_Mutation_Response = {
  __typename?: 'broadcast_logs_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Broadcast_Logs>;
};

/** input type for inserting object relation for remote table "broadcast_logs" */
export type Broadcast_Logs_Obj_Rel_Insert_Input = {
  data: Broadcast_Logs_Insert_Input;
  on_conflict?: Maybe<Broadcast_Logs_On_Conflict>;
};

/** on conflict condition type for table "broadcast_logs" */
export type Broadcast_Logs_On_Conflict = {
  constraint: Broadcast_Logs_Constraint;
  update_columns: Array<Broadcast_Logs_Update_Column>;
  where?: Maybe<Broadcast_Logs_Bool_Exp>;
};

/** ordering options when selecting data from "broadcast_logs" */
export type Broadcast_Logs_Order_By = {
  broadcast?: Maybe<Broadcasts_Order_By>;
  broadcastId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  emailResponse?: Maybe<Order_By>;
  emailStatus?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  isViewed?: Maybe<Order_By>;
  notificationResponse?: Maybe<Order_By>;
  notificationStatus?: Maybe<Order_By>;
  recipient?: Maybe<Users_Order_By>;
  recipientId?: Maybe<Order_By>;
  smsResponse?: Maybe<Order_By>;
  smsStatus?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "broadcast_logs" */
export type Broadcast_Logs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Broadcast_Logs_Prepend_Input = {
  emailResponse?: Maybe<Scalars['jsonb']>;
  notificationResponse?: Maybe<Scalars['jsonb']>;
  smsResponse?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "broadcast_logs" */
export enum Broadcast_Logs_Select_Column {
  /** column name */
  BroadcastId = 'broadcastId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EmailResponse = 'emailResponse',
  /** column name */
  EmailStatus = 'emailStatus',
  /** column name */
  Id = 'id',
  /** column name */
  IsViewed = 'isViewed',
  /** column name */
  NotificationResponse = 'notificationResponse',
  /** column name */
  NotificationStatus = 'notificationStatus',
  /** column name */
  RecipientId = 'recipientId',
  /** column name */
  SmsResponse = 'smsResponse',
  /** column name */
  SmsStatus = 'smsStatus',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "broadcast_logs" */
export type Broadcast_Logs_Set_Input = {
  broadcastId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailResponse?: Maybe<Scalars['jsonb']>;
  emailStatus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  isViewed?: Maybe<Scalars['Boolean']>;
  notificationResponse?: Maybe<Scalars['jsonb']>;
  notificationStatus?: Maybe<Scalars['String']>;
  recipientId?: Maybe<Scalars['uuid']>;
  smsResponse?: Maybe<Scalars['jsonb']>;
  smsStatus?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "broadcast_logs" */
export enum Broadcast_Logs_Update_Column {
  /** column name */
  BroadcastId = 'broadcastId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EmailResponse = 'emailResponse',
  /** column name */
  EmailStatus = 'emailStatus',
  /** column name */
  Id = 'id',
  /** column name */
  IsViewed = 'isViewed',
  /** column name */
  NotificationResponse = 'notificationResponse',
  /** column name */
  NotificationStatus = 'notificationStatus',
  /** column name */
  RecipientId = 'recipientId',
  /** column name */
  SmsResponse = 'smsResponse',
  /** column name */
  SmsStatus = 'smsStatus',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** columns and relationships of "broadcasts" */
export type Broadcasts = {
  __typename?: 'broadcasts';
  /** An array relationship */
  broadcastLogs: Array<Broadcast_Logs>;
  /** An aggregated array relationship */
  broadcastLogs_aggregate: Broadcast_Logs_Aggregate;
  broadcastStatus: Scalars['String'];
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  createdUser?: Maybe<Users>;
  filterRecipient?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  recipientType?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  subject?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  updatedUser?: Maybe<Users>;
  via: Scalars['jsonb'];
};


/** columns and relationships of "broadcasts" */
export type BroadcastsBroadcastLogsArgs = {
  distinct_on?: Maybe<Array<Broadcast_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Broadcast_Logs_Order_By>>;
  where?: Maybe<Broadcast_Logs_Bool_Exp>;
};


/** columns and relationships of "broadcasts" */
export type BroadcastsBroadcastLogs_AggregateArgs = {
  distinct_on?: Maybe<Array<Broadcast_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Broadcast_Logs_Order_By>>;
  where?: Maybe<Broadcast_Logs_Bool_Exp>;
};


/** columns and relationships of "broadcasts" */
export type BroadcastsFilterRecipientArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "broadcasts" */
export type BroadcastsViaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "broadcasts" */
export type Broadcasts_Aggregate = {
  __typename?: 'broadcasts_aggregate';
  aggregate?: Maybe<Broadcasts_Aggregate_Fields>;
  nodes: Array<Broadcasts>;
};

/** aggregate fields of "broadcasts" */
export type Broadcasts_Aggregate_Fields = {
  __typename?: 'broadcasts_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Broadcasts_Max_Fields>;
  min?: Maybe<Broadcasts_Min_Fields>;
};


/** aggregate fields of "broadcasts" */
export type Broadcasts_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Broadcasts_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "broadcasts" */
export type Broadcasts_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Broadcasts_Max_Order_By>;
  min?: Maybe<Broadcasts_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Broadcasts_Append_Input = {
  filterRecipient?: Maybe<Scalars['jsonb']>;
  via?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "broadcasts" */
export type Broadcasts_Arr_Rel_Insert_Input = {
  data: Array<Broadcasts_Insert_Input>;
  on_conflict?: Maybe<Broadcasts_On_Conflict>;
};

/** Boolean expression to filter rows from the table "broadcasts". All fields are combined with a logical 'AND'. */
export type Broadcasts_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Broadcasts_Bool_Exp>>>;
  _not?: Maybe<Broadcasts_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Broadcasts_Bool_Exp>>>;
  broadcastLogs?: Maybe<Broadcast_Logs_Bool_Exp>;
  broadcastStatus?: Maybe<String_Comparison_Exp>;
  content?: Maybe<String_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  createdUser?: Maybe<Users_Bool_Exp>;
  filterRecipient?: Maybe<Jsonb_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  recipientType?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  subject?: Maybe<String_Comparison_Exp>;
  title?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  updatedUser?: Maybe<Users_Bool_Exp>;
  via?: Maybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "broadcasts" */
export enum Broadcasts_Constraint {
  /** unique or primary key constraint */
  BroadcastsPkey = 'broadcasts_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Broadcasts_Delete_At_Path_Input = {
  filterRecipient?: Maybe<Array<Maybe<Scalars['String']>>>;
  via?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Broadcasts_Delete_Elem_Input = {
  filterRecipient?: Maybe<Scalars['Int']>;
  via?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Broadcasts_Delete_Key_Input = {
  filterRecipient?: Maybe<Scalars['String']>;
  via?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "broadcasts" */
export type Broadcasts_Insert_Input = {
  broadcastLogs?: Maybe<Broadcast_Logs_Arr_Rel_Insert_Input>;
  broadcastStatus?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  createdUser?: Maybe<Users_Obj_Rel_Insert_Input>;
  filterRecipient?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  recipientType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  updatedUser?: Maybe<Users_Obj_Rel_Insert_Input>;
  via?: Maybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type Broadcasts_Max_Fields = {
  __typename?: 'broadcasts_max_fields';
  broadcastStatus?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  recipientType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "broadcasts" */
export type Broadcasts_Max_Order_By = {
  broadcastStatus?: Maybe<Order_By>;
  content?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  recipientType?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  subject?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Broadcasts_Min_Fields = {
  __typename?: 'broadcasts_min_fields';
  broadcastStatus?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  recipientType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "broadcasts" */
export type Broadcasts_Min_Order_By = {
  broadcastStatus?: Maybe<Order_By>;
  content?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  recipientType?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  subject?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "broadcasts" */
export type Broadcasts_Mutation_Response = {
  __typename?: 'broadcasts_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Broadcasts>;
};

/** input type for inserting object relation for remote table "broadcasts" */
export type Broadcasts_Obj_Rel_Insert_Input = {
  data: Broadcasts_Insert_Input;
  on_conflict?: Maybe<Broadcasts_On_Conflict>;
};

/** on conflict condition type for table "broadcasts" */
export type Broadcasts_On_Conflict = {
  constraint: Broadcasts_Constraint;
  update_columns: Array<Broadcasts_Update_Column>;
  where?: Maybe<Broadcasts_Bool_Exp>;
};

/** ordering options when selecting data from "broadcasts" */
export type Broadcasts_Order_By = {
  broadcastLogs_aggregate?: Maybe<Broadcast_Logs_Aggregate_Order_By>;
  broadcastStatus?: Maybe<Order_By>;
  content?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  createdUser?: Maybe<Users_Order_By>;
  filterRecipient?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  recipientType?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  subject?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  updatedUser?: Maybe<Users_Order_By>;
  via?: Maybe<Order_By>;
};

/** primary key columns input for table: "broadcasts" */
export type Broadcasts_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Broadcasts_Prepend_Input = {
  filterRecipient?: Maybe<Scalars['jsonb']>;
  via?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "broadcasts" */
export enum Broadcasts_Select_Column {
  /** column name */
  BroadcastStatus = 'broadcastStatus',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  FilterRecipient = 'filterRecipient',
  /** column name */
  Id = 'id',
  /** column name */
  RecipientType = 'recipientType',
  /** column name */
  Status = 'status',
  /** column name */
  Subject = 'subject',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Via = 'via'
}

/** input type for updating data in table "broadcasts" */
export type Broadcasts_Set_Input = {
  broadcastStatus?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  filterRecipient?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  recipientType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  via?: Maybe<Scalars['jsonb']>;
};

/** update columns of table "broadcasts" */
export enum Broadcasts_Update_Column {
  /** column name */
  BroadcastStatus = 'broadcastStatus',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  FilterRecipient = 'filterRecipient',
  /** column name */
  Id = 'id',
  /** column name */
  RecipientType = 'recipientType',
  /** column name */
  Status = 'status',
  /** column name */
  Subject = 'subject',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Via = 'via'
}

export type Class_Filter_By_Filling_Status_Args = {
  filling_status?: Maybe<Scalars['String']>;
};

export type Class_Filter_By_Student_Args = {
  student_id?: Maybe<Scalars['uuid']>;
};

/** columns and relationships of "class_students_waiting" */
export type Class_Students_Waiting = {
  __typename?: 'class_students_waiting';
  /** An object relationship */
  class: Classes;
  classId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  paymentStatus: Scalars['String'];
  status: Scalars['String'];
  /** An object relationship */
  student: Users;
  studentId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  waitingStatus: Scalars['String'];
};

/** aggregated selection of "class_students_waiting" */
export type Class_Students_Waiting_Aggregate = {
  __typename?: 'class_students_waiting_aggregate';
  aggregate?: Maybe<Class_Students_Waiting_Aggregate_Fields>;
  nodes: Array<Class_Students_Waiting>;
};

/** aggregate fields of "class_students_waiting" */
export type Class_Students_Waiting_Aggregate_Fields = {
  __typename?: 'class_students_waiting_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Class_Students_Waiting_Max_Fields>;
  min?: Maybe<Class_Students_Waiting_Min_Fields>;
};


/** aggregate fields of "class_students_waiting" */
export type Class_Students_Waiting_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Class_Students_Waiting_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "class_students_waiting" */
export type Class_Students_Waiting_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Class_Students_Waiting_Max_Order_By>;
  min?: Maybe<Class_Students_Waiting_Min_Order_By>;
};

/** input type for inserting array relation for remote table "class_students_waiting" */
export type Class_Students_Waiting_Arr_Rel_Insert_Input = {
  data: Array<Class_Students_Waiting_Insert_Input>;
  on_conflict?: Maybe<Class_Students_Waiting_On_Conflict>;
};

/** Boolean expression to filter rows from the table "class_students_waiting". All fields are combined with a logical 'AND'. */
export type Class_Students_Waiting_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Class_Students_Waiting_Bool_Exp>>>;
  _not?: Maybe<Class_Students_Waiting_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Class_Students_Waiting_Bool_Exp>>>;
  class?: Maybe<Classes_Bool_Exp>;
  classId?: Maybe<Uuid_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  paymentStatus?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  student?: Maybe<Users_Bool_Exp>;
  studentId?: Maybe<Uuid_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  waitingStatus?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "class_students_waiting" */
export enum Class_Students_Waiting_Constraint {
  /** unique or primary key constraint */
  ClassStudentsWaitingPkey = 'class_students_waiting_pkey',
  /** unique or primary key constraint */
  ClassStudentsWaitingStudentIdClassIdKey = 'class_students_waiting_studentId_classId_key'
}

/** input type for inserting data into table "class_students_waiting" */
export type Class_Students_Waiting_Insert_Input = {
  class?: Maybe<Classes_Obj_Rel_Insert_Input>;
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentStatus?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  student?: Maybe<Users_Obj_Rel_Insert_Input>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  waitingStatus?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Class_Students_Waiting_Max_Fields = {
  __typename?: 'class_students_waiting_max_fields';
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentStatus?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  waitingStatus?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "class_students_waiting" */
export type Class_Students_Waiting_Max_Order_By = {
  classId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  paymentStatus?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  waitingStatus?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Class_Students_Waiting_Min_Fields = {
  __typename?: 'class_students_waiting_min_fields';
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentStatus?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  waitingStatus?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "class_students_waiting" */
export type Class_Students_Waiting_Min_Order_By = {
  classId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  paymentStatus?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  waitingStatus?: Maybe<Order_By>;
};

/** response of any mutation on the table "class_students_waiting" */
export type Class_Students_Waiting_Mutation_Response = {
  __typename?: 'class_students_waiting_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Class_Students_Waiting>;
};

/** input type for inserting object relation for remote table "class_students_waiting" */
export type Class_Students_Waiting_Obj_Rel_Insert_Input = {
  data: Class_Students_Waiting_Insert_Input;
  on_conflict?: Maybe<Class_Students_Waiting_On_Conflict>;
};

/** on conflict condition type for table "class_students_waiting" */
export type Class_Students_Waiting_On_Conflict = {
  constraint: Class_Students_Waiting_Constraint;
  update_columns: Array<Class_Students_Waiting_Update_Column>;
  where?: Maybe<Class_Students_Waiting_Bool_Exp>;
};

/** ordering options when selecting data from "class_students_waiting" */
export type Class_Students_Waiting_Order_By = {
  class?: Maybe<Classes_Order_By>;
  classId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  paymentStatus?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  student?: Maybe<Users_Order_By>;
  studentId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  waitingStatus?: Maybe<Order_By>;
};

/** primary key columns input for table: "class_students_waiting" */
export type Class_Students_Waiting_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "class_students_waiting" */
export enum Class_Students_Waiting_Select_Column {
  /** column name */
  ClassId = 'classId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentStatus = 'paymentStatus',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  WaitingStatus = 'waitingStatus'
}

/** input type for updating data in table "class_students_waiting" */
export type Class_Students_Waiting_Set_Input = {
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentStatus?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  waitingStatus?: Maybe<Scalars['String']>;
};

/** update columns of table "class_students_waiting" */
export enum Class_Students_Waiting_Update_Column {
  /** column name */
  ClassId = 'classId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentStatus = 'paymentStatus',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  WaitingStatus = 'waitingStatus'
}

/** columns and relationships of "classes" */
export type Classes = {
  __typename?: 'classes';
  /** An object relationship */
  academicCalendar?: Maybe<Academic_Calendars>;
  academicCalendarId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  additional_class_tickets: Array<Additional_Class_Tickets>;
  /** An aggregated array relationship */
  additional_class_tickets_aggregate: Additional_Class_Tickets_Aggregate;
  classId: Scalars['String'];
  classStatus: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  credit_note_classes: Array<Credit_Note_Classes>;
  /** An aggregated array relationship */
  credit_note_classes_aggregate: Credit_Note_Classes_Aggregate;
  /** A computed field, executes function "enrolled_field_classes" */
  enrolledClass?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  lessonType: Scalars['String'];
  /** An array relationship */
  lessons: Array<Lessons>;
  /** An aggregated array relationship */
  lessons_aggregate: Lessons_Aggregate;
  name: Scalars['String'];
  /** An array relationship */
  paymentAdviceClasses: Array<Payment_Advice_Classes>;
  /** An aggregated array relationship */
  paymentAdviceClasses_aggregate: Payment_Advice_Classes_Aggregate;
  /** An object relationship */
  program: Programs;
  programId: Scalars['uuid'];
  /** An object relationship */
  programTypeDoubleLesson?: Maybe<Double_Lesson_Program_Types>;
  programTypeDoubleLessonId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  programTypeGeneral?: Maybe<General_Program_Types>;
  programTypeGeneralId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  programTypeRegular?: Maybe<Regular_Program_Types>;
  programTypeRegularId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  programTypeSpecial?: Maybe<Specical_Program_Types>;
  programTypeSpecialId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  refund_classes: Array<Refund_Classes>;
  /** An aggregated array relationship */
  refund_classes_aggregate: Refund_Classes_Aggregate;
  remark?: Maybe<Scalars['String']>;
  /** An array relationship */
  special_programme_class_pricings: Array<Special_Programme_Class_Pricings>;
  /** An aggregated array relationship */
  special_programme_class_pricings_aggregate: Special_Programme_Class_Pricings_Aggregate;
  startDate?: Maybe<Scalars['timestamptz']>;
  status: Scalars['String'];
  /** An array relationship */
  studentsWaiting: Array<Class_Students_Waiting>;
  /** An aggregated array relationship */
  studentsWaiting_aggregate: Class_Students_Waiting_Aggregate;
  /** An array relationship */
  termClasses: Array<Term_Classes>;
  /** An aggregated array relationship */
  termClasses_aggregate: Term_Classes_Aggregate;
  totalLoop?: Maybe<Scalars['numeric']>;
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  waitingTime?: Maybe<Scalars['timestamptz']>;
  year?: Maybe<Scalars['String']>;
};


/** columns and relationships of "classes" */
export type ClassesAdditional_Class_TicketsArgs = {
  distinct_on?: Maybe<Array<Additional_Class_Tickets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Additional_Class_Tickets_Order_By>>;
  where?: Maybe<Additional_Class_Tickets_Bool_Exp>;
};


/** columns and relationships of "classes" */
export type ClassesAdditional_Class_Tickets_AggregateArgs = {
  distinct_on?: Maybe<Array<Additional_Class_Tickets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Additional_Class_Tickets_Order_By>>;
  where?: Maybe<Additional_Class_Tickets_Bool_Exp>;
};


/** columns and relationships of "classes" */
export type ClassesCredit_Note_ClassesArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Classes_Order_By>>;
  where?: Maybe<Credit_Note_Classes_Bool_Exp>;
};


/** columns and relationships of "classes" */
export type ClassesCredit_Note_Classes_AggregateArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Classes_Order_By>>;
  where?: Maybe<Credit_Note_Classes_Bool_Exp>;
};


/** columns and relationships of "classes" */
export type ClassesLessonsArgs = {
  distinct_on?: Maybe<Array<Lessons_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Order_By>>;
  where?: Maybe<Lessons_Bool_Exp>;
};


/** columns and relationships of "classes" */
export type ClassesLessons_AggregateArgs = {
  distinct_on?: Maybe<Array<Lessons_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Order_By>>;
  where?: Maybe<Lessons_Bool_Exp>;
};


/** columns and relationships of "classes" */
export type ClassesPaymentAdviceClassesArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Classes_Order_By>>;
  where?: Maybe<Payment_Advice_Classes_Bool_Exp>;
};


/** columns and relationships of "classes" */
export type ClassesPaymentAdviceClasses_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Classes_Order_By>>;
  where?: Maybe<Payment_Advice_Classes_Bool_Exp>;
};


/** columns and relationships of "classes" */
export type ClassesRefund_ClassesArgs = {
  distinct_on?: Maybe<Array<Refund_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refund_Classes_Order_By>>;
  where?: Maybe<Refund_Classes_Bool_Exp>;
};


/** columns and relationships of "classes" */
export type ClassesRefund_Classes_AggregateArgs = {
  distinct_on?: Maybe<Array<Refund_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refund_Classes_Order_By>>;
  where?: Maybe<Refund_Classes_Bool_Exp>;
};


/** columns and relationships of "classes" */
export type ClassesSpecial_Programme_Class_PricingsArgs = {
  distinct_on?: Maybe<Array<Special_Programme_Class_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Special_Programme_Class_Pricings_Order_By>>;
  where?: Maybe<Special_Programme_Class_Pricings_Bool_Exp>;
};


/** columns and relationships of "classes" */
export type ClassesSpecial_Programme_Class_Pricings_AggregateArgs = {
  distinct_on?: Maybe<Array<Special_Programme_Class_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Special_Programme_Class_Pricings_Order_By>>;
  where?: Maybe<Special_Programme_Class_Pricings_Bool_Exp>;
};


/** columns and relationships of "classes" */
export type ClassesStudentsWaitingArgs = {
  distinct_on?: Maybe<Array<Class_Students_Waiting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Class_Students_Waiting_Order_By>>;
  where?: Maybe<Class_Students_Waiting_Bool_Exp>;
};


/** columns and relationships of "classes" */
export type ClassesStudentsWaiting_AggregateArgs = {
  distinct_on?: Maybe<Array<Class_Students_Waiting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Class_Students_Waiting_Order_By>>;
  where?: Maybe<Class_Students_Waiting_Bool_Exp>;
};


/** columns and relationships of "classes" */
export type ClassesTermClassesArgs = {
  distinct_on?: Maybe<Array<Term_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Term_Classes_Order_By>>;
  where?: Maybe<Term_Classes_Bool_Exp>;
};


/** columns and relationships of "classes" */
export type ClassesTermClasses_AggregateArgs = {
  distinct_on?: Maybe<Array<Term_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Term_Classes_Order_By>>;
  where?: Maybe<Term_Classes_Bool_Exp>;
};

/** aggregated selection of "classes" */
export type Classes_Aggregate = {
  __typename?: 'classes_aggregate';
  aggregate?: Maybe<Classes_Aggregate_Fields>;
  nodes: Array<Classes>;
};

/** aggregate fields of "classes" */
export type Classes_Aggregate_Fields = {
  __typename?: 'classes_aggregate_fields';
  avg?: Maybe<Classes_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Classes_Max_Fields>;
  min?: Maybe<Classes_Min_Fields>;
  stddev?: Maybe<Classes_Stddev_Fields>;
  stddev_pop?: Maybe<Classes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Classes_Stddev_Samp_Fields>;
  sum?: Maybe<Classes_Sum_Fields>;
  var_pop?: Maybe<Classes_Var_Pop_Fields>;
  var_samp?: Maybe<Classes_Var_Samp_Fields>;
  variance?: Maybe<Classes_Variance_Fields>;
};


/** aggregate fields of "classes" */
export type Classes_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Classes_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "classes" */
export type Classes_Aggregate_Order_By = {
  avg?: Maybe<Classes_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Classes_Max_Order_By>;
  min?: Maybe<Classes_Min_Order_By>;
  stddev?: Maybe<Classes_Stddev_Order_By>;
  stddev_pop?: Maybe<Classes_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Classes_Stddev_Samp_Order_By>;
  sum?: Maybe<Classes_Sum_Order_By>;
  var_pop?: Maybe<Classes_Var_Pop_Order_By>;
  var_samp?: Maybe<Classes_Var_Samp_Order_By>;
  variance?: Maybe<Classes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "classes" */
export type Classes_Arr_Rel_Insert_Input = {
  data: Array<Classes_Insert_Input>;
  on_conflict?: Maybe<Classes_On_Conflict>;
};

/** aggregate avg on columns */
export type Classes_Avg_Fields = {
  __typename?: 'classes_avg_fields';
  totalLoop?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "classes" */
export type Classes_Avg_Order_By = {
  totalLoop?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "classes". All fields are combined with a logical 'AND'. */
export type Classes_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Classes_Bool_Exp>>>;
  _not?: Maybe<Classes_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Classes_Bool_Exp>>>;
  academicCalendar?: Maybe<Academic_Calendars_Bool_Exp>;
  academicCalendarId?: Maybe<Uuid_Comparison_Exp>;
  additional_class_tickets?: Maybe<Additional_Class_Tickets_Bool_Exp>;
  classId?: Maybe<String_Comparison_Exp>;
  classStatus?: Maybe<String_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  credit_note_classes?: Maybe<Credit_Note_Classes_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  lessonType?: Maybe<String_Comparison_Exp>;
  lessons?: Maybe<Lessons_Bool_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  paymentAdviceClasses?: Maybe<Payment_Advice_Classes_Bool_Exp>;
  program?: Maybe<Programs_Bool_Exp>;
  programId?: Maybe<Uuid_Comparison_Exp>;
  programTypeDoubleLesson?: Maybe<Double_Lesson_Program_Types_Bool_Exp>;
  programTypeDoubleLessonId?: Maybe<Uuid_Comparison_Exp>;
  programTypeGeneral?: Maybe<General_Program_Types_Bool_Exp>;
  programTypeGeneralId?: Maybe<Uuid_Comparison_Exp>;
  programTypeRegular?: Maybe<Regular_Program_Types_Bool_Exp>;
  programTypeRegularId?: Maybe<Uuid_Comparison_Exp>;
  programTypeSpecial?: Maybe<Specical_Program_Types_Bool_Exp>;
  programTypeSpecialId?: Maybe<Uuid_Comparison_Exp>;
  refund_classes?: Maybe<Refund_Classes_Bool_Exp>;
  remark?: Maybe<String_Comparison_Exp>;
  special_programme_class_pricings?: Maybe<Special_Programme_Class_Pricings_Bool_Exp>;
  startDate?: Maybe<Timestamptz_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  studentsWaiting?: Maybe<Class_Students_Waiting_Bool_Exp>;
  termClasses?: Maybe<Term_Classes_Bool_Exp>;
  totalLoop?: Maybe<Numeric_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  waitingTime?: Maybe<Timestamptz_Comparison_Exp>;
  year?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "classes" */
export enum Classes_Constraint {
  /** unique or primary key constraint */
  ClassesPkey = 'classes_pkey'
}

/** input type for incrementing integer column in table "classes" */
export type Classes_Inc_Input = {
  totalLoop?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "classes" */
export type Classes_Insert_Input = {
  academicCalendar?: Maybe<Academic_Calendars_Obj_Rel_Insert_Input>;
  academicCalendarId?: Maybe<Scalars['uuid']>;
  additional_class_tickets?: Maybe<Additional_Class_Tickets_Arr_Rel_Insert_Input>;
  classId?: Maybe<Scalars['String']>;
  classStatus?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  credit_note_classes?: Maybe<Credit_Note_Classes_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  lessonType?: Maybe<Scalars['String']>;
  lessons?: Maybe<Lessons_Arr_Rel_Insert_Input>;
  name?: Maybe<Scalars['String']>;
  paymentAdviceClasses?: Maybe<Payment_Advice_Classes_Arr_Rel_Insert_Input>;
  program?: Maybe<Programs_Obj_Rel_Insert_Input>;
  programId?: Maybe<Scalars['uuid']>;
  programTypeDoubleLesson?: Maybe<Double_Lesson_Program_Types_Obj_Rel_Insert_Input>;
  programTypeDoubleLessonId?: Maybe<Scalars['uuid']>;
  programTypeGeneral?: Maybe<General_Program_Types_Obj_Rel_Insert_Input>;
  programTypeGeneralId?: Maybe<Scalars['uuid']>;
  programTypeRegular?: Maybe<Regular_Program_Types_Obj_Rel_Insert_Input>;
  programTypeRegularId?: Maybe<Scalars['uuid']>;
  programTypeSpecial?: Maybe<Specical_Program_Types_Obj_Rel_Insert_Input>;
  programTypeSpecialId?: Maybe<Scalars['uuid']>;
  refund_classes?: Maybe<Refund_Classes_Arr_Rel_Insert_Input>;
  remark?: Maybe<Scalars['String']>;
  special_programme_class_pricings?: Maybe<Special_Programme_Class_Pricings_Arr_Rel_Insert_Input>;
  startDate?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  studentsWaiting?: Maybe<Class_Students_Waiting_Arr_Rel_Insert_Input>;
  termClasses?: Maybe<Term_Classes_Arr_Rel_Insert_Input>;
  totalLoop?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  waitingTime?: Maybe<Scalars['timestamptz']>;
  year?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Classes_Max_Fields = {
  __typename?: 'classes_max_fields';
  academicCalendarId?: Maybe<Scalars['uuid']>;
  classId?: Maybe<Scalars['String']>;
  classStatus?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  lessonType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['uuid']>;
  programTypeDoubleLessonId?: Maybe<Scalars['uuid']>;
  programTypeGeneralId?: Maybe<Scalars['uuid']>;
  programTypeRegularId?: Maybe<Scalars['uuid']>;
  programTypeSpecialId?: Maybe<Scalars['uuid']>;
  remark?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  totalLoop?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  waitingTime?: Maybe<Scalars['timestamptz']>;
  year?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "classes" */
export type Classes_Max_Order_By = {
  academicCalendarId?: Maybe<Order_By>;
  classId?: Maybe<Order_By>;
  classStatus?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lessonType?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  programId?: Maybe<Order_By>;
  programTypeDoubleLessonId?: Maybe<Order_By>;
  programTypeGeneralId?: Maybe<Order_By>;
  programTypeRegularId?: Maybe<Order_By>;
  programTypeSpecialId?: Maybe<Order_By>;
  remark?: Maybe<Order_By>;
  startDate?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  totalLoop?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  waitingTime?: Maybe<Order_By>;
  year?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Classes_Min_Fields = {
  __typename?: 'classes_min_fields';
  academicCalendarId?: Maybe<Scalars['uuid']>;
  classId?: Maybe<Scalars['String']>;
  classStatus?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  lessonType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['uuid']>;
  programTypeDoubleLessonId?: Maybe<Scalars['uuid']>;
  programTypeGeneralId?: Maybe<Scalars['uuid']>;
  programTypeRegularId?: Maybe<Scalars['uuid']>;
  programTypeSpecialId?: Maybe<Scalars['uuid']>;
  remark?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  totalLoop?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  waitingTime?: Maybe<Scalars['timestamptz']>;
  year?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "classes" */
export type Classes_Min_Order_By = {
  academicCalendarId?: Maybe<Order_By>;
  classId?: Maybe<Order_By>;
  classStatus?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lessonType?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  programId?: Maybe<Order_By>;
  programTypeDoubleLessonId?: Maybe<Order_By>;
  programTypeGeneralId?: Maybe<Order_By>;
  programTypeRegularId?: Maybe<Order_By>;
  programTypeSpecialId?: Maybe<Order_By>;
  remark?: Maybe<Order_By>;
  startDate?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  totalLoop?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  waitingTime?: Maybe<Order_By>;
  year?: Maybe<Order_By>;
};

/** response of any mutation on the table "classes" */
export type Classes_Mutation_Response = {
  __typename?: 'classes_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Classes>;
};

/** input type for inserting object relation for remote table "classes" */
export type Classes_Obj_Rel_Insert_Input = {
  data: Classes_Insert_Input;
  on_conflict?: Maybe<Classes_On_Conflict>;
};

/** on conflict condition type for table "classes" */
export type Classes_On_Conflict = {
  constraint: Classes_Constraint;
  update_columns: Array<Classes_Update_Column>;
  where?: Maybe<Classes_Bool_Exp>;
};

/** ordering options when selecting data from "classes" */
export type Classes_Order_By = {
  academicCalendar?: Maybe<Academic_Calendars_Order_By>;
  academicCalendarId?: Maybe<Order_By>;
  additional_class_tickets_aggregate?: Maybe<Additional_Class_Tickets_Aggregate_Order_By>;
  classId?: Maybe<Order_By>;
  classStatus?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  credit_note_classes_aggregate?: Maybe<Credit_Note_Classes_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  lessonType?: Maybe<Order_By>;
  lessons_aggregate?: Maybe<Lessons_Aggregate_Order_By>;
  name?: Maybe<Order_By>;
  paymentAdviceClasses_aggregate?: Maybe<Payment_Advice_Classes_Aggregate_Order_By>;
  program?: Maybe<Programs_Order_By>;
  programId?: Maybe<Order_By>;
  programTypeDoubleLesson?: Maybe<Double_Lesson_Program_Types_Order_By>;
  programTypeDoubleLessonId?: Maybe<Order_By>;
  programTypeGeneral?: Maybe<General_Program_Types_Order_By>;
  programTypeGeneralId?: Maybe<Order_By>;
  programTypeRegular?: Maybe<Regular_Program_Types_Order_By>;
  programTypeRegularId?: Maybe<Order_By>;
  programTypeSpecial?: Maybe<Specical_Program_Types_Order_By>;
  programTypeSpecialId?: Maybe<Order_By>;
  refund_classes_aggregate?: Maybe<Refund_Classes_Aggregate_Order_By>;
  remark?: Maybe<Order_By>;
  special_programme_class_pricings_aggregate?: Maybe<Special_Programme_Class_Pricings_Aggregate_Order_By>;
  startDate?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentsWaiting_aggregate?: Maybe<Class_Students_Waiting_Aggregate_Order_By>;
  termClasses_aggregate?: Maybe<Term_Classes_Aggregate_Order_By>;
  totalLoop?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  waitingTime?: Maybe<Order_By>;
  year?: Maybe<Order_By>;
};

/** primary key columns input for table: "classes" */
export type Classes_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "classes" */
export enum Classes_Select_Column {
  /** column name */
  AcademicCalendarId = 'academicCalendarId',
  /** column name */
  ClassId = 'classId',
  /** column name */
  ClassStatus = 'classStatus',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  LessonType = 'lessonType',
  /** column name */
  Name = 'name',
  /** column name */
  ProgramId = 'programId',
  /** column name */
  ProgramTypeDoubleLessonId = 'programTypeDoubleLessonId',
  /** column name */
  ProgramTypeGeneralId = 'programTypeGeneralId',
  /** column name */
  ProgramTypeRegularId = 'programTypeRegularId',
  /** column name */
  ProgramTypeSpecialId = 'programTypeSpecialId',
  /** column name */
  Remark = 'remark',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  Status = 'status',
  /** column name */
  TotalLoop = 'totalLoop',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  WaitingTime = 'waitingTime',
  /** column name */
  Year = 'year'
}

/** input type for updating data in table "classes" */
export type Classes_Set_Input = {
  academicCalendarId?: Maybe<Scalars['uuid']>;
  classId?: Maybe<Scalars['String']>;
  classStatus?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  lessonType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['uuid']>;
  programTypeDoubleLessonId?: Maybe<Scalars['uuid']>;
  programTypeGeneralId?: Maybe<Scalars['uuid']>;
  programTypeRegularId?: Maybe<Scalars['uuid']>;
  programTypeSpecialId?: Maybe<Scalars['uuid']>;
  remark?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  totalLoop?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  waitingTime?: Maybe<Scalars['timestamptz']>;
  year?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Classes_Stddev_Fields = {
  __typename?: 'classes_stddev_fields';
  totalLoop?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "classes" */
export type Classes_Stddev_Order_By = {
  totalLoop?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Classes_Stddev_Pop_Fields = {
  __typename?: 'classes_stddev_pop_fields';
  totalLoop?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "classes" */
export type Classes_Stddev_Pop_Order_By = {
  totalLoop?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Classes_Stddev_Samp_Fields = {
  __typename?: 'classes_stddev_samp_fields';
  totalLoop?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "classes" */
export type Classes_Stddev_Samp_Order_By = {
  totalLoop?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Classes_Sum_Fields = {
  __typename?: 'classes_sum_fields';
  totalLoop?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "classes" */
export type Classes_Sum_Order_By = {
  totalLoop?: Maybe<Order_By>;
};

/** update columns of table "classes" */
export enum Classes_Update_Column {
  /** column name */
  AcademicCalendarId = 'academicCalendarId',
  /** column name */
  ClassId = 'classId',
  /** column name */
  ClassStatus = 'classStatus',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  LessonType = 'lessonType',
  /** column name */
  Name = 'name',
  /** column name */
  ProgramId = 'programId',
  /** column name */
  ProgramTypeDoubleLessonId = 'programTypeDoubleLessonId',
  /** column name */
  ProgramTypeGeneralId = 'programTypeGeneralId',
  /** column name */
  ProgramTypeRegularId = 'programTypeRegularId',
  /** column name */
  ProgramTypeSpecialId = 'programTypeSpecialId',
  /** column name */
  Remark = 'remark',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  Status = 'status',
  /** column name */
  TotalLoop = 'totalLoop',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  WaitingTime = 'waitingTime',
  /** column name */
  Year = 'year'
}

/** aggregate var_pop on columns */
export type Classes_Var_Pop_Fields = {
  __typename?: 'classes_var_pop_fields';
  totalLoop?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "classes" */
export type Classes_Var_Pop_Order_By = {
  totalLoop?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Classes_Var_Samp_Fields = {
  __typename?: 'classes_var_samp_fields';
  totalLoop?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "classes" */
export type Classes_Var_Samp_Order_By = {
  totalLoop?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Classes_Variance_Fields = {
  __typename?: 'classes_variance_fields';
  totalLoop?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "classes" */
export type Classes_Variance_Order_By = {
  totalLoop?: Maybe<Order_By>;
};

/** columns and relationships of "classrooms" */
export type Classrooms = {
  __typename?: 'classrooms';
  /** An object relationship */
  branch: Branches;
  branchId: Scalars['uuid'];
  capacity: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An array relationship */
  lessons: Array<Lessons>;
  /** An aggregated array relationship */
  lessons_aggregate: Lessons_Aggregate;
  name: Scalars['String'];
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "classrooms" */
export type ClassroomsLessonsArgs = {
  distinct_on?: Maybe<Array<Lessons_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Order_By>>;
  where?: Maybe<Lessons_Bool_Exp>;
};


/** columns and relationships of "classrooms" */
export type ClassroomsLessons_AggregateArgs = {
  distinct_on?: Maybe<Array<Lessons_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Order_By>>;
  where?: Maybe<Lessons_Bool_Exp>;
};

/** aggregated selection of "classrooms" */
export type Classrooms_Aggregate = {
  __typename?: 'classrooms_aggregate';
  aggregate?: Maybe<Classrooms_Aggregate_Fields>;
  nodes: Array<Classrooms>;
};

/** aggregate fields of "classrooms" */
export type Classrooms_Aggregate_Fields = {
  __typename?: 'classrooms_aggregate_fields';
  avg?: Maybe<Classrooms_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Classrooms_Max_Fields>;
  min?: Maybe<Classrooms_Min_Fields>;
  stddev?: Maybe<Classrooms_Stddev_Fields>;
  stddev_pop?: Maybe<Classrooms_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Classrooms_Stddev_Samp_Fields>;
  sum?: Maybe<Classrooms_Sum_Fields>;
  var_pop?: Maybe<Classrooms_Var_Pop_Fields>;
  var_samp?: Maybe<Classrooms_Var_Samp_Fields>;
  variance?: Maybe<Classrooms_Variance_Fields>;
};


/** aggregate fields of "classrooms" */
export type Classrooms_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Classrooms_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "classrooms" */
export type Classrooms_Aggregate_Order_By = {
  avg?: Maybe<Classrooms_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Classrooms_Max_Order_By>;
  min?: Maybe<Classrooms_Min_Order_By>;
  stddev?: Maybe<Classrooms_Stddev_Order_By>;
  stddev_pop?: Maybe<Classrooms_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Classrooms_Stddev_Samp_Order_By>;
  sum?: Maybe<Classrooms_Sum_Order_By>;
  var_pop?: Maybe<Classrooms_Var_Pop_Order_By>;
  var_samp?: Maybe<Classrooms_Var_Samp_Order_By>;
  variance?: Maybe<Classrooms_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "classrooms" */
export type Classrooms_Arr_Rel_Insert_Input = {
  data: Array<Classrooms_Insert_Input>;
  on_conflict?: Maybe<Classrooms_On_Conflict>;
};

/** aggregate avg on columns */
export type Classrooms_Avg_Fields = {
  __typename?: 'classrooms_avg_fields';
  capacity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "classrooms" */
export type Classrooms_Avg_Order_By = {
  capacity?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "classrooms". All fields are combined with a logical 'AND'. */
export type Classrooms_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Classrooms_Bool_Exp>>>;
  _not?: Maybe<Classrooms_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Classrooms_Bool_Exp>>>;
  branch?: Maybe<Branches_Bool_Exp>;
  branchId?: Maybe<Uuid_Comparison_Exp>;
  capacity?: Maybe<Int_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  lessons?: Maybe<Lessons_Bool_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "classrooms" */
export enum Classrooms_Constraint {
  /** unique or primary key constraint */
  ClassroomsPkey = 'classrooms_pkey'
}

/** input type for incrementing integer column in table "classrooms" */
export type Classrooms_Inc_Input = {
  capacity?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "classrooms" */
export type Classrooms_Insert_Input = {
  branch?: Maybe<Branches_Obj_Rel_Insert_Input>;
  branchId?: Maybe<Scalars['uuid']>;
  capacity?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  lessons?: Maybe<Lessons_Arr_Rel_Insert_Input>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Classrooms_Max_Fields = {
  __typename?: 'classrooms_max_fields';
  branchId?: Maybe<Scalars['uuid']>;
  capacity?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "classrooms" */
export type Classrooms_Max_Order_By = {
  branchId?: Maybe<Order_By>;
  capacity?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Classrooms_Min_Fields = {
  __typename?: 'classrooms_min_fields';
  branchId?: Maybe<Scalars['uuid']>;
  capacity?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "classrooms" */
export type Classrooms_Min_Order_By = {
  branchId?: Maybe<Order_By>;
  capacity?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "classrooms" */
export type Classrooms_Mutation_Response = {
  __typename?: 'classrooms_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Classrooms>;
};

/** input type for inserting object relation for remote table "classrooms" */
export type Classrooms_Obj_Rel_Insert_Input = {
  data: Classrooms_Insert_Input;
  on_conflict?: Maybe<Classrooms_On_Conflict>;
};

/** on conflict condition type for table "classrooms" */
export type Classrooms_On_Conflict = {
  constraint: Classrooms_Constraint;
  update_columns: Array<Classrooms_Update_Column>;
  where?: Maybe<Classrooms_Bool_Exp>;
};

/** ordering options when selecting data from "classrooms" */
export type Classrooms_Order_By = {
  branch?: Maybe<Branches_Order_By>;
  branchId?: Maybe<Order_By>;
  capacity?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lessons_aggregate?: Maybe<Lessons_Aggregate_Order_By>;
  name?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "classrooms" */
export type Classrooms_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "classrooms" */
export enum Classrooms_Select_Column {
  /** column name */
  BranchId = 'branchId',
  /** column name */
  Capacity = 'capacity',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "classrooms" */
export type Classrooms_Set_Input = {
  branchId?: Maybe<Scalars['uuid']>;
  capacity?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Classrooms_Stddev_Fields = {
  __typename?: 'classrooms_stddev_fields';
  capacity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "classrooms" */
export type Classrooms_Stddev_Order_By = {
  capacity?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Classrooms_Stddev_Pop_Fields = {
  __typename?: 'classrooms_stddev_pop_fields';
  capacity?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "classrooms" */
export type Classrooms_Stddev_Pop_Order_By = {
  capacity?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Classrooms_Stddev_Samp_Fields = {
  __typename?: 'classrooms_stddev_samp_fields';
  capacity?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "classrooms" */
export type Classrooms_Stddev_Samp_Order_By = {
  capacity?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Classrooms_Sum_Fields = {
  __typename?: 'classrooms_sum_fields';
  capacity?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "classrooms" */
export type Classrooms_Sum_Order_By = {
  capacity?: Maybe<Order_By>;
};

/** update columns of table "classrooms" */
export enum Classrooms_Update_Column {
  /** column name */
  BranchId = 'branchId',
  /** column name */
  Capacity = 'capacity',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** aggregate var_pop on columns */
export type Classrooms_Var_Pop_Fields = {
  __typename?: 'classrooms_var_pop_fields';
  capacity?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "classrooms" */
export type Classrooms_Var_Pop_Order_By = {
  capacity?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Classrooms_Var_Samp_Fields = {
  __typename?: 'classrooms_var_samp_fields';
  capacity?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "classrooms" */
export type Classrooms_Var_Samp_Order_By = {
  capacity?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Classrooms_Variance_Fields = {
  __typename?: 'classrooms_variance_fields';
  capacity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "classrooms" */
export type Classrooms_Variance_Order_By = {
  capacity?: Maybe<Order_By>;
};

/** columns and relationships of "credit_note_classes" */
export type Credit_Note_Classes = {
  __typename?: 'credit_note_classes';
  /** An object relationship */
  class?: Maybe<Classes>;
  classId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  credit_notes: Array<Credit_Notes>;
  /** An aggregated array relationship */
  credit_notes_aggregate: Credit_Notes_Aggregate;
  endDate?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  lessonIds?: Maybe<Scalars['jsonb']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  status: Scalars['String'];
  /** An object relationship */
  term?: Maybe<Terms>;
  termId?: Maybe<Scalars['uuid']>;
  termName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  userByCreatedby?: Maybe<Users>;
};


/** columns and relationships of "credit_note_classes" */
export type Credit_Note_ClassesCredit_NotesArgs = {
  distinct_on?: Maybe<Array<Credit_Notes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Notes_Order_By>>;
  where?: Maybe<Credit_Notes_Bool_Exp>;
};


/** columns and relationships of "credit_note_classes" */
export type Credit_Note_ClassesCredit_Notes_AggregateArgs = {
  distinct_on?: Maybe<Array<Credit_Notes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Notes_Order_By>>;
  where?: Maybe<Credit_Notes_Bool_Exp>;
};


/** columns and relationships of "credit_note_classes" */
export type Credit_Note_ClassesLessonIdsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "credit_note_classes" */
export type Credit_Note_Classes_Aggregate = {
  __typename?: 'credit_note_classes_aggregate';
  aggregate?: Maybe<Credit_Note_Classes_Aggregate_Fields>;
  nodes: Array<Credit_Note_Classes>;
};

/** aggregate fields of "credit_note_classes" */
export type Credit_Note_Classes_Aggregate_Fields = {
  __typename?: 'credit_note_classes_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Credit_Note_Classes_Max_Fields>;
  min?: Maybe<Credit_Note_Classes_Min_Fields>;
};


/** aggregate fields of "credit_note_classes" */
export type Credit_Note_Classes_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Credit_Note_Classes_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "credit_note_classes" */
export type Credit_Note_Classes_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Credit_Note_Classes_Max_Order_By>;
  min?: Maybe<Credit_Note_Classes_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Credit_Note_Classes_Append_Input = {
  lessonIds?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "credit_note_classes" */
export type Credit_Note_Classes_Arr_Rel_Insert_Input = {
  data: Array<Credit_Note_Classes_Insert_Input>;
  on_conflict?: Maybe<Credit_Note_Classes_On_Conflict>;
};

/** Boolean expression to filter rows from the table "credit_note_classes". All fields are combined with a logical 'AND'. */
export type Credit_Note_Classes_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Credit_Note_Classes_Bool_Exp>>>;
  _not?: Maybe<Credit_Note_Classes_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Credit_Note_Classes_Bool_Exp>>>;
  class?: Maybe<Classes_Bool_Exp>;
  classId?: Maybe<Uuid_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  credit_notes?: Maybe<Credit_Notes_Bool_Exp>;
  endDate?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  lessonIds?: Maybe<Jsonb_Comparison_Exp>;
  startDate?: Maybe<Timestamptz_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  term?: Maybe<Terms_Bool_Exp>;
  termId?: Maybe<Uuid_Comparison_Exp>;
  termName?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  userByCreatedby?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "credit_note_classes" */
export enum Credit_Note_Classes_Constraint {
  /** unique or primary key constraint */
  CreditNoteClassesPkey = 'credit_note_classes_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Credit_Note_Classes_Delete_At_Path_Input = {
  lessonIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Credit_Note_Classes_Delete_Elem_Input = {
  lessonIds?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Credit_Note_Classes_Delete_Key_Input = {
  lessonIds?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "credit_note_classes" */
export type Credit_Note_Classes_Insert_Input = {
  class?: Maybe<Classes_Obj_Rel_Insert_Input>;
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  credit_notes?: Maybe<Credit_Notes_Arr_Rel_Insert_Input>;
  endDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonIds?: Maybe<Scalars['jsonb']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  term?: Maybe<Terms_Obj_Rel_Insert_Input>;
  termId?: Maybe<Scalars['uuid']>;
  termName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  userByCreatedby?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Credit_Note_Classes_Max_Fields = {
  __typename?: 'credit_note_classes_max_fields';
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  endDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  termId?: Maybe<Scalars['uuid']>;
  termName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "credit_note_classes" */
export type Credit_Note_Classes_Max_Order_By = {
  classId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  endDate?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  startDate?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  termId?: Maybe<Order_By>;
  termName?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Credit_Note_Classes_Min_Fields = {
  __typename?: 'credit_note_classes_min_fields';
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  endDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  termId?: Maybe<Scalars['uuid']>;
  termName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "credit_note_classes" */
export type Credit_Note_Classes_Min_Order_By = {
  classId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  endDate?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  startDate?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  termId?: Maybe<Order_By>;
  termName?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "credit_note_classes" */
export type Credit_Note_Classes_Mutation_Response = {
  __typename?: 'credit_note_classes_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Credit_Note_Classes>;
};

/** input type for inserting object relation for remote table "credit_note_classes" */
export type Credit_Note_Classes_Obj_Rel_Insert_Input = {
  data: Credit_Note_Classes_Insert_Input;
  on_conflict?: Maybe<Credit_Note_Classes_On_Conflict>;
};

/** on conflict condition type for table "credit_note_classes" */
export type Credit_Note_Classes_On_Conflict = {
  constraint: Credit_Note_Classes_Constraint;
  update_columns: Array<Credit_Note_Classes_Update_Column>;
  where?: Maybe<Credit_Note_Classes_Bool_Exp>;
};

/** ordering options when selecting data from "credit_note_classes" */
export type Credit_Note_Classes_Order_By = {
  class?: Maybe<Classes_Order_By>;
  classId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  credit_notes_aggregate?: Maybe<Credit_Notes_Aggregate_Order_By>;
  endDate?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lessonIds?: Maybe<Order_By>;
  startDate?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  term?: Maybe<Terms_Order_By>;
  termId?: Maybe<Order_By>;
  termName?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  userByCreatedby?: Maybe<Users_Order_By>;
};

/** primary key columns input for table: "credit_note_classes" */
export type Credit_Note_Classes_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Credit_Note_Classes_Prepend_Input = {
  lessonIds?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "credit_note_classes" */
export enum Credit_Note_Classes_Select_Column {
  /** column name */
  ClassId = 'classId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  Id = 'id',
  /** column name */
  LessonIds = 'lessonIds',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  Status = 'status',
  /** column name */
  TermId = 'termId',
  /** column name */
  TermName = 'termName',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "credit_note_classes" */
export type Credit_Note_Classes_Set_Input = {
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  endDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonIds?: Maybe<Scalars['jsonb']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  termId?: Maybe<Scalars['uuid']>;
  termName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "credit_note_classes" */
export enum Credit_Note_Classes_Update_Column {
  /** column name */
  ClassId = 'classId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  Id = 'id',
  /** column name */
  LessonIds = 'lessonIds',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  Status = 'status',
  /** column name */
  TermId = 'termId',
  /** column name */
  TermName = 'termName',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** columns and relationships of "credit_note_fees" */
export type Credit_Note_Fees = {
  __typename?: 'credit_note_fees';
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  credit_notes: Array<Credit_Notes>;
  /** An aggregated array relationship */
  credit_notes_aggregate: Credit_Notes_Aggregate;
  id: Scalars['uuid'];
  numberOfLesson?: Maybe<Scalars['numeric']>;
  overpaidAmount?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  receipt: Receipts;
  receiptId: Scalars['uuid'];
  status: Scalars['String'];
  unitPriceOfClass?: Maybe<Scalars['numeric']>;
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  userByCreatedby?: Maybe<Users>;
};


/** columns and relationships of "credit_note_fees" */
export type Credit_Note_FeesCredit_NotesArgs = {
  distinct_on?: Maybe<Array<Credit_Notes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Notes_Order_By>>;
  where?: Maybe<Credit_Notes_Bool_Exp>;
};


/** columns and relationships of "credit_note_fees" */
export type Credit_Note_FeesCredit_Notes_AggregateArgs = {
  distinct_on?: Maybe<Array<Credit_Notes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Notes_Order_By>>;
  where?: Maybe<Credit_Notes_Bool_Exp>;
};

/** aggregated selection of "credit_note_fees" */
export type Credit_Note_Fees_Aggregate = {
  __typename?: 'credit_note_fees_aggregate';
  aggregate?: Maybe<Credit_Note_Fees_Aggregate_Fields>;
  nodes: Array<Credit_Note_Fees>;
};

/** aggregate fields of "credit_note_fees" */
export type Credit_Note_Fees_Aggregate_Fields = {
  __typename?: 'credit_note_fees_aggregate_fields';
  avg?: Maybe<Credit_Note_Fees_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Credit_Note_Fees_Max_Fields>;
  min?: Maybe<Credit_Note_Fees_Min_Fields>;
  stddev?: Maybe<Credit_Note_Fees_Stddev_Fields>;
  stddev_pop?: Maybe<Credit_Note_Fees_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Credit_Note_Fees_Stddev_Samp_Fields>;
  sum?: Maybe<Credit_Note_Fees_Sum_Fields>;
  var_pop?: Maybe<Credit_Note_Fees_Var_Pop_Fields>;
  var_samp?: Maybe<Credit_Note_Fees_Var_Samp_Fields>;
  variance?: Maybe<Credit_Note_Fees_Variance_Fields>;
};


/** aggregate fields of "credit_note_fees" */
export type Credit_Note_Fees_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Credit_Note_Fees_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "credit_note_fees" */
export type Credit_Note_Fees_Aggregate_Order_By = {
  avg?: Maybe<Credit_Note_Fees_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Credit_Note_Fees_Max_Order_By>;
  min?: Maybe<Credit_Note_Fees_Min_Order_By>;
  stddev?: Maybe<Credit_Note_Fees_Stddev_Order_By>;
  stddev_pop?: Maybe<Credit_Note_Fees_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Credit_Note_Fees_Stddev_Samp_Order_By>;
  sum?: Maybe<Credit_Note_Fees_Sum_Order_By>;
  var_pop?: Maybe<Credit_Note_Fees_Var_Pop_Order_By>;
  var_samp?: Maybe<Credit_Note_Fees_Var_Samp_Order_By>;
  variance?: Maybe<Credit_Note_Fees_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "credit_note_fees" */
export type Credit_Note_Fees_Arr_Rel_Insert_Input = {
  data: Array<Credit_Note_Fees_Insert_Input>;
  on_conflict?: Maybe<Credit_Note_Fees_On_Conflict>;
};

/** aggregate avg on columns */
export type Credit_Note_Fees_Avg_Fields = {
  __typename?: 'credit_note_fees_avg_fields';
  numberOfLesson?: Maybe<Scalars['Float']>;
  overpaidAmount?: Maybe<Scalars['Float']>;
  unitPriceOfClass?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "credit_note_fees" */
export type Credit_Note_Fees_Avg_Order_By = {
  numberOfLesson?: Maybe<Order_By>;
  overpaidAmount?: Maybe<Order_By>;
  unitPriceOfClass?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "credit_note_fees". All fields are combined with a logical 'AND'. */
export type Credit_Note_Fees_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Credit_Note_Fees_Bool_Exp>>>;
  _not?: Maybe<Credit_Note_Fees_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Credit_Note_Fees_Bool_Exp>>>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  credit_notes?: Maybe<Credit_Notes_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  numberOfLesson?: Maybe<Numeric_Comparison_Exp>;
  overpaidAmount?: Maybe<Numeric_Comparison_Exp>;
  receipt?: Maybe<Receipts_Bool_Exp>;
  receiptId?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  unitPriceOfClass?: Maybe<Numeric_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  userByCreatedby?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "credit_note_fees" */
export enum Credit_Note_Fees_Constraint {
  /** unique or primary key constraint */
  CreditNoteFeesPkey = 'credit_note_fees_pkey'
}

/** input type for incrementing integer column in table "credit_note_fees" */
export type Credit_Note_Fees_Inc_Input = {
  numberOfLesson?: Maybe<Scalars['numeric']>;
  overpaidAmount?: Maybe<Scalars['numeric']>;
  unitPriceOfClass?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "credit_note_fees" */
export type Credit_Note_Fees_Insert_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  credit_notes?: Maybe<Credit_Notes_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  numberOfLesson?: Maybe<Scalars['numeric']>;
  overpaidAmount?: Maybe<Scalars['numeric']>;
  receipt?: Maybe<Receipts_Obj_Rel_Insert_Input>;
  receiptId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  unitPriceOfClass?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  userByCreatedby?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Credit_Note_Fees_Max_Fields = {
  __typename?: 'credit_note_fees_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  numberOfLesson?: Maybe<Scalars['numeric']>;
  overpaidAmount?: Maybe<Scalars['numeric']>;
  receiptId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  unitPriceOfClass?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "credit_note_fees" */
export type Credit_Note_Fees_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  numberOfLesson?: Maybe<Order_By>;
  overpaidAmount?: Maybe<Order_By>;
  receiptId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  unitPriceOfClass?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Credit_Note_Fees_Min_Fields = {
  __typename?: 'credit_note_fees_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  numberOfLesson?: Maybe<Scalars['numeric']>;
  overpaidAmount?: Maybe<Scalars['numeric']>;
  receiptId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  unitPriceOfClass?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "credit_note_fees" */
export type Credit_Note_Fees_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  numberOfLesson?: Maybe<Order_By>;
  overpaidAmount?: Maybe<Order_By>;
  receiptId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  unitPriceOfClass?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "credit_note_fees" */
export type Credit_Note_Fees_Mutation_Response = {
  __typename?: 'credit_note_fees_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Credit_Note_Fees>;
};

/** input type for inserting object relation for remote table "credit_note_fees" */
export type Credit_Note_Fees_Obj_Rel_Insert_Input = {
  data: Credit_Note_Fees_Insert_Input;
  on_conflict?: Maybe<Credit_Note_Fees_On_Conflict>;
};

/** on conflict condition type for table "credit_note_fees" */
export type Credit_Note_Fees_On_Conflict = {
  constraint: Credit_Note_Fees_Constraint;
  update_columns: Array<Credit_Note_Fees_Update_Column>;
  where?: Maybe<Credit_Note_Fees_Bool_Exp>;
};

/** ordering options when selecting data from "credit_note_fees" */
export type Credit_Note_Fees_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  credit_notes_aggregate?: Maybe<Credit_Notes_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  numberOfLesson?: Maybe<Order_By>;
  overpaidAmount?: Maybe<Order_By>;
  receipt?: Maybe<Receipts_Order_By>;
  receiptId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  unitPriceOfClass?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  userByCreatedby?: Maybe<Users_Order_By>;
};

/** primary key columns input for table: "credit_note_fees" */
export type Credit_Note_Fees_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "credit_note_fees" */
export enum Credit_Note_Fees_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  NumberOfLesson = 'numberOfLesson',
  /** column name */
  OverpaidAmount = 'overpaidAmount',
  /** column name */
  ReceiptId = 'receiptId',
  /** column name */
  Status = 'status',
  /** column name */
  UnitPriceOfClass = 'unitPriceOfClass',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "credit_note_fees" */
export type Credit_Note_Fees_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  numberOfLesson?: Maybe<Scalars['numeric']>;
  overpaidAmount?: Maybe<Scalars['numeric']>;
  receiptId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  unitPriceOfClass?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Credit_Note_Fees_Stddev_Fields = {
  __typename?: 'credit_note_fees_stddev_fields';
  numberOfLesson?: Maybe<Scalars['Float']>;
  overpaidAmount?: Maybe<Scalars['Float']>;
  unitPriceOfClass?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "credit_note_fees" */
export type Credit_Note_Fees_Stddev_Order_By = {
  numberOfLesson?: Maybe<Order_By>;
  overpaidAmount?: Maybe<Order_By>;
  unitPriceOfClass?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Credit_Note_Fees_Stddev_Pop_Fields = {
  __typename?: 'credit_note_fees_stddev_pop_fields';
  numberOfLesson?: Maybe<Scalars['Float']>;
  overpaidAmount?: Maybe<Scalars['Float']>;
  unitPriceOfClass?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "credit_note_fees" */
export type Credit_Note_Fees_Stddev_Pop_Order_By = {
  numberOfLesson?: Maybe<Order_By>;
  overpaidAmount?: Maybe<Order_By>;
  unitPriceOfClass?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Credit_Note_Fees_Stddev_Samp_Fields = {
  __typename?: 'credit_note_fees_stddev_samp_fields';
  numberOfLesson?: Maybe<Scalars['Float']>;
  overpaidAmount?: Maybe<Scalars['Float']>;
  unitPriceOfClass?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "credit_note_fees" */
export type Credit_Note_Fees_Stddev_Samp_Order_By = {
  numberOfLesson?: Maybe<Order_By>;
  overpaidAmount?: Maybe<Order_By>;
  unitPriceOfClass?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Credit_Note_Fees_Sum_Fields = {
  __typename?: 'credit_note_fees_sum_fields';
  numberOfLesson?: Maybe<Scalars['numeric']>;
  overpaidAmount?: Maybe<Scalars['numeric']>;
  unitPriceOfClass?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "credit_note_fees" */
export type Credit_Note_Fees_Sum_Order_By = {
  numberOfLesson?: Maybe<Order_By>;
  overpaidAmount?: Maybe<Order_By>;
  unitPriceOfClass?: Maybe<Order_By>;
};

/** update columns of table "credit_note_fees" */
export enum Credit_Note_Fees_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  NumberOfLesson = 'numberOfLesson',
  /** column name */
  OverpaidAmount = 'overpaidAmount',
  /** column name */
  ReceiptId = 'receiptId',
  /** column name */
  Status = 'status',
  /** column name */
  UnitPriceOfClass = 'unitPriceOfClass',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** aggregate var_pop on columns */
export type Credit_Note_Fees_Var_Pop_Fields = {
  __typename?: 'credit_note_fees_var_pop_fields';
  numberOfLesson?: Maybe<Scalars['Float']>;
  overpaidAmount?: Maybe<Scalars['Float']>;
  unitPriceOfClass?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "credit_note_fees" */
export type Credit_Note_Fees_Var_Pop_Order_By = {
  numberOfLesson?: Maybe<Order_By>;
  overpaidAmount?: Maybe<Order_By>;
  unitPriceOfClass?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Credit_Note_Fees_Var_Samp_Fields = {
  __typename?: 'credit_note_fees_var_samp_fields';
  numberOfLesson?: Maybe<Scalars['Float']>;
  overpaidAmount?: Maybe<Scalars['Float']>;
  unitPriceOfClass?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "credit_note_fees" */
export type Credit_Note_Fees_Var_Samp_Order_By = {
  numberOfLesson?: Maybe<Order_By>;
  overpaidAmount?: Maybe<Order_By>;
  unitPriceOfClass?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Credit_Note_Fees_Variance_Fields = {
  __typename?: 'credit_note_fees_variance_fields';
  numberOfLesson?: Maybe<Scalars['Float']>;
  overpaidAmount?: Maybe<Scalars['Float']>;
  unitPriceOfClass?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "credit_note_fees" */
export type Credit_Note_Fees_Variance_Order_By = {
  numberOfLesson?: Maybe<Order_By>;
  overpaidAmount?: Maybe<Order_By>;
  unitPriceOfClass?: Maybe<Order_By>;
};

export type Credit_Note_Filter_Args = {
  month?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "credit_note_logs" */
export type Credit_Note_Logs = {
  __typename?: 'credit_note_logs';
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  creditNote: Credit_Notes;
  creditNoteId: Scalars['uuid'];
  id: Scalars['uuid'];
  key?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
  valueAfter?: Maybe<Scalars['jsonb']>;
  valueBefore?: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "credit_note_logs" */
export type Credit_Note_LogsValueAfterArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "credit_note_logs" */
export type Credit_Note_LogsValueBeforeArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "credit_note_logs" */
export type Credit_Note_Logs_Aggregate = {
  __typename?: 'credit_note_logs_aggregate';
  aggregate?: Maybe<Credit_Note_Logs_Aggregate_Fields>;
  nodes: Array<Credit_Note_Logs>;
};

/** aggregate fields of "credit_note_logs" */
export type Credit_Note_Logs_Aggregate_Fields = {
  __typename?: 'credit_note_logs_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Credit_Note_Logs_Max_Fields>;
  min?: Maybe<Credit_Note_Logs_Min_Fields>;
};


/** aggregate fields of "credit_note_logs" */
export type Credit_Note_Logs_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Credit_Note_Logs_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "credit_note_logs" */
export type Credit_Note_Logs_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Credit_Note_Logs_Max_Order_By>;
  min?: Maybe<Credit_Note_Logs_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Credit_Note_Logs_Append_Input = {
  valueAfter?: Maybe<Scalars['jsonb']>;
  valueBefore?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "credit_note_logs" */
export type Credit_Note_Logs_Arr_Rel_Insert_Input = {
  data: Array<Credit_Note_Logs_Insert_Input>;
  on_conflict?: Maybe<Credit_Note_Logs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "credit_note_logs". All fields are combined with a logical 'AND'. */
export type Credit_Note_Logs_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Credit_Note_Logs_Bool_Exp>>>;
  _not?: Maybe<Credit_Note_Logs_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Credit_Note_Logs_Bool_Exp>>>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  creditNote?: Maybe<Credit_Notes_Bool_Exp>;
  creditNoteId?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  key?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  type?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  valueAfter?: Maybe<Jsonb_Comparison_Exp>;
  valueBefore?: Maybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "credit_note_logs" */
export enum Credit_Note_Logs_Constraint {
  /** unique or primary key constraint */
  CreditNoteLogsPkey = 'credit_note_logs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Credit_Note_Logs_Delete_At_Path_Input = {
  valueAfter?: Maybe<Array<Maybe<Scalars['String']>>>;
  valueBefore?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Credit_Note_Logs_Delete_Elem_Input = {
  valueAfter?: Maybe<Scalars['Int']>;
  valueBefore?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Credit_Note_Logs_Delete_Key_Input = {
  valueAfter?: Maybe<Scalars['String']>;
  valueBefore?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "credit_note_logs" */
export type Credit_Note_Logs_Insert_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  creditNote?: Maybe<Credit_Notes_Obj_Rel_Insert_Input>;
  creditNoteId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  valueAfter?: Maybe<Scalars['jsonb']>;
  valueBefore?: Maybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type Credit_Note_Logs_Max_Fields = {
  __typename?: 'credit_note_logs_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  creditNoteId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "credit_note_logs" */
export type Credit_Note_Logs_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  creditNoteId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  key?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Credit_Note_Logs_Min_Fields = {
  __typename?: 'credit_note_logs_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  creditNoteId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "credit_note_logs" */
export type Credit_Note_Logs_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  creditNoteId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  key?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "credit_note_logs" */
export type Credit_Note_Logs_Mutation_Response = {
  __typename?: 'credit_note_logs_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Credit_Note_Logs>;
};

/** input type for inserting object relation for remote table "credit_note_logs" */
export type Credit_Note_Logs_Obj_Rel_Insert_Input = {
  data: Credit_Note_Logs_Insert_Input;
  on_conflict?: Maybe<Credit_Note_Logs_On_Conflict>;
};

/** on conflict condition type for table "credit_note_logs" */
export type Credit_Note_Logs_On_Conflict = {
  constraint: Credit_Note_Logs_Constraint;
  update_columns: Array<Credit_Note_Logs_Update_Column>;
  where?: Maybe<Credit_Note_Logs_Bool_Exp>;
};

/** ordering options when selecting data from "credit_note_logs" */
export type Credit_Note_Logs_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  creditNote?: Maybe<Credit_Notes_Order_By>;
  creditNoteId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  key?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  valueAfter?: Maybe<Order_By>;
  valueBefore?: Maybe<Order_By>;
};

/** primary key columns input for table: "credit_note_logs" */
export type Credit_Note_Logs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Credit_Note_Logs_Prepend_Input = {
  valueAfter?: Maybe<Scalars['jsonb']>;
  valueBefore?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "credit_note_logs" */
export enum Credit_Note_Logs_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CreditNoteId = 'creditNoteId',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  ValueAfter = 'valueAfter',
  /** column name */
  ValueBefore = 'valueBefore'
}

/** input type for updating data in table "credit_note_logs" */
export type Credit_Note_Logs_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  creditNoteId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  valueAfter?: Maybe<Scalars['jsonb']>;
  valueBefore?: Maybe<Scalars['jsonb']>;
};

/** update columns of table "credit_note_logs" */
export enum Credit_Note_Logs_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CreditNoteId = 'creditNoteId',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  ValueAfter = 'valueAfter',
  /** column name */
  ValueBefore = 'valueBefore'
}

/** columns and relationships of "credit_notes" */
export type Credit_Notes = {
  __typename?: 'credit_notes';
  approvedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  approver?: Maybe<Users>;
  approverId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  creditNoteClass?: Maybe<Credit_Note_Classes>;
  creditNoteClassId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  creditNoteFee?: Maybe<Credit_Note_Fees>;
  creditNoteFeeId?: Maybe<Scalars['uuid']>;
  creditNoteStatus: Scalars['String'];
  /** An array relationship */
  credit_note_logs: Array<Credit_Note_Logs>;
  /** An aggregated array relationship */
  credit_note_logs_aggregate: Credit_Note_Logs_Aggregate;
  id: Scalars['uuid'];
  link?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  /** An object relationship */
  student?: Maybe<Users>;
  studentId?: Maybe<Scalars['uuid']>;
  summary?: Maybe<Scalars['jsonb']>;
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  userByCreatedby?: Maybe<Users>;
};


/** columns and relationships of "credit_notes" */
export type Credit_NotesCredit_Note_LogsArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Logs_Order_By>>;
  where?: Maybe<Credit_Note_Logs_Bool_Exp>;
};


/** columns and relationships of "credit_notes" */
export type Credit_NotesCredit_Note_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Logs_Order_By>>;
  where?: Maybe<Credit_Note_Logs_Bool_Exp>;
};


/** columns and relationships of "credit_notes" */
export type Credit_NotesSummaryArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "credit_notes" */
export type Credit_Notes_Aggregate = {
  __typename?: 'credit_notes_aggregate';
  aggregate?: Maybe<Credit_Notes_Aggregate_Fields>;
  nodes: Array<Credit_Notes>;
};

/** aggregate fields of "credit_notes" */
export type Credit_Notes_Aggregate_Fields = {
  __typename?: 'credit_notes_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Credit_Notes_Max_Fields>;
  min?: Maybe<Credit_Notes_Min_Fields>;
};


/** aggregate fields of "credit_notes" */
export type Credit_Notes_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Credit_Notes_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "credit_notes" */
export type Credit_Notes_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Credit_Notes_Max_Order_By>;
  min?: Maybe<Credit_Notes_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Credit_Notes_Append_Input = {
  summary?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "credit_notes" */
export type Credit_Notes_Arr_Rel_Insert_Input = {
  data: Array<Credit_Notes_Insert_Input>;
  on_conflict?: Maybe<Credit_Notes_On_Conflict>;
};

/** Boolean expression to filter rows from the table "credit_notes". All fields are combined with a logical 'AND'. */
export type Credit_Notes_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Credit_Notes_Bool_Exp>>>;
  _not?: Maybe<Credit_Notes_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Credit_Notes_Bool_Exp>>>;
  approvedAt?: Maybe<Timestamptz_Comparison_Exp>;
  approver?: Maybe<Users_Bool_Exp>;
  approverId?: Maybe<Uuid_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  creditNoteClass?: Maybe<Credit_Note_Classes_Bool_Exp>;
  creditNoteClassId?: Maybe<Uuid_Comparison_Exp>;
  creditNoteFee?: Maybe<Credit_Note_Fees_Bool_Exp>;
  creditNoteFeeId?: Maybe<Uuid_Comparison_Exp>;
  creditNoteStatus?: Maybe<String_Comparison_Exp>;
  credit_note_logs?: Maybe<Credit_Note_Logs_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  link?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  reason?: Maybe<String_Comparison_Exp>;
  remarks?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  student?: Maybe<Users_Bool_Exp>;
  studentId?: Maybe<Uuid_Comparison_Exp>;
  summary?: Maybe<Jsonb_Comparison_Exp>;
  type?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  userByCreatedby?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "credit_notes" */
export enum Credit_Notes_Constraint {
  /** unique or primary key constraint */
  CreditNotesNameKey = 'credit_notes_name_key',
  /** unique or primary key constraint */
  CreditNotesPkey = 'credit_notes_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Credit_Notes_Delete_At_Path_Input = {
  summary?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Credit_Notes_Delete_Elem_Input = {
  summary?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Credit_Notes_Delete_Key_Input = {
  summary?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "credit_notes" */
export type Credit_Notes_Insert_Input = {
  approvedAt?: Maybe<Scalars['timestamptz']>;
  approver?: Maybe<Users_Obj_Rel_Insert_Input>;
  approverId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  creditNoteClass?: Maybe<Credit_Note_Classes_Obj_Rel_Insert_Input>;
  creditNoteClassId?: Maybe<Scalars['uuid']>;
  creditNoteFee?: Maybe<Credit_Note_Fees_Obj_Rel_Insert_Input>;
  creditNoteFeeId?: Maybe<Scalars['uuid']>;
  creditNoteStatus?: Maybe<Scalars['String']>;
  credit_note_logs?: Maybe<Credit_Note_Logs_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  student?: Maybe<Users_Obj_Rel_Insert_Input>;
  studentId?: Maybe<Scalars['uuid']>;
  summary?: Maybe<Scalars['jsonb']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  userByCreatedby?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Credit_Notes_Max_Fields = {
  __typename?: 'credit_notes_max_fields';
  approvedAt?: Maybe<Scalars['timestamptz']>;
  approverId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  creditNoteClassId?: Maybe<Scalars['uuid']>;
  creditNoteFeeId?: Maybe<Scalars['uuid']>;
  creditNoteStatus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "credit_notes" */
export type Credit_Notes_Max_Order_By = {
  approvedAt?: Maybe<Order_By>;
  approverId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  creditNoteClassId?: Maybe<Order_By>;
  creditNoteFeeId?: Maybe<Order_By>;
  creditNoteStatus?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  link?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  reason?: Maybe<Order_By>;
  remarks?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Credit_Notes_Min_Fields = {
  __typename?: 'credit_notes_min_fields';
  approvedAt?: Maybe<Scalars['timestamptz']>;
  approverId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  creditNoteClassId?: Maybe<Scalars['uuid']>;
  creditNoteFeeId?: Maybe<Scalars['uuid']>;
  creditNoteStatus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "credit_notes" */
export type Credit_Notes_Min_Order_By = {
  approvedAt?: Maybe<Order_By>;
  approverId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  creditNoteClassId?: Maybe<Order_By>;
  creditNoteFeeId?: Maybe<Order_By>;
  creditNoteStatus?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  link?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  reason?: Maybe<Order_By>;
  remarks?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "credit_notes" */
export type Credit_Notes_Mutation_Response = {
  __typename?: 'credit_notes_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Credit_Notes>;
};

/** input type for inserting object relation for remote table "credit_notes" */
export type Credit_Notes_Obj_Rel_Insert_Input = {
  data: Credit_Notes_Insert_Input;
  on_conflict?: Maybe<Credit_Notes_On_Conflict>;
};

/** on conflict condition type for table "credit_notes" */
export type Credit_Notes_On_Conflict = {
  constraint: Credit_Notes_Constraint;
  update_columns: Array<Credit_Notes_Update_Column>;
  where?: Maybe<Credit_Notes_Bool_Exp>;
};

/** ordering options when selecting data from "credit_notes" */
export type Credit_Notes_Order_By = {
  approvedAt?: Maybe<Order_By>;
  approver?: Maybe<Users_Order_By>;
  approverId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  creditNoteClass?: Maybe<Credit_Note_Classes_Order_By>;
  creditNoteClassId?: Maybe<Order_By>;
  creditNoteFee?: Maybe<Credit_Note_Fees_Order_By>;
  creditNoteFeeId?: Maybe<Order_By>;
  creditNoteStatus?: Maybe<Order_By>;
  credit_note_logs_aggregate?: Maybe<Credit_Note_Logs_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  link?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  reason?: Maybe<Order_By>;
  remarks?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  student?: Maybe<Users_Order_By>;
  studentId?: Maybe<Order_By>;
  summary?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  userByCreatedby?: Maybe<Users_Order_By>;
};

/** primary key columns input for table: "credit_notes" */
export type Credit_Notes_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Credit_Notes_Prepend_Input = {
  summary?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "credit_notes" */
export enum Credit_Notes_Select_Column {
  /** column name */
  ApprovedAt = 'approvedAt',
  /** column name */
  ApproverId = 'approverId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CreditNoteClassId = 'creditNoteClassId',
  /** column name */
  CreditNoteFeeId = 'creditNoteFeeId',
  /** column name */
  CreditNoteStatus = 'creditNoteStatus',
  /** column name */
  Id = 'id',
  /** column name */
  Link = 'link',
  /** column name */
  Name = 'name',
  /** column name */
  Reason = 'reason',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  Summary = 'summary',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "credit_notes" */
export type Credit_Notes_Set_Input = {
  approvedAt?: Maybe<Scalars['timestamptz']>;
  approverId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  creditNoteClassId?: Maybe<Scalars['uuid']>;
  creditNoteFeeId?: Maybe<Scalars['uuid']>;
  creditNoteStatus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  summary?: Maybe<Scalars['jsonb']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "credit_notes" */
export enum Credit_Notes_Update_Column {
  /** column name */
  ApprovedAt = 'approvedAt',
  /** column name */
  ApproverId = 'approverId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CreditNoteClassId = 'creditNoteClassId',
  /** column name */
  CreditNoteFeeId = 'creditNoteFeeId',
  /** column name */
  CreditNoteStatus = 'creditNoteStatus',
  /** column name */
  Id = 'id',
  /** column name */
  Link = 'link',
  /** column name */
  Name = 'name',
  /** column name */
  Reason = 'reason',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  Summary = 'summary',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** columns and relationships of "curriculums" */
export type Curriculums = {
  __typename?: 'curriculums';
  abbreviation?: Maybe<Scalars['String']>;
  /** An array relationship */
  academic_calendars: Array<Academic_Calendars>;
  /** An aggregated array relationship */
  academic_calendars_aggregate: Academic_Calendars_Aggregate;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  curriculums_levels: Array<Curriculums_Levels>;
  /** An aggregated array relationship */
  curriculums_levels_aggregate: Curriculums_Levels_Aggregate;
  id: Scalars['uuid'];
  name: Scalars['String'];
  nameOfReport?: Maybe<Scalars['String']>;
  /** An array relationship */
  regular_programme_pricings: Array<Regular_Programme_Pricings>;
  /** An aggregated array relationship */
  regular_programme_pricings_aggregate: Regular_Programme_Pricings_Aggregate;
  status: Scalars['String'];
  /** An array relationship */
  student_profiles: Array<Student_Profiles>;
  /** An aggregated array relationship */
  student_profiles_aggregate: Student_Profiles_Aggregate;
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  userByCreatedby?: Maybe<Users>;
};


/** columns and relationships of "curriculums" */
export type CurriculumsAcademic_CalendarsArgs = {
  distinct_on?: Maybe<Array<Academic_Calendars_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Academic_Calendars_Order_By>>;
  where?: Maybe<Academic_Calendars_Bool_Exp>;
};


/** columns and relationships of "curriculums" */
export type CurriculumsAcademic_Calendars_AggregateArgs = {
  distinct_on?: Maybe<Array<Academic_Calendars_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Academic_Calendars_Order_By>>;
  where?: Maybe<Academic_Calendars_Bool_Exp>;
};


/** columns and relationships of "curriculums" */
export type CurriculumsCurriculums_LevelsArgs = {
  distinct_on?: Maybe<Array<Curriculums_Levels_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Curriculums_Levels_Order_By>>;
  where?: Maybe<Curriculums_Levels_Bool_Exp>;
};


/** columns and relationships of "curriculums" */
export type CurriculumsCurriculums_Levels_AggregateArgs = {
  distinct_on?: Maybe<Array<Curriculums_Levels_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Curriculums_Levels_Order_By>>;
  where?: Maybe<Curriculums_Levels_Bool_Exp>;
};


/** columns and relationships of "curriculums" */
export type CurriculumsRegular_Programme_PricingsArgs = {
  distinct_on?: Maybe<Array<Regular_Programme_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Regular_Programme_Pricings_Order_By>>;
  where?: Maybe<Regular_Programme_Pricings_Bool_Exp>;
};


/** columns and relationships of "curriculums" */
export type CurriculumsRegular_Programme_Pricings_AggregateArgs = {
  distinct_on?: Maybe<Array<Regular_Programme_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Regular_Programme_Pricings_Order_By>>;
  where?: Maybe<Regular_Programme_Pricings_Bool_Exp>;
};


/** columns and relationships of "curriculums" */
export type CurriculumsStudent_ProfilesArgs = {
  distinct_on?: Maybe<Array<Student_Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Student_Profiles_Order_By>>;
  where?: Maybe<Student_Profiles_Bool_Exp>;
};


/** columns and relationships of "curriculums" */
export type CurriculumsStudent_Profiles_AggregateArgs = {
  distinct_on?: Maybe<Array<Student_Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Student_Profiles_Order_By>>;
  where?: Maybe<Student_Profiles_Bool_Exp>;
};

/** aggregated selection of "curriculums" */
export type Curriculums_Aggregate = {
  __typename?: 'curriculums_aggregate';
  aggregate?: Maybe<Curriculums_Aggregate_Fields>;
  nodes: Array<Curriculums>;
};

/** aggregate fields of "curriculums" */
export type Curriculums_Aggregate_Fields = {
  __typename?: 'curriculums_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Curriculums_Max_Fields>;
  min?: Maybe<Curriculums_Min_Fields>;
};


/** aggregate fields of "curriculums" */
export type Curriculums_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Curriculums_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "curriculums" */
export type Curriculums_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Curriculums_Max_Order_By>;
  min?: Maybe<Curriculums_Min_Order_By>;
};

/** input type for inserting array relation for remote table "curriculums" */
export type Curriculums_Arr_Rel_Insert_Input = {
  data: Array<Curriculums_Insert_Input>;
  on_conflict?: Maybe<Curriculums_On_Conflict>;
};

/** Boolean expression to filter rows from the table "curriculums". All fields are combined with a logical 'AND'. */
export type Curriculums_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Curriculums_Bool_Exp>>>;
  _not?: Maybe<Curriculums_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Curriculums_Bool_Exp>>>;
  abbreviation?: Maybe<String_Comparison_Exp>;
  academic_calendars?: Maybe<Academic_Calendars_Bool_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  curriculums_levels?: Maybe<Curriculums_Levels_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  nameOfReport?: Maybe<String_Comparison_Exp>;
  regular_programme_pricings?: Maybe<Regular_Programme_Pricings_Bool_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  student_profiles?: Maybe<Student_Profiles_Bool_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  userByCreatedby?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "curriculums" */
export enum Curriculums_Constraint {
  /** unique or primary key constraint */
  CurriculumsPkey = 'curriculums_pkey'
}

/** input type for inserting data into table "curriculums" */
export type Curriculums_Insert_Input = {
  abbreviation?: Maybe<Scalars['String']>;
  academic_calendars?: Maybe<Academic_Calendars_Arr_Rel_Insert_Input>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculums_levels?: Maybe<Curriculums_Levels_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  nameOfReport?: Maybe<Scalars['String']>;
  regular_programme_pricings?: Maybe<Regular_Programme_Pricings_Arr_Rel_Insert_Input>;
  status?: Maybe<Scalars['String']>;
  student_profiles?: Maybe<Student_Profiles_Arr_Rel_Insert_Input>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  userByCreatedby?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** columns and relationships of "curriculums_levels" */
export type Curriculums_Levels = {
  __typename?: 'curriculums_levels';
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  curriculum: Curriculums;
  curriculumId: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  level: Levels;
  levelId: Scalars['uuid'];
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "curriculums_levels" */
export type Curriculums_Levels_Aggregate = {
  __typename?: 'curriculums_levels_aggregate';
  aggregate?: Maybe<Curriculums_Levels_Aggregate_Fields>;
  nodes: Array<Curriculums_Levels>;
};

/** aggregate fields of "curriculums_levels" */
export type Curriculums_Levels_Aggregate_Fields = {
  __typename?: 'curriculums_levels_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Curriculums_Levels_Max_Fields>;
  min?: Maybe<Curriculums_Levels_Min_Fields>;
};


/** aggregate fields of "curriculums_levels" */
export type Curriculums_Levels_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Curriculums_Levels_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "curriculums_levels" */
export type Curriculums_Levels_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Curriculums_Levels_Max_Order_By>;
  min?: Maybe<Curriculums_Levels_Min_Order_By>;
};

/** input type for inserting array relation for remote table "curriculums_levels" */
export type Curriculums_Levels_Arr_Rel_Insert_Input = {
  data: Array<Curriculums_Levels_Insert_Input>;
  on_conflict?: Maybe<Curriculums_Levels_On_Conflict>;
};

/** Boolean expression to filter rows from the table "curriculums_levels". All fields are combined with a logical 'AND'. */
export type Curriculums_Levels_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Curriculums_Levels_Bool_Exp>>>;
  _not?: Maybe<Curriculums_Levels_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Curriculums_Levels_Bool_Exp>>>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  curriculum?: Maybe<Curriculums_Bool_Exp>;
  curriculumId?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  level?: Maybe<Levels_Bool_Exp>;
  levelId?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "curriculums_levels" */
export enum Curriculums_Levels_Constraint {
  /** unique or primary key constraint */
  CurriculumsLevelsPkey = 'curriculums_levels_pkey'
}

/** input type for inserting data into table "curriculums_levels" */
export type Curriculums_Levels_Insert_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculum?: Maybe<Curriculums_Obj_Rel_Insert_Input>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  level?: Maybe<Levels_Obj_Rel_Insert_Input>;
  levelId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Curriculums_Levels_Max_Fields = {
  __typename?: 'curriculums_levels_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  levelId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "curriculums_levels" */
export type Curriculums_Levels_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  curriculumId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  levelId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Curriculums_Levels_Min_Fields = {
  __typename?: 'curriculums_levels_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  levelId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "curriculums_levels" */
export type Curriculums_Levels_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  curriculumId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  levelId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "curriculums_levels" */
export type Curriculums_Levels_Mutation_Response = {
  __typename?: 'curriculums_levels_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Curriculums_Levels>;
};

/** input type for inserting object relation for remote table "curriculums_levels" */
export type Curriculums_Levels_Obj_Rel_Insert_Input = {
  data: Curriculums_Levels_Insert_Input;
  on_conflict?: Maybe<Curriculums_Levels_On_Conflict>;
};

/** on conflict condition type for table "curriculums_levels" */
export type Curriculums_Levels_On_Conflict = {
  constraint: Curriculums_Levels_Constraint;
  update_columns: Array<Curriculums_Levels_Update_Column>;
  where?: Maybe<Curriculums_Levels_Bool_Exp>;
};

/** ordering options when selecting data from "curriculums_levels" */
export type Curriculums_Levels_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  curriculum?: Maybe<Curriculums_Order_By>;
  curriculumId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  level?: Maybe<Levels_Order_By>;
  levelId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "curriculums_levels" */
export type Curriculums_Levels_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "curriculums_levels" */
export enum Curriculums_Levels_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CurriculumId = 'curriculumId',
  /** column name */
  Id = 'id',
  /** column name */
  LevelId = 'levelId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "curriculums_levels" */
export type Curriculums_Levels_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  levelId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "curriculums_levels" */
export enum Curriculums_Levels_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CurriculumId = 'curriculumId',
  /** column name */
  Id = 'id',
  /** column name */
  LevelId = 'levelId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** aggregate max on columns */
export type Curriculums_Max_Fields = {
  __typename?: 'curriculums_max_fields';
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  nameOfReport?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "curriculums" */
export type Curriculums_Max_Order_By = {
  abbreviation?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  nameOfReport?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Curriculums_Min_Fields = {
  __typename?: 'curriculums_min_fields';
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  nameOfReport?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "curriculums" */
export type Curriculums_Min_Order_By = {
  abbreviation?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  nameOfReport?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "curriculums" */
export type Curriculums_Mutation_Response = {
  __typename?: 'curriculums_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Curriculums>;
};

/** input type for inserting object relation for remote table "curriculums" */
export type Curriculums_Obj_Rel_Insert_Input = {
  data: Curriculums_Insert_Input;
  on_conflict?: Maybe<Curriculums_On_Conflict>;
};

/** on conflict condition type for table "curriculums" */
export type Curriculums_On_Conflict = {
  constraint: Curriculums_Constraint;
  update_columns: Array<Curriculums_Update_Column>;
  where?: Maybe<Curriculums_Bool_Exp>;
};

/** ordering options when selecting data from "curriculums" */
export type Curriculums_Order_By = {
  abbreviation?: Maybe<Order_By>;
  academic_calendars_aggregate?: Maybe<Academic_Calendars_Aggregate_Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  curriculums_levels_aggregate?: Maybe<Curriculums_Levels_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  nameOfReport?: Maybe<Order_By>;
  regular_programme_pricings_aggregate?: Maybe<Regular_Programme_Pricings_Aggregate_Order_By>;
  status?: Maybe<Order_By>;
  student_profiles_aggregate?: Maybe<Student_Profiles_Aggregate_Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  userByCreatedby?: Maybe<Users_Order_By>;
};

/** primary key columns input for table: "curriculums" */
export type Curriculums_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "curriculums" */
export enum Curriculums_Select_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameOfReport = 'nameOfReport',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "curriculums" */
export type Curriculums_Set_Input = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  nameOfReport?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "curriculums" */
export enum Curriculums_Update_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameOfReport = 'nameOfReport',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** columns and relationships of "deposits" */
export type Deposits = {
  __typename?: 'deposits';
  amount: Scalars['numeric'];
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  depositStatus: Scalars['String'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An object relationship */
  receipt?: Maybe<Receipts>;
  receiptId?: Maybe<Scalars['uuid']>;
  status: Scalars['String'];
  /** An object relationship */
  student: Users;
  studentId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "deposits" */
export type Deposits_Aggregate = {
  __typename?: 'deposits_aggregate';
  aggregate?: Maybe<Deposits_Aggregate_Fields>;
  nodes: Array<Deposits>;
};

/** aggregate fields of "deposits" */
export type Deposits_Aggregate_Fields = {
  __typename?: 'deposits_aggregate_fields';
  avg?: Maybe<Deposits_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Deposits_Max_Fields>;
  min?: Maybe<Deposits_Min_Fields>;
  stddev?: Maybe<Deposits_Stddev_Fields>;
  stddev_pop?: Maybe<Deposits_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Deposits_Stddev_Samp_Fields>;
  sum?: Maybe<Deposits_Sum_Fields>;
  var_pop?: Maybe<Deposits_Var_Pop_Fields>;
  var_samp?: Maybe<Deposits_Var_Samp_Fields>;
  variance?: Maybe<Deposits_Variance_Fields>;
};


/** aggregate fields of "deposits" */
export type Deposits_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Deposits_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "deposits" */
export type Deposits_Aggregate_Order_By = {
  avg?: Maybe<Deposits_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Deposits_Max_Order_By>;
  min?: Maybe<Deposits_Min_Order_By>;
  stddev?: Maybe<Deposits_Stddev_Order_By>;
  stddev_pop?: Maybe<Deposits_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Deposits_Stddev_Samp_Order_By>;
  sum?: Maybe<Deposits_Sum_Order_By>;
  var_pop?: Maybe<Deposits_Var_Pop_Order_By>;
  var_samp?: Maybe<Deposits_Var_Samp_Order_By>;
  variance?: Maybe<Deposits_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "deposits" */
export type Deposits_Arr_Rel_Insert_Input = {
  data: Array<Deposits_Insert_Input>;
  on_conflict?: Maybe<Deposits_On_Conflict>;
};

/** aggregate avg on columns */
export type Deposits_Avg_Fields = {
  __typename?: 'deposits_avg_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "deposits" */
export type Deposits_Avg_Order_By = {
  amount?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "deposits". All fields are combined with a logical 'AND'. */
export type Deposits_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Deposits_Bool_Exp>>>;
  _not?: Maybe<Deposits_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Deposits_Bool_Exp>>>;
  amount?: Maybe<Numeric_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  depositStatus?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  receipt?: Maybe<Receipts_Bool_Exp>;
  receiptId?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  student?: Maybe<Users_Bool_Exp>;
  studentId?: Maybe<Uuid_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "deposits" */
export enum Deposits_Constraint {
  /** unique or primary key constraint */
  DepositsPkey = 'deposits_pkey'
}

/** input type for incrementing integer column in table "deposits" */
export type Deposits_Inc_Input = {
  amount?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "deposits" */
export type Deposits_Insert_Input = {
  amount?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  depositStatus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  receipt?: Maybe<Receipts_Obj_Rel_Insert_Input>;
  receiptId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  student?: Maybe<Users_Obj_Rel_Insert_Input>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Deposits_Max_Fields = {
  __typename?: 'deposits_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  depositStatus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  receiptId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "deposits" */
export type Deposits_Max_Order_By = {
  amount?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  depositStatus?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  receiptId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Deposits_Min_Fields = {
  __typename?: 'deposits_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  depositStatus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  receiptId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "deposits" */
export type Deposits_Min_Order_By = {
  amount?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  depositStatus?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  receiptId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "deposits" */
export type Deposits_Mutation_Response = {
  __typename?: 'deposits_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Deposits>;
};

/** input type for inserting object relation for remote table "deposits" */
export type Deposits_Obj_Rel_Insert_Input = {
  data: Deposits_Insert_Input;
  on_conflict?: Maybe<Deposits_On_Conflict>;
};

/** on conflict condition type for table "deposits" */
export type Deposits_On_Conflict = {
  constraint: Deposits_Constraint;
  update_columns: Array<Deposits_Update_Column>;
  where?: Maybe<Deposits_Bool_Exp>;
};

/** ordering options when selecting data from "deposits" */
export type Deposits_Order_By = {
  amount?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  depositStatus?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  receipt?: Maybe<Receipts_Order_By>;
  receiptId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  student?: Maybe<Users_Order_By>;
  studentId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "deposits" */
export type Deposits_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "deposits" */
export enum Deposits_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DepositStatus = 'depositStatus',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ReceiptId = 'receiptId',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "deposits" */
export type Deposits_Set_Input = {
  amount?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  depositStatus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  receiptId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Deposits_Stddev_Fields = {
  __typename?: 'deposits_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "deposits" */
export type Deposits_Stddev_Order_By = {
  amount?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Deposits_Stddev_Pop_Fields = {
  __typename?: 'deposits_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "deposits" */
export type Deposits_Stddev_Pop_Order_By = {
  amount?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Deposits_Stddev_Samp_Fields = {
  __typename?: 'deposits_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "deposits" */
export type Deposits_Stddev_Samp_Order_By = {
  amount?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Deposits_Sum_Fields = {
  __typename?: 'deposits_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "deposits" */
export type Deposits_Sum_Order_By = {
  amount?: Maybe<Order_By>;
};

/** update columns of table "deposits" */
export enum Deposits_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DepositStatus = 'depositStatus',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ReceiptId = 'receiptId',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** aggregate var_pop on columns */
export type Deposits_Var_Pop_Fields = {
  __typename?: 'deposits_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "deposits" */
export type Deposits_Var_Pop_Order_By = {
  amount?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Deposits_Var_Samp_Fields = {
  __typename?: 'deposits_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "deposits" */
export type Deposits_Var_Samp_Order_By = {
  amount?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Deposits_Variance_Fields = {
  __typename?: 'deposits_variance_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "deposits" */
export type Deposits_Variance_Order_By = {
  amount?: Maybe<Order_By>;
};

/** columns and relationships of "discount_bills" */
export type Discount_Bills = {
  __typename?: 'discount_bills';
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  discount: Discounts;
  discountId: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  paymentAdvice: Payment_Advices;
  paymentAdviceId: Scalars['uuid'];
  price?: Maybe<Scalars['numeric']>;
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "discount_bills" */
export type Discount_Bills_Aggregate = {
  __typename?: 'discount_bills_aggregate';
  aggregate?: Maybe<Discount_Bills_Aggregate_Fields>;
  nodes: Array<Discount_Bills>;
};

/** aggregate fields of "discount_bills" */
export type Discount_Bills_Aggregate_Fields = {
  __typename?: 'discount_bills_aggregate_fields';
  avg?: Maybe<Discount_Bills_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Discount_Bills_Max_Fields>;
  min?: Maybe<Discount_Bills_Min_Fields>;
  stddev?: Maybe<Discount_Bills_Stddev_Fields>;
  stddev_pop?: Maybe<Discount_Bills_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Discount_Bills_Stddev_Samp_Fields>;
  sum?: Maybe<Discount_Bills_Sum_Fields>;
  var_pop?: Maybe<Discount_Bills_Var_Pop_Fields>;
  var_samp?: Maybe<Discount_Bills_Var_Samp_Fields>;
  variance?: Maybe<Discount_Bills_Variance_Fields>;
};


/** aggregate fields of "discount_bills" */
export type Discount_Bills_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Discount_Bills_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "discount_bills" */
export type Discount_Bills_Aggregate_Order_By = {
  avg?: Maybe<Discount_Bills_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Discount_Bills_Max_Order_By>;
  min?: Maybe<Discount_Bills_Min_Order_By>;
  stddev?: Maybe<Discount_Bills_Stddev_Order_By>;
  stddev_pop?: Maybe<Discount_Bills_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Discount_Bills_Stddev_Samp_Order_By>;
  sum?: Maybe<Discount_Bills_Sum_Order_By>;
  var_pop?: Maybe<Discount_Bills_Var_Pop_Order_By>;
  var_samp?: Maybe<Discount_Bills_Var_Samp_Order_By>;
  variance?: Maybe<Discount_Bills_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "discount_bills" */
export type Discount_Bills_Arr_Rel_Insert_Input = {
  data: Array<Discount_Bills_Insert_Input>;
  on_conflict?: Maybe<Discount_Bills_On_Conflict>;
};

/** aggregate avg on columns */
export type Discount_Bills_Avg_Fields = {
  __typename?: 'discount_bills_avg_fields';
  price?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "discount_bills" */
export type Discount_Bills_Avg_Order_By = {
  price?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "discount_bills". All fields are combined with a logical 'AND'. */
export type Discount_Bills_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Discount_Bills_Bool_Exp>>>;
  _not?: Maybe<Discount_Bills_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Discount_Bills_Bool_Exp>>>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  discount?: Maybe<Discounts_Bool_Exp>;
  discountId?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  paymentAdvice?: Maybe<Payment_Advices_Bool_Exp>;
  paymentAdviceId?: Maybe<Uuid_Comparison_Exp>;
  price?: Maybe<Numeric_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "discount_bills" */
export enum Discount_Bills_Constraint {
  /** unique or primary key constraint */
  DiscountBillsDiscountIdPaymentAdviceIdKey = 'discount_bills_discountId_paymentAdviceId_key',
  /** unique or primary key constraint */
  DiscountBillsPkey = 'discount_bills_pkey'
}

/** input type for incrementing integer column in table "discount_bills" */
export type Discount_Bills_Inc_Input = {
  price?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "discount_bills" */
export type Discount_Bills_Insert_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  discount?: Maybe<Discounts_Obj_Rel_Insert_Input>;
  discountId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdvice?: Maybe<Payment_Advices_Obj_Rel_Insert_Input>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Discount_Bills_Max_Fields = {
  __typename?: 'discount_bills_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  discountId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "discount_bills" */
export type Discount_Bills_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  discountId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  price?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Discount_Bills_Min_Fields = {
  __typename?: 'discount_bills_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  discountId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "discount_bills" */
export type Discount_Bills_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  discountId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  price?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "discount_bills" */
export type Discount_Bills_Mutation_Response = {
  __typename?: 'discount_bills_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Discount_Bills>;
};

/** input type for inserting object relation for remote table "discount_bills" */
export type Discount_Bills_Obj_Rel_Insert_Input = {
  data: Discount_Bills_Insert_Input;
  on_conflict?: Maybe<Discount_Bills_On_Conflict>;
};

/** on conflict condition type for table "discount_bills" */
export type Discount_Bills_On_Conflict = {
  constraint: Discount_Bills_Constraint;
  update_columns: Array<Discount_Bills_Update_Column>;
  where?: Maybe<Discount_Bills_Bool_Exp>;
};

/** ordering options when selecting data from "discount_bills" */
export type Discount_Bills_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  discount?: Maybe<Discounts_Order_By>;
  discountId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  paymentAdvice?: Maybe<Payment_Advices_Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  price?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "discount_bills" */
export type Discount_Bills_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "discount_bills" */
export enum Discount_Bills_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DiscountId = 'discountId',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentAdviceId = 'paymentAdviceId',
  /** column name */
  Price = 'price',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "discount_bills" */
export type Discount_Bills_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  discountId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Discount_Bills_Stddev_Fields = {
  __typename?: 'discount_bills_stddev_fields';
  price?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "discount_bills" */
export type Discount_Bills_Stddev_Order_By = {
  price?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Discount_Bills_Stddev_Pop_Fields = {
  __typename?: 'discount_bills_stddev_pop_fields';
  price?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "discount_bills" */
export type Discount_Bills_Stddev_Pop_Order_By = {
  price?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Discount_Bills_Stddev_Samp_Fields = {
  __typename?: 'discount_bills_stddev_samp_fields';
  price?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "discount_bills" */
export type Discount_Bills_Stddev_Samp_Order_By = {
  price?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Discount_Bills_Sum_Fields = {
  __typename?: 'discount_bills_sum_fields';
  price?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "discount_bills" */
export type Discount_Bills_Sum_Order_By = {
  price?: Maybe<Order_By>;
};

/** update columns of table "discount_bills" */
export enum Discount_Bills_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DiscountId = 'discountId',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentAdviceId = 'paymentAdviceId',
  /** column name */
  Price = 'price',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** aggregate var_pop on columns */
export type Discount_Bills_Var_Pop_Fields = {
  __typename?: 'discount_bills_var_pop_fields';
  price?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "discount_bills" */
export type Discount_Bills_Var_Pop_Order_By = {
  price?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Discount_Bills_Var_Samp_Fields = {
  __typename?: 'discount_bills_var_samp_fields';
  price?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "discount_bills" */
export type Discount_Bills_Var_Samp_Order_By = {
  price?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Discount_Bills_Variance_Fields = {
  __typename?: 'discount_bills_variance_fields';
  price?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "discount_bills" */
export type Discount_Bills_Variance_Order_By = {
  price?: Maybe<Order_By>;
};

/** columns and relationships of "discount_students" */
export type Discount_Students = {
  __typename?: 'discount_students';
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  discount: Discounts;
  discountId: Scalars['uuid'];
  id: Scalars['uuid'];
  isUsed: Scalars['Boolean'];
  /** An object relationship */
  reference?: Maybe<Users>;
  referenceId?: Maybe<Scalars['uuid']>;
  relationships?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  /** An object relationship */
  student: Users;
  studentId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  userByCreatedby?: Maybe<Users>;
};

/** aggregated selection of "discount_students" */
export type Discount_Students_Aggregate = {
  __typename?: 'discount_students_aggregate';
  aggregate?: Maybe<Discount_Students_Aggregate_Fields>;
  nodes: Array<Discount_Students>;
};

/** aggregate fields of "discount_students" */
export type Discount_Students_Aggregate_Fields = {
  __typename?: 'discount_students_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Discount_Students_Max_Fields>;
  min?: Maybe<Discount_Students_Min_Fields>;
};


/** aggregate fields of "discount_students" */
export type Discount_Students_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Discount_Students_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "discount_students" */
export type Discount_Students_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Discount_Students_Max_Order_By>;
  min?: Maybe<Discount_Students_Min_Order_By>;
};

/** input type for inserting array relation for remote table "discount_students" */
export type Discount_Students_Arr_Rel_Insert_Input = {
  data: Array<Discount_Students_Insert_Input>;
  on_conflict?: Maybe<Discount_Students_On_Conflict>;
};

/** Boolean expression to filter rows from the table "discount_students". All fields are combined with a logical 'AND'. */
export type Discount_Students_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Discount_Students_Bool_Exp>>>;
  _not?: Maybe<Discount_Students_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Discount_Students_Bool_Exp>>>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  discount?: Maybe<Discounts_Bool_Exp>;
  discountId?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  isUsed?: Maybe<Boolean_Comparison_Exp>;
  reference?: Maybe<Users_Bool_Exp>;
  referenceId?: Maybe<Uuid_Comparison_Exp>;
  relationships?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  student?: Maybe<Users_Bool_Exp>;
  studentId?: Maybe<Uuid_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  userByCreatedby?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "discount_students" */
export enum Discount_Students_Constraint {
  /** unique or primary key constraint */
  DiscountStudentsPkey = 'discount_students_pkey'
}

/** input type for inserting data into table "discount_students" */
export type Discount_Students_Insert_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  discount?: Maybe<Discounts_Obj_Rel_Insert_Input>;
  discountId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  isUsed?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Users_Obj_Rel_Insert_Input>;
  referenceId?: Maybe<Scalars['uuid']>;
  relationships?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  student?: Maybe<Users_Obj_Rel_Insert_Input>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  userByCreatedby?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Discount_Students_Max_Fields = {
  __typename?: 'discount_students_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  discountId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  referenceId?: Maybe<Scalars['uuid']>;
  relationships?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "discount_students" */
export type Discount_Students_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  discountId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  referenceId?: Maybe<Order_By>;
  relationships?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Discount_Students_Min_Fields = {
  __typename?: 'discount_students_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  discountId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  referenceId?: Maybe<Scalars['uuid']>;
  relationships?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "discount_students" */
export type Discount_Students_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  discountId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  referenceId?: Maybe<Order_By>;
  relationships?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "discount_students" */
export type Discount_Students_Mutation_Response = {
  __typename?: 'discount_students_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Discount_Students>;
};

/** input type for inserting object relation for remote table "discount_students" */
export type Discount_Students_Obj_Rel_Insert_Input = {
  data: Discount_Students_Insert_Input;
  on_conflict?: Maybe<Discount_Students_On_Conflict>;
};

/** on conflict condition type for table "discount_students" */
export type Discount_Students_On_Conflict = {
  constraint: Discount_Students_Constraint;
  update_columns: Array<Discount_Students_Update_Column>;
  where?: Maybe<Discount_Students_Bool_Exp>;
};

/** ordering options when selecting data from "discount_students" */
export type Discount_Students_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  discount?: Maybe<Discounts_Order_By>;
  discountId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  isUsed?: Maybe<Order_By>;
  reference?: Maybe<Users_Order_By>;
  referenceId?: Maybe<Order_By>;
  relationships?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  student?: Maybe<Users_Order_By>;
  studentId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  userByCreatedby?: Maybe<Users_Order_By>;
};

/** primary key columns input for table: "discount_students" */
export type Discount_Students_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "discount_students" */
export enum Discount_Students_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DiscountId = 'discountId',
  /** column name */
  Id = 'id',
  /** column name */
  IsUsed = 'isUsed',
  /** column name */
  ReferenceId = 'referenceId',
  /** column name */
  Relationships = 'relationships',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "discount_students" */
export type Discount_Students_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  discountId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  isUsed?: Maybe<Scalars['Boolean']>;
  referenceId?: Maybe<Scalars['uuid']>;
  relationships?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "discount_students" */
export enum Discount_Students_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DiscountId = 'discountId',
  /** column name */
  Id = 'id',
  /** column name */
  IsUsed = 'isUsed',
  /** column name */
  ReferenceId = 'referenceId',
  /** column name */
  Relationships = 'relationships',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** columns and relationships of "discounts" */
export type Discounts = {
  __typename?: 'discounts';
  amount: Scalars['numeric'];
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  discount_bills: Array<Discount_Bills>;
  /** An aggregated array relationship */
  discount_bills_aggregate: Discount_Bills_Aggregate;
  /** An array relationship */
  discount_students: Array<Discount_Students>;
  /** An aggregated array relationship */
  discount_students_aggregate: Discount_Students_Aggregate;
  id: Scalars['uuid'];
  metadata?: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  unit?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "discounts" */
export type DiscountsDiscount_BillsArgs = {
  distinct_on?: Maybe<Array<Discount_Bills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discount_Bills_Order_By>>;
  where?: Maybe<Discount_Bills_Bool_Exp>;
};


/** columns and relationships of "discounts" */
export type DiscountsDiscount_Bills_AggregateArgs = {
  distinct_on?: Maybe<Array<Discount_Bills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discount_Bills_Order_By>>;
  where?: Maybe<Discount_Bills_Bool_Exp>;
};


/** columns and relationships of "discounts" */
export type DiscountsDiscount_StudentsArgs = {
  distinct_on?: Maybe<Array<Discount_Students_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discount_Students_Order_By>>;
  where?: Maybe<Discount_Students_Bool_Exp>;
};


/** columns and relationships of "discounts" */
export type DiscountsDiscount_Students_AggregateArgs = {
  distinct_on?: Maybe<Array<Discount_Students_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discount_Students_Order_By>>;
  where?: Maybe<Discount_Students_Bool_Exp>;
};


/** columns and relationships of "discounts" */
export type DiscountsMetadataArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "discounts" */
export type Discounts_Aggregate = {
  __typename?: 'discounts_aggregate';
  aggregate?: Maybe<Discounts_Aggregate_Fields>;
  nodes: Array<Discounts>;
};

/** aggregate fields of "discounts" */
export type Discounts_Aggregate_Fields = {
  __typename?: 'discounts_aggregate_fields';
  avg?: Maybe<Discounts_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Discounts_Max_Fields>;
  min?: Maybe<Discounts_Min_Fields>;
  stddev?: Maybe<Discounts_Stddev_Fields>;
  stddev_pop?: Maybe<Discounts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Discounts_Stddev_Samp_Fields>;
  sum?: Maybe<Discounts_Sum_Fields>;
  var_pop?: Maybe<Discounts_Var_Pop_Fields>;
  var_samp?: Maybe<Discounts_Var_Samp_Fields>;
  variance?: Maybe<Discounts_Variance_Fields>;
};


/** aggregate fields of "discounts" */
export type Discounts_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Discounts_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "discounts" */
export type Discounts_Aggregate_Order_By = {
  avg?: Maybe<Discounts_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Discounts_Max_Order_By>;
  min?: Maybe<Discounts_Min_Order_By>;
  stddev?: Maybe<Discounts_Stddev_Order_By>;
  stddev_pop?: Maybe<Discounts_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Discounts_Stddev_Samp_Order_By>;
  sum?: Maybe<Discounts_Sum_Order_By>;
  var_pop?: Maybe<Discounts_Var_Pop_Order_By>;
  var_samp?: Maybe<Discounts_Var_Samp_Order_By>;
  variance?: Maybe<Discounts_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Discounts_Append_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "discounts" */
export type Discounts_Arr_Rel_Insert_Input = {
  data: Array<Discounts_Insert_Input>;
  on_conflict?: Maybe<Discounts_On_Conflict>;
};

/** aggregate avg on columns */
export type Discounts_Avg_Fields = {
  __typename?: 'discounts_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "discounts" */
export type Discounts_Avg_Order_By = {
  amount?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "discounts". All fields are combined with a logical 'AND'. */
export type Discounts_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Discounts_Bool_Exp>>>;
  _not?: Maybe<Discounts_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Discounts_Bool_Exp>>>;
  amount?: Maybe<Numeric_Comparison_Exp>;
  code?: Maybe<String_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  discount_bills?: Maybe<Discount_Bills_Bool_Exp>;
  discount_students?: Maybe<Discount_Students_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  metadata?: Maybe<Jsonb_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  order?: Maybe<Int_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  unit?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "discounts" */
export enum Discounts_Constraint {
  /** unique or primary key constraint */
  DiscountsPkey = 'discounts_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Discounts_Delete_At_Path_Input = {
  metadata?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Discounts_Delete_Elem_Input = {
  metadata?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Discounts_Delete_Key_Input = {
  metadata?: Maybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "discounts" */
export type Discounts_Inc_Input = {
  amount?: Maybe<Scalars['numeric']>;
  order?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "discounts" */
export type Discounts_Insert_Input = {
  amount?: Maybe<Scalars['numeric']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  discount_bills?: Maybe<Discount_Bills_Arr_Rel_Insert_Input>;
  discount_students?: Maybe<Discount_Students_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  metadata?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Discounts_Max_Fields = {
  __typename?: 'discounts_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "discounts" */
export type Discounts_Max_Order_By = {
  amount?: Maybe<Order_By>;
  code?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  unit?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Discounts_Min_Fields = {
  __typename?: 'discounts_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "discounts" */
export type Discounts_Min_Order_By = {
  amount?: Maybe<Order_By>;
  code?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  unit?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "discounts" */
export type Discounts_Mutation_Response = {
  __typename?: 'discounts_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Discounts>;
};

/** input type for inserting object relation for remote table "discounts" */
export type Discounts_Obj_Rel_Insert_Input = {
  data: Discounts_Insert_Input;
  on_conflict?: Maybe<Discounts_On_Conflict>;
};

/** on conflict condition type for table "discounts" */
export type Discounts_On_Conflict = {
  constraint: Discounts_Constraint;
  update_columns: Array<Discounts_Update_Column>;
  where?: Maybe<Discounts_Bool_Exp>;
};

/** ordering options when selecting data from "discounts" */
export type Discounts_Order_By = {
  amount?: Maybe<Order_By>;
  code?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  discount_bills_aggregate?: Maybe<Discount_Bills_Aggregate_Order_By>;
  discount_students_aggregate?: Maybe<Discount_Students_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  metadata?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  unit?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "discounts" */
export type Discounts_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Discounts_Prepend_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "discounts" */
export enum Discounts_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  Status = 'status',
  /** column name */
  Unit = 'unit',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "discounts" */
export type Discounts_Set_Input = {
  amount?: Maybe<Scalars['numeric']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  metadata?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Discounts_Stddev_Fields = {
  __typename?: 'discounts_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "discounts" */
export type Discounts_Stddev_Order_By = {
  amount?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Discounts_Stddev_Pop_Fields = {
  __typename?: 'discounts_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "discounts" */
export type Discounts_Stddev_Pop_Order_By = {
  amount?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Discounts_Stddev_Samp_Fields = {
  __typename?: 'discounts_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "discounts" */
export type Discounts_Stddev_Samp_Order_By = {
  amount?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Discounts_Sum_Fields = {
  __typename?: 'discounts_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "discounts" */
export type Discounts_Sum_Order_By = {
  amount?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
};

/** update columns of table "discounts" */
export enum Discounts_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  Status = 'status',
  /** column name */
  Unit = 'unit',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** aggregate var_pop on columns */
export type Discounts_Var_Pop_Fields = {
  __typename?: 'discounts_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "discounts" */
export type Discounts_Var_Pop_Order_By = {
  amount?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Discounts_Var_Samp_Fields = {
  __typename?: 'discounts_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "discounts" */
export type Discounts_Var_Samp_Order_By = {
  amount?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Discounts_Variance_Fields = {
  __typename?: 'discounts_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "discounts" */
export type Discounts_Variance_Order_By = {
  amount?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
};

/** columns and relationships of "double_lesson_academic_pricings" */
export type Double_Lesson_Academic_Pricings = {
  __typename?: 'double_lesson_academic_pricings';
  /** An object relationship */
  academyCalendar?: Maybe<Academic_Calendars>;
  academyCalendarId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  doubleLessonProgramType?: Maybe<Double_Lesson_Program_Types>;
  id: Scalars['uuid'];
  pricePerLesson: Scalars['numeric'];
  programTypeDoubleLessonId?: Maybe<Scalars['uuid']>;
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  updater?: Maybe<Users>;
};

/** aggregated selection of "double_lesson_academic_pricings" */
export type Double_Lesson_Academic_Pricings_Aggregate = {
  __typename?: 'double_lesson_academic_pricings_aggregate';
  aggregate?: Maybe<Double_Lesson_Academic_Pricings_Aggregate_Fields>;
  nodes: Array<Double_Lesson_Academic_Pricings>;
};

/** aggregate fields of "double_lesson_academic_pricings" */
export type Double_Lesson_Academic_Pricings_Aggregate_Fields = {
  __typename?: 'double_lesson_academic_pricings_aggregate_fields';
  avg?: Maybe<Double_Lesson_Academic_Pricings_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Double_Lesson_Academic_Pricings_Max_Fields>;
  min?: Maybe<Double_Lesson_Academic_Pricings_Min_Fields>;
  stddev?: Maybe<Double_Lesson_Academic_Pricings_Stddev_Fields>;
  stddev_pop?: Maybe<Double_Lesson_Academic_Pricings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Double_Lesson_Academic_Pricings_Stddev_Samp_Fields>;
  sum?: Maybe<Double_Lesson_Academic_Pricings_Sum_Fields>;
  var_pop?: Maybe<Double_Lesson_Academic_Pricings_Var_Pop_Fields>;
  var_samp?: Maybe<Double_Lesson_Academic_Pricings_Var_Samp_Fields>;
  variance?: Maybe<Double_Lesson_Academic_Pricings_Variance_Fields>;
};


/** aggregate fields of "double_lesson_academic_pricings" */
export type Double_Lesson_Academic_Pricings_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Double_Lesson_Academic_Pricings_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "double_lesson_academic_pricings" */
export type Double_Lesson_Academic_Pricings_Aggregate_Order_By = {
  avg?: Maybe<Double_Lesson_Academic_Pricings_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Double_Lesson_Academic_Pricings_Max_Order_By>;
  min?: Maybe<Double_Lesson_Academic_Pricings_Min_Order_By>;
  stddev?: Maybe<Double_Lesson_Academic_Pricings_Stddev_Order_By>;
  stddev_pop?: Maybe<Double_Lesson_Academic_Pricings_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Double_Lesson_Academic_Pricings_Stddev_Samp_Order_By>;
  sum?: Maybe<Double_Lesson_Academic_Pricings_Sum_Order_By>;
  var_pop?: Maybe<Double_Lesson_Academic_Pricings_Var_Pop_Order_By>;
  var_samp?: Maybe<Double_Lesson_Academic_Pricings_Var_Samp_Order_By>;
  variance?: Maybe<Double_Lesson_Academic_Pricings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "double_lesson_academic_pricings" */
export type Double_Lesson_Academic_Pricings_Arr_Rel_Insert_Input = {
  data: Array<Double_Lesson_Academic_Pricings_Insert_Input>;
  on_conflict?: Maybe<Double_Lesson_Academic_Pricings_On_Conflict>;
};

/** aggregate avg on columns */
export type Double_Lesson_Academic_Pricings_Avg_Fields = {
  __typename?: 'double_lesson_academic_pricings_avg_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "double_lesson_academic_pricings" */
export type Double_Lesson_Academic_Pricings_Avg_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "double_lesson_academic_pricings". All fields are combined with a logical 'AND'. */
export type Double_Lesson_Academic_Pricings_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Double_Lesson_Academic_Pricings_Bool_Exp>>>;
  _not?: Maybe<Double_Lesson_Academic_Pricings_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Double_Lesson_Academic_Pricings_Bool_Exp>>>;
  academyCalendar?: Maybe<Academic_Calendars_Bool_Exp>;
  academyCalendarId?: Maybe<Uuid_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  doubleLessonProgramType?: Maybe<Double_Lesson_Program_Types_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  pricePerLesson?: Maybe<Numeric_Comparison_Exp>;
  programTypeDoubleLessonId?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  updater?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "double_lesson_academic_pricings" */
export enum Double_Lesson_Academic_Pricings_Constraint {
  /** unique or primary key constraint */
  DoubleLessonAcademicPricingsPkey = 'double_lesson_academic_pricings_pkey'
}

/** input type for incrementing integer column in table "double_lesson_academic_pricings" */
export type Double_Lesson_Academic_Pricings_Inc_Input = {
  pricePerLesson?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "double_lesson_academic_pricings" */
export type Double_Lesson_Academic_Pricings_Insert_Input = {
  academyCalendar?: Maybe<Academic_Calendars_Obj_Rel_Insert_Input>;
  academyCalendarId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  doubleLessonProgramType?: Maybe<Double_Lesson_Program_Types_Obj_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  pricePerLesson?: Maybe<Scalars['numeric']>;
  programTypeDoubleLessonId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  updater?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Double_Lesson_Academic_Pricings_Max_Fields = {
  __typename?: 'double_lesson_academic_pricings_max_fields';
  academyCalendarId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  pricePerLesson?: Maybe<Scalars['numeric']>;
  programTypeDoubleLessonId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "double_lesson_academic_pricings" */
export type Double_Lesson_Academic_Pricings_Max_Order_By = {
  academyCalendarId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pricePerLesson?: Maybe<Order_By>;
  programTypeDoubleLessonId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Double_Lesson_Academic_Pricings_Min_Fields = {
  __typename?: 'double_lesson_academic_pricings_min_fields';
  academyCalendarId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  pricePerLesson?: Maybe<Scalars['numeric']>;
  programTypeDoubleLessonId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "double_lesson_academic_pricings" */
export type Double_Lesson_Academic_Pricings_Min_Order_By = {
  academyCalendarId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pricePerLesson?: Maybe<Order_By>;
  programTypeDoubleLessonId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "double_lesson_academic_pricings" */
export type Double_Lesson_Academic_Pricings_Mutation_Response = {
  __typename?: 'double_lesson_academic_pricings_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Double_Lesson_Academic_Pricings>;
};

/** input type for inserting object relation for remote table "double_lesson_academic_pricings" */
export type Double_Lesson_Academic_Pricings_Obj_Rel_Insert_Input = {
  data: Double_Lesson_Academic_Pricings_Insert_Input;
  on_conflict?: Maybe<Double_Lesson_Academic_Pricings_On_Conflict>;
};

/** on conflict condition type for table "double_lesson_academic_pricings" */
export type Double_Lesson_Academic_Pricings_On_Conflict = {
  constraint: Double_Lesson_Academic_Pricings_Constraint;
  update_columns: Array<Double_Lesson_Academic_Pricings_Update_Column>;
  where?: Maybe<Double_Lesson_Academic_Pricings_Bool_Exp>;
};

/** ordering options when selecting data from "double_lesson_academic_pricings" */
export type Double_Lesson_Academic_Pricings_Order_By = {
  academyCalendar?: Maybe<Academic_Calendars_Order_By>;
  academyCalendarId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  doubleLessonProgramType?: Maybe<Double_Lesson_Program_Types_Order_By>;
  id?: Maybe<Order_By>;
  pricePerLesson?: Maybe<Order_By>;
  programTypeDoubleLessonId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  updater?: Maybe<Users_Order_By>;
};

/** primary key columns input for table: "double_lesson_academic_pricings" */
export type Double_Lesson_Academic_Pricings_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "double_lesson_academic_pricings" */
export enum Double_Lesson_Academic_Pricings_Select_Column {
  /** column name */
  AcademyCalendarId = 'academyCalendarId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  PricePerLesson = 'pricePerLesson',
  /** column name */
  ProgramTypeDoubleLessonId = 'programTypeDoubleLessonId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "double_lesson_academic_pricings" */
export type Double_Lesson_Academic_Pricings_Set_Input = {
  academyCalendarId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  pricePerLesson?: Maybe<Scalars['numeric']>;
  programTypeDoubleLessonId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Double_Lesson_Academic_Pricings_Stddev_Fields = {
  __typename?: 'double_lesson_academic_pricings_stddev_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "double_lesson_academic_pricings" */
export type Double_Lesson_Academic_Pricings_Stddev_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Double_Lesson_Academic_Pricings_Stddev_Pop_Fields = {
  __typename?: 'double_lesson_academic_pricings_stddev_pop_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "double_lesson_academic_pricings" */
export type Double_Lesson_Academic_Pricings_Stddev_Pop_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Double_Lesson_Academic_Pricings_Stddev_Samp_Fields = {
  __typename?: 'double_lesson_academic_pricings_stddev_samp_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "double_lesson_academic_pricings" */
export type Double_Lesson_Academic_Pricings_Stddev_Samp_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Double_Lesson_Academic_Pricings_Sum_Fields = {
  __typename?: 'double_lesson_academic_pricings_sum_fields';
  pricePerLesson?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "double_lesson_academic_pricings" */
export type Double_Lesson_Academic_Pricings_Sum_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** update columns of table "double_lesson_academic_pricings" */
export enum Double_Lesson_Academic_Pricings_Update_Column {
  /** column name */
  AcademyCalendarId = 'academyCalendarId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  PricePerLesson = 'pricePerLesson',
  /** column name */
  ProgramTypeDoubleLessonId = 'programTypeDoubleLessonId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** aggregate var_pop on columns */
export type Double_Lesson_Academic_Pricings_Var_Pop_Fields = {
  __typename?: 'double_lesson_academic_pricings_var_pop_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "double_lesson_academic_pricings" */
export type Double_Lesson_Academic_Pricings_Var_Pop_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Double_Lesson_Academic_Pricings_Var_Samp_Fields = {
  __typename?: 'double_lesson_academic_pricings_var_samp_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "double_lesson_academic_pricings" */
export type Double_Lesson_Academic_Pricings_Var_Samp_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Double_Lesson_Academic_Pricings_Variance_Fields = {
  __typename?: 'double_lesson_academic_pricings_variance_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "double_lesson_academic_pricings" */
export type Double_Lesson_Academic_Pricings_Variance_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** columns and relationships of "double_lesson_program_types" */
export type Double_Lesson_Program_Types = {
  __typename?: 'double_lesson_program_types';
  code: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  fullName: Scalars['String'];
  id: Scalars['uuid'];
  shortName: Scalars['String'];
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "double_lesson_program_types" */
export type Double_Lesson_Program_Types_Aggregate = {
  __typename?: 'double_lesson_program_types_aggregate';
  aggregate?: Maybe<Double_Lesson_Program_Types_Aggregate_Fields>;
  nodes: Array<Double_Lesson_Program_Types>;
};

/** aggregate fields of "double_lesson_program_types" */
export type Double_Lesson_Program_Types_Aggregate_Fields = {
  __typename?: 'double_lesson_program_types_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Double_Lesson_Program_Types_Max_Fields>;
  min?: Maybe<Double_Lesson_Program_Types_Min_Fields>;
};


/** aggregate fields of "double_lesson_program_types" */
export type Double_Lesson_Program_Types_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Double_Lesson_Program_Types_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "double_lesson_program_types" */
export type Double_Lesson_Program_Types_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Double_Lesson_Program_Types_Max_Order_By>;
  min?: Maybe<Double_Lesson_Program_Types_Min_Order_By>;
};

/** input type for inserting array relation for remote table "double_lesson_program_types" */
export type Double_Lesson_Program_Types_Arr_Rel_Insert_Input = {
  data: Array<Double_Lesson_Program_Types_Insert_Input>;
  on_conflict?: Maybe<Double_Lesson_Program_Types_On_Conflict>;
};

/** Boolean expression to filter rows from the table "double_lesson_program_types". All fields are combined with a logical 'AND'. */
export type Double_Lesson_Program_Types_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Double_Lesson_Program_Types_Bool_Exp>>>;
  _not?: Maybe<Double_Lesson_Program_Types_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Double_Lesson_Program_Types_Bool_Exp>>>;
  code?: Maybe<String_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  fullName?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  shortName?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "double_lesson_program_types" */
export enum Double_Lesson_Program_Types_Constraint {
  /** unique or primary key constraint */
  DoubleLessonProgramTypesCodeKey = 'double_lesson_program_types_code_key',
  /** unique or primary key constraint */
  DoubleLessonProgramTypesPkey = 'double_lesson_program_types_pkey'
}

/** input type for inserting data into table "double_lesson_program_types" */
export type Double_Lesson_Program_Types_Insert_Input = {
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  shortName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Double_Lesson_Program_Types_Max_Fields = {
  __typename?: 'double_lesson_program_types_max_fields';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  shortName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "double_lesson_program_types" */
export type Double_Lesson_Program_Types_Max_Order_By = {
  code?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  fullName?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  shortName?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Double_Lesson_Program_Types_Min_Fields = {
  __typename?: 'double_lesson_program_types_min_fields';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  shortName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "double_lesson_program_types" */
export type Double_Lesson_Program_Types_Min_Order_By = {
  code?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  fullName?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  shortName?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "double_lesson_program_types" */
export type Double_Lesson_Program_Types_Mutation_Response = {
  __typename?: 'double_lesson_program_types_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Double_Lesson_Program_Types>;
};

/** input type for inserting object relation for remote table "double_lesson_program_types" */
export type Double_Lesson_Program_Types_Obj_Rel_Insert_Input = {
  data: Double_Lesson_Program_Types_Insert_Input;
  on_conflict?: Maybe<Double_Lesson_Program_Types_On_Conflict>;
};

/** on conflict condition type for table "double_lesson_program_types" */
export type Double_Lesson_Program_Types_On_Conflict = {
  constraint: Double_Lesson_Program_Types_Constraint;
  update_columns: Array<Double_Lesson_Program_Types_Update_Column>;
  where?: Maybe<Double_Lesson_Program_Types_Bool_Exp>;
};

/** ordering options when selecting data from "double_lesson_program_types" */
export type Double_Lesson_Program_Types_Order_By = {
  code?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  fullName?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  shortName?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "double_lesson_program_types" */
export type Double_Lesson_Program_Types_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "double_lesson_program_types" */
export enum Double_Lesson_Program_Types_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  FullName = 'fullName',
  /** column name */
  Id = 'id',
  /** column name */
  ShortName = 'shortName',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "double_lesson_program_types" */
export type Double_Lesson_Program_Types_Set_Input = {
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  shortName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "double_lesson_program_types" */
export enum Double_Lesson_Program_Types_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  FullName = 'fullName',
  /** column name */
  Id = 'id',
  /** column name */
  ShortName = 'shortName',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** columns and relationships of "double_lesson_programme_pricings" */
export type Double_Lesson_Programme_Pricings = {
  __typename?: 'double_lesson_programme_pricings';
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  curriculum: Curriculums;
  curriculumId: Scalars['uuid'];
  /** An object relationship */
  double_lesson_program_type: Double_Lesson_Program_Types;
  id: Scalars['uuid'];
  pricePerLesson: Scalars['numeric'];
  programTypeDoubleLessonId: Scalars['uuid'];
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  updater?: Maybe<Users>;
};

/** aggregated selection of "double_lesson_programme_pricings" */
export type Double_Lesson_Programme_Pricings_Aggregate = {
  __typename?: 'double_lesson_programme_pricings_aggregate';
  aggregate?: Maybe<Double_Lesson_Programme_Pricings_Aggregate_Fields>;
  nodes: Array<Double_Lesson_Programme_Pricings>;
};

/** aggregate fields of "double_lesson_programme_pricings" */
export type Double_Lesson_Programme_Pricings_Aggregate_Fields = {
  __typename?: 'double_lesson_programme_pricings_aggregate_fields';
  avg?: Maybe<Double_Lesson_Programme_Pricings_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Double_Lesson_Programme_Pricings_Max_Fields>;
  min?: Maybe<Double_Lesson_Programme_Pricings_Min_Fields>;
  stddev?: Maybe<Double_Lesson_Programme_Pricings_Stddev_Fields>;
  stddev_pop?: Maybe<Double_Lesson_Programme_Pricings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Double_Lesson_Programme_Pricings_Stddev_Samp_Fields>;
  sum?: Maybe<Double_Lesson_Programme_Pricings_Sum_Fields>;
  var_pop?: Maybe<Double_Lesson_Programme_Pricings_Var_Pop_Fields>;
  var_samp?: Maybe<Double_Lesson_Programme_Pricings_Var_Samp_Fields>;
  variance?: Maybe<Double_Lesson_Programme_Pricings_Variance_Fields>;
};


/** aggregate fields of "double_lesson_programme_pricings" */
export type Double_Lesson_Programme_Pricings_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Double_Lesson_Programme_Pricings_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "double_lesson_programme_pricings" */
export type Double_Lesson_Programme_Pricings_Aggregate_Order_By = {
  avg?: Maybe<Double_Lesson_Programme_Pricings_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Double_Lesson_Programme_Pricings_Max_Order_By>;
  min?: Maybe<Double_Lesson_Programme_Pricings_Min_Order_By>;
  stddev?: Maybe<Double_Lesson_Programme_Pricings_Stddev_Order_By>;
  stddev_pop?: Maybe<Double_Lesson_Programme_Pricings_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Double_Lesson_Programme_Pricings_Stddev_Samp_Order_By>;
  sum?: Maybe<Double_Lesson_Programme_Pricings_Sum_Order_By>;
  var_pop?: Maybe<Double_Lesson_Programme_Pricings_Var_Pop_Order_By>;
  var_samp?: Maybe<Double_Lesson_Programme_Pricings_Var_Samp_Order_By>;
  variance?: Maybe<Double_Lesson_Programme_Pricings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "double_lesson_programme_pricings" */
export type Double_Lesson_Programme_Pricings_Arr_Rel_Insert_Input = {
  data: Array<Double_Lesson_Programme_Pricings_Insert_Input>;
  on_conflict?: Maybe<Double_Lesson_Programme_Pricings_On_Conflict>;
};

/** aggregate avg on columns */
export type Double_Lesson_Programme_Pricings_Avg_Fields = {
  __typename?: 'double_lesson_programme_pricings_avg_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "double_lesson_programme_pricings" */
export type Double_Lesson_Programme_Pricings_Avg_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "double_lesson_programme_pricings". All fields are combined with a logical 'AND'. */
export type Double_Lesson_Programme_Pricings_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Double_Lesson_Programme_Pricings_Bool_Exp>>>;
  _not?: Maybe<Double_Lesson_Programme_Pricings_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Double_Lesson_Programme_Pricings_Bool_Exp>>>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  curriculum?: Maybe<Curriculums_Bool_Exp>;
  curriculumId?: Maybe<Uuid_Comparison_Exp>;
  double_lesson_program_type?: Maybe<Double_Lesson_Program_Types_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  pricePerLesson?: Maybe<Numeric_Comparison_Exp>;
  programTypeDoubleLessonId?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  updater?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "double_lesson_programme_pricings" */
export enum Double_Lesson_Programme_Pricings_Constraint {
  /** unique or primary key constraint */
  DoubleLessonProgrammePricingsPkey = 'double_lesson_programme_pricings_pkey'
}

/** input type for incrementing integer column in table "double_lesson_programme_pricings" */
export type Double_Lesson_Programme_Pricings_Inc_Input = {
  pricePerLesson?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "double_lesson_programme_pricings" */
export type Double_Lesson_Programme_Pricings_Insert_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculum?: Maybe<Curriculums_Obj_Rel_Insert_Input>;
  curriculumId?: Maybe<Scalars['uuid']>;
  double_lesson_program_type?: Maybe<Double_Lesson_Program_Types_Obj_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  pricePerLesson?: Maybe<Scalars['numeric']>;
  programTypeDoubleLessonId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  updater?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Double_Lesson_Programme_Pricings_Max_Fields = {
  __typename?: 'double_lesson_programme_pricings_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  pricePerLesson?: Maybe<Scalars['numeric']>;
  programTypeDoubleLessonId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "double_lesson_programme_pricings" */
export type Double_Lesson_Programme_Pricings_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  curriculumId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pricePerLesson?: Maybe<Order_By>;
  programTypeDoubleLessonId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Double_Lesson_Programme_Pricings_Min_Fields = {
  __typename?: 'double_lesson_programme_pricings_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  pricePerLesson?: Maybe<Scalars['numeric']>;
  programTypeDoubleLessonId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "double_lesson_programme_pricings" */
export type Double_Lesson_Programme_Pricings_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  curriculumId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pricePerLesson?: Maybe<Order_By>;
  programTypeDoubleLessonId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "double_lesson_programme_pricings" */
export type Double_Lesson_Programme_Pricings_Mutation_Response = {
  __typename?: 'double_lesson_programme_pricings_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Double_Lesson_Programme_Pricings>;
};

/** input type for inserting object relation for remote table "double_lesson_programme_pricings" */
export type Double_Lesson_Programme_Pricings_Obj_Rel_Insert_Input = {
  data: Double_Lesson_Programme_Pricings_Insert_Input;
  on_conflict?: Maybe<Double_Lesson_Programme_Pricings_On_Conflict>;
};

/** on conflict condition type for table "double_lesson_programme_pricings" */
export type Double_Lesson_Programme_Pricings_On_Conflict = {
  constraint: Double_Lesson_Programme_Pricings_Constraint;
  update_columns: Array<Double_Lesson_Programme_Pricings_Update_Column>;
  where?: Maybe<Double_Lesson_Programme_Pricings_Bool_Exp>;
};

/** ordering options when selecting data from "double_lesson_programme_pricings" */
export type Double_Lesson_Programme_Pricings_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  curriculum?: Maybe<Curriculums_Order_By>;
  curriculumId?: Maybe<Order_By>;
  double_lesson_program_type?: Maybe<Double_Lesson_Program_Types_Order_By>;
  id?: Maybe<Order_By>;
  pricePerLesson?: Maybe<Order_By>;
  programTypeDoubleLessonId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  updater?: Maybe<Users_Order_By>;
};

/** primary key columns input for table: "double_lesson_programme_pricings" */
export type Double_Lesson_Programme_Pricings_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "double_lesson_programme_pricings" */
export enum Double_Lesson_Programme_Pricings_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CurriculumId = 'curriculumId',
  /** column name */
  Id = 'id',
  /** column name */
  PricePerLesson = 'pricePerLesson',
  /** column name */
  ProgramTypeDoubleLessonId = 'programTypeDoubleLessonId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "double_lesson_programme_pricings" */
export type Double_Lesson_Programme_Pricings_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  pricePerLesson?: Maybe<Scalars['numeric']>;
  programTypeDoubleLessonId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Double_Lesson_Programme_Pricings_Stddev_Fields = {
  __typename?: 'double_lesson_programme_pricings_stddev_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "double_lesson_programme_pricings" */
export type Double_Lesson_Programme_Pricings_Stddev_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Double_Lesson_Programme_Pricings_Stddev_Pop_Fields = {
  __typename?: 'double_lesson_programme_pricings_stddev_pop_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "double_lesson_programme_pricings" */
export type Double_Lesson_Programme_Pricings_Stddev_Pop_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Double_Lesson_Programme_Pricings_Stddev_Samp_Fields = {
  __typename?: 'double_lesson_programme_pricings_stddev_samp_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "double_lesson_programme_pricings" */
export type Double_Lesson_Programme_Pricings_Stddev_Samp_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Double_Lesson_Programme_Pricings_Sum_Fields = {
  __typename?: 'double_lesson_programme_pricings_sum_fields';
  pricePerLesson?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "double_lesson_programme_pricings" */
export type Double_Lesson_Programme_Pricings_Sum_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** update columns of table "double_lesson_programme_pricings" */
export enum Double_Lesson_Programme_Pricings_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CurriculumId = 'curriculumId',
  /** column name */
  Id = 'id',
  /** column name */
  PricePerLesson = 'pricePerLesson',
  /** column name */
  ProgramTypeDoubleLessonId = 'programTypeDoubleLessonId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** aggregate var_pop on columns */
export type Double_Lesson_Programme_Pricings_Var_Pop_Fields = {
  __typename?: 'double_lesson_programme_pricings_var_pop_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "double_lesson_programme_pricings" */
export type Double_Lesson_Programme_Pricings_Var_Pop_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Double_Lesson_Programme_Pricings_Var_Samp_Fields = {
  __typename?: 'double_lesson_programme_pricings_var_samp_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "double_lesson_programme_pricings" */
export type Double_Lesson_Programme_Pricings_Var_Samp_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Double_Lesson_Programme_Pricings_Variance_Fields = {
  __typename?: 'double_lesson_programme_pricings_variance_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "double_lesson_programme_pricings" */
export type Double_Lesson_Programme_Pricings_Variance_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** columns and relationships of "email_student_logs" */
export type Email_Student_Logs = {
  __typename?: 'email_student_logs';
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  emailResponse?: Maybe<Scalars['jsonb']>;
  emailStatus?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An object relationship */
  paymentAdvice: Payment_Advices;
  paymentAdviceId: Scalars['uuid'];
  status: Scalars['String'];
  /** An object relationship */
  student: Users;
  studentId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "email_student_logs" */
export type Email_Student_LogsEmailResponseArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "email_student_logs" */
export type Email_Student_Logs_Aggregate = {
  __typename?: 'email_student_logs_aggregate';
  aggregate?: Maybe<Email_Student_Logs_Aggregate_Fields>;
  nodes: Array<Email_Student_Logs>;
};

/** aggregate fields of "email_student_logs" */
export type Email_Student_Logs_Aggregate_Fields = {
  __typename?: 'email_student_logs_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Email_Student_Logs_Max_Fields>;
  min?: Maybe<Email_Student_Logs_Min_Fields>;
};


/** aggregate fields of "email_student_logs" */
export type Email_Student_Logs_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Email_Student_Logs_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "email_student_logs" */
export type Email_Student_Logs_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Email_Student_Logs_Max_Order_By>;
  min?: Maybe<Email_Student_Logs_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Email_Student_Logs_Append_Input = {
  emailResponse?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "email_student_logs" */
export type Email_Student_Logs_Arr_Rel_Insert_Input = {
  data: Array<Email_Student_Logs_Insert_Input>;
  on_conflict?: Maybe<Email_Student_Logs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "email_student_logs". All fields are combined with a logical 'AND'. */
export type Email_Student_Logs_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Email_Student_Logs_Bool_Exp>>>;
  _not?: Maybe<Email_Student_Logs_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Email_Student_Logs_Bool_Exp>>>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  emailResponse?: Maybe<Jsonb_Comparison_Exp>;
  emailStatus?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  paymentAdvice?: Maybe<Payment_Advices_Bool_Exp>;
  paymentAdviceId?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  student?: Maybe<Users_Bool_Exp>;
  studentId?: Maybe<Uuid_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "email_student_logs" */
export enum Email_Student_Logs_Constraint {
  /** unique or primary key constraint */
  EmailStudentLogsPkey = 'email_student_logs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Email_Student_Logs_Delete_At_Path_Input = {
  emailResponse?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Email_Student_Logs_Delete_Elem_Input = {
  emailResponse?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Email_Student_Logs_Delete_Key_Input = {
  emailResponse?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "email_student_logs" */
export type Email_Student_Logs_Insert_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailResponse?: Maybe<Scalars['jsonb']>;
  emailStatus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdvice?: Maybe<Payment_Advices_Obj_Rel_Insert_Input>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  student?: Maybe<Users_Obj_Rel_Insert_Input>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Email_Student_Logs_Max_Fields = {
  __typename?: 'email_student_logs_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailStatus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "email_student_logs" */
export type Email_Student_Logs_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  emailStatus?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Email_Student_Logs_Min_Fields = {
  __typename?: 'email_student_logs_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailStatus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "email_student_logs" */
export type Email_Student_Logs_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  emailStatus?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "email_student_logs" */
export type Email_Student_Logs_Mutation_Response = {
  __typename?: 'email_student_logs_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Email_Student_Logs>;
};

/** input type for inserting object relation for remote table "email_student_logs" */
export type Email_Student_Logs_Obj_Rel_Insert_Input = {
  data: Email_Student_Logs_Insert_Input;
  on_conflict?: Maybe<Email_Student_Logs_On_Conflict>;
};

/** on conflict condition type for table "email_student_logs" */
export type Email_Student_Logs_On_Conflict = {
  constraint: Email_Student_Logs_Constraint;
  update_columns: Array<Email_Student_Logs_Update_Column>;
  where?: Maybe<Email_Student_Logs_Bool_Exp>;
};

/** ordering options when selecting data from "email_student_logs" */
export type Email_Student_Logs_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  emailResponse?: Maybe<Order_By>;
  emailStatus?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  paymentAdvice?: Maybe<Payment_Advices_Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  student?: Maybe<Users_Order_By>;
  studentId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "email_student_logs" */
export type Email_Student_Logs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Email_Student_Logs_Prepend_Input = {
  emailResponse?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "email_student_logs" */
export enum Email_Student_Logs_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EmailResponse = 'emailResponse',
  /** column name */
  EmailStatus = 'emailStatus',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentAdviceId = 'paymentAdviceId',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "email_student_logs" */
export type Email_Student_Logs_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailResponse?: Maybe<Scalars['jsonb']>;
  emailStatus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "email_student_logs" */
export enum Email_Student_Logs_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EmailResponse = 'emailResponse',
  /** column name */
  EmailStatus = 'emailStatus',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentAdviceId = 'paymentAdviceId',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** columns and relationships of "enrollment_list_new" */
export type Enrollment_List_New = {
  __typename?: 'enrollment_list_new';
  /** An object relationship */
  class?: Maybe<Classes>;
  classId?: Maybe<Scalars['uuid']>;
  classInformation: Scalars['jsonb'];
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An object relationship */
  paymentAdvice?: Maybe<Payment_Advices>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  status: Scalars['String'];
  /** An object relationship */
  student?: Maybe<Users>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "enrollment_list_new" */
export type Enrollment_List_NewClassInformationArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "enrollment_list_new" */
export type Enrollment_List_New_Aggregate = {
  __typename?: 'enrollment_list_new_aggregate';
  aggregate?: Maybe<Enrollment_List_New_Aggregate_Fields>;
  nodes: Array<Enrollment_List_New>;
};

/** aggregate fields of "enrollment_list_new" */
export type Enrollment_List_New_Aggregate_Fields = {
  __typename?: 'enrollment_list_new_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Enrollment_List_New_Max_Fields>;
  min?: Maybe<Enrollment_List_New_Min_Fields>;
};


/** aggregate fields of "enrollment_list_new" */
export type Enrollment_List_New_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Enrollment_List_New_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "enrollment_list_new" */
export type Enrollment_List_New_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Enrollment_List_New_Max_Order_By>;
  min?: Maybe<Enrollment_List_New_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Enrollment_List_New_Append_Input = {
  classInformation?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "enrollment_list_new" */
export type Enrollment_List_New_Arr_Rel_Insert_Input = {
  data: Array<Enrollment_List_New_Insert_Input>;
  on_conflict?: Maybe<Enrollment_List_New_On_Conflict>;
};

/** Boolean expression to filter rows from the table "enrollment_list_new". All fields are combined with a logical 'AND'. */
export type Enrollment_List_New_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Enrollment_List_New_Bool_Exp>>>;
  _not?: Maybe<Enrollment_List_New_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Enrollment_List_New_Bool_Exp>>>;
  class?: Maybe<Classes_Bool_Exp>;
  classId?: Maybe<Uuid_Comparison_Exp>;
  classInformation?: Maybe<Jsonb_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  paymentAdvice?: Maybe<Payment_Advices_Bool_Exp>;
  paymentAdviceId?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  student?: Maybe<Users_Bool_Exp>;
  studentId?: Maybe<Uuid_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "enrollment_list_new" */
export enum Enrollment_List_New_Constraint {
  /** unique or primary key constraint */
  EnrollmentListNewPkey = 'enrollment_list_new_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Enrollment_List_New_Delete_At_Path_Input = {
  classInformation?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Enrollment_List_New_Delete_Elem_Input = {
  classInformation?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Enrollment_List_New_Delete_Key_Input = {
  classInformation?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "enrollment_list_new" */
export type Enrollment_List_New_Insert_Input = {
  class?: Maybe<Classes_Obj_Rel_Insert_Input>;
  classId?: Maybe<Scalars['uuid']>;
  classInformation?: Maybe<Scalars['jsonb']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdvice?: Maybe<Payment_Advices_Obj_Rel_Insert_Input>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  student?: Maybe<Users_Obj_Rel_Insert_Input>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Enrollment_List_New_Max_Fields = {
  __typename?: 'enrollment_list_new_max_fields';
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "enrollment_list_new" */
export type Enrollment_List_New_Max_Order_By = {
  classId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Enrollment_List_New_Min_Fields = {
  __typename?: 'enrollment_list_new_min_fields';
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "enrollment_list_new" */
export type Enrollment_List_New_Min_Order_By = {
  classId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "enrollment_list_new" */
export type Enrollment_List_New_Mutation_Response = {
  __typename?: 'enrollment_list_new_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Enrollment_List_New>;
};

/** input type for inserting object relation for remote table "enrollment_list_new" */
export type Enrollment_List_New_Obj_Rel_Insert_Input = {
  data: Enrollment_List_New_Insert_Input;
  on_conflict?: Maybe<Enrollment_List_New_On_Conflict>;
};

/** on conflict condition type for table "enrollment_list_new" */
export type Enrollment_List_New_On_Conflict = {
  constraint: Enrollment_List_New_Constraint;
  update_columns: Array<Enrollment_List_New_Update_Column>;
  where?: Maybe<Enrollment_List_New_Bool_Exp>;
};

/** ordering options when selecting data from "enrollment_list_new" */
export type Enrollment_List_New_Order_By = {
  class?: Maybe<Classes_Order_By>;
  classId?: Maybe<Order_By>;
  classInformation?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  paymentAdvice?: Maybe<Payment_Advices_Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  student?: Maybe<Users_Order_By>;
  studentId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "enrollment_list_new" */
export type Enrollment_List_New_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Enrollment_List_New_Prepend_Input = {
  classInformation?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "enrollment_list_new" */
export enum Enrollment_List_New_Select_Column {
  /** column name */
  ClassId = 'classId',
  /** column name */
  ClassInformation = 'classInformation',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentAdviceId = 'paymentAdviceId',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "enrollment_list_new" */
export type Enrollment_List_New_Set_Input = {
  classId?: Maybe<Scalars['uuid']>;
  classInformation?: Maybe<Scalars['jsonb']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "enrollment_list_new" */
export enum Enrollment_List_New_Update_Column {
  /** column name */
  ClassId = 'classId',
  /** column name */
  ClassInformation = 'classInformation',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentAdviceId = 'paymentAdviceId',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** columns and relationships of "general_program_types" */
export type General_Program_Types = {
  __typename?: 'general_program_types';
  /** An array relationship */
  classes: Array<Classes>;
  /** An aggregated array relationship */
  classes_aggregate: Classes_Aggregate;
  code: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  fullName: Scalars['String'];
  id: Scalars['uuid'];
  shortName: Scalars['String'];
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "general_program_types" */
export type General_Program_TypesClassesArgs = {
  distinct_on?: Maybe<Array<Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classes_Order_By>>;
  where?: Maybe<Classes_Bool_Exp>;
};


/** columns and relationships of "general_program_types" */
export type General_Program_TypesClasses_AggregateArgs = {
  distinct_on?: Maybe<Array<Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classes_Order_By>>;
  where?: Maybe<Classes_Bool_Exp>;
};

/** aggregated selection of "general_program_types" */
export type General_Program_Types_Aggregate = {
  __typename?: 'general_program_types_aggregate';
  aggregate?: Maybe<General_Program_Types_Aggregate_Fields>;
  nodes: Array<General_Program_Types>;
};

/** aggregate fields of "general_program_types" */
export type General_Program_Types_Aggregate_Fields = {
  __typename?: 'general_program_types_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<General_Program_Types_Max_Fields>;
  min?: Maybe<General_Program_Types_Min_Fields>;
};


/** aggregate fields of "general_program_types" */
export type General_Program_Types_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<General_Program_Types_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "general_program_types" */
export type General_Program_Types_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<General_Program_Types_Max_Order_By>;
  min?: Maybe<General_Program_Types_Min_Order_By>;
};

/** input type for inserting array relation for remote table "general_program_types" */
export type General_Program_Types_Arr_Rel_Insert_Input = {
  data: Array<General_Program_Types_Insert_Input>;
  on_conflict?: Maybe<General_Program_Types_On_Conflict>;
};

/** Boolean expression to filter rows from the table "general_program_types". All fields are combined with a logical 'AND'. */
export type General_Program_Types_Bool_Exp = {
  _and?: Maybe<Array<Maybe<General_Program_Types_Bool_Exp>>>;
  _not?: Maybe<General_Program_Types_Bool_Exp>;
  _or?: Maybe<Array<Maybe<General_Program_Types_Bool_Exp>>>;
  classes?: Maybe<Classes_Bool_Exp>;
  code?: Maybe<String_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  fullName?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  shortName?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "general_program_types" */
export enum General_Program_Types_Constraint {
  /** unique or primary key constraint */
  GeneralProgramCategoriesCodeKey = 'general_program_categories_code_key',
  /** unique or primary key constraint */
  GeneralProgramCategoriesPkey = 'general_program_categories_pkey'
}

/** input type for inserting data into table "general_program_types" */
export type General_Program_Types_Insert_Input = {
  classes?: Maybe<Classes_Arr_Rel_Insert_Input>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  shortName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type General_Program_Types_Max_Fields = {
  __typename?: 'general_program_types_max_fields';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  shortName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "general_program_types" */
export type General_Program_Types_Max_Order_By = {
  code?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  fullName?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  shortName?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type General_Program_Types_Min_Fields = {
  __typename?: 'general_program_types_min_fields';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  shortName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "general_program_types" */
export type General_Program_Types_Min_Order_By = {
  code?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  fullName?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  shortName?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "general_program_types" */
export type General_Program_Types_Mutation_Response = {
  __typename?: 'general_program_types_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<General_Program_Types>;
};

/** input type for inserting object relation for remote table "general_program_types" */
export type General_Program_Types_Obj_Rel_Insert_Input = {
  data: General_Program_Types_Insert_Input;
  on_conflict?: Maybe<General_Program_Types_On_Conflict>;
};

/** on conflict condition type for table "general_program_types" */
export type General_Program_Types_On_Conflict = {
  constraint: General_Program_Types_Constraint;
  update_columns: Array<General_Program_Types_Update_Column>;
  where?: Maybe<General_Program_Types_Bool_Exp>;
};

/** ordering options when selecting data from "general_program_types" */
export type General_Program_Types_Order_By = {
  classes_aggregate?: Maybe<Classes_Aggregate_Order_By>;
  code?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  fullName?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  shortName?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "general_program_types" */
export type General_Program_Types_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "general_program_types" */
export enum General_Program_Types_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  FullName = 'fullName',
  /** column name */
  Id = 'id',
  /** column name */
  ShortName = 'shortName',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "general_program_types" */
export type General_Program_Types_Set_Input = {
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  shortName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "general_program_types" */
export enum General_Program_Types_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  FullName = 'fullName',
  /** column name */
  Id = 'id',
  /** column name */
  ShortName = 'shortName',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** columns and relationships of "get_profile" */
export type Get_Profile = {
  __typename?: 'get_profile';
  address?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  cognitoId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  dob?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  isVerifiedEmail?: Maybe<Scalars['Boolean']>;
  isVerifiedPhoneNumber?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['jsonb']>;
  phoneNumber?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  roleIds?: Maybe<Scalars['jsonb']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  username?: Maybe<Scalars['String']>;
};


/** columns and relationships of "get_profile" */
export type Get_ProfilePhoneArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "get_profile" */
export type Get_ProfileRoleIdsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "get_profile" */
export type Get_Profile_Aggregate = {
  __typename?: 'get_profile_aggregate';
  aggregate?: Maybe<Get_Profile_Aggregate_Fields>;
  nodes: Array<Get_Profile>;
};

/** aggregate fields of "get_profile" */
export type Get_Profile_Aggregate_Fields = {
  __typename?: 'get_profile_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Get_Profile_Max_Fields>;
  min?: Maybe<Get_Profile_Min_Fields>;
};


/** aggregate fields of "get_profile" */
export type Get_Profile_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Get_Profile_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "get_profile" */
export type Get_Profile_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Get_Profile_Max_Order_By>;
  min?: Maybe<Get_Profile_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Get_Profile_Append_Input = {
  phone?: Maybe<Scalars['jsonb']>;
  roleIds?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "get_profile" */
export type Get_Profile_Arr_Rel_Insert_Input = {
  data: Array<Get_Profile_Insert_Input>;
};

/** Boolean expression to filter rows from the table "get_profile". All fields are combined with a logical 'AND'. */
export type Get_Profile_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Get_Profile_Bool_Exp>>>;
  _not?: Maybe<Get_Profile_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Get_Profile_Bool_Exp>>>;
  address?: Maybe<String_Comparison_Exp>;
  avatar?: Maybe<String_Comparison_Exp>;
  code?: Maybe<String_Comparison_Exp>;
  cognitoId?: Maybe<String_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  dob?: Maybe<Timestamptz_Comparison_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  firstName?: Maybe<String_Comparison_Exp>;
  fullName?: Maybe<String_Comparison_Exp>;
  gender?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  isVerifiedEmail?: Maybe<Boolean_Comparison_Exp>;
  isVerifiedPhoneNumber?: Maybe<Boolean_Comparison_Exp>;
  lastName?: Maybe<String_Comparison_Exp>;
  phone?: Maybe<Jsonb_Comparison_Exp>;
  phoneNumber?: Maybe<String_Comparison_Exp>;
  role?: Maybe<String_Comparison_Exp>;
  roleIds?: Maybe<Jsonb_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  studentId?: Maybe<Uuid_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  username?: Maybe<String_Comparison_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Get_Profile_Delete_At_Path_Input = {
  phone?: Maybe<Array<Maybe<Scalars['String']>>>;
  roleIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Get_Profile_Delete_Elem_Input = {
  phone?: Maybe<Scalars['Int']>;
  roleIds?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Get_Profile_Delete_Key_Input = {
  phone?: Maybe<Scalars['String']>;
  roleIds?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "get_profile" */
export type Get_Profile_Insert_Input = {
  address?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  cognitoId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  dob?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  isVerifiedEmail?: Maybe<Scalars['Boolean']>;
  isVerifiedPhoneNumber?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['jsonb']>;
  phoneNumber?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  roleIds?: Maybe<Scalars['jsonb']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  username?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Get_Profile_Max_Fields = {
  __typename?: 'get_profile_max_fields';
  address?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  cognitoId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  dob?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  username?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "get_profile" */
export type Get_Profile_Max_Order_By = {
  address?: Maybe<Order_By>;
  avatar?: Maybe<Order_By>;
  code?: Maybe<Order_By>;
  cognitoId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  dob?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  firstName?: Maybe<Order_By>;
  fullName?: Maybe<Order_By>;
  gender?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lastName?: Maybe<Order_By>;
  phoneNumber?: Maybe<Order_By>;
  role?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  username?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Get_Profile_Min_Fields = {
  __typename?: 'get_profile_min_fields';
  address?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  cognitoId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  dob?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  username?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "get_profile" */
export type Get_Profile_Min_Order_By = {
  address?: Maybe<Order_By>;
  avatar?: Maybe<Order_By>;
  code?: Maybe<Order_By>;
  cognitoId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  dob?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  firstName?: Maybe<Order_By>;
  fullName?: Maybe<Order_By>;
  gender?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lastName?: Maybe<Order_By>;
  phoneNumber?: Maybe<Order_By>;
  role?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  username?: Maybe<Order_By>;
};

/** response of any mutation on the table "get_profile" */
export type Get_Profile_Mutation_Response = {
  __typename?: 'get_profile_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Get_Profile>;
};

/** input type for inserting object relation for remote table "get_profile" */
export type Get_Profile_Obj_Rel_Insert_Input = {
  data: Get_Profile_Insert_Input;
};

/** ordering options when selecting data from "get_profile" */
export type Get_Profile_Order_By = {
  address?: Maybe<Order_By>;
  avatar?: Maybe<Order_By>;
  code?: Maybe<Order_By>;
  cognitoId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  dob?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  firstName?: Maybe<Order_By>;
  fullName?: Maybe<Order_By>;
  gender?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  isVerifiedEmail?: Maybe<Order_By>;
  isVerifiedPhoneNumber?: Maybe<Order_By>;
  lastName?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  phoneNumber?: Maybe<Order_By>;
  role?: Maybe<Order_By>;
  roleIds?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  username?: Maybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Get_Profile_Prepend_Input = {
  phone?: Maybe<Scalars['jsonb']>;
  roleIds?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "get_profile" */
export enum Get_Profile_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Avatar = 'avatar',
  /** column name */
  Code = 'code',
  /** column name */
  CognitoId = 'cognitoId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Dob = 'dob',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  FullName = 'fullName',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  IsVerifiedEmail = 'isVerifiedEmail',
  /** column name */
  IsVerifiedPhoneNumber = 'isVerifiedPhoneNumber',
  /** column name */
  LastName = 'lastName',
  /** column name */
  Phone = 'phone',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  Role = 'role',
  /** column name */
  RoleIds = 'roleIds',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "get_profile" */
export type Get_Profile_Set_Input = {
  address?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  cognitoId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  dob?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  isVerifiedEmail?: Maybe<Scalars['Boolean']>;
  isVerifiedPhoneNumber?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['jsonb']>;
  phoneNumber?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  roleIds?: Maybe<Scalars['jsonb']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  username?: Maybe<Scalars['String']>;
};

export type Invoice_Filter_Args = {
  month?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "invoice_partial_payments" */
export type Invoice_Partial_Payments = {
  __typename?: 'invoice_partial_payments';
  amount?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  bank?: Maybe<Banks>;
  bankId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  branch?: Maybe<Branches>;
  branchId?: Maybe<Scalars['uuid']>;
  cardNumber?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  creditNote?: Maybe<Credit_Notes>;
  creditNoteId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An object relationship */
  invoice: Invoices;
  invoiceId: Scalars['uuid'];
  order?: Maybe<Scalars['Int']>;
  paymentMethod?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  updater?: Maybe<Users>;
};

/** aggregated selection of "invoice_partial_payments" */
export type Invoice_Partial_Payments_Aggregate = {
  __typename?: 'invoice_partial_payments_aggregate';
  aggregate?: Maybe<Invoice_Partial_Payments_Aggregate_Fields>;
  nodes: Array<Invoice_Partial_Payments>;
};

/** aggregate fields of "invoice_partial_payments" */
export type Invoice_Partial_Payments_Aggregate_Fields = {
  __typename?: 'invoice_partial_payments_aggregate_fields';
  avg?: Maybe<Invoice_Partial_Payments_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Invoice_Partial_Payments_Max_Fields>;
  min?: Maybe<Invoice_Partial_Payments_Min_Fields>;
  stddev?: Maybe<Invoice_Partial_Payments_Stddev_Fields>;
  stddev_pop?: Maybe<Invoice_Partial_Payments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Invoice_Partial_Payments_Stddev_Samp_Fields>;
  sum?: Maybe<Invoice_Partial_Payments_Sum_Fields>;
  var_pop?: Maybe<Invoice_Partial_Payments_Var_Pop_Fields>;
  var_samp?: Maybe<Invoice_Partial_Payments_Var_Samp_Fields>;
  variance?: Maybe<Invoice_Partial_Payments_Variance_Fields>;
};


/** aggregate fields of "invoice_partial_payments" */
export type Invoice_Partial_Payments_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Invoice_Partial_Payments_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "invoice_partial_payments" */
export type Invoice_Partial_Payments_Aggregate_Order_By = {
  avg?: Maybe<Invoice_Partial_Payments_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Invoice_Partial_Payments_Max_Order_By>;
  min?: Maybe<Invoice_Partial_Payments_Min_Order_By>;
  stddev?: Maybe<Invoice_Partial_Payments_Stddev_Order_By>;
  stddev_pop?: Maybe<Invoice_Partial_Payments_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Invoice_Partial_Payments_Stddev_Samp_Order_By>;
  sum?: Maybe<Invoice_Partial_Payments_Sum_Order_By>;
  var_pop?: Maybe<Invoice_Partial_Payments_Var_Pop_Order_By>;
  var_samp?: Maybe<Invoice_Partial_Payments_Var_Samp_Order_By>;
  variance?: Maybe<Invoice_Partial_Payments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "invoice_partial_payments" */
export type Invoice_Partial_Payments_Arr_Rel_Insert_Input = {
  data: Array<Invoice_Partial_Payments_Insert_Input>;
  on_conflict?: Maybe<Invoice_Partial_Payments_On_Conflict>;
};

/** aggregate avg on columns */
export type Invoice_Partial_Payments_Avg_Fields = {
  __typename?: 'invoice_partial_payments_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "invoice_partial_payments" */
export type Invoice_Partial_Payments_Avg_Order_By = {
  amount?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "invoice_partial_payments". All fields are combined with a logical 'AND'. */
export type Invoice_Partial_Payments_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Invoice_Partial_Payments_Bool_Exp>>>;
  _not?: Maybe<Invoice_Partial_Payments_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Invoice_Partial_Payments_Bool_Exp>>>;
  amount?: Maybe<Numeric_Comparison_Exp>;
  bank?: Maybe<Banks_Bool_Exp>;
  bankId?: Maybe<Uuid_Comparison_Exp>;
  branch?: Maybe<Branches_Bool_Exp>;
  branchId?: Maybe<Uuid_Comparison_Exp>;
  cardNumber?: Maybe<String_Comparison_Exp>;
  cardType?: Maybe<String_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  creditNote?: Maybe<Credit_Notes_Bool_Exp>;
  creditNoteId?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  invoice?: Maybe<Invoices_Bool_Exp>;
  invoiceId?: Maybe<Uuid_Comparison_Exp>;
  order?: Maybe<Int_Comparison_Exp>;
  paymentMethod?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  updater?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "invoice_partial_payments" */
export enum Invoice_Partial_Payments_Constraint {
  /** unique or primary key constraint */
  InvoicePartialPaymentsPkey = 'invoice_partial_payments_pkey'
}

/** input type for incrementing integer column in table "invoice_partial_payments" */
export type Invoice_Partial_Payments_Inc_Input = {
  amount?: Maybe<Scalars['numeric']>;
  order?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "invoice_partial_payments" */
export type Invoice_Partial_Payments_Insert_Input = {
  amount?: Maybe<Scalars['numeric']>;
  bank?: Maybe<Banks_Obj_Rel_Insert_Input>;
  bankId?: Maybe<Scalars['uuid']>;
  branch?: Maybe<Branches_Obj_Rel_Insert_Input>;
  branchId?: Maybe<Scalars['uuid']>;
  cardNumber?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  creditNote?: Maybe<Credit_Notes_Obj_Rel_Insert_Input>;
  creditNoteId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invoice?: Maybe<Invoices_Obj_Rel_Insert_Input>;
  invoiceId?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  paymentMethod?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  updater?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Invoice_Partial_Payments_Max_Fields = {
  __typename?: 'invoice_partial_payments_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  bankId?: Maybe<Scalars['uuid']>;
  branchId?: Maybe<Scalars['uuid']>;
  cardNumber?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  creditNoteId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invoiceId?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  paymentMethod?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "invoice_partial_payments" */
export type Invoice_Partial_Payments_Max_Order_By = {
  amount?: Maybe<Order_By>;
  bankId?: Maybe<Order_By>;
  branchId?: Maybe<Order_By>;
  cardNumber?: Maybe<Order_By>;
  cardType?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  creditNoteId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invoiceId?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
  paymentMethod?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Invoice_Partial_Payments_Min_Fields = {
  __typename?: 'invoice_partial_payments_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  bankId?: Maybe<Scalars['uuid']>;
  branchId?: Maybe<Scalars['uuid']>;
  cardNumber?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  creditNoteId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invoiceId?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  paymentMethod?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "invoice_partial_payments" */
export type Invoice_Partial_Payments_Min_Order_By = {
  amount?: Maybe<Order_By>;
  bankId?: Maybe<Order_By>;
  branchId?: Maybe<Order_By>;
  cardNumber?: Maybe<Order_By>;
  cardType?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  creditNoteId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invoiceId?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
  paymentMethod?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "invoice_partial_payments" */
export type Invoice_Partial_Payments_Mutation_Response = {
  __typename?: 'invoice_partial_payments_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Invoice_Partial_Payments>;
};

/** input type for inserting object relation for remote table "invoice_partial_payments" */
export type Invoice_Partial_Payments_Obj_Rel_Insert_Input = {
  data: Invoice_Partial_Payments_Insert_Input;
  on_conflict?: Maybe<Invoice_Partial_Payments_On_Conflict>;
};

/** on conflict condition type for table "invoice_partial_payments" */
export type Invoice_Partial_Payments_On_Conflict = {
  constraint: Invoice_Partial_Payments_Constraint;
  update_columns: Array<Invoice_Partial_Payments_Update_Column>;
  where?: Maybe<Invoice_Partial_Payments_Bool_Exp>;
};

/** ordering options when selecting data from "invoice_partial_payments" */
export type Invoice_Partial_Payments_Order_By = {
  amount?: Maybe<Order_By>;
  bank?: Maybe<Banks_Order_By>;
  bankId?: Maybe<Order_By>;
  branch?: Maybe<Branches_Order_By>;
  branchId?: Maybe<Order_By>;
  cardNumber?: Maybe<Order_By>;
  cardType?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  creditNote?: Maybe<Credit_Notes_Order_By>;
  creditNoteId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invoice?: Maybe<Invoices_Order_By>;
  invoiceId?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
  paymentMethod?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  updater?: Maybe<Users_Order_By>;
};

/** primary key columns input for table: "invoice_partial_payments" */
export type Invoice_Partial_Payments_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "invoice_partial_payments" */
export enum Invoice_Partial_Payments_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BankId = 'bankId',
  /** column name */
  BranchId = 'branchId',
  /** column name */
  CardNumber = 'cardNumber',
  /** column name */
  CardType = 'cardType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CreditNoteId = 'creditNoteId',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceId = 'invoiceId',
  /** column name */
  Order = 'order',
  /** column name */
  PaymentMethod = 'paymentMethod',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "invoice_partial_payments" */
export type Invoice_Partial_Payments_Set_Input = {
  amount?: Maybe<Scalars['numeric']>;
  bankId?: Maybe<Scalars['uuid']>;
  branchId?: Maybe<Scalars['uuid']>;
  cardNumber?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  creditNoteId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invoiceId?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  paymentMethod?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Invoice_Partial_Payments_Stddev_Fields = {
  __typename?: 'invoice_partial_payments_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "invoice_partial_payments" */
export type Invoice_Partial_Payments_Stddev_Order_By = {
  amount?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Invoice_Partial_Payments_Stddev_Pop_Fields = {
  __typename?: 'invoice_partial_payments_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "invoice_partial_payments" */
export type Invoice_Partial_Payments_Stddev_Pop_Order_By = {
  amount?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Invoice_Partial_Payments_Stddev_Samp_Fields = {
  __typename?: 'invoice_partial_payments_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "invoice_partial_payments" */
export type Invoice_Partial_Payments_Stddev_Samp_Order_By = {
  amount?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Invoice_Partial_Payments_Sum_Fields = {
  __typename?: 'invoice_partial_payments_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "invoice_partial_payments" */
export type Invoice_Partial_Payments_Sum_Order_By = {
  amount?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
};

/** update columns of table "invoice_partial_payments" */
export enum Invoice_Partial_Payments_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BankId = 'bankId',
  /** column name */
  BranchId = 'branchId',
  /** column name */
  CardNumber = 'cardNumber',
  /** column name */
  CardType = 'cardType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CreditNoteId = 'creditNoteId',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceId = 'invoiceId',
  /** column name */
  Order = 'order',
  /** column name */
  PaymentMethod = 'paymentMethod',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** aggregate var_pop on columns */
export type Invoice_Partial_Payments_Var_Pop_Fields = {
  __typename?: 'invoice_partial_payments_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "invoice_partial_payments" */
export type Invoice_Partial_Payments_Var_Pop_Order_By = {
  amount?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Invoice_Partial_Payments_Var_Samp_Fields = {
  __typename?: 'invoice_partial_payments_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "invoice_partial_payments" */
export type Invoice_Partial_Payments_Var_Samp_Order_By = {
  amount?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Invoice_Partial_Payments_Variance_Fields = {
  __typename?: 'invoice_partial_payments_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "invoice_partial_payments" */
export type Invoice_Partial_Payments_Variance_Order_By = {
  amount?: Maybe<Order_By>;
  order?: Maybe<Order_By>;
};

/** columns and relationships of "invoices" */
export type Invoices = {
  __typename?: 'invoices';
  billingStatic?: Maybe<Scalars['jsonb']>;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  invoiceDate?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  invoicePartialPayments: Array<Invoice_Partial_Payments>;
  /** An aggregated array relationship */
  invoicePartialPayments_aggregate: Invoice_Partial_Payments_Aggregate;
  invoiceStatus?: Maybe<Scalars['String']>;
  isGeneratedReceipt?: Maybe<Scalars['Boolean']>;
  link?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  /** An object relationship */
  pa: Payment_Advices;
  paymentAdviceId: Scalars['uuid'];
  reasons?: Maybe<Scalars['String']>;
  /** An object relationship */
  receipt?: Maybe<Receipts>;
  status: Scalars['String'];
  total: Scalars['numeric'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  userByCreatedby?: Maybe<Users>;
};


/** columns and relationships of "invoices" */
export type InvoicesBillingStaticArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "invoices" */
export type InvoicesInvoicePartialPaymentsArgs = {
  distinct_on?: Maybe<Array<Invoice_Partial_Payments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoice_Partial_Payments_Order_By>>;
  where?: Maybe<Invoice_Partial_Payments_Bool_Exp>;
};


/** columns and relationships of "invoices" */
export type InvoicesInvoicePartialPayments_AggregateArgs = {
  distinct_on?: Maybe<Array<Invoice_Partial_Payments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoice_Partial_Payments_Order_By>>;
  where?: Maybe<Invoice_Partial_Payments_Bool_Exp>;
};

/** aggregated selection of "invoices" */
export type Invoices_Aggregate = {
  __typename?: 'invoices_aggregate';
  aggregate?: Maybe<Invoices_Aggregate_Fields>;
  nodes: Array<Invoices>;
};

/** aggregate fields of "invoices" */
export type Invoices_Aggregate_Fields = {
  __typename?: 'invoices_aggregate_fields';
  avg?: Maybe<Invoices_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Invoices_Max_Fields>;
  min?: Maybe<Invoices_Min_Fields>;
  stddev?: Maybe<Invoices_Stddev_Fields>;
  stddev_pop?: Maybe<Invoices_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Invoices_Stddev_Samp_Fields>;
  sum?: Maybe<Invoices_Sum_Fields>;
  var_pop?: Maybe<Invoices_Var_Pop_Fields>;
  var_samp?: Maybe<Invoices_Var_Samp_Fields>;
  variance?: Maybe<Invoices_Variance_Fields>;
};


/** aggregate fields of "invoices" */
export type Invoices_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Invoices_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "invoices" */
export type Invoices_Aggregate_Order_By = {
  avg?: Maybe<Invoices_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Invoices_Max_Order_By>;
  min?: Maybe<Invoices_Min_Order_By>;
  stddev?: Maybe<Invoices_Stddev_Order_By>;
  stddev_pop?: Maybe<Invoices_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Invoices_Stddev_Samp_Order_By>;
  sum?: Maybe<Invoices_Sum_Order_By>;
  var_pop?: Maybe<Invoices_Var_Pop_Order_By>;
  var_samp?: Maybe<Invoices_Var_Samp_Order_By>;
  variance?: Maybe<Invoices_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Invoices_Append_Input = {
  billingStatic?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "invoices" */
export type Invoices_Arr_Rel_Insert_Input = {
  data: Array<Invoices_Insert_Input>;
  on_conflict?: Maybe<Invoices_On_Conflict>;
};

/** aggregate avg on columns */
export type Invoices_Avg_Fields = {
  __typename?: 'invoices_avg_fields';
  total?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "invoices" */
export type Invoices_Avg_Order_By = {
  total?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "invoices". All fields are combined with a logical 'AND'. */
export type Invoices_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Invoices_Bool_Exp>>>;
  _not?: Maybe<Invoices_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Invoices_Bool_Exp>>>;
  billingStatic?: Maybe<Jsonb_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  invoiceDate?: Maybe<Timestamptz_Comparison_Exp>;
  invoicePartialPayments?: Maybe<Invoice_Partial_Payments_Bool_Exp>;
  invoiceStatus?: Maybe<String_Comparison_Exp>;
  isGeneratedReceipt?: Maybe<Boolean_Comparison_Exp>;
  link?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  notes?: Maybe<String_Comparison_Exp>;
  pa?: Maybe<Payment_Advices_Bool_Exp>;
  paymentAdviceId?: Maybe<Uuid_Comparison_Exp>;
  reasons?: Maybe<String_Comparison_Exp>;
  receipt?: Maybe<Receipts_Bool_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  total?: Maybe<Numeric_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  userByCreatedby?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "invoices" */
export enum Invoices_Constraint {
  /** unique or primary key constraint */
  InvoicesNameKey = 'invoices_name_key',
  /** unique or primary key constraint */
  InvoicesPkey = 'invoices_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Invoices_Delete_At_Path_Input = {
  billingStatic?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Invoices_Delete_Elem_Input = {
  billingStatic?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Invoices_Delete_Key_Input = {
  billingStatic?: Maybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "invoices" */
export type Invoices_Inc_Input = {
  total?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "invoices" */
export type Invoices_Insert_Input = {
  billingStatic?: Maybe<Scalars['jsonb']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invoiceDate?: Maybe<Scalars['timestamptz']>;
  invoicePartialPayments?: Maybe<Invoice_Partial_Payments_Arr_Rel_Insert_Input>;
  invoiceStatus?: Maybe<Scalars['String']>;
  isGeneratedReceipt?: Maybe<Scalars['Boolean']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pa?: Maybe<Payment_Advices_Obj_Rel_Insert_Input>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  reasons?: Maybe<Scalars['String']>;
  receipt?: Maybe<Receipts_Obj_Rel_Insert_Input>;
  status?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  userByCreatedby?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Invoices_Max_Fields = {
  __typename?: 'invoices_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invoiceDate?: Maybe<Scalars['timestamptz']>;
  invoiceStatus?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  reasons?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "invoices" */
export type Invoices_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invoiceDate?: Maybe<Order_By>;
  invoiceStatus?: Maybe<Order_By>;
  link?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  notes?: Maybe<Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  reasons?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  total?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Invoices_Min_Fields = {
  __typename?: 'invoices_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invoiceDate?: Maybe<Scalars['timestamptz']>;
  invoiceStatus?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  reasons?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "invoices" */
export type Invoices_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invoiceDate?: Maybe<Order_By>;
  invoiceStatus?: Maybe<Order_By>;
  link?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  notes?: Maybe<Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  reasons?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  total?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "invoices" */
export type Invoices_Mutation_Response = {
  __typename?: 'invoices_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Invoices>;
};

/** input type for inserting object relation for remote table "invoices" */
export type Invoices_Obj_Rel_Insert_Input = {
  data: Invoices_Insert_Input;
  on_conflict?: Maybe<Invoices_On_Conflict>;
};

/** on conflict condition type for table "invoices" */
export type Invoices_On_Conflict = {
  constraint: Invoices_Constraint;
  update_columns: Array<Invoices_Update_Column>;
  where?: Maybe<Invoices_Bool_Exp>;
};

/** ordering options when selecting data from "invoices" */
export type Invoices_Order_By = {
  billingStatic?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invoiceDate?: Maybe<Order_By>;
  invoicePartialPayments_aggregate?: Maybe<Invoice_Partial_Payments_Aggregate_Order_By>;
  invoiceStatus?: Maybe<Order_By>;
  isGeneratedReceipt?: Maybe<Order_By>;
  link?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  notes?: Maybe<Order_By>;
  pa?: Maybe<Payment_Advices_Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  reasons?: Maybe<Order_By>;
  receipt?: Maybe<Receipts_Order_By>;
  status?: Maybe<Order_By>;
  total?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  userByCreatedby?: Maybe<Users_Order_By>;
};

/** primary key columns input for table: "invoices" */
export type Invoices_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Invoices_Prepend_Input = {
  billingStatic?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "invoices" */
export enum Invoices_Select_Column {
  /** column name */
  BillingStatic = 'billingStatic',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceDate = 'invoiceDate',
  /** column name */
  InvoiceStatus = 'invoiceStatus',
  /** column name */
  IsGeneratedReceipt = 'isGeneratedReceipt',
  /** column name */
  Link = 'link',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  PaymentAdviceId = 'paymentAdviceId',
  /** column name */
  Reasons = 'reasons',
  /** column name */
  Status = 'status',
  /** column name */
  Total = 'total',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "invoices" */
export type Invoices_Set_Input = {
  billingStatic?: Maybe<Scalars['jsonb']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invoiceDate?: Maybe<Scalars['timestamptz']>;
  invoiceStatus?: Maybe<Scalars['String']>;
  isGeneratedReceipt?: Maybe<Scalars['Boolean']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  reasons?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Invoices_Stddev_Fields = {
  __typename?: 'invoices_stddev_fields';
  total?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "invoices" */
export type Invoices_Stddev_Order_By = {
  total?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Invoices_Stddev_Pop_Fields = {
  __typename?: 'invoices_stddev_pop_fields';
  total?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "invoices" */
export type Invoices_Stddev_Pop_Order_By = {
  total?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Invoices_Stddev_Samp_Fields = {
  __typename?: 'invoices_stddev_samp_fields';
  total?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "invoices" */
export type Invoices_Stddev_Samp_Order_By = {
  total?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Invoices_Sum_Fields = {
  __typename?: 'invoices_sum_fields';
  total?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "invoices" */
export type Invoices_Sum_Order_By = {
  total?: Maybe<Order_By>;
};

/** update columns of table "invoices" */
export enum Invoices_Update_Column {
  /** column name */
  BillingStatic = 'billingStatic',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceDate = 'invoiceDate',
  /** column name */
  InvoiceStatus = 'invoiceStatus',
  /** column name */
  IsGeneratedReceipt = 'isGeneratedReceipt',
  /** column name */
  Link = 'link',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  PaymentAdviceId = 'paymentAdviceId',
  /** column name */
  Reasons = 'reasons',
  /** column name */
  Status = 'status',
  /** column name */
  Total = 'total',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** aggregate var_pop on columns */
export type Invoices_Var_Pop_Fields = {
  __typename?: 'invoices_var_pop_fields';
  total?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "invoices" */
export type Invoices_Var_Pop_Order_By = {
  total?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Invoices_Var_Samp_Fields = {
  __typename?: 'invoices_var_samp_fields';
  total?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "invoices" */
export type Invoices_Var_Samp_Order_By = {
  total?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Invoices_Variance_Fields = {
  __typename?: 'invoices_variance_fields';
  total?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "invoices" */
export type Invoices_Variance_Order_By = {
  total?: Maybe<Order_By>;
};


/** expression to compare columns of type json. All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: Maybe<Scalars['json']>;
  _gt?: Maybe<Scalars['json']>;
  _gte?: Maybe<Scalars['json']>;
  _in?: Maybe<Array<Scalars['json']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['json']>;
  _lte?: Maybe<Scalars['json']>;
  _neq?: Maybe<Scalars['json']>;
  _nin?: Maybe<Array<Scalars['json']>>;
};


/** expression to compare columns of type jsonb. All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  /** is the column contained in the given json value */
  _contained_in?: Maybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: Maybe<Scalars['jsonb']>;
  _eq?: Maybe<Scalars['jsonb']>;
  _gt?: Maybe<Scalars['jsonb']>;
  _gte?: Maybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: Maybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: Maybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: Maybe<Array<Scalars['String']>>;
  _in?: Maybe<Array<Scalars['jsonb']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['jsonb']>;
  _lte?: Maybe<Scalars['jsonb']>;
  _neq?: Maybe<Scalars['jsonb']>;
  _nin?: Maybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "lessons" */
export type Lessons = {
  __typename?: 'lessons';
  /** An object relationship */
  class: Classes;
  classId: Scalars['uuid'];
  /** An object relationship */
  classroom: Classrooms;
  classroomId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  date: Scalars['timestamptz'];
  id: Scalars['uuid'];
  lessonStatus: Scalars['String'];
  numberWeek?: Maybe<Scalars['Int']>;
  orderPriority: Scalars['numeric'];
  /** An array relationship */
  sessions: Array<Sessions>;
  /** An aggregated array relationship */
  sessions_aggregate: Sessions_Aggregate;
  status: Scalars['String'];
  /** An array relationship */
  students: Array<Lessons_Students>;
  /** An aggregated array relationship */
  students_aggregate: Lessons_Students_Aggregate;
  /** An object relationship */
  termClass?: Maybe<Term_Classes>;
  termClassId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  userByCreatedby?: Maybe<Users>;
};


/** columns and relationships of "lessons" */
export type LessonsSessionsArgs = {
  distinct_on?: Maybe<Array<Sessions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Sessions_Order_By>>;
  where?: Maybe<Sessions_Bool_Exp>;
};


/** columns and relationships of "lessons" */
export type LessonsSessions_AggregateArgs = {
  distinct_on?: Maybe<Array<Sessions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Sessions_Order_By>>;
  where?: Maybe<Sessions_Bool_Exp>;
};


/** columns and relationships of "lessons" */
export type LessonsStudentsArgs = {
  distinct_on?: Maybe<Array<Lessons_Students_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Students_Order_By>>;
  where?: Maybe<Lessons_Students_Bool_Exp>;
};


/** columns and relationships of "lessons" */
export type LessonsStudents_AggregateArgs = {
  distinct_on?: Maybe<Array<Lessons_Students_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Students_Order_By>>;
  where?: Maybe<Lessons_Students_Bool_Exp>;
};

/** aggregated selection of "lessons" */
export type Lessons_Aggregate = {
  __typename?: 'lessons_aggregate';
  aggregate?: Maybe<Lessons_Aggregate_Fields>;
  nodes: Array<Lessons>;
};

/** aggregate fields of "lessons" */
export type Lessons_Aggregate_Fields = {
  __typename?: 'lessons_aggregate_fields';
  avg?: Maybe<Lessons_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Lessons_Max_Fields>;
  min?: Maybe<Lessons_Min_Fields>;
  stddev?: Maybe<Lessons_Stddev_Fields>;
  stddev_pop?: Maybe<Lessons_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lessons_Stddev_Samp_Fields>;
  sum?: Maybe<Lessons_Sum_Fields>;
  var_pop?: Maybe<Lessons_Var_Pop_Fields>;
  var_samp?: Maybe<Lessons_Var_Samp_Fields>;
  variance?: Maybe<Lessons_Variance_Fields>;
};


/** aggregate fields of "lessons" */
export type Lessons_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Lessons_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lessons" */
export type Lessons_Aggregate_Order_By = {
  avg?: Maybe<Lessons_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Lessons_Max_Order_By>;
  min?: Maybe<Lessons_Min_Order_By>;
  stddev?: Maybe<Lessons_Stddev_Order_By>;
  stddev_pop?: Maybe<Lessons_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Lessons_Stddev_Samp_Order_By>;
  sum?: Maybe<Lessons_Sum_Order_By>;
  var_pop?: Maybe<Lessons_Var_Pop_Order_By>;
  var_samp?: Maybe<Lessons_Var_Samp_Order_By>;
  variance?: Maybe<Lessons_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "lessons" */
export type Lessons_Arr_Rel_Insert_Input = {
  data: Array<Lessons_Insert_Input>;
  on_conflict?: Maybe<Lessons_On_Conflict>;
};

/** aggregate avg on columns */
export type Lessons_Avg_Fields = {
  __typename?: 'lessons_avg_fields';
  numberWeek?: Maybe<Scalars['Float']>;
  orderPriority?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "lessons" */
export type Lessons_Avg_Order_By = {
  numberWeek?: Maybe<Order_By>;
  orderPriority?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "lessons". All fields are combined with a logical 'AND'. */
export type Lessons_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Lessons_Bool_Exp>>>;
  _not?: Maybe<Lessons_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Lessons_Bool_Exp>>>;
  class?: Maybe<Classes_Bool_Exp>;
  classId?: Maybe<Uuid_Comparison_Exp>;
  classroom?: Maybe<Classrooms_Bool_Exp>;
  classroomId?: Maybe<Uuid_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  date?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  lessonStatus?: Maybe<String_Comparison_Exp>;
  numberWeek?: Maybe<Int_Comparison_Exp>;
  orderPriority?: Maybe<Numeric_Comparison_Exp>;
  sessions?: Maybe<Sessions_Bool_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  students?: Maybe<Lessons_Students_Bool_Exp>;
  termClass?: Maybe<Term_Classes_Bool_Exp>;
  termClassId?: Maybe<Uuid_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  userByCreatedby?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "lessons" */
export enum Lessons_Constraint {
  /** unique or primary key constraint */
  LessonsOrderPriorityClassIdKey = 'lessons_orderPriority_classId_key',
  /** unique or primary key constraint */
  LessonsPkey = 'lessons_pkey'
}

/** input type for incrementing integer column in table "lessons" */
export type Lessons_Inc_Input = {
  numberWeek?: Maybe<Scalars['Int']>;
  orderPriority?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "lessons" */
export type Lessons_Insert_Input = {
  class?: Maybe<Classes_Obj_Rel_Insert_Input>;
  classId?: Maybe<Scalars['uuid']>;
  classroom?: Maybe<Classrooms_Obj_Rel_Insert_Input>;
  classroomId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonStatus?: Maybe<Scalars['String']>;
  numberWeek?: Maybe<Scalars['Int']>;
  orderPriority?: Maybe<Scalars['numeric']>;
  sessions?: Maybe<Sessions_Arr_Rel_Insert_Input>;
  status?: Maybe<Scalars['String']>;
  students?: Maybe<Lessons_Students_Arr_Rel_Insert_Input>;
  termClass?: Maybe<Term_Classes_Obj_Rel_Insert_Input>;
  termClassId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  userByCreatedby?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Lessons_Max_Fields = {
  __typename?: 'lessons_max_fields';
  classId?: Maybe<Scalars['uuid']>;
  classroomId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonStatus?: Maybe<Scalars['String']>;
  numberWeek?: Maybe<Scalars['Int']>;
  orderPriority?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  termClassId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "lessons" */
export type Lessons_Max_Order_By = {
  classId?: Maybe<Order_By>;
  classroomId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lessonStatus?: Maybe<Order_By>;
  numberWeek?: Maybe<Order_By>;
  orderPriority?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  termClassId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Lessons_Min_Fields = {
  __typename?: 'lessons_min_fields';
  classId?: Maybe<Scalars['uuid']>;
  classroomId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonStatus?: Maybe<Scalars['String']>;
  numberWeek?: Maybe<Scalars['Int']>;
  orderPriority?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  termClassId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "lessons" */
export type Lessons_Min_Order_By = {
  classId?: Maybe<Order_By>;
  classroomId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lessonStatus?: Maybe<Order_By>;
  numberWeek?: Maybe<Order_By>;
  orderPriority?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  termClassId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "lessons" */
export type Lessons_Mutation_Response = {
  __typename?: 'lessons_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Lessons>;
};

/** input type for inserting object relation for remote table "lessons" */
export type Lessons_Obj_Rel_Insert_Input = {
  data: Lessons_Insert_Input;
  on_conflict?: Maybe<Lessons_On_Conflict>;
};

/** on conflict condition type for table "lessons" */
export type Lessons_On_Conflict = {
  constraint: Lessons_Constraint;
  update_columns: Array<Lessons_Update_Column>;
  where?: Maybe<Lessons_Bool_Exp>;
};

/** ordering options when selecting data from "lessons" */
export type Lessons_Order_By = {
  class?: Maybe<Classes_Order_By>;
  classId?: Maybe<Order_By>;
  classroom?: Maybe<Classrooms_Order_By>;
  classroomId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lessonStatus?: Maybe<Order_By>;
  numberWeek?: Maybe<Order_By>;
  orderPriority?: Maybe<Order_By>;
  sessions_aggregate?: Maybe<Sessions_Aggregate_Order_By>;
  status?: Maybe<Order_By>;
  students_aggregate?: Maybe<Lessons_Students_Aggregate_Order_By>;
  termClass?: Maybe<Term_Classes_Order_By>;
  termClassId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  userByCreatedby?: Maybe<Users_Order_By>;
};

/** primary key columns input for table: "lessons" */
export type Lessons_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "lessons" */
export enum Lessons_Select_Column {
  /** column name */
  ClassId = 'classId',
  /** column name */
  ClassroomId = 'classroomId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  LessonStatus = 'lessonStatus',
  /** column name */
  NumberWeek = 'numberWeek',
  /** column name */
  OrderPriority = 'orderPriority',
  /** column name */
  Status = 'status',
  /** column name */
  TermClassId = 'termClassId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "lessons" */
export type Lessons_Set_Input = {
  classId?: Maybe<Scalars['uuid']>;
  classroomId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonStatus?: Maybe<Scalars['String']>;
  numberWeek?: Maybe<Scalars['Int']>;
  orderPriority?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  termClassId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Lessons_Stddev_Fields = {
  __typename?: 'lessons_stddev_fields';
  numberWeek?: Maybe<Scalars['Float']>;
  orderPriority?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "lessons" */
export type Lessons_Stddev_Order_By = {
  numberWeek?: Maybe<Order_By>;
  orderPriority?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Lessons_Stddev_Pop_Fields = {
  __typename?: 'lessons_stddev_pop_fields';
  numberWeek?: Maybe<Scalars['Float']>;
  orderPriority?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "lessons" */
export type Lessons_Stddev_Pop_Order_By = {
  numberWeek?: Maybe<Order_By>;
  orderPriority?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Lessons_Stddev_Samp_Fields = {
  __typename?: 'lessons_stddev_samp_fields';
  numberWeek?: Maybe<Scalars['Float']>;
  orderPriority?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "lessons" */
export type Lessons_Stddev_Samp_Order_By = {
  numberWeek?: Maybe<Order_By>;
  orderPriority?: Maybe<Order_By>;
};

/** columns and relationships of "lessons_students" */
export type Lessons_Students = {
  __typename?: 'lessons_students';
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  emailStatus: Scalars['String'];
  entryTime?: Maybe<Scalars['timestamptz']>;
  hasAttended: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** An object relationship */
  lesson: Lessons;
  lessonId: Scalars['uuid'];
  /** A computed field, executes function "lessons_students_field_lesson_status" */
  lessonStatus?: Maybe<Scalars['String']>;
  /** An object relationship */
  oldLesson?: Maybe<Lessons>;
  oldLessonId?: Maybe<Scalars['uuid']>;
  remarks?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  /** An object relationship */
  student: Users;
  studentId: Scalars['uuid'];
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "lessons_students" */
export type Lessons_Students_Aggregate = {
  __typename?: 'lessons_students_aggregate';
  aggregate?: Maybe<Lessons_Students_Aggregate_Fields>;
  nodes: Array<Lessons_Students>;
};

/** aggregate fields of "lessons_students" */
export type Lessons_Students_Aggregate_Fields = {
  __typename?: 'lessons_students_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Lessons_Students_Max_Fields>;
  min?: Maybe<Lessons_Students_Min_Fields>;
};


/** aggregate fields of "lessons_students" */
export type Lessons_Students_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Lessons_Students_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lessons_students" */
export type Lessons_Students_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Lessons_Students_Max_Order_By>;
  min?: Maybe<Lessons_Students_Min_Order_By>;
};

/** input type for inserting array relation for remote table "lessons_students" */
export type Lessons_Students_Arr_Rel_Insert_Input = {
  data: Array<Lessons_Students_Insert_Input>;
  on_conflict?: Maybe<Lessons_Students_On_Conflict>;
};

/** Boolean expression to filter rows from the table "lessons_students". All fields are combined with a logical 'AND'. */
export type Lessons_Students_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Lessons_Students_Bool_Exp>>>;
  _not?: Maybe<Lessons_Students_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Lessons_Students_Bool_Exp>>>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  emailStatus?: Maybe<String_Comparison_Exp>;
  entryTime?: Maybe<Timestamptz_Comparison_Exp>;
  hasAttended?: Maybe<Boolean_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  lesson?: Maybe<Lessons_Bool_Exp>;
  lessonId?: Maybe<Uuid_Comparison_Exp>;
  oldLesson?: Maybe<Lessons_Bool_Exp>;
  oldLessonId?: Maybe<Uuid_Comparison_Exp>;
  remarks?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  student?: Maybe<Users_Bool_Exp>;
  studentId?: Maybe<Uuid_Comparison_Exp>;
  type?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "lessons_students" */
export enum Lessons_Students_Constraint {
  /** unique or primary key constraint */
  LessonsStudentsLessonIdStudentIdKey = 'lessons_students_lessonId_studentId_key',
  /** unique or primary key constraint */
  LessonsStudentsPkey = 'lessons_students_pkey'
}

/** input type for inserting data into table "lessons_students" */
export type Lessons_Students_Insert_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailStatus?: Maybe<Scalars['String']>;
  entryTime?: Maybe<Scalars['timestamptz']>;
  hasAttended?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  lesson?: Maybe<Lessons_Obj_Rel_Insert_Input>;
  lessonId?: Maybe<Scalars['uuid']>;
  oldLesson?: Maybe<Lessons_Obj_Rel_Insert_Input>;
  oldLessonId?: Maybe<Scalars['uuid']>;
  remarks?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  student?: Maybe<Users_Obj_Rel_Insert_Input>;
  studentId?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Lessons_Students_Max_Fields = {
  __typename?: 'lessons_students_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailStatus?: Maybe<Scalars['String']>;
  entryTime?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  oldLessonId?: Maybe<Scalars['uuid']>;
  remarks?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "lessons_students" */
export type Lessons_Students_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  emailStatus?: Maybe<Order_By>;
  entryTime?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lessonId?: Maybe<Order_By>;
  oldLessonId?: Maybe<Order_By>;
  remarks?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Lessons_Students_Min_Fields = {
  __typename?: 'lessons_students_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailStatus?: Maybe<Scalars['String']>;
  entryTime?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  oldLessonId?: Maybe<Scalars['uuid']>;
  remarks?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "lessons_students" */
export type Lessons_Students_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  emailStatus?: Maybe<Order_By>;
  entryTime?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lessonId?: Maybe<Order_By>;
  oldLessonId?: Maybe<Order_By>;
  remarks?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "lessons_students" */
export type Lessons_Students_Mutation_Response = {
  __typename?: 'lessons_students_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Lessons_Students>;
};

/** input type for inserting object relation for remote table "lessons_students" */
export type Lessons_Students_Obj_Rel_Insert_Input = {
  data: Lessons_Students_Insert_Input;
  on_conflict?: Maybe<Lessons_Students_On_Conflict>;
};

/** on conflict condition type for table "lessons_students" */
export type Lessons_Students_On_Conflict = {
  constraint: Lessons_Students_Constraint;
  update_columns: Array<Lessons_Students_Update_Column>;
  where?: Maybe<Lessons_Students_Bool_Exp>;
};

/** ordering options when selecting data from "lessons_students" */
export type Lessons_Students_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  emailStatus?: Maybe<Order_By>;
  entryTime?: Maybe<Order_By>;
  hasAttended?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lesson?: Maybe<Lessons_Order_By>;
  lessonId?: Maybe<Order_By>;
  oldLesson?: Maybe<Lessons_Order_By>;
  oldLessonId?: Maybe<Order_By>;
  remarks?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  student?: Maybe<Users_Order_By>;
  studentId?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "lessons_students" */
export type Lessons_Students_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "lessons_students" */
export enum Lessons_Students_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EmailStatus = 'emailStatus',
  /** column name */
  EntryTime = 'entryTime',
  /** column name */
  HasAttended = 'hasAttended',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  OldLessonId = 'oldLessonId',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "lessons_students" */
export type Lessons_Students_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailStatus?: Maybe<Scalars['String']>;
  entryTime?: Maybe<Scalars['timestamptz']>;
  hasAttended?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  oldLessonId?: Maybe<Scalars['uuid']>;
  remarks?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "lessons_students" */
export enum Lessons_Students_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EmailStatus = 'emailStatus',
  /** column name */
  EntryTime = 'entryTime',
  /** column name */
  HasAttended = 'hasAttended',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  OldLessonId = 'oldLessonId',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** aggregate sum on columns */
export type Lessons_Sum_Fields = {
  __typename?: 'lessons_sum_fields';
  numberWeek?: Maybe<Scalars['Int']>;
  orderPriority?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "lessons" */
export type Lessons_Sum_Order_By = {
  numberWeek?: Maybe<Order_By>;
  orderPriority?: Maybe<Order_By>;
};

/** update columns of table "lessons" */
export enum Lessons_Update_Column {
  /** column name */
  ClassId = 'classId',
  /** column name */
  ClassroomId = 'classroomId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  LessonStatus = 'lessonStatus',
  /** column name */
  NumberWeek = 'numberWeek',
  /** column name */
  OrderPriority = 'orderPriority',
  /** column name */
  Status = 'status',
  /** column name */
  TermClassId = 'termClassId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** aggregate var_pop on columns */
export type Lessons_Var_Pop_Fields = {
  __typename?: 'lessons_var_pop_fields';
  numberWeek?: Maybe<Scalars['Float']>;
  orderPriority?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "lessons" */
export type Lessons_Var_Pop_Order_By = {
  numberWeek?: Maybe<Order_By>;
  orderPriority?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Lessons_Var_Samp_Fields = {
  __typename?: 'lessons_var_samp_fields';
  numberWeek?: Maybe<Scalars['Float']>;
  orderPriority?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "lessons" */
export type Lessons_Var_Samp_Order_By = {
  numberWeek?: Maybe<Order_By>;
  orderPriority?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Lessons_Variance_Fields = {
  __typename?: 'lessons_variance_fields';
  numberWeek?: Maybe<Scalars['Float']>;
  orderPriority?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "lessons" */
export type Lessons_Variance_Order_By = {
  numberWeek?: Maybe<Order_By>;
  orderPriority?: Maybe<Order_By>;
};

/** columns and relationships of "levels" */
export type Levels = {
  __typename?: 'levels';
  abbreviation: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  curriculums_levels: Array<Curriculums_Levels>;
  /** An aggregated array relationship */
  curriculums_levels_aggregate: Curriculums_Levels_Aggregate;
  id: Scalars['uuid'];
  name: Scalars['String'];
  status: Scalars['String'];
  /** An array relationship */
  student_profiles: Array<Student_Profiles>;
  /** An aggregated array relationship */
  student_profiles_aggregate: Student_Profiles_Aggregate;
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "levels" */
export type LevelsCurriculums_LevelsArgs = {
  distinct_on?: Maybe<Array<Curriculums_Levels_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Curriculums_Levels_Order_By>>;
  where?: Maybe<Curriculums_Levels_Bool_Exp>;
};


/** columns and relationships of "levels" */
export type LevelsCurriculums_Levels_AggregateArgs = {
  distinct_on?: Maybe<Array<Curriculums_Levels_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Curriculums_Levels_Order_By>>;
  where?: Maybe<Curriculums_Levels_Bool_Exp>;
};


/** columns and relationships of "levels" */
export type LevelsStudent_ProfilesArgs = {
  distinct_on?: Maybe<Array<Student_Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Student_Profiles_Order_By>>;
  where?: Maybe<Student_Profiles_Bool_Exp>;
};


/** columns and relationships of "levels" */
export type LevelsStudent_Profiles_AggregateArgs = {
  distinct_on?: Maybe<Array<Student_Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Student_Profiles_Order_By>>;
  where?: Maybe<Student_Profiles_Bool_Exp>;
};

/** aggregated selection of "levels" */
export type Levels_Aggregate = {
  __typename?: 'levels_aggregate';
  aggregate?: Maybe<Levels_Aggregate_Fields>;
  nodes: Array<Levels>;
};

/** aggregate fields of "levels" */
export type Levels_Aggregate_Fields = {
  __typename?: 'levels_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Levels_Max_Fields>;
  min?: Maybe<Levels_Min_Fields>;
};


/** aggregate fields of "levels" */
export type Levels_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Levels_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "levels" */
export type Levels_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Levels_Max_Order_By>;
  min?: Maybe<Levels_Min_Order_By>;
};

/** input type for inserting array relation for remote table "levels" */
export type Levels_Arr_Rel_Insert_Input = {
  data: Array<Levels_Insert_Input>;
  on_conflict?: Maybe<Levels_On_Conflict>;
};

/** Boolean expression to filter rows from the table "levels". All fields are combined with a logical 'AND'. */
export type Levels_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Levels_Bool_Exp>>>;
  _not?: Maybe<Levels_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Levels_Bool_Exp>>>;
  abbreviation?: Maybe<String_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  curriculums_levels?: Maybe<Curriculums_Levels_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  student_profiles?: Maybe<Student_Profiles_Bool_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "levels" */
export enum Levels_Constraint {
  /** unique or primary key constraint */
  LevelsPkey = 'levels_pkey'
}

/** input type for inserting data into table "levels" */
export type Levels_Insert_Input = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculums_levels?: Maybe<Curriculums_Levels_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  student_profiles?: Maybe<Student_Profiles_Arr_Rel_Insert_Input>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Levels_Max_Fields = {
  __typename?: 'levels_max_fields';
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "levels" */
export type Levels_Max_Order_By = {
  abbreviation?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Levels_Min_Fields = {
  __typename?: 'levels_min_fields';
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "levels" */
export type Levels_Min_Order_By = {
  abbreviation?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "levels" */
export type Levels_Mutation_Response = {
  __typename?: 'levels_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Levels>;
};

/** input type for inserting object relation for remote table "levels" */
export type Levels_Obj_Rel_Insert_Input = {
  data: Levels_Insert_Input;
  on_conflict?: Maybe<Levels_On_Conflict>;
};

/** on conflict condition type for table "levels" */
export type Levels_On_Conflict = {
  constraint: Levels_Constraint;
  update_columns: Array<Levels_Update_Column>;
  where?: Maybe<Levels_Bool_Exp>;
};

/** ordering options when selecting data from "levels" */
export type Levels_Order_By = {
  abbreviation?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  curriculums_levels_aggregate?: Maybe<Curriculums_Levels_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  student_profiles_aggregate?: Maybe<Student_Profiles_Aggregate_Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "levels" */
export type Levels_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "levels" */
export enum Levels_Select_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "levels" */
export type Levels_Set_Input = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "levels" */
export enum Levels_Update_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  activeStudentById?: Maybe<Scalars['String']>;
  addClass?: Maybe<Scalars['String']>;
  addLesson?: Maybe<Scalars['String']>;
  addStudentToLesson?: Maybe<Scalars['String']>;
  addStudentToWaitingList?: Maybe<Scalars['String']>;
  cancelLesson?: Maybe<Scalars['String']>;
  cancelTransferClass?: Maybe<Scalars['Boolean']>;
  changeClassStatus?: Maybe<Scalars['String']>;
  changeClassroomForLesson?: Maybe<Scalars['String']>;
  changeCreditNoteStatus?: Maybe<Scalars['String']>;
  changeRefundStatus?: Maybe<Scalars['String']>;
  changeUserAttribute?: Maybe<Scalars['String']>;
  changeUserPassword?: Maybe<Scalars['String']>;
  changeUsername?: Maybe<Scalars['String']>;
  computeEnrollmentListNewByStudentId?: Maybe<Scalars['Boolean']>;
  confirmStudentForgotPassword?: Maybe<Scalars['String']>;
  confirmUser?: Maybe<Scalars['String']>;
  coverDataReceipt?: Maybe<Scalars['String']>;
  createAcademyCalendar?: Maybe<Scalars['String']>;
  createBatchPaymentAdvice?: Maybe<Scalars['String']>;
  createCreditNote?: Maybe<Scalars['String']>;
  createCurriculumAndLevels?: Maybe<Scalars['String']>;
  createInvoice?: Maybe<Scalars['String']>;
  createInvoicePartialPayment?: Maybe<Scalars['String']>;
  createPaymentAdvice?: Maybe<PaymentAdviceModel>;
  createPaymentAdvicePaper?: Maybe<PaymentAdvicePaperModel>;
  createReceipt?: Maybe<Scalars['String']>;
  createRefund?: Maybe<Scalars['String']>;
  createStudent?: Maybe<Scalars['String']>;
  createUser?: Maybe<Scalars['String']>;
  deleteBatchPaymentAdvice?: Maybe<Scalars['String']>;
  deleteCurriculumById?: Maybe<Scalars['String']>;
  deletePaymentAdvice?: Maybe<Scalars['String']>;
  deleteProgramById?: Maybe<Scalars['String']>;
  deleteStudent?: Maybe<Scalars['String']>;
  deleteStudentInWaitingList?: Maybe<Scalars['String']>;
  deleteUser?: Maybe<Scalars['String']>;
  /** delete data from the table: "academic_calendars" */
  delete_academic_calendars?: Maybe<Academic_Calendars_Mutation_Response>;
  /** delete single row from the table: "academic_calendars" */
  delete_academic_calendars_by_pk?: Maybe<Academic_Calendars>;
  /** delete data from the table: "additional_class_tickets" */
  delete_additional_class_tickets?: Maybe<Additional_Class_Tickets_Mutation_Response>;
  /** delete single row from the table: "additional_class_tickets" */
  delete_additional_class_tickets_by_pk?: Maybe<Additional_Class_Tickets>;
  /** delete data from the table: "backup_attendance_logs" */
  delete_backup_attendance_logs?: Maybe<Backup_Attendance_Logs_Mutation_Response>;
  /** delete single row from the table: "backup_attendance_logs" */
  delete_backup_attendance_logs_by_pk?: Maybe<Backup_Attendance_Logs>;
  /** delete data from the table: "banks" */
  delete_banks?: Maybe<Banks_Mutation_Response>;
  /** delete single row from the table: "banks" */
  delete_banks_by_pk?: Maybe<Banks>;
  /** delete data from the table: "batch_payment_advices" */
  delete_batch_payment_advices?: Maybe<Batch_Payment_Advices_Mutation_Response>;
  /** delete single row from the table: "batch_payment_advices" */
  delete_batch_payment_advices_by_pk?: Maybe<Batch_Payment_Advices>;
  /** delete data from the table: "branches" */
  delete_branches?: Maybe<Branches_Mutation_Response>;
  /** delete single row from the table: "branches" */
  delete_branches_by_pk?: Maybe<Branches>;
  /** delete data from the table: "broadcast_logs" */
  delete_broadcast_logs?: Maybe<Broadcast_Logs_Mutation_Response>;
  /** delete single row from the table: "broadcast_logs" */
  delete_broadcast_logs_by_pk?: Maybe<Broadcast_Logs>;
  /** delete data from the table: "broadcasts" */
  delete_broadcasts?: Maybe<Broadcasts_Mutation_Response>;
  /** delete single row from the table: "broadcasts" */
  delete_broadcasts_by_pk?: Maybe<Broadcasts>;
  /** delete data from the table: "class_students_waiting" */
  delete_class_students_waiting?: Maybe<Class_Students_Waiting_Mutation_Response>;
  /** delete single row from the table: "class_students_waiting" */
  delete_class_students_waiting_by_pk?: Maybe<Class_Students_Waiting>;
  /** delete data from the table: "classes" */
  delete_classes?: Maybe<Classes_Mutation_Response>;
  /** delete single row from the table: "classes" */
  delete_classes_by_pk?: Maybe<Classes>;
  /** delete data from the table: "classrooms" */
  delete_classrooms?: Maybe<Classrooms_Mutation_Response>;
  /** delete single row from the table: "classrooms" */
  delete_classrooms_by_pk?: Maybe<Classrooms>;
  /** delete data from the table: "credit_note_classes" */
  delete_credit_note_classes?: Maybe<Credit_Note_Classes_Mutation_Response>;
  /** delete single row from the table: "credit_note_classes" */
  delete_credit_note_classes_by_pk?: Maybe<Credit_Note_Classes>;
  /** delete data from the table: "credit_note_fees" */
  delete_credit_note_fees?: Maybe<Credit_Note_Fees_Mutation_Response>;
  /** delete single row from the table: "credit_note_fees" */
  delete_credit_note_fees_by_pk?: Maybe<Credit_Note_Fees>;
  /** delete data from the table: "credit_note_logs" */
  delete_credit_note_logs?: Maybe<Credit_Note_Logs_Mutation_Response>;
  /** delete single row from the table: "credit_note_logs" */
  delete_credit_note_logs_by_pk?: Maybe<Credit_Note_Logs>;
  /** delete data from the table: "credit_notes" */
  delete_credit_notes?: Maybe<Credit_Notes_Mutation_Response>;
  /** delete single row from the table: "credit_notes" */
  delete_credit_notes_by_pk?: Maybe<Credit_Notes>;
  /** delete data from the table: "curriculums" */
  delete_curriculums?: Maybe<Curriculums_Mutation_Response>;
  /** delete single row from the table: "curriculums" */
  delete_curriculums_by_pk?: Maybe<Curriculums>;
  /** delete data from the table: "curriculums_levels" */
  delete_curriculums_levels?: Maybe<Curriculums_Levels_Mutation_Response>;
  /** delete single row from the table: "curriculums_levels" */
  delete_curriculums_levels_by_pk?: Maybe<Curriculums_Levels>;
  /** delete data from the table: "deposits" */
  delete_deposits?: Maybe<Deposits_Mutation_Response>;
  /** delete single row from the table: "deposits" */
  delete_deposits_by_pk?: Maybe<Deposits>;
  /** delete data from the table: "discount_bills" */
  delete_discount_bills?: Maybe<Discount_Bills_Mutation_Response>;
  /** delete single row from the table: "discount_bills" */
  delete_discount_bills_by_pk?: Maybe<Discount_Bills>;
  /** delete data from the table: "discount_students" */
  delete_discount_students?: Maybe<Discount_Students_Mutation_Response>;
  /** delete single row from the table: "discount_students" */
  delete_discount_students_by_pk?: Maybe<Discount_Students>;
  /** delete data from the table: "discounts" */
  delete_discounts?: Maybe<Discounts_Mutation_Response>;
  /** delete single row from the table: "discounts" */
  delete_discounts_by_pk?: Maybe<Discounts>;
  /** delete data from the table: "double_lesson_academic_pricings" */
  delete_double_lesson_academic_pricings?: Maybe<Double_Lesson_Academic_Pricings_Mutation_Response>;
  /** delete single row from the table: "double_lesson_academic_pricings" */
  delete_double_lesson_academic_pricings_by_pk?: Maybe<Double_Lesson_Academic_Pricings>;
  /** delete data from the table: "double_lesson_program_types" */
  delete_double_lesson_program_types?: Maybe<Double_Lesson_Program_Types_Mutation_Response>;
  /** delete single row from the table: "double_lesson_program_types" */
  delete_double_lesson_program_types_by_pk?: Maybe<Double_Lesson_Program_Types>;
  /** delete data from the table: "double_lesson_programme_pricings" */
  delete_double_lesson_programme_pricings?: Maybe<Double_Lesson_Programme_Pricings_Mutation_Response>;
  /** delete single row from the table: "double_lesson_programme_pricings" */
  delete_double_lesson_programme_pricings_by_pk?: Maybe<Double_Lesson_Programme_Pricings>;
  /** delete data from the table: "email_student_logs" */
  delete_email_student_logs?: Maybe<Email_Student_Logs_Mutation_Response>;
  /** delete single row from the table: "email_student_logs" */
  delete_email_student_logs_by_pk?: Maybe<Email_Student_Logs>;
  /** delete data from the table: "enrollment_list_new" */
  delete_enrollment_list_new?: Maybe<Enrollment_List_New_Mutation_Response>;
  /** delete single row from the table: "enrollment_list_new" */
  delete_enrollment_list_new_by_pk?: Maybe<Enrollment_List_New>;
  /** delete data from the table: "general_program_types" */
  delete_general_program_types?: Maybe<General_Program_Types_Mutation_Response>;
  /** delete single row from the table: "general_program_types" */
  delete_general_program_types_by_pk?: Maybe<General_Program_Types>;
  /** delete data from the table: "get_profile" */
  delete_get_profile?: Maybe<Get_Profile_Mutation_Response>;
  /** delete data from the table: "invoice_partial_payments" */
  delete_invoice_partial_payments?: Maybe<Invoice_Partial_Payments_Mutation_Response>;
  /** delete single row from the table: "invoice_partial_payments" */
  delete_invoice_partial_payments_by_pk?: Maybe<Invoice_Partial_Payments>;
  /** delete data from the table: "invoices" */
  delete_invoices?: Maybe<Invoices_Mutation_Response>;
  /** delete single row from the table: "invoices" */
  delete_invoices_by_pk?: Maybe<Invoices>;
  /** delete data from the table: "lessons" */
  delete_lessons?: Maybe<Lessons_Mutation_Response>;
  /** delete single row from the table: "lessons" */
  delete_lessons_by_pk?: Maybe<Lessons>;
  /** delete data from the table: "lessons_students" */
  delete_lessons_students?: Maybe<Lessons_Students_Mutation_Response>;
  /** delete single row from the table: "lessons_students" */
  delete_lessons_students_by_pk?: Maybe<Lessons_Students>;
  /** delete data from the table: "levels" */
  delete_levels?: Maybe<Levels_Mutation_Response>;
  /** delete single row from the table: "levels" */
  delete_levels_by_pk?: Maybe<Levels>;
  /** delete data from the table: "news" */
  delete_news?: Maybe<News_Mutation_Response>;
  /** delete single row from the table: "news" */
  delete_news_by_pk?: Maybe<News>;
  /** delete data from the table: "news_logs" */
  delete_news_logs?: Maybe<News_Logs_Mutation_Response>;
  /** delete single row from the table: "news_logs" */
  delete_news_logs_by_pk?: Maybe<News_Logs>;
  /** delete data from the table: "news_recipients_upload" */
  delete_news_recipients_upload?: Maybe<News_Recipients_Upload_Mutation_Response>;
  /** delete single row from the table: "news_recipients_upload" */
  delete_news_recipients_upload_by_pk?: Maybe<News_Recipients_Upload>;
  /** delete data from the table: "pass_door_logs" */
  delete_pass_door_logs?: Maybe<Pass_Door_Logs_Mutation_Response>;
  /** delete single row from the table: "pass_door_logs" */
  delete_pass_door_logs_by_pk?: Maybe<Pass_Door_Logs>;
  /** delete data from the table: "payment_advice_class_transfer" */
  delete_payment_advice_class_transfer?: Maybe<Payment_Advice_Class_Transfer_Mutation_Response>;
  /** delete single row from the table: "payment_advice_class_transfer" */
  delete_payment_advice_class_transfer_by_pk?: Maybe<Payment_Advice_Class_Transfer>;
  /** delete data from the table: "payment_advice_classes" */
  delete_payment_advice_classes?: Maybe<Payment_Advice_Classes_Mutation_Response>;
  /** delete single row from the table: "payment_advice_classes" */
  delete_payment_advice_classes_by_pk?: Maybe<Payment_Advice_Classes>;
  /** delete data from the table: "payment_advice_delete_logs" */
  delete_payment_advice_delete_logs?: Maybe<Payment_Advice_Delete_Logs_Mutation_Response>;
  /** delete single row from the table: "payment_advice_delete_logs" */
  delete_payment_advice_delete_logs_by_pk?: Maybe<Payment_Advice_Delete_Logs>;
  /** delete data from the table: "payment_advice_logs" */
  delete_payment_advice_logs?: Maybe<Payment_Advice_Logs_Mutation_Response>;
  /** delete single row from the table: "payment_advice_logs" */
  delete_payment_advice_logs_by_pk?: Maybe<Payment_Advice_Logs>;
  /** delete data from the table: "payment_advice_term_classes" */
  delete_payment_advice_term_classes?: Maybe<Payment_Advice_Term_Classes_Mutation_Response>;
  /** delete single row from the table: "payment_advice_term_classes" */
  delete_payment_advice_term_classes_by_pk?: Maybe<Payment_Advice_Term_Classes>;
  /** delete data from the table: "payment_advice_transfers" */
  delete_payment_advice_transfers?: Maybe<Payment_Advice_Transfers_Mutation_Response>;
  /** delete single row from the table: "payment_advice_transfers" */
  delete_payment_advice_transfers_by_pk?: Maybe<Payment_Advice_Transfers>;
  /** delete data from the table: "payment_advices" */
  delete_payment_advices?: Maybe<Payment_Advices_Mutation_Response>;
  /** delete single row from the table: "payment_advices" */
  delete_payment_advices_by_pk?: Maybe<Payment_Advices>;
  /** delete data from the table: "programs" */
  delete_programs?: Maybe<Programs_Mutation_Response>;
  /** delete single row from the table: "programs" */
  delete_programs_by_pk?: Maybe<Programs>;
  /** delete data from the table: "receipts" */
  delete_receipts?: Maybe<Receipts_Mutation_Response>;
  /** delete single row from the table: "receipts" */
  delete_receipts_by_pk?: Maybe<Receipts>;
  /** delete data from the table: "refund_classes" */
  delete_refund_classes?: Maybe<Refund_Classes_Mutation_Response>;
  /** delete single row from the table: "refund_classes" */
  delete_refund_classes_by_pk?: Maybe<Refund_Classes>;
  /** delete data from the table: "refund_logs" */
  delete_refund_logs?: Maybe<Refund_Logs_Mutation_Response>;
  /** delete single row from the table: "refund_logs" */
  delete_refund_logs_by_pk?: Maybe<Refund_Logs>;
  /** delete data from the table: "refunds" */
  delete_refunds?: Maybe<Refunds_Mutation_Response>;
  /** delete single row from the table: "refunds" */
  delete_refunds_by_pk?: Maybe<Refunds>;
  /** delete data from the table: "regular_academic_pricings" */
  delete_regular_academic_pricings?: Maybe<Regular_Academic_Pricings_Mutation_Response>;
  /** delete single row from the table: "regular_academic_pricings" */
  delete_regular_academic_pricings_by_pk?: Maybe<Regular_Academic_Pricings>;
  /** delete data from the table: "regular_program_types" */
  delete_regular_program_types?: Maybe<Regular_Program_Types_Mutation_Response>;
  /** delete single row from the table: "regular_program_types" */
  delete_regular_program_types_by_pk?: Maybe<Regular_Program_Types>;
  /** delete data from the table: "regular_programme_pricings" */
  delete_regular_programme_pricings?: Maybe<Regular_Programme_Pricings_Mutation_Response>;
  /** delete single row from the table: "regular_programme_pricings" */
  delete_regular_programme_pricings_by_pk?: Maybe<Regular_Programme_Pricings>;
  /** delete data from the table: "report_subject_budget" */
  delete_report_subject_budget?: Maybe<Report_Subject_Budget_Mutation_Response>;
  /** delete single row from the table: "report_subject_budget" */
  delete_report_subject_budget_by_pk?: Maybe<Report_Subject_Budget>;
  /** delete data from the table: "request_transfer_classes" */
  delete_request_transfer_classes?: Maybe<Request_Transfer_Classes_Mutation_Response>;
  /** delete single row from the table: "request_transfer_classes" */
  delete_request_transfer_classes_by_pk?: Maybe<Request_Transfer_Classes>;
  /** delete data from the table: "roles" */
  delete_roles?: Maybe<Roles_Mutation_Response>;
  /** delete single row from the table: "roles" */
  delete_roles_by_pk?: Maybe<Roles>;
  /** delete data from the table: "schools" */
  delete_schools?: Maybe<Schools_Mutation_Response>;
  /** delete single row from the table: "schools" */
  delete_schools_by_pk?: Maybe<Schools>;
  /** delete data from the table: "sessions" */
  delete_sessions?: Maybe<Sessions_Mutation_Response>;
  /** delete single row from the table: "sessions" */
  delete_sessions_by_pk?: Maybe<Sessions>;
  /** delete data from the table: "special_programme_class_pricings" */
  delete_special_programme_class_pricings?: Maybe<Special_Programme_Class_Pricings_Mutation_Response>;
  /** delete single row from the table: "special_programme_class_pricings" */
  delete_special_programme_class_pricings_by_pk?: Maybe<Special_Programme_Class_Pricings>;
  /** delete data from the table: "specical_program_types" */
  delete_specical_program_types?: Maybe<Specical_Program_Types_Mutation_Response>;
  /** delete single row from the table: "specical_program_types" */
  delete_specical_program_types_by_pk?: Maybe<Specical_Program_Types>;
  /** delete data from the table: "student_profiles" */
  delete_student_profiles?: Maybe<Student_Profiles_Mutation_Response>;
  /** delete single row from the table: "student_profiles" */
  delete_student_profiles_by_pk?: Maybe<Student_Profiles>;
  /** delete data from the table: "subjects" */
  delete_subjects?: Maybe<Subjects_Mutation_Response>;
  /** delete single row from the table: "subjects" */
  delete_subjects_by_pk?: Maybe<Subjects>;
  /** delete data from the table: "system_settings" */
  delete_system_settings?: Maybe<System_Settings_Mutation_Response>;
  /** delete single row from the table: "system_settings" */
  delete_system_settings_by_pk?: Maybe<System_Settings>;
  /** delete data from the table: "term_classes" */
  delete_term_classes?: Maybe<Term_Classes_Mutation_Response>;
  /** delete single row from the table: "term_classes" */
  delete_term_classes_by_pk?: Maybe<Term_Classes>;
  /** delete data from the table: "terms" */
  delete_terms?: Maybe<Terms_Mutation_Response>;
  /** delete single row from the table: "terms" */
  delete_terms_by_pk?: Maybe<Terms>;
  /** delete data from the table: "three_times_absents" */
  delete_three_times_absents?: Maybe<Three_Times_Absents_Mutation_Response>;
  /** delete single row from the table: "three_times_absents" */
  delete_three_times_absents_by_pk?: Maybe<Three_Times_Absents>;
  /** delete data from the table: "transaction_logs" */
  delete_transaction_logs?: Maybe<Transaction_Logs_Mutation_Response>;
  /** delete single row from the table: "transaction_logs" */
  delete_transaction_logs_by_pk?: Maybe<Transaction_Logs>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** delete data from the table: "vms_person_groups" */
  delete_vms_person_groups?: Maybe<Vms_Person_Groups_Mutation_Response>;
  /** delete single row from the table: "vms_person_groups" */
  delete_vms_person_groups_by_pk?: Maybe<Vms_Person_Groups>;
  duplicateCreditNote?: Maybe<Scalars['String']>;
  extendWaitingPeriod?: Maybe<Scalars['JSON']>;
  forgotStudentPassword?: Maybe<ForgotPasswordModel>;
  generatePdfFinance?: Maybe<Scalars['String']>;
  getGantryUserRecords?: Maybe<GantryUserRecordsModel>;
  getVerificationCode?: Maybe<Scalars['String']>;
  importDataStudentsFromCsv?: Maybe<Scalars['String']>;
  /** insert data into the table: "academic_calendars" */
  insert_academic_calendars?: Maybe<Academic_Calendars_Mutation_Response>;
  /** insert a single row into the table: "academic_calendars" */
  insert_academic_calendars_one?: Maybe<Academic_Calendars>;
  /** insert data into the table: "additional_class_tickets" */
  insert_additional_class_tickets?: Maybe<Additional_Class_Tickets_Mutation_Response>;
  /** insert a single row into the table: "additional_class_tickets" */
  insert_additional_class_tickets_one?: Maybe<Additional_Class_Tickets>;
  /** insert data into the table: "backup_attendance_logs" */
  insert_backup_attendance_logs?: Maybe<Backup_Attendance_Logs_Mutation_Response>;
  /** insert a single row into the table: "backup_attendance_logs" */
  insert_backup_attendance_logs_one?: Maybe<Backup_Attendance_Logs>;
  /** insert data into the table: "banks" */
  insert_banks?: Maybe<Banks_Mutation_Response>;
  /** insert a single row into the table: "banks" */
  insert_banks_one?: Maybe<Banks>;
  /** insert data into the table: "batch_payment_advices" */
  insert_batch_payment_advices?: Maybe<Batch_Payment_Advices_Mutation_Response>;
  /** insert a single row into the table: "batch_payment_advices" */
  insert_batch_payment_advices_one?: Maybe<Batch_Payment_Advices>;
  /** insert data into the table: "branches" */
  insert_branches?: Maybe<Branches_Mutation_Response>;
  /** insert a single row into the table: "branches" */
  insert_branches_one?: Maybe<Branches>;
  /** insert data into the table: "broadcast_logs" */
  insert_broadcast_logs?: Maybe<Broadcast_Logs_Mutation_Response>;
  /** insert a single row into the table: "broadcast_logs" */
  insert_broadcast_logs_one?: Maybe<Broadcast_Logs>;
  /** insert data into the table: "broadcasts" */
  insert_broadcasts?: Maybe<Broadcasts_Mutation_Response>;
  /** insert a single row into the table: "broadcasts" */
  insert_broadcasts_one?: Maybe<Broadcasts>;
  /** insert data into the table: "class_students_waiting" */
  insert_class_students_waiting?: Maybe<Class_Students_Waiting_Mutation_Response>;
  /** insert a single row into the table: "class_students_waiting" */
  insert_class_students_waiting_one?: Maybe<Class_Students_Waiting>;
  /** insert data into the table: "classes" */
  insert_classes?: Maybe<Classes_Mutation_Response>;
  /** insert a single row into the table: "classes" */
  insert_classes_one?: Maybe<Classes>;
  /** insert data into the table: "classrooms" */
  insert_classrooms?: Maybe<Classrooms_Mutation_Response>;
  /** insert a single row into the table: "classrooms" */
  insert_classrooms_one?: Maybe<Classrooms>;
  /** insert data into the table: "credit_note_classes" */
  insert_credit_note_classes?: Maybe<Credit_Note_Classes_Mutation_Response>;
  /** insert a single row into the table: "credit_note_classes" */
  insert_credit_note_classes_one?: Maybe<Credit_Note_Classes>;
  /** insert data into the table: "credit_note_fees" */
  insert_credit_note_fees?: Maybe<Credit_Note_Fees_Mutation_Response>;
  /** insert a single row into the table: "credit_note_fees" */
  insert_credit_note_fees_one?: Maybe<Credit_Note_Fees>;
  /** insert data into the table: "credit_note_logs" */
  insert_credit_note_logs?: Maybe<Credit_Note_Logs_Mutation_Response>;
  /** insert a single row into the table: "credit_note_logs" */
  insert_credit_note_logs_one?: Maybe<Credit_Note_Logs>;
  /** insert data into the table: "credit_notes" */
  insert_credit_notes?: Maybe<Credit_Notes_Mutation_Response>;
  /** insert a single row into the table: "credit_notes" */
  insert_credit_notes_one?: Maybe<Credit_Notes>;
  /** insert data into the table: "curriculums" */
  insert_curriculums?: Maybe<Curriculums_Mutation_Response>;
  /** insert data into the table: "curriculums_levels" */
  insert_curriculums_levels?: Maybe<Curriculums_Levels_Mutation_Response>;
  /** insert a single row into the table: "curriculums_levels" */
  insert_curriculums_levels_one?: Maybe<Curriculums_Levels>;
  /** insert a single row into the table: "curriculums" */
  insert_curriculums_one?: Maybe<Curriculums>;
  /** insert data into the table: "deposits" */
  insert_deposits?: Maybe<Deposits_Mutation_Response>;
  /** insert a single row into the table: "deposits" */
  insert_deposits_one?: Maybe<Deposits>;
  /** insert data into the table: "discount_bills" */
  insert_discount_bills?: Maybe<Discount_Bills_Mutation_Response>;
  /** insert a single row into the table: "discount_bills" */
  insert_discount_bills_one?: Maybe<Discount_Bills>;
  /** insert data into the table: "discount_students" */
  insert_discount_students?: Maybe<Discount_Students_Mutation_Response>;
  /** insert a single row into the table: "discount_students" */
  insert_discount_students_one?: Maybe<Discount_Students>;
  /** insert data into the table: "discounts" */
  insert_discounts?: Maybe<Discounts_Mutation_Response>;
  /** insert a single row into the table: "discounts" */
  insert_discounts_one?: Maybe<Discounts>;
  /** insert data into the table: "double_lesson_academic_pricings" */
  insert_double_lesson_academic_pricings?: Maybe<Double_Lesson_Academic_Pricings_Mutation_Response>;
  /** insert a single row into the table: "double_lesson_academic_pricings" */
  insert_double_lesson_academic_pricings_one?: Maybe<Double_Lesson_Academic_Pricings>;
  /** insert data into the table: "double_lesson_program_types" */
  insert_double_lesson_program_types?: Maybe<Double_Lesson_Program_Types_Mutation_Response>;
  /** insert a single row into the table: "double_lesson_program_types" */
  insert_double_lesson_program_types_one?: Maybe<Double_Lesson_Program_Types>;
  /** insert data into the table: "double_lesson_programme_pricings" */
  insert_double_lesson_programme_pricings?: Maybe<Double_Lesson_Programme_Pricings_Mutation_Response>;
  /** insert a single row into the table: "double_lesson_programme_pricings" */
  insert_double_lesson_programme_pricings_one?: Maybe<Double_Lesson_Programme_Pricings>;
  /** insert data into the table: "email_student_logs" */
  insert_email_student_logs?: Maybe<Email_Student_Logs_Mutation_Response>;
  /** insert a single row into the table: "email_student_logs" */
  insert_email_student_logs_one?: Maybe<Email_Student_Logs>;
  /** insert data into the table: "enrollment_list_new" */
  insert_enrollment_list_new?: Maybe<Enrollment_List_New_Mutation_Response>;
  /** insert a single row into the table: "enrollment_list_new" */
  insert_enrollment_list_new_one?: Maybe<Enrollment_List_New>;
  /** insert data into the table: "general_program_types" */
  insert_general_program_types?: Maybe<General_Program_Types_Mutation_Response>;
  /** insert a single row into the table: "general_program_types" */
  insert_general_program_types_one?: Maybe<General_Program_Types>;
  /** insert data into the table: "get_profile" */
  insert_get_profile?: Maybe<Get_Profile_Mutation_Response>;
  /** insert a single row into the table: "get_profile" */
  insert_get_profile_one?: Maybe<Get_Profile>;
  /** insert data into the table: "invoice_partial_payments" */
  insert_invoice_partial_payments?: Maybe<Invoice_Partial_Payments_Mutation_Response>;
  /** insert a single row into the table: "invoice_partial_payments" */
  insert_invoice_partial_payments_one?: Maybe<Invoice_Partial_Payments>;
  /** insert data into the table: "invoices" */
  insert_invoices?: Maybe<Invoices_Mutation_Response>;
  /** insert a single row into the table: "invoices" */
  insert_invoices_one?: Maybe<Invoices>;
  /** insert data into the table: "lessons" */
  insert_lessons?: Maybe<Lessons_Mutation_Response>;
  /** insert a single row into the table: "lessons" */
  insert_lessons_one?: Maybe<Lessons>;
  /** insert data into the table: "lessons_students" */
  insert_lessons_students?: Maybe<Lessons_Students_Mutation_Response>;
  /** insert a single row into the table: "lessons_students" */
  insert_lessons_students_one?: Maybe<Lessons_Students>;
  /** insert data into the table: "levels" */
  insert_levels?: Maybe<Levels_Mutation_Response>;
  /** insert a single row into the table: "levels" */
  insert_levels_one?: Maybe<Levels>;
  /** insert data into the table: "news" */
  insert_news?: Maybe<News_Mutation_Response>;
  /** insert data into the table: "news_logs" */
  insert_news_logs?: Maybe<News_Logs_Mutation_Response>;
  /** insert a single row into the table: "news_logs" */
  insert_news_logs_one?: Maybe<News_Logs>;
  /** insert a single row into the table: "news" */
  insert_news_one?: Maybe<News>;
  /** insert data into the table: "news_recipients_upload" */
  insert_news_recipients_upload?: Maybe<News_Recipients_Upload_Mutation_Response>;
  /** insert a single row into the table: "news_recipients_upload" */
  insert_news_recipients_upload_one?: Maybe<News_Recipients_Upload>;
  /** insert data into the table: "pass_door_logs" */
  insert_pass_door_logs?: Maybe<Pass_Door_Logs_Mutation_Response>;
  /** insert a single row into the table: "pass_door_logs" */
  insert_pass_door_logs_one?: Maybe<Pass_Door_Logs>;
  /** insert data into the table: "payment_advice_class_transfer" */
  insert_payment_advice_class_transfer?: Maybe<Payment_Advice_Class_Transfer_Mutation_Response>;
  /** insert a single row into the table: "payment_advice_class_transfer" */
  insert_payment_advice_class_transfer_one?: Maybe<Payment_Advice_Class_Transfer>;
  /** insert data into the table: "payment_advice_classes" */
  insert_payment_advice_classes?: Maybe<Payment_Advice_Classes_Mutation_Response>;
  /** insert a single row into the table: "payment_advice_classes" */
  insert_payment_advice_classes_one?: Maybe<Payment_Advice_Classes>;
  /** insert data into the table: "payment_advice_delete_logs" */
  insert_payment_advice_delete_logs?: Maybe<Payment_Advice_Delete_Logs_Mutation_Response>;
  /** insert a single row into the table: "payment_advice_delete_logs" */
  insert_payment_advice_delete_logs_one?: Maybe<Payment_Advice_Delete_Logs>;
  /** insert data into the table: "payment_advice_logs" */
  insert_payment_advice_logs?: Maybe<Payment_Advice_Logs_Mutation_Response>;
  /** insert a single row into the table: "payment_advice_logs" */
  insert_payment_advice_logs_one?: Maybe<Payment_Advice_Logs>;
  /** insert data into the table: "payment_advice_term_classes" */
  insert_payment_advice_term_classes?: Maybe<Payment_Advice_Term_Classes_Mutation_Response>;
  /** insert a single row into the table: "payment_advice_term_classes" */
  insert_payment_advice_term_classes_one?: Maybe<Payment_Advice_Term_Classes>;
  /** insert data into the table: "payment_advice_transfers" */
  insert_payment_advice_transfers?: Maybe<Payment_Advice_Transfers_Mutation_Response>;
  /** insert a single row into the table: "payment_advice_transfers" */
  insert_payment_advice_transfers_one?: Maybe<Payment_Advice_Transfers>;
  /** insert data into the table: "payment_advices" */
  insert_payment_advices?: Maybe<Payment_Advices_Mutation_Response>;
  /** insert a single row into the table: "payment_advices" */
  insert_payment_advices_one?: Maybe<Payment_Advices>;
  /** insert data into the table: "programs" */
  insert_programs?: Maybe<Programs_Mutation_Response>;
  /** insert a single row into the table: "programs" */
  insert_programs_one?: Maybe<Programs>;
  /** insert data into the table: "receipts" */
  insert_receipts?: Maybe<Receipts_Mutation_Response>;
  /** insert a single row into the table: "receipts" */
  insert_receipts_one?: Maybe<Receipts>;
  /** insert data into the table: "refund_classes" */
  insert_refund_classes?: Maybe<Refund_Classes_Mutation_Response>;
  /** insert a single row into the table: "refund_classes" */
  insert_refund_classes_one?: Maybe<Refund_Classes>;
  /** insert data into the table: "refund_logs" */
  insert_refund_logs?: Maybe<Refund_Logs_Mutation_Response>;
  /** insert a single row into the table: "refund_logs" */
  insert_refund_logs_one?: Maybe<Refund_Logs>;
  /** insert data into the table: "refunds" */
  insert_refunds?: Maybe<Refunds_Mutation_Response>;
  /** insert a single row into the table: "refunds" */
  insert_refunds_one?: Maybe<Refunds>;
  /** insert data into the table: "regular_academic_pricings" */
  insert_regular_academic_pricings?: Maybe<Regular_Academic_Pricings_Mutation_Response>;
  /** insert a single row into the table: "regular_academic_pricings" */
  insert_regular_academic_pricings_one?: Maybe<Regular_Academic_Pricings>;
  /** insert data into the table: "regular_program_types" */
  insert_regular_program_types?: Maybe<Regular_Program_Types_Mutation_Response>;
  /** insert a single row into the table: "regular_program_types" */
  insert_regular_program_types_one?: Maybe<Regular_Program_Types>;
  /** insert data into the table: "regular_programme_pricings" */
  insert_regular_programme_pricings?: Maybe<Regular_Programme_Pricings_Mutation_Response>;
  /** insert a single row into the table: "regular_programme_pricings" */
  insert_regular_programme_pricings_one?: Maybe<Regular_Programme_Pricings>;
  /** insert data into the table: "report_subject_budget" */
  insert_report_subject_budget?: Maybe<Report_Subject_Budget_Mutation_Response>;
  /** insert a single row into the table: "report_subject_budget" */
  insert_report_subject_budget_one?: Maybe<Report_Subject_Budget>;
  /** insert data into the table: "request_transfer_classes" */
  insert_request_transfer_classes?: Maybe<Request_Transfer_Classes_Mutation_Response>;
  /** insert a single row into the table: "request_transfer_classes" */
  insert_request_transfer_classes_one?: Maybe<Request_Transfer_Classes>;
  /** insert data into the table: "roles" */
  insert_roles?: Maybe<Roles_Mutation_Response>;
  /** insert a single row into the table: "roles" */
  insert_roles_one?: Maybe<Roles>;
  /** insert data into the table: "schools" */
  insert_schools?: Maybe<Schools_Mutation_Response>;
  /** insert a single row into the table: "schools" */
  insert_schools_one?: Maybe<Schools>;
  /** insert data into the table: "sessions" */
  insert_sessions?: Maybe<Sessions_Mutation_Response>;
  /** insert a single row into the table: "sessions" */
  insert_sessions_one?: Maybe<Sessions>;
  /** insert data into the table: "special_programme_class_pricings" */
  insert_special_programme_class_pricings?: Maybe<Special_Programme_Class_Pricings_Mutation_Response>;
  /** insert a single row into the table: "special_programme_class_pricings" */
  insert_special_programme_class_pricings_one?: Maybe<Special_Programme_Class_Pricings>;
  /** insert data into the table: "specical_program_types" */
  insert_specical_program_types?: Maybe<Specical_Program_Types_Mutation_Response>;
  /** insert a single row into the table: "specical_program_types" */
  insert_specical_program_types_one?: Maybe<Specical_Program_Types>;
  /** insert data into the table: "student_profiles" */
  insert_student_profiles?: Maybe<Student_Profiles_Mutation_Response>;
  /** insert a single row into the table: "student_profiles" */
  insert_student_profiles_one?: Maybe<Student_Profiles>;
  /** insert data into the table: "subjects" */
  insert_subjects?: Maybe<Subjects_Mutation_Response>;
  /** insert a single row into the table: "subjects" */
  insert_subjects_one?: Maybe<Subjects>;
  /** insert data into the table: "system_settings" */
  insert_system_settings?: Maybe<System_Settings_Mutation_Response>;
  /** insert a single row into the table: "system_settings" */
  insert_system_settings_one?: Maybe<System_Settings>;
  /** insert data into the table: "term_classes" */
  insert_term_classes?: Maybe<Term_Classes_Mutation_Response>;
  /** insert a single row into the table: "term_classes" */
  insert_term_classes_one?: Maybe<Term_Classes>;
  /** insert data into the table: "terms" */
  insert_terms?: Maybe<Terms_Mutation_Response>;
  /** insert a single row into the table: "terms" */
  insert_terms_one?: Maybe<Terms>;
  /** insert data into the table: "three_times_absents" */
  insert_three_times_absents?: Maybe<Three_Times_Absents_Mutation_Response>;
  /** insert a single row into the table: "three_times_absents" */
  insert_three_times_absents_one?: Maybe<Three_Times_Absents>;
  /** insert data into the table: "transaction_logs" */
  insert_transaction_logs?: Maybe<Transaction_Logs_Mutation_Response>;
  /** insert a single row into the table: "transaction_logs" */
  insert_transaction_logs_one?: Maybe<Transaction_Logs>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** insert data into the table: "vms_person_groups" */
  insert_vms_person_groups?: Maybe<Vms_Person_Groups_Mutation_Response>;
  /** insert a single row into the table: "vms_person_groups" */
  insert_vms_person_groups_one?: Maybe<Vms_Person_Groups>;
  removeDataStudentsFromCsv?: Maybe<Scalars['String']>;
  removePaymentAdvices?: Maybe<Scalars['String']>;
  removeStudentFromLesson?: Maybe<Scalars['String']>;
  removeStudentsDeleted?: Maybe<Scalars['String']>;
  requestTransferClass?: Maybe<Scalars['String']>;
  resendVerificationCodeUser?: Maybe<Scalars['String']>;
  resetUserPassword?: Maybe<Scalars['String']>;
  sendMailToStudents?: Maybe<Scalars['String']>;
  /** perform the action: "sentBroadcast" */
  sentBroadcast: Scalars['uuid'];
  /** perform the action: "sentNews" */
  sentNews: Scalars['uuid'];
  setDefaultPassword?: Maybe<Scalars['String']>;
  stepFamilyInformation?: Maybe<Scalars['String']>;
  stepProgramAndClass?: Maybe<Scalars['String']>;
  stepStudentInformation?: Maybe<Scalars['String']>;
  suggestionUsername?: Maybe<Scalars['String']>;
  testRequestQRCode?: Maybe<Scalars['Boolean']>;
  transferStudent?: Maybe<Scalars['String']>;
  unlockedAccount?: Maybe<Scalars['Boolean']>;
  updateClassroom?: Maybe<Scalars['String']>;
  updateCreditNote?: Maybe<Scalars['String']>;
  updatePaymentAdvice?: Maybe<PaymentAdviceModel>;
  updatePaymentStatusStudent?: Maybe<Scalars['String']>;
  updateRefund?: Maybe<RefundModel>;
  updateSession?: Maybe<Scalars['String']>;
  updateStudent?: Maybe<Scalars['String']>;
  updateStudentToVms?: Maybe<Scalars['String']>;
  updateTransactionLog?: Maybe<Scalars['String']>;
  updateUserToVms?: Maybe<Scalars['String']>;
  /** update data of the table: "academic_calendars" */
  update_academic_calendars?: Maybe<Academic_Calendars_Mutation_Response>;
  /** update single row of the table: "academic_calendars" */
  update_academic_calendars_by_pk?: Maybe<Academic_Calendars>;
  /** update data of the table: "additional_class_tickets" */
  update_additional_class_tickets?: Maybe<Additional_Class_Tickets_Mutation_Response>;
  /** update single row of the table: "additional_class_tickets" */
  update_additional_class_tickets_by_pk?: Maybe<Additional_Class_Tickets>;
  /** update data of the table: "backup_attendance_logs" */
  update_backup_attendance_logs?: Maybe<Backup_Attendance_Logs_Mutation_Response>;
  /** update single row of the table: "backup_attendance_logs" */
  update_backup_attendance_logs_by_pk?: Maybe<Backup_Attendance_Logs>;
  /** update data of the table: "banks" */
  update_banks?: Maybe<Banks_Mutation_Response>;
  /** update single row of the table: "banks" */
  update_banks_by_pk?: Maybe<Banks>;
  /** update data of the table: "batch_payment_advices" */
  update_batch_payment_advices?: Maybe<Batch_Payment_Advices_Mutation_Response>;
  /** update single row of the table: "batch_payment_advices" */
  update_batch_payment_advices_by_pk?: Maybe<Batch_Payment_Advices>;
  /** update data of the table: "branches" */
  update_branches?: Maybe<Branches_Mutation_Response>;
  /** update single row of the table: "branches" */
  update_branches_by_pk?: Maybe<Branches>;
  /** update data of the table: "broadcast_logs" */
  update_broadcast_logs?: Maybe<Broadcast_Logs_Mutation_Response>;
  /** update single row of the table: "broadcast_logs" */
  update_broadcast_logs_by_pk?: Maybe<Broadcast_Logs>;
  /** update data of the table: "broadcasts" */
  update_broadcasts?: Maybe<Broadcasts_Mutation_Response>;
  /** update single row of the table: "broadcasts" */
  update_broadcasts_by_pk?: Maybe<Broadcasts>;
  /** update data of the table: "class_students_waiting" */
  update_class_students_waiting?: Maybe<Class_Students_Waiting_Mutation_Response>;
  /** update single row of the table: "class_students_waiting" */
  update_class_students_waiting_by_pk?: Maybe<Class_Students_Waiting>;
  /** update data of the table: "classes" */
  update_classes?: Maybe<Classes_Mutation_Response>;
  /** update single row of the table: "classes" */
  update_classes_by_pk?: Maybe<Classes>;
  /** update data of the table: "classrooms" */
  update_classrooms?: Maybe<Classrooms_Mutation_Response>;
  /** update single row of the table: "classrooms" */
  update_classrooms_by_pk?: Maybe<Classrooms>;
  /** update data of the table: "credit_note_classes" */
  update_credit_note_classes?: Maybe<Credit_Note_Classes_Mutation_Response>;
  /** update single row of the table: "credit_note_classes" */
  update_credit_note_classes_by_pk?: Maybe<Credit_Note_Classes>;
  /** update data of the table: "credit_note_fees" */
  update_credit_note_fees?: Maybe<Credit_Note_Fees_Mutation_Response>;
  /** update single row of the table: "credit_note_fees" */
  update_credit_note_fees_by_pk?: Maybe<Credit_Note_Fees>;
  /** update data of the table: "credit_note_logs" */
  update_credit_note_logs?: Maybe<Credit_Note_Logs_Mutation_Response>;
  /** update single row of the table: "credit_note_logs" */
  update_credit_note_logs_by_pk?: Maybe<Credit_Note_Logs>;
  /** update data of the table: "credit_notes" */
  update_credit_notes?: Maybe<Credit_Notes_Mutation_Response>;
  /** update single row of the table: "credit_notes" */
  update_credit_notes_by_pk?: Maybe<Credit_Notes>;
  /** update data of the table: "curriculums" */
  update_curriculums?: Maybe<Curriculums_Mutation_Response>;
  /** update single row of the table: "curriculums" */
  update_curriculums_by_pk?: Maybe<Curriculums>;
  /** update data of the table: "curriculums_levels" */
  update_curriculums_levels?: Maybe<Curriculums_Levels_Mutation_Response>;
  /** update single row of the table: "curriculums_levels" */
  update_curriculums_levels_by_pk?: Maybe<Curriculums_Levels>;
  /** update data of the table: "deposits" */
  update_deposits?: Maybe<Deposits_Mutation_Response>;
  /** update single row of the table: "deposits" */
  update_deposits_by_pk?: Maybe<Deposits>;
  /** update data of the table: "discount_bills" */
  update_discount_bills?: Maybe<Discount_Bills_Mutation_Response>;
  /** update single row of the table: "discount_bills" */
  update_discount_bills_by_pk?: Maybe<Discount_Bills>;
  /** update data of the table: "discount_students" */
  update_discount_students?: Maybe<Discount_Students_Mutation_Response>;
  /** update single row of the table: "discount_students" */
  update_discount_students_by_pk?: Maybe<Discount_Students>;
  /** update data of the table: "discounts" */
  update_discounts?: Maybe<Discounts_Mutation_Response>;
  /** update single row of the table: "discounts" */
  update_discounts_by_pk?: Maybe<Discounts>;
  /** update data of the table: "double_lesson_academic_pricings" */
  update_double_lesson_academic_pricings?: Maybe<Double_Lesson_Academic_Pricings_Mutation_Response>;
  /** update single row of the table: "double_lesson_academic_pricings" */
  update_double_lesson_academic_pricings_by_pk?: Maybe<Double_Lesson_Academic_Pricings>;
  /** update data of the table: "double_lesson_program_types" */
  update_double_lesson_program_types?: Maybe<Double_Lesson_Program_Types_Mutation_Response>;
  /** update single row of the table: "double_lesson_program_types" */
  update_double_lesson_program_types_by_pk?: Maybe<Double_Lesson_Program_Types>;
  /** update data of the table: "double_lesson_programme_pricings" */
  update_double_lesson_programme_pricings?: Maybe<Double_Lesson_Programme_Pricings_Mutation_Response>;
  /** update single row of the table: "double_lesson_programme_pricings" */
  update_double_lesson_programme_pricings_by_pk?: Maybe<Double_Lesson_Programme_Pricings>;
  /** update data of the table: "email_student_logs" */
  update_email_student_logs?: Maybe<Email_Student_Logs_Mutation_Response>;
  /** update single row of the table: "email_student_logs" */
  update_email_student_logs_by_pk?: Maybe<Email_Student_Logs>;
  /** update data of the table: "enrollment_list_new" */
  update_enrollment_list_new?: Maybe<Enrollment_List_New_Mutation_Response>;
  /** update single row of the table: "enrollment_list_new" */
  update_enrollment_list_new_by_pk?: Maybe<Enrollment_List_New>;
  /** update data of the table: "general_program_types" */
  update_general_program_types?: Maybe<General_Program_Types_Mutation_Response>;
  /** update single row of the table: "general_program_types" */
  update_general_program_types_by_pk?: Maybe<General_Program_Types>;
  /** update data of the table: "get_profile" */
  update_get_profile?: Maybe<Get_Profile_Mutation_Response>;
  /** update data of the table: "invoice_partial_payments" */
  update_invoice_partial_payments?: Maybe<Invoice_Partial_Payments_Mutation_Response>;
  /** update single row of the table: "invoice_partial_payments" */
  update_invoice_partial_payments_by_pk?: Maybe<Invoice_Partial_Payments>;
  /** update data of the table: "invoices" */
  update_invoices?: Maybe<Invoices_Mutation_Response>;
  /** update single row of the table: "invoices" */
  update_invoices_by_pk?: Maybe<Invoices>;
  /** update data of the table: "lessons" */
  update_lessons?: Maybe<Lessons_Mutation_Response>;
  /** update single row of the table: "lessons" */
  update_lessons_by_pk?: Maybe<Lessons>;
  /** update data of the table: "lessons_students" */
  update_lessons_students?: Maybe<Lessons_Students_Mutation_Response>;
  /** update single row of the table: "lessons_students" */
  update_lessons_students_by_pk?: Maybe<Lessons_Students>;
  /** update data of the table: "levels" */
  update_levels?: Maybe<Levels_Mutation_Response>;
  /** update single row of the table: "levels" */
  update_levels_by_pk?: Maybe<Levels>;
  /** update data of the table: "news" */
  update_news?: Maybe<News_Mutation_Response>;
  /** update single row of the table: "news" */
  update_news_by_pk?: Maybe<News>;
  /** update data of the table: "news_logs" */
  update_news_logs?: Maybe<News_Logs_Mutation_Response>;
  /** update single row of the table: "news_logs" */
  update_news_logs_by_pk?: Maybe<News_Logs>;
  /** update data of the table: "news_recipients_upload" */
  update_news_recipients_upload?: Maybe<News_Recipients_Upload_Mutation_Response>;
  /** update single row of the table: "news_recipients_upload" */
  update_news_recipients_upload_by_pk?: Maybe<News_Recipients_Upload>;
  /** update data of the table: "pass_door_logs" */
  update_pass_door_logs?: Maybe<Pass_Door_Logs_Mutation_Response>;
  /** update single row of the table: "pass_door_logs" */
  update_pass_door_logs_by_pk?: Maybe<Pass_Door_Logs>;
  /** update data of the table: "payment_advice_class_transfer" */
  update_payment_advice_class_transfer?: Maybe<Payment_Advice_Class_Transfer_Mutation_Response>;
  /** update single row of the table: "payment_advice_class_transfer" */
  update_payment_advice_class_transfer_by_pk?: Maybe<Payment_Advice_Class_Transfer>;
  /** update data of the table: "payment_advice_classes" */
  update_payment_advice_classes?: Maybe<Payment_Advice_Classes_Mutation_Response>;
  /** update single row of the table: "payment_advice_classes" */
  update_payment_advice_classes_by_pk?: Maybe<Payment_Advice_Classes>;
  /** update data of the table: "payment_advice_delete_logs" */
  update_payment_advice_delete_logs?: Maybe<Payment_Advice_Delete_Logs_Mutation_Response>;
  /** update single row of the table: "payment_advice_delete_logs" */
  update_payment_advice_delete_logs_by_pk?: Maybe<Payment_Advice_Delete_Logs>;
  /** update data of the table: "payment_advice_logs" */
  update_payment_advice_logs?: Maybe<Payment_Advice_Logs_Mutation_Response>;
  /** update single row of the table: "payment_advice_logs" */
  update_payment_advice_logs_by_pk?: Maybe<Payment_Advice_Logs>;
  /** update data of the table: "payment_advice_term_classes" */
  update_payment_advice_term_classes?: Maybe<Payment_Advice_Term_Classes_Mutation_Response>;
  /** update single row of the table: "payment_advice_term_classes" */
  update_payment_advice_term_classes_by_pk?: Maybe<Payment_Advice_Term_Classes>;
  /** update data of the table: "payment_advice_transfers" */
  update_payment_advice_transfers?: Maybe<Payment_Advice_Transfers_Mutation_Response>;
  /** update single row of the table: "payment_advice_transfers" */
  update_payment_advice_transfers_by_pk?: Maybe<Payment_Advice_Transfers>;
  /** update data of the table: "payment_advices" */
  update_payment_advices?: Maybe<Payment_Advices_Mutation_Response>;
  /** update single row of the table: "payment_advices" */
  update_payment_advices_by_pk?: Maybe<Payment_Advices>;
  /** update data of the table: "programs" */
  update_programs?: Maybe<Programs_Mutation_Response>;
  /** update single row of the table: "programs" */
  update_programs_by_pk?: Maybe<Programs>;
  /** update data of the table: "receipts" */
  update_receipts?: Maybe<Receipts_Mutation_Response>;
  /** update single row of the table: "receipts" */
  update_receipts_by_pk?: Maybe<Receipts>;
  /** update data of the table: "refund_classes" */
  update_refund_classes?: Maybe<Refund_Classes_Mutation_Response>;
  /** update single row of the table: "refund_classes" */
  update_refund_classes_by_pk?: Maybe<Refund_Classes>;
  /** update data of the table: "refund_logs" */
  update_refund_logs?: Maybe<Refund_Logs_Mutation_Response>;
  /** update single row of the table: "refund_logs" */
  update_refund_logs_by_pk?: Maybe<Refund_Logs>;
  /** update data of the table: "refunds" */
  update_refunds?: Maybe<Refunds_Mutation_Response>;
  /** update single row of the table: "refunds" */
  update_refunds_by_pk?: Maybe<Refunds>;
  /** update data of the table: "regular_academic_pricings" */
  update_regular_academic_pricings?: Maybe<Regular_Academic_Pricings_Mutation_Response>;
  /** update single row of the table: "regular_academic_pricings" */
  update_regular_academic_pricings_by_pk?: Maybe<Regular_Academic_Pricings>;
  /** update data of the table: "regular_program_types" */
  update_regular_program_types?: Maybe<Regular_Program_Types_Mutation_Response>;
  /** update single row of the table: "regular_program_types" */
  update_regular_program_types_by_pk?: Maybe<Regular_Program_Types>;
  /** update data of the table: "regular_programme_pricings" */
  update_regular_programme_pricings?: Maybe<Regular_Programme_Pricings_Mutation_Response>;
  /** update single row of the table: "regular_programme_pricings" */
  update_regular_programme_pricings_by_pk?: Maybe<Regular_Programme_Pricings>;
  /** update data of the table: "report_subject_budget" */
  update_report_subject_budget?: Maybe<Report_Subject_Budget_Mutation_Response>;
  /** update single row of the table: "report_subject_budget" */
  update_report_subject_budget_by_pk?: Maybe<Report_Subject_Budget>;
  /** update data of the table: "request_transfer_classes" */
  update_request_transfer_classes?: Maybe<Request_Transfer_Classes_Mutation_Response>;
  /** update single row of the table: "request_transfer_classes" */
  update_request_transfer_classes_by_pk?: Maybe<Request_Transfer_Classes>;
  /** update data of the table: "roles" */
  update_roles?: Maybe<Roles_Mutation_Response>;
  /** update single row of the table: "roles" */
  update_roles_by_pk?: Maybe<Roles>;
  /** update data of the table: "schools" */
  update_schools?: Maybe<Schools_Mutation_Response>;
  /** update single row of the table: "schools" */
  update_schools_by_pk?: Maybe<Schools>;
  /** update data of the table: "sessions" */
  update_sessions?: Maybe<Sessions_Mutation_Response>;
  /** update single row of the table: "sessions" */
  update_sessions_by_pk?: Maybe<Sessions>;
  /** update data of the table: "special_programme_class_pricings" */
  update_special_programme_class_pricings?: Maybe<Special_Programme_Class_Pricings_Mutation_Response>;
  /** update single row of the table: "special_programme_class_pricings" */
  update_special_programme_class_pricings_by_pk?: Maybe<Special_Programme_Class_Pricings>;
  /** update data of the table: "specical_program_types" */
  update_specical_program_types?: Maybe<Specical_Program_Types_Mutation_Response>;
  /** update single row of the table: "specical_program_types" */
  update_specical_program_types_by_pk?: Maybe<Specical_Program_Types>;
  /** update data of the table: "student_profiles" */
  update_student_profiles?: Maybe<Student_Profiles_Mutation_Response>;
  /** update single row of the table: "student_profiles" */
  update_student_profiles_by_pk?: Maybe<Student_Profiles>;
  /** update data of the table: "subjects" */
  update_subjects?: Maybe<Subjects_Mutation_Response>;
  /** update single row of the table: "subjects" */
  update_subjects_by_pk?: Maybe<Subjects>;
  /** update data of the table: "system_settings" */
  update_system_settings?: Maybe<System_Settings_Mutation_Response>;
  /** update single row of the table: "system_settings" */
  update_system_settings_by_pk?: Maybe<System_Settings>;
  /** update data of the table: "term_classes" */
  update_term_classes?: Maybe<Term_Classes_Mutation_Response>;
  /** update single row of the table: "term_classes" */
  update_term_classes_by_pk?: Maybe<Term_Classes>;
  /** update data of the table: "terms" */
  update_terms?: Maybe<Terms_Mutation_Response>;
  /** update single row of the table: "terms" */
  update_terms_by_pk?: Maybe<Terms>;
  /** update data of the table: "three_times_absents" */
  update_three_times_absents?: Maybe<Three_Times_Absents_Mutation_Response>;
  /** update single row of the table: "three_times_absents" */
  update_three_times_absents_by_pk?: Maybe<Three_Times_Absents>;
  /** update data of the table: "transaction_logs" */
  update_transaction_logs?: Maybe<Transaction_Logs_Mutation_Response>;
  /** update single row of the table: "transaction_logs" */
  update_transaction_logs_by_pk?: Maybe<Transaction_Logs>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update data of the table: "vms_person_groups" */
  update_vms_person_groups?: Maybe<Vms_Person_Groups_Mutation_Response>;
  /** update single row of the table: "vms_person_groups" */
  update_vms_person_groups_by_pk?: Maybe<Vms_Person_Groups>;
  validateClassesCapacity?: Maybe<Scalars['Boolean']>;
  verifyUserAttribute?: Maybe<Scalars['String']>;
  voidUnpaidPaymentAdvice?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** mutation root */
export type Mutation_RootActiveStudentByIdArgs = {
  studentId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootAddClassArgs = {
  form: FormCreateClass;
};


/** mutation root */
export type Mutation_RootAddLessonArgs = {
  classId: Scalars['String'];
  form: FormCreateLesson;
};


/** mutation root */
export type Mutation_RootAddStudentToLessonArgs = {
  form: FormAddStudentToLesson;
};


/** mutation root */
export type Mutation_RootAddStudentToWaitingListArgs = {
  classId: Scalars['String'];
  form: FormAddStudentToWaitingList;
};


/** mutation root */
export type Mutation_RootCancelLessonArgs = {
  lessonId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootCancelTransferClassArgs = {
  form?: Maybe<FormCancelTransferClass>;
};


/** mutation root */
export type Mutation_RootChangeClassStatusArgs = {
  classId: Scalars['String'];
  form: FormChangeClassStatus;
};


/** mutation root */
export type Mutation_RootChangeClassroomForLessonArgs = {
  classroomId: Scalars['String'];
  lessonId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootChangeCreditNoteStatusArgs = {
  form: FormChangeCreditNoteStatus;
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootChangeRefundStatusArgs = {
  id: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootChangeUserAttributeArgs = {
  form: ChangeUserAttributeInput;
};


/** mutation root */
export type Mutation_RootChangeUserPasswordArgs = {
  form: FormChangeUserPassword;
};


/** mutation root */
export type Mutation_RootChangeUsernameArgs = {
  form: FormChangeUsername;
};


/** mutation root */
export type Mutation_RootComputeEnrollmentListNewByStudentIdArgs = {
  studentId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootConfirmStudentForgotPasswordArgs = {
  confirmationCode: Scalars['String'];
  newPassword: Scalars['String'];
  username: Scalars['String'];
};


/** mutation root */
export type Mutation_RootConfirmUserArgs = {
  code: Scalars['String'];
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootCoverDataReceiptArgs = {
  receiptId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootCreateAcademyCalendarArgs = {
  form: FormCreateAcademyCalendar;
};


/** mutation root */
export type Mutation_RootCreateBatchPaymentAdviceArgs = {
  form?: Maybe<FormBatchPaymentAdvice>;
};


/** mutation root */
export type Mutation_RootCreateCreditNoteArgs = {
  form: FormCreateCreditNote;
};


/** mutation root */
export type Mutation_RootCreateCurriculumAndLevelsArgs = {
  form: FormCreateCurriculumAndLevels;
};


/** mutation root */
export type Mutation_RootCreateInvoiceArgs = {
  form: FormCreateInvoice;
};


/** mutation root */
export type Mutation_RootCreateInvoicePartialPaymentArgs = {
  form: FormInvoicePartialPayment;
};


/** mutation root */
export type Mutation_RootCreatePaymentAdviceArgs = {
  form: FormPaymentAdvice;
};


/** mutation root */
export type Mutation_RootCreatePaymentAdvicePaperArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootCreateReceiptArgs = {
  invoiceId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootCreateRefundArgs = {
  form: FormCreateRefund;
};


/** mutation root */
export type Mutation_RootCreateStudentArgs = {
  form: CreateStudentForm;
};


/** mutation root */
export type Mutation_RootCreateUserArgs = {
  form: CreateUserForm;
};


/** mutation root */
export type Mutation_RootDeleteBatchPaymentAdviceArgs = {
  batchPaymentAdviceId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteCurriculumByIdArgs = {
  curriculumId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeletePaymentAdviceArgs = {
  paymentAdviceIds: Array<Maybe<Scalars['String']>>;
};


/** mutation root */
export type Mutation_RootDeleteProgramByIdArgs = {
  programId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteStudentArgs = {
  studentId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteStudentInWaitingListArgs = {
  classId: Scalars['String'];
  form: FormDeleteStudentInWaitingList;
};


/** mutation root */
export type Mutation_RootDeleteUserArgs = {
  form?: Maybe<DeleteUserForm>;
};


/** mutation root */
export type Mutation_RootDelete_Academic_CalendarsArgs = {
  where: Academic_Calendars_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Academic_Calendars_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Additional_Class_TicketsArgs = {
  where: Additional_Class_Tickets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Additional_Class_Tickets_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Backup_Attendance_LogsArgs = {
  where: Backup_Attendance_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Backup_Attendance_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_BanksArgs = {
  where: Banks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Banks_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Batch_Payment_AdvicesArgs = {
  where: Batch_Payment_Advices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Batch_Payment_Advices_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_BranchesArgs = {
  where: Branches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Branches_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Broadcast_LogsArgs = {
  where: Broadcast_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Broadcast_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_BroadcastsArgs = {
  where: Broadcasts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Broadcasts_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Class_Students_WaitingArgs = {
  where: Class_Students_Waiting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Class_Students_Waiting_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ClassesArgs = {
  where: Classes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Classes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ClassroomsArgs = {
  where: Classrooms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Classrooms_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Credit_Note_ClassesArgs = {
  where: Credit_Note_Classes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Credit_Note_Classes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Credit_Note_FeesArgs = {
  where: Credit_Note_Fees_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Credit_Note_Fees_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Credit_Note_LogsArgs = {
  where: Credit_Note_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Credit_Note_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Credit_NotesArgs = {
  where: Credit_Notes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Credit_Notes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_CurriculumsArgs = {
  where: Curriculums_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Curriculums_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Curriculums_LevelsArgs = {
  where: Curriculums_Levels_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Curriculums_Levels_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_DepositsArgs = {
  where: Deposits_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Deposits_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Discount_BillsArgs = {
  where: Discount_Bills_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Discount_Bills_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Discount_StudentsArgs = {
  where: Discount_Students_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Discount_Students_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_DiscountsArgs = {
  where: Discounts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Discounts_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Double_Lesson_Academic_PricingsArgs = {
  where: Double_Lesson_Academic_Pricings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Double_Lesson_Academic_Pricings_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Double_Lesson_Program_TypesArgs = {
  where: Double_Lesson_Program_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Double_Lesson_Program_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Double_Lesson_Programme_PricingsArgs = {
  where: Double_Lesson_Programme_Pricings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Double_Lesson_Programme_Pricings_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Email_Student_LogsArgs = {
  where: Email_Student_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Email_Student_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Enrollment_List_NewArgs = {
  where: Enrollment_List_New_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enrollment_List_New_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_General_Program_TypesArgs = {
  where: General_Program_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_General_Program_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Get_ProfileArgs = {
  where: Get_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invoice_Partial_PaymentsArgs = {
  where: Invoice_Partial_Payments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invoice_Partial_Payments_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_InvoicesArgs = {
  where: Invoices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invoices_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_LessonsArgs = {
  where: Lessons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lessons_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Lessons_StudentsArgs = {
  where: Lessons_Students_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lessons_Students_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_LevelsArgs = {
  where: Levels_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Levels_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_NewsArgs = {
  where: News_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_News_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_News_LogsArgs = {
  where: News_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_News_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_News_Recipients_UploadArgs = {
  where: News_Recipients_Upload_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_News_Recipients_Upload_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Pass_Door_LogsArgs = {
  where: Pass_Door_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pass_Door_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Payment_Advice_Class_TransferArgs = {
  where: Payment_Advice_Class_Transfer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payment_Advice_Class_Transfer_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Payment_Advice_ClassesArgs = {
  where: Payment_Advice_Classes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payment_Advice_Classes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Payment_Advice_Delete_LogsArgs = {
  where: Payment_Advice_Delete_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payment_Advice_Delete_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Payment_Advice_LogsArgs = {
  where: Payment_Advice_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payment_Advice_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Payment_Advice_Term_ClassesArgs = {
  where: Payment_Advice_Term_Classes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payment_Advice_Term_Classes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Payment_Advice_TransfersArgs = {
  where: Payment_Advice_Transfers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payment_Advice_Transfers_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Payment_AdvicesArgs = {
  where: Payment_Advices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payment_Advices_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ProgramsArgs = {
  where: Programs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Programs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ReceiptsArgs = {
  where: Receipts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Receipts_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Refund_ClassesArgs = {
  where: Refund_Classes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Refund_Classes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Refund_LogsArgs = {
  where: Refund_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Refund_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_RefundsArgs = {
  where: Refunds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Refunds_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Regular_Academic_PricingsArgs = {
  where: Regular_Academic_Pricings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Regular_Academic_Pricings_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Regular_Program_TypesArgs = {
  where: Regular_Program_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Regular_Program_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Regular_Programme_PricingsArgs = {
  where: Regular_Programme_Pricings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Regular_Programme_Pricings_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Report_Subject_BudgetArgs = {
  where: Report_Subject_Budget_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Report_Subject_Budget_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Request_Transfer_ClassesArgs = {
  where: Request_Transfer_Classes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Request_Transfer_Classes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_RolesArgs = {
  where: Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Roles_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SchoolsArgs = {
  where: Schools_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Schools_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SessionsArgs = {
  where: Sessions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sessions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Special_Programme_Class_PricingsArgs = {
  where: Special_Programme_Class_Pricings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Special_Programme_Class_Pricings_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Specical_Program_TypesArgs = {
  where: Specical_Program_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Specical_Program_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Student_ProfilesArgs = {
  where: Student_Profiles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Student_Profiles_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SubjectsArgs = {
  where: Subjects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subjects_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_System_SettingsArgs = {
  where: System_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_System_Settings_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Term_ClassesArgs = {
  where: Term_Classes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Term_Classes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_TermsArgs = {
  where: Terms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Terms_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Three_Times_AbsentsArgs = {
  where: Three_Times_Absents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Three_Times_Absents_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Transaction_LogsArgs = {
  where: Transaction_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Transaction_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Vms_Person_GroupsArgs = {
  where: Vms_Person_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vms_Person_Groups_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDuplicateCreditNoteArgs = {
  creditNoteId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootExtendWaitingPeriodArgs = {
  form: FormExtendWaitingPeriod;
};


/** mutation root */
export type Mutation_RootForgotStudentPasswordArgs = {
  studentEmail: Scalars['String'];
};


/** mutation root */
export type Mutation_RootGeneratePdfFinanceArgs = {
  invoiceId: Scalars['String'];
  type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootGetGantryUserRecordsArgs = {
  form: GantryUserRecordsForm;
};


/** mutation root */
export type Mutation_RootGetVerificationCodeArgs = {
  form: GetVerificationCodeForm;
};


/** mutation root */
export type Mutation_RootImportDataStudentsFromCsvArgs = {
  studentId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootInsert_Academic_CalendarsArgs = {
  objects: Array<Academic_Calendars_Insert_Input>;
  on_conflict?: Maybe<Academic_Calendars_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Academic_Calendars_OneArgs = {
  object: Academic_Calendars_Insert_Input;
  on_conflict?: Maybe<Academic_Calendars_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Additional_Class_TicketsArgs = {
  objects: Array<Additional_Class_Tickets_Insert_Input>;
  on_conflict?: Maybe<Additional_Class_Tickets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Additional_Class_Tickets_OneArgs = {
  object: Additional_Class_Tickets_Insert_Input;
  on_conflict?: Maybe<Additional_Class_Tickets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Backup_Attendance_LogsArgs = {
  objects: Array<Backup_Attendance_Logs_Insert_Input>;
  on_conflict?: Maybe<Backup_Attendance_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Backup_Attendance_Logs_OneArgs = {
  object: Backup_Attendance_Logs_Insert_Input;
  on_conflict?: Maybe<Backup_Attendance_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BanksArgs = {
  objects: Array<Banks_Insert_Input>;
  on_conflict?: Maybe<Banks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Banks_OneArgs = {
  object: Banks_Insert_Input;
  on_conflict?: Maybe<Banks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Batch_Payment_AdvicesArgs = {
  objects: Array<Batch_Payment_Advices_Insert_Input>;
  on_conflict?: Maybe<Batch_Payment_Advices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Batch_Payment_Advices_OneArgs = {
  object: Batch_Payment_Advices_Insert_Input;
  on_conflict?: Maybe<Batch_Payment_Advices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BranchesArgs = {
  objects: Array<Branches_Insert_Input>;
  on_conflict?: Maybe<Branches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Branches_OneArgs = {
  object: Branches_Insert_Input;
  on_conflict?: Maybe<Branches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Broadcast_LogsArgs = {
  objects: Array<Broadcast_Logs_Insert_Input>;
  on_conflict?: Maybe<Broadcast_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Broadcast_Logs_OneArgs = {
  object: Broadcast_Logs_Insert_Input;
  on_conflict?: Maybe<Broadcast_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BroadcastsArgs = {
  objects: Array<Broadcasts_Insert_Input>;
  on_conflict?: Maybe<Broadcasts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Broadcasts_OneArgs = {
  object: Broadcasts_Insert_Input;
  on_conflict?: Maybe<Broadcasts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Class_Students_WaitingArgs = {
  objects: Array<Class_Students_Waiting_Insert_Input>;
  on_conflict?: Maybe<Class_Students_Waiting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Class_Students_Waiting_OneArgs = {
  object: Class_Students_Waiting_Insert_Input;
  on_conflict?: Maybe<Class_Students_Waiting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClassesArgs = {
  objects: Array<Classes_Insert_Input>;
  on_conflict?: Maybe<Classes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Classes_OneArgs = {
  object: Classes_Insert_Input;
  on_conflict?: Maybe<Classes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClassroomsArgs = {
  objects: Array<Classrooms_Insert_Input>;
  on_conflict?: Maybe<Classrooms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Classrooms_OneArgs = {
  object: Classrooms_Insert_Input;
  on_conflict?: Maybe<Classrooms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Credit_Note_ClassesArgs = {
  objects: Array<Credit_Note_Classes_Insert_Input>;
  on_conflict?: Maybe<Credit_Note_Classes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Credit_Note_Classes_OneArgs = {
  object: Credit_Note_Classes_Insert_Input;
  on_conflict?: Maybe<Credit_Note_Classes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Credit_Note_FeesArgs = {
  objects: Array<Credit_Note_Fees_Insert_Input>;
  on_conflict?: Maybe<Credit_Note_Fees_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Credit_Note_Fees_OneArgs = {
  object: Credit_Note_Fees_Insert_Input;
  on_conflict?: Maybe<Credit_Note_Fees_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Credit_Note_LogsArgs = {
  objects: Array<Credit_Note_Logs_Insert_Input>;
  on_conflict?: Maybe<Credit_Note_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Credit_Note_Logs_OneArgs = {
  object: Credit_Note_Logs_Insert_Input;
  on_conflict?: Maybe<Credit_Note_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Credit_NotesArgs = {
  objects: Array<Credit_Notes_Insert_Input>;
  on_conflict?: Maybe<Credit_Notes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Credit_Notes_OneArgs = {
  object: Credit_Notes_Insert_Input;
  on_conflict?: Maybe<Credit_Notes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CurriculumsArgs = {
  objects: Array<Curriculums_Insert_Input>;
  on_conflict?: Maybe<Curriculums_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Curriculums_LevelsArgs = {
  objects: Array<Curriculums_Levels_Insert_Input>;
  on_conflict?: Maybe<Curriculums_Levels_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Curriculums_Levels_OneArgs = {
  object: Curriculums_Levels_Insert_Input;
  on_conflict?: Maybe<Curriculums_Levels_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Curriculums_OneArgs = {
  object: Curriculums_Insert_Input;
  on_conflict?: Maybe<Curriculums_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DepositsArgs = {
  objects: Array<Deposits_Insert_Input>;
  on_conflict?: Maybe<Deposits_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Deposits_OneArgs = {
  object: Deposits_Insert_Input;
  on_conflict?: Maybe<Deposits_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Discount_BillsArgs = {
  objects: Array<Discount_Bills_Insert_Input>;
  on_conflict?: Maybe<Discount_Bills_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Discount_Bills_OneArgs = {
  object: Discount_Bills_Insert_Input;
  on_conflict?: Maybe<Discount_Bills_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Discount_StudentsArgs = {
  objects: Array<Discount_Students_Insert_Input>;
  on_conflict?: Maybe<Discount_Students_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Discount_Students_OneArgs = {
  object: Discount_Students_Insert_Input;
  on_conflict?: Maybe<Discount_Students_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DiscountsArgs = {
  objects: Array<Discounts_Insert_Input>;
  on_conflict?: Maybe<Discounts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Discounts_OneArgs = {
  object: Discounts_Insert_Input;
  on_conflict?: Maybe<Discounts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Double_Lesson_Academic_PricingsArgs = {
  objects: Array<Double_Lesson_Academic_Pricings_Insert_Input>;
  on_conflict?: Maybe<Double_Lesson_Academic_Pricings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Double_Lesson_Academic_Pricings_OneArgs = {
  object: Double_Lesson_Academic_Pricings_Insert_Input;
  on_conflict?: Maybe<Double_Lesson_Academic_Pricings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Double_Lesson_Program_TypesArgs = {
  objects: Array<Double_Lesson_Program_Types_Insert_Input>;
  on_conflict?: Maybe<Double_Lesson_Program_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Double_Lesson_Program_Types_OneArgs = {
  object: Double_Lesson_Program_Types_Insert_Input;
  on_conflict?: Maybe<Double_Lesson_Program_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Double_Lesson_Programme_PricingsArgs = {
  objects: Array<Double_Lesson_Programme_Pricings_Insert_Input>;
  on_conflict?: Maybe<Double_Lesson_Programme_Pricings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Double_Lesson_Programme_Pricings_OneArgs = {
  object: Double_Lesson_Programme_Pricings_Insert_Input;
  on_conflict?: Maybe<Double_Lesson_Programme_Pricings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Student_LogsArgs = {
  objects: Array<Email_Student_Logs_Insert_Input>;
  on_conflict?: Maybe<Email_Student_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Student_Logs_OneArgs = {
  object: Email_Student_Logs_Insert_Input;
  on_conflict?: Maybe<Email_Student_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enrollment_List_NewArgs = {
  objects: Array<Enrollment_List_New_Insert_Input>;
  on_conflict?: Maybe<Enrollment_List_New_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enrollment_List_New_OneArgs = {
  object: Enrollment_List_New_Insert_Input;
  on_conflict?: Maybe<Enrollment_List_New_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_General_Program_TypesArgs = {
  objects: Array<General_Program_Types_Insert_Input>;
  on_conflict?: Maybe<General_Program_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_General_Program_Types_OneArgs = {
  object: General_Program_Types_Insert_Input;
  on_conflict?: Maybe<General_Program_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Get_ProfileArgs = {
  objects: Array<Get_Profile_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Get_Profile_OneArgs = {
  object: Get_Profile_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Invoice_Partial_PaymentsArgs = {
  objects: Array<Invoice_Partial_Payments_Insert_Input>;
  on_conflict?: Maybe<Invoice_Partial_Payments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invoice_Partial_Payments_OneArgs = {
  object: Invoice_Partial_Payments_Insert_Input;
  on_conflict?: Maybe<Invoice_Partial_Payments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InvoicesArgs = {
  objects: Array<Invoices_Insert_Input>;
  on_conflict?: Maybe<Invoices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invoices_OneArgs = {
  object: Invoices_Insert_Input;
  on_conflict?: Maybe<Invoices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LessonsArgs = {
  objects: Array<Lessons_Insert_Input>;
  on_conflict?: Maybe<Lessons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lessons_OneArgs = {
  object: Lessons_Insert_Input;
  on_conflict?: Maybe<Lessons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lessons_StudentsArgs = {
  objects: Array<Lessons_Students_Insert_Input>;
  on_conflict?: Maybe<Lessons_Students_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lessons_Students_OneArgs = {
  object: Lessons_Students_Insert_Input;
  on_conflict?: Maybe<Lessons_Students_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LevelsArgs = {
  objects: Array<Levels_Insert_Input>;
  on_conflict?: Maybe<Levels_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Levels_OneArgs = {
  object: Levels_Insert_Input;
  on_conflict?: Maybe<Levels_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NewsArgs = {
  objects: Array<News_Insert_Input>;
  on_conflict?: Maybe<News_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_News_LogsArgs = {
  objects: Array<News_Logs_Insert_Input>;
  on_conflict?: Maybe<News_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_News_Logs_OneArgs = {
  object: News_Logs_Insert_Input;
  on_conflict?: Maybe<News_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_News_OneArgs = {
  object: News_Insert_Input;
  on_conflict?: Maybe<News_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_News_Recipients_UploadArgs = {
  objects: Array<News_Recipients_Upload_Insert_Input>;
  on_conflict?: Maybe<News_Recipients_Upload_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_News_Recipients_Upload_OneArgs = {
  object: News_Recipients_Upload_Insert_Input;
  on_conflict?: Maybe<News_Recipients_Upload_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pass_Door_LogsArgs = {
  objects: Array<Pass_Door_Logs_Insert_Input>;
  on_conflict?: Maybe<Pass_Door_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pass_Door_Logs_OneArgs = {
  object: Pass_Door_Logs_Insert_Input;
  on_conflict?: Maybe<Pass_Door_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Advice_Class_TransferArgs = {
  objects: Array<Payment_Advice_Class_Transfer_Insert_Input>;
  on_conflict?: Maybe<Payment_Advice_Class_Transfer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Advice_Class_Transfer_OneArgs = {
  object: Payment_Advice_Class_Transfer_Insert_Input;
  on_conflict?: Maybe<Payment_Advice_Class_Transfer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Advice_ClassesArgs = {
  objects: Array<Payment_Advice_Classes_Insert_Input>;
  on_conflict?: Maybe<Payment_Advice_Classes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Advice_Classes_OneArgs = {
  object: Payment_Advice_Classes_Insert_Input;
  on_conflict?: Maybe<Payment_Advice_Classes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Advice_Delete_LogsArgs = {
  objects: Array<Payment_Advice_Delete_Logs_Insert_Input>;
  on_conflict?: Maybe<Payment_Advice_Delete_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Advice_Delete_Logs_OneArgs = {
  object: Payment_Advice_Delete_Logs_Insert_Input;
  on_conflict?: Maybe<Payment_Advice_Delete_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Advice_LogsArgs = {
  objects: Array<Payment_Advice_Logs_Insert_Input>;
  on_conflict?: Maybe<Payment_Advice_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Advice_Logs_OneArgs = {
  object: Payment_Advice_Logs_Insert_Input;
  on_conflict?: Maybe<Payment_Advice_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Advice_Term_ClassesArgs = {
  objects: Array<Payment_Advice_Term_Classes_Insert_Input>;
  on_conflict?: Maybe<Payment_Advice_Term_Classes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Advice_Term_Classes_OneArgs = {
  object: Payment_Advice_Term_Classes_Insert_Input;
  on_conflict?: Maybe<Payment_Advice_Term_Classes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Advice_TransfersArgs = {
  objects: Array<Payment_Advice_Transfers_Insert_Input>;
  on_conflict?: Maybe<Payment_Advice_Transfers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Advice_Transfers_OneArgs = {
  object: Payment_Advice_Transfers_Insert_Input;
  on_conflict?: Maybe<Payment_Advice_Transfers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_AdvicesArgs = {
  objects: Array<Payment_Advices_Insert_Input>;
  on_conflict?: Maybe<Payment_Advices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Advices_OneArgs = {
  object: Payment_Advices_Insert_Input;
  on_conflict?: Maybe<Payment_Advices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProgramsArgs = {
  objects: Array<Programs_Insert_Input>;
  on_conflict?: Maybe<Programs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Programs_OneArgs = {
  object: Programs_Insert_Input;
  on_conflict?: Maybe<Programs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReceiptsArgs = {
  objects: Array<Receipts_Insert_Input>;
  on_conflict?: Maybe<Receipts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Receipts_OneArgs = {
  object: Receipts_Insert_Input;
  on_conflict?: Maybe<Receipts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Refund_ClassesArgs = {
  objects: Array<Refund_Classes_Insert_Input>;
  on_conflict?: Maybe<Refund_Classes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Refund_Classes_OneArgs = {
  object: Refund_Classes_Insert_Input;
  on_conflict?: Maybe<Refund_Classes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Refund_LogsArgs = {
  objects: Array<Refund_Logs_Insert_Input>;
  on_conflict?: Maybe<Refund_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Refund_Logs_OneArgs = {
  object: Refund_Logs_Insert_Input;
  on_conflict?: Maybe<Refund_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RefundsArgs = {
  objects: Array<Refunds_Insert_Input>;
  on_conflict?: Maybe<Refunds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Refunds_OneArgs = {
  object: Refunds_Insert_Input;
  on_conflict?: Maybe<Refunds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Regular_Academic_PricingsArgs = {
  objects: Array<Regular_Academic_Pricings_Insert_Input>;
  on_conflict?: Maybe<Regular_Academic_Pricings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Regular_Academic_Pricings_OneArgs = {
  object: Regular_Academic_Pricings_Insert_Input;
  on_conflict?: Maybe<Regular_Academic_Pricings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Regular_Program_TypesArgs = {
  objects: Array<Regular_Program_Types_Insert_Input>;
  on_conflict?: Maybe<Regular_Program_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Regular_Program_Types_OneArgs = {
  object: Regular_Program_Types_Insert_Input;
  on_conflict?: Maybe<Regular_Program_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Regular_Programme_PricingsArgs = {
  objects: Array<Regular_Programme_Pricings_Insert_Input>;
  on_conflict?: Maybe<Regular_Programme_Pricings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Regular_Programme_Pricings_OneArgs = {
  object: Regular_Programme_Pricings_Insert_Input;
  on_conflict?: Maybe<Regular_Programme_Pricings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Report_Subject_BudgetArgs = {
  objects: Array<Report_Subject_Budget_Insert_Input>;
  on_conflict?: Maybe<Report_Subject_Budget_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Report_Subject_Budget_OneArgs = {
  object: Report_Subject_Budget_Insert_Input;
  on_conflict?: Maybe<Report_Subject_Budget_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Request_Transfer_ClassesArgs = {
  objects: Array<Request_Transfer_Classes_Insert_Input>;
  on_conflict?: Maybe<Request_Transfer_Classes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Request_Transfer_Classes_OneArgs = {
  object: Request_Transfer_Classes_Insert_Input;
  on_conflict?: Maybe<Request_Transfer_Classes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RolesArgs = {
  objects: Array<Roles_Insert_Input>;
  on_conflict?: Maybe<Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Roles_OneArgs = {
  object: Roles_Insert_Input;
  on_conflict?: Maybe<Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SchoolsArgs = {
  objects: Array<Schools_Insert_Input>;
  on_conflict?: Maybe<Schools_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Schools_OneArgs = {
  object: Schools_Insert_Input;
  on_conflict?: Maybe<Schools_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SessionsArgs = {
  objects: Array<Sessions_Insert_Input>;
  on_conflict?: Maybe<Sessions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sessions_OneArgs = {
  object: Sessions_Insert_Input;
  on_conflict?: Maybe<Sessions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Special_Programme_Class_PricingsArgs = {
  objects: Array<Special_Programme_Class_Pricings_Insert_Input>;
  on_conflict?: Maybe<Special_Programme_Class_Pricings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Special_Programme_Class_Pricings_OneArgs = {
  object: Special_Programme_Class_Pricings_Insert_Input;
  on_conflict?: Maybe<Special_Programme_Class_Pricings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Specical_Program_TypesArgs = {
  objects: Array<Specical_Program_Types_Insert_Input>;
  on_conflict?: Maybe<Specical_Program_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Specical_Program_Types_OneArgs = {
  object: Specical_Program_Types_Insert_Input;
  on_conflict?: Maybe<Specical_Program_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Student_ProfilesArgs = {
  objects: Array<Student_Profiles_Insert_Input>;
  on_conflict?: Maybe<Student_Profiles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Student_Profiles_OneArgs = {
  object: Student_Profiles_Insert_Input;
  on_conflict?: Maybe<Student_Profiles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SubjectsArgs = {
  objects: Array<Subjects_Insert_Input>;
  on_conflict?: Maybe<Subjects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subjects_OneArgs = {
  object: Subjects_Insert_Input;
  on_conflict?: Maybe<Subjects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_System_SettingsArgs = {
  objects: Array<System_Settings_Insert_Input>;
  on_conflict?: Maybe<System_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_System_Settings_OneArgs = {
  object: System_Settings_Insert_Input;
  on_conflict?: Maybe<System_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Term_ClassesArgs = {
  objects: Array<Term_Classes_Insert_Input>;
  on_conflict?: Maybe<Term_Classes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Term_Classes_OneArgs = {
  object: Term_Classes_Insert_Input;
  on_conflict?: Maybe<Term_Classes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TermsArgs = {
  objects: Array<Terms_Insert_Input>;
  on_conflict?: Maybe<Terms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Terms_OneArgs = {
  object: Terms_Insert_Input;
  on_conflict?: Maybe<Terms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Three_Times_AbsentsArgs = {
  objects: Array<Three_Times_Absents_Insert_Input>;
  on_conflict?: Maybe<Three_Times_Absents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Three_Times_Absents_OneArgs = {
  object: Three_Times_Absents_Insert_Input;
  on_conflict?: Maybe<Three_Times_Absents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transaction_LogsArgs = {
  objects: Array<Transaction_Logs_Insert_Input>;
  on_conflict?: Maybe<Transaction_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transaction_Logs_OneArgs = {
  object: Transaction_Logs_Insert_Input;
  on_conflict?: Maybe<Transaction_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: Maybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: Maybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vms_Person_GroupsArgs = {
  objects: Array<Vms_Person_Groups_Insert_Input>;
  on_conflict?: Maybe<Vms_Person_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vms_Person_Groups_OneArgs = {
  object: Vms_Person_Groups_Insert_Input;
  on_conflict?: Maybe<Vms_Person_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootRemoveDataStudentsFromCsvArgs = {
  studentId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootRemovePaymentAdvicesArgs = {
  limit: Scalars['String'];
};


/** mutation root */
export type Mutation_RootRemoveStudentFromLessonArgs = {
  form: FormRemoveStudentFromLesson;
};


/** mutation root */
export type Mutation_RootRemoveStudentsDeletedArgs = {
  limit: Scalars['String'];
};


/** mutation root */
export type Mutation_RootRequestTransferClassArgs = {
  form?: Maybe<FormRequestTransferClass>;
};


/** mutation root */
export type Mutation_RootResendVerificationCodeUserArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootResetUserPasswordArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootSendMailToStudentsArgs = {
  form: FormSendMailToStudents;
};


/** mutation root */
export type Mutation_RootSentBroadcastArgs = {
  form: Input;
};


/** mutation root */
export type Mutation_RootSentNewsArgs = {
  form: NewsInput;
};


/** mutation root */
export type Mutation_RootSetDefaultPasswordArgs = {
  username: Scalars['String'];
};


/** mutation root */
export type Mutation_RootStepFamilyInformationArgs = {
  form: FormFamilyInformation;
  studentId?: Maybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootStepProgramAndClassArgs = {
  form: FormProgramAndClass;
  studentId?: Maybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootStepStudentInformationArgs = {
  form: FormStudentInformation;
  studentId?: Maybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootSuggestionUsernameArgs = {
  form: SuggestionForm;
};


/** mutation root */
export type Mutation_RootTestRequestQrCodeArgs = {
  user: Scalars['String'];
};


/** mutation root */
export type Mutation_RootTransferStudentArgs = {
  form?: Maybe<FormTransferStudent>;
};


/** mutation root */
export type Mutation_RootUnlockedAccountArgs = {
  userId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootUpdateClassroomArgs = {
  classroomId: Scalars['String'];
  form: FormCreateClassroom;
};


/** mutation root */
export type Mutation_RootUpdateCreditNoteArgs = {
  form: FormUpdateCreditNote;
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootUpdatePaymentAdviceArgs = {
  form: FormPaymentAdvice;
  id: Scalars['String'];
  saveForm: Scalars['Boolean'];
};


/** mutation root */
export type Mutation_RootUpdatePaymentStatusStudentArgs = {
  username: Scalars['String'];
};


/** mutation root */
export type Mutation_RootUpdateRefundArgs = {
  form: FormRefund;
  id: Scalars['String'];
  saveForm: Scalars['Boolean'];
};


/** mutation root */
export type Mutation_RootUpdateSessionArgs = {
  form: FormUpdateSession;
  sessionId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootUpdateStudentArgs = {
  form: UpdateStudentForm;
  studentId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootUpdateStudentToVmsArgs = {
  studentId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootUpdateTransactionLogArgs = {
  transaction: Scalars['String'];
};


/** mutation root */
export type Mutation_RootUpdateUserToVmsArgs = {
  userId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootUpdate_Academic_CalendarsArgs = {
  _append?: Maybe<Academic_Calendars_Append_Input>;
  _delete_at_path?: Maybe<Academic_Calendars_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Academic_Calendars_Delete_Elem_Input>;
  _delete_key?: Maybe<Academic_Calendars_Delete_Key_Input>;
  _prepend?: Maybe<Academic_Calendars_Prepend_Input>;
  _set?: Maybe<Academic_Calendars_Set_Input>;
  where: Academic_Calendars_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Academic_Calendars_By_PkArgs = {
  _append?: Maybe<Academic_Calendars_Append_Input>;
  _delete_at_path?: Maybe<Academic_Calendars_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Academic_Calendars_Delete_Elem_Input>;
  _delete_key?: Maybe<Academic_Calendars_Delete_Key_Input>;
  _prepend?: Maybe<Academic_Calendars_Prepend_Input>;
  _set?: Maybe<Academic_Calendars_Set_Input>;
  pk_columns: Academic_Calendars_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Additional_Class_TicketsArgs = {
  _inc?: Maybe<Additional_Class_Tickets_Inc_Input>;
  _set?: Maybe<Additional_Class_Tickets_Set_Input>;
  where: Additional_Class_Tickets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Additional_Class_Tickets_By_PkArgs = {
  _inc?: Maybe<Additional_Class_Tickets_Inc_Input>;
  _set?: Maybe<Additional_Class_Tickets_Set_Input>;
  pk_columns: Additional_Class_Tickets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Backup_Attendance_LogsArgs = {
  _set?: Maybe<Backup_Attendance_Logs_Set_Input>;
  where: Backup_Attendance_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Backup_Attendance_Logs_By_PkArgs = {
  _set?: Maybe<Backup_Attendance_Logs_Set_Input>;
  pk_columns: Backup_Attendance_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_BanksArgs = {
  _set?: Maybe<Banks_Set_Input>;
  where: Banks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Banks_By_PkArgs = {
  _set?: Maybe<Banks_Set_Input>;
  pk_columns: Banks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Batch_Payment_AdvicesArgs = {
  _append?: Maybe<Batch_Payment_Advices_Append_Input>;
  _delete_at_path?: Maybe<Batch_Payment_Advices_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Batch_Payment_Advices_Delete_Elem_Input>;
  _delete_key?: Maybe<Batch_Payment_Advices_Delete_Key_Input>;
  _inc?: Maybe<Batch_Payment_Advices_Inc_Input>;
  _prepend?: Maybe<Batch_Payment_Advices_Prepend_Input>;
  _set?: Maybe<Batch_Payment_Advices_Set_Input>;
  where: Batch_Payment_Advices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Batch_Payment_Advices_By_PkArgs = {
  _append?: Maybe<Batch_Payment_Advices_Append_Input>;
  _delete_at_path?: Maybe<Batch_Payment_Advices_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Batch_Payment_Advices_Delete_Elem_Input>;
  _delete_key?: Maybe<Batch_Payment_Advices_Delete_Key_Input>;
  _inc?: Maybe<Batch_Payment_Advices_Inc_Input>;
  _prepend?: Maybe<Batch_Payment_Advices_Prepend_Input>;
  _set?: Maybe<Batch_Payment_Advices_Set_Input>;
  pk_columns: Batch_Payment_Advices_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_BranchesArgs = {
  _set?: Maybe<Branches_Set_Input>;
  where: Branches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Branches_By_PkArgs = {
  _set?: Maybe<Branches_Set_Input>;
  pk_columns: Branches_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Broadcast_LogsArgs = {
  _append?: Maybe<Broadcast_Logs_Append_Input>;
  _delete_at_path?: Maybe<Broadcast_Logs_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Broadcast_Logs_Delete_Elem_Input>;
  _delete_key?: Maybe<Broadcast_Logs_Delete_Key_Input>;
  _prepend?: Maybe<Broadcast_Logs_Prepend_Input>;
  _set?: Maybe<Broadcast_Logs_Set_Input>;
  where: Broadcast_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Broadcast_Logs_By_PkArgs = {
  _append?: Maybe<Broadcast_Logs_Append_Input>;
  _delete_at_path?: Maybe<Broadcast_Logs_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Broadcast_Logs_Delete_Elem_Input>;
  _delete_key?: Maybe<Broadcast_Logs_Delete_Key_Input>;
  _prepend?: Maybe<Broadcast_Logs_Prepend_Input>;
  _set?: Maybe<Broadcast_Logs_Set_Input>;
  pk_columns: Broadcast_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_BroadcastsArgs = {
  _append?: Maybe<Broadcasts_Append_Input>;
  _delete_at_path?: Maybe<Broadcasts_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Broadcasts_Delete_Elem_Input>;
  _delete_key?: Maybe<Broadcasts_Delete_Key_Input>;
  _prepend?: Maybe<Broadcasts_Prepend_Input>;
  _set?: Maybe<Broadcasts_Set_Input>;
  where: Broadcasts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Broadcasts_By_PkArgs = {
  _append?: Maybe<Broadcasts_Append_Input>;
  _delete_at_path?: Maybe<Broadcasts_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Broadcasts_Delete_Elem_Input>;
  _delete_key?: Maybe<Broadcasts_Delete_Key_Input>;
  _prepend?: Maybe<Broadcasts_Prepend_Input>;
  _set?: Maybe<Broadcasts_Set_Input>;
  pk_columns: Broadcasts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Students_WaitingArgs = {
  _set?: Maybe<Class_Students_Waiting_Set_Input>;
  where: Class_Students_Waiting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Students_Waiting_By_PkArgs = {
  _set?: Maybe<Class_Students_Waiting_Set_Input>;
  pk_columns: Class_Students_Waiting_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ClassesArgs = {
  _inc?: Maybe<Classes_Inc_Input>;
  _set?: Maybe<Classes_Set_Input>;
  where: Classes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Classes_By_PkArgs = {
  _inc?: Maybe<Classes_Inc_Input>;
  _set?: Maybe<Classes_Set_Input>;
  pk_columns: Classes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ClassroomsArgs = {
  _inc?: Maybe<Classrooms_Inc_Input>;
  _set?: Maybe<Classrooms_Set_Input>;
  where: Classrooms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Classrooms_By_PkArgs = {
  _inc?: Maybe<Classrooms_Inc_Input>;
  _set?: Maybe<Classrooms_Set_Input>;
  pk_columns: Classrooms_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_Note_ClassesArgs = {
  _append?: Maybe<Credit_Note_Classes_Append_Input>;
  _delete_at_path?: Maybe<Credit_Note_Classes_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Credit_Note_Classes_Delete_Elem_Input>;
  _delete_key?: Maybe<Credit_Note_Classes_Delete_Key_Input>;
  _prepend?: Maybe<Credit_Note_Classes_Prepend_Input>;
  _set?: Maybe<Credit_Note_Classes_Set_Input>;
  where: Credit_Note_Classes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_Note_Classes_By_PkArgs = {
  _append?: Maybe<Credit_Note_Classes_Append_Input>;
  _delete_at_path?: Maybe<Credit_Note_Classes_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Credit_Note_Classes_Delete_Elem_Input>;
  _delete_key?: Maybe<Credit_Note_Classes_Delete_Key_Input>;
  _prepend?: Maybe<Credit_Note_Classes_Prepend_Input>;
  _set?: Maybe<Credit_Note_Classes_Set_Input>;
  pk_columns: Credit_Note_Classes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_Note_FeesArgs = {
  _inc?: Maybe<Credit_Note_Fees_Inc_Input>;
  _set?: Maybe<Credit_Note_Fees_Set_Input>;
  where: Credit_Note_Fees_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_Note_Fees_By_PkArgs = {
  _inc?: Maybe<Credit_Note_Fees_Inc_Input>;
  _set?: Maybe<Credit_Note_Fees_Set_Input>;
  pk_columns: Credit_Note_Fees_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_Note_LogsArgs = {
  _append?: Maybe<Credit_Note_Logs_Append_Input>;
  _delete_at_path?: Maybe<Credit_Note_Logs_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Credit_Note_Logs_Delete_Elem_Input>;
  _delete_key?: Maybe<Credit_Note_Logs_Delete_Key_Input>;
  _prepend?: Maybe<Credit_Note_Logs_Prepend_Input>;
  _set?: Maybe<Credit_Note_Logs_Set_Input>;
  where: Credit_Note_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_Note_Logs_By_PkArgs = {
  _append?: Maybe<Credit_Note_Logs_Append_Input>;
  _delete_at_path?: Maybe<Credit_Note_Logs_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Credit_Note_Logs_Delete_Elem_Input>;
  _delete_key?: Maybe<Credit_Note_Logs_Delete_Key_Input>;
  _prepend?: Maybe<Credit_Note_Logs_Prepend_Input>;
  _set?: Maybe<Credit_Note_Logs_Set_Input>;
  pk_columns: Credit_Note_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_NotesArgs = {
  _append?: Maybe<Credit_Notes_Append_Input>;
  _delete_at_path?: Maybe<Credit_Notes_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Credit_Notes_Delete_Elem_Input>;
  _delete_key?: Maybe<Credit_Notes_Delete_Key_Input>;
  _prepend?: Maybe<Credit_Notes_Prepend_Input>;
  _set?: Maybe<Credit_Notes_Set_Input>;
  where: Credit_Notes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_Notes_By_PkArgs = {
  _append?: Maybe<Credit_Notes_Append_Input>;
  _delete_at_path?: Maybe<Credit_Notes_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Credit_Notes_Delete_Elem_Input>;
  _delete_key?: Maybe<Credit_Notes_Delete_Key_Input>;
  _prepend?: Maybe<Credit_Notes_Prepend_Input>;
  _set?: Maybe<Credit_Notes_Set_Input>;
  pk_columns: Credit_Notes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CurriculumsArgs = {
  _set?: Maybe<Curriculums_Set_Input>;
  where: Curriculums_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Curriculums_By_PkArgs = {
  _set?: Maybe<Curriculums_Set_Input>;
  pk_columns: Curriculums_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Curriculums_LevelsArgs = {
  _set?: Maybe<Curriculums_Levels_Set_Input>;
  where: Curriculums_Levels_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Curriculums_Levels_By_PkArgs = {
  _set?: Maybe<Curriculums_Levels_Set_Input>;
  pk_columns: Curriculums_Levels_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_DepositsArgs = {
  _inc?: Maybe<Deposits_Inc_Input>;
  _set?: Maybe<Deposits_Set_Input>;
  where: Deposits_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Deposits_By_PkArgs = {
  _inc?: Maybe<Deposits_Inc_Input>;
  _set?: Maybe<Deposits_Set_Input>;
  pk_columns: Deposits_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Discount_BillsArgs = {
  _inc?: Maybe<Discount_Bills_Inc_Input>;
  _set?: Maybe<Discount_Bills_Set_Input>;
  where: Discount_Bills_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Discount_Bills_By_PkArgs = {
  _inc?: Maybe<Discount_Bills_Inc_Input>;
  _set?: Maybe<Discount_Bills_Set_Input>;
  pk_columns: Discount_Bills_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Discount_StudentsArgs = {
  _set?: Maybe<Discount_Students_Set_Input>;
  where: Discount_Students_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Discount_Students_By_PkArgs = {
  _set?: Maybe<Discount_Students_Set_Input>;
  pk_columns: Discount_Students_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_DiscountsArgs = {
  _append?: Maybe<Discounts_Append_Input>;
  _delete_at_path?: Maybe<Discounts_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Discounts_Delete_Elem_Input>;
  _delete_key?: Maybe<Discounts_Delete_Key_Input>;
  _inc?: Maybe<Discounts_Inc_Input>;
  _prepend?: Maybe<Discounts_Prepend_Input>;
  _set?: Maybe<Discounts_Set_Input>;
  where: Discounts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Discounts_By_PkArgs = {
  _append?: Maybe<Discounts_Append_Input>;
  _delete_at_path?: Maybe<Discounts_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Discounts_Delete_Elem_Input>;
  _delete_key?: Maybe<Discounts_Delete_Key_Input>;
  _inc?: Maybe<Discounts_Inc_Input>;
  _prepend?: Maybe<Discounts_Prepend_Input>;
  _set?: Maybe<Discounts_Set_Input>;
  pk_columns: Discounts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Double_Lesson_Academic_PricingsArgs = {
  _inc?: Maybe<Double_Lesson_Academic_Pricings_Inc_Input>;
  _set?: Maybe<Double_Lesson_Academic_Pricings_Set_Input>;
  where: Double_Lesson_Academic_Pricings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Double_Lesson_Academic_Pricings_By_PkArgs = {
  _inc?: Maybe<Double_Lesson_Academic_Pricings_Inc_Input>;
  _set?: Maybe<Double_Lesson_Academic_Pricings_Set_Input>;
  pk_columns: Double_Lesson_Academic_Pricings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Double_Lesson_Program_TypesArgs = {
  _set?: Maybe<Double_Lesson_Program_Types_Set_Input>;
  where: Double_Lesson_Program_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Double_Lesson_Program_Types_By_PkArgs = {
  _set?: Maybe<Double_Lesson_Program_Types_Set_Input>;
  pk_columns: Double_Lesson_Program_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Double_Lesson_Programme_PricingsArgs = {
  _inc?: Maybe<Double_Lesson_Programme_Pricings_Inc_Input>;
  _set?: Maybe<Double_Lesson_Programme_Pricings_Set_Input>;
  where: Double_Lesson_Programme_Pricings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Double_Lesson_Programme_Pricings_By_PkArgs = {
  _inc?: Maybe<Double_Lesson_Programme_Pricings_Inc_Input>;
  _set?: Maybe<Double_Lesson_Programme_Pricings_Set_Input>;
  pk_columns: Double_Lesson_Programme_Pricings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Student_LogsArgs = {
  _append?: Maybe<Email_Student_Logs_Append_Input>;
  _delete_at_path?: Maybe<Email_Student_Logs_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Email_Student_Logs_Delete_Elem_Input>;
  _delete_key?: Maybe<Email_Student_Logs_Delete_Key_Input>;
  _prepend?: Maybe<Email_Student_Logs_Prepend_Input>;
  _set?: Maybe<Email_Student_Logs_Set_Input>;
  where: Email_Student_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Student_Logs_By_PkArgs = {
  _append?: Maybe<Email_Student_Logs_Append_Input>;
  _delete_at_path?: Maybe<Email_Student_Logs_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Email_Student_Logs_Delete_Elem_Input>;
  _delete_key?: Maybe<Email_Student_Logs_Delete_Key_Input>;
  _prepend?: Maybe<Email_Student_Logs_Prepend_Input>;
  _set?: Maybe<Email_Student_Logs_Set_Input>;
  pk_columns: Email_Student_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enrollment_List_NewArgs = {
  _append?: Maybe<Enrollment_List_New_Append_Input>;
  _delete_at_path?: Maybe<Enrollment_List_New_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Enrollment_List_New_Delete_Elem_Input>;
  _delete_key?: Maybe<Enrollment_List_New_Delete_Key_Input>;
  _prepend?: Maybe<Enrollment_List_New_Prepend_Input>;
  _set?: Maybe<Enrollment_List_New_Set_Input>;
  where: Enrollment_List_New_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enrollment_List_New_By_PkArgs = {
  _append?: Maybe<Enrollment_List_New_Append_Input>;
  _delete_at_path?: Maybe<Enrollment_List_New_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Enrollment_List_New_Delete_Elem_Input>;
  _delete_key?: Maybe<Enrollment_List_New_Delete_Key_Input>;
  _prepend?: Maybe<Enrollment_List_New_Prepend_Input>;
  _set?: Maybe<Enrollment_List_New_Set_Input>;
  pk_columns: Enrollment_List_New_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_General_Program_TypesArgs = {
  _set?: Maybe<General_Program_Types_Set_Input>;
  where: General_Program_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_General_Program_Types_By_PkArgs = {
  _set?: Maybe<General_Program_Types_Set_Input>;
  pk_columns: General_Program_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Get_ProfileArgs = {
  _append?: Maybe<Get_Profile_Append_Input>;
  _delete_at_path?: Maybe<Get_Profile_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Get_Profile_Delete_Elem_Input>;
  _delete_key?: Maybe<Get_Profile_Delete_Key_Input>;
  _prepend?: Maybe<Get_Profile_Prepend_Input>;
  _set?: Maybe<Get_Profile_Set_Input>;
  where: Get_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_Partial_PaymentsArgs = {
  _inc?: Maybe<Invoice_Partial_Payments_Inc_Input>;
  _set?: Maybe<Invoice_Partial_Payments_Set_Input>;
  where: Invoice_Partial_Payments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_Partial_Payments_By_PkArgs = {
  _inc?: Maybe<Invoice_Partial_Payments_Inc_Input>;
  _set?: Maybe<Invoice_Partial_Payments_Set_Input>;
  pk_columns: Invoice_Partial_Payments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_InvoicesArgs = {
  _append?: Maybe<Invoices_Append_Input>;
  _delete_at_path?: Maybe<Invoices_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Invoices_Delete_Elem_Input>;
  _delete_key?: Maybe<Invoices_Delete_Key_Input>;
  _inc?: Maybe<Invoices_Inc_Input>;
  _prepend?: Maybe<Invoices_Prepend_Input>;
  _set?: Maybe<Invoices_Set_Input>;
  where: Invoices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invoices_By_PkArgs = {
  _append?: Maybe<Invoices_Append_Input>;
  _delete_at_path?: Maybe<Invoices_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Invoices_Delete_Elem_Input>;
  _delete_key?: Maybe<Invoices_Delete_Key_Input>;
  _inc?: Maybe<Invoices_Inc_Input>;
  _prepend?: Maybe<Invoices_Prepend_Input>;
  _set?: Maybe<Invoices_Set_Input>;
  pk_columns: Invoices_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_LessonsArgs = {
  _inc?: Maybe<Lessons_Inc_Input>;
  _set?: Maybe<Lessons_Set_Input>;
  where: Lessons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lessons_By_PkArgs = {
  _inc?: Maybe<Lessons_Inc_Input>;
  _set?: Maybe<Lessons_Set_Input>;
  pk_columns: Lessons_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lessons_StudentsArgs = {
  _set?: Maybe<Lessons_Students_Set_Input>;
  where: Lessons_Students_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lessons_Students_By_PkArgs = {
  _set?: Maybe<Lessons_Students_Set_Input>;
  pk_columns: Lessons_Students_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_LevelsArgs = {
  _set?: Maybe<Levels_Set_Input>;
  where: Levels_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Levels_By_PkArgs = {
  _set?: Maybe<Levels_Set_Input>;
  pk_columns: Levels_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_NewsArgs = {
  _append?: Maybe<News_Append_Input>;
  _delete_at_path?: Maybe<News_Delete_At_Path_Input>;
  _delete_elem?: Maybe<News_Delete_Elem_Input>;
  _delete_key?: Maybe<News_Delete_Key_Input>;
  _prepend?: Maybe<News_Prepend_Input>;
  _set?: Maybe<News_Set_Input>;
  where: News_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_News_By_PkArgs = {
  _append?: Maybe<News_Append_Input>;
  _delete_at_path?: Maybe<News_Delete_At_Path_Input>;
  _delete_elem?: Maybe<News_Delete_Elem_Input>;
  _delete_key?: Maybe<News_Delete_Key_Input>;
  _prepend?: Maybe<News_Prepend_Input>;
  _set?: Maybe<News_Set_Input>;
  pk_columns: News_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_News_LogsArgs = {
  _append?: Maybe<News_Logs_Append_Input>;
  _delete_at_path?: Maybe<News_Logs_Delete_At_Path_Input>;
  _delete_elem?: Maybe<News_Logs_Delete_Elem_Input>;
  _delete_key?: Maybe<News_Logs_Delete_Key_Input>;
  _prepend?: Maybe<News_Logs_Prepend_Input>;
  _set?: Maybe<News_Logs_Set_Input>;
  where: News_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_News_Logs_By_PkArgs = {
  _append?: Maybe<News_Logs_Append_Input>;
  _delete_at_path?: Maybe<News_Logs_Delete_At_Path_Input>;
  _delete_elem?: Maybe<News_Logs_Delete_Elem_Input>;
  _delete_key?: Maybe<News_Logs_Delete_Key_Input>;
  _prepend?: Maybe<News_Logs_Prepend_Input>;
  _set?: Maybe<News_Logs_Set_Input>;
  pk_columns: News_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_News_Recipients_UploadArgs = {
  _set?: Maybe<News_Recipients_Upload_Set_Input>;
  where: News_Recipients_Upload_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_News_Recipients_Upload_By_PkArgs = {
  _set?: Maybe<News_Recipients_Upload_Set_Input>;
  pk_columns: News_Recipients_Upload_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pass_Door_LogsArgs = {
  _append?: Maybe<Pass_Door_Logs_Append_Input>;
  _delete_at_path?: Maybe<Pass_Door_Logs_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Pass_Door_Logs_Delete_Elem_Input>;
  _delete_key?: Maybe<Pass_Door_Logs_Delete_Key_Input>;
  _prepend?: Maybe<Pass_Door_Logs_Prepend_Input>;
  _set?: Maybe<Pass_Door_Logs_Set_Input>;
  where: Pass_Door_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pass_Door_Logs_By_PkArgs = {
  _append?: Maybe<Pass_Door_Logs_Append_Input>;
  _delete_at_path?: Maybe<Pass_Door_Logs_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Pass_Door_Logs_Delete_Elem_Input>;
  _delete_key?: Maybe<Pass_Door_Logs_Delete_Key_Input>;
  _prepend?: Maybe<Pass_Door_Logs_Prepend_Input>;
  _set?: Maybe<Pass_Door_Logs_Set_Input>;
  pk_columns: Pass_Door_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Advice_Class_TransferArgs = {
  _set?: Maybe<Payment_Advice_Class_Transfer_Set_Input>;
  where: Payment_Advice_Class_Transfer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Advice_Class_Transfer_By_PkArgs = {
  _set?: Maybe<Payment_Advice_Class_Transfer_Set_Input>;
  pk_columns: Payment_Advice_Class_Transfer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Advice_ClassesArgs = {
  _append?: Maybe<Payment_Advice_Classes_Append_Input>;
  _delete_at_path?: Maybe<Payment_Advice_Classes_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Payment_Advice_Classes_Delete_Elem_Input>;
  _delete_key?: Maybe<Payment_Advice_Classes_Delete_Key_Input>;
  _inc?: Maybe<Payment_Advice_Classes_Inc_Input>;
  _prepend?: Maybe<Payment_Advice_Classes_Prepend_Input>;
  _set?: Maybe<Payment_Advice_Classes_Set_Input>;
  where: Payment_Advice_Classes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Advice_Classes_By_PkArgs = {
  _append?: Maybe<Payment_Advice_Classes_Append_Input>;
  _delete_at_path?: Maybe<Payment_Advice_Classes_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Payment_Advice_Classes_Delete_Elem_Input>;
  _delete_key?: Maybe<Payment_Advice_Classes_Delete_Key_Input>;
  _inc?: Maybe<Payment_Advice_Classes_Inc_Input>;
  _prepend?: Maybe<Payment_Advice_Classes_Prepend_Input>;
  _set?: Maybe<Payment_Advice_Classes_Set_Input>;
  pk_columns: Payment_Advice_Classes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Advice_Delete_LogsArgs = {
  _set?: Maybe<Payment_Advice_Delete_Logs_Set_Input>;
  where: Payment_Advice_Delete_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Advice_Delete_Logs_By_PkArgs = {
  _set?: Maybe<Payment_Advice_Delete_Logs_Set_Input>;
  pk_columns: Payment_Advice_Delete_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Advice_LogsArgs = {
  _append?: Maybe<Payment_Advice_Logs_Append_Input>;
  _delete_at_path?: Maybe<Payment_Advice_Logs_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Payment_Advice_Logs_Delete_Elem_Input>;
  _delete_key?: Maybe<Payment_Advice_Logs_Delete_Key_Input>;
  _prepend?: Maybe<Payment_Advice_Logs_Prepend_Input>;
  _set?: Maybe<Payment_Advice_Logs_Set_Input>;
  where: Payment_Advice_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Advice_Logs_By_PkArgs = {
  _append?: Maybe<Payment_Advice_Logs_Append_Input>;
  _delete_at_path?: Maybe<Payment_Advice_Logs_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Payment_Advice_Logs_Delete_Elem_Input>;
  _delete_key?: Maybe<Payment_Advice_Logs_Delete_Key_Input>;
  _prepend?: Maybe<Payment_Advice_Logs_Prepend_Input>;
  _set?: Maybe<Payment_Advice_Logs_Set_Input>;
  pk_columns: Payment_Advice_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Advice_Term_ClassesArgs = {
  _append?: Maybe<Payment_Advice_Term_Classes_Append_Input>;
  _delete_at_path?: Maybe<Payment_Advice_Term_Classes_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Payment_Advice_Term_Classes_Delete_Elem_Input>;
  _delete_key?: Maybe<Payment_Advice_Term_Classes_Delete_Key_Input>;
  _inc?: Maybe<Payment_Advice_Term_Classes_Inc_Input>;
  _prepend?: Maybe<Payment_Advice_Term_Classes_Prepend_Input>;
  _set?: Maybe<Payment_Advice_Term_Classes_Set_Input>;
  where: Payment_Advice_Term_Classes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Advice_Term_Classes_By_PkArgs = {
  _append?: Maybe<Payment_Advice_Term_Classes_Append_Input>;
  _delete_at_path?: Maybe<Payment_Advice_Term_Classes_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Payment_Advice_Term_Classes_Delete_Elem_Input>;
  _delete_key?: Maybe<Payment_Advice_Term_Classes_Delete_Key_Input>;
  _inc?: Maybe<Payment_Advice_Term_Classes_Inc_Input>;
  _prepend?: Maybe<Payment_Advice_Term_Classes_Prepend_Input>;
  _set?: Maybe<Payment_Advice_Term_Classes_Set_Input>;
  pk_columns: Payment_Advice_Term_Classes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Advice_TransfersArgs = {
  _set?: Maybe<Payment_Advice_Transfers_Set_Input>;
  where: Payment_Advice_Transfers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Advice_Transfers_By_PkArgs = {
  _set?: Maybe<Payment_Advice_Transfers_Set_Input>;
  pk_columns: Payment_Advice_Transfers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_AdvicesArgs = {
  _append?: Maybe<Payment_Advices_Append_Input>;
  _delete_at_path?: Maybe<Payment_Advices_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Payment_Advices_Delete_Elem_Input>;
  _delete_key?: Maybe<Payment_Advices_Delete_Key_Input>;
  _prepend?: Maybe<Payment_Advices_Prepend_Input>;
  _set?: Maybe<Payment_Advices_Set_Input>;
  where: Payment_Advices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Advices_By_PkArgs = {
  _append?: Maybe<Payment_Advices_Append_Input>;
  _delete_at_path?: Maybe<Payment_Advices_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Payment_Advices_Delete_Elem_Input>;
  _delete_key?: Maybe<Payment_Advices_Delete_Key_Input>;
  _prepend?: Maybe<Payment_Advices_Prepend_Input>;
  _set?: Maybe<Payment_Advices_Set_Input>;
  pk_columns: Payment_Advices_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProgramsArgs = {
  _append?: Maybe<Programs_Append_Input>;
  _delete_at_path?: Maybe<Programs_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Programs_Delete_Elem_Input>;
  _delete_key?: Maybe<Programs_Delete_Key_Input>;
  _prepend?: Maybe<Programs_Prepend_Input>;
  _set?: Maybe<Programs_Set_Input>;
  where: Programs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Programs_By_PkArgs = {
  _append?: Maybe<Programs_Append_Input>;
  _delete_at_path?: Maybe<Programs_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Programs_Delete_Elem_Input>;
  _delete_key?: Maybe<Programs_Delete_Key_Input>;
  _prepend?: Maybe<Programs_Prepend_Input>;
  _set?: Maybe<Programs_Set_Input>;
  pk_columns: Programs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ReceiptsArgs = {
  _set?: Maybe<Receipts_Set_Input>;
  where: Receipts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Receipts_By_PkArgs = {
  _set?: Maybe<Receipts_Set_Input>;
  pk_columns: Receipts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Refund_ClassesArgs = {
  _append?: Maybe<Refund_Classes_Append_Input>;
  _delete_at_path?: Maybe<Refund_Classes_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Refund_Classes_Delete_Elem_Input>;
  _delete_key?: Maybe<Refund_Classes_Delete_Key_Input>;
  _inc?: Maybe<Refund_Classes_Inc_Input>;
  _prepend?: Maybe<Refund_Classes_Prepend_Input>;
  _set?: Maybe<Refund_Classes_Set_Input>;
  where: Refund_Classes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Refund_Classes_By_PkArgs = {
  _append?: Maybe<Refund_Classes_Append_Input>;
  _delete_at_path?: Maybe<Refund_Classes_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Refund_Classes_Delete_Elem_Input>;
  _delete_key?: Maybe<Refund_Classes_Delete_Key_Input>;
  _inc?: Maybe<Refund_Classes_Inc_Input>;
  _prepend?: Maybe<Refund_Classes_Prepend_Input>;
  _set?: Maybe<Refund_Classes_Set_Input>;
  pk_columns: Refund_Classes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Refund_LogsArgs = {
  _append?: Maybe<Refund_Logs_Append_Input>;
  _delete_at_path?: Maybe<Refund_Logs_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Refund_Logs_Delete_Elem_Input>;
  _delete_key?: Maybe<Refund_Logs_Delete_Key_Input>;
  _prepend?: Maybe<Refund_Logs_Prepend_Input>;
  _set?: Maybe<Refund_Logs_Set_Input>;
  where: Refund_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Refund_Logs_By_PkArgs = {
  _append?: Maybe<Refund_Logs_Append_Input>;
  _delete_at_path?: Maybe<Refund_Logs_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Refund_Logs_Delete_Elem_Input>;
  _delete_key?: Maybe<Refund_Logs_Delete_Key_Input>;
  _prepend?: Maybe<Refund_Logs_Prepend_Input>;
  _set?: Maybe<Refund_Logs_Set_Input>;
  pk_columns: Refund_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_RefundsArgs = {
  _append?: Maybe<Refunds_Append_Input>;
  _delete_at_path?: Maybe<Refunds_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Refunds_Delete_Elem_Input>;
  _delete_key?: Maybe<Refunds_Delete_Key_Input>;
  _prepend?: Maybe<Refunds_Prepend_Input>;
  _set?: Maybe<Refunds_Set_Input>;
  where: Refunds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Refunds_By_PkArgs = {
  _append?: Maybe<Refunds_Append_Input>;
  _delete_at_path?: Maybe<Refunds_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Refunds_Delete_Elem_Input>;
  _delete_key?: Maybe<Refunds_Delete_Key_Input>;
  _prepend?: Maybe<Refunds_Prepend_Input>;
  _set?: Maybe<Refunds_Set_Input>;
  pk_columns: Refunds_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Regular_Academic_PricingsArgs = {
  _inc?: Maybe<Regular_Academic_Pricings_Inc_Input>;
  _set?: Maybe<Regular_Academic_Pricings_Set_Input>;
  where: Regular_Academic_Pricings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Regular_Academic_Pricings_By_PkArgs = {
  _inc?: Maybe<Regular_Academic_Pricings_Inc_Input>;
  _set?: Maybe<Regular_Academic_Pricings_Set_Input>;
  pk_columns: Regular_Academic_Pricings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Regular_Program_TypesArgs = {
  _set?: Maybe<Regular_Program_Types_Set_Input>;
  where: Regular_Program_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Regular_Program_Types_By_PkArgs = {
  _set?: Maybe<Regular_Program_Types_Set_Input>;
  pk_columns: Regular_Program_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Regular_Programme_PricingsArgs = {
  _inc?: Maybe<Regular_Programme_Pricings_Inc_Input>;
  _set?: Maybe<Regular_Programme_Pricings_Set_Input>;
  where: Regular_Programme_Pricings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Regular_Programme_Pricings_By_PkArgs = {
  _inc?: Maybe<Regular_Programme_Pricings_Inc_Input>;
  _set?: Maybe<Regular_Programme_Pricings_Set_Input>;
  pk_columns: Regular_Programme_Pricings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Report_Subject_BudgetArgs = {
  _inc?: Maybe<Report_Subject_Budget_Inc_Input>;
  _set?: Maybe<Report_Subject_Budget_Set_Input>;
  where: Report_Subject_Budget_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Report_Subject_Budget_By_PkArgs = {
  _inc?: Maybe<Report_Subject_Budget_Inc_Input>;
  _set?: Maybe<Report_Subject_Budget_Set_Input>;
  pk_columns: Report_Subject_Budget_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Request_Transfer_ClassesArgs = {
  _set?: Maybe<Request_Transfer_Classes_Set_Input>;
  where: Request_Transfer_Classes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Request_Transfer_Classes_By_PkArgs = {
  _set?: Maybe<Request_Transfer_Classes_Set_Input>;
  pk_columns: Request_Transfer_Classes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_RolesArgs = {
  _set?: Maybe<Roles_Set_Input>;
  where: Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_By_PkArgs = {
  _set?: Maybe<Roles_Set_Input>;
  pk_columns: Roles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SchoolsArgs = {
  _set?: Maybe<Schools_Set_Input>;
  where: Schools_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Schools_By_PkArgs = {
  _set?: Maybe<Schools_Set_Input>;
  pk_columns: Schools_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SessionsArgs = {
  _append?: Maybe<Sessions_Append_Input>;
  _delete_at_path?: Maybe<Sessions_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Sessions_Delete_Elem_Input>;
  _delete_key?: Maybe<Sessions_Delete_Key_Input>;
  _inc?: Maybe<Sessions_Inc_Input>;
  _prepend?: Maybe<Sessions_Prepend_Input>;
  _set?: Maybe<Sessions_Set_Input>;
  where: Sessions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sessions_By_PkArgs = {
  _append?: Maybe<Sessions_Append_Input>;
  _delete_at_path?: Maybe<Sessions_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Sessions_Delete_Elem_Input>;
  _delete_key?: Maybe<Sessions_Delete_Key_Input>;
  _inc?: Maybe<Sessions_Inc_Input>;
  _prepend?: Maybe<Sessions_Prepend_Input>;
  _set?: Maybe<Sessions_Set_Input>;
  pk_columns: Sessions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Special_Programme_Class_PricingsArgs = {
  _inc?: Maybe<Special_Programme_Class_Pricings_Inc_Input>;
  _set?: Maybe<Special_Programme_Class_Pricings_Set_Input>;
  where: Special_Programme_Class_Pricings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Special_Programme_Class_Pricings_By_PkArgs = {
  _inc?: Maybe<Special_Programme_Class_Pricings_Inc_Input>;
  _set?: Maybe<Special_Programme_Class_Pricings_Set_Input>;
  pk_columns: Special_Programme_Class_Pricings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Specical_Program_TypesArgs = {
  _set?: Maybe<Specical_Program_Types_Set_Input>;
  where: Specical_Program_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Specical_Program_Types_By_PkArgs = {
  _set?: Maybe<Specical_Program_Types_Set_Input>;
  pk_columns: Specical_Program_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Student_ProfilesArgs = {
  _append?: Maybe<Student_Profiles_Append_Input>;
  _delete_at_path?: Maybe<Student_Profiles_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Student_Profiles_Delete_Elem_Input>;
  _delete_key?: Maybe<Student_Profiles_Delete_Key_Input>;
  _prepend?: Maybe<Student_Profiles_Prepend_Input>;
  _set?: Maybe<Student_Profiles_Set_Input>;
  where: Student_Profiles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Student_Profiles_By_PkArgs = {
  _append?: Maybe<Student_Profiles_Append_Input>;
  _delete_at_path?: Maybe<Student_Profiles_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Student_Profiles_Delete_Elem_Input>;
  _delete_key?: Maybe<Student_Profiles_Delete_Key_Input>;
  _prepend?: Maybe<Student_Profiles_Prepend_Input>;
  _set?: Maybe<Student_Profiles_Set_Input>;
  pk_columns: Student_Profiles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SubjectsArgs = {
  _set?: Maybe<Subjects_Set_Input>;
  where: Subjects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subjects_By_PkArgs = {
  _set?: Maybe<Subjects_Set_Input>;
  pk_columns: Subjects_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_System_SettingsArgs = {
  _set?: Maybe<System_Settings_Set_Input>;
  where: System_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_System_Settings_By_PkArgs = {
  _set?: Maybe<System_Settings_Set_Input>;
  pk_columns: System_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Term_ClassesArgs = {
  _set?: Maybe<Term_Classes_Set_Input>;
  where: Term_Classes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Term_Classes_By_PkArgs = {
  _set?: Maybe<Term_Classes_Set_Input>;
  pk_columns: Term_Classes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_TermsArgs = {
  _inc?: Maybe<Terms_Inc_Input>;
  _set?: Maybe<Terms_Set_Input>;
  where: Terms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Terms_By_PkArgs = {
  _inc?: Maybe<Terms_Inc_Input>;
  _set?: Maybe<Terms_Set_Input>;
  pk_columns: Terms_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Three_Times_AbsentsArgs = {
  _append?: Maybe<Three_Times_Absents_Append_Input>;
  _delete_at_path?: Maybe<Three_Times_Absents_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Three_Times_Absents_Delete_Elem_Input>;
  _delete_key?: Maybe<Three_Times_Absents_Delete_Key_Input>;
  _prepend?: Maybe<Three_Times_Absents_Prepend_Input>;
  _set?: Maybe<Three_Times_Absents_Set_Input>;
  where: Three_Times_Absents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Three_Times_Absents_By_PkArgs = {
  _append?: Maybe<Three_Times_Absents_Append_Input>;
  _delete_at_path?: Maybe<Three_Times_Absents_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Three_Times_Absents_Delete_Elem_Input>;
  _delete_key?: Maybe<Three_Times_Absents_Delete_Key_Input>;
  _prepend?: Maybe<Three_Times_Absents_Prepend_Input>;
  _set?: Maybe<Three_Times_Absents_Set_Input>;
  pk_columns: Three_Times_Absents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Transaction_LogsArgs = {
  _append?: Maybe<Transaction_Logs_Append_Input>;
  _delete_at_path?: Maybe<Transaction_Logs_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Transaction_Logs_Delete_Elem_Input>;
  _delete_key?: Maybe<Transaction_Logs_Delete_Key_Input>;
  _prepend?: Maybe<Transaction_Logs_Prepend_Input>;
  _set?: Maybe<Transaction_Logs_Set_Input>;
  where: Transaction_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Transaction_Logs_By_PkArgs = {
  _append?: Maybe<Transaction_Logs_Append_Input>;
  _delete_at_path?: Maybe<Transaction_Logs_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Transaction_Logs_Delete_Elem_Input>;
  _delete_key?: Maybe<Transaction_Logs_Delete_Key_Input>;
  _prepend?: Maybe<Transaction_Logs_Prepend_Input>;
  _set?: Maybe<Transaction_Logs_Set_Input>;
  pk_columns: Transaction_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _append?: Maybe<Users_Append_Input>;
  _delete_at_path?: Maybe<Users_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Users_Delete_Elem_Input>;
  _delete_key?: Maybe<Users_Delete_Key_Input>;
  _inc?: Maybe<Users_Inc_Input>;
  _prepend?: Maybe<Users_Prepend_Input>;
  _set?: Maybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _append?: Maybe<Users_Append_Input>;
  _delete_at_path?: Maybe<Users_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Users_Delete_Elem_Input>;
  _delete_key?: Maybe<Users_Delete_Key_Input>;
  _inc?: Maybe<Users_Inc_Input>;
  _prepend?: Maybe<Users_Prepend_Input>;
  _set?: Maybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vms_Person_GroupsArgs = {
  _set?: Maybe<Vms_Person_Groups_Set_Input>;
  where: Vms_Person_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vms_Person_Groups_By_PkArgs = {
  _set?: Maybe<Vms_Person_Groups_Set_Input>;
  pk_columns: Vms_Person_Groups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootValidateClassesCapacityArgs = {
  form: Array<Maybe<FormClassInformation>>;
};


/** mutation root */
export type Mutation_RootVerifyUserAttributeArgs = {
  form: VerifyUserAttributeInput;
};


/** mutation root */
export type Mutation_RootVoidUnpaidPaymentAdviceArgs = {
  paymentAdviceIds: Array<Maybe<Scalars['String']>>;
};

/** columns and relationships of "news" */
export type News = {
  __typename?: 'news';
  coverUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  createdUser?: Maybe<Users>;
  filterRecipient: Scalars['jsonb'];
  footer?: Maybe<Scalars['String']>;
  hashtags: Scalars['jsonb'];
  id: Scalars['uuid'];
  message?: Maybe<Scalars['String']>;
  /** An array relationship */
  newsLogs: Array<News_Logs>;
  /** An aggregated array relationship */
  newsLogs_aggregate: News_Logs_Aggregate;
  newsStatus: Scalars['String'];
  /** A computed field, executes function "news_field_number_of_clicked_emails" */
  numClicks?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "news_field_number_of_opened_emails" */
  numOpens?: Maybe<Scalars['Int']>;
  recipientType?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  subject?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['jsonb'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  updatedUser?: Maybe<Users>;
};


/** columns and relationships of "news" */
export type NewsFilterRecipientArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "news" */
export type NewsHashtagsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "news" */
export type NewsNewsLogsArgs = {
  distinct_on?: Maybe<Array<News_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<News_Logs_Order_By>>;
  where?: Maybe<News_Logs_Bool_Exp>;
};


/** columns and relationships of "news" */
export type NewsNewsLogs_AggregateArgs = {
  distinct_on?: Maybe<Array<News_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<News_Logs_Order_By>>;
  where?: Maybe<News_Logs_Bool_Exp>;
};


/** columns and relationships of "news" */
export type NewsTypeArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "news" */
export type News_Aggregate = {
  __typename?: 'news_aggregate';
  aggregate?: Maybe<News_Aggregate_Fields>;
  nodes: Array<News>;
};

/** aggregate fields of "news" */
export type News_Aggregate_Fields = {
  __typename?: 'news_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<News_Max_Fields>;
  min?: Maybe<News_Min_Fields>;
};


/** aggregate fields of "news" */
export type News_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<News_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "news" */
export type News_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<News_Max_Order_By>;
  min?: Maybe<News_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type News_Append_Input = {
  filterRecipient?: Maybe<Scalars['jsonb']>;
  hashtags?: Maybe<Scalars['jsonb']>;
  type?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "news" */
export type News_Arr_Rel_Insert_Input = {
  data: Array<News_Insert_Input>;
  on_conflict?: Maybe<News_On_Conflict>;
};

/** Boolean expression to filter rows from the table "news". All fields are combined with a logical 'AND'. */
export type News_Bool_Exp = {
  _and?: Maybe<Array<Maybe<News_Bool_Exp>>>;
  _not?: Maybe<News_Bool_Exp>;
  _or?: Maybe<Array<Maybe<News_Bool_Exp>>>;
  coverUrl?: Maybe<String_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  createdUser?: Maybe<Users_Bool_Exp>;
  filterRecipient?: Maybe<Jsonb_Comparison_Exp>;
  footer?: Maybe<String_Comparison_Exp>;
  hashtags?: Maybe<Jsonb_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  message?: Maybe<String_Comparison_Exp>;
  newsLogs?: Maybe<News_Logs_Bool_Exp>;
  newsStatus?: Maybe<String_Comparison_Exp>;
  recipientType?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  subject?: Maybe<String_Comparison_Exp>;
  title?: Maybe<String_Comparison_Exp>;
  type?: Maybe<Jsonb_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  updatedUser?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "news" */
export enum News_Constraint {
  /** unique or primary key constraint */
  NewsPkey = 'news_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type News_Delete_At_Path_Input = {
  filterRecipient?: Maybe<Array<Maybe<Scalars['String']>>>;
  hashtags?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type News_Delete_Elem_Input = {
  filterRecipient?: Maybe<Scalars['Int']>;
  hashtags?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type News_Delete_Key_Input = {
  filterRecipient?: Maybe<Scalars['String']>;
  hashtags?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "news" */
export type News_Insert_Input = {
  coverUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  createdUser?: Maybe<Users_Obj_Rel_Insert_Input>;
  filterRecipient?: Maybe<Scalars['jsonb']>;
  footer?: Maybe<Scalars['String']>;
  hashtags?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  newsLogs?: Maybe<News_Logs_Arr_Rel_Insert_Input>;
  newsStatus?: Maybe<Scalars['String']>;
  recipientType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['jsonb']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  updatedUser?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** columns and relationships of "news_logs" */
export type News_Logs = {
  __typename?: 'news_logs';
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  createdUser?: Maybe<Users>;
  hasNewfeed: Scalars['Boolean'];
  id: Scalars['uuid'];
  isClicked: Scalars['Boolean'];
  isOpened: Scalars['Boolean'];
  isViewed: Scalars['Boolean'];
  messageId?: Maybe<Scalars['String']>;
  /** An object relationship */
  news: News;
  newsId: Scalars['uuid'];
  newsRecipientId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  newsRecipientsUpload?: Maybe<News_Recipients_Upload>;
  /** An object relationship */
  recipient?: Maybe<Users>;
  recipientId?: Maybe<Scalars['uuid']>;
  response?: Maybe<Scalars['jsonb']>;
  status: Scalars['String'];
  statusSent: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  updatedUser?: Maybe<Users>;
};


/** columns and relationships of "news_logs" */
export type News_LogsResponseArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "news_logs" */
export type News_Logs_Aggregate = {
  __typename?: 'news_logs_aggregate';
  aggregate?: Maybe<News_Logs_Aggregate_Fields>;
  nodes: Array<News_Logs>;
};

/** aggregate fields of "news_logs" */
export type News_Logs_Aggregate_Fields = {
  __typename?: 'news_logs_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<News_Logs_Max_Fields>;
  min?: Maybe<News_Logs_Min_Fields>;
};


/** aggregate fields of "news_logs" */
export type News_Logs_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<News_Logs_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "news_logs" */
export type News_Logs_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<News_Logs_Max_Order_By>;
  min?: Maybe<News_Logs_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type News_Logs_Append_Input = {
  response?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "news_logs" */
export type News_Logs_Arr_Rel_Insert_Input = {
  data: Array<News_Logs_Insert_Input>;
  on_conflict?: Maybe<News_Logs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "news_logs". All fields are combined with a logical 'AND'. */
export type News_Logs_Bool_Exp = {
  _and?: Maybe<Array<Maybe<News_Logs_Bool_Exp>>>;
  _not?: Maybe<News_Logs_Bool_Exp>;
  _or?: Maybe<Array<Maybe<News_Logs_Bool_Exp>>>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  createdUser?: Maybe<Users_Bool_Exp>;
  hasNewfeed?: Maybe<Boolean_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  isClicked?: Maybe<Boolean_Comparison_Exp>;
  isOpened?: Maybe<Boolean_Comparison_Exp>;
  isViewed?: Maybe<Boolean_Comparison_Exp>;
  messageId?: Maybe<String_Comparison_Exp>;
  news?: Maybe<News_Bool_Exp>;
  newsId?: Maybe<Uuid_Comparison_Exp>;
  newsRecipientId?: Maybe<Uuid_Comparison_Exp>;
  newsRecipientsUpload?: Maybe<News_Recipients_Upload_Bool_Exp>;
  recipient?: Maybe<Users_Bool_Exp>;
  recipientId?: Maybe<Uuid_Comparison_Exp>;
  response?: Maybe<Jsonb_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  statusSent?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  updatedUser?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "news_logs" */
export enum News_Logs_Constraint {
  /** unique or primary key constraint */
  NewLogsPkey = 'new_logs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type News_Logs_Delete_At_Path_Input = {
  response?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type News_Logs_Delete_Elem_Input = {
  response?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type News_Logs_Delete_Key_Input = {
  response?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "news_logs" */
export type News_Logs_Insert_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  createdUser?: Maybe<Users_Obj_Rel_Insert_Input>;
  hasNewfeed?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  isClicked?: Maybe<Scalars['Boolean']>;
  isOpened?: Maybe<Scalars['Boolean']>;
  isViewed?: Maybe<Scalars['Boolean']>;
  messageId?: Maybe<Scalars['String']>;
  news?: Maybe<News_Obj_Rel_Insert_Input>;
  newsId?: Maybe<Scalars['uuid']>;
  newsRecipientId?: Maybe<Scalars['uuid']>;
  newsRecipientsUpload?: Maybe<News_Recipients_Upload_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Users_Obj_Rel_Insert_Input>;
  recipientId?: Maybe<Scalars['uuid']>;
  response?: Maybe<Scalars['jsonb']>;
  status?: Maybe<Scalars['String']>;
  statusSent?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  updatedUser?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type News_Logs_Max_Fields = {
  __typename?: 'news_logs_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  messageId?: Maybe<Scalars['String']>;
  newsId?: Maybe<Scalars['uuid']>;
  newsRecipientId?: Maybe<Scalars['uuid']>;
  recipientId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  statusSent?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "news_logs" */
export type News_Logs_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  messageId?: Maybe<Order_By>;
  newsId?: Maybe<Order_By>;
  newsRecipientId?: Maybe<Order_By>;
  recipientId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  statusSent?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type News_Logs_Min_Fields = {
  __typename?: 'news_logs_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  messageId?: Maybe<Scalars['String']>;
  newsId?: Maybe<Scalars['uuid']>;
  newsRecipientId?: Maybe<Scalars['uuid']>;
  recipientId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  statusSent?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "news_logs" */
export type News_Logs_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  messageId?: Maybe<Order_By>;
  newsId?: Maybe<Order_By>;
  newsRecipientId?: Maybe<Order_By>;
  recipientId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  statusSent?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "news_logs" */
export type News_Logs_Mutation_Response = {
  __typename?: 'news_logs_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<News_Logs>;
};

/** input type for inserting object relation for remote table "news_logs" */
export type News_Logs_Obj_Rel_Insert_Input = {
  data: News_Logs_Insert_Input;
  on_conflict?: Maybe<News_Logs_On_Conflict>;
};

/** on conflict condition type for table "news_logs" */
export type News_Logs_On_Conflict = {
  constraint: News_Logs_Constraint;
  update_columns: Array<News_Logs_Update_Column>;
  where?: Maybe<News_Logs_Bool_Exp>;
};

/** ordering options when selecting data from "news_logs" */
export type News_Logs_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  createdUser?: Maybe<Users_Order_By>;
  hasNewfeed?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  isClicked?: Maybe<Order_By>;
  isOpened?: Maybe<Order_By>;
  isViewed?: Maybe<Order_By>;
  messageId?: Maybe<Order_By>;
  news?: Maybe<News_Order_By>;
  newsId?: Maybe<Order_By>;
  newsRecipientId?: Maybe<Order_By>;
  newsRecipientsUpload?: Maybe<News_Recipients_Upload_Order_By>;
  recipient?: Maybe<Users_Order_By>;
  recipientId?: Maybe<Order_By>;
  response?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  statusSent?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  updatedUser?: Maybe<Users_Order_By>;
};

/** primary key columns input for table: "news_logs" */
export type News_Logs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type News_Logs_Prepend_Input = {
  response?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "news_logs" */
export enum News_Logs_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  HasNewfeed = 'hasNewfeed',
  /** column name */
  Id = 'id',
  /** column name */
  IsClicked = 'isClicked',
  /** column name */
  IsOpened = 'isOpened',
  /** column name */
  IsViewed = 'isViewed',
  /** column name */
  MessageId = 'messageId',
  /** column name */
  NewsId = 'newsId',
  /** column name */
  NewsRecipientId = 'newsRecipientId',
  /** column name */
  RecipientId = 'recipientId',
  /** column name */
  Response = 'response',
  /** column name */
  Status = 'status',
  /** column name */
  StatusSent = 'statusSent',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "news_logs" */
export type News_Logs_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  hasNewfeed?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  isClicked?: Maybe<Scalars['Boolean']>;
  isOpened?: Maybe<Scalars['Boolean']>;
  isViewed?: Maybe<Scalars['Boolean']>;
  messageId?: Maybe<Scalars['String']>;
  newsId?: Maybe<Scalars['uuid']>;
  newsRecipientId?: Maybe<Scalars['uuid']>;
  recipientId?: Maybe<Scalars['uuid']>;
  response?: Maybe<Scalars['jsonb']>;
  status?: Maybe<Scalars['String']>;
  statusSent?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "news_logs" */
export enum News_Logs_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  HasNewfeed = 'hasNewfeed',
  /** column name */
  Id = 'id',
  /** column name */
  IsClicked = 'isClicked',
  /** column name */
  IsOpened = 'isOpened',
  /** column name */
  IsViewed = 'isViewed',
  /** column name */
  MessageId = 'messageId',
  /** column name */
  NewsId = 'newsId',
  /** column name */
  NewsRecipientId = 'newsRecipientId',
  /** column name */
  RecipientId = 'recipientId',
  /** column name */
  Response = 'response',
  /** column name */
  Status = 'status',
  /** column name */
  StatusSent = 'statusSent',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** aggregate max on columns */
export type News_Max_Fields = {
  __typename?: 'news_max_fields';
  coverUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  footer?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  newsStatus?: Maybe<Scalars['String']>;
  recipientType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "news" */
export type News_Max_Order_By = {
  coverUrl?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  footer?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  message?: Maybe<Order_By>;
  newsStatus?: Maybe<Order_By>;
  recipientType?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  subject?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type News_Min_Fields = {
  __typename?: 'news_min_fields';
  coverUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  footer?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  newsStatus?: Maybe<Scalars['String']>;
  recipientType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "news" */
export type News_Min_Order_By = {
  coverUrl?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  footer?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  message?: Maybe<Order_By>;
  newsStatus?: Maybe<Order_By>;
  recipientType?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  subject?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "news" */
export type News_Mutation_Response = {
  __typename?: 'news_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<News>;
};

/** input type for inserting object relation for remote table "news" */
export type News_Obj_Rel_Insert_Input = {
  data: News_Insert_Input;
  on_conflict?: Maybe<News_On_Conflict>;
};

/** on conflict condition type for table "news" */
export type News_On_Conflict = {
  constraint: News_Constraint;
  update_columns: Array<News_Update_Column>;
  where?: Maybe<News_Bool_Exp>;
};

/** ordering options when selecting data from "news" */
export type News_Order_By = {
  coverUrl?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  createdUser?: Maybe<Users_Order_By>;
  filterRecipient?: Maybe<Order_By>;
  footer?: Maybe<Order_By>;
  hashtags?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  message?: Maybe<Order_By>;
  newsLogs_aggregate?: Maybe<News_Logs_Aggregate_Order_By>;
  newsStatus?: Maybe<Order_By>;
  recipientType?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  subject?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  updatedUser?: Maybe<Users_Order_By>;
};

/** primary key columns input for table: "news" */
export type News_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type News_Prepend_Input = {
  filterRecipient?: Maybe<Scalars['jsonb']>;
  hashtags?: Maybe<Scalars['jsonb']>;
  type?: Maybe<Scalars['jsonb']>;
};

/** columns and relationships of "news_recipients_upload" */
export type News_Recipients_Upload = {
  __typename?: 'news_recipients_upload';
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  email: Scalars['String'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An object relationship */
  news?: Maybe<News>;
  newsId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  news_logs: Array<News_Logs>;
  /** An aggregated array relationship */
  news_logs_aggregate: News_Logs_Aggregate;
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "news_recipients_upload" */
export type News_Recipients_UploadNews_LogsArgs = {
  distinct_on?: Maybe<Array<News_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<News_Logs_Order_By>>;
  where?: Maybe<News_Logs_Bool_Exp>;
};


/** columns and relationships of "news_recipients_upload" */
export type News_Recipients_UploadNews_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<News_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<News_Logs_Order_By>>;
  where?: Maybe<News_Logs_Bool_Exp>;
};

/** aggregated selection of "news_recipients_upload" */
export type News_Recipients_Upload_Aggregate = {
  __typename?: 'news_recipients_upload_aggregate';
  aggregate?: Maybe<News_Recipients_Upload_Aggregate_Fields>;
  nodes: Array<News_Recipients_Upload>;
};

/** aggregate fields of "news_recipients_upload" */
export type News_Recipients_Upload_Aggregate_Fields = {
  __typename?: 'news_recipients_upload_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<News_Recipients_Upload_Max_Fields>;
  min?: Maybe<News_Recipients_Upload_Min_Fields>;
};


/** aggregate fields of "news_recipients_upload" */
export type News_Recipients_Upload_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<News_Recipients_Upload_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "news_recipients_upload" */
export type News_Recipients_Upload_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<News_Recipients_Upload_Max_Order_By>;
  min?: Maybe<News_Recipients_Upload_Min_Order_By>;
};

/** input type for inserting array relation for remote table "news_recipients_upload" */
export type News_Recipients_Upload_Arr_Rel_Insert_Input = {
  data: Array<News_Recipients_Upload_Insert_Input>;
  on_conflict?: Maybe<News_Recipients_Upload_On_Conflict>;
};

/** Boolean expression to filter rows from the table "news_recipients_upload". All fields are combined with a logical 'AND'. */
export type News_Recipients_Upload_Bool_Exp = {
  _and?: Maybe<Array<Maybe<News_Recipients_Upload_Bool_Exp>>>;
  _not?: Maybe<News_Recipients_Upload_Bool_Exp>;
  _or?: Maybe<Array<Maybe<News_Recipients_Upload_Bool_Exp>>>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  news?: Maybe<News_Bool_Exp>;
  newsId?: Maybe<Uuid_Comparison_Exp>;
  news_logs?: Maybe<News_Logs_Bool_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "news_recipients_upload" */
export enum News_Recipients_Upload_Constraint {
  /** unique or primary key constraint */
  NewsRecipientsPkey = 'news_recipients_pkey'
}

/** input type for inserting data into table "news_recipients_upload" */
export type News_Recipients_Upload_Insert_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  news?: Maybe<News_Obj_Rel_Insert_Input>;
  newsId?: Maybe<Scalars['uuid']>;
  news_logs?: Maybe<News_Logs_Arr_Rel_Insert_Input>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type News_Recipients_Upload_Max_Fields = {
  __typename?: 'news_recipients_upload_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  newsId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "news_recipients_upload" */
export type News_Recipients_Upload_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  newsId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type News_Recipients_Upload_Min_Fields = {
  __typename?: 'news_recipients_upload_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  newsId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "news_recipients_upload" */
export type News_Recipients_Upload_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  newsId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "news_recipients_upload" */
export type News_Recipients_Upload_Mutation_Response = {
  __typename?: 'news_recipients_upload_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<News_Recipients_Upload>;
};

/** input type for inserting object relation for remote table "news_recipients_upload" */
export type News_Recipients_Upload_Obj_Rel_Insert_Input = {
  data: News_Recipients_Upload_Insert_Input;
  on_conflict?: Maybe<News_Recipients_Upload_On_Conflict>;
};

/** on conflict condition type for table "news_recipients_upload" */
export type News_Recipients_Upload_On_Conflict = {
  constraint: News_Recipients_Upload_Constraint;
  update_columns: Array<News_Recipients_Upload_Update_Column>;
  where?: Maybe<News_Recipients_Upload_Bool_Exp>;
};

/** ordering options when selecting data from "news_recipients_upload" */
export type News_Recipients_Upload_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  news?: Maybe<News_Order_By>;
  newsId?: Maybe<Order_By>;
  news_logs_aggregate?: Maybe<News_Logs_Aggregate_Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "news_recipients_upload" */
export type News_Recipients_Upload_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "news_recipients_upload" */
export enum News_Recipients_Upload_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NewsId = 'newsId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "news_recipients_upload" */
export type News_Recipients_Upload_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  newsId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "news_recipients_upload" */
export enum News_Recipients_Upload_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NewsId = 'newsId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** select columns of table "news" */
export enum News_Select_Column {
  /** column name */
  CoverUrl = 'coverUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  FilterRecipient = 'filterRecipient',
  /** column name */
  Footer = 'footer',
  /** column name */
  Hashtags = 'hashtags',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  NewsStatus = 'newsStatus',
  /** column name */
  RecipientType = 'recipientType',
  /** column name */
  Status = 'status',
  /** column name */
  Subject = 'subject',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "news" */
export type News_Set_Input = {
  coverUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  filterRecipient?: Maybe<Scalars['jsonb']>;
  footer?: Maybe<Scalars['String']>;
  hashtags?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  newsStatus?: Maybe<Scalars['String']>;
  recipientType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['jsonb']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "news" */
export enum News_Update_Column {
  /** column name */
  CoverUrl = 'coverUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  FilterRecipient = 'filterRecipient',
  /** column name */
  Footer = 'footer',
  /** column name */
  Hashtags = 'hashtags',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  NewsStatus = 'newsStatus',
  /** column name */
  RecipientType = 'recipientType',
  /** column name */
  Status = 'status',
  /** column name */
  Subject = 'subject',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}


/** expression to compare columns of type numeric. All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: Maybe<Scalars['numeric']>;
  _gt?: Maybe<Scalars['numeric']>;
  _gte?: Maybe<Scalars['numeric']>;
  _in?: Maybe<Array<Scalars['numeric']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['numeric']>;
  _lte?: Maybe<Scalars['numeric']>;
  _neq?: Maybe<Scalars['numeric']>;
  _nin?: Maybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum Order_By {
  /** in the ascending order, nulls last */
  Asc = 'asc',
  /** in the ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in the ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in the descending order, nulls first */
  Desc = 'desc',
  /** in the descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in the descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "pass_door_logs" */
export type Pass_Door_Logs = {
  __typename?: 'pass_door_logs';
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  notes: Scalars['jsonb'];
  status: Scalars['String'];
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "pass_door_logs" */
export type Pass_Door_LogsNotesArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "pass_door_logs" */
export type Pass_Door_Logs_Aggregate = {
  __typename?: 'pass_door_logs_aggregate';
  aggregate?: Maybe<Pass_Door_Logs_Aggregate_Fields>;
  nodes: Array<Pass_Door_Logs>;
};

/** aggregate fields of "pass_door_logs" */
export type Pass_Door_Logs_Aggregate_Fields = {
  __typename?: 'pass_door_logs_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Pass_Door_Logs_Max_Fields>;
  min?: Maybe<Pass_Door_Logs_Min_Fields>;
};


/** aggregate fields of "pass_door_logs" */
export type Pass_Door_Logs_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Pass_Door_Logs_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pass_door_logs" */
export type Pass_Door_Logs_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Pass_Door_Logs_Max_Order_By>;
  min?: Maybe<Pass_Door_Logs_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Pass_Door_Logs_Append_Input = {
  notes?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "pass_door_logs" */
export type Pass_Door_Logs_Arr_Rel_Insert_Input = {
  data: Array<Pass_Door_Logs_Insert_Input>;
  on_conflict?: Maybe<Pass_Door_Logs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "pass_door_logs". All fields are combined with a logical 'AND'. */
export type Pass_Door_Logs_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Pass_Door_Logs_Bool_Exp>>>;
  _not?: Maybe<Pass_Door_Logs_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Pass_Door_Logs_Bool_Exp>>>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  notes?: Maybe<Jsonb_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "pass_door_logs" */
export enum Pass_Door_Logs_Constraint {
  /** unique or primary key constraint */
  PassDoorLogsPkey = 'pass_door_logs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Pass_Door_Logs_Delete_At_Path_Input = {
  notes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Pass_Door_Logs_Delete_Elem_Input = {
  notes?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Pass_Door_Logs_Delete_Key_Input = {
  notes?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "pass_door_logs" */
export type Pass_Door_Logs_Insert_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['jsonb']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Pass_Door_Logs_Max_Fields = {
  __typename?: 'pass_door_logs_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "pass_door_logs" */
export type Pass_Door_Logs_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Pass_Door_Logs_Min_Fields = {
  __typename?: 'pass_door_logs_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "pass_door_logs" */
export type Pass_Door_Logs_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "pass_door_logs" */
export type Pass_Door_Logs_Mutation_Response = {
  __typename?: 'pass_door_logs_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Pass_Door_Logs>;
};

/** input type for inserting object relation for remote table "pass_door_logs" */
export type Pass_Door_Logs_Obj_Rel_Insert_Input = {
  data: Pass_Door_Logs_Insert_Input;
  on_conflict?: Maybe<Pass_Door_Logs_On_Conflict>;
};

/** on conflict condition type for table "pass_door_logs" */
export type Pass_Door_Logs_On_Conflict = {
  constraint: Pass_Door_Logs_Constraint;
  update_columns: Array<Pass_Door_Logs_Update_Column>;
  where?: Maybe<Pass_Door_Logs_Bool_Exp>;
};

/** ordering options when selecting data from "pass_door_logs" */
export type Pass_Door_Logs_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  notes?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "pass_door_logs" */
export type Pass_Door_Logs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Pass_Door_Logs_Prepend_Input = {
  notes?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "pass_door_logs" */
export enum Pass_Door_Logs_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "pass_door_logs" */
export type Pass_Door_Logs_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['jsonb']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "pass_door_logs" */
export enum Pass_Door_Logs_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** columns and relationships of "payment_advice_class_transfer" */
export type Payment_Advice_Class_Transfer = {
  __typename?: 'payment_advice_class_transfer';
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An object relationship */
  paymentAdviceClass: Payment_Advice_Classes;
  paymentAdviceClassId: Scalars['uuid'];
  /** An object relationship */
  paymentAdviceTransfer: Payment_Advice_Transfers;
  paymentAdviceTransferId: Scalars['uuid'];
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "payment_advice_class_transfer" */
export type Payment_Advice_Class_Transfer_Aggregate = {
  __typename?: 'payment_advice_class_transfer_aggregate';
  aggregate?: Maybe<Payment_Advice_Class_Transfer_Aggregate_Fields>;
  nodes: Array<Payment_Advice_Class_Transfer>;
};

/** aggregate fields of "payment_advice_class_transfer" */
export type Payment_Advice_Class_Transfer_Aggregate_Fields = {
  __typename?: 'payment_advice_class_transfer_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Payment_Advice_Class_Transfer_Max_Fields>;
  min?: Maybe<Payment_Advice_Class_Transfer_Min_Fields>;
};


/** aggregate fields of "payment_advice_class_transfer" */
export type Payment_Advice_Class_Transfer_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Payment_Advice_Class_Transfer_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payment_advice_class_transfer" */
export type Payment_Advice_Class_Transfer_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Payment_Advice_Class_Transfer_Max_Order_By>;
  min?: Maybe<Payment_Advice_Class_Transfer_Min_Order_By>;
};

/** input type for inserting array relation for remote table "payment_advice_class_transfer" */
export type Payment_Advice_Class_Transfer_Arr_Rel_Insert_Input = {
  data: Array<Payment_Advice_Class_Transfer_Insert_Input>;
  on_conflict?: Maybe<Payment_Advice_Class_Transfer_On_Conflict>;
};

/** Boolean expression to filter rows from the table "payment_advice_class_transfer". All fields are combined with a logical 'AND'. */
export type Payment_Advice_Class_Transfer_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Payment_Advice_Class_Transfer_Bool_Exp>>>;
  _not?: Maybe<Payment_Advice_Class_Transfer_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Payment_Advice_Class_Transfer_Bool_Exp>>>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  paymentAdviceClass?: Maybe<Payment_Advice_Classes_Bool_Exp>;
  paymentAdviceClassId?: Maybe<Uuid_Comparison_Exp>;
  paymentAdviceTransfer?: Maybe<Payment_Advice_Transfers_Bool_Exp>;
  paymentAdviceTransferId?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "payment_advice_class_transfer" */
export enum Payment_Advice_Class_Transfer_Constraint {
  /** unique or primary key constraint */
  PaymentAdviceClassTransferPkey = 'payment_advice_class_transfer_pkey'
}

/** input type for inserting data into table "payment_advice_class_transfer" */
export type Payment_Advice_Class_Transfer_Insert_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdviceClass?: Maybe<Payment_Advice_Classes_Obj_Rel_Insert_Input>;
  paymentAdviceClassId?: Maybe<Scalars['uuid']>;
  paymentAdviceTransfer?: Maybe<Payment_Advice_Transfers_Obj_Rel_Insert_Input>;
  paymentAdviceTransferId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Payment_Advice_Class_Transfer_Max_Fields = {
  __typename?: 'payment_advice_class_transfer_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdviceClassId?: Maybe<Scalars['uuid']>;
  paymentAdviceTransferId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "payment_advice_class_transfer" */
export type Payment_Advice_Class_Transfer_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  paymentAdviceClassId?: Maybe<Order_By>;
  paymentAdviceTransferId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Payment_Advice_Class_Transfer_Min_Fields = {
  __typename?: 'payment_advice_class_transfer_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdviceClassId?: Maybe<Scalars['uuid']>;
  paymentAdviceTransferId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "payment_advice_class_transfer" */
export type Payment_Advice_Class_Transfer_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  paymentAdviceClassId?: Maybe<Order_By>;
  paymentAdviceTransferId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "payment_advice_class_transfer" */
export type Payment_Advice_Class_Transfer_Mutation_Response = {
  __typename?: 'payment_advice_class_transfer_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Payment_Advice_Class_Transfer>;
};

/** input type for inserting object relation for remote table "payment_advice_class_transfer" */
export type Payment_Advice_Class_Transfer_Obj_Rel_Insert_Input = {
  data: Payment_Advice_Class_Transfer_Insert_Input;
  on_conflict?: Maybe<Payment_Advice_Class_Transfer_On_Conflict>;
};

/** on conflict condition type for table "payment_advice_class_transfer" */
export type Payment_Advice_Class_Transfer_On_Conflict = {
  constraint: Payment_Advice_Class_Transfer_Constraint;
  update_columns: Array<Payment_Advice_Class_Transfer_Update_Column>;
  where?: Maybe<Payment_Advice_Class_Transfer_Bool_Exp>;
};

/** ordering options when selecting data from "payment_advice_class_transfer" */
export type Payment_Advice_Class_Transfer_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  paymentAdviceClass?: Maybe<Payment_Advice_Classes_Order_By>;
  paymentAdviceClassId?: Maybe<Order_By>;
  paymentAdviceTransfer?: Maybe<Payment_Advice_Transfers_Order_By>;
  paymentAdviceTransferId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "payment_advice_class_transfer" */
export type Payment_Advice_Class_Transfer_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "payment_advice_class_transfer" */
export enum Payment_Advice_Class_Transfer_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentAdviceClassId = 'paymentAdviceClassId',
  /** column name */
  PaymentAdviceTransferId = 'paymentAdviceTransferId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "payment_advice_class_transfer" */
export type Payment_Advice_Class_Transfer_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdviceClassId?: Maybe<Scalars['uuid']>;
  paymentAdviceTransferId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "payment_advice_class_transfer" */
export enum Payment_Advice_Class_Transfer_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentAdviceClassId = 'paymentAdviceClassId',
  /** column name */
  PaymentAdviceTransferId = 'paymentAdviceTransferId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** columns and relationships of "payment_advice_classes" */
export type Payment_Advice_Classes = {
  __typename?: 'payment_advice_classes';
  additionalDiscount?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  class: Classes;
  classId: Scalars['uuid'];
  classTypeOfStudent?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  discounts?: Maybe<Scalars['jsonb']>;
  firstLessonDate?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  lastLessonDate?: Maybe<Scalars['timestamptz']>;
  lessonStartDate?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  paymentAdvice: Payment_Advices;
  paymentAdviceId: Scalars['uuid'];
  /** An array relationship */
  paymentAdviceTermClasses: Array<Payment_Advice_Term_Classes>;
  /** An aggregated array relationship */
  paymentAdviceTermClasses_aggregate: Payment_Advice_Term_Classes_Aggregate;
  /** An array relationship */
  payment_advice_class_transfers: Array<Payment_Advice_Class_Transfer>;
  /** An aggregated array relationship */
  payment_advice_class_transfers_aggregate: Payment_Advice_Class_Transfer_Aggregate;
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  userByCreatedby?: Maybe<Users>;
};


/** columns and relationships of "payment_advice_classes" */
export type Payment_Advice_ClassesDiscountsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "payment_advice_classes" */
export type Payment_Advice_ClassesPaymentAdviceTermClassesArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Term_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Term_Classes_Order_By>>;
  where?: Maybe<Payment_Advice_Term_Classes_Bool_Exp>;
};


/** columns and relationships of "payment_advice_classes" */
export type Payment_Advice_ClassesPaymentAdviceTermClasses_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Term_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Term_Classes_Order_By>>;
  where?: Maybe<Payment_Advice_Term_Classes_Bool_Exp>;
};


/** columns and relationships of "payment_advice_classes" */
export type Payment_Advice_ClassesPayment_Advice_Class_TransfersArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Class_Transfer_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Class_Transfer_Order_By>>;
  where?: Maybe<Payment_Advice_Class_Transfer_Bool_Exp>;
};


/** columns and relationships of "payment_advice_classes" */
export type Payment_Advice_ClassesPayment_Advice_Class_Transfers_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Class_Transfer_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Class_Transfer_Order_By>>;
  where?: Maybe<Payment_Advice_Class_Transfer_Bool_Exp>;
};

/** aggregated selection of "payment_advice_classes" */
export type Payment_Advice_Classes_Aggregate = {
  __typename?: 'payment_advice_classes_aggregate';
  aggregate?: Maybe<Payment_Advice_Classes_Aggregate_Fields>;
  nodes: Array<Payment_Advice_Classes>;
};

/** aggregate fields of "payment_advice_classes" */
export type Payment_Advice_Classes_Aggregate_Fields = {
  __typename?: 'payment_advice_classes_aggregate_fields';
  avg?: Maybe<Payment_Advice_Classes_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Payment_Advice_Classes_Max_Fields>;
  min?: Maybe<Payment_Advice_Classes_Min_Fields>;
  stddev?: Maybe<Payment_Advice_Classes_Stddev_Fields>;
  stddev_pop?: Maybe<Payment_Advice_Classes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Payment_Advice_Classes_Stddev_Samp_Fields>;
  sum?: Maybe<Payment_Advice_Classes_Sum_Fields>;
  var_pop?: Maybe<Payment_Advice_Classes_Var_Pop_Fields>;
  var_samp?: Maybe<Payment_Advice_Classes_Var_Samp_Fields>;
  variance?: Maybe<Payment_Advice_Classes_Variance_Fields>;
};


/** aggregate fields of "payment_advice_classes" */
export type Payment_Advice_Classes_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Payment_Advice_Classes_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payment_advice_classes" */
export type Payment_Advice_Classes_Aggregate_Order_By = {
  avg?: Maybe<Payment_Advice_Classes_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Payment_Advice_Classes_Max_Order_By>;
  min?: Maybe<Payment_Advice_Classes_Min_Order_By>;
  stddev?: Maybe<Payment_Advice_Classes_Stddev_Order_By>;
  stddev_pop?: Maybe<Payment_Advice_Classes_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Payment_Advice_Classes_Stddev_Samp_Order_By>;
  sum?: Maybe<Payment_Advice_Classes_Sum_Order_By>;
  var_pop?: Maybe<Payment_Advice_Classes_Var_Pop_Order_By>;
  var_samp?: Maybe<Payment_Advice_Classes_Var_Samp_Order_By>;
  variance?: Maybe<Payment_Advice_Classes_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Payment_Advice_Classes_Append_Input = {
  discounts?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "payment_advice_classes" */
export type Payment_Advice_Classes_Arr_Rel_Insert_Input = {
  data: Array<Payment_Advice_Classes_Insert_Input>;
  on_conflict?: Maybe<Payment_Advice_Classes_On_Conflict>;
};

/** aggregate avg on columns */
export type Payment_Advice_Classes_Avg_Fields = {
  __typename?: 'payment_advice_classes_avg_fields';
  additionalDiscount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "payment_advice_classes" */
export type Payment_Advice_Classes_Avg_Order_By = {
  additionalDiscount?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "payment_advice_classes". All fields are combined with a logical 'AND'. */
export type Payment_Advice_Classes_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Payment_Advice_Classes_Bool_Exp>>>;
  _not?: Maybe<Payment_Advice_Classes_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Payment_Advice_Classes_Bool_Exp>>>;
  additionalDiscount?: Maybe<Numeric_Comparison_Exp>;
  class?: Maybe<Classes_Bool_Exp>;
  classId?: Maybe<Uuid_Comparison_Exp>;
  classTypeOfStudent?: Maybe<String_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  discounts?: Maybe<Jsonb_Comparison_Exp>;
  firstLessonDate?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  lastLessonDate?: Maybe<Timestamptz_Comparison_Exp>;
  lessonStartDate?: Maybe<Timestamptz_Comparison_Exp>;
  paymentAdvice?: Maybe<Payment_Advices_Bool_Exp>;
  paymentAdviceId?: Maybe<Uuid_Comparison_Exp>;
  paymentAdviceTermClasses?: Maybe<Payment_Advice_Term_Classes_Bool_Exp>;
  payment_advice_class_transfers?: Maybe<Payment_Advice_Class_Transfer_Bool_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  userByCreatedby?: Maybe<Users_Bool_Exp>;
};

export type Payment_Advice_Classes_By_Student_Id_Args = {
  student_id?: Maybe<Scalars['uuid']>;
};

/** unique or primary key constraints on table "payment_advice_classes" */
export enum Payment_Advice_Classes_Constraint {
  /** unique or primary key constraint */
  PaymentClassesPkey = 'payment_classes_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Payment_Advice_Classes_Delete_At_Path_Input = {
  discounts?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Payment_Advice_Classes_Delete_Elem_Input = {
  discounts?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Payment_Advice_Classes_Delete_Key_Input = {
  discounts?: Maybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "payment_advice_classes" */
export type Payment_Advice_Classes_Inc_Input = {
  additionalDiscount?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "payment_advice_classes" */
export type Payment_Advice_Classes_Insert_Input = {
  additionalDiscount?: Maybe<Scalars['numeric']>;
  class?: Maybe<Classes_Obj_Rel_Insert_Input>;
  classId?: Maybe<Scalars['uuid']>;
  classTypeOfStudent?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  discounts?: Maybe<Scalars['jsonb']>;
  firstLessonDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lastLessonDate?: Maybe<Scalars['timestamptz']>;
  lessonStartDate?: Maybe<Scalars['timestamptz']>;
  paymentAdvice?: Maybe<Payment_Advices_Obj_Rel_Insert_Input>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  paymentAdviceTermClasses?: Maybe<Payment_Advice_Term_Classes_Arr_Rel_Insert_Input>;
  payment_advice_class_transfers?: Maybe<Payment_Advice_Class_Transfer_Arr_Rel_Insert_Input>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  userByCreatedby?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Payment_Advice_Classes_Max_Fields = {
  __typename?: 'payment_advice_classes_max_fields';
  additionalDiscount?: Maybe<Scalars['numeric']>;
  classId?: Maybe<Scalars['uuid']>;
  classTypeOfStudent?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  firstLessonDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lastLessonDate?: Maybe<Scalars['timestamptz']>;
  lessonStartDate?: Maybe<Scalars['timestamptz']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "payment_advice_classes" */
export type Payment_Advice_Classes_Max_Order_By = {
  additionalDiscount?: Maybe<Order_By>;
  classId?: Maybe<Order_By>;
  classTypeOfStudent?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  firstLessonDate?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lastLessonDate?: Maybe<Order_By>;
  lessonStartDate?: Maybe<Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Payment_Advice_Classes_Min_Fields = {
  __typename?: 'payment_advice_classes_min_fields';
  additionalDiscount?: Maybe<Scalars['numeric']>;
  classId?: Maybe<Scalars['uuid']>;
  classTypeOfStudent?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  firstLessonDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lastLessonDate?: Maybe<Scalars['timestamptz']>;
  lessonStartDate?: Maybe<Scalars['timestamptz']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "payment_advice_classes" */
export type Payment_Advice_Classes_Min_Order_By = {
  additionalDiscount?: Maybe<Order_By>;
  classId?: Maybe<Order_By>;
  classTypeOfStudent?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  firstLessonDate?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lastLessonDate?: Maybe<Order_By>;
  lessonStartDate?: Maybe<Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "payment_advice_classes" */
export type Payment_Advice_Classes_Mutation_Response = {
  __typename?: 'payment_advice_classes_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Payment_Advice_Classes>;
};

/** input type for inserting object relation for remote table "payment_advice_classes" */
export type Payment_Advice_Classes_Obj_Rel_Insert_Input = {
  data: Payment_Advice_Classes_Insert_Input;
  on_conflict?: Maybe<Payment_Advice_Classes_On_Conflict>;
};

/** on conflict condition type for table "payment_advice_classes" */
export type Payment_Advice_Classes_On_Conflict = {
  constraint: Payment_Advice_Classes_Constraint;
  update_columns: Array<Payment_Advice_Classes_Update_Column>;
  where?: Maybe<Payment_Advice_Classes_Bool_Exp>;
};

/** ordering options when selecting data from "payment_advice_classes" */
export type Payment_Advice_Classes_Order_By = {
  additionalDiscount?: Maybe<Order_By>;
  class?: Maybe<Classes_Order_By>;
  classId?: Maybe<Order_By>;
  classTypeOfStudent?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  discounts?: Maybe<Order_By>;
  firstLessonDate?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lastLessonDate?: Maybe<Order_By>;
  lessonStartDate?: Maybe<Order_By>;
  paymentAdvice?: Maybe<Payment_Advices_Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  paymentAdviceTermClasses_aggregate?: Maybe<Payment_Advice_Term_Classes_Aggregate_Order_By>;
  payment_advice_class_transfers_aggregate?: Maybe<Payment_Advice_Class_Transfer_Aggregate_Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  userByCreatedby?: Maybe<Users_Order_By>;
};

/** primary key columns input for table: "payment_advice_classes" */
export type Payment_Advice_Classes_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Payment_Advice_Classes_Prepend_Input = {
  discounts?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "payment_advice_classes" */
export enum Payment_Advice_Classes_Select_Column {
  /** column name */
  AdditionalDiscount = 'additionalDiscount',
  /** column name */
  ClassId = 'classId',
  /** column name */
  ClassTypeOfStudent = 'classTypeOfStudent',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Discounts = 'discounts',
  /** column name */
  FirstLessonDate = 'firstLessonDate',
  /** column name */
  Id = 'id',
  /** column name */
  LastLessonDate = 'lastLessonDate',
  /** column name */
  LessonStartDate = 'lessonStartDate',
  /** column name */
  PaymentAdviceId = 'paymentAdviceId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "payment_advice_classes" */
export type Payment_Advice_Classes_Set_Input = {
  additionalDiscount?: Maybe<Scalars['numeric']>;
  classId?: Maybe<Scalars['uuid']>;
  classTypeOfStudent?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  discounts?: Maybe<Scalars['jsonb']>;
  firstLessonDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lastLessonDate?: Maybe<Scalars['timestamptz']>;
  lessonStartDate?: Maybe<Scalars['timestamptz']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Payment_Advice_Classes_Stddev_Fields = {
  __typename?: 'payment_advice_classes_stddev_fields';
  additionalDiscount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "payment_advice_classes" */
export type Payment_Advice_Classes_Stddev_Order_By = {
  additionalDiscount?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Payment_Advice_Classes_Stddev_Pop_Fields = {
  __typename?: 'payment_advice_classes_stddev_pop_fields';
  additionalDiscount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "payment_advice_classes" */
export type Payment_Advice_Classes_Stddev_Pop_Order_By = {
  additionalDiscount?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Payment_Advice_Classes_Stddev_Samp_Fields = {
  __typename?: 'payment_advice_classes_stddev_samp_fields';
  additionalDiscount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "payment_advice_classes" */
export type Payment_Advice_Classes_Stddev_Samp_Order_By = {
  additionalDiscount?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Payment_Advice_Classes_Sum_Fields = {
  __typename?: 'payment_advice_classes_sum_fields';
  additionalDiscount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "payment_advice_classes" */
export type Payment_Advice_Classes_Sum_Order_By = {
  additionalDiscount?: Maybe<Order_By>;
};

/** update columns of table "payment_advice_classes" */
export enum Payment_Advice_Classes_Update_Column {
  /** column name */
  AdditionalDiscount = 'additionalDiscount',
  /** column name */
  ClassId = 'classId',
  /** column name */
  ClassTypeOfStudent = 'classTypeOfStudent',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Discounts = 'discounts',
  /** column name */
  FirstLessonDate = 'firstLessonDate',
  /** column name */
  Id = 'id',
  /** column name */
  LastLessonDate = 'lastLessonDate',
  /** column name */
  LessonStartDate = 'lessonStartDate',
  /** column name */
  PaymentAdviceId = 'paymentAdviceId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** aggregate var_pop on columns */
export type Payment_Advice_Classes_Var_Pop_Fields = {
  __typename?: 'payment_advice_classes_var_pop_fields';
  additionalDiscount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "payment_advice_classes" */
export type Payment_Advice_Classes_Var_Pop_Order_By = {
  additionalDiscount?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Payment_Advice_Classes_Var_Samp_Fields = {
  __typename?: 'payment_advice_classes_var_samp_fields';
  additionalDiscount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "payment_advice_classes" */
export type Payment_Advice_Classes_Var_Samp_Order_By = {
  additionalDiscount?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Payment_Advice_Classes_Variance_Fields = {
  __typename?: 'payment_advice_classes_variance_fields';
  additionalDiscount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "payment_advice_classes" */
export type Payment_Advice_Classes_Variance_Order_By = {
  additionalDiscount?: Maybe<Order_By>;
};

/** columns and relationships of "payment_advice_delete_logs" */
export type Payment_Advice_Delete_Logs = {
  __typename?: 'payment_advice_delete_logs';
  /** An object relationship */
  createUser?: Maybe<Users>;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "payment_advice_delete_logs" */
export type Payment_Advice_Delete_Logs_Aggregate = {
  __typename?: 'payment_advice_delete_logs_aggregate';
  aggregate?: Maybe<Payment_Advice_Delete_Logs_Aggregate_Fields>;
  nodes: Array<Payment_Advice_Delete_Logs>;
};

/** aggregate fields of "payment_advice_delete_logs" */
export type Payment_Advice_Delete_Logs_Aggregate_Fields = {
  __typename?: 'payment_advice_delete_logs_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Payment_Advice_Delete_Logs_Max_Fields>;
  min?: Maybe<Payment_Advice_Delete_Logs_Min_Fields>;
};


/** aggregate fields of "payment_advice_delete_logs" */
export type Payment_Advice_Delete_Logs_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Payment_Advice_Delete_Logs_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payment_advice_delete_logs" */
export type Payment_Advice_Delete_Logs_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Payment_Advice_Delete_Logs_Max_Order_By>;
  min?: Maybe<Payment_Advice_Delete_Logs_Min_Order_By>;
};

/** input type for inserting array relation for remote table "payment_advice_delete_logs" */
export type Payment_Advice_Delete_Logs_Arr_Rel_Insert_Input = {
  data: Array<Payment_Advice_Delete_Logs_Insert_Input>;
  on_conflict?: Maybe<Payment_Advice_Delete_Logs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "payment_advice_delete_logs". All fields are combined with a logical 'AND'. */
export type Payment_Advice_Delete_Logs_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Payment_Advice_Delete_Logs_Bool_Exp>>>;
  _not?: Maybe<Payment_Advice_Delete_Logs_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Payment_Advice_Delete_Logs_Bool_Exp>>>;
  createUser?: Maybe<Users_Bool_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "payment_advice_delete_logs" */
export enum Payment_Advice_Delete_Logs_Constraint {
  /** unique or primary key constraint */
  PaymentAdviceDeleteLogsPkey = 'payment_advice_delete_logs_pkey'
}

/** input type for inserting data into table "payment_advice_delete_logs" */
export type Payment_Advice_Delete_Logs_Insert_Input = {
  createUser?: Maybe<Users_Obj_Rel_Insert_Input>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Payment_Advice_Delete_Logs_Max_Fields = {
  __typename?: 'payment_advice_delete_logs_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "payment_advice_delete_logs" */
export type Payment_Advice_Delete_Logs_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Payment_Advice_Delete_Logs_Min_Fields = {
  __typename?: 'payment_advice_delete_logs_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "payment_advice_delete_logs" */
export type Payment_Advice_Delete_Logs_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "payment_advice_delete_logs" */
export type Payment_Advice_Delete_Logs_Mutation_Response = {
  __typename?: 'payment_advice_delete_logs_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Payment_Advice_Delete_Logs>;
};

/** input type for inserting object relation for remote table "payment_advice_delete_logs" */
export type Payment_Advice_Delete_Logs_Obj_Rel_Insert_Input = {
  data: Payment_Advice_Delete_Logs_Insert_Input;
  on_conflict?: Maybe<Payment_Advice_Delete_Logs_On_Conflict>;
};

/** on conflict condition type for table "payment_advice_delete_logs" */
export type Payment_Advice_Delete_Logs_On_Conflict = {
  constraint: Payment_Advice_Delete_Logs_Constraint;
  update_columns: Array<Payment_Advice_Delete_Logs_Update_Column>;
  where?: Maybe<Payment_Advice_Delete_Logs_Bool_Exp>;
};

/** ordering options when selecting data from "payment_advice_delete_logs" */
export type Payment_Advice_Delete_Logs_Order_By = {
  createUser?: Maybe<Users_Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "payment_advice_delete_logs" */
export type Payment_Advice_Delete_Logs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "payment_advice_delete_logs" */
export enum Payment_Advice_Delete_Logs_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "payment_advice_delete_logs" */
export type Payment_Advice_Delete_Logs_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "payment_advice_delete_logs" */
export enum Payment_Advice_Delete_Logs_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type Payment_Advice_Filter_Args = {
  month?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "payment_advice_logs" */
export type Payment_Advice_Logs = {
  __typename?: 'payment_advice_logs';
  createdAt: Scalars['timestamptz'];
  createdBy: Scalars['uuid'];
  id: Scalars['uuid'];
  key: Scalars['String'];
  /** An object relationship */
  paymentAdvice: Payment_Advices;
  paymentAdviceId: Scalars['uuid'];
  status: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user: Users;
  valueAfter?: Maybe<Scalars['jsonb']>;
  valueBefore?: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "payment_advice_logs" */
export type Payment_Advice_LogsValueAfterArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "payment_advice_logs" */
export type Payment_Advice_LogsValueBeforeArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "payment_advice_logs" */
export type Payment_Advice_Logs_Aggregate = {
  __typename?: 'payment_advice_logs_aggregate';
  aggregate?: Maybe<Payment_Advice_Logs_Aggregate_Fields>;
  nodes: Array<Payment_Advice_Logs>;
};

/** aggregate fields of "payment_advice_logs" */
export type Payment_Advice_Logs_Aggregate_Fields = {
  __typename?: 'payment_advice_logs_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Payment_Advice_Logs_Max_Fields>;
  min?: Maybe<Payment_Advice_Logs_Min_Fields>;
};


/** aggregate fields of "payment_advice_logs" */
export type Payment_Advice_Logs_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Payment_Advice_Logs_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payment_advice_logs" */
export type Payment_Advice_Logs_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Payment_Advice_Logs_Max_Order_By>;
  min?: Maybe<Payment_Advice_Logs_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Payment_Advice_Logs_Append_Input = {
  valueAfter?: Maybe<Scalars['jsonb']>;
  valueBefore?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "payment_advice_logs" */
export type Payment_Advice_Logs_Arr_Rel_Insert_Input = {
  data: Array<Payment_Advice_Logs_Insert_Input>;
  on_conflict?: Maybe<Payment_Advice_Logs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "payment_advice_logs". All fields are combined with a logical 'AND'. */
export type Payment_Advice_Logs_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Payment_Advice_Logs_Bool_Exp>>>;
  _not?: Maybe<Payment_Advice_Logs_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Payment_Advice_Logs_Bool_Exp>>>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  key?: Maybe<String_Comparison_Exp>;
  paymentAdvice?: Maybe<Payment_Advices_Bool_Exp>;
  paymentAdviceId?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  type?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  valueAfter?: Maybe<Jsonb_Comparison_Exp>;
  valueBefore?: Maybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "payment_advice_logs" */
export enum Payment_Advice_Logs_Constraint {
  /** unique or primary key constraint */
  PaymentAdviceLogsPkey = 'payment_advice_logs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Payment_Advice_Logs_Delete_At_Path_Input = {
  valueAfter?: Maybe<Array<Maybe<Scalars['String']>>>;
  valueBefore?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Payment_Advice_Logs_Delete_Elem_Input = {
  valueAfter?: Maybe<Scalars['Int']>;
  valueBefore?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Payment_Advice_Logs_Delete_Key_Input = {
  valueAfter?: Maybe<Scalars['String']>;
  valueBefore?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "payment_advice_logs" */
export type Payment_Advice_Logs_Insert_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  paymentAdvice?: Maybe<Payment_Advices_Obj_Rel_Insert_Input>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  valueAfter?: Maybe<Scalars['jsonb']>;
  valueBefore?: Maybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type Payment_Advice_Logs_Max_Fields = {
  __typename?: 'payment_advice_logs_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "payment_advice_logs" */
export type Payment_Advice_Logs_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  key?: Maybe<Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Payment_Advice_Logs_Min_Fields = {
  __typename?: 'payment_advice_logs_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "payment_advice_logs" */
export type Payment_Advice_Logs_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  key?: Maybe<Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "payment_advice_logs" */
export type Payment_Advice_Logs_Mutation_Response = {
  __typename?: 'payment_advice_logs_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Payment_Advice_Logs>;
};

/** input type for inserting object relation for remote table "payment_advice_logs" */
export type Payment_Advice_Logs_Obj_Rel_Insert_Input = {
  data: Payment_Advice_Logs_Insert_Input;
  on_conflict?: Maybe<Payment_Advice_Logs_On_Conflict>;
};

/** on conflict condition type for table "payment_advice_logs" */
export type Payment_Advice_Logs_On_Conflict = {
  constraint: Payment_Advice_Logs_Constraint;
  update_columns: Array<Payment_Advice_Logs_Update_Column>;
  where?: Maybe<Payment_Advice_Logs_Bool_Exp>;
};

/** ordering options when selecting data from "payment_advice_logs" */
export type Payment_Advice_Logs_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  key?: Maybe<Order_By>;
  paymentAdvice?: Maybe<Payment_Advices_Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  valueAfter?: Maybe<Order_By>;
  valueBefore?: Maybe<Order_By>;
};

/** primary key columns input for table: "payment_advice_logs" */
export type Payment_Advice_Logs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Payment_Advice_Logs_Prepend_Input = {
  valueAfter?: Maybe<Scalars['jsonb']>;
  valueBefore?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "payment_advice_logs" */
export enum Payment_Advice_Logs_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  PaymentAdviceId = 'paymentAdviceId',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  ValueAfter = 'valueAfter',
  /** column name */
  ValueBefore = 'valueBefore'
}

/** input type for updating data in table "payment_advice_logs" */
export type Payment_Advice_Logs_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  valueAfter?: Maybe<Scalars['jsonb']>;
  valueBefore?: Maybe<Scalars['jsonb']>;
};

/** update columns of table "payment_advice_logs" */
export enum Payment_Advice_Logs_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  PaymentAdviceId = 'paymentAdviceId',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  ValueAfter = 'valueAfter',
  /** column name */
  ValueBefore = 'valueBefore'
}

/** columns and relationships of "payment_advice_term_classes" */
export type Payment_Advice_Term_Classes = {
  __typename?: 'payment_advice_term_classes';
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  lessonIds: Scalars['jsonb'];
  /** An object relationship */
  paymentAdviceClass: Payment_Advice_Classes;
  paymentAdviceClassId: Scalars['uuid'];
  pricing: Scalars['numeric'];
  status: Scalars['String'];
  /** An object relationship */
  termClass?: Maybe<Term_Classes>;
  termClassId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "payment_advice_term_classes" */
export type Payment_Advice_Term_ClassesLessonIdsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "payment_advice_term_classes" */
export type Payment_Advice_Term_Classes_Aggregate = {
  __typename?: 'payment_advice_term_classes_aggregate';
  aggregate?: Maybe<Payment_Advice_Term_Classes_Aggregate_Fields>;
  nodes: Array<Payment_Advice_Term_Classes>;
};

/** aggregate fields of "payment_advice_term_classes" */
export type Payment_Advice_Term_Classes_Aggregate_Fields = {
  __typename?: 'payment_advice_term_classes_aggregate_fields';
  avg?: Maybe<Payment_Advice_Term_Classes_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Payment_Advice_Term_Classes_Max_Fields>;
  min?: Maybe<Payment_Advice_Term_Classes_Min_Fields>;
  stddev?: Maybe<Payment_Advice_Term_Classes_Stddev_Fields>;
  stddev_pop?: Maybe<Payment_Advice_Term_Classes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Payment_Advice_Term_Classes_Stddev_Samp_Fields>;
  sum?: Maybe<Payment_Advice_Term_Classes_Sum_Fields>;
  var_pop?: Maybe<Payment_Advice_Term_Classes_Var_Pop_Fields>;
  var_samp?: Maybe<Payment_Advice_Term_Classes_Var_Samp_Fields>;
  variance?: Maybe<Payment_Advice_Term_Classes_Variance_Fields>;
};


/** aggregate fields of "payment_advice_term_classes" */
export type Payment_Advice_Term_Classes_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Payment_Advice_Term_Classes_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payment_advice_term_classes" */
export type Payment_Advice_Term_Classes_Aggregate_Order_By = {
  avg?: Maybe<Payment_Advice_Term_Classes_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Payment_Advice_Term_Classes_Max_Order_By>;
  min?: Maybe<Payment_Advice_Term_Classes_Min_Order_By>;
  stddev?: Maybe<Payment_Advice_Term_Classes_Stddev_Order_By>;
  stddev_pop?: Maybe<Payment_Advice_Term_Classes_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Payment_Advice_Term_Classes_Stddev_Samp_Order_By>;
  sum?: Maybe<Payment_Advice_Term_Classes_Sum_Order_By>;
  var_pop?: Maybe<Payment_Advice_Term_Classes_Var_Pop_Order_By>;
  var_samp?: Maybe<Payment_Advice_Term_Classes_Var_Samp_Order_By>;
  variance?: Maybe<Payment_Advice_Term_Classes_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Payment_Advice_Term_Classes_Append_Input = {
  lessonIds?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "payment_advice_term_classes" */
export type Payment_Advice_Term_Classes_Arr_Rel_Insert_Input = {
  data: Array<Payment_Advice_Term_Classes_Insert_Input>;
  on_conflict?: Maybe<Payment_Advice_Term_Classes_On_Conflict>;
};

/** aggregate avg on columns */
export type Payment_Advice_Term_Classes_Avg_Fields = {
  __typename?: 'payment_advice_term_classes_avg_fields';
  pricing?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "payment_advice_term_classes" */
export type Payment_Advice_Term_Classes_Avg_Order_By = {
  pricing?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "payment_advice_term_classes". All fields are combined with a logical 'AND'. */
export type Payment_Advice_Term_Classes_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Payment_Advice_Term_Classes_Bool_Exp>>>;
  _not?: Maybe<Payment_Advice_Term_Classes_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Payment_Advice_Term_Classes_Bool_Exp>>>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  lessonIds?: Maybe<Jsonb_Comparison_Exp>;
  paymentAdviceClass?: Maybe<Payment_Advice_Classes_Bool_Exp>;
  paymentAdviceClassId?: Maybe<Uuid_Comparison_Exp>;
  pricing?: Maybe<Numeric_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  termClass?: Maybe<Term_Classes_Bool_Exp>;
  termClassId?: Maybe<Uuid_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "payment_advice_term_classes" */
export enum Payment_Advice_Term_Classes_Constraint {
  /** unique or primary key constraint */
  PaymentAdviceTermClassesPkey = 'payment_advice_term_classes_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Payment_Advice_Term_Classes_Delete_At_Path_Input = {
  lessonIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Payment_Advice_Term_Classes_Delete_Elem_Input = {
  lessonIds?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Payment_Advice_Term_Classes_Delete_Key_Input = {
  lessonIds?: Maybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "payment_advice_term_classes" */
export type Payment_Advice_Term_Classes_Inc_Input = {
  pricing?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "payment_advice_term_classes" */
export type Payment_Advice_Term_Classes_Insert_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  lessonIds?: Maybe<Scalars['jsonb']>;
  paymentAdviceClass?: Maybe<Payment_Advice_Classes_Obj_Rel_Insert_Input>;
  paymentAdviceClassId?: Maybe<Scalars['uuid']>;
  pricing?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  termClass?: Maybe<Term_Classes_Obj_Rel_Insert_Input>;
  termClassId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Payment_Advice_Term_Classes_Max_Fields = {
  __typename?: 'payment_advice_term_classes_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdviceClassId?: Maybe<Scalars['uuid']>;
  pricing?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  termClassId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "payment_advice_term_classes" */
export type Payment_Advice_Term_Classes_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  paymentAdviceClassId?: Maybe<Order_By>;
  pricing?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  termClassId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Payment_Advice_Term_Classes_Min_Fields = {
  __typename?: 'payment_advice_term_classes_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdviceClassId?: Maybe<Scalars['uuid']>;
  pricing?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  termClassId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "payment_advice_term_classes" */
export type Payment_Advice_Term_Classes_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  paymentAdviceClassId?: Maybe<Order_By>;
  pricing?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  termClassId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "payment_advice_term_classes" */
export type Payment_Advice_Term_Classes_Mutation_Response = {
  __typename?: 'payment_advice_term_classes_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Payment_Advice_Term_Classes>;
};

/** input type for inserting object relation for remote table "payment_advice_term_classes" */
export type Payment_Advice_Term_Classes_Obj_Rel_Insert_Input = {
  data: Payment_Advice_Term_Classes_Insert_Input;
  on_conflict?: Maybe<Payment_Advice_Term_Classes_On_Conflict>;
};

/** on conflict condition type for table "payment_advice_term_classes" */
export type Payment_Advice_Term_Classes_On_Conflict = {
  constraint: Payment_Advice_Term_Classes_Constraint;
  update_columns: Array<Payment_Advice_Term_Classes_Update_Column>;
  where?: Maybe<Payment_Advice_Term_Classes_Bool_Exp>;
};

/** ordering options when selecting data from "payment_advice_term_classes" */
export type Payment_Advice_Term_Classes_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lessonIds?: Maybe<Order_By>;
  paymentAdviceClass?: Maybe<Payment_Advice_Classes_Order_By>;
  paymentAdviceClassId?: Maybe<Order_By>;
  pricing?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  termClass?: Maybe<Term_Classes_Order_By>;
  termClassId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "payment_advice_term_classes" */
export type Payment_Advice_Term_Classes_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Payment_Advice_Term_Classes_Prepend_Input = {
  lessonIds?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "payment_advice_term_classes" */
export enum Payment_Advice_Term_Classes_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  LessonIds = 'lessonIds',
  /** column name */
  PaymentAdviceClassId = 'paymentAdviceClassId',
  /** column name */
  Pricing = 'pricing',
  /** column name */
  Status = 'status',
  /** column name */
  TermClassId = 'termClassId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "payment_advice_term_classes" */
export type Payment_Advice_Term_Classes_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  lessonIds?: Maybe<Scalars['jsonb']>;
  paymentAdviceClassId?: Maybe<Scalars['uuid']>;
  pricing?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  termClassId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Payment_Advice_Term_Classes_Stddev_Fields = {
  __typename?: 'payment_advice_term_classes_stddev_fields';
  pricing?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "payment_advice_term_classes" */
export type Payment_Advice_Term_Classes_Stddev_Order_By = {
  pricing?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Payment_Advice_Term_Classes_Stddev_Pop_Fields = {
  __typename?: 'payment_advice_term_classes_stddev_pop_fields';
  pricing?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "payment_advice_term_classes" */
export type Payment_Advice_Term_Classes_Stddev_Pop_Order_By = {
  pricing?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Payment_Advice_Term_Classes_Stddev_Samp_Fields = {
  __typename?: 'payment_advice_term_classes_stddev_samp_fields';
  pricing?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "payment_advice_term_classes" */
export type Payment_Advice_Term_Classes_Stddev_Samp_Order_By = {
  pricing?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Payment_Advice_Term_Classes_Sum_Fields = {
  __typename?: 'payment_advice_term_classes_sum_fields';
  pricing?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "payment_advice_term_classes" */
export type Payment_Advice_Term_Classes_Sum_Order_By = {
  pricing?: Maybe<Order_By>;
};

/** update columns of table "payment_advice_term_classes" */
export enum Payment_Advice_Term_Classes_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  LessonIds = 'lessonIds',
  /** column name */
  PaymentAdviceClassId = 'paymentAdviceClassId',
  /** column name */
  Pricing = 'pricing',
  /** column name */
  Status = 'status',
  /** column name */
  TermClassId = 'termClassId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** aggregate var_pop on columns */
export type Payment_Advice_Term_Classes_Var_Pop_Fields = {
  __typename?: 'payment_advice_term_classes_var_pop_fields';
  pricing?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "payment_advice_term_classes" */
export type Payment_Advice_Term_Classes_Var_Pop_Order_By = {
  pricing?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Payment_Advice_Term_Classes_Var_Samp_Fields = {
  __typename?: 'payment_advice_term_classes_var_samp_fields';
  pricing?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "payment_advice_term_classes" */
export type Payment_Advice_Term_Classes_Var_Samp_Order_By = {
  pricing?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Payment_Advice_Term_Classes_Variance_Fields = {
  __typename?: 'payment_advice_term_classes_variance_fields';
  pricing?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "payment_advice_term_classes" */
export type Payment_Advice_Term_Classes_Variance_Order_By = {
  pricing?: Maybe<Order_By>;
};

/** columns and relationships of "payment_advice_transfers" */
export type Payment_Advice_Transfers = {
  __typename?: 'payment_advice_transfers';
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An array relationship */
  paClassesTransfer: Array<Payment_Advice_Class_Transfer>;
  /** An aggregated array relationship */
  paClassesTransfer_aggregate: Payment_Advice_Class_Transfer_Aggregate;
  /** An object relationship */
  paymentAdvice: Payment_Advices;
  paymentAdviceId: Scalars['uuid'];
  reason: Scalars['String'];
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "payment_advice_transfers" */
export type Payment_Advice_TransfersPaClassesTransferArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Class_Transfer_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Class_Transfer_Order_By>>;
  where?: Maybe<Payment_Advice_Class_Transfer_Bool_Exp>;
};


/** columns and relationships of "payment_advice_transfers" */
export type Payment_Advice_TransfersPaClassesTransfer_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Class_Transfer_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Class_Transfer_Order_By>>;
  where?: Maybe<Payment_Advice_Class_Transfer_Bool_Exp>;
};

/** aggregated selection of "payment_advice_transfers" */
export type Payment_Advice_Transfers_Aggregate = {
  __typename?: 'payment_advice_transfers_aggregate';
  aggregate?: Maybe<Payment_Advice_Transfers_Aggregate_Fields>;
  nodes: Array<Payment_Advice_Transfers>;
};

/** aggregate fields of "payment_advice_transfers" */
export type Payment_Advice_Transfers_Aggregate_Fields = {
  __typename?: 'payment_advice_transfers_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Payment_Advice_Transfers_Max_Fields>;
  min?: Maybe<Payment_Advice_Transfers_Min_Fields>;
};


/** aggregate fields of "payment_advice_transfers" */
export type Payment_Advice_Transfers_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Payment_Advice_Transfers_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payment_advice_transfers" */
export type Payment_Advice_Transfers_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Payment_Advice_Transfers_Max_Order_By>;
  min?: Maybe<Payment_Advice_Transfers_Min_Order_By>;
};

/** input type for inserting array relation for remote table "payment_advice_transfers" */
export type Payment_Advice_Transfers_Arr_Rel_Insert_Input = {
  data: Array<Payment_Advice_Transfers_Insert_Input>;
  on_conflict?: Maybe<Payment_Advice_Transfers_On_Conflict>;
};

/** Boolean expression to filter rows from the table "payment_advice_transfers". All fields are combined with a logical 'AND'. */
export type Payment_Advice_Transfers_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Payment_Advice_Transfers_Bool_Exp>>>;
  _not?: Maybe<Payment_Advice_Transfers_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Payment_Advice_Transfers_Bool_Exp>>>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  paClassesTransfer?: Maybe<Payment_Advice_Class_Transfer_Bool_Exp>;
  paymentAdvice?: Maybe<Payment_Advices_Bool_Exp>;
  paymentAdviceId?: Maybe<Uuid_Comparison_Exp>;
  reason?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "payment_advice_transfers" */
export enum Payment_Advice_Transfers_Constraint {
  /** unique or primary key constraint */
  PaymentAdviceTransfersPkey = 'payment_advice_transfers_pkey'
}

/** input type for inserting data into table "payment_advice_transfers" */
export type Payment_Advice_Transfers_Insert_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paClassesTransfer?: Maybe<Payment_Advice_Class_Transfer_Arr_Rel_Insert_Input>;
  paymentAdvice?: Maybe<Payment_Advices_Obj_Rel_Insert_Input>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Payment_Advice_Transfers_Max_Fields = {
  __typename?: 'payment_advice_transfers_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "payment_advice_transfers" */
export type Payment_Advice_Transfers_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  reason?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Payment_Advice_Transfers_Min_Fields = {
  __typename?: 'payment_advice_transfers_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "payment_advice_transfers" */
export type Payment_Advice_Transfers_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  reason?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "payment_advice_transfers" */
export type Payment_Advice_Transfers_Mutation_Response = {
  __typename?: 'payment_advice_transfers_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Payment_Advice_Transfers>;
};

/** input type for inserting object relation for remote table "payment_advice_transfers" */
export type Payment_Advice_Transfers_Obj_Rel_Insert_Input = {
  data: Payment_Advice_Transfers_Insert_Input;
  on_conflict?: Maybe<Payment_Advice_Transfers_On_Conflict>;
};

/** on conflict condition type for table "payment_advice_transfers" */
export type Payment_Advice_Transfers_On_Conflict = {
  constraint: Payment_Advice_Transfers_Constraint;
  update_columns: Array<Payment_Advice_Transfers_Update_Column>;
  where?: Maybe<Payment_Advice_Transfers_Bool_Exp>;
};

/** ordering options when selecting data from "payment_advice_transfers" */
export type Payment_Advice_Transfers_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  paClassesTransfer_aggregate?: Maybe<Payment_Advice_Class_Transfer_Aggregate_Order_By>;
  paymentAdvice?: Maybe<Payment_Advices_Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  reason?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "payment_advice_transfers" */
export type Payment_Advice_Transfers_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "payment_advice_transfers" */
export enum Payment_Advice_Transfers_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentAdviceId = 'paymentAdviceId',
  /** column name */
  Reason = 'reason',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "payment_advice_transfers" */
export type Payment_Advice_Transfers_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "payment_advice_transfers" */
export enum Payment_Advice_Transfers_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentAdviceId = 'paymentAdviceId',
  /** column name */
  Reason = 'reason',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** columns and relationships of "payment_advices" */
export type Payment_Advices = {
  __typename?: 'payment_advices';
  /** An array relationship */
  additional_class_tickets: Array<Additional_Class_Tickets>;
  /** An aggregated array relationship */
  additional_class_tickets_aggregate: Additional_Class_Tickets_Aggregate;
  /** An object relationship */
  batchPaymentAdvice?: Maybe<Batch_Payment_Advices>;
  batchPaymentAdviceId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  branch?: Maybe<Branches>;
  branchId?: Maybe<Scalars['uuid']>;
  classInformation?: Maybe<Scalars['jsonb']>;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  creditNoteIds: Scalars['jsonb'];
  /** A computed field, executes function "payment_advices_field_credit_notes" */
  creditNotes?: Maybe<Array<Credit_Notes>>;
  deduction?: Maybe<Scalars['jsonb']>;
  deposit?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  discount_bills: Array<Discount_Bills>;
  /** An aggregated array relationship */
  discount_bills_aggregate: Discount_Bills_Aggregate;
  dueDate?: Maybe<Scalars['timestamptz']>;
  hasExpiryDate?: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  /** An array relationship */
  invoices: Array<Invoices>;
  /** An aggregated array relationship */
  invoices_aggregate: Invoices_Aggregate;
  isOverdueAtPaid?: Maybe<Scalars['Boolean']>;
  isRegistrationFee?: Maybe<Scalars['Boolean']>;
  isTransfer?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['timestamptz']>;
  link?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  otherPayments?: Maybe<Scalars['jsonb']>;
  paidAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  paymentAdviceClasses: Array<Payment_Advice_Classes>;
  /** An aggregated array relationship */
  paymentAdviceClasses_aggregate: Payment_Advice_Classes_Aggregate;
  paymentStatus: Scalars['String'];
  paymentStatusFilter?: Maybe<Scalars['String']>;
  paymentSummaryStatic?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  payment_advice_logs: Array<Payment_Advice_Logs>;
  /** An aggregated array relationship */
  payment_advice_logs_aggregate: Payment_Advice_Logs_Aggregate;
  /** An array relationship */
  payment_advice_transfers: Array<Payment_Advice_Transfers>;
  /** An aggregated array relationship */
  payment_advice_transfers_aggregate: Payment_Advice_Transfers_Aggregate;
  placeOfCreation?: Maybe<Scalars['String']>;
  qrCodeLink?: Maybe<Scalars['String']>;
  qrExpiryDate?: Maybe<Scalars['timestamp']>;
  qrReferenceNo?: Maybe<Scalars['String']>;
  registrationFeeConfig?: Maybe<Scalars['jsonb']>;
  remarks?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  /** An object relationship */
  student?: Maybe<Users>;
  studentId?: Maybe<Scalars['uuid']>;
  unpaidAt?: Maybe<Scalars['timestamp']>;
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  userByCreatedby?: Maybe<Users>;
};


/** columns and relationships of "payment_advices" */
export type Payment_AdvicesAdditional_Class_TicketsArgs = {
  distinct_on?: Maybe<Array<Additional_Class_Tickets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Additional_Class_Tickets_Order_By>>;
  where?: Maybe<Additional_Class_Tickets_Bool_Exp>;
};


/** columns and relationships of "payment_advices" */
export type Payment_AdvicesAdditional_Class_Tickets_AggregateArgs = {
  distinct_on?: Maybe<Array<Additional_Class_Tickets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Additional_Class_Tickets_Order_By>>;
  where?: Maybe<Additional_Class_Tickets_Bool_Exp>;
};


/** columns and relationships of "payment_advices" */
export type Payment_AdvicesClassInformationArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "payment_advices" */
export type Payment_AdvicesCreditNoteIdsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "payment_advices" */
export type Payment_AdvicesCreditNotesArgs = {
  distinct_on?: Maybe<Array<Credit_Notes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Notes_Order_By>>;
  where?: Maybe<Credit_Notes_Bool_Exp>;
};


/** columns and relationships of "payment_advices" */
export type Payment_AdvicesDeductionArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "payment_advices" */
export type Payment_AdvicesDepositArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "payment_advices" */
export type Payment_AdvicesDiscount_BillsArgs = {
  distinct_on?: Maybe<Array<Discount_Bills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discount_Bills_Order_By>>;
  where?: Maybe<Discount_Bills_Bool_Exp>;
};


/** columns and relationships of "payment_advices" */
export type Payment_AdvicesDiscount_Bills_AggregateArgs = {
  distinct_on?: Maybe<Array<Discount_Bills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discount_Bills_Order_By>>;
  where?: Maybe<Discount_Bills_Bool_Exp>;
};


/** columns and relationships of "payment_advices" */
export type Payment_AdvicesInvoicesArgs = {
  distinct_on?: Maybe<Array<Invoices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoices_Order_By>>;
  where?: Maybe<Invoices_Bool_Exp>;
};


/** columns and relationships of "payment_advices" */
export type Payment_AdvicesInvoices_AggregateArgs = {
  distinct_on?: Maybe<Array<Invoices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoices_Order_By>>;
  where?: Maybe<Invoices_Bool_Exp>;
};


/** columns and relationships of "payment_advices" */
export type Payment_AdvicesOtherPaymentsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "payment_advices" */
export type Payment_AdvicesPaymentAdviceClassesArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Classes_Order_By>>;
  where?: Maybe<Payment_Advice_Classes_Bool_Exp>;
};


/** columns and relationships of "payment_advices" */
export type Payment_AdvicesPaymentAdviceClasses_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Classes_Order_By>>;
  where?: Maybe<Payment_Advice_Classes_Bool_Exp>;
};


/** columns and relationships of "payment_advices" */
export type Payment_AdvicesPaymentSummaryStaticArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "payment_advices" */
export type Payment_AdvicesPayment_Advice_LogsArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Logs_Order_By>>;
  where?: Maybe<Payment_Advice_Logs_Bool_Exp>;
};


/** columns and relationships of "payment_advices" */
export type Payment_AdvicesPayment_Advice_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Logs_Order_By>>;
  where?: Maybe<Payment_Advice_Logs_Bool_Exp>;
};


/** columns and relationships of "payment_advices" */
export type Payment_AdvicesPayment_Advice_TransfersArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Transfers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Transfers_Order_By>>;
  where?: Maybe<Payment_Advice_Transfers_Bool_Exp>;
};


/** columns and relationships of "payment_advices" */
export type Payment_AdvicesPayment_Advice_Transfers_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Transfers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Transfers_Order_By>>;
  where?: Maybe<Payment_Advice_Transfers_Bool_Exp>;
};


/** columns and relationships of "payment_advices" */
export type Payment_AdvicesRegistrationFeeConfigArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "payment_advices" */
export type Payment_Advices_Aggregate = {
  __typename?: 'payment_advices_aggregate';
  aggregate?: Maybe<Payment_Advices_Aggregate_Fields>;
  nodes: Array<Payment_Advices>;
};

/** aggregate fields of "payment_advices" */
export type Payment_Advices_Aggregate_Fields = {
  __typename?: 'payment_advices_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Payment_Advices_Max_Fields>;
  min?: Maybe<Payment_Advices_Min_Fields>;
};


/** aggregate fields of "payment_advices" */
export type Payment_Advices_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Payment_Advices_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payment_advices" */
export type Payment_Advices_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Payment_Advices_Max_Order_By>;
  min?: Maybe<Payment_Advices_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Payment_Advices_Append_Input = {
  classInformation?: Maybe<Scalars['jsonb']>;
  creditNoteIds?: Maybe<Scalars['jsonb']>;
  deduction?: Maybe<Scalars['jsonb']>;
  deposit?: Maybe<Scalars['jsonb']>;
  otherPayments?: Maybe<Scalars['jsonb']>;
  paymentSummaryStatic?: Maybe<Scalars['jsonb']>;
  registrationFeeConfig?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "payment_advices" */
export type Payment_Advices_Arr_Rel_Insert_Input = {
  data: Array<Payment_Advices_Insert_Input>;
  on_conflict?: Maybe<Payment_Advices_On_Conflict>;
};

/** Boolean expression to filter rows from the table "payment_advices". All fields are combined with a logical 'AND'. */
export type Payment_Advices_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Payment_Advices_Bool_Exp>>>;
  _not?: Maybe<Payment_Advices_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Payment_Advices_Bool_Exp>>>;
  additional_class_tickets?: Maybe<Additional_Class_Tickets_Bool_Exp>;
  batchPaymentAdvice?: Maybe<Batch_Payment_Advices_Bool_Exp>;
  batchPaymentAdviceId?: Maybe<Uuid_Comparison_Exp>;
  branch?: Maybe<Branches_Bool_Exp>;
  branchId?: Maybe<Uuid_Comparison_Exp>;
  classInformation?: Maybe<Jsonb_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  creditNoteIds?: Maybe<Jsonb_Comparison_Exp>;
  deduction?: Maybe<Jsonb_Comparison_Exp>;
  deposit?: Maybe<Jsonb_Comparison_Exp>;
  discount_bills?: Maybe<Discount_Bills_Bool_Exp>;
  dueDate?: Maybe<Timestamptz_Comparison_Exp>;
  hasExpiryDate?: Maybe<Boolean_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  invoices?: Maybe<Invoices_Bool_Exp>;
  isOverdueAtPaid?: Maybe<Boolean_Comparison_Exp>;
  isRegistrationFee?: Maybe<Boolean_Comparison_Exp>;
  isTransfer?: Maybe<Boolean_Comparison_Exp>;
  issueDate?: Maybe<Timestamptz_Comparison_Exp>;
  link?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  notes?: Maybe<String_Comparison_Exp>;
  otherPayments?: Maybe<Jsonb_Comparison_Exp>;
  paidAt?: Maybe<Timestamptz_Comparison_Exp>;
  paymentAdviceClasses?: Maybe<Payment_Advice_Classes_Bool_Exp>;
  paymentStatus?: Maybe<String_Comparison_Exp>;
  paymentStatusFilter?: Maybe<String_Comparison_Exp>;
  paymentSummaryStatic?: Maybe<Jsonb_Comparison_Exp>;
  payment_advice_logs?: Maybe<Payment_Advice_Logs_Bool_Exp>;
  payment_advice_transfers?: Maybe<Payment_Advice_Transfers_Bool_Exp>;
  placeOfCreation?: Maybe<String_Comparison_Exp>;
  qrCodeLink?: Maybe<String_Comparison_Exp>;
  qrExpiryDate?: Maybe<Timestamp_Comparison_Exp>;
  qrReferenceNo?: Maybe<String_Comparison_Exp>;
  registrationFeeConfig?: Maybe<Jsonb_Comparison_Exp>;
  remarks?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  student?: Maybe<Users_Bool_Exp>;
  studentId?: Maybe<Uuid_Comparison_Exp>;
  unpaidAt?: Maybe<Timestamp_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  userByCreatedby?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "payment_advices" */
export enum Payment_Advices_Constraint {
  /** unique or primary key constraint */
  PaymentAdvicesNameKey = 'payment_advices_name_key',
  /** unique or primary key constraint */
  PaymentAdvisesPkey = 'payment_advises_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Payment_Advices_Delete_At_Path_Input = {
  classInformation?: Maybe<Array<Maybe<Scalars['String']>>>;
  creditNoteIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  deduction?: Maybe<Array<Maybe<Scalars['String']>>>;
  deposit?: Maybe<Array<Maybe<Scalars['String']>>>;
  otherPayments?: Maybe<Array<Maybe<Scalars['String']>>>;
  paymentSummaryStatic?: Maybe<Array<Maybe<Scalars['String']>>>;
  registrationFeeConfig?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Payment_Advices_Delete_Elem_Input = {
  classInformation?: Maybe<Scalars['Int']>;
  creditNoteIds?: Maybe<Scalars['Int']>;
  deduction?: Maybe<Scalars['Int']>;
  deposit?: Maybe<Scalars['Int']>;
  otherPayments?: Maybe<Scalars['Int']>;
  paymentSummaryStatic?: Maybe<Scalars['Int']>;
  registrationFeeConfig?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Payment_Advices_Delete_Key_Input = {
  classInformation?: Maybe<Scalars['String']>;
  creditNoteIds?: Maybe<Scalars['String']>;
  deduction?: Maybe<Scalars['String']>;
  deposit?: Maybe<Scalars['String']>;
  otherPayments?: Maybe<Scalars['String']>;
  paymentSummaryStatic?: Maybe<Scalars['String']>;
  registrationFeeConfig?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "payment_advices" */
export type Payment_Advices_Insert_Input = {
  additional_class_tickets?: Maybe<Additional_Class_Tickets_Arr_Rel_Insert_Input>;
  batchPaymentAdvice?: Maybe<Batch_Payment_Advices_Obj_Rel_Insert_Input>;
  batchPaymentAdviceId?: Maybe<Scalars['uuid']>;
  branch?: Maybe<Branches_Obj_Rel_Insert_Input>;
  branchId?: Maybe<Scalars['uuid']>;
  classInformation?: Maybe<Scalars['jsonb']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  creditNoteIds?: Maybe<Scalars['jsonb']>;
  deduction?: Maybe<Scalars['jsonb']>;
  deposit?: Maybe<Scalars['jsonb']>;
  discount_bills?: Maybe<Discount_Bills_Arr_Rel_Insert_Input>;
  dueDate?: Maybe<Scalars['timestamptz']>;
  hasExpiryDate?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  invoices?: Maybe<Invoices_Arr_Rel_Insert_Input>;
  isOverdueAtPaid?: Maybe<Scalars['Boolean']>;
  isRegistrationFee?: Maybe<Scalars['Boolean']>;
  isTransfer?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['timestamptz']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  otherPayments?: Maybe<Scalars['jsonb']>;
  paidAt?: Maybe<Scalars['timestamptz']>;
  paymentAdviceClasses?: Maybe<Payment_Advice_Classes_Arr_Rel_Insert_Input>;
  paymentStatus?: Maybe<Scalars['String']>;
  paymentStatusFilter?: Maybe<Scalars['String']>;
  paymentSummaryStatic?: Maybe<Scalars['jsonb']>;
  payment_advice_logs?: Maybe<Payment_Advice_Logs_Arr_Rel_Insert_Input>;
  payment_advice_transfers?: Maybe<Payment_Advice_Transfers_Arr_Rel_Insert_Input>;
  placeOfCreation?: Maybe<Scalars['String']>;
  qrCodeLink?: Maybe<Scalars['String']>;
  qrExpiryDate?: Maybe<Scalars['timestamp']>;
  qrReferenceNo?: Maybe<Scalars['String']>;
  registrationFeeConfig?: Maybe<Scalars['jsonb']>;
  remarks?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  student?: Maybe<Users_Obj_Rel_Insert_Input>;
  studentId?: Maybe<Scalars['uuid']>;
  unpaidAt?: Maybe<Scalars['timestamp']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  userByCreatedby?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Payment_Advices_Max_Fields = {
  __typename?: 'payment_advices_max_fields';
  batchPaymentAdviceId?: Maybe<Scalars['uuid']>;
  branchId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  dueDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  issueDate?: Maybe<Scalars['timestamptz']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paidAt?: Maybe<Scalars['timestamptz']>;
  paymentStatus?: Maybe<Scalars['String']>;
  paymentStatusFilter?: Maybe<Scalars['String']>;
  placeOfCreation?: Maybe<Scalars['String']>;
  qrCodeLink?: Maybe<Scalars['String']>;
  qrExpiryDate?: Maybe<Scalars['timestamp']>;
  qrReferenceNo?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  unpaidAt?: Maybe<Scalars['timestamp']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "payment_advices" */
export type Payment_Advices_Max_Order_By = {
  batchPaymentAdviceId?: Maybe<Order_By>;
  branchId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  dueDate?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  issueDate?: Maybe<Order_By>;
  link?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  notes?: Maybe<Order_By>;
  paidAt?: Maybe<Order_By>;
  paymentStatus?: Maybe<Order_By>;
  paymentStatusFilter?: Maybe<Order_By>;
  placeOfCreation?: Maybe<Order_By>;
  qrCodeLink?: Maybe<Order_By>;
  qrExpiryDate?: Maybe<Order_By>;
  qrReferenceNo?: Maybe<Order_By>;
  remarks?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  unpaidAt?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Payment_Advices_Min_Fields = {
  __typename?: 'payment_advices_min_fields';
  batchPaymentAdviceId?: Maybe<Scalars['uuid']>;
  branchId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  dueDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  issueDate?: Maybe<Scalars['timestamptz']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paidAt?: Maybe<Scalars['timestamptz']>;
  paymentStatus?: Maybe<Scalars['String']>;
  paymentStatusFilter?: Maybe<Scalars['String']>;
  placeOfCreation?: Maybe<Scalars['String']>;
  qrCodeLink?: Maybe<Scalars['String']>;
  qrExpiryDate?: Maybe<Scalars['timestamp']>;
  qrReferenceNo?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  unpaidAt?: Maybe<Scalars['timestamp']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "payment_advices" */
export type Payment_Advices_Min_Order_By = {
  batchPaymentAdviceId?: Maybe<Order_By>;
  branchId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  dueDate?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  issueDate?: Maybe<Order_By>;
  link?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  notes?: Maybe<Order_By>;
  paidAt?: Maybe<Order_By>;
  paymentStatus?: Maybe<Order_By>;
  paymentStatusFilter?: Maybe<Order_By>;
  placeOfCreation?: Maybe<Order_By>;
  qrCodeLink?: Maybe<Order_By>;
  qrExpiryDate?: Maybe<Order_By>;
  qrReferenceNo?: Maybe<Order_By>;
  remarks?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  unpaidAt?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "payment_advices" */
export type Payment_Advices_Mutation_Response = {
  __typename?: 'payment_advices_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Payment_Advices>;
};

/** input type for inserting object relation for remote table "payment_advices" */
export type Payment_Advices_Obj_Rel_Insert_Input = {
  data: Payment_Advices_Insert_Input;
  on_conflict?: Maybe<Payment_Advices_On_Conflict>;
};

/** on conflict condition type for table "payment_advices" */
export type Payment_Advices_On_Conflict = {
  constraint: Payment_Advices_Constraint;
  update_columns: Array<Payment_Advices_Update_Column>;
  where?: Maybe<Payment_Advices_Bool_Exp>;
};

/** ordering options when selecting data from "payment_advices" */
export type Payment_Advices_Order_By = {
  additional_class_tickets_aggregate?: Maybe<Additional_Class_Tickets_Aggregate_Order_By>;
  batchPaymentAdvice?: Maybe<Batch_Payment_Advices_Order_By>;
  batchPaymentAdviceId?: Maybe<Order_By>;
  branch?: Maybe<Branches_Order_By>;
  branchId?: Maybe<Order_By>;
  classInformation?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  creditNoteIds?: Maybe<Order_By>;
  deduction?: Maybe<Order_By>;
  deposit?: Maybe<Order_By>;
  discount_bills_aggregate?: Maybe<Discount_Bills_Aggregate_Order_By>;
  dueDate?: Maybe<Order_By>;
  hasExpiryDate?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invoices_aggregate?: Maybe<Invoices_Aggregate_Order_By>;
  isOverdueAtPaid?: Maybe<Order_By>;
  isRegistrationFee?: Maybe<Order_By>;
  isTransfer?: Maybe<Order_By>;
  issueDate?: Maybe<Order_By>;
  link?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  notes?: Maybe<Order_By>;
  otherPayments?: Maybe<Order_By>;
  paidAt?: Maybe<Order_By>;
  paymentAdviceClasses_aggregate?: Maybe<Payment_Advice_Classes_Aggregate_Order_By>;
  paymentStatus?: Maybe<Order_By>;
  paymentStatusFilter?: Maybe<Order_By>;
  paymentSummaryStatic?: Maybe<Order_By>;
  payment_advice_logs_aggregate?: Maybe<Payment_Advice_Logs_Aggregate_Order_By>;
  payment_advice_transfers_aggregate?: Maybe<Payment_Advice_Transfers_Aggregate_Order_By>;
  placeOfCreation?: Maybe<Order_By>;
  qrCodeLink?: Maybe<Order_By>;
  qrExpiryDate?: Maybe<Order_By>;
  qrReferenceNo?: Maybe<Order_By>;
  registrationFeeConfig?: Maybe<Order_By>;
  remarks?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  student?: Maybe<Users_Order_By>;
  studentId?: Maybe<Order_By>;
  unpaidAt?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  userByCreatedby?: Maybe<Users_Order_By>;
};

/** primary key columns input for table: "payment_advices" */
export type Payment_Advices_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Payment_Advices_Prepend_Input = {
  classInformation?: Maybe<Scalars['jsonb']>;
  creditNoteIds?: Maybe<Scalars['jsonb']>;
  deduction?: Maybe<Scalars['jsonb']>;
  deposit?: Maybe<Scalars['jsonb']>;
  otherPayments?: Maybe<Scalars['jsonb']>;
  paymentSummaryStatic?: Maybe<Scalars['jsonb']>;
  registrationFeeConfig?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "payment_advices" */
export enum Payment_Advices_Select_Column {
  /** column name */
  BatchPaymentAdviceId = 'batchPaymentAdviceId',
  /** column name */
  BranchId = 'branchId',
  /** column name */
  ClassInformation = 'classInformation',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CreditNoteIds = 'creditNoteIds',
  /** column name */
  Deduction = 'deduction',
  /** column name */
  Deposit = 'deposit',
  /** column name */
  DueDate = 'dueDate',
  /** column name */
  HasExpiryDate = 'hasExpiryDate',
  /** column name */
  Id = 'id',
  /** column name */
  IsOverdueAtPaid = 'isOverdueAtPaid',
  /** column name */
  IsRegistrationFee = 'isRegistrationFee',
  /** column name */
  IsTransfer = 'isTransfer',
  /** column name */
  IssueDate = 'issueDate',
  /** column name */
  Link = 'link',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  OtherPayments = 'otherPayments',
  /** column name */
  PaidAt = 'paidAt',
  /** column name */
  PaymentStatus = 'paymentStatus',
  /** column name */
  PaymentStatusFilter = 'paymentStatusFilter',
  /** column name */
  PaymentSummaryStatic = 'paymentSummaryStatic',
  /** column name */
  PlaceOfCreation = 'placeOfCreation',
  /** column name */
  QrCodeLink = 'qrCodeLink',
  /** column name */
  QrExpiryDate = 'qrExpiryDate',
  /** column name */
  QrReferenceNo = 'qrReferenceNo',
  /** column name */
  RegistrationFeeConfig = 'registrationFeeConfig',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  UnpaidAt = 'unpaidAt',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "payment_advices" */
export type Payment_Advices_Set_Input = {
  batchPaymentAdviceId?: Maybe<Scalars['uuid']>;
  branchId?: Maybe<Scalars['uuid']>;
  classInformation?: Maybe<Scalars['jsonb']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  creditNoteIds?: Maybe<Scalars['jsonb']>;
  deduction?: Maybe<Scalars['jsonb']>;
  deposit?: Maybe<Scalars['jsonb']>;
  dueDate?: Maybe<Scalars['timestamptz']>;
  hasExpiryDate?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  isOverdueAtPaid?: Maybe<Scalars['Boolean']>;
  isRegistrationFee?: Maybe<Scalars['Boolean']>;
  isTransfer?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['timestamptz']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  otherPayments?: Maybe<Scalars['jsonb']>;
  paidAt?: Maybe<Scalars['timestamptz']>;
  paymentStatus?: Maybe<Scalars['String']>;
  paymentStatusFilter?: Maybe<Scalars['String']>;
  paymentSummaryStatic?: Maybe<Scalars['jsonb']>;
  placeOfCreation?: Maybe<Scalars['String']>;
  qrCodeLink?: Maybe<Scalars['String']>;
  qrExpiryDate?: Maybe<Scalars['timestamp']>;
  qrReferenceNo?: Maybe<Scalars['String']>;
  registrationFeeConfig?: Maybe<Scalars['jsonb']>;
  remarks?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  unpaidAt?: Maybe<Scalars['timestamp']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "payment_advices" */
export enum Payment_Advices_Update_Column {
  /** column name */
  BatchPaymentAdviceId = 'batchPaymentAdviceId',
  /** column name */
  BranchId = 'branchId',
  /** column name */
  ClassInformation = 'classInformation',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CreditNoteIds = 'creditNoteIds',
  /** column name */
  Deduction = 'deduction',
  /** column name */
  Deposit = 'deposit',
  /** column name */
  DueDate = 'dueDate',
  /** column name */
  HasExpiryDate = 'hasExpiryDate',
  /** column name */
  Id = 'id',
  /** column name */
  IsOverdueAtPaid = 'isOverdueAtPaid',
  /** column name */
  IsRegistrationFee = 'isRegistrationFee',
  /** column name */
  IsTransfer = 'isTransfer',
  /** column name */
  IssueDate = 'issueDate',
  /** column name */
  Link = 'link',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  OtherPayments = 'otherPayments',
  /** column name */
  PaidAt = 'paidAt',
  /** column name */
  PaymentStatus = 'paymentStatus',
  /** column name */
  PaymentStatusFilter = 'paymentStatusFilter',
  /** column name */
  PaymentSummaryStatic = 'paymentSummaryStatic',
  /** column name */
  PlaceOfCreation = 'placeOfCreation',
  /** column name */
  QrCodeLink = 'qrCodeLink',
  /** column name */
  QrExpiryDate = 'qrExpiryDate',
  /** column name */
  QrReferenceNo = 'qrReferenceNo',
  /** column name */
  RegistrationFeeConfig = 'registrationFeeConfig',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  UnpaidAt = 'unpaidAt',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** columns and relationships of "programs" */
export type Programs = {
  __typename?: 'programs';
  category?: Maybe<Scalars['String']>;
  /** An array relationship */
  classes: Array<Classes>;
  /** An aggregated array relationship */
  classes_aggregate: Classes_Aggregate;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  curriculumFiles: Scalars['jsonb'];
  curriculumIds: Scalars['jsonb'];
  /** A computed field, executes function "programs_field_curriculums" */
  curriculums?: Maybe<Array<Curriculums>>;
  /** A computed field, executes function "programs_field_number_of_students" */
  enrolledStudents?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  levelIds: Scalars['jsonb'];
  /** A computed field, executes function "programs_field_levels" */
  levels?: Maybe<Array<Levels>>;
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  /** A computed field, executes function "programs_field_number_of_dlwd_classes" */
  numberOfDBWDClasses?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "programs_field_number_of_dlwe_classes" */
  numberOfDBWEClasses?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "programs_field_number_of_dl_classes" */
  numberOfDLClasses?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "programs_field_number_of_gr_classes" */
  numberOfGeneralClasses?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "programs_field_number_of_special_classes" */
  numberOfSpecialClasses?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "programs_field_number_of_wlwd_classes" */
  numberOfWLWDClasses?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "programs_field_number_of_wlwe_classes" */
  numberOfWLWEClasses?: Maybe<Scalars['Int']>;
  programId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  /** An object relationship */
  subject: Subjects;
  subjectId: Scalars['uuid'];
  tutorIds: Scalars['jsonb'];
  /** A computed field, executes function "programs_field_tutors" */
  tutors?: Maybe<Array<Users>>;
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "programs" */
export type ProgramsClassesArgs = {
  distinct_on?: Maybe<Array<Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classes_Order_By>>;
  where?: Maybe<Classes_Bool_Exp>;
};


/** columns and relationships of "programs" */
export type ProgramsClasses_AggregateArgs = {
  distinct_on?: Maybe<Array<Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classes_Order_By>>;
  where?: Maybe<Classes_Bool_Exp>;
};


/** columns and relationships of "programs" */
export type ProgramsCurriculumFilesArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "programs" */
export type ProgramsCurriculumIdsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "programs" */
export type ProgramsCurriculumsArgs = {
  distinct_on?: Maybe<Array<Curriculums_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Curriculums_Order_By>>;
  where?: Maybe<Curriculums_Bool_Exp>;
};


/** columns and relationships of "programs" */
export type ProgramsLevelIdsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "programs" */
export type ProgramsLevelsArgs = {
  distinct_on?: Maybe<Array<Levels_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Levels_Order_By>>;
  where?: Maybe<Levels_Bool_Exp>;
};


/** columns and relationships of "programs" */
export type ProgramsTutorIdsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "programs" */
export type ProgramsTutorsArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};

/** aggregated selection of "programs" */
export type Programs_Aggregate = {
  __typename?: 'programs_aggregate';
  aggregate?: Maybe<Programs_Aggregate_Fields>;
  nodes: Array<Programs>;
};

/** aggregate fields of "programs" */
export type Programs_Aggregate_Fields = {
  __typename?: 'programs_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Programs_Max_Fields>;
  min?: Maybe<Programs_Min_Fields>;
};


/** aggregate fields of "programs" */
export type Programs_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Programs_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "programs" */
export type Programs_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Programs_Max_Order_By>;
  min?: Maybe<Programs_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Programs_Append_Input = {
  curriculumFiles?: Maybe<Scalars['jsonb']>;
  curriculumIds?: Maybe<Scalars['jsonb']>;
  levelIds?: Maybe<Scalars['jsonb']>;
  tutorIds?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "programs" */
export type Programs_Arr_Rel_Insert_Input = {
  data: Array<Programs_Insert_Input>;
  on_conflict?: Maybe<Programs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "programs". All fields are combined with a logical 'AND'. */
export type Programs_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Programs_Bool_Exp>>>;
  _not?: Maybe<Programs_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Programs_Bool_Exp>>>;
  category?: Maybe<String_Comparison_Exp>;
  classes?: Maybe<Classes_Bool_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  curriculumFiles?: Maybe<Jsonb_Comparison_Exp>;
  curriculumIds?: Maybe<Jsonb_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  levelIds?: Maybe<Jsonb_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  note?: Maybe<String_Comparison_Exp>;
  programId?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  subject?: Maybe<Subjects_Bool_Exp>;
  subjectId?: Maybe<Uuid_Comparison_Exp>;
  tutorIds?: Maybe<Jsonb_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "programs" */
export enum Programs_Constraint {
  /** unique or primary key constraint */
  ProgramsPkey = 'programs_pkey',
  /** unique or primary key constraint */
  ProgramsProgramIdKey = 'programs_programId_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Programs_Delete_At_Path_Input = {
  curriculumFiles?: Maybe<Array<Maybe<Scalars['String']>>>;
  curriculumIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  levelIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  tutorIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Programs_Delete_Elem_Input = {
  curriculumFiles?: Maybe<Scalars['Int']>;
  curriculumIds?: Maybe<Scalars['Int']>;
  levelIds?: Maybe<Scalars['Int']>;
  tutorIds?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Programs_Delete_Key_Input = {
  curriculumFiles?: Maybe<Scalars['String']>;
  curriculumIds?: Maybe<Scalars['String']>;
  levelIds?: Maybe<Scalars['String']>;
  tutorIds?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "programs" */
export type Programs_Insert_Input = {
  category?: Maybe<Scalars['String']>;
  classes?: Maybe<Classes_Arr_Rel_Insert_Input>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculumFiles?: Maybe<Scalars['jsonb']>;
  curriculumIds?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  levelIds?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subject?: Maybe<Subjects_Obj_Rel_Insert_Input>;
  subjectId?: Maybe<Scalars['uuid']>;
  tutorIds?: Maybe<Scalars['jsonb']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Programs_Max_Fields = {
  __typename?: 'programs_max_fields';
  category?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subjectId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "programs" */
export type Programs_Max_Order_By = {
  category?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  note?: Maybe<Order_By>;
  programId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  subjectId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Programs_Min_Fields = {
  __typename?: 'programs_min_fields';
  category?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subjectId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "programs" */
export type Programs_Min_Order_By = {
  category?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  note?: Maybe<Order_By>;
  programId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  subjectId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "programs" */
export type Programs_Mutation_Response = {
  __typename?: 'programs_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Programs>;
};

/** input type for inserting object relation for remote table "programs" */
export type Programs_Obj_Rel_Insert_Input = {
  data: Programs_Insert_Input;
  on_conflict?: Maybe<Programs_On_Conflict>;
};

/** on conflict condition type for table "programs" */
export type Programs_On_Conflict = {
  constraint: Programs_Constraint;
  update_columns: Array<Programs_Update_Column>;
  where?: Maybe<Programs_Bool_Exp>;
};

/** ordering options when selecting data from "programs" */
export type Programs_Order_By = {
  category?: Maybe<Order_By>;
  classes_aggregate?: Maybe<Classes_Aggregate_Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  curriculumFiles?: Maybe<Order_By>;
  curriculumIds?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  levelIds?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  note?: Maybe<Order_By>;
  programId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  subject?: Maybe<Subjects_Order_By>;
  subjectId?: Maybe<Order_By>;
  tutorIds?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "programs" */
export type Programs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Programs_Prepend_Input = {
  curriculumFiles?: Maybe<Scalars['jsonb']>;
  curriculumIds?: Maybe<Scalars['jsonb']>;
  levelIds?: Maybe<Scalars['jsonb']>;
  tutorIds?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "programs" */
export enum Programs_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CurriculumFiles = 'curriculumFiles',
  /** column name */
  CurriculumIds = 'curriculumIds',
  /** column name */
  Id = 'id',
  /** column name */
  LevelIds = 'levelIds',
  /** column name */
  Name = 'name',
  /** column name */
  Note = 'note',
  /** column name */
  ProgramId = 'programId',
  /** column name */
  Status = 'status',
  /** column name */
  SubjectId = 'subjectId',
  /** column name */
  TutorIds = 'tutorIds',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "programs" */
export type Programs_Set_Input = {
  category?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculumFiles?: Maybe<Scalars['jsonb']>;
  curriculumIds?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  levelIds?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subjectId?: Maybe<Scalars['uuid']>;
  tutorIds?: Maybe<Scalars['jsonb']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "programs" */
export enum Programs_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CurriculumFiles = 'curriculumFiles',
  /** column name */
  CurriculumIds = 'curriculumIds',
  /** column name */
  Id = 'id',
  /** column name */
  LevelIds = 'levelIds',
  /** column name */
  Name = 'name',
  /** column name */
  Note = 'note',
  /** column name */
  ProgramId = 'programId',
  /** column name */
  Status = 'status',
  /** column name */
  SubjectId = 'subjectId',
  /** column name */
  TutorIds = 'tutorIds',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** query root */
export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "academic_calendars" */
  academic_calendars: Array<Academic_Calendars>;
  /** fetch aggregated fields from the table: "academic_calendars" */
  academic_calendars_aggregate: Academic_Calendars_Aggregate;
  /** fetch data from the table: "academic_calendars" using primary key columns */
  academic_calendars_by_pk?: Maybe<Academic_Calendars>;
  /** fetch data from the table: "additional_class_tickets" */
  additional_class_tickets: Array<Additional_Class_Tickets>;
  /** fetch aggregated fields from the table: "additional_class_tickets" */
  additional_class_tickets_aggregate: Additional_Class_Tickets_Aggregate;
  /** fetch data from the table: "additional_class_tickets" using primary key columns */
  additional_class_tickets_by_pk?: Maybe<Additional_Class_Tickets>;
  /** fetch data from the table: "backup_attendance_logs" */
  backup_attendance_logs: Array<Backup_Attendance_Logs>;
  /** fetch aggregated fields from the table: "backup_attendance_logs" */
  backup_attendance_logs_aggregate: Backup_Attendance_Logs_Aggregate;
  /** fetch data from the table: "backup_attendance_logs" using primary key columns */
  backup_attendance_logs_by_pk?: Maybe<Backup_Attendance_Logs>;
  /** fetch data from the table: "banks" */
  banks: Array<Banks>;
  /** fetch aggregated fields from the table: "banks" */
  banks_aggregate: Banks_Aggregate;
  /** fetch data from the table: "banks" using primary key columns */
  banks_by_pk?: Maybe<Banks>;
  /** fetch data from the table: "batch_payment_advices" */
  batch_payment_advices: Array<Batch_Payment_Advices>;
  /** fetch aggregated fields from the table: "batch_payment_advices" */
  batch_payment_advices_aggregate: Batch_Payment_Advices_Aggregate;
  /** fetch data from the table: "batch_payment_advices" using primary key columns */
  batch_payment_advices_by_pk?: Maybe<Batch_Payment_Advices>;
  /** fetch data from the table: "branches" */
  branches: Array<Branches>;
  /** fetch aggregated fields from the table: "branches" */
  branches_aggregate: Branches_Aggregate;
  /** fetch data from the table: "branches" using primary key columns */
  branches_by_pk?: Maybe<Branches>;
  /** fetch data from the table: "broadcast_logs" */
  broadcast_logs: Array<Broadcast_Logs>;
  /** fetch aggregated fields from the table: "broadcast_logs" */
  broadcast_logs_aggregate: Broadcast_Logs_Aggregate;
  /** fetch data from the table: "broadcast_logs" using primary key columns */
  broadcast_logs_by_pk?: Maybe<Broadcast_Logs>;
  /** fetch data from the table: "broadcasts" */
  broadcasts: Array<Broadcasts>;
  /** fetch aggregated fields from the table: "broadcasts" */
  broadcasts_aggregate: Broadcasts_Aggregate;
  /** fetch data from the table: "broadcasts" using primary key columns */
  broadcasts_by_pk?: Maybe<Broadcasts>;
  /** execute function "class_filter_by_filling_status" which returns "classes" */
  class_filter_by_filling_status: Array<Classes>;
  /** execute function "class_filter_by_filling_status" and query aggregates on result of table type "classes" */
  class_filter_by_filling_status_aggregate: Classes_Aggregate;
  /** execute function "class_filter_by_student" which returns "classes" */
  class_filter_by_student: Array<Classes>;
  /** execute function "class_filter_by_student" and query aggregates on result of table type "classes" */
  class_filter_by_student_aggregate: Classes_Aggregate;
  /** fetch data from the table: "class_students_waiting" */
  class_students_waiting: Array<Class_Students_Waiting>;
  /** fetch aggregated fields from the table: "class_students_waiting" */
  class_students_waiting_aggregate: Class_Students_Waiting_Aggregate;
  /** fetch data from the table: "class_students_waiting" using primary key columns */
  class_students_waiting_by_pk?: Maybe<Class_Students_Waiting>;
  /** fetch data from the table: "classes" */
  classes: Array<Classes>;
  /** fetch aggregated fields from the table: "classes" */
  classes_aggregate: Classes_Aggregate;
  /** fetch data from the table: "classes" using primary key columns */
  classes_by_pk?: Maybe<Classes>;
  /** fetch data from the table: "classrooms" */
  classrooms: Array<Classrooms>;
  /** fetch aggregated fields from the table: "classrooms" */
  classrooms_aggregate: Classrooms_Aggregate;
  /** fetch data from the table: "classrooms" using primary key columns */
  classrooms_by_pk?: Maybe<Classrooms>;
  countSpecialClasses?: Maybe<Scalars['JSON']>;
  /** fetch data from the table: "credit_note_classes" */
  credit_note_classes: Array<Credit_Note_Classes>;
  /** fetch aggregated fields from the table: "credit_note_classes" */
  credit_note_classes_aggregate: Credit_Note_Classes_Aggregate;
  /** fetch data from the table: "credit_note_classes" using primary key columns */
  credit_note_classes_by_pk?: Maybe<Credit_Note_Classes>;
  /** fetch data from the table: "credit_note_fees" */
  credit_note_fees: Array<Credit_Note_Fees>;
  /** fetch aggregated fields from the table: "credit_note_fees" */
  credit_note_fees_aggregate: Credit_Note_Fees_Aggregate;
  /** fetch data from the table: "credit_note_fees" using primary key columns */
  credit_note_fees_by_pk?: Maybe<Credit_Note_Fees>;
  /** execute function "credit_note_filter" which returns "credit_notes" */
  credit_note_filter: Array<Credit_Notes>;
  /** execute function "credit_note_filter" and query aggregates on result of table type "credit_notes" */
  credit_note_filter_aggregate: Credit_Notes_Aggregate;
  /** fetch data from the table: "credit_note_logs" */
  credit_note_logs: Array<Credit_Note_Logs>;
  /** fetch aggregated fields from the table: "credit_note_logs" */
  credit_note_logs_aggregate: Credit_Note_Logs_Aggregate;
  /** fetch data from the table: "credit_note_logs" using primary key columns */
  credit_note_logs_by_pk?: Maybe<Credit_Note_Logs>;
  /** fetch data from the table: "credit_notes" */
  credit_notes: Array<Credit_Notes>;
  /** fetch aggregated fields from the table: "credit_notes" */
  credit_notes_aggregate: Credit_Notes_Aggregate;
  /** fetch data from the table: "credit_notes" using primary key columns */
  credit_notes_by_pk?: Maybe<Credit_Notes>;
  /** fetch data from the table: "curriculums" */
  curriculums: Array<Curriculums>;
  /** fetch aggregated fields from the table: "curriculums" */
  curriculums_aggregate: Curriculums_Aggregate;
  /** fetch data from the table: "curriculums" using primary key columns */
  curriculums_by_pk?: Maybe<Curriculums>;
  /** fetch data from the table: "curriculums_levels" */
  curriculums_levels: Array<Curriculums_Levels>;
  /** fetch aggregated fields from the table: "curriculums_levels" */
  curriculums_levels_aggregate: Curriculums_Levels_Aggregate;
  /** fetch data from the table: "curriculums_levels" using primary key columns */
  curriculums_levels_by_pk?: Maybe<Curriculums_Levels>;
  /** fetch data from the table: "deposits" */
  deposits: Array<Deposits>;
  /** fetch aggregated fields from the table: "deposits" */
  deposits_aggregate: Deposits_Aggregate;
  /** fetch data from the table: "deposits" using primary key columns */
  deposits_by_pk?: Maybe<Deposits>;
  /** fetch data from the table: "discount_bills" */
  discount_bills: Array<Discount_Bills>;
  /** fetch aggregated fields from the table: "discount_bills" */
  discount_bills_aggregate: Discount_Bills_Aggregate;
  /** fetch data from the table: "discount_bills" using primary key columns */
  discount_bills_by_pk?: Maybe<Discount_Bills>;
  /** fetch data from the table: "discount_students" */
  discount_students: Array<Discount_Students>;
  /** fetch aggregated fields from the table: "discount_students" */
  discount_students_aggregate: Discount_Students_Aggregate;
  /** fetch data from the table: "discount_students" using primary key columns */
  discount_students_by_pk?: Maybe<Discount_Students>;
  /** fetch data from the table: "discounts" */
  discounts: Array<Discounts>;
  /** fetch aggregated fields from the table: "discounts" */
  discounts_aggregate: Discounts_Aggregate;
  /** fetch data from the table: "discounts" using primary key columns */
  discounts_by_pk?: Maybe<Discounts>;
  /** fetch data from the table: "double_lesson_academic_pricings" */
  double_lesson_academic_pricings: Array<Double_Lesson_Academic_Pricings>;
  /** fetch aggregated fields from the table: "double_lesson_academic_pricings" */
  double_lesson_academic_pricings_aggregate: Double_Lesson_Academic_Pricings_Aggregate;
  /** fetch data from the table: "double_lesson_academic_pricings" using primary key columns */
  double_lesson_academic_pricings_by_pk?: Maybe<Double_Lesson_Academic_Pricings>;
  /** fetch data from the table: "double_lesson_program_types" */
  double_lesson_program_types: Array<Double_Lesson_Program_Types>;
  /** fetch aggregated fields from the table: "double_lesson_program_types" */
  double_lesson_program_types_aggregate: Double_Lesson_Program_Types_Aggregate;
  /** fetch data from the table: "double_lesson_program_types" using primary key columns */
  double_lesson_program_types_by_pk?: Maybe<Double_Lesson_Program_Types>;
  /** fetch data from the table: "double_lesson_programme_pricings" */
  double_lesson_programme_pricings: Array<Double_Lesson_Programme_Pricings>;
  /** fetch aggregated fields from the table: "double_lesson_programme_pricings" */
  double_lesson_programme_pricings_aggregate: Double_Lesson_Programme_Pricings_Aggregate;
  /** fetch data from the table: "double_lesson_programme_pricings" using primary key columns */
  double_lesson_programme_pricings_by_pk?: Maybe<Double_Lesson_Programme_Pricings>;
  /** fetch data from the table: "email_student_logs" */
  email_student_logs: Array<Email_Student_Logs>;
  /** fetch aggregated fields from the table: "email_student_logs" */
  email_student_logs_aggregate: Email_Student_Logs_Aggregate;
  /** fetch data from the table: "email_student_logs" using primary key columns */
  email_student_logs_by_pk?: Maybe<Email_Student_Logs>;
  /** fetch data from the table: "enrollment_list_new" */
  enrollment_list_new: Array<Enrollment_List_New>;
  /** fetch aggregated fields from the table: "enrollment_list_new" */
  enrollment_list_new_aggregate: Enrollment_List_New_Aggregate;
  /** fetch data from the table: "enrollment_list_new" using primary key columns */
  enrollment_list_new_by_pk?: Maybe<Enrollment_List_New>;
  filterClassByStudentId?: Maybe<PaginationClassModel>;
  /** fetch data from the table: "general_program_types" */
  general_program_types: Array<General_Program_Types>;
  /** fetch aggregated fields from the table: "general_program_types" */
  general_program_types_aggregate: General_Program_Types_Aggregate;
  /** fetch data from the table: "general_program_types" using primary key columns */
  general_program_types_by_pk?: Maybe<General_Program_Types>;
  getClassInformation?: Maybe<ClassInformation>;
  getClassInformationForCreditNote?: Maybe<ClassInformationCreditNote>;
  getClassInformationForRefund?: Maybe<WithdrawalClass>;
  getClassUpcomingOfStudent?: Maybe<Array<Maybe<Scalars['String']>>>;
  getClassroomAvailable?: Maybe<Array<Maybe<Scalars['String']>>>;
  getDetailInvoice?: Maybe<InvoiceModel>;
  getDetailPaymentAdvice?: Maybe<PaymentAdviceModel>;
  getDetailPaymentAdvicePaper?: Maybe<InvoiceModel>;
  getDetailRefund?: Maybe<RefundModel>;
  getListClassNotRefundByStudent?: Maybe<Array<Maybe<ClassOfStudent>>>;
  getPaRelationships?: Maybe<PaymentAdviceRelationshipsModel>;
  getReceiptListings?: Maybe<Array<Maybe<ReceiptListModel>>>;
  getRoles?: Maybe<Array<Maybe<Role>>>;
  getStudentsWithManyAbsents?: Maybe<AbsentStudentPaginationModel>;
  /** fetch data from the table: "get_profile" */
  get_profile: Array<Get_Profile>;
  /** fetch aggregated fields from the table: "get_profile" */
  get_profile_aggregate: Get_Profile_Aggregate;
  /** execute function "invoice_filter" which returns "invoices" */
  invoice_filter: Array<Invoices>;
  /** execute function "invoice_filter" and query aggregates on result of table type "invoices" */
  invoice_filter_aggregate: Invoices_Aggregate;
  /** fetch data from the table: "invoice_partial_payments" */
  invoice_partial_payments: Array<Invoice_Partial_Payments>;
  /** fetch aggregated fields from the table: "invoice_partial_payments" */
  invoice_partial_payments_aggregate: Invoice_Partial_Payments_Aggregate;
  /** fetch data from the table: "invoice_partial_payments" using primary key columns */
  invoice_partial_payments_by_pk?: Maybe<Invoice_Partial_Payments>;
  /** fetch data from the table: "invoices" */
  invoices: Array<Invoices>;
  /** fetch aggregated fields from the table: "invoices" */
  invoices_aggregate: Invoices_Aggregate;
  /** fetch data from the table: "invoices" using primary key columns */
  invoices_by_pk?: Maybe<Invoices>;
  /** fetch data from the table: "lessons" */
  lessons: Array<Lessons>;
  /** fetch aggregated fields from the table: "lessons" */
  lessons_aggregate: Lessons_Aggregate;
  /** fetch data from the table: "lessons" using primary key columns */
  lessons_by_pk?: Maybe<Lessons>;
  /** fetch data from the table: "lessons_students" */
  lessons_students: Array<Lessons_Students>;
  /** fetch aggregated fields from the table: "lessons_students" */
  lessons_students_aggregate: Lessons_Students_Aggregate;
  /** fetch data from the table: "lessons_students" using primary key columns */
  lessons_students_by_pk?: Maybe<Lessons_Students>;
  /** fetch data from the table: "levels" */
  levels: Array<Levels>;
  /** fetch aggregated fields from the table: "levels" */
  levels_aggregate: Levels_Aggregate;
  /** fetch data from the table: "levels" using primary key columns */
  levels_by_pk?: Maybe<Levels>;
  /** fetch data from the table: "news" */
  news: Array<News>;
  /** fetch aggregated fields from the table: "news" */
  news_aggregate: News_Aggregate;
  /** fetch data from the table: "news" using primary key columns */
  news_by_pk?: Maybe<News>;
  /** fetch data from the table: "news_logs" */
  news_logs: Array<News_Logs>;
  /** fetch aggregated fields from the table: "news_logs" */
  news_logs_aggregate: News_Logs_Aggregate;
  /** fetch data from the table: "news_logs" using primary key columns */
  news_logs_by_pk?: Maybe<News_Logs>;
  /** fetch data from the table: "news_recipients_upload" */
  news_recipients_upload: Array<News_Recipients_Upload>;
  /** fetch aggregated fields from the table: "news_recipients_upload" */
  news_recipients_upload_aggregate: News_Recipients_Upload_Aggregate;
  /** fetch data from the table: "news_recipients_upload" using primary key columns */
  news_recipients_upload_by_pk?: Maybe<News_Recipients_Upload>;
  /** fetch data from the table: "pass_door_logs" */
  pass_door_logs: Array<Pass_Door_Logs>;
  /** fetch aggregated fields from the table: "pass_door_logs" */
  pass_door_logs_aggregate: Pass_Door_Logs_Aggregate;
  /** fetch data from the table: "pass_door_logs" using primary key columns */
  pass_door_logs_by_pk?: Maybe<Pass_Door_Logs>;
  /** fetch data from the table: "payment_advice_class_transfer" */
  payment_advice_class_transfer: Array<Payment_Advice_Class_Transfer>;
  /** fetch aggregated fields from the table: "payment_advice_class_transfer" */
  payment_advice_class_transfer_aggregate: Payment_Advice_Class_Transfer_Aggregate;
  /** fetch data from the table: "payment_advice_class_transfer" using primary key columns */
  payment_advice_class_transfer_by_pk?: Maybe<Payment_Advice_Class_Transfer>;
  /** fetch data from the table: "payment_advice_classes" */
  payment_advice_classes: Array<Payment_Advice_Classes>;
  /** fetch aggregated fields from the table: "payment_advice_classes" */
  payment_advice_classes_aggregate: Payment_Advice_Classes_Aggregate;
  /** fetch data from the table: "payment_advice_classes" using primary key columns */
  payment_advice_classes_by_pk?: Maybe<Payment_Advice_Classes>;
  /** execute function "payment_advice_classes_by_student_id" which returns "classes" */
  payment_advice_classes_by_student_id: Array<Classes>;
  /** execute function "payment_advice_classes_by_student_id" and query aggregates on result of table type "classes" */
  payment_advice_classes_by_student_id_aggregate: Classes_Aggregate;
  /** fetch data from the table: "payment_advice_delete_logs" */
  payment_advice_delete_logs: Array<Payment_Advice_Delete_Logs>;
  /** fetch aggregated fields from the table: "payment_advice_delete_logs" */
  payment_advice_delete_logs_aggregate: Payment_Advice_Delete_Logs_Aggregate;
  /** fetch data from the table: "payment_advice_delete_logs" using primary key columns */
  payment_advice_delete_logs_by_pk?: Maybe<Payment_Advice_Delete_Logs>;
  /** execute function "payment_advice_filter" which returns "payment_advices" */
  payment_advice_filter: Array<Payment_Advices>;
  /** execute function "payment_advice_filter" and query aggregates on result of table type "payment_advices" */
  payment_advice_filter_aggregate: Payment_Advices_Aggregate;
  /** fetch data from the table: "payment_advice_logs" */
  payment_advice_logs: Array<Payment_Advice_Logs>;
  /** fetch aggregated fields from the table: "payment_advice_logs" */
  payment_advice_logs_aggregate: Payment_Advice_Logs_Aggregate;
  /** fetch data from the table: "payment_advice_logs" using primary key columns */
  payment_advice_logs_by_pk?: Maybe<Payment_Advice_Logs>;
  /** fetch data from the table: "payment_advice_term_classes" */
  payment_advice_term_classes: Array<Payment_Advice_Term_Classes>;
  /** fetch aggregated fields from the table: "payment_advice_term_classes" */
  payment_advice_term_classes_aggregate: Payment_Advice_Term_Classes_Aggregate;
  /** fetch data from the table: "payment_advice_term_classes" using primary key columns */
  payment_advice_term_classes_by_pk?: Maybe<Payment_Advice_Term_Classes>;
  /** fetch data from the table: "payment_advice_transfers" */
  payment_advice_transfers: Array<Payment_Advice_Transfers>;
  /** fetch aggregated fields from the table: "payment_advice_transfers" */
  payment_advice_transfers_aggregate: Payment_Advice_Transfers_Aggregate;
  /** fetch data from the table: "payment_advice_transfers" using primary key columns */
  payment_advice_transfers_by_pk?: Maybe<Payment_Advice_Transfers>;
  /** fetch data from the table: "payment_advices" */
  payment_advices: Array<Payment_Advices>;
  /** fetch aggregated fields from the table: "payment_advices" */
  payment_advices_aggregate: Payment_Advices_Aggregate;
  /** fetch data from the table: "payment_advices" using primary key columns */
  payment_advices_by_pk?: Maybe<Payment_Advices>;
  /** fetch data from the table: "programs" */
  programs: Array<Programs>;
  /** fetch aggregated fields from the table: "programs" */
  programs_aggregate: Programs_Aggregate;
  /** fetch data from the table: "programs" using primary key columns */
  programs_by_pk?: Maybe<Programs>;
  /** execute function "receipt_filter" which returns "receipts" */
  receipt_filter: Array<Receipts>;
  /** execute function "receipt_filter" and query aggregates on result of table type "receipts" */
  receipt_filter_aggregate: Receipts_Aggregate;
  /** execute function "receipt_filter_by_class" which returns "receipts" */
  receipt_filter_by_class: Array<Receipts>;
  /** execute function "receipt_filter_by_class" and query aggregates on result of table type "receipts" */
  receipt_filter_by_class_aggregate: Receipts_Aggregate;
  /** fetch data from the table: "receipts" */
  receipts: Array<Receipts>;
  /** fetch aggregated fields from the table: "receipts" */
  receipts_aggregate: Receipts_Aggregate;
  /** fetch data from the table: "receipts" using primary key columns */
  receipts_by_pk?: Maybe<Receipts>;
  /** fetch data from the table: "refund_classes" */
  refund_classes: Array<Refund_Classes>;
  /** fetch aggregated fields from the table: "refund_classes" */
  refund_classes_aggregate: Refund_Classes_Aggregate;
  /** fetch data from the table: "refund_classes" using primary key columns */
  refund_classes_by_pk?: Maybe<Refund_Classes>;
  /** execute function "refund_filter" which returns "refunds" */
  refund_filter: Array<Refunds>;
  /** execute function "refund_filter" and query aggregates on result of table type "refunds" */
  refund_filter_aggregate: Refunds_Aggregate;
  /** fetch data from the table: "refund_logs" */
  refund_logs: Array<Refund_Logs>;
  /** fetch aggregated fields from the table: "refund_logs" */
  refund_logs_aggregate: Refund_Logs_Aggregate;
  /** fetch data from the table: "refund_logs" using primary key columns */
  refund_logs_by_pk?: Maybe<Refund_Logs>;
  /** fetch data from the table: "refunds" */
  refunds: Array<Refunds>;
  /** fetch aggregated fields from the table: "refunds" */
  refunds_aggregate: Refunds_Aggregate;
  /** fetch data from the table: "refunds" using primary key columns */
  refunds_by_pk?: Maybe<Refunds>;
  /** fetch data from the table: "regular_academic_pricings" */
  regular_academic_pricings: Array<Regular_Academic_Pricings>;
  /** fetch aggregated fields from the table: "regular_academic_pricings" */
  regular_academic_pricings_aggregate: Regular_Academic_Pricings_Aggregate;
  /** fetch data from the table: "regular_academic_pricings" using primary key columns */
  regular_academic_pricings_by_pk?: Maybe<Regular_Academic_Pricings>;
  /** fetch data from the table: "regular_program_types" */
  regular_program_types: Array<Regular_Program_Types>;
  /** fetch aggregated fields from the table: "regular_program_types" */
  regular_program_types_aggregate: Regular_Program_Types_Aggregate;
  /** fetch data from the table: "regular_program_types" using primary key columns */
  regular_program_types_by_pk?: Maybe<Regular_Program_Types>;
  /** fetch data from the table: "regular_programme_pricings" */
  regular_programme_pricings: Array<Regular_Programme_Pricings>;
  /** fetch aggregated fields from the table: "regular_programme_pricings" */
  regular_programme_pricings_aggregate: Regular_Programme_Pricings_Aggregate;
  /** fetch data from the table: "regular_programme_pricings" using primary key columns */
  regular_programme_pricings_by_pk?: Maybe<Regular_Programme_Pricings>;
  /** fetch data from the table: "report_subject_budget" */
  report_subject_budget: Array<Report_Subject_Budget>;
  /** fetch aggregated fields from the table: "report_subject_budget" */
  report_subject_budget_aggregate: Report_Subject_Budget_Aggregate;
  /** fetch data from the table: "report_subject_budget" using primary key columns */
  report_subject_budget_by_pk?: Maybe<Report_Subject_Budget>;
  /** fetch data from the table: "request_transfer_classes" */
  request_transfer_classes: Array<Request_Transfer_Classes>;
  /** fetch aggregated fields from the table: "request_transfer_classes" */
  request_transfer_classes_aggregate: Request_Transfer_Classes_Aggregate;
  /** fetch data from the table: "request_transfer_classes" using primary key columns */
  request_transfer_classes_by_pk?: Maybe<Request_Transfer_Classes>;
  /** fetch data from the table: "roles" */
  roles: Array<Roles>;
  /** fetch aggregated fields from the table: "roles" */
  roles_aggregate: Roles_Aggregate;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: Maybe<Roles>;
  /** fetch data from the table: "schools" */
  schools: Array<Schools>;
  /** fetch aggregated fields from the table: "schools" */
  schools_aggregate: Schools_Aggregate;
  /** fetch data from the table: "schools" using primary key columns */
  schools_by_pk?: Maybe<Schools>;
  /** retrieve the result of action: "sentBroadcast" */
  sentBroadcast?: Maybe<SentBroadcast>;
  /** retrieve the result of action: "sentNews" */
  sentNews?: Maybe<SentNews>;
  /** fetch data from the table: "sessions" */
  sessions: Array<Sessions>;
  /** fetch aggregated fields from the table: "sessions" */
  sessions_aggregate: Sessions_Aggregate;
  /** fetch data from the table: "sessions" using primary key columns */
  sessions_by_pk?: Maybe<Sessions>;
  /** fetch data from the table: "special_programme_class_pricings" */
  special_programme_class_pricings: Array<Special_Programme_Class_Pricings>;
  /** fetch aggregated fields from the table: "special_programme_class_pricings" */
  special_programme_class_pricings_aggregate: Special_Programme_Class_Pricings_Aggregate;
  /** fetch data from the table: "special_programme_class_pricings" using primary key columns */
  special_programme_class_pricings_by_pk?: Maybe<Special_Programme_Class_Pricings>;
  /** fetch data from the table: "specical_program_types" */
  specical_program_types: Array<Specical_Program_Types>;
  /** fetch aggregated fields from the table: "specical_program_types" */
  specical_program_types_aggregate: Specical_Program_Types_Aggregate;
  /** fetch data from the table: "specical_program_types" using primary key columns */
  specical_program_types_by_pk?: Maybe<Specical_Program_Types>;
  /** fetch data from the table: "student_profiles" */
  student_profiles: Array<Student_Profiles>;
  /** fetch aggregated fields from the table: "student_profiles" */
  student_profiles_aggregate: Student_Profiles_Aggregate;
  /** fetch data from the table: "student_profiles" using primary key columns */
  student_profiles_by_pk?: Maybe<Student_Profiles>;
  /** execute function "students_filter" which returns "users" */
  students_filter: Array<Users>;
  /** execute function "students_filter" and query aggregates on result of table type "users" */
  students_filter_aggregate: Users_Aggregate;
  /** execute function "students_list_filter" which returns "users" */
  students_list_filter: Array<Users>;
  /** execute function "students_list_filter" and query aggregates on result of table type "users" */
  students_list_filter_aggregate: Users_Aggregate;
  /** execute function "students_list_filter_payment" which returns "users" */
  students_list_filter_payment: Array<Users>;
  /** execute function "students_list_filter_payment" and query aggregates on result of table type "users" */
  students_list_filter_payment_aggregate: Users_Aggregate;
  /** execute function "students_programs_filter" which returns "programs" */
  students_programs_filter: Array<Programs>;
  /** execute function "students_programs_filter" and query aggregates on result of table type "programs" */
  students_programs_filter_aggregate: Programs_Aggregate;
  /** fetch data from the table: "subjects" */
  subjects: Array<Subjects>;
  /** fetch aggregated fields from the table: "subjects" */
  subjects_aggregate: Subjects_Aggregate;
  /** fetch data from the table: "subjects" using primary key columns */
  subjects_by_pk?: Maybe<Subjects>;
  /** fetch data from the table: "system_settings" */
  system_settings: Array<System_Settings>;
  /** fetch aggregated fields from the table: "system_settings" */
  system_settings_aggregate: System_Settings_Aggregate;
  /** fetch data from the table: "system_settings" using primary key columns */
  system_settings_by_pk?: Maybe<System_Settings>;
  /** fetch data from the table: "term_classes" */
  term_classes: Array<Term_Classes>;
  /** fetch aggregated fields from the table: "term_classes" */
  term_classes_aggregate: Term_Classes_Aggregate;
  /** fetch data from the table: "term_classes" using primary key columns */
  term_classes_by_pk?: Maybe<Term_Classes>;
  /** fetch data from the table: "terms" */
  terms: Array<Terms>;
  /** fetch aggregated fields from the table: "terms" */
  terms_aggregate: Terms_Aggregate;
  /** fetch data from the table: "terms" using primary key columns */
  terms_by_pk?: Maybe<Terms>;
  /** fetch data from the table: "three_times_absents" */
  three_times_absents: Array<Three_Times_Absents>;
  /** fetch aggregated fields from the table: "three_times_absents" */
  three_times_absents_aggregate: Three_Times_Absents_Aggregate;
  /** fetch data from the table: "three_times_absents" using primary key columns */
  three_times_absents_by_pk?: Maybe<Three_Times_Absents>;
  /** fetch data from the table: "transaction_logs" */
  transaction_logs: Array<Transaction_Logs>;
  /** fetch aggregated fields from the table: "transaction_logs" */
  transaction_logs_aggregate: Transaction_Logs_Aggregate;
  /** fetch data from the table: "transaction_logs" using primary key columns */
  transaction_logs_by_pk?: Maybe<Transaction_Logs>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table: "vms_person_groups" */
  vms_person_groups: Array<Vms_Person_Groups>;
  /** fetch aggregated fields from the table: "vms_person_groups" */
  vms_person_groups_aggregate: Vms_Person_Groups_Aggregate;
  /** fetch data from the table: "vms_person_groups" using primary key columns */
  vms_person_groups_by_pk?: Maybe<Vms_Person_Groups>;
};


/** query root */
export type Query_RootAcademic_CalendarsArgs = {
  distinct_on?: Maybe<Array<Academic_Calendars_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Academic_Calendars_Order_By>>;
  where?: Maybe<Academic_Calendars_Bool_Exp>;
};


/** query root */
export type Query_RootAcademic_Calendars_AggregateArgs = {
  distinct_on?: Maybe<Array<Academic_Calendars_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Academic_Calendars_Order_By>>;
  where?: Maybe<Academic_Calendars_Bool_Exp>;
};


/** query root */
export type Query_RootAcademic_Calendars_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootAdditional_Class_TicketsArgs = {
  distinct_on?: Maybe<Array<Additional_Class_Tickets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Additional_Class_Tickets_Order_By>>;
  where?: Maybe<Additional_Class_Tickets_Bool_Exp>;
};


/** query root */
export type Query_RootAdditional_Class_Tickets_AggregateArgs = {
  distinct_on?: Maybe<Array<Additional_Class_Tickets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Additional_Class_Tickets_Order_By>>;
  where?: Maybe<Additional_Class_Tickets_Bool_Exp>;
};


/** query root */
export type Query_RootAdditional_Class_Tickets_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootBackup_Attendance_LogsArgs = {
  distinct_on?: Maybe<Array<Backup_Attendance_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Backup_Attendance_Logs_Order_By>>;
  where?: Maybe<Backup_Attendance_Logs_Bool_Exp>;
};


/** query root */
export type Query_RootBackup_Attendance_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Backup_Attendance_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Backup_Attendance_Logs_Order_By>>;
  where?: Maybe<Backup_Attendance_Logs_Bool_Exp>;
};


/** query root */
export type Query_RootBackup_Attendance_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootBanksArgs = {
  distinct_on?: Maybe<Array<Banks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Banks_Order_By>>;
  where?: Maybe<Banks_Bool_Exp>;
};


/** query root */
export type Query_RootBanks_AggregateArgs = {
  distinct_on?: Maybe<Array<Banks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Banks_Order_By>>;
  where?: Maybe<Banks_Bool_Exp>;
};


/** query root */
export type Query_RootBanks_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootBatch_Payment_AdvicesArgs = {
  distinct_on?: Maybe<Array<Batch_Payment_Advices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Batch_Payment_Advices_Order_By>>;
  where?: Maybe<Batch_Payment_Advices_Bool_Exp>;
};


/** query root */
export type Query_RootBatch_Payment_Advices_AggregateArgs = {
  distinct_on?: Maybe<Array<Batch_Payment_Advices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Batch_Payment_Advices_Order_By>>;
  where?: Maybe<Batch_Payment_Advices_Bool_Exp>;
};


/** query root */
export type Query_RootBatch_Payment_Advices_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootBranchesArgs = {
  distinct_on?: Maybe<Array<Branches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Branches_Order_By>>;
  where?: Maybe<Branches_Bool_Exp>;
};


/** query root */
export type Query_RootBranches_AggregateArgs = {
  distinct_on?: Maybe<Array<Branches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Branches_Order_By>>;
  where?: Maybe<Branches_Bool_Exp>;
};


/** query root */
export type Query_RootBranches_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootBroadcast_LogsArgs = {
  distinct_on?: Maybe<Array<Broadcast_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Broadcast_Logs_Order_By>>;
  where?: Maybe<Broadcast_Logs_Bool_Exp>;
};


/** query root */
export type Query_RootBroadcast_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Broadcast_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Broadcast_Logs_Order_By>>;
  where?: Maybe<Broadcast_Logs_Bool_Exp>;
};


/** query root */
export type Query_RootBroadcast_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootBroadcastsArgs = {
  distinct_on?: Maybe<Array<Broadcasts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Broadcasts_Order_By>>;
  where?: Maybe<Broadcasts_Bool_Exp>;
};


/** query root */
export type Query_RootBroadcasts_AggregateArgs = {
  distinct_on?: Maybe<Array<Broadcasts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Broadcasts_Order_By>>;
  where?: Maybe<Broadcasts_Bool_Exp>;
};


/** query root */
export type Query_RootBroadcasts_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootClass_Filter_By_Filling_StatusArgs = {
  args: Class_Filter_By_Filling_Status_Args;
  distinct_on?: Maybe<Array<Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classes_Order_By>>;
  where?: Maybe<Classes_Bool_Exp>;
};


/** query root */
export type Query_RootClass_Filter_By_Filling_Status_AggregateArgs = {
  args: Class_Filter_By_Filling_Status_Args;
  distinct_on?: Maybe<Array<Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classes_Order_By>>;
  where?: Maybe<Classes_Bool_Exp>;
};


/** query root */
export type Query_RootClass_Filter_By_StudentArgs = {
  args: Class_Filter_By_Student_Args;
  distinct_on?: Maybe<Array<Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classes_Order_By>>;
  where?: Maybe<Classes_Bool_Exp>;
};


/** query root */
export type Query_RootClass_Filter_By_Student_AggregateArgs = {
  args: Class_Filter_By_Student_Args;
  distinct_on?: Maybe<Array<Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classes_Order_By>>;
  where?: Maybe<Classes_Bool_Exp>;
};


/** query root */
export type Query_RootClass_Students_WaitingArgs = {
  distinct_on?: Maybe<Array<Class_Students_Waiting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Class_Students_Waiting_Order_By>>;
  where?: Maybe<Class_Students_Waiting_Bool_Exp>;
};


/** query root */
export type Query_RootClass_Students_Waiting_AggregateArgs = {
  distinct_on?: Maybe<Array<Class_Students_Waiting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Class_Students_Waiting_Order_By>>;
  where?: Maybe<Class_Students_Waiting_Bool_Exp>;
};


/** query root */
export type Query_RootClass_Students_Waiting_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootClassesArgs = {
  distinct_on?: Maybe<Array<Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classes_Order_By>>;
  where?: Maybe<Classes_Bool_Exp>;
};


/** query root */
export type Query_RootClasses_AggregateArgs = {
  distinct_on?: Maybe<Array<Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classes_Order_By>>;
  where?: Maybe<Classes_Bool_Exp>;
};


/** query root */
export type Query_RootClasses_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootClassroomsArgs = {
  distinct_on?: Maybe<Array<Classrooms_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classrooms_Order_By>>;
  where?: Maybe<Classrooms_Bool_Exp>;
};


/** query root */
export type Query_RootClassrooms_AggregateArgs = {
  distinct_on?: Maybe<Array<Classrooms_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classrooms_Order_By>>;
  where?: Maybe<Classrooms_Bool_Exp>;
};


/** query root */
export type Query_RootClassrooms_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootCountSpecialClassesArgs = {
  programId: Scalars['String'];
};


/** query root */
export type Query_RootCredit_Note_ClassesArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Classes_Order_By>>;
  where?: Maybe<Credit_Note_Classes_Bool_Exp>;
};


/** query root */
export type Query_RootCredit_Note_Classes_AggregateArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Classes_Order_By>>;
  where?: Maybe<Credit_Note_Classes_Bool_Exp>;
};


/** query root */
export type Query_RootCredit_Note_Classes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootCredit_Note_FeesArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Fees_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Fees_Order_By>>;
  where?: Maybe<Credit_Note_Fees_Bool_Exp>;
};


/** query root */
export type Query_RootCredit_Note_Fees_AggregateArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Fees_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Fees_Order_By>>;
  where?: Maybe<Credit_Note_Fees_Bool_Exp>;
};


/** query root */
export type Query_RootCredit_Note_Fees_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootCredit_Note_FilterArgs = {
  args: Credit_Note_Filter_Args;
  distinct_on?: Maybe<Array<Credit_Notes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Notes_Order_By>>;
  where?: Maybe<Credit_Notes_Bool_Exp>;
};


/** query root */
export type Query_RootCredit_Note_Filter_AggregateArgs = {
  args: Credit_Note_Filter_Args;
  distinct_on?: Maybe<Array<Credit_Notes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Notes_Order_By>>;
  where?: Maybe<Credit_Notes_Bool_Exp>;
};


/** query root */
export type Query_RootCredit_Note_LogsArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Logs_Order_By>>;
  where?: Maybe<Credit_Note_Logs_Bool_Exp>;
};


/** query root */
export type Query_RootCredit_Note_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Logs_Order_By>>;
  where?: Maybe<Credit_Note_Logs_Bool_Exp>;
};


/** query root */
export type Query_RootCredit_Note_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootCredit_NotesArgs = {
  distinct_on?: Maybe<Array<Credit_Notes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Notes_Order_By>>;
  where?: Maybe<Credit_Notes_Bool_Exp>;
};


/** query root */
export type Query_RootCredit_Notes_AggregateArgs = {
  distinct_on?: Maybe<Array<Credit_Notes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Notes_Order_By>>;
  where?: Maybe<Credit_Notes_Bool_Exp>;
};


/** query root */
export type Query_RootCredit_Notes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootCurriculumsArgs = {
  distinct_on?: Maybe<Array<Curriculums_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Curriculums_Order_By>>;
  where?: Maybe<Curriculums_Bool_Exp>;
};


/** query root */
export type Query_RootCurriculums_AggregateArgs = {
  distinct_on?: Maybe<Array<Curriculums_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Curriculums_Order_By>>;
  where?: Maybe<Curriculums_Bool_Exp>;
};


/** query root */
export type Query_RootCurriculums_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootCurriculums_LevelsArgs = {
  distinct_on?: Maybe<Array<Curriculums_Levels_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Curriculums_Levels_Order_By>>;
  where?: Maybe<Curriculums_Levels_Bool_Exp>;
};


/** query root */
export type Query_RootCurriculums_Levels_AggregateArgs = {
  distinct_on?: Maybe<Array<Curriculums_Levels_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Curriculums_Levels_Order_By>>;
  where?: Maybe<Curriculums_Levels_Bool_Exp>;
};


/** query root */
export type Query_RootCurriculums_Levels_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootDepositsArgs = {
  distinct_on?: Maybe<Array<Deposits_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Deposits_Order_By>>;
  where?: Maybe<Deposits_Bool_Exp>;
};


/** query root */
export type Query_RootDeposits_AggregateArgs = {
  distinct_on?: Maybe<Array<Deposits_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Deposits_Order_By>>;
  where?: Maybe<Deposits_Bool_Exp>;
};


/** query root */
export type Query_RootDeposits_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootDiscount_BillsArgs = {
  distinct_on?: Maybe<Array<Discount_Bills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discount_Bills_Order_By>>;
  where?: Maybe<Discount_Bills_Bool_Exp>;
};


/** query root */
export type Query_RootDiscount_Bills_AggregateArgs = {
  distinct_on?: Maybe<Array<Discount_Bills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discount_Bills_Order_By>>;
  where?: Maybe<Discount_Bills_Bool_Exp>;
};


/** query root */
export type Query_RootDiscount_Bills_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootDiscount_StudentsArgs = {
  distinct_on?: Maybe<Array<Discount_Students_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discount_Students_Order_By>>;
  where?: Maybe<Discount_Students_Bool_Exp>;
};


/** query root */
export type Query_RootDiscount_Students_AggregateArgs = {
  distinct_on?: Maybe<Array<Discount_Students_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discount_Students_Order_By>>;
  where?: Maybe<Discount_Students_Bool_Exp>;
};


/** query root */
export type Query_RootDiscount_Students_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootDiscountsArgs = {
  distinct_on?: Maybe<Array<Discounts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discounts_Order_By>>;
  where?: Maybe<Discounts_Bool_Exp>;
};


/** query root */
export type Query_RootDiscounts_AggregateArgs = {
  distinct_on?: Maybe<Array<Discounts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discounts_Order_By>>;
  where?: Maybe<Discounts_Bool_Exp>;
};


/** query root */
export type Query_RootDiscounts_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootDouble_Lesson_Academic_PricingsArgs = {
  distinct_on?: Maybe<Array<Double_Lesson_Academic_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Double_Lesson_Academic_Pricings_Order_By>>;
  where?: Maybe<Double_Lesson_Academic_Pricings_Bool_Exp>;
};


/** query root */
export type Query_RootDouble_Lesson_Academic_Pricings_AggregateArgs = {
  distinct_on?: Maybe<Array<Double_Lesson_Academic_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Double_Lesson_Academic_Pricings_Order_By>>;
  where?: Maybe<Double_Lesson_Academic_Pricings_Bool_Exp>;
};


/** query root */
export type Query_RootDouble_Lesson_Academic_Pricings_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootDouble_Lesson_Program_TypesArgs = {
  distinct_on?: Maybe<Array<Double_Lesson_Program_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Double_Lesson_Program_Types_Order_By>>;
  where?: Maybe<Double_Lesson_Program_Types_Bool_Exp>;
};


/** query root */
export type Query_RootDouble_Lesson_Program_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Double_Lesson_Program_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Double_Lesson_Program_Types_Order_By>>;
  where?: Maybe<Double_Lesson_Program_Types_Bool_Exp>;
};


/** query root */
export type Query_RootDouble_Lesson_Program_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootDouble_Lesson_Programme_PricingsArgs = {
  distinct_on?: Maybe<Array<Double_Lesson_Programme_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Double_Lesson_Programme_Pricings_Order_By>>;
  where?: Maybe<Double_Lesson_Programme_Pricings_Bool_Exp>;
};


/** query root */
export type Query_RootDouble_Lesson_Programme_Pricings_AggregateArgs = {
  distinct_on?: Maybe<Array<Double_Lesson_Programme_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Double_Lesson_Programme_Pricings_Order_By>>;
  where?: Maybe<Double_Lesson_Programme_Pricings_Bool_Exp>;
};


/** query root */
export type Query_RootDouble_Lesson_Programme_Pricings_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootEmail_Student_LogsArgs = {
  distinct_on?: Maybe<Array<Email_Student_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Email_Student_Logs_Order_By>>;
  where?: Maybe<Email_Student_Logs_Bool_Exp>;
};


/** query root */
export type Query_RootEmail_Student_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Email_Student_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Email_Student_Logs_Order_By>>;
  where?: Maybe<Email_Student_Logs_Bool_Exp>;
};


/** query root */
export type Query_RootEmail_Student_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootEnrollment_List_NewArgs = {
  distinct_on?: Maybe<Array<Enrollment_List_New_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Enrollment_List_New_Order_By>>;
  where?: Maybe<Enrollment_List_New_Bool_Exp>;
};


/** query root */
export type Query_RootEnrollment_List_New_AggregateArgs = {
  distinct_on?: Maybe<Array<Enrollment_List_New_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Enrollment_List_New_Order_By>>;
  where?: Maybe<Enrollment_List_New_Bool_Exp>;
};


/** query root */
export type Query_RootEnrollment_List_New_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootFilterClassByStudentIdArgs = {
  form: FilterClassList;
  studentId: Scalars['String'];
};


/** query root */
export type Query_RootGeneral_Program_TypesArgs = {
  distinct_on?: Maybe<Array<General_Program_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<General_Program_Types_Order_By>>;
  where?: Maybe<General_Program_Types_Bool_Exp>;
};


/** query root */
export type Query_RootGeneral_Program_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<General_Program_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<General_Program_Types_Order_By>>;
  where?: Maybe<General_Program_Types_Bool_Exp>;
};


/** query root */
export type Query_RootGeneral_Program_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootGetClassInformationArgs = {
  form: FormGetClassInformation;
};


/** query root */
export type Query_RootGetClassInformationForCreditNoteArgs = {
  form: FormGetClassInformationForCreditNote;
};


/** query root */
export type Query_RootGetClassInformationForRefundArgs = {
  form: FormWithdrawalClass;
  noticeDate: Scalars['DateTime'];
};


/** query root */
export type Query_RootGetClassUpcomingOfStudentArgs = {
  studentId: Scalars['String'];
};


/** query root */
export type Query_RootGetClassroomAvailableArgs = {
  form?: Maybe<FormGetClassroomAvailable>;
};


/** query root */
export type Query_RootGetDetailInvoiceArgs = {
  id: Scalars['String'];
};


/** query root */
export type Query_RootGetDetailPaymentAdviceArgs = {
  id: Scalars['String'];
};


/** query root */
export type Query_RootGetDetailPaymentAdvicePaperArgs = {
  id: Scalars['String'];
  invoiceId?: Maybe<Scalars['String']>;
};


/** query root */
export type Query_RootGetDetailRefundArgs = {
  id: Scalars['String'];
};


/** query root */
export type Query_RootGetListClassNotRefundByStudentArgs = {
  studentId: Scalars['String'];
};


/** query root */
export type Query_RootGetPaRelationshipsArgs = {
  id: Scalars['String'];
};


/** query root */
export type Query_RootGetReceiptListingsArgs = {
  fromDate: Scalars['DateTime'];
  toDate: Scalars['DateTime'];
};


/** query root */
export type Query_RootGetStudentsWithManyAbsentsArgs = {
  form: FilterAbsentStudents;
  numberOfAbsents: Scalars['Float'];
};


/** query root */
export type Query_RootGet_ProfileArgs = {
  distinct_on?: Maybe<Array<Get_Profile_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Get_Profile_Order_By>>;
  where?: Maybe<Get_Profile_Bool_Exp>;
};


/** query root */
export type Query_RootGet_Profile_AggregateArgs = {
  distinct_on?: Maybe<Array<Get_Profile_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Get_Profile_Order_By>>;
  where?: Maybe<Get_Profile_Bool_Exp>;
};


/** query root */
export type Query_RootInvoice_FilterArgs = {
  args: Invoice_Filter_Args;
  distinct_on?: Maybe<Array<Invoices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoices_Order_By>>;
  where?: Maybe<Invoices_Bool_Exp>;
};


/** query root */
export type Query_RootInvoice_Filter_AggregateArgs = {
  args: Invoice_Filter_Args;
  distinct_on?: Maybe<Array<Invoices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoices_Order_By>>;
  where?: Maybe<Invoices_Bool_Exp>;
};


/** query root */
export type Query_RootInvoice_Partial_PaymentsArgs = {
  distinct_on?: Maybe<Array<Invoice_Partial_Payments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoice_Partial_Payments_Order_By>>;
  where?: Maybe<Invoice_Partial_Payments_Bool_Exp>;
};


/** query root */
export type Query_RootInvoice_Partial_Payments_AggregateArgs = {
  distinct_on?: Maybe<Array<Invoice_Partial_Payments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoice_Partial_Payments_Order_By>>;
  where?: Maybe<Invoice_Partial_Payments_Bool_Exp>;
};


/** query root */
export type Query_RootInvoice_Partial_Payments_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootInvoicesArgs = {
  distinct_on?: Maybe<Array<Invoices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoices_Order_By>>;
  where?: Maybe<Invoices_Bool_Exp>;
};


/** query root */
export type Query_RootInvoices_AggregateArgs = {
  distinct_on?: Maybe<Array<Invoices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoices_Order_By>>;
  where?: Maybe<Invoices_Bool_Exp>;
};


/** query root */
export type Query_RootInvoices_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootLessonsArgs = {
  distinct_on?: Maybe<Array<Lessons_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Order_By>>;
  where?: Maybe<Lessons_Bool_Exp>;
};


/** query root */
export type Query_RootLessons_AggregateArgs = {
  distinct_on?: Maybe<Array<Lessons_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Order_By>>;
  where?: Maybe<Lessons_Bool_Exp>;
};


/** query root */
export type Query_RootLessons_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootLessons_StudentsArgs = {
  distinct_on?: Maybe<Array<Lessons_Students_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Students_Order_By>>;
  where?: Maybe<Lessons_Students_Bool_Exp>;
};


/** query root */
export type Query_RootLessons_Students_AggregateArgs = {
  distinct_on?: Maybe<Array<Lessons_Students_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Students_Order_By>>;
  where?: Maybe<Lessons_Students_Bool_Exp>;
};


/** query root */
export type Query_RootLessons_Students_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootLevelsArgs = {
  distinct_on?: Maybe<Array<Levels_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Levels_Order_By>>;
  where?: Maybe<Levels_Bool_Exp>;
};


/** query root */
export type Query_RootLevels_AggregateArgs = {
  distinct_on?: Maybe<Array<Levels_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Levels_Order_By>>;
  where?: Maybe<Levels_Bool_Exp>;
};


/** query root */
export type Query_RootLevels_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootNewsArgs = {
  distinct_on?: Maybe<Array<News_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<News_Order_By>>;
  where?: Maybe<News_Bool_Exp>;
};


/** query root */
export type Query_RootNews_AggregateArgs = {
  distinct_on?: Maybe<Array<News_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<News_Order_By>>;
  where?: Maybe<News_Bool_Exp>;
};


/** query root */
export type Query_RootNews_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootNews_LogsArgs = {
  distinct_on?: Maybe<Array<News_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<News_Logs_Order_By>>;
  where?: Maybe<News_Logs_Bool_Exp>;
};


/** query root */
export type Query_RootNews_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<News_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<News_Logs_Order_By>>;
  where?: Maybe<News_Logs_Bool_Exp>;
};


/** query root */
export type Query_RootNews_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootNews_Recipients_UploadArgs = {
  distinct_on?: Maybe<Array<News_Recipients_Upload_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<News_Recipients_Upload_Order_By>>;
  where?: Maybe<News_Recipients_Upload_Bool_Exp>;
};


/** query root */
export type Query_RootNews_Recipients_Upload_AggregateArgs = {
  distinct_on?: Maybe<Array<News_Recipients_Upload_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<News_Recipients_Upload_Order_By>>;
  where?: Maybe<News_Recipients_Upload_Bool_Exp>;
};


/** query root */
export type Query_RootNews_Recipients_Upload_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootPass_Door_LogsArgs = {
  distinct_on?: Maybe<Array<Pass_Door_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Pass_Door_Logs_Order_By>>;
  where?: Maybe<Pass_Door_Logs_Bool_Exp>;
};


/** query root */
export type Query_RootPass_Door_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Pass_Door_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Pass_Door_Logs_Order_By>>;
  where?: Maybe<Pass_Door_Logs_Bool_Exp>;
};


/** query root */
export type Query_RootPass_Door_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootPayment_Advice_Class_TransferArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Class_Transfer_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Class_Transfer_Order_By>>;
  where?: Maybe<Payment_Advice_Class_Transfer_Bool_Exp>;
};


/** query root */
export type Query_RootPayment_Advice_Class_Transfer_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Class_Transfer_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Class_Transfer_Order_By>>;
  where?: Maybe<Payment_Advice_Class_Transfer_Bool_Exp>;
};


/** query root */
export type Query_RootPayment_Advice_Class_Transfer_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootPayment_Advice_ClassesArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Classes_Order_By>>;
  where?: Maybe<Payment_Advice_Classes_Bool_Exp>;
};


/** query root */
export type Query_RootPayment_Advice_Classes_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Classes_Order_By>>;
  where?: Maybe<Payment_Advice_Classes_Bool_Exp>;
};


/** query root */
export type Query_RootPayment_Advice_Classes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootPayment_Advice_Classes_By_Student_IdArgs = {
  args: Payment_Advice_Classes_By_Student_Id_Args;
  distinct_on?: Maybe<Array<Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classes_Order_By>>;
  where?: Maybe<Classes_Bool_Exp>;
};


/** query root */
export type Query_RootPayment_Advice_Classes_By_Student_Id_AggregateArgs = {
  args: Payment_Advice_Classes_By_Student_Id_Args;
  distinct_on?: Maybe<Array<Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classes_Order_By>>;
  where?: Maybe<Classes_Bool_Exp>;
};


/** query root */
export type Query_RootPayment_Advice_Delete_LogsArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Delete_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Delete_Logs_Order_By>>;
  where?: Maybe<Payment_Advice_Delete_Logs_Bool_Exp>;
};


/** query root */
export type Query_RootPayment_Advice_Delete_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Delete_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Delete_Logs_Order_By>>;
  where?: Maybe<Payment_Advice_Delete_Logs_Bool_Exp>;
};


/** query root */
export type Query_RootPayment_Advice_Delete_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootPayment_Advice_FilterArgs = {
  args: Payment_Advice_Filter_Args;
  distinct_on?: Maybe<Array<Payment_Advices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advices_Order_By>>;
  where?: Maybe<Payment_Advices_Bool_Exp>;
};


/** query root */
export type Query_RootPayment_Advice_Filter_AggregateArgs = {
  args: Payment_Advice_Filter_Args;
  distinct_on?: Maybe<Array<Payment_Advices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advices_Order_By>>;
  where?: Maybe<Payment_Advices_Bool_Exp>;
};


/** query root */
export type Query_RootPayment_Advice_LogsArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Logs_Order_By>>;
  where?: Maybe<Payment_Advice_Logs_Bool_Exp>;
};


/** query root */
export type Query_RootPayment_Advice_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Logs_Order_By>>;
  where?: Maybe<Payment_Advice_Logs_Bool_Exp>;
};


/** query root */
export type Query_RootPayment_Advice_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootPayment_Advice_Term_ClassesArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Term_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Term_Classes_Order_By>>;
  where?: Maybe<Payment_Advice_Term_Classes_Bool_Exp>;
};


/** query root */
export type Query_RootPayment_Advice_Term_Classes_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Term_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Term_Classes_Order_By>>;
  where?: Maybe<Payment_Advice_Term_Classes_Bool_Exp>;
};


/** query root */
export type Query_RootPayment_Advice_Term_Classes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootPayment_Advice_TransfersArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Transfers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Transfers_Order_By>>;
  where?: Maybe<Payment_Advice_Transfers_Bool_Exp>;
};


/** query root */
export type Query_RootPayment_Advice_Transfers_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Transfers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Transfers_Order_By>>;
  where?: Maybe<Payment_Advice_Transfers_Bool_Exp>;
};


/** query root */
export type Query_RootPayment_Advice_Transfers_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootPayment_AdvicesArgs = {
  distinct_on?: Maybe<Array<Payment_Advices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advices_Order_By>>;
  where?: Maybe<Payment_Advices_Bool_Exp>;
};


/** query root */
export type Query_RootPayment_Advices_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advices_Order_By>>;
  where?: Maybe<Payment_Advices_Bool_Exp>;
};


/** query root */
export type Query_RootPayment_Advices_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootProgramsArgs = {
  distinct_on?: Maybe<Array<Programs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Programs_Order_By>>;
  where?: Maybe<Programs_Bool_Exp>;
};


/** query root */
export type Query_RootPrograms_AggregateArgs = {
  distinct_on?: Maybe<Array<Programs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Programs_Order_By>>;
  where?: Maybe<Programs_Bool_Exp>;
};


/** query root */
export type Query_RootPrograms_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootReceipt_FilterArgs = {
  args: Receipt_Filter_Args;
  distinct_on?: Maybe<Array<Receipts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Receipts_Order_By>>;
  where?: Maybe<Receipts_Bool_Exp>;
};


/** query root */
export type Query_RootReceipt_Filter_AggregateArgs = {
  args: Receipt_Filter_Args;
  distinct_on?: Maybe<Array<Receipts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Receipts_Order_By>>;
  where?: Maybe<Receipts_Bool_Exp>;
};


/** query root */
export type Query_RootReceipt_Filter_By_ClassArgs = {
  args: Receipt_Filter_By_Class_Args;
  distinct_on?: Maybe<Array<Receipts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Receipts_Order_By>>;
  where?: Maybe<Receipts_Bool_Exp>;
};


/** query root */
export type Query_RootReceipt_Filter_By_Class_AggregateArgs = {
  args: Receipt_Filter_By_Class_Args;
  distinct_on?: Maybe<Array<Receipts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Receipts_Order_By>>;
  where?: Maybe<Receipts_Bool_Exp>;
};


/** query root */
export type Query_RootReceiptsArgs = {
  distinct_on?: Maybe<Array<Receipts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Receipts_Order_By>>;
  where?: Maybe<Receipts_Bool_Exp>;
};


/** query root */
export type Query_RootReceipts_AggregateArgs = {
  distinct_on?: Maybe<Array<Receipts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Receipts_Order_By>>;
  where?: Maybe<Receipts_Bool_Exp>;
};


/** query root */
export type Query_RootReceipts_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootRefund_ClassesArgs = {
  distinct_on?: Maybe<Array<Refund_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refund_Classes_Order_By>>;
  where?: Maybe<Refund_Classes_Bool_Exp>;
};


/** query root */
export type Query_RootRefund_Classes_AggregateArgs = {
  distinct_on?: Maybe<Array<Refund_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refund_Classes_Order_By>>;
  where?: Maybe<Refund_Classes_Bool_Exp>;
};


/** query root */
export type Query_RootRefund_Classes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootRefund_FilterArgs = {
  args: Refund_Filter_Args;
  distinct_on?: Maybe<Array<Refunds_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refunds_Order_By>>;
  where?: Maybe<Refunds_Bool_Exp>;
};


/** query root */
export type Query_RootRefund_Filter_AggregateArgs = {
  args: Refund_Filter_Args;
  distinct_on?: Maybe<Array<Refunds_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refunds_Order_By>>;
  where?: Maybe<Refunds_Bool_Exp>;
};


/** query root */
export type Query_RootRefund_LogsArgs = {
  distinct_on?: Maybe<Array<Refund_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refund_Logs_Order_By>>;
  where?: Maybe<Refund_Logs_Bool_Exp>;
};


/** query root */
export type Query_RootRefund_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Refund_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refund_Logs_Order_By>>;
  where?: Maybe<Refund_Logs_Bool_Exp>;
};


/** query root */
export type Query_RootRefund_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootRefundsArgs = {
  distinct_on?: Maybe<Array<Refunds_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refunds_Order_By>>;
  where?: Maybe<Refunds_Bool_Exp>;
};


/** query root */
export type Query_RootRefunds_AggregateArgs = {
  distinct_on?: Maybe<Array<Refunds_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refunds_Order_By>>;
  where?: Maybe<Refunds_Bool_Exp>;
};


/** query root */
export type Query_RootRefunds_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootRegular_Academic_PricingsArgs = {
  distinct_on?: Maybe<Array<Regular_Academic_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Regular_Academic_Pricings_Order_By>>;
  where?: Maybe<Regular_Academic_Pricings_Bool_Exp>;
};


/** query root */
export type Query_RootRegular_Academic_Pricings_AggregateArgs = {
  distinct_on?: Maybe<Array<Regular_Academic_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Regular_Academic_Pricings_Order_By>>;
  where?: Maybe<Regular_Academic_Pricings_Bool_Exp>;
};


/** query root */
export type Query_RootRegular_Academic_Pricings_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootRegular_Program_TypesArgs = {
  distinct_on?: Maybe<Array<Regular_Program_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Regular_Program_Types_Order_By>>;
  where?: Maybe<Regular_Program_Types_Bool_Exp>;
};


/** query root */
export type Query_RootRegular_Program_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Regular_Program_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Regular_Program_Types_Order_By>>;
  where?: Maybe<Regular_Program_Types_Bool_Exp>;
};


/** query root */
export type Query_RootRegular_Program_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootRegular_Programme_PricingsArgs = {
  distinct_on?: Maybe<Array<Regular_Programme_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Regular_Programme_Pricings_Order_By>>;
  where?: Maybe<Regular_Programme_Pricings_Bool_Exp>;
};


/** query root */
export type Query_RootRegular_Programme_Pricings_AggregateArgs = {
  distinct_on?: Maybe<Array<Regular_Programme_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Regular_Programme_Pricings_Order_By>>;
  where?: Maybe<Regular_Programme_Pricings_Bool_Exp>;
};


/** query root */
export type Query_RootRegular_Programme_Pricings_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootReport_Subject_BudgetArgs = {
  distinct_on?: Maybe<Array<Report_Subject_Budget_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Report_Subject_Budget_Order_By>>;
  where?: Maybe<Report_Subject_Budget_Bool_Exp>;
};


/** query root */
export type Query_RootReport_Subject_Budget_AggregateArgs = {
  distinct_on?: Maybe<Array<Report_Subject_Budget_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Report_Subject_Budget_Order_By>>;
  where?: Maybe<Report_Subject_Budget_Bool_Exp>;
};


/** query root */
export type Query_RootReport_Subject_Budget_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootRequest_Transfer_ClassesArgs = {
  distinct_on?: Maybe<Array<Request_Transfer_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Request_Transfer_Classes_Order_By>>;
  where?: Maybe<Request_Transfer_Classes_Bool_Exp>;
};


/** query root */
export type Query_RootRequest_Transfer_Classes_AggregateArgs = {
  distinct_on?: Maybe<Array<Request_Transfer_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Request_Transfer_Classes_Order_By>>;
  where?: Maybe<Request_Transfer_Classes_Bool_Exp>;
};


/** query root */
export type Query_RootRequest_Transfer_Classes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootRolesArgs = {
  distinct_on?: Maybe<Array<Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Roles_Order_By>>;
  where?: Maybe<Roles_Bool_Exp>;
};


/** query root */
export type Query_RootRoles_AggregateArgs = {
  distinct_on?: Maybe<Array<Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Roles_Order_By>>;
  where?: Maybe<Roles_Bool_Exp>;
};


/** query root */
export type Query_RootRoles_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootSchoolsArgs = {
  distinct_on?: Maybe<Array<Schools_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Schools_Order_By>>;
  where?: Maybe<Schools_Bool_Exp>;
};


/** query root */
export type Query_RootSchools_AggregateArgs = {
  distinct_on?: Maybe<Array<Schools_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Schools_Order_By>>;
  where?: Maybe<Schools_Bool_Exp>;
};


/** query root */
export type Query_RootSchools_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootSentBroadcastArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootSentNewsArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootSessionsArgs = {
  distinct_on?: Maybe<Array<Sessions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Sessions_Order_By>>;
  where?: Maybe<Sessions_Bool_Exp>;
};


/** query root */
export type Query_RootSessions_AggregateArgs = {
  distinct_on?: Maybe<Array<Sessions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Sessions_Order_By>>;
  where?: Maybe<Sessions_Bool_Exp>;
};


/** query root */
export type Query_RootSessions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootSpecial_Programme_Class_PricingsArgs = {
  distinct_on?: Maybe<Array<Special_Programme_Class_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Special_Programme_Class_Pricings_Order_By>>;
  where?: Maybe<Special_Programme_Class_Pricings_Bool_Exp>;
};


/** query root */
export type Query_RootSpecial_Programme_Class_Pricings_AggregateArgs = {
  distinct_on?: Maybe<Array<Special_Programme_Class_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Special_Programme_Class_Pricings_Order_By>>;
  where?: Maybe<Special_Programme_Class_Pricings_Bool_Exp>;
};


/** query root */
export type Query_RootSpecial_Programme_Class_Pricings_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootSpecical_Program_TypesArgs = {
  distinct_on?: Maybe<Array<Specical_Program_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Specical_Program_Types_Order_By>>;
  where?: Maybe<Specical_Program_Types_Bool_Exp>;
};


/** query root */
export type Query_RootSpecical_Program_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Specical_Program_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Specical_Program_Types_Order_By>>;
  where?: Maybe<Specical_Program_Types_Bool_Exp>;
};


/** query root */
export type Query_RootSpecical_Program_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootStudent_ProfilesArgs = {
  distinct_on?: Maybe<Array<Student_Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Student_Profiles_Order_By>>;
  where?: Maybe<Student_Profiles_Bool_Exp>;
};


/** query root */
export type Query_RootStudent_Profiles_AggregateArgs = {
  distinct_on?: Maybe<Array<Student_Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Student_Profiles_Order_By>>;
  where?: Maybe<Student_Profiles_Bool_Exp>;
};


/** query root */
export type Query_RootStudent_Profiles_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootStudents_FilterArgs = {
  args: Students_Filter_Args;
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** query root */
export type Query_RootStudents_Filter_AggregateArgs = {
  args: Students_Filter_Args;
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** query root */
export type Query_RootStudents_List_FilterArgs = {
  args: Students_List_Filter_Args;
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** query root */
export type Query_RootStudents_List_Filter_AggregateArgs = {
  args: Students_List_Filter_Args;
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** query root */
export type Query_RootStudents_List_Filter_PaymentArgs = {
  args: Students_List_Filter_Payment_Args;
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** query root */
export type Query_RootStudents_List_Filter_Payment_AggregateArgs = {
  args: Students_List_Filter_Payment_Args;
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** query root */
export type Query_RootStudents_Programs_FilterArgs = {
  args: Students_Programs_Filter_Args;
  distinct_on?: Maybe<Array<Programs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Programs_Order_By>>;
  where?: Maybe<Programs_Bool_Exp>;
};


/** query root */
export type Query_RootStudents_Programs_Filter_AggregateArgs = {
  args: Students_Programs_Filter_Args;
  distinct_on?: Maybe<Array<Programs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Programs_Order_By>>;
  where?: Maybe<Programs_Bool_Exp>;
};


/** query root */
export type Query_RootSubjectsArgs = {
  distinct_on?: Maybe<Array<Subjects_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Subjects_Order_By>>;
  where?: Maybe<Subjects_Bool_Exp>;
};


/** query root */
export type Query_RootSubjects_AggregateArgs = {
  distinct_on?: Maybe<Array<Subjects_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Subjects_Order_By>>;
  where?: Maybe<Subjects_Bool_Exp>;
};


/** query root */
export type Query_RootSubjects_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootSystem_SettingsArgs = {
  distinct_on?: Maybe<Array<System_Settings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<System_Settings_Order_By>>;
  where?: Maybe<System_Settings_Bool_Exp>;
};


/** query root */
export type Query_RootSystem_Settings_AggregateArgs = {
  distinct_on?: Maybe<Array<System_Settings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<System_Settings_Order_By>>;
  where?: Maybe<System_Settings_Bool_Exp>;
};


/** query root */
export type Query_RootSystem_Settings_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootTerm_ClassesArgs = {
  distinct_on?: Maybe<Array<Term_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Term_Classes_Order_By>>;
  where?: Maybe<Term_Classes_Bool_Exp>;
};


/** query root */
export type Query_RootTerm_Classes_AggregateArgs = {
  distinct_on?: Maybe<Array<Term_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Term_Classes_Order_By>>;
  where?: Maybe<Term_Classes_Bool_Exp>;
};


/** query root */
export type Query_RootTerm_Classes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootTermsArgs = {
  distinct_on?: Maybe<Array<Terms_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Terms_Order_By>>;
  where?: Maybe<Terms_Bool_Exp>;
};


/** query root */
export type Query_RootTerms_AggregateArgs = {
  distinct_on?: Maybe<Array<Terms_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Terms_Order_By>>;
  where?: Maybe<Terms_Bool_Exp>;
};


/** query root */
export type Query_RootTerms_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootThree_Times_AbsentsArgs = {
  distinct_on?: Maybe<Array<Three_Times_Absents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Three_Times_Absents_Order_By>>;
  where?: Maybe<Three_Times_Absents_Bool_Exp>;
};


/** query root */
export type Query_RootThree_Times_Absents_AggregateArgs = {
  distinct_on?: Maybe<Array<Three_Times_Absents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Three_Times_Absents_Order_By>>;
  where?: Maybe<Three_Times_Absents_Bool_Exp>;
};


/** query root */
export type Query_RootThree_Times_Absents_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootTransaction_LogsArgs = {
  distinct_on?: Maybe<Array<Transaction_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Transaction_Logs_Order_By>>;
  where?: Maybe<Transaction_Logs_Bool_Exp>;
};


/** query root */
export type Query_RootTransaction_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Transaction_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Transaction_Logs_Order_By>>;
  where?: Maybe<Transaction_Logs_Bool_Exp>;
};


/** query root */
export type Query_RootTransaction_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** query root */
export type Query_RootUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** query root */
export type Query_RootUsers_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootVms_Person_GroupsArgs = {
  distinct_on?: Maybe<Array<Vms_Person_Groups_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vms_Person_Groups_Order_By>>;
  where?: Maybe<Vms_Person_Groups_Bool_Exp>;
};


/** query root */
export type Query_RootVms_Person_Groups_AggregateArgs = {
  distinct_on?: Maybe<Array<Vms_Person_Groups_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vms_Person_Groups_Order_By>>;
  where?: Maybe<Vms_Person_Groups_Bool_Exp>;
};


/** query root */
export type Query_RootVms_Person_Groups_By_PkArgs = {
  id: Scalars['uuid'];
};

export type Receipt_Filter_Args = {
  month?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type Receipt_Filter_By_Class_Args = {
  class_id?: Maybe<Scalars['uuid']>;
  student_id?: Maybe<Scalars['uuid']>;
};

/** columns and relationships of "receipts" */
export type Receipts = {
  __typename?: 'receipts';
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  credit_note_fees: Array<Credit_Note_Fees>;
  /** An aggregated array relationship */
  credit_note_fees_aggregate: Credit_Note_Fees_Aggregate;
  /** An array relationship */
  deposits: Array<Deposits>;
  /** An aggregated array relationship */
  deposits_aggregate: Deposits_Aggregate;
  id: Scalars['uuid'];
  /** An object relationship */
  invoice: Invoices;
  invoiceId: Scalars['uuid'];
  link?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  receiptDate?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  refund_classes: Array<Refund_Classes>;
  /** An aggregated array relationship */
  refund_classes_aggregate: Refund_Classes_Aggregate;
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  userByCreatedby?: Maybe<Users>;
};


/** columns and relationships of "receipts" */
export type ReceiptsCredit_Note_FeesArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Fees_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Fees_Order_By>>;
  where?: Maybe<Credit_Note_Fees_Bool_Exp>;
};


/** columns and relationships of "receipts" */
export type ReceiptsCredit_Note_Fees_AggregateArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Fees_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Fees_Order_By>>;
  where?: Maybe<Credit_Note_Fees_Bool_Exp>;
};


/** columns and relationships of "receipts" */
export type ReceiptsDepositsArgs = {
  distinct_on?: Maybe<Array<Deposits_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Deposits_Order_By>>;
  where?: Maybe<Deposits_Bool_Exp>;
};


/** columns and relationships of "receipts" */
export type ReceiptsDeposits_AggregateArgs = {
  distinct_on?: Maybe<Array<Deposits_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Deposits_Order_By>>;
  where?: Maybe<Deposits_Bool_Exp>;
};


/** columns and relationships of "receipts" */
export type ReceiptsRefund_ClassesArgs = {
  distinct_on?: Maybe<Array<Refund_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refund_Classes_Order_By>>;
  where?: Maybe<Refund_Classes_Bool_Exp>;
};


/** columns and relationships of "receipts" */
export type ReceiptsRefund_Classes_AggregateArgs = {
  distinct_on?: Maybe<Array<Refund_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refund_Classes_Order_By>>;
  where?: Maybe<Refund_Classes_Bool_Exp>;
};

/** aggregated selection of "receipts" */
export type Receipts_Aggregate = {
  __typename?: 'receipts_aggregate';
  aggregate?: Maybe<Receipts_Aggregate_Fields>;
  nodes: Array<Receipts>;
};

/** aggregate fields of "receipts" */
export type Receipts_Aggregate_Fields = {
  __typename?: 'receipts_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Receipts_Max_Fields>;
  min?: Maybe<Receipts_Min_Fields>;
};


/** aggregate fields of "receipts" */
export type Receipts_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Receipts_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "receipts" */
export type Receipts_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Receipts_Max_Order_By>;
  min?: Maybe<Receipts_Min_Order_By>;
};

/** input type for inserting array relation for remote table "receipts" */
export type Receipts_Arr_Rel_Insert_Input = {
  data: Array<Receipts_Insert_Input>;
  on_conflict?: Maybe<Receipts_On_Conflict>;
};

/** Boolean expression to filter rows from the table "receipts". All fields are combined with a logical 'AND'. */
export type Receipts_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Receipts_Bool_Exp>>>;
  _not?: Maybe<Receipts_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Receipts_Bool_Exp>>>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  credit_note_fees?: Maybe<Credit_Note_Fees_Bool_Exp>;
  deposits?: Maybe<Deposits_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  invoice?: Maybe<Invoices_Bool_Exp>;
  invoiceId?: Maybe<Uuid_Comparison_Exp>;
  link?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  receiptDate?: Maybe<Timestamptz_Comparison_Exp>;
  refund_classes?: Maybe<Refund_Classes_Bool_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  userByCreatedby?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "receipts" */
export enum Receipts_Constraint {
  /** unique or primary key constraint */
  ReceiptsInvoiceIdKey = 'receipts_invoiceId_key',
  /** unique or primary key constraint */
  ReceiptsNameKey = 'receipts_name_key',
  /** unique or primary key constraint */
  ReceiptsPkey = 'receipts_pkey'
}

/** input type for inserting data into table "receipts" */
export type Receipts_Insert_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  credit_note_fees?: Maybe<Credit_Note_Fees_Arr_Rel_Insert_Input>;
  deposits?: Maybe<Deposits_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  invoice?: Maybe<Invoices_Obj_Rel_Insert_Input>;
  invoiceId?: Maybe<Scalars['uuid']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  receiptDate?: Maybe<Scalars['timestamptz']>;
  refund_classes?: Maybe<Refund_Classes_Arr_Rel_Insert_Input>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  userByCreatedby?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Receipts_Max_Fields = {
  __typename?: 'receipts_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invoiceId?: Maybe<Scalars['uuid']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  receiptDate?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "receipts" */
export type Receipts_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invoiceId?: Maybe<Order_By>;
  link?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  receiptDate?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Receipts_Min_Fields = {
  __typename?: 'receipts_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invoiceId?: Maybe<Scalars['uuid']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  receiptDate?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "receipts" */
export type Receipts_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invoiceId?: Maybe<Order_By>;
  link?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  receiptDate?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "receipts" */
export type Receipts_Mutation_Response = {
  __typename?: 'receipts_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Receipts>;
};

/** input type for inserting object relation for remote table "receipts" */
export type Receipts_Obj_Rel_Insert_Input = {
  data: Receipts_Insert_Input;
  on_conflict?: Maybe<Receipts_On_Conflict>;
};

/** on conflict condition type for table "receipts" */
export type Receipts_On_Conflict = {
  constraint: Receipts_Constraint;
  update_columns: Array<Receipts_Update_Column>;
  where?: Maybe<Receipts_Bool_Exp>;
};

/** ordering options when selecting data from "receipts" */
export type Receipts_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  credit_note_fees_aggregate?: Maybe<Credit_Note_Fees_Aggregate_Order_By>;
  deposits_aggregate?: Maybe<Deposits_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  invoice?: Maybe<Invoices_Order_By>;
  invoiceId?: Maybe<Order_By>;
  link?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  receiptDate?: Maybe<Order_By>;
  refund_classes_aggregate?: Maybe<Refund_Classes_Aggregate_Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  userByCreatedby?: Maybe<Users_Order_By>;
};

/** primary key columns input for table: "receipts" */
export type Receipts_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "receipts" */
export enum Receipts_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceId = 'invoiceId',
  /** column name */
  Link = 'link',
  /** column name */
  Name = 'name',
  /** column name */
  ReceiptDate = 'receiptDate',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "receipts" */
export type Receipts_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invoiceId?: Maybe<Scalars['uuid']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  receiptDate?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "receipts" */
export enum Receipts_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceId = 'invoiceId',
  /** column name */
  Link = 'link',
  /** column name */
  Name = 'name',
  /** column name */
  ReceiptDate = 'receiptDate',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** columns and relationships of "refund_classes" */
export type Refund_Classes = {
  __typename?: 'refund_classes';
  /** An object relationship */
  class: Classes;
  classId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  deduction: Scalars['jsonb'];
  id: Scalars['uuid'];
  lastLessonDate: Scalars['timestamptz'];
  leftLessonAmount?: Maybe<Scalars['Int']>;
  leftLessonNo: Scalars['Int'];
  lessonIds?: Maybe<Scalars['jsonb']>;
  otherPayments: Scalars['jsonb'];
  oweLessonNo: Scalars['Int'];
  /** An object relationship */
  receipt?: Maybe<Receipts>;
  receiptId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  refund: Refunds;
  refundId: Scalars['uuid'];
  status: Scalars['String'];
  summary: Scalars['jsonb'];
  unitPrice?: Maybe<Scalars['numeric']>;
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "refund_classes" */
export type Refund_ClassesDeductionArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "refund_classes" */
export type Refund_ClassesLessonIdsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "refund_classes" */
export type Refund_ClassesOtherPaymentsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "refund_classes" */
export type Refund_ClassesSummaryArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "refund_classes" */
export type Refund_Classes_Aggregate = {
  __typename?: 'refund_classes_aggregate';
  aggregate?: Maybe<Refund_Classes_Aggregate_Fields>;
  nodes: Array<Refund_Classes>;
};

/** aggregate fields of "refund_classes" */
export type Refund_Classes_Aggregate_Fields = {
  __typename?: 'refund_classes_aggregate_fields';
  avg?: Maybe<Refund_Classes_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Refund_Classes_Max_Fields>;
  min?: Maybe<Refund_Classes_Min_Fields>;
  stddev?: Maybe<Refund_Classes_Stddev_Fields>;
  stddev_pop?: Maybe<Refund_Classes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Refund_Classes_Stddev_Samp_Fields>;
  sum?: Maybe<Refund_Classes_Sum_Fields>;
  var_pop?: Maybe<Refund_Classes_Var_Pop_Fields>;
  var_samp?: Maybe<Refund_Classes_Var_Samp_Fields>;
  variance?: Maybe<Refund_Classes_Variance_Fields>;
};


/** aggregate fields of "refund_classes" */
export type Refund_Classes_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Refund_Classes_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "refund_classes" */
export type Refund_Classes_Aggregate_Order_By = {
  avg?: Maybe<Refund_Classes_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Refund_Classes_Max_Order_By>;
  min?: Maybe<Refund_Classes_Min_Order_By>;
  stddev?: Maybe<Refund_Classes_Stddev_Order_By>;
  stddev_pop?: Maybe<Refund_Classes_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Refund_Classes_Stddev_Samp_Order_By>;
  sum?: Maybe<Refund_Classes_Sum_Order_By>;
  var_pop?: Maybe<Refund_Classes_Var_Pop_Order_By>;
  var_samp?: Maybe<Refund_Classes_Var_Samp_Order_By>;
  variance?: Maybe<Refund_Classes_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Refund_Classes_Append_Input = {
  deduction?: Maybe<Scalars['jsonb']>;
  lessonIds?: Maybe<Scalars['jsonb']>;
  otherPayments?: Maybe<Scalars['jsonb']>;
  summary?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "refund_classes" */
export type Refund_Classes_Arr_Rel_Insert_Input = {
  data: Array<Refund_Classes_Insert_Input>;
  on_conflict?: Maybe<Refund_Classes_On_Conflict>;
};

/** aggregate avg on columns */
export type Refund_Classes_Avg_Fields = {
  __typename?: 'refund_classes_avg_fields';
  leftLessonAmount?: Maybe<Scalars['Float']>;
  leftLessonNo?: Maybe<Scalars['Float']>;
  oweLessonNo?: Maybe<Scalars['Float']>;
  unitPrice?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "refund_classes" */
export type Refund_Classes_Avg_Order_By = {
  leftLessonAmount?: Maybe<Order_By>;
  leftLessonNo?: Maybe<Order_By>;
  oweLessonNo?: Maybe<Order_By>;
  unitPrice?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "refund_classes". All fields are combined with a logical 'AND'. */
export type Refund_Classes_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Refund_Classes_Bool_Exp>>>;
  _not?: Maybe<Refund_Classes_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Refund_Classes_Bool_Exp>>>;
  class?: Maybe<Classes_Bool_Exp>;
  classId?: Maybe<Uuid_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  deduction?: Maybe<Jsonb_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  lastLessonDate?: Maybe<Timestamptz_Comparison_Exp>;
  leftLessonAmount?: Maybe<Int_Comparison_Exp>;
  leftLessonNo?: Maybe<Int_Comparison_Exp>;
  lessonIds?: Maybe<Jsonb_Comparison_Exp>;
  otherPayments?: Maybe<Jsonb_Comparison_Exp>;
  oweLessonNo?: Maybe<Int_Comparison_Exp>;
  receipt?: Maybe<Receipts_Bool_Exp>;
  receiptId?: Maybe<Uuid_Comparison_Exp>;
  refund?: Maybe<Refunds_Bool_Exp>;
  refundId?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  summary?: Maybe<Jsonb_Comparison_Exp>;
  unitPrice?: Maybe<Numeric_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "refund_classes" */
export enum Refund_Classes_Constraint {
  /** unique or primary key constraint */
  RefundClassesPkey = 'refund_classes_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Refund_Classes_Delete_At_Path_Input = {
  deduction?: Maybe<Array<Maybe<Scalars['String']>>>;
  lessonIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  otherPayments?: Maybe<Array<Maybe<Scalars['String']>>>;
  summary?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Refund_Classes_Delete_Elem_Input = {
  deduction?: Maybe<Scalars['Int']>;
  lessonIds?: Maybe<Scalars['Int']>;
  otherPayments?: Maybe<Scalars['Int']>;
  summary?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Refund_Classes_Delete_Key_Input = {
  deduction?: Maybe<Scalars['String']>;
  lessonIds?: Maybe<Scalars['String']>;
  otherPayments?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "refund_classes" */
export type Refund_Classes_Inc_Input = {
  leftLessonAmount?: Maybe<Scalars['Int']>;
  leftLessonNo?: Maybe<Scalars['Int']>;
  oweLessonNo?: Maybe<Scalars['Int']>;
  unitPrice?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "refund_classes" */
export type Refund_Classes_Insert_Input = {
  class?: Maybe<Classes_Obj_Rel_Insert_Input>;
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  deduction?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  lastLessonDate?: Maybe<Scalars['timestamptz']>;
  leftLessonAmount?: Maybe<Scalars['Int']>;
  leftLessonNo?: Maybe<Scalars['Int']>;
  lessonIds?: Maybe<Scalars['jsonb']>;
  otherPayments?: Maybe<Scalars['jsonb']>;
  oweLessonNo?: Maybe<Scalars['Int']>;
  receipt?: Maybe<Receipts_Obj_Rel_Insert_Input>;
  receiptId?: Maybe<Scalars['uuid']>;
  refund?: Maybe<Refunds_Obj_Rel_Insert_Input>;
  refundId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['jsonb']>;
  unitPrice?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Refund_Classes_Max_Fields = {
  __typename?: 'refund_classes_max_fields';
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  lastLessonDate?: Maybe<Scalars['timestamptz']>;
  leftLessonAmount?: Maybe<Scalars['Int']>;
  leftLessonNo?: Maybe<Scalars['Int']>;
  oweLessonNo?: Maybe<Scalars['Int']>;
  receiptId?: Maybe<Scalars['uuid']>;
  refundId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "refund_classes" */
export type Refund_Classes_Max_Order_By = {
  classId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lastLessonDate?: Maybe<Order_By>;
  leftLessonAmount?: Maybe<Order_By>;
  leftLessonNo?: Maybe<Order_By>;
  oweLessonNo?: Maybe<Order_By>;
  receiptId?: Maybe<Order_By>;
  refundId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  unitPrice?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Refund_Classes_Min_Fields = {
  __typename?: 'refund_classes_min_fields';
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  lastLessonDate?: Maybe<Scalars['timestamptz']>;
  leftLessonAmount?: Maybe<Scalars['Int']>;
  leftLessonNo?: Maybe<Scalars['Int']>;
  oweLessonNo?: Maybe<Scalars['Int']>;
  receiptId?: Maybe<Scalars['uuid']>;
  refundId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "refund_classes" */
export type Refund_Classes_Min_Order_By = {
  classId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lastLessonDate?: Maybe<Order_By>;
  leftLessonAmount?: Maybe<Order_By>;
  leftLessonNo?: Maybe<Order_By>;
  oweLessonNo?: Maybe<Order_By>;
  receiptId?: Maybe<Order_By>;
  refundId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  unitPrice?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "refund_classes" */
export type Refund_Classes_Mutation_Response = {
  __typename?: 'refund_classes_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Refund_Classes>;
};

/** input type for inserting object relation for remote table "refund_classes" */
export type Refund_Classes_Obj_Rel_Insert_Input = {
  data: Refund_Classes_Insert_Input;
  on_conflict?: Maybe<Refund_Classes_On_Conflict>;
};

/** on conflict condition type for table "refund_classes" */
export type Refund_Classes_On_Conflict = {
  constraint: Refund_Classes_Constraint;
  update_columns: Array<Refund_Classes_Update_Column>;
  where?: Maybe<Refund_Classes_Bool_Exp>;
};

/** ordering options when selecting data from "refund_classes" */
export type Refund_Classes_Order_By = {
  class?: Maybe<Classes_Order_By>;
  classId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  deduction?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lastLessonDate?: Maybe<Order_By>;
  leftLessonAmount?: Maybe<Order_By>;
  leftLessonNo?: Maybe<Order_By>;
  lessonIds?: Maybe<Order_By>;
  otherPayments?: Maybe<Order_By>;
  oweLessonNo?: Maybe<Order_By>;
  receipt?: Maybe<Receipts_Order_By>;
  receiptId?: Maybe<Order_By>;
  refund?: Maybe<Refunds_Order_By>;
  refundId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  summary?: Maybe<Order_By>;
  unitPrice?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "refund_classes" */
export type Refund_Classes_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Refund_Classes_Prepend_Input = {
  deduction?: Maybe<Scalars['jsonb']>;
  lessonIds?: Maybe<Scalars['jsonb']>;
  otherPayments?: Maybe<Scalars['jsonb']>;
  summary?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "refund_classes" */
export enum Refund_Classes_Select_Column {
  /** column name */
  ClassId = 'classId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Deduction = 'deduction',
  /** column name */
  Id = 'id',
  /** column name */
  LastLessonDate = 'lastLessonDate',
  /** column name */
  LeftLessonAmount = 'leftLessonAmount',
  /** column name */
  LeftLessonNo = 'leftLessonNo',
  /** column name */
  LessonIds = 'lessonIds',
  /** column name */
  OtherPayments = 'otherPayments',
  /** column name */
  OweLessonNo = 'oweLessonNo',
  /** column name */
  ReceiptId = 'receiptId',
  /** column name */
  RefundId = 'refundId',
  /** column name */
  Status = 'status',
  /** column name */
  Summary = 'summary',
  /** column name */
  UnitPrice = 'unitPrice',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "refund_classes" */
export type Refund_Classes_Set_Input = {
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  deduction?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  lastLessonDate?: Maybe<Scalars['timestamptz']>;
  leftLessonAmount?: Maybe<Scalars['Int']>;
  leftLessonNo?: Maybe<Scalars['Int']>;
  lessonIds?: Maybe<Scalars['jsonb']>;
  otherPayments?: Maybe<Scalars['jsonb']>;
  oweLessonNo?: Maybe<Scalars['Int']>;
  receiptId?: Maybe<Scalars['uuid']>;
  refundId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['jsonb']>;
  unitPrice?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Refund_Classes_Stddev_Fields = {
  __typename?: 'refund_classes_stddev_fields';
  leftLessonAmount?: Maybe<Scalars['Float']>;
  leftLessonNo?: Maybe<Scalars['Float']>;
  oweLessonNo?: Maybe<Scalars['Float']>;
  unitPrice?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "refund_classes" */
export type Refund_Classes_Stddev_Order_By = {
  leftLessonAmount?: Maybe<Order_By>;
  leftLessonNo?: Maybe<Order_By>;
  oweLessonNo?: Maybe<Order_By>;
  unitPrice?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Refund_Classes_Stddev_Pop_Fields = {
  __typename?: 'refund_classes_stddev_pop_fields';
  leftLessonAmount?: Maybe<Scalars['Float']>;
  leftLessonNo?: Maybe<Scalars['Float']>;
  oweLessonNo?: Maybe<Scalars['Float']>;
  unitPrice?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "refund_classes" */
export type Refund_Classes_Stddev_Pop_Order_By = {
  leftLessonAmount?: Maybe<Order_By>;
  leftLessonNo?: Maybe<Order_By>;
  oweLessonNo?: Maybe<Order_By>;
  unitPrice?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Refund_Classes_Stddev_Samp_Fields = {
  __typename?: 'refund_classes_stddev_samp_fields';
  leftLessonAmount?: Maybe<Scalars['Float']>;
  leftLessonNo?: Maybe<Scalars['Float']>;
  oweLessonNo?: Maybe<Scalars['Float']>;
  unitPrice?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "refund_classes" */
export type Refund_Classes_Stddev_Samp_Order_By = {
  leftLessonAmount?: Maybe<Order_By>;
  leftLessonNo?: Maybe<Order_By>;
  oweLessonNo?: Maybe<Order_By>;
  unitPrice?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Refund_Classes_Sum_Fields = {
  __typename?: 'refund_classes_sum_fields';
  leftLessonAmount?: Maybe<Scalars['Int']>;
  leftLessonNo?: Maybe<Scalars['Int']>;
  oweLessonNo?: Maybe<Scalars['Int']>;
  unitPrice?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "refund_classes" */
export type Refund_Classes_Sum_Order_By = {
  leftLessonAmount?: Maybe<Order_By>;
  leftLessonNo?: Maybe<Order_By>;
  oweLessonNo?: Maybe<Order_By>;
  unitPrice?: Maybe<Order_By>;
};

/** update columns of table "refund_classes" */
export enum Refund_Classes_Update_Column {
  /** column name */
  ClassId = 'classId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Deduction = 'deduction',
  /** column name */
  Id = 'id',
  /** column name */
  LastLessonDate = 'lastLessonDate',
  /** column name */
  LeftLessonAmount = 'leftLessonAmount',
  /** column name */
  LeftLessonNo = 'leftLessonNo',
  /** column name */
  LessonIds = 'lessonIds',
  /** column name */
  OtherPayments = 'otherPayments',
  /** column name */
  OweLessonNo = 'oweLessonNo',
  /** column name */
  ReceiptId = 'receiptId',
  /** column name */
  RefundId = 'refundId',
  /** column name */
  Status = 'status',
  /** column name */
  Summary = 'summary',
  /** column name */
  UnitPrice = 'unitPrice',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** aggregate var_pop on columns */
export type Refund_Classes_Var_Pop_Fields = {
  __typename?: 'refund_classes_var_pop_fields';
  leftLessonAmount?: Maybe<Scalars['Float']>;
  leftLessonNo?: Maybe<Scalars['Float']>;
  oweLessonNo?: Maybe<Scalars['Float']>;
  unitPrice?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "refund_classes" */
export type Refund_Classes_Var_Pop_Order_By = {
  leftLessonAmount?: Maybe<Order_By>;
  leftLessonNo?: Maybe<Order_By>;
  oweLessonNo?: Maybe<Order_By>;
  unitPrice?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Refund_Classes_Var_Samp_Fields = {
  __typename?: 'refund_classes_var_samp_fields';
  leftLessonAmount?: Maybe<Scalars['Float']>;
  leftLessonNo?: Maybe<Scalars['Float']>;
  oweLessonNo?: Maybe<Scalars['Float']>;
  unitPrice?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "refund_classes" */
export type Refund_Classes_Var_Samp_Order_By = {
  leftLessonAmount?: Maybe<Order_By>;
  leftLessonNo?: Maybe<Order_By>;
  oweLessonNo?: Maybe<Order_By>;
  unitPrice?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Refund_Classes_Variance_Fields = {
  __typename?: 'refund_classes_variance_fields';
  leftLessonAmount?: Maybe<Scalars['Float']>;
  leftLessonNo?: Maybe<Scalars['Float']>;
  oweLessonNo?: Maybe<Scalars['Float']>;
  unitPrice?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "refund_classes" */
export type Refund_Classes_Variance_Order_By = {
  leftLessonAmount?: Maybe<Order_By>;
  leftLessonNo?: Maybe<Order_By>;
  oweLessonNo?: Maybe<Order_By>;
  unitPrice?: Maybe<Order_By>;
};

export type Refund_Filter_Args = {
  month?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "refund_logs" */
export type Refund_Logs = {
  __typename?: 'refund_logs';
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  key?: Maybe<Scalars['String']>;
  /** An object relationship */
  refund: Refunds;
  refundId: Scalars['uuid'];
  status: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
  valueAfter?: Maybe<Scalars['jsonb']>;
  valueBefore?: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "refund_logs" */
export type Refund_LogsValueAfterArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "refund_logs" */
export type Refund_LogsValueBeforeArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "refund_logs" */
export type Refund_Logs_Aggregate = {
  __typename?: 'refund_logs_aggregate';
  aggregate?: Maybe<Refund_Logs_Aggregate_Fields>;
  nodes: Array<Refund_Logs>;
};

/** aggregate fields of "refund_logs" */
export type Refund_Logs_Aggregate_Fields = {
  __typename?: 'refund_logs_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Refund_Logs_Max_Fields>;
  min?: Maybe<Refund_Logs_Min_Fields>;
};


/** aggregate fields of "refund_logs" */
export type Refund_Logs_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Refund_Logs_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "refund_logs" */
export type Refund_Logs_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Refund_Logs_Max_Order_By>;
  min?: Maybe<Refund_Logs_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Refund_Logs_Append_Input = {
  valueAfter?: Maybe<Scalars['jsonb']>;
  valueBefore?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "refund_logs" */
export type Refund_Logs_Arr_Rel_Insert_Input = {
  data: Array<Refund_Logs_Insert_Input>;
  on_conflict?: Maybe<Refund_Logs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "refund_logs". All fields are combined with a logical 'AND'. */
export type Refund_Logs_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Refund_Logs_Bool_Exp>>>;
  _not?: Maybe<Refund_Logs_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Refund_Logs_Bool_Exp>>>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  key?: Maybe<String_Comparison_Exp>;
  refund?: Maybe<Refunds_Bool_Exp>;
  refundId?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  type?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  valueAfter?: Maybe<Jsonb_Comparison_Exp>;
  valueBefore?: Maybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "refund_logs" */
export enum Refund_Logs_Constraint {
  /** unique or primary key constraint */
  RefundLogsPkey = 'refund_logs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Refund_Logs_Delete_At_Path_Input = {
  valueAfter?: Maybe<Array<Maybe<Scalars['String']>>>;
  valueBefore?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Refund_Logs_Delete_Elem_Input = {
  valueAfter?: Maybe<Scalars['Int']>;
  valueBefore?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Refund_Logs_Delete_Key_Input = {
  valueAfter?: Maybe<Scalars['String']>;
  valueBefore?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "refund_logs" */
export type Refund_Logs_Insert_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  refund?: Maybe<Refunds_Obj_Rel_Insert_Input>;
  refundId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  valueAfter?: Maybe<Scalars['jsonb']>;
  valueBefore?: Maybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type Refund_Logs_Max_Fields = {
  __typename?: 'refund_logs_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  refundId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "refund_logs" */
export type Refund_Logs_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  key?: Maybe<Order_By>;
  refundId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Refund_Logs_Min_Fields = {
  __typename?: 'refund_logs_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  refundId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "refund_logs" */
export type Refund_Logs_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  key?: Maybe<Order_By>;
  refundId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "refund_logs" */
export type Refund_Logs_Mutation_Response = {
  __typename?: 'refund_logs_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Refund_Logs>;
};

/** input type for inserting object relation for remote table "refund_logs" */
export type Refund_Logs_Obj_Rel_Insert_Input = {
  data: Refund_Logs_Insert_Input;
  on_conflict?: Maybe<Refund_Logs_On_Conflict>;
};

/** on conflict condition type for table "refund_logs" */
export type Refund_Logs_On_Conflict = {
  constraint: Refund_Logs_Constraint;
  update_columns: Array<Refund_Logs_Update_Column>;
  where?: Maybe<Refund_Logs_Bool_Exp>;
};

/** ordering options when selecting data from "refund_logs" */
export type Refund_Logs_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  key?: Maybe<Order_By>;
  refund?: Maybe<Refunds_Order_By>;
  refundId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  valueAfter?: Maybe<Order_By>;
  valueBefore?: Maybe<Order_By>;
};

/** primary key columns input for table: "refund_logs" */
export type Refund_Logs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Refund_Logs_Prepend_Input = {
  valueAfter?: Maybe<Scalars['jsonb']>;
  valueBefore?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "refund_logs" */
export enum Refund_Logs_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  RefundId = 'refundId',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  ValueAfter = 'valueAfter',
  /** column name */
  ValueBefore = 'valueBefore'
}

/** input type for updating data in table "refund_logs" */
export type Refund_Logs_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  refundId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  valueAfter?: Maybe<Scalars['jsonb']>;
  valueBefore?: Maybe<Scalars['jsonb']>;
};

/** update columns of table "refund_logs" */
export enum Refund_Logs_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  RefundId = 'refundId',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  ValueAfter = 'valueAfter',
  /** column name */
  ValueBefore = 'valueBefore'
}

/** columns and relationships of "refunds" */
export type Refunds = {
  __typename?: 'refunds';
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  creditNoteIds: Scalars['jsonb'];
  depositIds: Scalars['jsonb'];
  id: Scalars['uuid'];
  issuedBy: Scalars['jsonb'];
  name: Scalars['String'];
  noticeDate?: Maybe<Scalars['timestamptz']>;
  payeeDetails: Scalars['jsonb'];
  reason?: Maybe<Scalars['String']>;
  reasonReject?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  refundClass: Array<Refund_Classes>;
  /** An aggregated array relationship */
  refundClass_aggregate: Refund_Classes_Aggregate;
  refundStatus: Scalars['String'];
  /** An array relationship */
  refund_logs: Array<Refund_Logs>;
  /** An aggregated array relationship */
  refund_logs_aggregate: Refund_Logs_Aggregate;
  remarks?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  /** An object relationship */
  student?: Maybe<Users>;
  studentFeedback: Scalars['jsonb'];
  studentId?: Maybe<Scalars['uuid']>;
  summary: Scalars['jsonb'];
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "refunds" */
export type RefundsCreditNoteIdsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "refunds" */
export type RefundsDepositIdsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "refunds" */
export type RefundsIssuedByArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "refunds" */
export type RefundsPayeeDetailsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "refunds" */
export type RefundsReasonRejectArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "refunds" */
export type RefundsRefundClassArgs = {
  distinct_on?: Maybe<Array<Refund_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refund_Classes_Order_By>>;
  where?: Maybe<Refund_Classes_Bool_Exp>;
};


/** columns and relationships of "refunds" */
export type RefundsRefundClass_AggregateArgs = {
  distinct_on?: Maybe<Array<Refund_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refund_Classes_Order_By>>;
  where?: Maybe<Refund_Classes_Bool_Exp>;
};


/** columns and relationships of "refunds" */
export type RefundsRefund_LogsArgs = {
  distinct_on?: Maybe<Array<Refund_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refund_Logs_Order_By>>;
  where?: Maybe<Refund_Logs_Bool_Exp>;
};


/** columns and relationships of "refunds" */
export type RefundsRefund_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Refund_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refund_Logs_Order_By>>;
  where?: Maybe<Refund_Logs_Bool_Exp>;
};


/** columns and relationships of "refunds" */
export type RefundsStudentFeedbackArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "refunds" */
export type RefundsSummaryArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "refunds" */
export type Refunds_Aggregate = {
  __typename?: 'refunds_aggregate';
  aggregate?: Maybe<Refunds_Aggregate_Fields>;
  nodes: Array<Refunds>;
};

/** aggregate fields of "refunds" */
export type Refunds_Aggregate_Fields = {
  __typename?: 'refunds_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Refunds_Max_Fields>;
  min?: Maybe<Refunds_Min_Fields>;
};


/** aggregate fields of "refunds" */
export type Refunds_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Refunds_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "refunds" */
export type Refunds_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Refunds_Max_Order_By>;
  min?: Maybe<Refunds_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Refunds_Append_Input = {
  creditNoteIds?: Maybe<Scalars['jsonb']>;
  depositIds?: Maybe<Scalars['jsonb']>;
  issuedBy?: Maybe<Scalars['jsonb']>;
  payeeDetails?: Maybe<Scalars['jsonb']>;
  reasonReject?: Maybe<Scalars['jsonb']>;
  studentFeedback?: Maybe<Scalars['jsonb']>;
  summary?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "refunds" */
export type Refunds_Arr_Rel_Insert_Input = {
  data: Array<Refunds_Insert_Input>;
  on_conflict?: Maybe<Refunds_On_Conflict>;
};

/** Boolean expression to filter rows from the table "refunds". All fields are combined with a logical 'AND'. */
export type Refunds_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Refunds_Bool_Exp>>>;
  _not?: Maybe<Refunds_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Refunds_Bool_Exp>>>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  creditNoteIds?: Maybe<Jsonb_Comparison_Exp>;
  depositIds?: Maybe<Jsonb_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  issuedBy?: Maybe<Jsonb_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  noticeDate?: Maybe<Timestamptz_Comparison_Exp>;
  payeeDetails?: Maybe<Jsonb_Comparison_Exp>;
  reason?: Maybe<String_Comparison_Exp>;
  reasonReject?: Maybe<Jsonb_Comparison_Exp>;
  refundClass?: Maybe<Refund_Classes_Bool_Exp>;
  refundStatus?: Maybe<String_Comparison_Exp>;
  refund_logs?: Maybe<Refund_Logs_Bool_Exp>;
  remarks?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  student?: Maybe<Users_Bool_Exp>;
  studentFeedback?: Maybe<Jsonb_Comparison_Exp>;
  studentId?: Maybe<Uuid_Comparison_Exp>;
  summary?: Maybe<Jsonb_Comparison_Exp>;
  type?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "refunds" */
export enum Refunds_Constraint {
  /** unique or primary key constraint */
  RefundsPkey = 'refunds_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Refunds_Delete_At_Path_Input = {
  creditNoteIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  depositIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  issuedBy?: Maybe<Array<Maybe<Scalars['String']>>>;
  payeeDetails?: Maybe<Array<Maybe<Scalars['String']>>>;
  reasonReject?: Maybe<Array<Maybe<Scalars['String']>>>;
  studentFeedback?: Maybe<Array<Maybe<Scalars['String']>>>;
  summary?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Refunds_Delete_Elem_Input = {
  creditNoteIds?: Maybe<Scalars['Int']>;
  depositIds?: Maybe<Scalars['Int']>;
  issuedBy?: Maybe<Scalars['Int']>;
  payeeDetails?: Maybe<Scalars['Int']>;
  reasonReject?: Maybe<Scalars['Int']>;
  studentFeedback?: Maybe<Scalars['Int']>;
  summary?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Refunds_Delete_Key_Input = {
  creditNoteIds?: Maybe<Scalars['String']>;
  depositIds?: Maybe<Scalars['String']>;
  issuedBy?: Maybe<Scalars['String']>;
  payeeDetails?: Maybe<Scalars['String']>;
  reasonReject?: Maybe<Scalars['String']>;
  studentFeedback?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "refunds" */
export type Refunds_Insert_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  creditNoteIds?: Maybe<Scalars['jsonb']>;
  depositIds?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  issuedBy?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  noticeDate?: Maybe<Scalars['timestamptz']>;
  payeeDetails?: Maybe<Scalars['jsonb']>;
  reason?: Maybe<Scalars['String']>;
  reasonReject?: Maybe<Scalars['jsonb']>;
  refundClass?: Maybe<Refund_Classes_Arr_Rel_Insert_Input>;
  refundStatus?: Maybe<Scalars['String']>;
  refund_logs?: Maybe<Refund_Logs_Arr_Rel_Insert_Input>;
  remarks?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  student?: Maybe<Users_Obj_Rel_Insert_Input>;
  studentFeedback?: Maybe<Scalars['jsonb']>;
  studentId?: Maybe<Scalars['uuid']>;
  summary?: Maybe<Scalars['jsonb']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Refunds_Max_Fields = {
  __typename?: 'refunds_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  noticeDate?: Maybe<Scalars['timestamptz']>;
  reason?: Maybe<Scalars['String']>;
  refundStatus?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "refunds" */
export type Refunds_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  noticeDate?: Maybe<Order_By>;
  reason?: Maybe<Order_By>;
  refundStatus?: Maybe<Order_By>;
  remarks?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Refunds_Min_Fields = {
  __typename?: 'refunds_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  noticeDate?: Maybe<Scalars['timestamptz']>;
  reason?: Maybe<Scalars['String']>;
  refundStatus?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "refunds" */
export type Refunds_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  noticeDate?: Maybe<Order_By>;
  reason?: Maybe<Order_By>;
  refundStatus?: Maybe<Order_By>;
  remarks?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "refunds" */
export type Refunds_Mutation_Response = {
  __typename?: 'refunds_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Refunds>;
};

/** input type for inserting object relation for remote table "refunds" */
export type Refunds_Obj_Rel_Insert_Input = {
  data: Refunds_Insert_Input;
  on_conflict?: Maybe<Refunds_On_Conflict>;
};

/** on conflict condition type for table "refunds" */
export type Refunds_On_Conflict = {
  constraint: Refunds_Constraint;
  update_columns: Array<Refunds_Update_Column>;
  where?: Maybe<Refunds_Bool_Exp>;
};

/** ordering options when selecting data from "refunds" */
export type Refunds_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  creditNoteIds?: Maybe<Order_By>;
  depositIds?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  issuedBy?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  noticeDate?: Maybe<Order_By>;
  payeeDetails?: Maybe<Order_By>;
  reason?: Maybe<Order_By>;
  reasonReject?: Maybe<Order_By>;
  refundClass_aggregate?: Maybe<Refund_Classes_Aggregate_Order_By>;
  refundStatus?: Maybe<Order_By>;
  refund_logs_aggregate?: Maybe<Refund_Logs_Aggregate_Order_By>;
  remarks?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  student?: Maybe<Users_Order_By>;
  studentFeedback?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  summary?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "refunds" */
export type Refunds_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Refunds_Prepend_Input = {
  creditNoteIds?: Maybe<Scalars['jsonb']>;
  depositIds?: Maybe<Scalars['jsonb']>;
  issuedBy?: Maybe<Scalars['jsonb']>;
  payeeDetails?: Maybe<Scalars['jsonb']>;
  reasonReject?: Maybe<Scalars['jsonb']>;
  studentFeedback?: Maybe<Scalars['jsonb']>;
  summary?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "refunds" */
export enum Refunds_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CreditNoteIds = 'creditNoteIds',
  /** column name */
  DepositIds = 'depositIds',
  /** column name */
  Id = 'id',
  /** column name */
  IssuedBy = 'issuedBy',
  /** column name */
  Name = 'name',
  /** column name */
  NoticeDate = 'noticeDate',
  /** column name */
  PayeeDetails = 'payeeDetails',
  /** column name */
  Reason = 'reason',
  /** column name */
  ReasonReject = 'reasonReject',
  /** column name */
  RefundStatus = 'refundStatus',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  Status = 'status',
  /** column name */
  StudentFeedback = 'studentFeedback',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  Summary = 'summary',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "refunds" */
export type Refunds_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  creditNoteIds?: Maybe<Scalars['jsonb']>;
  depositIds?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  issuedBy?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  noticeDate?: Maybe<Scalars['timestamptz']>;
  payeeDetails?: Maybe<Scalars['jsonb']>;
  reason?: Maybe<Scalars['String']>;
  reasonReject?: Maybe<Scalars['jsonb']>;
  refundStatus?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentFeedback?: Maybe<Scalars['jsonb']>;
  studentId?: Maybe<Scalars['uuid']>;
  summary?: Maybe<Scalars['jsonb']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "refunds" */
export enum Refunds_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CreditNoteIds = 'creditNoteIds',
  /** column name */
  DepositIds = 'depositIds',
  /** column name */
  Id = 'id',
  /** column name */
  IssuedBy = 'issuedBy',
  /** column name */
  Name = 'name',
  /** column name */
  NoticeDate = 'noticeDate',
  /** column name */
  PayeeDetails = 'payeeDetails',
  /** column name */
  Reason = 'reason',
  /** column name */
  ReasonReject = 'reasonReject',
  /** column name */
  RefundStatus = 'refundStatus',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  Status = 'status',
  /** column name */
  StudentFeedback = 'studentFeedback',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  Summary = 'summary',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** columns and relationships of "regular_academic_pricings" */
export type Regular_Academic_Pricings = {
  __typename?: 'regular_academic_pricings';
  /** An object relationship */
  academyCalendar?: Maybe<Academic_Calendars>;
  academyCalendarId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  pricePerLesson: Scalars['numeric'];
  /** An object relationship */
  regularProgramType?: Maybe<Regular_Program_Types>;
  regularProgramTypeId?: Maybe<Scalars['uuid']>;
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  updater?: Maybe<Users>;
};

/** aggregated selection of "regular_academic_pricings" */
export type Regular_Academic_Pricings_Aggregate = {
  __typename?: 'regular_academic_pricings_aggregate';
  aggregate?: Maybe<Regular_Academic_Pricings_Aggregate_Fields>;
  nodes: Array<Regular_Academic_Pricings>;
};

/** aggregate fields of "regular_academic_pricings" */
export type Regular_Academic_Pricings_Aggregate_Fields = {
  __typename?: 'regular_academic_pricings_aggregate_fields';
  avg?: Maybe<Regular_Academic_Pricings_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Regular_Academic_Pricings_Max_Fields>;
  min?: Maybe<Regular_Academic_Pricings_Min_Fields>;
  stddev?: Maybe<Regular_Academic_Pricings_Stddev_Fields>;
  stddev_pop?: Maybe<Regular_Academic_Pricings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Regular_Academic_Pricings_Stddev_Samp_Fields>;
  sum?: Maybe<Regular_Academic_Pricings_Sum_Fields>;
  var_pop?: Maybe<Regular_Academic_Pricings_Var_Pop_Fields>;
  var_samp?: Maybe<Regular_Academic_Pricings_Var_Samp_Fields>;
  variance?: Maybe<Regular_Academic_Pricings_Variance_Fields>;
};


/** aggregate fields of "regular_academic_pricings" */
export type Regular_Academic_Pricings_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Regular_Academic_Pricings_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "regular_academic_pricings" */
export type Regular_Academic_Pricings_Aggregate_Order_By = {
  avg?: Maybe<Regular_Academic_Pricings_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Regular_Academic_Pricings_Max_Order_By>;
  min?: Maybe<Regular_Academic_Pricings_Min_Order_By>;
  stddev?: Maybe<Regular_Academic_Pricings_Stddev_Order_By>;
  stddev_pop?: Maybe<Regular_Academic_Pricings_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Regular_Academic_Pricings_Stddev_Samp_Order_By>;
  sum?: Maybe<Regular_Academic_Pricings_Sum_Order_By>;
  var_pop?: Maybe<Regular_Academic_Pricings_Var_Pop_Order_By>;
  var_samp?: Maybe<Regular_Academic_Pricings_Var_Samp_Order_By>;
  variance?: Maybe<Regular_Academic_Pricings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "regular_academic_pricings" */
export type Regular_Academic_Pricings_Arr_Rel_Insert_Input = {
  data: Array<Regular_Academic_Pricings_Insert_Input>;
  on_conflict?: Maybe<Regular_Academic_Pricings_On_Conflict>;
};

/** aggregate avg on columns */
export type Regular_Academic_Pricings_Avg_Fields = {
  __typename?: 'regular_academic_pricings_avg_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "regular_academic_pricings" */
export type Regular_Academic_Pricings_Avg_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "regular_academic_pricings". All fields are combined with a logical 'AND'. */
export type Regular_Academic_Pricings_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Regular_Academic_Pricings_Bool_Exp>>>;
  _not?: Maybe<Regular_Academic_Pricings_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Regular_Academic_Pricings_Bool_Exp>>>;
  academyCalendar?: Maybe<Academic_Calendars_Bool_Exp>;
  academyCalendarId?: Maybe<Uuid_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  pricePerLesson?: Maybe<Numeric_Comparison_Exp>;
  regularProgramType?: Maybe<Regular_Program_Types_Bool_Exp>;
  regularProgramTypeId?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  updater?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "regular_academic_pricings" */
export enum Regular_Academic_Pricings_Constraint {
  /** unique or primary key constraint */
  RegularAcademicPricingsPkey = 'regular_academic_pricings_pkey'
}

/** input type for incrementing integer column in table "regular_academic_pricings" */
export type Regular_Academic_Pricings_Inc_Input = {
  pricePerLesson?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "regular_academic_pricings" */
export type Regular_Academic_Pricings_Insert_Input = {
  academyCalendar?: Maybe<Academic_Calendars_Obj_Rel_Insert_Input>;
  academyCalendarId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  pricePerLesson?: Maybe<Scalars['numeric']>;
  regularProgramType?: Maybe<Regular_Program_Types_Obj_Rel_Insert_Input>;
  regularProgramTypeId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  updater?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Regular_Academic_Pricings_Max_Fields = {
  __typename?: 'regular_academic_pricings_max_fields';
  academyCalendarId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  pricePerLesson?: Maybe<Scalars['numeric']>;
  regularProgramTypeId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "regular_academic_pricings" */
export type Regular_Academic_Pricings_Max_Order_By = {
  academyCalendarId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pricePerLesson?: Maybe<Order_By>;
  regularProgramTypeId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Regular_Academic_Pricings_Min_Fields = {
  __typename?: 'regular_academic_pricings_min_fields';
  academyCalendarId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  pricePerLesson?: Maybe<Scalars['numeric']>;
  regularProgramTypeId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "regular_academic_pricings" */
export type Regular_Academic_Pricings_Min_Order_By = {
  academyCalendarId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pricePerLesson?: Maybe<Order_By>;
  regularProgramTypeId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "regular_academic_pricings" */
export type Regular_Academic_Pricings_Mutation_Response = {
  __typename?: 'regular_academic_pricings_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Regular_Academic_Pricings>;
};

/** input type for inserting object relation for remote table "regular_academic_pricings" */
export type Regular_Academic_Pricings_Obj_Rel_Insert_Input = {
  data: Regular_Academic_Pricings_Insert_Input;
  on_conflict?: Maybe<Regular_Academic_Pricings_On_Conflict>;
};

/** on conflict condition type for table "regular_academic_pricings" */
export type Regular_Academic_Pricings_On_Conflict = {
  constraint: Regular_Academic_Pricings_Constraint;
  update_columns: Array<Regular_Academic_Pricings_Update_Column>;
  where?: Maybe<Regular_Academic_Pricings_Bool_Exp>;
};

/** ordering options when selecting data from "regular_academic_pricings" */
export type Regular_Academic_Pricings_Order_By = {
  academyCalendar?: Maybe<Academic_Calendars_Order_By>;
  academyCalendarId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pricePerLesson?: Maybe<Order_By>;
  regularProgramType?: Maybe<Regular_Program_Types_Order_By>;
  regularProgramTypeId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  updater?: Maybe<Users_Order_By>;
};

/** primary key columns input for table: "regular_academic_pricings" */
export type Regular_Academic_Pricings_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "regular_academic_pricings" */
export enum Regular_Academic_Pricings_Select_Column {
  /** column name */
  AcademyCalendarId = 'academyCalendarId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  PricePerLesson = 'pricePerLesson',
  /** column name */
  RegularProgramTypeId = 'regularProgramTypeId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "regular_academic_pricings" */
export type Regular_Academic_Pricings_Set_Input = {
  academyCalendarId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  pricePerLesson?: Maybe<Scalars['numeric']>;
  regularProgramTypeId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Regular_Academic_Pricings_Stddev_Fields = {
  __typename?: 'regular_academic_pricings_stddev_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "regular_academic_pricings" */
export type Regular_Academic_Pricings_Stddev_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Regular_Academic_Pricings_Stddev_Pop_Fields = {
  __typename?: 'regular_academic_pricings_stddev_pop_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "regular_academic_pricings" */
export type Regular_Academic_Pricings_Stddev_Pop_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Regular_Academic_Pricings_Stddev_Samp_Fields = {
  __typename?: 'regular_academic_pricings_stddev_samp_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "regular_academic_pricings" */
export type Regular_Academic_Pricings_Stddev_Samp_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Regular_Academic_Pricings_Sum_Fields = {
  __typename?: 'regular_academic_pricings_sum_fields';
  pricePerLesson?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "regular_academic_pricings" */
export type Regular_Academic_Pricings_Sum_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** update columns of table "regular_academic_pricings" */
export enum Regular_Academic_Pricings_Update_Column {
  /** column name */
  AcademyCalendarId = 'academyCalendarId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  PricePerLesson = 'pricePerLesson',
  /** column name */
  RegularProgramTypeId = 'regularProgramTypeId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** aggregate var_pop on columns */
export type Regular_Academic_Pricings_Var_Pop_Fields = {
  __typename?: 'regular_academic_pricings_var_pop_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "regular_academic_pricings" */
export type Regular_Academic_Pricings_Var_Pop_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Regular_Academic_Pricings_Var_Samp_Fields = {
  __typename?: 'regular_academic_pricings_var_samp_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "regular_academic_pricings" */
export type Regular_Academic_Pricings_Var_Samp_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Regular_Academic_Pricings_Variance_Fields = {
  __typename?: 'regular_academic_pricings_variance_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "regular_academic_pricings" */
export type Regular_Academic_Pricings_Variance_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** columns and relationships of "regular_program_types" */
export type Regular_Program_Types = {
  __typename?: 'regular_program_types';
  /** An array relationship */
  classes: Array<Classes>;
  /** An aggregated array relationship */
  classes_aggregate: Classes_Aggregate;
  code: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  fullName: Scalars['String'];
  id: Scalars['uuid'];
  /** An array relationship */
  regular_programme_pricings: Array<Regular_Programme_Pricings>;
  /** An aggregated array relationship */
  regular_programme_pricings_aggregate: Regular_Programme_Pricings_Aggregate;
  shortName: Scalars['String'];
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "regular_program_types" */
export type Regular_Program_TypesClassesArgs = {
  distinct_on?: Maybe<Array<Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classes_Order_By>>;
  where?: Maybe<Classes_Bool_Exp>;
};


/** columns and relationships of "regular_program_types" */
export type Regular_Program_TypesClasses_AggregateArgs = {
  distinct_on?: Maybe<Array<Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classes_Order_By>>;
  where?: Maybe<Classes_Bool_Exp>;
};


/** columns and relationships of "regular_program_types" */
export type Regular_Program_TypesRegular_Programme_PricingsArgs = {
  distinct_on?: Maybe<Array<Regular_Programme_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Regular_Programme_Pricings_Order_By>>;
  where?: Maybe<Regular_Programme_Pricings_Bool_Exp>;
};


/** columns and relationships of "regular_program_types" */
export type Regular_Program_TypesRegular_Programme_Pricings_AggregateArgs = {
  distinct_on?: Maybe<Array<Regular_Programme_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Regular_Programme_Pricings_Order_By>>;
  where?: Maybe<Regular_Programme_Pricings_Bool_Exp>;
};

/** aggregated selection of "regular_program_types" */
export type Regular_Program_Types_Aggregate = {
  __typename?: 'regular_program_types_aggregate';
  aggregate?: Maybe<Regular_Program_Types_Aggregate_Fields>;
  nodes: Array<Regular_Program_Types>;
};

/** aggregate fields of "regular_program_types" */
export type Regular_Program_Types_Aggregate_Fields = {
  __typename?: 'regular_program_types_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Regular_Program_Types_Max_Fields>;
  min?: Maybe<Regular_Program_Types_Min_Fields>;
};


/** aggregate fields of "regular_program_types" */
export type Regular_Program_Types_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Regular_Program_Types_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "regular_program_types" */
export type Regular_Program_Types_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Regular_Program_Types_Max_Order_By>;
  min?: Maybe<Regular_Program_Types_Min_Order_By>;
};

/** input type for inserting array relation for remote table "regular_program_types" */
export type Regular_Program_Types_Arr_Rel_Insert_Input = {
  data: Array<Regular_Program_Types_Insert_Input>;
  on_conflict?: Maybe<Regular_Program_Types_On_Conflict>;
};

/** Boolean expression to filter rows from the table "regular_program_types". All fields are combined with a logical 'AND'. */
export type Regular_Program_Types_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Regular_Program_Types_Bool_Exp>>>;
  _not?: Maybe<Regular_Program_Types_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Regular_Program_Types_Bool_Exp>>>;
  classes?: Maybe<Classes_Bool_Exp>;
  code?: Maybe<String_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  fullName?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  regular_programme_pricings?: Maybe<Regular_Programme_Pricings_Bool_Exp>;
  shortName?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "regular_program_types" */
export enum Regular_Program_Types_Constraint {
  /** unique or primary key constraint */
  RegularProgramTypesCodeKey = 'regular_program_types_code_key',
  /** unique or primary key constraint */
  RegularProgramTypesPkey = 'regular_program_types_pkey'
}

/** input type for inserting data into table "regular_program_types" */
export type Regular_Program_Types_Insert_Input = {
  classes?: Maybe<Classes_Arr_Rel_Insert_Input>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  regular_programme_pricings?: Maybe<Regular_Programme_Pricings_Arr_Rel_Insert_Input>;
  shortName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Regular_Program_Types_Max_Fields = {
  __typename?: 'regular_program_types_max_fields';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  shortName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "regular_program_types" */
export type Regular_Program_Types_Max_Order_By = {
  code?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  fullName?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  shortName?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Regular_Program_Types_Min_Fields = {
  __typename?: 'regular_program_types_min_fields';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  shortName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "regular_program_types" */
export type Regular_Program_Types_Min_Order_By = {
  code?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  fullName?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  shortName?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "regular_program_types" */
export type Regular_Program_Types_Mutation_Response = {
  __typename?: 'regular_program_types_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Regular_Program_Types>;
};

/** input type for inserting object relation for remote table "regular_program_types" */
export type Regular_Program_Types_Obj_Rel_Insert_Input = {
  data: Regular_Program_Types_Insert_Input;
  on_conflict?: Maybe<Regular_Program_Types_On_Conflict>;
};

/** on conflict condition type for table "regular_program_types" */
export type Regular_Program_Types_On_Conflict = {
  constraint: Regular_Program_Types_Constraint;
  update_columns: Array<Regular_Program_Types_Update_Column>;
  where?: Maybe<Regular_Program_Types_Bool_Exp>;
};

/** ordering options when selecting data from "regular_program_types" */
export type Regular_Program_Types_Order_By = {
  classes_aggregate?: Maybe<Classes_Aggregate_Order_By>;
  code?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  fullName?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  regular_programme_pricings_aggregate?: Maybe<Regular_Programme_Pricings_Aggregate_Order_By>;
  shortName?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "regular_program_types" */
export type Regular_Program_Types_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "regular_program_types" */
export enum Regular_Program_Types_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  FullName = 'fullName',
  /** column name */
  Id = 'id',
  /** column name */
  ShortName = 'shortName',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "regular_program_types" */
export type Regular_Program_Types_Set_Input = {
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  shortName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "regular_program_types" */
export enum Regular_Program_Types_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  FullName = 'fullName',
  /** column name */
  Id = 'id',
  /** column name */
  ShortName = 'shortName',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** columns and relationships of "regular_programme_pricings" */
export type Regular_Programme_Pricings = {
  __typename?: 'regular_programme_pricings';
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  curriculum: Curriculums;
  curriculumId: Scalars['uuid'];
  id: Scalars['uuid'];
  pricePerLesson: Scalars['numeric'];
  regularProgramTypeId: Scalars['uuid'];
  /** An object relationship */
  regular_program_type: Regular_Program_Types;
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  updater?: Maybe<Users>;
};

/** aggregated selection of "regular_programme_pricings" */
export type Regular_Programme_Pricings_Aggregate = {
  __typename?: 'regular_programme_pricings_aggregate';
  aggregate?: Maybe<Regular_Programme_Pricings_Aggregate_Fields>;
  nodes: Array<Regular_Programme_Pricings>;
};

/** aggregate fields of "regular_programme_pricings" */
export type Regular_Programme_Pricings_Aggregate_Fields = {
  __typename?: 'regular_programme_pricings_aggregate_fields';
  avg?: Maybe<Regular_Programme_Pricings_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Regular_Programme_Pricings_Max_Fields>;
  min?: Maybe<Regular_Programme_Pricings_Min_Fields>;
  stddev?: Maybe<Regular_Programme_Pricings_Stddev_Fields>;
  stddev_pop?: Maybe<Regular_Programme_Pricings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Regular_Programme_Pricings_Stddev_Samp_Fields>;
  sum?: Maybe<Regular_Programme_Pricings_Sum_Fields>;
  var_pop?: Maybe<Regular_Programme_Pricings_Var_Pop_Fields>;
  var_samp?: Maybe<Regular_Programme_Pricings_Var_Samp_Fields>;
  variance?: Maybe<Regular_Programme_Pricings_Variance_Fields>;
};


/** aggregate fields of "regular_programme_pricings" */
export type Regular_Programme_Pricings_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Regular_Programme_Pricings_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "regular_programme_pricings" */
export type Regular_Programme_Pricings_Aggregate_Order_By = {
  avg?: Maybe<Regular_Programme_Pricings_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Regular_Programme_Pricings_Max_Order_By>;
  min?: Maybe<Regular_Programme_Pricings_Min_Order_By>;
  stddev?: Maybe<Regular_Programme_Pricings_Stddev_Order_By>;
  stddev_pop?: Maybe<Regular_Programme_Pricings_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Regular_Programme_Pricings_Stddev_Samp_Order_By>;
  sum?: Maybe<Regular_Programme_Pricings_Sum_Order_By>;
  var_pop?: Maybe<Regular_Programme_Pricings_Var_Pop_Order_By>;
  var_samp?: Maybe<Regular_Programme_Pricings_Var_Samp_Order_By>;
  variance?: Maybe<Regular_Programme_Pricings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "regular_programme_pricings" */
export type Regular_Programme_Pricings_Arr_Rel_Insert_Input = {
  data: Array<Regular_Programme_Pricings_Insert_Input>;
  on_conflict?: Maybe<Regular_Programme_Pricings_On_Conflict>;
};

/** aggregate avg on columns */
export type Regular_Programme_Pricings_Avg_Fields = {
  __typename?: 'regular_programme_pricings_avg_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "regular_programme_pricings" */
export type Regular_Programme_Pricings_Avg_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "regular_programme_pricings". All fields are combined with a logical 'AND'. */
export type Regular_Programme_Pricings_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Regular_Programme_Pricings_Bool_Exp>>>;
  _not?: Maybe<Regular_Programme_Pricings_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Regular_Programme_Pricings_Bool_Exp>>>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  curriculum?: Maybe<Curriculums_Bool_Exp>;
  curriculumId?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  pricePerLesson?: Maybe<Numeric_Comparison_Exp>;
  regularProgramTypeId?: Maybe<Uuid_Comparison_Exp>;
  regular_program_type?: Maybe<Regular_Program_Types_Bool_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  updater?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "regular_programme_pricings" */
export enum Regular_Programme_Pricings_Constraint {
  /** unique or primary key constraint */
  RegularProgrammePricingsPkey = 'regular_programme_pricings_pkey'
}

/** input type for incrementing integer column in table "regular_programme_pricings" */
export type Regular_Programme_Pricings_Inc_Input = {
  pricePerLesson?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "regular_programme_pricings" */
export type Regular_Programme_Pricings_Insert_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculum?: Maybe<Curriculums_Obj_Rel_Insert_Input>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  pricePerLesson?: Maybe<Scalars['numeric']>;
  regularProgramTypeId?: Maybe<Scalars['uuid']>;
  regular_program_type?: Maybe<Regular_Program_Types_Obj_Rel_Insert_Input>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  updater?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Regular_Programme_Pricings_Max_Fields = {
  __typename?: 'regular_programme_pricings_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  pricePerLesson?: Maybe<Scalars['numeric']>;
  regularProgramTypeId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "regular_programme_pricings" */
export type Regular_Programme_Pricings_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  curriculumId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pricePerLesson?: Maybe<Order_By>;
  regularProgramTypeId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Regular_Programme_Pricings_Min_Fields = {
  __typename?: 'regular_programme_pricings_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  pricePerLesson?: Maybe<Scalars['numeric']>;
  regularProgramTypeId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "regular_programme_pricings" */
export type Regular_Programme_Pricings_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  curriculumId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pricePerLesson?: Maybe<Order_By>;
  regularProgramTypeId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "regular_programme_pricings" */
export type Regular_Programme_Pricings_Mutation_Response = {
  __typename?: 'regular_programme_pricings_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Regular_Programme_Pricings>;
};

/** input type for inserting object relation for remote table "regular_programme_pricings" */
export type Regular_Programme_Pricings_Obj_Rel_Insert_Input = {
  data: Regular_Programme_Pricings_Insert_Input;
  on_conflict?: Maybe<Regular_Programme_Pricings_On_Conflict>;
};

/** on conflict condition type for table "regular_programme_pricings" */
export type Regular_Programme_Pricings_On_Conflict = {
  constraint: Regular_Programme_Pricings_Constraint;
  update_columns: Array<Regular_Programme_Pricings_Update_Column>;
  where?: Maybe<Regular_Programme_Pricings_Bool_Exp>;
};

/** ordering options when selecting data from "regular_programme_pricings" */
export type Regular_Programme_Pricings_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  curriculum?: Maybe<Curriculums_Order_By>;
  curriculumId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pricePerLesson?: Maybe<Order_By>;
  regularProgramTypeId?: Maybe<Order_By>;
  regular_program_type?: Maybe<Regular_Program_Types_Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  updater?: Maybe<Users_Order_By>;
};

/** primary key columns input for table: "regular_programme_pricings" */
export type Regular_Programme_Pricings_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "regular_programme_pricings" */
export enum Regular_Programme_Pricings_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CurriculumId = 'curriculumId',
  /** column name */
  Id = 'id',
  /** column name */
  PricePerLesson = 'pricePerLesson',
  /** column name */
  RegularProgramTypeId = 'regularProgramTypeId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "regular_programme_pricings" */
export type Regular_Programme_Pricings_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  pricePerLesson?: Maybe<Scalars['numeric']>;
  regularProgramTypeId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Regular_Programme_Pricings_Stddev_Fields = {
  __typename?: 'regular_programme_pricings_stddev_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "regular_programme_pricings" */
export type Regular_Programme_Pricings_Stddev_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Regular_Programme_Pricings_Stddev_Pop_Fields = {
  __typename?: 'regular_programme_pricings_stddev_pop_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "regular_programme_pricings" */
export type Regular_Programme_Pricings_Stddev_Pop_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Regular_Programme_Pricings_Stddev_Samp_Fields = {
  __typename?: 'regular_programme_pricings_stddev_samp_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "regular_programme_pricings" */
export type Regular_Programme_Pricings_Stddev_Samp_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Regular_Programme_Pricings_Sum_Fields = {
  __typename?: 'regular_programme_pricings_sum_fields';
  pricePerLesson?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "regular_programme_pricings" */
export type Regular_Programme_Pricings_Sum_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** update columns of table "regular_programme_pricings" */
export enum Regular_Programme_Pricings_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CurriculumId = 'curriculumId',
  /** column name */
  Id = 'id',
  /** column name */
  PricePerLesson = 'pricePerLesson',
  /** column name */
  RegularProgramTypeId = 'regularProgramTypeId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** aggregate var_pop on columns */
export type Regular_Programme_Pricings_Var_Pop_Fields = {
  __typename?: 'regular_programme_pricings_var_pop_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "regular_programme_pricings" */
export type Regular_Programme_Pricings_Var_Pop_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Regular_Programme_Pricings_Var_Samp_Fields = {
  __typename?: 'regular_programme_pricings_var_samp_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "regular_programme_pricings" */
export type Regular_Programme_Pricings_Var_Samp_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Regular_Programme_Pricings_Variance_Fields = {
  __typename?: 'regular_programme_pricings_variance_fields';
  pricePerLesson?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "regular_programme_pricings" */
export type Regular_Programme_Pricings_Variance_Order_By = {
  pricePerLesson?: Maybe<Order_By>;
};

/** columns and relationships of "report_subject_budget" */
export type Report_Subject_Budget = {
  __typename?: 'report_subject_budget';
  budget: Scalars['numeric'];
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  curriculum?: Maybe<Curriculums>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An object relationship */
  subject?: Maybe<Subjects>;
  subjectId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "report_subject_budget" */
export type Report_Subject_Budget_Aggregate = {
  __typename?: 'report_subject_budget_aggregate';
  aggregate?: Maybe<Report_Subject_Budget_Aggregate_Fields>;
  nodes: Array<Report_Subject_Budget>;
};

/** aggregate fields of "report_subject_budget" */
export type Report_Subject_Budget_Aggregate_Fields = {
  __typename?: 'report_subject_budget_aggregate_fields';
  avg?: Maybe<Report_Subject_Budget_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Report_Subject_Budget_Max_Fields>;
  min?: Maybe<Report_Subject_Budget_Min_Fields>;
  stddev?: Maybe<Report_Subject_Budget_Stddev_Fields>;
  stddev_pop?: Maybe<Report_Subject_Budget_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Report_Subject_Budget_Stddev_Samp_Fields>;
  sum?: Maybe<Report_Subject_Budget_Sum_Fields>;
  var_pop?: Maybe<Report_Subject_Budget_Var_Pop_Fields>;
  var_samp?: Maybe<Report_Subject_Budget_Var_Samp_Fields>;
  variance?: Maybe<Report_Subject_Budget_Variance_Fields>;
};


/** aggregate fields of "report_subject_budget" */
export type Report_Subject_Budget_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Report_Subject_Budget_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "report_subject_budget" */
export type Report_Subject_Budget_Aggregate_Order_By = {
  avg?: Maybe<Report_Subject_Budget_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Report_Subject_Budget_Max_Order_By>;
  min?: Maybe<Report_Subject_Budget_Min_Order_By>;
  stddev?: Maybe<Report_Subject_Budget_Stddev_Order_By>;
  stddev_pop?: Maybe<Report_Subject_Budget_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Report_Subject_Budget_Stddev_Samp_Order_By>;
  sum?: Maybe<Report_Subject_Budget_Sum_Order_By>;
  var_pop?: Maybe<Report_Subject_Budget_Var_Pop_Order_By>;
  var_samp?: Maybe<Report_Subject_Budget_Var_Samp_Order_By>;
  variance?: Maybe<Report_Subject_Budget_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "report_subject_budget" */
export type Report_Subject_Budget_Arr_Rel_Insert_Input = {
  data: Array<Report_Subject_Budget_Insert_Input>;
  on_conflict?: Maybe<Report_Subject_Budget_On_Conflict>;
};

/** aggregate avg on columns */
export type Report_Subject_Budget_Avg_Fields = {
  __typename?: 'report_subject_budget_avg_fields';
  budget?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "report_subject_budget" */
export type Report_Subject_Budget_Avg_Order_By = {
  budget?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "report_subject_budget". All fields are combined with a logical 'AND'. */
export type Report_Subject_Budget_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Report_Subject_Budget_Bool_Exp>>>;
  _not?: Maybe<Report_Subject_Budget_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Report_Subject_Budget_Bool_Exp>>>;
  budget?: Maybe<Numeric_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  curriculum?: Maybe<Curriculums_Bool_Exp>;
  curriculumId?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  subject?: Maybe<Subjects_Bool_Exp>;
  subjectId?: Maybe<Uuid_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "report_subject_budget" */
export enum Report_Subject_Budget_Constraint {
  /** unique or primary key constraint */
  ReportSubjectBudgetPkey = 'report_subject_budget_pkey'
}

/** input type for incrementing integer column in table "report_subject_budget" */
export type Report_Subject_Budget_Inc_Input = {
  budget?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "report_subject_budget" */
export type Report_Subject_Budget_Insert_Input = {
  budget?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculum?: Maybe<Curriculums_Obj_Rel_Insert_Input>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  subject?: Maybe<Subjects_Obj_Rel_Insert_Input>;
  subjectId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Report_Subject_Budget_Max_Fields = {
  __typename?: 'report_subject_budget_max_fields';
  budget?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  subjectId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "report_subject_budget" */
export type Report_Subject_Budget_Max_Order_By = {
  budget?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  curriculumId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  subjectId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Report_Subject_Budget_Min_Fields = {
  __typename?: 'report_subject_budget_min_fields';
  budget?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  subjectId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "report_subject_budget" */
export type Report_Subject_Budget_Min_Order_By = {
  budget?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  curriculumId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  subjectId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "report_subject_budget" */
export type Report_Subject_Budget_Mutation_Response = {
  __typename?: 'report_subject_budget_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Report_Subject_Budget>;
};

/** input type for inserting object relation for remote table "report_subject_budget" */
export type Report_Subject_Budget_Obj_Rel_Insert_Input = {
  data: Report_Subject_Budget_Insert_Input;
  on_conflict?: Maybe<Report_Subject_Budget_On_Conflict>;
};

/** on conflict condition type for table "report_subject_budget" */
export type Report_Subject_Budget_On_Conflict = {
  constraint: Report_Subject_Budget_Constraint;
  update_columns: Array<Report_Subject_Budget_Update_Column>;
  where?: Maybe<Report_Subject_Budget_Bool_Exp>;
};

/** ordering options when selecting data from "report_subject_budget" */
export type Report_Subject_Budget_Order_By = {
  budget?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  curriculum?: Maybe<Curriculums_Order_By>;
  curriculumId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  subject?: Maybe<Subjects_Order_By>;
  subjectId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "report_subject_budget" */
export type Report_Subject_Budget_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "report_subject_budget" */
export enum Report_Subject_Budget_Select_Column {
  /** column name */
  Budget = 'budget',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CurriculumId = 'curriculumId',
  /** column name */
  Id = 'id',
  /** column name */
  SubjectId = 'subjectId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "report_subject_budget" */
export type Report_Subject_Budget_Set_Input = {
  budget?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  subjectId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Report_Subject_Budget_Stddev_Fields = {
  __typename?: 'report_subject_budget_stddev_fields';
  budget?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "report_subject_budget" */
export type Report_Subject_Budget_Stddev_Order_By = {
  budget?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Report_Subject_Budget_Stddev_Pop_Fields = {
  __typename?: 'report_subject_budget_stddev_pop_fields';
  budget?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "report_subject_budget" */
export type Report_Subject_Budget_Stddev_Pop_Order_By = {
  budget?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Report_Subject_Budget_Stddev_Samp_Fields = {
  __typename?: 'report_subject_budget_stddev_samp_fields';
  budget?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "report_subject_budget" */
export type Report_Subject_Budget_Stddev_Samp_Order_By = {
  budget?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Report_Subject_Budget_Sum_Fields = {
  __typename?: 'report_subject_budget_sum_fields';
  budget?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "report_subject_budget" */
export type Report_Subject_Budget_Sum_Order_By = {
  budget?: Maybe<Order_By>;
};

/** update columns of table "report_subject_budget" */
export enum Report_Subject_Budget_Update_Column {
  /** column name */
  Budget = 'budget',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CurriculumId = 'curriculumId',
  /** column name */
  Id = 'id',
  /** column name */
  SubjectId = 'subjectId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** aggregate var_pop on columns */
export type Report_Subject_Budget_Var_Pop_Fields = {
  __typename?: 'report_subject_budget_var_pop_fields';
  budget?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "report_subject_budget" */
export type Report_Subject_Budget_Var_Pop_Order_By = {
  budget?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Report_Subject_Budget_Var_Samp_Fields = {
  __typename?: 'report_subject_budget_var_samp_fields';
  budget?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "report_subject_budget" */
export type Report_Subject_Budget_Var_Samp_Order_By = {
  budget?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Report_Subject_Budget_Variance_Fields = {
  __typename?: 'report_subject_budget_variance_fields';
  budget?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "report_subject_budget" */
export type Report_Subject_Budget_Variance_Order_By = {
  budget?: Maybe<Order_By>;
};

/** columns and relationships of "request_transfer_classes" */
export type Request_Transfer_Classes = {
  __typename?: 'request_transfer_classes';
  /** An object relationship */
  createUser?: Maybe<Users>;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  fromClass: Classes;
  fromClassId: Scalars['uuid'];
  id: Scalars['uuid'];
  isRequested: Scalars['Boolean'];
  processingStatus: Scalars['String'];
  status: Scalars['String'];
  /** An object relationship */
  student: Users;
  studentId: Scalars['uuid'];
  /** An object relationship */
  toClass: Classes;
  toClassId: Scalars['uuid'];
  transferClassStatus: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  updater?: Maybe<Users>;
};

/** aggregated selection of "request_transfer_classes" */
export type Request_Transfer_Classes_Aggregate = {
  __typename?: 'request_transfer_classes_aggregate';
  aggregate?: Maybe<Request_Transfer_Classes_Aggregate_Fields>;
  nodes: Array<Request_Transfer_Classes>;
};

/** aggregate fields of "request_transfer_classes" */
export type Request_Transfer_Classes_Aggregate_Fields = {
  __typename?: 'request_transfer_classes_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Request_Transfer_Classes_Max_Fields>;
  min?: Maybe<Request_Transfer_Classes_Min_Fields>;
};


/** aggregate fields of "request_transfer_classes" */
export type Request_Transfer_Classes_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Request_Transfer_Classes_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "request_transfer_classes" */
export type Request_Transfer_Classes_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Request_Transfer_Classes_Max_Order_By>;
  min?: Maybe<Request_Transfer_Classes_Min_Order_By>;
};

/** input type for inserting array relation for remote table "request_transfer_classes" */
export type Request_Transfer_Classes_Arr_Rel_Insert_Input = {
  data: Array<Request_Transfer_Classes_Insert_Input>;
  on_conflict?: Maybe<Request_Transfer_Classes_On_Conflict>;
};

/** Boolean expression to filter rows from the table "request_transfer_classes". All fields are combined with a logical 'AND'. */
export type Request_Transfer_Classes_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Request_Transfer_Classes_Bool_Exp>>>;
  _not?: Maybe<Request_Transfer_Classes_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Request_Transfer_Classes_Bool_Exp>>>;
  createUser?: Maybe<Users_Bool_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  fromClass?: Maybe<Classes_Bool_Exp>;
  fromClassId?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  isRequested?: Maybe<Boolean_Comparison_Exp>;
  processingStatus?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  student?: Maybe<Users_Bool_Exp>;
  studentId?: Maybe<Uuid_Comparison_Exp>;
  toClass?: Maybe<Classes_Bool_Exp>;
  toClassId?: Maybe<Uuid_Comparison_Exp>;
  transferClassStatus?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  updater?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "request_transfer_classes" */
export enum Request_Transfer_Classes_Constraint {
  /** unique or primary key constraint */
  RequestTransferClassesPkey = 'request_transfer_classes_pkey'
}

/** input type for inserting data into table "request_transfer_classes" */
export type Request_Transfer_Classes_Insert_Input = {
  createUser?: Maybe<Users_Obj_Rel_Insert_Input>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  fromClass?: Maybe<Classes_Obj_Rel_Insert_Input>;
  fromClassId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  isRequested?: Maybe<Scalars['Boolean']>;
  processingStatus?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  student?: Maybe<Users_Obj_Rel_Insert_Input>;
  studentId?: Maybe<Scalars['uuid']>;
  toClass?: Maybe<Classes_Obj_Rel_Insert_Input>;
  toClassId?: Maybe<Scalars['uuid']>;
  transferClassStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  updater?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Request_Transfer_Classes_Max_Fields = {
  __typename?: 'request_transfer_classes_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  fromClassId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  processingStatus?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  toClassId?: Maybe<Scalars['uuid']>;
  transferClassStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "request_transfer_classes" */
export type Request_Transfer_Classes_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  fromClassId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  processingStatus?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  toClassId?: Maybe<Order_By>;
  transferClassStatus?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Request_Transfer_Classes_Min_Fields = {
  __typename?: 'request_transfer_classes_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  fromClassId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  processingStatus?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  toClassId?: Maybe<Scalars['uuid']>;
  transferClassStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "request_transfer_classes" */
export type Request_Transfer_Classes_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  fromClassId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  processingStatus?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  toClassId?: Maybe<Order_By>;
  transferClassStatus?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "request_transfer_classes" */
export type Request_Transfer_Classes_Mutation_Response = {
  __typename?: 'request_transfer_classes_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Request_Transfer_Classes>;
};

/** input type for inserting object relation for remote table "request_transfer_classes" */
export type Request_Transfer_Classes_Obj_Rel_Insert_Input = {
  data: Request_Transfer_Classes_Insert_Input;
  on_conflict?: Maybe<Request_Transfer_Classes_On_Conflict>;
};

/** on conflict condition type for table "request_transfer_classes" */
export type Request_Transfer_Classes_On_Conflict = {
  constraint: Request_Transfer_Classes_Constraint;
  update_columns: Array<Request_Transfer_Classes_Update_Column>;
  where?: Maybe<Request_Transfer_Classes_Bool_Exp>;
};

/** ordering options when selecting data from "request_transfer_classes" */
export type Request_Transfer_Classes_Order_By = {
  createUser?: Maybe<Users_Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  fromClass?: Maybe<Classes_Order_By>;
  fromClassId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  isRequested?: Maybe<Order_By>;
  processingStatus?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  student?: Maybe<Users_Order_By>;
  studentId?: Maybe<Order_By>;
  toClass?: Maybe<Classes_Order_By>;
  toClassId?: Maybe<Order_By>;
  transferClassStatus?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  updater?: Maybe<Users_Order_By>;
};

/** primary key columns input for table: "request_transfer_classes" */
export type Request_Transfer_Classes_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "request_transfer_classes" */
export enum Request_Transfer_Classes_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  FromClassId = 'fromClassId',
  /** column name */
  Id = 'id',
  /** column name */
  IsRequested = 'isRequested',
  /** column name */
  ProcessingStatus = 'processingStatus',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  ToClassId = 'toClassId',
  /** column name */
  TransferClassStatus = 'transferClassStatus',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "request_transfer_classes" */
export type Request_Transfer_Classes_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  fromClassId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  isRequested?: Maybe<Scalars['Boolean']>;
  processingStatus?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  toClassId?: Maybe<Scalars['uuid']>;
  transferClassStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "request_transfer_classes" */
export enum Request_Transfer_Classes_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  FromClassId = 'fromClassId',
  /** column name */
  Id = 'id',
  /** column name */
  IsRequested = 'isRequested',
  /** column name */
  ProcessingStatus = 'processingStatus',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  ToClassId = 'toClassId',
  /** column name */
  TransferClassStatus = 'transferClassStatus',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** columns and relationships of "roles" */
export type Roles = {
  __typename?: 'roles';
  abbreviation?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  isTeaching: Scalars['Boolean'];
  name: Scalars['String'];
  role?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  /** A computed field, executes function "count_number_user_by_role" */
  totalUsers?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "roles" */
export type Roles_Aggregate = {
  __typename?: 'roles_aggregate';
  aggregate?: Maybe<Roles_Aggregate_Fields>;
  nodes: Array<Roles>;
};

/** aggregate fields of "roles" */
export type Roles_Aggregate_Fields = {
  __typename?: 'roles_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Roles_Max_Fields>;
  min?: Maybe<Roles_Min_Fields>;
};


/** aggregate fields of "roles" */
export type Roles_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Roles_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "roles" */
export type Roles_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Roles_Max_Order_By>;
  min?: Maybe<Roles_Min_Order_By>;
};

/** input type for inserting array relation for remote table "roles" */
export type Roles_Arr_Rel_Insert_Input = {
  data: Array<Roles_Insert_Input>;
  on_conflict?: Maybe<Roles_On_Conflict>;
};

/** Boolean expression to filter rows from the table "roles". All fields are combined with a logical 'AND'. */
export type Roles_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Roles_Bool_Exp>>>;
  _not?: Maybe<Roles_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Roles_Bool_Exp>>>;
  abbreviation?: Maybe<String_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  isTeaching?: Maybe<Boolean_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  role?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "roles" */
export enum Roles_Constraint {
  /** unique or primary key constraint */
  RolesPkey = 'roles_pkey'
}

/** input type for inserting data into table "roles" */
export type Roles_Insert_Input = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  isTeaching?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Roles_Max_Fields = {
  __typename?: 'roles_max_fields';
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "roles" */
export type Roles_Max_Order_By = {
  abbreviation?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  role?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Roles_Min_Fields = {
  __typename?: 'roles_min_fields';
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "roles" */
export type Roles_Min_Order_By = {
  abbreviation?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  role?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "roles" */
export type Roles_Mutation_Response = {
  __typename?: 'roles_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Roles>;
};

/** input type for inserting object relation for remote table "roles" */
export type Roles_Obj_Rel_Insert_Input = {
  data: Roles_Insert_Input;
  on_conflict?: Maybe<Roles_On_Conflict>;
};

/** on conflict condition type for table "roles" */
export type Roles_On_Conflict = {
  constraint: Roles_Constraint;
  update_columns: Array<Roles_Update_Column>;
  where?: Maybe<Roles_Bool_Exp>;
};

/** ordering options when selecting data from "roles" */
export type Roles_Order_By = {
  abbreviation?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  isTeaching?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  role?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "roles" */
export type Roles_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "roles" */
export enum Roles_Select_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  IsTeaching = 'isTeaching',
  /** column name */
  Name = 'name',
  /** column name */
  Role = 'role',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "roles" */
export type Roles_Set_Input = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  isTeaching?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "roles" */
export enum Roles_Update_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  IsTeaching = 'isTeaching',
  /** column name */
  Name = 'name',
  /** column name */
  Role = 'role',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** columns and relationships of "schools" */
export type Schools = {
  __typename?: 'schools';
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  status: Scalars['String'];
  /** An array relationship */
  student_profiles: Array<Student_Profiles>;
  /** An aggregated array relationship */
  student_profiles_aggregate: Student_Profiles_Aggregate;
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "schools" */
export type SchoolsStudent_ProfilesArgs = {
  distinct_on?: Maybe<Array<Student_Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Student_Profiles_Order_By>>;
  where?: Maybe<Student_Profiles_Bool_Exp>;
};


/** columns and relationships of "schools" */
export type SchoolsStudent_Profiles_AggregateArgs = {
  distinct_on?: Maybe<Array<Student_Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Student_Profiles_Order_By>>;
  where?: Maybe<Student_Profiles_Bool_Exp>;
};

/** aggregated selection of "schools" */
export type Schools_Aggregate = {
  __typename?: 'schools_aggregate';
  aggregate?: Maybe<Schools_Aggregate_Fields>;
  nodes: Array<Schools>;
};

/** aggregate fields of "schools" */
export type Schools_Aggregate_Fields = {
  __typename?: 'schools_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Schools_Max_Fields>;
  min?: Maybe<Schools_Min_Fields>;
};


/** aggregate fields of "schools" */
export type Schools_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Schools_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "schools" */
export type Schools_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Schools_Max_Order_By>;
  min?: Maybe<Schools_Min_Order_By>;
};

/** input type for inserting array relation for remote table "schools" */
export type Schools_Arr_Rel_Insert_Input = {
  data: Array<Schools_Insert_Input>;
  on_conflict?: Maybe<Schools_On_Conflict>;
};

/** Boolean expression to filter rows from the table "schools". All fields are combined with a logical 'AND'. */
export type Schools_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Schools_Bool_Exp>>>;
  _not?: Maybe<Schools_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Schools_Bool_Exp>>>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  student_profiles?: Maybe<Student_Profiles_Bool_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "schools" */
export enum Schools_Constraint {
  /** unique or primary key constraint */
  SchoolsPkey = 'schools_pkey'
}

/** input type for inserting data into table "schools" */
export type Schools_Insert_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  student_profiles?: Maybe<Student_Profiles_Arr_Rel_Insert_Input>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Schools_Max_Fields = {
  __typename?: 'schools_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "schools" */
export type Schools_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Schools_Min_Fields = {
  __typename?: 'schools_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "schools" */
export type Schools_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "schools" */
export type Schools_Mutation_Response = {
  __typename?: 'schools_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Schools>;
};

/** input type for inserting object relation for remote table "schools" */
export type Schools_Obj_Rel_Insert_Input = {
  data: Schools_Insert_Input;
  on_conflict?: Maybe<Schools_On_Conflict>;
};

/** on conflict condition type for table "schools" */
export type Schools_On_Conflict = {
  constraint: Schools_Constraint;
  update_columns: Array<Schools_Update_Column>;
  where?: Maybe<Schools_Bool_Exp>;
};

/** ordering options when selecting data from "schools" */
export type Schools_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  student_profiles_aggregate?: Maybe<Student_Profiles_Aggregate_Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "schools" */
export type Schools_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "schools" */
export enum Schools_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "schools" */
export type Schools_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "schools" */
export enum Schools_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** fields of action: "sentBroadcast" */
export type SentBroadcast = {
  __typename?: 'sentBroadcast';
  /** the time at which this action was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** errors related to the invocation */
  errors?: Maybe<Scalars['json']>;
  /** the unique id of an action */
  id?: Maybe<Scalars['uuid']>;
  /** the output fields of this action */
  output?: Maybe<Output>;
};

/** fields of action: "sentNews" */
export type SentNews = {
  __typename?: 'sentNews';
  /** the time at which this action was created */
  created_at?: Maybe<Scalars['timestamptz']>;
  /** errors related to the invocation */
  errors?: Maybe<Scalars['json']>;
  /** the unique id of an action */
  id?: Maybe<Scalars['uuid']>;
  /** the output fields of this action */
  output?: Maybe<NewsOutput>;
};

/** columns and relationships of "sessions" */
export type Sessions = {
  __typename?: 'sessions';
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  endTime: Scalars['timetz'];
  id: Scalars['uuid'];
  /** An object relationship */
  lesson: Lessons;
  lessonId: Scalars['uuid'];
  orderPriority: Scalars['numeric'];
  startTime: Scalars['timetz'];
  status: Scalars['String'];
  tutorIds: Scalars['jsonb'];
  /** A computed field, executes function "sessions_field_tutors" */
  tutors?: Maybe<Array<Users>>;
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  userByCreatedby?: Maybe<Users>;
};


/** columns and relationships of "sessions" */
export type SessionsTutorIdsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "sessions" */
export type SessionsTutorsArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};

/** aggregated selection of "sessions" */
export type Sessions_Aggregate = {
  __typename?: 'sessions_aggregate';
  aggregate?: Maybe<Sessions_Aggregate_Fields>;
  nodes: Array<Sessions>;
};

/** aggregate fields of "sessions" */
export type Sessions_Aggregate_Fields = {
  __typename?: 'sessions_aggregate_fields';
  avg?: Maybe<Sessions_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Sessions_Max_Fields>;
  min?: Maybe<Sessions_Min_Fields>;
  stddev?: Maybe<Sessions_Stddev_Fields>;
  stddev_pop?: Maybe<Sessions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sessions_Stddev_Samp_Fields>;
  sum?: Maybe<Sessions_Sum_Fields>;
  var_pop?: Maybe<Sessions_Var_Pop_Fields>;
  var_samp?: Maybe<Sessions_Var_Samp_Fields>;
  variance?: Maybe<Sessions_Variance_Fields>;
};


/** aggregate fields of "sessions" */
export type Sessions_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Sessions_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sessions" */
export type Sessions_Aggregate_Order_By = {
  avg?: Maybe<Sessions_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Sessions_Max_Order_By>;
  min?: Maybe<Sessions_Min_Order_By>;
  stddev?: Maybe<Sessions_Stddev_Order_By>;
  stddev_pop?: Maybe<Sessions_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Sessions_Stddev_Samp_Order_By>;
  sum?: Maybe<Sessions_Sum_Order_By>;
  var_pop?: Maybe<Sessions_Var_Pop_Order_By>;
  var_samp?: Maybe<Sessions_Var_Samp_Order_By>;
  variance?: Maybe<Sessions_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Sessions_Append_Input = {
  tutorIds?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "sessions" */
export type Sessions_Arr_Rel_Insert_Input = {
  data: Array<Sessions_Insert_Input>;
  on_conflict?: Maybe<Sessions_On_Conflict>;
};

/** aggregate avg on columns */
export type Sessions_Avg_Fields = {
  __typename?: 'sessions_avg_fields';
  orderPriority?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "sessions" */
export type Sessions_Avg_Order_By = {
  orderPriority?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sessions". All fields are combined with a logical 'AND'. */
export type Sessions_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Sessions_Bool_Exp>>>;
  _not?: Maybe<Sessions_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Sessions_Bool_Exp>>>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  endTime?: Maybe<Timetz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  lesson?: Maybe<Lessons_Bool_Exp>;
  lessonId?: Maybe<Uuid_Comparison_Exp>;
  orderPriority?: Maybe<Numeric_Comparison_Exp>;
  startTime?: Maybe<Timetz_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  tutorIds?: Maybe<Jsonb_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  userByCreatedby?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "sessions" */
export enum Sessions_Constraint {
  /** unique or primary key constraint */
  SessionsLessonIdOrderPriorityKey = 'sessions_lessonId_orderPriority_key',
  /** unique or primary key constraint */
  SessionsLessonIdStartTimeEndTimeKey = 'sessions_lessonId_startTime_endTime_key',
  /** unique or primary key constraint */
  SessionsPkey = 'sessions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Sessions_Delete_At_Path_Input = {
  tutorIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Sessions_Delete_Elem_Input = {
  tutorIds?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Sessions_Delete_Key_Input = {
  tutorIds?: Maybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "sessions" */
export type Sessions_Inc_Input = {
  orderPriority?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "sessions" */
export type Sessions_Insert_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  endTime?: Maybe<Scalars['timetz']>;
  id?: Maybe<Scalars['uuid']>;
  lesson?: Maybe<Lessons_Obj_Rel_Insert_Input>;
  lessonId?: Maybe<Scalars['uuid']>;
  orderPriority?: Maybe<Scalars['numeric']>;
  startTime?: Maybe<Scalars['timetz']>;
  status?: Maybe<Scalars['String']>;
  tutorIds?: Maybe<Scalars['jsonb']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  userByCreatedby?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Sessions_Max_Fields = {
  __typename?: 'sessions_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  endTime?: Maybe<Scalars['timetz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  orderPriority?: Maybe<Scalars['numeric']>;
  startTime?: Maybe<Scalars['timetz']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "sessions" */
export type Sessions_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  endTime?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lessonId?: Maybe<Order_By>;
  orderPriority?: Maybe<Order_By>;
  startTime?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Sessions_Min_Fields = {
  __typename?: 'sessions_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  endTime?: Maybe<Scalars['timetz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  orderPriority?: Maybe<Scalars['numeric']>;
  startTime?: Maybe<Scalars['timetz']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "sessions" */
export type Sessions_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  endTime?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lessonId?: Maybe<Order_By>;
  orderPriority?: Maybe<Order_By>;
  startTime?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "sessions" */
export type Sessions_Mutation_Response = {
  __typename?: 'sessions_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Sessions>;
};

/** input type for inserting object relation for remote table "sessions" */
export type Sessions_Obj_Rel_Insert_Input = {
  data: Sessions_Insert_Input;
  on_conflict?: Maybe<Sessions_On_Conflict>;
};

/** on conflict condition type for table "sessions" */
export type Sessions_On_Conflict = {
  constraint: Sessions_Constraint;
  update_columns: Array<Sessions_Update_Column>;
  where?: Maybe<Sessions_Bool_Exp>;
};

/** ordering options when selecting data from "sessions" */
export type Sessions_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  endTime?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lesson?: Maybe<Lessons_Order_By>;
  lessonId?: Maybe<Order_By>;
  orderPriority?: Maybe<Order_By>;
  startTime?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  tutorIds?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  userByCreatedby?: Maybe<Users_Order_By>;
};

/** primary key columns input for table: "sessions" */
export type Sessions_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Sessions_Prepend_Input = {
  tutorIds?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "sessions" */
export enum Sessions_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  OrderPriority = 'orderPriority',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  Status = 'status',
  /** column name */
  TutorIds = 'tutorIds',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "sessions" */
export type Sessions_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  endTime?: Maybe<Scalars['timetz']>;
  id?: Maybe<Scalars['uuid']>;
  lessonId?: Maybe<Scalars['uuid']>;
  orderPriority?: Maybe<Scalars['numeric']>;
  startTime?: Maybe<Scalars['timetz']>;
  status?: Maybe<Scalars['String']>;
  tutorIds?: Maybe<Scalars['jsonb']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Sessions_Stddev_Fields = {
  __typename?: 'sessions_stddev_fields';
  orderPriority?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "sessions" */
export type Sessions_Stddev_Order_By = {
  orderPriority?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sessions_Stddev_Pop_Fields = {
  __typename?: 'sessions_stddev_pop_fields';
  orderPriority?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "sessions" */
export type Sessions_Stddev_Pop_Order_By = {
  orderPriority?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sessions_Stddev_Samp_Fields = {
  __typename?: 'sessions_stddev_samp_fields';
  orderPriority?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "sessions" */
export type Sessions_Stddev_Samp_Order_By = {
  orderPriority?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Sessions_Sum_Fields = {
  __typename?: 'sessions_sum_fields';
  orderPriority?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "sessions" */
export type Sessions_Sum_Order_By = {
  orderPriority?: Maybe<Order_By>;
};

/** update columns of table "sessions" */
export enum Sessions_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  Id = 'id',
  /** column name */
  LessonId = 'lessonId',
  /** column name */
  OrderPriority = 'orderPriority',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  Status = 'status',
  /** column name */
  TutorIds = 'tutorIds',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** aggregate var_pop on columns */
export type Sessions_Var_Pop_Fields = {
  __typename?: 'sessions_var_pop_fields';
  orderPriority?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "sessions" */
export type Sessions_Var_Pop_Order_By = {
  orderPriority?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sessions_Var_Samp_Fields = {
  __typename?: 'sessions_var_samp_fields';
  orderPriority?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "sessions" */
export type Sessions_Var_Samp_Order_By = {
  orderPriority?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Sessions_Variance_Fields = {
  __typename?: 'sessions_variance_fields';
  orderPriority?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "sessions" */
export type Sessions_Variance_Order_By = {
  orderPriority?: Maybe<Order_By>;
};

/** columns and relationships of "special_programme_class_pricings" */
export type Special_Programme_Class_Pricings = {
  __typename?: 'special_programme_class_pricings';
  /** An object relationship */
  class: Classes;
  classId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  pricePerStudent: Scalars['numeric'];
  status: Scalars['String'];
  studentType: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  updater?: Maybe<Users>;
};

/** aggregated selection of "special_programme_class_pricings" */
export type Special_Programme_Class_Pricings_Aggregate = {
  __typename?: 'special_programme_class_pricings_aggregate';
  aggregate?: Maybe<Special_Programme_Class_Pricings_Aggregate_Fields>;
  nodes: Array<Special_Programme_Class_Pricings>;
};

/** aggregate fields of "special_programme_class_pricings" */
export type Special_Programme_Class_Pricings_Aggregate_Fields = {
  __typename?: 'special_programme_class_pricings_aggregate_fields';
  avg?: Maybe<Special_Programme_Class_Pricings_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Special_Programme_Class_Pricings_Max_Fields>;
  min?: Maybe<Special_Programme_Class_Pricings_Min_Fields>;
  stddev?: Maybe<Special_Programme_Class_Pricings_Stddev_Fields>;
  stddev_pop?: Maybe<Special_Programme_Class_Pricings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Special_Programme_Class_Pricings_Stddev_Samp_Fields>;
  sum?: Maybe<Special_Programme_Class_Pricings_Sum_Fields>;
  var_pop?: Maybe<Special_Programme_Class_Pricings_Var_Pop_Fields>;
  var_samp?: Maybe<Special_Programme_Class_Pricings_Var_Samp_Fields>;
  variance?: Maybe<Special_Programme_Class_Pricings_Variance_Fields>;
};


/** aggregate fields of "special_programme_class_pricings" */
export type Special_Programme_Class_Pricings_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Special_Programme_Class_Pricings_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "special_programme_class_pricings" */
export type Special_Programme_Class_Pricings_Aggregate_Order_By = {
  avg?: Maybe<Special_Programme_Class_Pricings_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Special_Programme_Class_Pricings_Max_Order_By>;
  min?: Maybe<Special_Programme_Class_Pricings_Min_Order_By>;
  stddev?: Maybe<Special_Programme_Class_Pricings_Stddev_Order_By>;
  stddev_pop?: Maybe<Special_Programme_Class_Pricings_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Special_Programme_Class_Pricings_Stddev_Samp_Order_By>;
  sum?: Maybe<Special_Programme_Class_Pricings_Sum_Order_By>;
  var_pop?: Maybe<Special_Programme_Class_Pricings_Var_Pop_Order_By>;
  var_samp?: Maybe<Special_Programme_Class_Pricings_Var_Samp_Order_By>;
  variance?: Maybe<Special_Programme_Class_Pricings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "special_programme_class_pricings" */
export type Special_Programme_Class_Pricings_Arr_Rel_Insert_Input = {
  data: Array<Special_Programme_Class_Pricings_Insert_Input>;
  on_conflict?: Maybe<Special_Programme_Class_Pricings_On_Conflict>;
};

/** aggregate avg on columns */
export type Special_Programme_Class_Pricings_Avg_Fields = {
  __typename?: 'special_programme_class_pricings_avg_fields';
  pricePerStudent?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "special_programme_class_pricings" */
export type Special_Programme_Class_Pricings_Avg_Order_By = {
  pricePerStudent?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "special_programme_class_pricings". All fields are combined with a logical 'AND'. */
export type Special_Programme_Class_Pricings_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Special_Programme_Class_Pricings_Bool_Exp>>>;
  _not?: Maybe<Special_Programme_Class_Pricings_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Special_Programme_Class_Pricings_Bool_Exp>>>;
  class?: Maybe<Classes_Bool_Exp>;
  classId?: Maybe<Uuid_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  pricePerStudent?: Maybe<Numeric_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  studentType?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  updater?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "special_programme_class_pricings" */
export enum Special_Programme_Class_Pricings_Constraint {
  /** unique or primary key constraint */
  SpecialProgrammeClassPricingsPkey = 'special_programme_class_pricings_pkey'
}

/** input type for incrementing integer column in table "special_programme_class_pricings" */
export type Special_Programme_Class_Pricings_Inc_Input = {
  pricePerStudent?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "special_programme_class_pricings" */
export type Special_Programme_Class_Pricings_Insert_Input = {
  class?: Maybe<Classes_Obj_Rel_Insert_Input>;
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  pricePerStudent?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  studentType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  updater?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Special_Programme_Class_Pricings_Max_Fields = {
  __typename?: 'special_programme_class_pricings_max_fields';
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  pricePerStudent?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  studentType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "special_programme_class_pricings" */
export type Special_Programme_Class_Pricings_Max_Order_By = {
  classId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pricePerStudent?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentType?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Special_Programme_Class_Pricings_Min_Fields = {
  __typename?: 'special_programme_class_pricings_min_fields';
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  pricePerStudent?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  studentType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "special_programme_class_pricings" */
export type Special_Programme_Class_Pricings_Min_Order_By = {
  classId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pricePerStudent?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentType?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "special_programme_class_pricings" */
export type Special_Programme_Class_Pricings_Mutation_Response = {
  __typename?: 'special_programme_class_pricings_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Special_Programme_Class_Pricings>;
};

/** input type for inserting object relation for remote table "special_programme_class_pricings" */
export type Special_Programme_Class_Pricings_Obj_Rel_Insert_Input = {
  data: Special_Programme_Class_Pricings_Insert_Input;
  on_conflict?: Maybe<Special_Programme_Class_Pricings_On_Conflict>;
};

/** on conflict condition type for table "special_programme_class_pricings" */
export type Special_Programme_Class_Pricings_On_Conflict = {
  constraint: Special_Programme_Class_Pricings_Constraint;
  update_columns: Array<Special_Programme_Class_Pricings_Update_Column>;
  where?: Maybe<Special_Programme_Class_Pricings_Bool_Exp>;
};

/** ordering options when selecting data from "special_programme_class_pricings" */
export type Special_Programme_Class_Pricings_Order_By = {
  class?: Maybe<Classes_Order_By>;
  classId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pricePerStudent?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentType?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  updater?: Maybe<Users_Order_By>;
};

/** primary key columns input for table: "special_programme_class_pricings" */
export type Special_Programme_Class_Pricings_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "special_programme_class_pricings" */
export enum Special_Programme_Class_Pricings_Select_Column {
  /** column name */
  ClassId = 'classId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  PricePerStudent = 'pricePerStudent',
  /** column name */
  Status = 'status',
  /** column name */
  StudentType = 'studentType',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "special_programme_class_pricings" */
export type Special_Programme_Class_Pricings_Set_Input = {
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  pricePerStudent?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  studentType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Special_Programme_Class_Pricings_Stddev_Fields = {
  __typename?: 'special_programme_class_pricings_stddev_fields';
  pricePerStudent?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "special_programme_class_pricings" */
export type Special_Programme_Class_Pricings_Stddev_Order_By = {
  pricePerStudent?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Special_Programme_Class_Pricings_Stddev_Pop_Fields = {
  __typename?: 'special_programme_class_pricings_stddev_pop_fields';
  pricePerStudent?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "special_programme_class_pricings" */
export type Special_Programme_Class_Pricings_Stddev_Pop_Order_By = {
  pricePerStudent?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Special_Programme_Class_Pricings_Stddev_Samp_Fields = {
  __typename?: 'special_programme_class_pricings_stddev_samp_fields';
  pricePerStudent?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "special_programme_class_pricings" */
export type Special_Programme_Class_Pricings_Stddev_Samp_Order_By = {
  pricePerStudent?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Special_Programme_Class_Pricings_Sum_Fields = {
  __typename?: 'special_programme_class_pricings_sum_fields';
  pricePerStudent?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "special_programme_class_pricings" */
export type Special_Programme_Class_Pricings_Sum_Order_By = {
  pricePerStudent?: Maybe<Order_By>;
};

/** update columns of table "special_programme_class_pricings" */
export enum Special_Programme_Class_Pricings_Update_Column {
  /** column name */
  ClassId = 'classId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  PricePerStudent = 'pricePerStudent',
  /** column name */
  Status = 'status',
  /** column name */
  StudentType = 'studentType',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** aggregate var_pop on columns */
export type Special_Programme_Class_Pricings_Var_Pop_Fields = {
  __typename?: 'special_programme_class_pricings_var_pop_fields';
  pricePerStudent?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "special_programme_class_pricings" */
export type Special_Programme_Class_Pricings_Var_Pop_Order_By = {
  pricePerStudent?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Special_Programme_Class_Pricings_Var_Samp_Fields = {
  __typename?: 'special_programme_class_pricings_var_samp_fields';
  pricePerStudent?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "special_programme_class_pricings" */
export type Special_Programme_Class_Pricings_Var_Samp_Order_By = {
  pricePerStudent?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Special_Programme_Class_Pricings_Variance_Fields = {
  __typename?: 'special_programme_class_pricings_variance_fields';
  pricePerStudent?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "special_programme_class_pricings" */
export type Special_Programme_Class_Pricings_Variance_Order_By = {
  pricePerStudent?: Maybe<Order_By>;
};

/** columns and relationships of "specical_program_types" */
export type Specical_Program_Types = {
  __typename?: 'specical_program_types';
  /** An array relationship */
  classes: Array<Classes>;
  /** An aggregated array relationship */
  classes_aggregate: Classes_Aggregate;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  fullName: Scalars['String'];
  id: Scalars['uuid'];
  shortName: Scalars['String'];
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "specical_program_types" */
export type Specical_Program_TypesClassesArgs = {
  distinct_on?: Maybe<Array<Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classes_Order_By>>;
  where?: Maybe<Classes_Bool_Exp>;
};


/** columns and relationships of "specical_program_types" */
export type Specical_Program_TypesClasses_AggregateArgs = {
  distinct_on?: Maybe<Array<Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classes_Order_By>>;
  where?: Maybe<Classes_Bool_Exp>;
};

/** aggregated selection of "specical_program_types" */
export type Specical_Program_Types_Aggregate = {
  __typename?: 'specical_program_types_aggregate';
  aggregate?: Maybe<Specical_Program_Types_Aggregate_Fields>;
  nodes: Array<Specical_Program_Types>;
};

/** aggregate fields of "specical_program_types" */
export type Specical_Program_Types_Aggregate_Fields = {
  __typename?: 'specical_program_types_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Specical_Program_Types_Max_Fields>;
  min?: Maybe<Specical_Program_Types_Min_Fields>;
};


/** aggregate fields of "specical_program_types" */
export type Specical_Program_Types_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Specical_Program_Types_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "specical_program_types" */
export type Specical_Program_Types_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Specical_Program_Types_Max_Order_By>;
  min?: Maybe<Specical_Program_Types_Min_Order_By>;
};

/** input type for inserting array relation for remote table "specical_program_types" */
export type Specical_Program_Types_Arr_Rel_Insert_Input = {
  data: Array<Specical_Program_Types_Insert_Input>;
  on_conflict?: Maybe<Specical_Program_Types_On_Conflict>;
};

/** Boolean expression to filter rows from the table "specical_program_types". All fields are combined with a logical 'AND'. */
export type Specical_Program_Types_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Specical_Program_Types_Bool_Exp>>>;
  _not?: Maybe<Specical_Program_Types_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Specical_Program_Types_Bool_Exp>>>;
  classes?: Maybe<Classes_Bool_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  fullName?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  shortName?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "specical_program_types" */
export enum Specical_Program_Types_Constraint {
  /** unique or primary key constraint */
  SpecicalProgramTypesPkey = 'specical_program_types_pkey'
}

/** input type for inserting data into table "specical_program_types" */
export type Specical_Program_Types_Insert_Input = {
  classes?: Maybe<Classes_Arr_Rel_Insert_Input>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  shortName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Specical_Program_Types_Max_Fields = {
  __typename?: 'specical_program_types_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  shortName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "specical_program_types" */
export type Specical_Program_Types_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  fullName?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  shortName?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Specical_Program_Types_Min_Fields = {
  __typename?: 'specical_program_types_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  shortName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "specical_program_types" */
export type Specical_Program_Types_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  fullName?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  shortName?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "specical_program_types" */
export type Specical_Program_Types_Mutation_Response = {
  __typename?: 'specical_program_types_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Specical_Program_Types>;
};

/** input type for inserting object relation for remote table "specical_program_types" */
export type Specical_Program_Types_Obj_Rel_Insert_Input = {
  data: Specical_Program_Types_Insert_Input;
  on_conflict?: Maybe<Specical_Program_Types_On_Conflict>;
};

/** on conflict condition type for table "specical_program_types" */
export type Specical_Program_Types_On_Conflict = {
  constraint: Specical_Program_Types_Constraint;
  update_columns: Array<Specical_Program_Types_Update_Column>;
  where?: Maybe<Specical_Program_Types_Bool_Exp>;
};

/** ordering options when selecting data from "specical_program_types" */
export type Specical_Program_Types_Order_By = {
  classes_aggregate?: Maybe<Classes_Aggregate_Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  fullName?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  shortName?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "specical_program_types" */
export type Specical_Program_Types_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "specical_program_types" */
export enum Specical_Program_Types_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  FullName = 'fullName',
  /** column name */
  Id = 'id',
  /** column name */
  ShortName = 'shortName',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "specical_program_types" */
export type Specical_Program_Types_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  shortName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "specical_program_types" */
export enum Specical_Program_Types_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  FullName = 'fullName',
  /** column name */
  Id = 'id',
  /** column name */
  ShortName = 'shortName',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** columns and relationships of "student_profiles" */
export type Student_Profiles = {
  __typename?: 'student_profiles';
  billing?: Maybe<Scalars['jsonb']>;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  currentStep?: Maybe<Scalars['String']>;
  /** An object relationship */
  curriculum?: Maybe<Curriculums>;
  curriculumId?: Maybe<Scalars['uuid']>;
  emergencyContact?: Maybe<Scalars['jsonb']>;
  firstParent?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  /** An object relationship */
  level?: Maybe<Levels>;
  levelId?: Maybe<Scalars['uuid']>;
  mailling?: Maybe<Scalars['jsonb']>;
  notes?: Maybe<Scalars['jsonb']>;
  parents?: Maybe<Scalars['jsonb']>;
  payLaterReason?: Maybe<Scalars['String']>;
  payOnline: Scalars['Boolean'];
  payment?: Maybe<Scalars['jsonb']>;
  paymentStatus: Scalars['Boolean'];
  /** An object relationship */
  school?: Maybe<Schools>;
  schoolId?: Maybe<Scalars['uuid']>;
  status: Scalars['String'];
  subscribe: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  userByCreatedby?: Maybe<Users>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregated array relationship */
  users_aggregate: Users_Aggregate;
  willPayLater: Scalars['Boolean'];
};


/** columns and relationships of "student_profiles" */
export type Student_ProfilesBillingArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "student_profiles" */
export type Student_ProfilesEmergencyContactArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "student_profiles" */
export type Student_ProfilesFirstParentArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "student_profiles" */
export type Student_ProfilesMaillingArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "student_profiles" */
export type Student_ProfilesNotesArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "student_profiles" */
export type Student_ProfilesParentsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "student_profiles" */
export type Student_ProfilesPaymentArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "student_profiles" */
export type Student_ProfilesUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** columns and relationships of "student_profiles" */
export type Student_ProfilesUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};

/** aggregated selection of "student_profiles" */
export type Student_Profiles_Aggregate = {
  __typename?: 'student_profiles_aggregate';
  aggregate?: Maybe<Student_Profiles_Aggregate_Fields>;
  nodes: Array<Student_Profiles>;
};

/** aggregate fields of "student_profiles" */
export type Student_Profiles_Aggregate_Fields = {
  __typename?: 'student_profiles_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Student_Profiles_Max_Fields>;
  min?: Maybe<Student_Profiles_Min_Fields>;
};


/** aggregate fields of "student_profiles" */
export type Student_Profiles_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Student_Profiles_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "student_profiles" */
export type Student_Profiles_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Student_Profiles_Max_Order_By>;
  min?: Maybe<Student_Profiles_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Student_Profiles_Append_Input = {
  billing?: Maybe<Scalars['jsonb']>;
  emergencyContact?: Maybe<Scalars['jsonb']>;
  firstParent?: Maybe<Scalars['jsonb']>;
  mailling?: Maybe<Scalars['jsonb']>;
  notes?: Maybe<Scalars['jsonb']>;
  parents?: Maybe<Scalars['jsonb']>;
  payment?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "student_profiles" */
export type Student_Profiles_Arr_Rel_Insert_Input = {
  data: Array<Student_Profiles_Insert_Input>;
  on_conflict?: Maybe<Student_Profiles_On_Conflict>;
};

/** Boolean expression to filter rows from the table "student_profiles". All fields are combined with a logical 'AND'. */
export type Student_Profiles_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Student_Profiles_Bool_Exp>>>;
  _not?: Maybe<Student_Profiles_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Student_Profiles_Bool_Exp>>>;
  billing?: Maybe<Jsonb_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  currentStep?: Maybe<String_Comparison_Exp>;
  curriculum?: Maybe<Curriculums_Bool_Exp>;
  curriculumId?: Maybe<Uuid_Comparison_Exp>;
  emergencyContact?: Maybe<Jsonb_Comparison_Exp>;
  firstParent?: Maybe<Jsonb_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  level?: Maybe<Levels_Bool_Exp>;
  levelId?: Maybe<Uuid_Comparison_Exp>;
  mailling?: Maybe<Jsonb_Comparison_Exp>;
  notes?: Maybe<Jsonb_Comparison_Exp>;
  parents?: Maybe<Jsonb_Comparison_Exp>;
  payLaterReason?: Maybe<String_Comparison_Exp>;
  payOnline?: Maybe<Boolean_Comparison_Exp>;
  payment?: Maybe<Jsonb_Comparison_Exp>;
  paymentStatus?: Maybe<Boolean_Comparison_Exp>;
  school?: Maybe<Schools_Bool_Exp>;
  schoolId?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  subscribe?: Maybe<Boolean_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  userByCreatedby?: Maybe<Users_Bool_Exp>;
  users?: Maybe<Users_Bool_Exp>;
  willPayLater?: Maybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "student_profiles" */
export enum Student_Profiles_Constraint {
  /** unique or primary key constraint */
  StudentProfilesPkey = 'student_profiles_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Student_Profiles_Delete_At_Path_Input = {
  billing?: Maybe<Array<Maybe<Scalars['String']>>>;
  emergencyContact?: Maybe<Array<Maybe<Scalars['String']>>>;
  firstParent?: Maybe<Array<Maybe<Scalars['String']>>>;
  mailling?: Maybe<Array<Maybe<Scalars['String']>>>;
  notes?: Maybe<Array<Maybe<Scalars['String']>>>;
  parents?: Maybe<Array<Maybe<Scalars['String']>>>;
  payment?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Student_Profiles_Delete_Elem_Input = {
  billing?: Maybe<Scalars['Int']>;
  emergencyContact?: Maybe<Scalars['Int']>;
  firstParent?: Maybe<Scalars['Int']>;
  mailling?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['Int']>;
  parents?: Maybe<Scalars['Int']>;
  payment?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Student_Profiles_Delete_Key_Input = {
  billing?: Maybe<Scalars['String']>;
  emergencyContact?: Maybe<Scalars['String']>;
  firstParent?: Maybe<Scalars['String']>;
  mailling?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  parents?: Maybe<Scalars['String']>;
  payment?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "student_profiles" */
export type Student_Profiles_Insert_Input = {
  billing?: Maybe<Scalars['jsonb']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  currentStep?: Maybe<Scalars['String']>;
  curriculum?: Maybe<Curriculums_Obj_Rel_Insert_Input>;
  curriculumId?: Maybe<Scalars['uuid']>;
  emergencyContact?: Maybe<Scalars['jsonb']>;
  firstParent?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  level?: Maybe<Levels_Obj_Rel_Insert_Input>;
  levelId?: Maybe<Scalars['uuid']>;
  mailling?: Maybe<Scalars['jsonb']>;
  notes?: Maybe<Scalars['jsonb']>;
  parents?: Maybe<Scalars['jsonb']>;
  payLaterReason?: Maybe<Scalars['String']>;
  payOnline?: Maybe<Scalars['Boolean']>;
  payment?: Maybe<Scalars['jsonb']>;
  paymentStatus?: Maybe<Scalars['Boolean']>;
  school?: Maybe<Schools_Obj_Rel_Insert_Input>;
  schoolId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  subscribe?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  userByCreatedby?: Maybe<Users_Obj_Rel_Insert_Input>;
  users?: Maybe<Users_Arr_Rel_Insert_Input>;
  willPayLater?: Maybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Student_Profiles_Max_Fields = {
  __typename?: 'student_profiles_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  currentStep?: Maybe<Scalars['String']>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  levelId?: Maybe<Scalars['uuid']>;
  payLaterReason?: Maybe<Scalars['String']>;
  schoolId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "student_profiles" */
export type Student_Profiles_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  currentStep?: Maybe<Order_By>;
  curriculumId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  levelId?: Maybe<Order_By>;
  payLaterReason?: Maybe<Order_By>;
  schoolId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Student_Profiles_Min_Fields = {
  __typename?: 'student_profiles_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  currentStep?: Maybe<Scalars['String']>;
  curriculumId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  levelId?: Maybe<Scalars['uuid']>;
  payLaterReason?: Maybe<Scalars['String']>;
  schoolId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "student_profiles" */
export type Student_Profiles_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  currentStep?: Maybe<Order_By>;
  curriculumId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  levelId?: Maybe<Order_By>;
  payLaterReason?: Maybe<Order_By>;
  schoolId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "student_profiles" */
export type Student_Profiles_Mutation_Response = {
  __typename?: 'student_profiles_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Student_Profiles>;
};

/** input type for inserting object relation for remote table "student_profiles" */
export type Student_Profiles_Obj_Rel_Insert_Input = {
  data: Student_Profiles_Insert_Input;
  on_conflict?: Maybe<Student_Profiles_On_Conflict>;
};

/** on conflict condition type for table "student_profiles" */
export type Student_Profiles_On_Conflict = {
  constraint: Student_Profiles_Constraint;
  update_columns: Array<Student_Profiles_Update_Column>;
  where?: Maybe<Student_Profiles_Bool_Exp>;
};

/** ordering options when selecting data from "student_profiles" */
export type Student_Profiles_Order_By = {
  billing?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  currentStep?: Maybe<Order_By>;
  curriculum?: Maybe<Curriculums_Order_By>;
  curriculumId?: Maybe<Order_By>;
  emergencyContact?: Maybe<Order_By>;
  firstParent?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  level?: Maybe<Levels_Order_By>;
  levelId?: Maybe<Order_By>;
  mailling?: Maybe<Order_By>;
  notes?: Maybe<Order_By>;
  parents?: Maybe<Order_By>;
  payLaterReason?: Maybe<Order_By>;
  payOnline?: Maybe<Order_By>;
  payment?: Maybe<Order_By>;
  paymentStatus?: Maybe<Order_By>;
  school?: Maybe<Schools_Order_By>;
  schoolId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  subscribe?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  userByCreatedby?: Maybe<Users_Order_By>;
  users_aggregate?: Maybe<Users_Aggregate_Order_By>;
  willPayLater?: Maybe<Order_By>;
};

/** primary key columns input for table: "student_profiles" */
export type Student_Profiles_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Student_Profiles_Prepend_Input = {
  billing?: Maybe<Scalars['jsonb']>;
  emergencyContact?: Maybe<Scalars['jsonb']>;
  firstParent?: Maybe<Scalars['jsonb']>;
  mailling?: Maybe<Scalars['jsonb']>;
  notes?: Maybe<Scalars['jsonb']>;
  parents?: Maybe<Scalars['jsonb']>;
  payment?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "student_profiles" */
export enum Student_Profiles_Select_Column {
  /** column name */
  Billing = 'billing',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CurrentStep = 'currentStep',
  /** column name */
  CurriculumId = 'curriculumId',
  /** column name */
  EmergencyContact = 'emergencyContact',
  /** column name */
  FirstParent = 'firstParent',
  /** column name */
  Id = 'id',
  /** column name */
  LevelId = 'levelId',
  /** column name */
  Mailling = 'mailling',
  /** column name */
  Notes = 'notes',
  /** column name */
  Parents = 'parents',
  /** column name */
  PayLaterReason = 'payLaterReason',
  /** column name */
  PayOnline = 'payOnline',
  /** column name */
  Payment = 'payment',
  /** column name */
  PaymentStatus = 'paymentStatus',
  /** column name */
  SchoolId = 'schoolId',
  /** column name */
  Status = 'status',
  /** column name */
  Subscribe = 'subscribe',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  WillPayLater = 'willPayLater'
}

/** input type for updating data in table "student_profiles" */
export type Student_Profiles_Set_Input = {
  billing?: Maybe<Scalars['jsonb']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  currentStep?: Maybe<Scalars['String']>;
  curriculumId?: Maybe<Scalars['uuid']>;
  emergencyContact?: Maybe<Scalars['jsonb']>;
  firstParent?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  levelId?: Maybe<Scalars['uuid']>;
  mailling?: Maybe<Scalars['jsonb']>;
  notes?: Maybe<Scalars['jsonb']>;
  parents?: Maybe<Scalars['jsonb']>;
  payLaterReason?: Maybe<Scalars['String']>;
  payOnline?: Maybe<Scalars['Boolean']>;
  payment?: Maybe<Scalars['jsonb']>;
  paymentStatus?: Maybe<Scalars['Boolean']>;
  schoolId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  subscribe?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  willPayLater?: Maybe<Scalars['Boolean']>;
};

/** update columns of table "student_profiles" */
export enum Student_Profiles_Update_Column {
  /** column name */
  Billing = 'billing',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  CurrentStep = 'currentStep',
  /** column name */
  CurriculumId = 'curriculumId',
  /** column name */
  EmergencyContact = 'emergencyContact',
  /** column name */
  FirstParent = 'firstParent',
  /** column name */
  Id = 'id',
  /** column name */
  LevelId = 'levelId',
  /** column name */
  Mailling = 'mailling',
  /** column name */
  Notes = 'notes',
  /** column name */
  Parents = 'parents',
  /** column name */
  PayLaterReason = 'payLaterReason',
  /** column name */
  PayOnline = 'payOnline',
  /** column name */
  Payment = 'payment',
  /** column name */
  PaymentStatus = 'paymentStatus',
  /** column name */
  SchoolId = 'schoolId',
  /** column name */
  Status = 'status',
  /** column name */
  Subscribe = 'subscribe',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  WillPayLater = 'willPayLater'
}

export type Students_Filter_Args = {
  payment_status?: Maybe<Scalars['String']>;
  status_student_follow_class?: Maybe<Scalars['String']>;
};

export type Students_List_Filter_Args = {
  payment_status?: Maybe<Scalars['String']>;
  student_status?: Maybe<Scalars['String']>;
};

export type Students_List_Filter_Payment_Args = {
  payment_status?: Maybe<Scalars['String']>;
};

export type Students_Programs_Filter_Args = {
  academic_year?: Maybe<Scalars['String']>;
  student_id?: Maybe<Scalars['uuid']>;
};

/** columns and relationships of "subjects" */
export type Subjects = {
  __typename?: 'subjects';
  abbreviation: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  programs: Array<Programs>;
  /** An aggregated array relationship */
  programs_aggregate: Programs_Aggregate;
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "subjects" */
export type SubjectsProgramsArgs = {
  distinct_on?: Maybe<Array<Programs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Programs_Order_By>>;
  where?: Maybe<Programs_Bool_Exp>;
};


/** columns and relationships of "subjects" */
export type SubjectsPrograms_AggregateArgs = {
  distinct_on?: Maybe<Array<Programs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Programs_Order_By>>;
  where?: Maybe<Programs_Bool_Exp>;
};

/** aggregated selection of "subjects" */
export type Subjects_Aggregate = {
  __typename?: 'subjects_aggregate';
  aggregate?: Maybe<Subjects_Aggregate_Fields>;
  nodes: Array<Subjects>;
};

/** aggregate fields of "subjects" */
export type Subjects_Aggregate_Fields = {
  __typename?: 'subjects_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Subjects_Max_Fields>;
  min?: Maybe<Subjects_Min_Fields>;
};


/** aggregate fields of "subjects" */
export type Subjects_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Subjects_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "subjects" */
export type Subjects_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Subjects_Max_Order_By>;
  min?: Maybe<Subjects_Min_Order_By>;
};

/** input type for inserting array relation for remote table "subjects" */
export type Subjects_Arr_Rel_Insert_Input = {
  data: Array<Subjects_Insert_Input>;
  on_conflict?: Maybe<Subjects_On_Conflict>;
};

/** Boolean expression to filter rows from the table "subjects". All fields are combined with a logical 'AND'. */
export type Subjects_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Subjects_Bool_Exp>>>;
  _not?: Maybe<Subjects_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Subjects_Bool_Exp>>>;
  abbreviation?: Maybe<String_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  programs?: Maybe<Programs_Bool_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "subjects" */
export enum Subjects_Constraint {
  /** unique or primary key constraint */
  SubjectsPkey = 'subjects_pkey'
}

/** input type for inserting data into table "subjects" */
export type Subjects_Insert_Input = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  programs?: Maybe<Programs_Arr_Rel_Insert_Input>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Subjects_Max_Fields = {
  __typename?: 'subjects_max_fields';
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "subjects" */
export type Subjects_Max_Order_By = {
  abbreviation?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Subjects_Min_Fields = {
  __typename?: 'subjects_min_fields';
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "subjects" */
export type Subjects_Min_Order_By = {
  abbreviation?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "subjects" */
export type Subjects_Mutation_Response = {
  __typename?: 'subjects_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Subjects>;
};

/** input type for inserting object relation for remote table "subjects" */
export type Subjects_Obj_Rel_Insert_Input = {
  data: Subjects_Insert_Input;
  on_conflict?: Maybe<Subjects_On_Conflict>;
};

/** on conflict condition type for table "subjects" */
export type Subjects_On_Conflict = {
  constraint: Subjects_Constraint;
  update_columns: Array<Subjects_Update_Column>;
  where?: Maybe<Subjects_Bool_Exp>;
};

/** ordering options when selecting data from "subjects" */
export type Subjects_Order_By = {
  abbreviation?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  programs_aggregate?: Maybe<Programs_Aggregate_Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "subjects" */
export type Subjects_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "subjects" */
export enum Subjects_Select_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "subjects" */
export type Subjects_Set_Input = {
  abbreviation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "subjects" */
export enum Subjects_Update_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** subscription root */
export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "academic_calendars" */
  academic_calendars: Array<Academic_Calendars>;
  /** fetch aggregated fields from the table: "academic_calendars" */
  academic_calendars_aggregate: Academic_Calendars_Aggregate;
  /** fetch data from the table: "academic_calendars" using primary key columns */
  academic_calendars_by_pk?: Maybe<Academic_Calendars>;
  /** fetch data from the table: "additional_class_tickets" */
  additional_class_tickets: Array<Additional_Class_Tickets>;
  /** fetch aggregated fields from the table: "additional_class_tickets" */
  additional_class_tickets_aggregate: Additional_Class_Tickets_Aggregate;
  /** fetch data from the table: "additional_class_tickets" using primary key columns */
  additional_class_tickets_by_pk?: Maybe<Additional_Class_Tickets>;
  /** fetch data from the table: "backup_attendance_logs" */
  backup_attendance_logs: Array<Backup_Attendance_Logs>;
  /** fetch aggregated fields from the table: "backup_attendance_logs" */
  backup_attendance_logs_aggregate: Backup_Attendance_Logs_Aggregate;
  /** fetch data from the table: "backup_attendance_logs" using primary key columns */
  backup_attendance_logs_by_pk?: Maybe<Backup_Attendance_Logs>;
  /** fetch data from the table: "banks" */
  banks: Array<Banks>;
  /** fetch aggregated fields from the table: "banks" */
  banks_aggregate: Banks_Aggregate;
  /** fetch data from the table: "banks" using primary key columns */
  banks_by_pk?: Maybe<Banks>;
  /** fetch data from the table: "batch_payment_advices" */
  batch_payment_advices: Array<Batch_Payment_Advices>;
  /** fetch aggregated fields from the table: "batch_payment_advices" */
  batch_payment_advices_aggregate: Batch_Payment_Advices_Aggregate;
  /** fetch data from the table: "batch_payment_advices" using primary key columns */
  batch_payment_advices_by_pk?: Maybe<Batch_Payment_Advices>;
  /** fetch data from the table: "branches" */
  branches: Array<Branches>;
  /** fetch aggregated fields from the table: "branches" */
  branches_aggregate: Branches_Aggregate;
  /** fetch data from the table: "branches" using primary key columns */
  branches_by_pk?: Maybe<Branches>;
  /** fetch data from the table: "broadcast_logs" */
  broadcast_logs: Array<Broadcast_Logs>;
  /** fetch aggregated fields from the table: "broadcast_logs" */
  broadcast_logs_aggregate: Broadcast_Logs_Aggregate;
  /** fetch data from the table: "broadcast_logs" using primary key columns */
  broadcast_logs_by_pk?: Maybe<Broadcast_Logs>;
  /** fetch data from the table: "broadcasts" */
  broadcasts: Array<Broadcasts>;
  /** fetch aggregated fields from the table: "broadcasts" */
  broadcasts_aggregate: Broadcasts_Aggregate;
  /** fetch data from the table: "broadcasts" using primary key columns */
  broadcasts_by_pk?: Maybe<Broadcasts>;
  /** execute function "class_filter_by_filling_status" which returns "classes" */
  class_filter_by_filling_status: Array<Classes>;
  /** execute function "class_filter_by_filling_status" and query aggregates on result of table type "classes" */
  class_filter_by_filling_status_aggregate: Classes_Aggregate;
  /** execute function "class_filter_by_student" which returns "classes" */
  class_filter_by_student: Array<Classes>;
  /** execute function "class_filter_by_student" and query aggregates on result of table type "classes" */
  class_filter_by_student_aggregate: Classes_Aggregate;
  /** fetch data from the table: "class_students_waiting" */
  class_students_waiting: Array<Class_Students_Waiting>;
  /** fetch aggregated fields from the table: "class_students_waiting" */
  class_students_waiting_aggregate: Class_Students_Waiting_Aggregate;
  /** fetch data from the table: "class_students_waiting" using primary key columns */
  class_students_waiting_by_pk?: Maybe<Class_Students_Waiting>;
  /** fetch data from the table: "classes" */
  classes: Array<Classes>;
  /** fetch aggregated fields from the table: "classes" */
  classes_aggregate: Classes_Aggregate;
  /** fetch data from the table: "classes" using primary key columns */
  classes_by_pk?: Maybe<Classes>;
  /** fetch data from the table: "classrooms" */
  classrooms: Array<Classrooms>;
  /** fetch aggregated fields from the table: "classrooms" */
  classrooms_aggregate: Classrooms_Aggregate;
  /** fetch data from the table: "classrooms" using primary key columns */
  classrooms_by_pk?: Maybe<Classrooms>;
  /** fetch data from the table: "credit_note_classes" */
  credit_note_classes: Array<Credit_Note_Classes>;
  /** fetch aggregated fields from the table: "credit_note_classes" */
  credit_note_classes_aggregate: Credit_Note_Classes_Aggregate;
  /** fetch data from the table: "credit_note_classes" using primary key columns */
  credit_note_classes_by_pk?: Maybe<Credit_Note_Classes>;
  /** fetch data from the table: "credit_note_fees" */
  credit_note_fees: Array<Credit_Note_Fees>;
  /** fetch aggregated fields from the table: "credit_note_fees" */
  credit_note_fees_aggregate: Credit_Note_Fees_Aggregate;
  /** fetch data from the table: "credit_note_fees" using primary key columns */
  credit_note_fees_by_pk?: Maybe<Credit_Note_Fees>;
  /** execute function "credit_note_filter" which returns "credit_notes" */
  credit_note_filter: Array<Credit_Notes>;
  /** execute function "credit_note_filter" and query aggregates on result of table type "credit_notes" */
  credit_note_filter_aggregate: Credit_Notes_Aggregate;
  /** fetch data from the table: "credit_note_logs" */
  credit_note_logs: Array<Credit_Note_Logs>;
  /** fetch aggregated fields from the table: "credit_note_logs" */
  credit_note_logs_aggregate: Credit_Note_Logs_Aggregate;
  /** fetch data from the table: "credit_note_logs" using primary key columns */
  credit_note_logs_by_pk?: Maybe<Credit_Note_Logs>;
  /** fetch data from the table: "credit_notes" */
  credit_notes: Array<Credit_Notes>;
  /** fetch aggregated fields from the table: "credit_notes" */
  credit_notes_aggregate: Credit_Notes_Aggregate;
  /** fetch data from the table: "credit_notes" using primary key columns */
  credit_notes_by_pk?: Maybe<Credit_Notes>;
  /** fetch data from the table: "curriculums" */
  curriculums: Array<Curriculums>;
  /** fetch aggregated fields from the table: "curriculums" */
  curriculums_aggregate: Curriculums_Aggregate;
  /** fetch data from the table: "curriculums" using primary key columns */
  curriculums_by_pk?: Maybe<Curriculums>;
  /** fetch data from the table: "curriculums_levels" */
  curriculums_levels: Array<Curriculums_Levels>;
  /** fetch aggregated fields from the table: "curriculums_levels" */
  curriculums_levels_aggregate: Curriculums_Levels_Aggregate;
  /** fetch data from the table: "curriculums_levels" using primary key columns */
  curriculums_levels_by_pk?: Maybe<Curriculums_Levels>;
  /** fetch data from the table: "deposits" */
  deposits: Array<Deposits>;
  /** fetch aggregated fields from the table: "deposits" */
  deposits_aggregate: Deposits_Aggregate;
  /** fetch data from the table: "deposits" using primary key columns */
  deposits_by_pk?: Maybe<Deposits>;
  /** fetch data from the table: "discount_bills" */
  discount_bills: Array<Discount_Bills>;
  /** fetch aggregated fields from the table: "discount_bills" */
  discount_bills_aggregate: Discount_Bills_Aggregate;
  /** fetch data from the table: "discount_bills" using primary key columns */
  discount_bills_by_pk?: Maybe<Discount_Bills>;
  /** fetch data from the table: "discount_students" */
  discount_students: Array<Discount_Students>;
  /** fetch aggregated fields from the table: "discount_students" */
  discount_students_aggregate: Discount_Students_Aggregate;
  /** fetch data from the table: "discount_students" using primary key columns */
  discount_students_by_pk?: Maybe<Discount_Students>;
  /** fetch data from the table: "discounts" */
  discounts: Array<Discounts>;
  /** fetch aggregated fields from the table: "discounts" */
  discounts_aggregate: Discounts_Aggregate;
  /** fetch data from the table: "discounts" using primary key columns */
  discounts_by_pk?: Maybe<Discounts>;
  /** fetch data from the table: "double_lesson_academic_pricings" */
  double_lesson_academic_pricings: Array<Double_Lesson_Academic_Pricings>;
  /** fetch aggregated fields from the table: "double_lesson_academic_pricings" */
  double_lesson_academic_pricings_aggregate: Double_Lesson_Academic_Pricings_Aggregate;
  /** fetch data from the table: "double_lesson_academic_pricings" using primary key columns */
  double_lesson_academic_pricings_by_pk?: Maybe<Double_Lesson_Academic_Pricings>;
  /** fetch data from the table: "double_lesson_program_types" */
  double_lesson_program_types: Array<Double_Lesson_Program_Types>;
  /** fetch aggregated fields from the table: "double_lesson_program_types" */
  double_lesson_program_types_aggregate: Double_Lesson_Program_Types_Aggregate;
  /** fetch data from the table: "double_lesson_program_types" using primary key columns */
  double_lesson_program_types_by_pk?: Maybe<Double_Lesson_Program_Types>;
  /** fetch data from the table: "double_lesson_programme_pricings" */
  double_lesson_programme_pricings: Array<Double_Lesson_Programme_Pricings>;
  /** fetch aggregated fields from the table: "double_lesson_programme_pricings" */
  double_lesson_programme_pricings_aggregate: Double_Lesson_Programme_Pricings_Aggregate;
  /** fetch data from the table: "double_lesson_programme_pricings" using primary key columns */
  double_lesson_programme_pricings_by_pk?: Maybe<Double_Lesson_Programme_Pricings>;
  /** fetch data from the table: "email_student_logs" */
  email_student_logs: Array<Email_Student_Logs>;
  /** fetch aggregated fields from the table: "email_student_logs" */
  email_student_logs_aggregate: Email_Student_Logs_Aggregate;
  /** fetch data from the table: "email_student_logs" using primary key columns */
  email_student_logs_by_pk?: Maybe<Email_Student_Logs>;
  /** fetch data from the table: "enrollment_list_new" */
  enrollment_list_new: Array<Enrollment_List_New>;
  /** fetch aggregated fields from the table: "enrollment_list_new" */
  enrollment_list_new_aggregate: Enrollment_List_New_Aggregate;
  /** fetch data from the table: "enrollment_list_new" using primary key columns */
  enrollment_list_new_by_pk?: Maybe<Enrollment_List_New>;
  /** fetch data from the table: "general_program_types" */
  general_program_types: Array<General_Program_Types>;
  /** fetch aggregated fields from the table: "general_program_types" */
  general_program_types_aggregate: General_Program_Types_Aggregate;
  /** fetch data from the table: "general_program_types" using primary key columns */
  general_program_types_by_pk?: Maybe<General_Program_Types>;
  /** fetch data from the table: "get_profile" */
  get_profile: Array<Get_Profile>;
  /** fetch aggregated fields from the table: "get_profile" */
  get_profile_aggregate: Get_Profile_Aggregate;
  /** execute function "invoice_filter" which returns "invoices" */
  invoice_filter: Array<Invoices>;
  /** execute function "invoice_filter" and query aggregates on result of table type "invoices" */
  invoice_filter_aggregate: Invoices_Aggregate;
  /** fetch data from the table: "invoice_partial_payments" */
  invoice_partial_payments: Array<Invoice_Partial_Payments>;
  /** fetch aggregated fields from the table: "invoice_partial_payments" */
  invoice_partial_payments_aggregate: Invoice_Partial_Payments_Aggregate;
  /** fetch data from the table: "invoice_partial_payments" using primary key columns */
  invoice_partial_payments_by_pk?: Maybe<Invoice_Partial_Payments>;
  /** fetch data from the table: "invoices" */
  invoices: Array<Invoices>;
  /** fetch aggregated fields from the table: "invoices" */
  invoices_aggregate: Invoices_Aggregate;
  /** fetch data from the table: "invoices" using primary key columns */
  invoices_by_pk?: Maybe<Invoices>;
  /** fetch data from the table: "lessons" */
  lessons: Array<Lessons>;
  /** fetch aggregated fields from the table: "lessons" */
  lessons_aggregate: Lessons_Aggregate;
  /** fetch data from the table: "lessons" using primary key columns */
  lessons_by_pk?: Maybe<Lessons>;
  /** fetch data from the table: "lessons_students" */
  lessons_students: Array<Lessons_Students>;
  /** fetch aggregated fields from the table: "lessons_students" */
  lessons_students_aggregate: Lessons_Students_Aggregate;
  /** fetch data from the table: "lessons_students" using primary key columns */
  lessons_students_by_pk?: Maybe<Lessons_Students>;
  /** fetch data from the table: "levels" */
  levels: Array<Levels>;
  /** fetch aggregated fields from the table: "levels" */
  levels_aggregate: Levels_Aggregate;
  /** fetch data from the table: "levels" using primary key columns */
  levels_by_pk?: Maybe<Levels>;
  /** fetch data from the table: "news" */
  news: Array<News>;
  /** fetch aggregated fields from the table: "news" */
  news_aggregate: News_Aggregate;
  /** fetch data from the table: "news" using primary key columns */
  news_by_pk?: Maybe<News>;
  /** fetch data from the table: "news_logs" */
  news_logs: Array<News_Logs>;
  /** fetch aggregated fields from the table: "news_logs" */
  news_logs_aggregate: News_Logs_Aggregate;
  /** fetch data from the table: "news_logs" using primary key columns */
  news_logs_by_pk?: Maybe<News_Logs>;
  /** fetch data from the table: "news_recipients_upload" */
  news_recipients_upload: Array<News_Recipients_Upload>;
  /** fetch aggregated fields from the table: "news_recipients_upload" */
  news_recipients_upload_aggregate: News_Recipients_Upload_Aggregate;
  /** fetch data from the table: "news_recipients_upload" using primary key columns */
  news_recipients_upload_by_pk?: Maybe<News_Recipients_Upload>;
  /** fetch data from the table: "pass_door_logs" */
  pass_door_logs: Array<Pass_Door_Logs>;
  /** fetch aggregated fields from the table: "pass_door_logs" */
  pass_door_logs_aggregate: Pass_Door_Logs_Aggregate;
  /** fetch data from the table: "pass_door_logs" using primary key columns */
  pass_door_logs_by_pk?: Maybe<Pass_Door_Logs>;
  /** fetch data from the table: "payment_advice_class_transfer" */
  payment_advice_class_transfer: Array<Payment_Advice_Class_Transfer>;
  /** fetch aggregated fields from the table: "payment_advice_class_transfer" */
  payment_advice_class_transfer_aggregate: Payment_Advice_Class_Transfer_Aggregate;
  /** fetch data from the table: "payment_advice_class_transfer" using primary key columns */
  payment_advice_class_transfer_by_pk?: Maybe<Payment_Advice_Class_Transfer>;
  /** fetch data from the table: "payment_advice_classes" */
  payment_advice_classes: Array<Payment_Advice_Classes>;
  /** fetch aggregated fields from the table: "payment_advice_classes" */
  payment_advice_classes_aggregate: Payment_Advice_Classes_Aggregate;
  /** fetch data from the table: "payment_advice_classes" using primary key columns */
  payment_advice_classes_by_pk?: Maybe<Payment_Advice_Classes>;
  /** execute function "payment_advice_classes_by_student_id" which returns "classes" */
  payment_advice_classes_by_student_id: Array<Classes>;
  /** execute function "payment_advice_classes_by_student_id" and query aggregates on result of table type "classes" */
  payment_advice_classes_by_student_id_aggregate: Classes_Aggregate;
  /** fetch data from the table: "payment_advice_delete_logs" */
  payment_advice_delete_logs: Array<Payment_Advice_Delete_Logs>;
  /** fetch aggregated fields from the table: "payment_advice_delete_logs" */
  payment_advice_delete_logs_aggregate: Payment_Advice_Delete_Logs_Aggregate;
  /** fetch data from the table: "payment_advice_delete_logs" using primary key columns */
  payment_advice_delete_logs_by_pk?: Maybe<Payment_Advice_Delete_Logs>;
  /** execute function "payment_advice_filter" which returns "payment_advices" */
  payment_advice_filter: Array<Payment_Advices>;
  /** execute function "payment_advice_filter" and query aggregates on result of table type "payment_advices" */
  payment_advice_filter_aggregate: Payment_Advices_Aggregate;
  /** fetch data from the table: "payment_advice_logs" */
  payment_advice_logs: Array<Payment_Advice_Logs>;
  /** fetch aggregated fields from the table: "payment_advice_logs" */
  payment_advice_logs_aggregate: Payment_Advice_Logs_Aggregate;
  /** fetch data from the table: "payment_advice_logs" using primary key columns */
  payment_advice_logs_by_pk?: Maybe<Payment_Advice_Logs>;
  /** fetch data from the table: "payment_advice_term_classes" */
  payment_advice_term_classes: Array<Payment_Advice_Term_Classes>;
  /** fetch aggregated fields from the table: "payment_advice_term_classes" */
  payment_advice_term_classes_aggregate: Payment_Advice_Term_Classes_Aggregate;
  /** fetch data from the table: "payment_advice_term_classes" using primary key columns */
  payment_advice_term_classes_by_pk?: Maybe<Payment_Advice_Term_Classes>;
  /** fetch data from the table: "payment_advice_transfers" */
  payment_advice_transfers: Array<Payment_Advice_Transfers>;
  /** fetch aggregated fields from the table: "payment_advice_transfers" */
  payment_advice_transfers_aggregate: Payment_Advice_Transfers_Aggregate;
  /** fetch data from the table: "payment_advice_transfers" using primary key columns */
  payment_advice_transfers_by_pk?: Maybe<Payment_Advice_Transfers>;
  /** fetch data from the table: "payment_advices" */
  payment_advices: Array<Payment_Advices>;
  /** fetch aggregated fields from the table: "payment_advices" */
  payment_advices_aggregate: Payment_Advices_Aggregate;
  /** fetch data from the table: "payment_advices" using primary key columns */
  payment_advices_by_pk?: Maybe<Payment_Advices>;
  /** fetch data from the table: "programs" */
  programs: Array<Programs>;
  /** fetch aggregated fields from the table: "programs" */
  programs_aggregate: Programs_Aggregate;
  /** fetch data from the table: "programs" using primary key columns */
  programs_by_pk?: Maybe<Programs>;
  /** execute function "receipt_filter" which returns "receipts" */
  receipt_filter: Array<Receipts>;
  /** execute function "receipt_filter" and query aggregates on result of table type "receipts" */
  receipt_filter_aggregate: Receipts_Aggregate;
  /** execute function "receipt_filter_by_class" which returns "receipts" */
  receipt_filter_by_class: Array<Receipts>;
  /** execute function "receipt_filter_by_class" and query aggregates on result of table type "receipts" */
  receipt_filter_by_class_aggregate: Receipts_Aggregate;
  /** fetch data from the table: "receipts" */
  receipts: Array<Receipts>;
  /** fetch aggregated fields from the table: "receipts" */
  receipts_aggregate: Receipts_Aggregate;
  /** fetch data from the table: "receipts" using primary key columns */
  receipts_by_pk?: Maybe<Receipts>;
  /** fetch data from the table: "refund_classes" */
  refund_classes: Array<Refund_Classes>;
  /** fetch aggregated fields from the table: "refund_classes" */
  refund_classes_aggregate: Refund_Classes_Aggregate;
  /** fetch data from the table: "refund_classes" using primary key columns */
  refund_classes_by_pk?: Maybe<Refund_Classes>;
  /** execute function "refund_filter" which returns "refunds" */
  refund_filter: Array<Refunds>;
  /** execute function "refund_filter" and query aggregates on result of table type "refunds" */
  refund_filter_aggregate: Refunds_Aggregate;
  /** fetch data from the table: "refund_logs" */
  refund_logs: Array<Refund_Logs>;
  /** fetch aggregated fields from the table: "refund_logs" */
  refund_logs_aggregate: Refund_Logs_Aggregate;
  /** fetch data from the table: "refund_logs" using primary key columns */
  refund_logs_by_pk?: Maybe<Refund_Logs>;
  /** fetch data from the table: "refunds" */
  refunds: Array<Refunds>;
  /** fetch aggregated fields from the table: "refunds" */
  refunds_aggregate: Refunds_Aggregate;
  /** fetch data from the table: "refunds" using primary key columns */
  refunds_by_pk?: Maybe<Refunds>;
  /** fetch data from the table: "regular_academic_pricings" */
  regular_academic_pricings: Array<Regular_Academic_Pricings>;
  /** fetch aggregated fields from the table: "regular_academic_pricings" */
  regular_academic_pricings_aggregate: Regular_Academic_Pricings_Aggregate;
  /** fetch data from the table: "regular_academic_pricings" using primary key columns */
  regular_academic_pricings_by_pk?: Maybe<Regular_Academic_Pricings>;
  /** fetch data from the table: "regular_program_types" */
  regular_program_types: Array<Regular_Program_Types>;
  /** fetch aggregated fields from the table: "regular_program_types" */
  regular_program_types_aggregate: Regular_Program_Types_Aggregate;
  /** fetch data from the table: "regular_program_types" using primary key columns */
  regular_program_types_by_pk?: Maybe<Regular_Program_Types>;
  /** fetch data from the table: "regular_programme_pricings" */
  regular_programme_pricings: Array<Regular_Programme_Pricings>;
  /** fetch aggregated fields from the table: "regular_programme_pricings" */
  regular_programme_pricings_aggregate: Regular_Programme_Pricings_Aggregate;
  /** fetch data from the table: "regular_programme_pricings" using primary key columns */
  regular_programme_pricings_by_pk?: Maybe<Regular_Programme_Pricings>;
  /** fetch data from the table: "report_subject_budget" */
  report_subject_budget: Array<Report_Subject_Budget>;
  /** fetch aggregated fields from the table: "report_subject_budget" */
  report_subject_budget_aggregate: Report_Subject_Budget_Aggregate;
  /** fetch data from the table: "report_subject_budget" using primary key columns */
  report_subject_budget_by_pk?: Maybe<Report_Subject_Budget>;
  /** fetch data from the table: "request_transfer_classes" */
  request_transfer_classes: Array<Request_Transfer_Classes>;
  /** fetch aggregated fields from the table: "request_transfer_classes" */
  request_transfer_classes_aggregate: Request_Transfer_Classes_Aggregate;
  /** fetch data from the table: "request_transfer_classes" using primary key columns */
  request_transfer_classes_by_pk?: Maybe<Request_Transfer_Classes>;
  /** fetch data from the table: "roles" */
  roles: Array<Roles>;
  /** fetch aggregated fields from the table: "roles" */
  roles_aggregate: Roles_Aggregate;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: Maybe<Roles>;
  /** fetch data from the table: "schools" */
  schools: Array<Schools>;
  /** fetch aggregated fields from the table: "schools" */
  schools_aggregate: Schools_Aggregate;
  /** fetch data from the table: "schools" using primary key columns */
  schools_by_pk?: Maybe<Schools>;
  /** retrieve the result of action: "sentBroadcast" */
  sentBroadcast?: Maybe<SentBroadcast>;
  /** retrieve the result of action: "sentNews" */
  sentNews?: Maybe<SentNews>;
  /** fetch data from the table: "sessions" */
  sessions: Array<Sessions>;
  /** fetch aggregated fields from the table: "sessions" */
  sessions_aggregate: Sessions_Aggregate;
  /** fetch data from the table: "sessions" using primary key columns */
  sessions_by_pk?: Maybe<Sessions>;
  /** fetch data from the table: "special_programme_class_pricings" */
  special_programme_class_pricings: Array<Special_Programme_Class_Pricings>;
  /** fetch aggregated fields from the table: "special_programme_class_pricings" */
  special_programme_class_pricings_aggregate: Special_Programme_Class_Pricings_Aggregate;
  /** fetch data from the table: "special_programme_class_pricings" using primary key columns */
  special_programme_class_pricings_by_pk?: Maybe<Special_Programme_Class_Pricings>;
  /** fetch data from the table: "specical_program_types" */
  specical_program_types: Array<Specical_Program_Types>;
  /** fetch aggregated fields from the table: "specical_program_types" */
  specical_program_types_aggregate: Specical_Program_Types_Aggregate;
  /** fetch data from the table: "specical_program_types" using primary key columns */
  specical_program_types_by_pk?: Maybe<Specical_Program_Types>;
  /** fetch data from the table: "student_profiles" */
  student_profiles: Array<Student_Profiles>;
  /** fetch aggregated fields from the table: "student_profiles" */
  student_profiles_aggregate: Student_Profiles_Aggregate;
  /** fetch data from the table: "student_profiles" using primary key columns */
  student_profiles_by_pk?: Maybe<Student_Profiles>;
  /** execute function "students_filter" which returns "users" */
  students_filter: Array<Users>;
  /** execute function "students_filter" and query aggregates on result of table type "users" */
  students_filter_aggregate: Users_Aggregate;
  /** execute function "students_list_filter" which returns "users" */
  students_list_filter: Array<Users>;
  /** execute function "students_list_filter" and query aggregates on result of table type "users" */
  students_list_filter_aggregate: Users_Aggregate;
  /** execute function "students_list_filter_payment" which returns "users" */
  students_list_filter_payment: Array<Users>;
  /** execute function "students_list_filter_payment" and query aggregates on result of table type "users" */
  students_list_filter_payment_aggregate: Users_Aggregate;
  /** execute function "students_programs_filter" which returns "programs" */
  students_programs_filter: Array<Programs>;
  /** execute function "students_programs_filter" and query aggregates on result of table type "programs" */
  students_programs_filter_aggregate: Programs_Aggregate;
  /** fetch data from the table: "subjects" */
  subjects: Array<Subjects>;
  /** fetch aggregated fields from the table: "subjects" */
  subjects_aggregate: Subjects_Aggregate;
  /** fetch data from the table: "subjects" using primary key columns */
  subjects_by_pk?: Maybe<Subjects>;
  /** fetch data from the table: "system_settings" */
  system_settings: Array<System_Settings>;
  /** fetch aggregated fields from the table: "system_settings" */
  system_settings_aggregate: System_Settings_Aggregate;
  /** fetch data from the table: "system_settings" using primary key columns */
  system_settings_by_pk?: Maybe<System_Settings>;
  /** fetch data from the table: "term_classes" */
  term_classes: Array<Term_Classes>;
  /** fetch aggregated fields from the table: "term_classes" */
  term_classes_aggregate: Term_Classes_Aggregate;
  /** fetch data from the table: "term_classes" using primary key columns */
  term_classes_by_pk?: Maybe<Term_Classes>;
  /** fetch data from the table: "terms" */
  terms: Array<Terms>;
  /** fetch aggregated fields from the table: "terms" */
  terms_aggregate: Terms_Aggregate;
  /** fetch data from the table: "terms" using primary key columns */
  terms_by_pk?: Maybe<Terms>;
  /** fetch data from the table: "three_times_absents" */
  three_times_absents: Array<Three_Times_Absents>;
  /** fetch aggregated fields from the table: "three_times_absents" */
  three_times_absents_aggregate: Three_Times_Absents_Aggregate;
  /** fetch data from the table: "three_times_absents" using primary key columns */
  three_times_absents_by_pk?: Maybe<Three_Times_Absents>;
  /** fetch data from the table: "transaction_logs" */
  transaction_logs: Array<Transaction_Logs>;
  /** fetch aggregated fields from the table: "transaction_logs" */
  transaction_logs_aggregate: Transaction_Logs_Aggregate;
  /** fetch data from the table: "transaction_logs" using primary key columns */
  transaction_logs_by_pk?: Maybe<Transaction_Logs>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table: "vms_person_groups" */
  vms_person_groups: Array<Vms_Person_Groups>;
  /** fetch aggregated fields from the table: "vms_person_groups" */
  vms_person_groups_aggregate: Vms_Person_Groups_Aggregate;
  /** fetch data from the table: "vms_person_groups" using primary key columns */
  vms_person_groups_by_pk?: Maybe<Vms_Person_Groups>;
};


/** subscription root */
export type Subscription_RootAcademic_CalendarsArgs = {
  distinct_on?: Maybe<Array<Academic_Calendars_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Academic_Calendars_Order_By>>;
  where?: Maybe<Academic_Calendars_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAcademic_Calendars_AggregateArgs = {
  distinct_on?: Maybe<Array<Academic_Calendars_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Academic_Calendars_Order_By>>;
  where?: Maybe<Academic_Calendars_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAcademic_Calendars_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootAdditional_Class_TicketsArgs = {
  distinct_on?: Maybe<Array<Additional_Class_Tickets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Additional_Class_Tickets_Order_By>>;
  where?: Maybe<Additional_Class_Tickets_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAdditional_Class_Tickets_AggregateArgs = {
  distinct_on?: Maybe<Array<Additional_Class_Tickets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Additional_Class_Tickets_Order_By>>;
  where?: Maybe<Additional_Class_Tickets_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAdditional_Class_Tickets_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootBackup_Attendance_LogsArgs = {
  distinct_on?: Maybe<Array<Backup_Attendance_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Backup_Attendance_Logs_Order_By>>;
  where?: Maybe<Backup_Attendance_Logs_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBackup_Attendance_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Backup_Attendance_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Backup_Attendance_Logs_Order_By>>;
  where?: Maybe<Backup_Attendance_Logs_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBackup_Attendance_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootBanksArgs = {
  distinct_on?: Maybe<Array<Banks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Banks_Order_By>>;
  where?: Maybe<Banks_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBanks_AggregateArgs = {
  distinct_on?: Maybe<Array<Banks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Banks_Order_By>>;
  where?: Maybe<Banks_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBanks_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootBatch_Payment_AdvicesArgs = {
  distinct_on?: Maybe<Array<Batch_Payment_Advices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Batch_Payment_Advices_Order_By>>;
  where?: Maybe<Batch_Payment_Advices_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBatch_Payment_Advices_AggregateArgs = {
  distinct_on?: Maybe<Array<Batch_Payment_Advices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Batch_Payment_Advices_Order_By>>;
  where?: Maybe<Batch_Payment_Advices_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBatch_Payment_Advices_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootBranchesArgs = {
  distinct_on?: Maybe<Array<Branches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Branches_Order_By>>;
  where?: Maybe<Branches_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBranches_AggregateArgs = {
  distinct_on?: Maybe<Array<Branches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Branches_Order_By>>;
  where?: Maybe<Branches_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBranches_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootBroadcast_LogsArgs = {
  distinct_on?: Maybe<Array<Broadcast_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Broadcast_Logs_Order_By>>;
  where?: Maybe<Broadcast_Logs_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBroadcast_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Broadcast_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Broadcast_Logs_Order_By>>;
  where?: Maybe<Broadcast_Logs_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBroadcast_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootBroadcastsArgs = {
  distinct_on?: Maybe<Array<Broadcasts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Broadcasts_Order_By>>;
  where?: Maybe<Broadcasts_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBroadcasts_AggregateArgs = {
  distinct_on?: Maybe<Array<Broadcasts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Broadcasts_Order_By>>;
  where?: Maybe<Broadcasts_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBroadcasts_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootClass_Filter_By_Filling_StatusArgs = {
  args: Class_Filter_By_Filling_Status_Args;
  distinct_on?: Maybe<Array<Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classes_Order_By>>;
  where?: Maybe<Classes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootClass_Filter_By_Filling_Status_AggregateArgs = {
  args: Class_Filter_By_Filling_Status_Args;
  distinct_on?: Maybe<Array<Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classes_Order_By>>;
  where?: Maybe<Classes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootClass_Filter_By_StudentArgs = {
  args: Class_Filter_By_Student_Args;
  distinct_on?: Maybe<Array<Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classes_Order_By>>;
  where?: Maybe<Classes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootClass_Filter_By_Student_AggregateArgs = {
  args: Class_Filter_By_Student_Args;
  distinct_on?: Maybe<Array<Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classes_Order_By>>;
  where?: Maybe<Classes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootClass_Students_WaitingArgs = {
  distinct_on?: Maybe<Array<Class_Students_Waiting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Class_Students_Waiting_Order_By>>;
  where?: Maybe<Class_Students_Waiting_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootClass_Students_Waiting_AggregateArgs = {
  distinct_on?: Maybe<Array<Class_Students_Waiting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Class_Students_Waiting_Order_By>>;
  where?: Maybe<Class_Students_Waiting_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootClass_Students_Waiting_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootClassesArgs = {
  distinct_on?: Maybe<Array<Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classes_Order_By>>;
  where?: Maybe<Classes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootClasses_AggregateArgs = {
  distinct_on?: Maybe<Array<Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classes_Order_By>>;
  where?: Maybe<Classes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootClasses_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootClassroomsArgs = {
  distinct_on?: Maybe<Array<Classrooms_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classrooms_Order_By>>;
  where?: Maybe<Classrooms_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootClassrooms_AggregateArgs = {
  distinct_on?: Maybe<Array<Classrooms_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classrooms_Order_By>>;
  where?: Maybe<Classrooms_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootClassrooms_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootCredit_Note_ClassesArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Classes_Order_By>>;
  where?: Maybe<Credit_Note_Classes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCredit_Note_Classes_AggregateArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Classes_Order_By>>;
  where?: Maybe<Credit_Note_Classes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCredit_Note_Classes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootCredit_Note_FeesArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Fees_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Fees_Order_By>>;
  where?: Maybe<Credit_Note_Fees_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCredit_Note_Fees_AggregateArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Fees_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Fees_Order_By>>;
  where?: Maybe<Credit_Note_Fees_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCredit_Note_Fees_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootCredit_Note_FilterArgs = {
  args: Credit_Note_Filter_Args;
  distinct_on?: Maybe<Array<Credit_Notes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Notes_Order_By>>;
  where?: Maybe<Credit_Notes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCredit_Note_Filter_AggregateArgs = {
  args: Credit_Note_Filter_Args;
  distinct_on?: Maybe<Array<Credit_Notes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Notes_Order_By>>;
  where?: Maybe<Credit_Notes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCredit_Note_LogsArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Logs_Order_By>>;
  where?: Maybe<Credit_Note_Logs_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCredit_Note_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Logs_Order_By>>;
  where?: Maybe<Credit_Note_Logs_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCredit_Note_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootCredit_NotesArgs = {
  distinct_on?: Maybe<Array<Credit_Notes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Notes_Order_By>>;
  where?: Maybe<Credit_Notes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCredit_Notes_AggregateArgs = {
  distinct_on?: Maybe<Array<Credit_Notes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Notes_Order_By>>;
  where?: Maybe<Credit_Notes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCredit_Notes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootCurriculumsArgs = {
  distinct_on?: Maybe<Array<Curriculums_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Curriculums_Order_By>>;
  where?: Maybe<Curriculums_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCurriculums_AggregateArgs = {
  distinct_on?: Maybe<Array<Curriculums_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Curriculums_Order_By>>;
  where?: Maybe<Curriculums_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCurriculums_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootCurriculums_LevelsArgs = {
  distinct_on?: Maybe<Array<Curriculums_Levels_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Curriculums_Levels_Order_By>>;
  where?: Maybe<Curriculums_Levels_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCurriculums_Levels_AggregateArgs = {
  distinct_on?: Maybe<Array<Curriculums_Levels_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Curriculums_Levels_Order_By>>;
  where?: Maybe<Curriculums_Levels_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCurriculums_Levels_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootDepositsArgs = {
  distinct_on?: Maybe<Array<Deposits_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Deposits_Order_By>>;
  where?: Maybe<Deposits_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootDeposits_AggregateArgs = {
  distinct_on?: Maybe<Array<Deposits_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Deposits_Order_By>>;
  where?: Maybe<Deposits_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootDeposits_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootDiscount_BillsArgs = {
  distinct_on?: Maybe<Array<Discount_Bills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discount_Bills_Order_By>>;
  where?: Maybe<Discount_Bills_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootDiscount_Bills_AggregateArgs = {
  distinct_on?: Maybe<Array<Discount_Bills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discount_Bills_Order_By>>;
  where?: Maybe<Discount_Bills_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootDiscount_Bills_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootDiscount_StudentsArgs = {
  distinct_on?: Maybe<Array<Discount_Students_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discount_Students_Order_By>>;
  where?: Maybe<Discount_Students_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootDiscount_Students_AggregateArgs = {
  distinct_on?: Maybe<Array<Discount_Students_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discount_Students_Order_By>>;
  where?: Maybe<Discount_Students_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootDiscount_Students_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootDiscountsArgs = {
  distinct_on?: Maybe<Array<Discounts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discounts_Order_By>>;
  where?: Maybe<Discounts_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootDiscounts_AggregateArgs = {
  distinct_on?: Maybe<Array<Discounts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discounts_Order_By>>;
  where?: Maybe<Discounts_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootDiscounts_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootDouble_Lesson_Academic_PricingsArgs = {
  distinct_on?: Maybe<Array<Double_Lesson_Academic_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Double_Lesson_Academic_Pricings_Order_By>>;
  where?: Maybe<Double_Lesson_Academic_Pricings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootDouble_Lesson_Academic_Pricings_AggregateArgs = {
  distinct_on?: Maybe<Array<Double_Lesson_Academic_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Double_Lesson_Academic_Pricings_Order_By>>;
  where?: Maybe<Double_Lesson_Academic_Pricings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootDouble_Lesson_Academic_Pricings_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootDouble_Lesson_Program_TypesArgs = {
  distinct_on?: Maybe<Array<Double_Lesson_Program_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Double_Lesson_Program_Types_Order_By>>;
  where?: Maybe<Double_Lesson_Program_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootDouble_Lesson_Program_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Double_Lesson_Program_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Double_Lesson_Program_Types_Order_By>>;
  where?: Maybe<Double_Lesson_Program_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootDouble_Lesson_Program_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootDouble_Lesson_Programme_PricingsArgs = {
  distinct_on?: Maybe<Array<Double_Lesson_Programme_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Double_Lesson_Programme_Pricings_Order_By>>;
  where?: Maybe<Double_Lesson_Programme_Pricings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootDouble_Lesson_Programme_Pricings_AggregateArgs = {
  distinct_on?: Maybe<Array<Double_Lesson_Programme_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Double_Lesson_Programme_Pricings_Order_By>>;
  where?: Maybe<Double_Lesson_Programme_Pricings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootDouble_Lesson_Programme_Pricings_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootEmail_Student_LogsArgs = {
  distinct_on?: Maybe<Array<Email_Student_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Email_Student_Logs_Order_By>>;
  where?: Maybe<Email_Student_Logs_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootEmail_Student_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Email_Student_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Email_Student_Logs_Order_By>>;
  where?: Maybe<Email_Student_Logs_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootEmail_Student_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootEnrollment_List_NewArgs = {
  distinct_on?: Maybe<Array<Enrollment_List_New_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Enrollment_List_New_Order_By>>;
  where?: Maybe<Enrollment_List_New_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootEnrollment_List_New_AggregateArgs = {
  distinct_on?: Maybe<Array<Enrollment_List_New_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Enrollment_List_New_Order_By>>;
  where?: Maybe<Enrollment_List_New_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootEnrollment_List_New_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootGeneral_Program_TypesArgs = {
  distinct_on?: Maybe<Array<General_Program_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<General_Program_Types_Order_By>>;
  where?: Maybe<General_Program_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGeneral_Program_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<General_Program_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<General_Program_Types_Order_By>>;
  where?: Maybe<General_Program_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGeneral_Program_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootGet_ProfileArgs = {
  distinct_on?: Maybe<Array<Get_Profile_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Get_Profile_Order_By>>;
  where?: Maybe<Get_Profile_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGet_Profile_AggregateArgs = {
  distinct_on?: Maybe<Array<Get_Profile_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Get_Profile_Order_By>>;
  where?: Maybe<Get_Profile_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootInvoice_FilterArgs = {
  args: Invoice_Filter_Args;
  distinct_on?: Maybe<Array<Invoices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoices_Order_By>>;
  where?: Maybe<Invoices_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootInvoice_Filter_AggregateArgs = {
  args: Invoice_Filter_Args;
  distinct_on?: Maybe<Array<Invoices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoices_Order_By>>;
  where?: Maybe<Invoices_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootInvoice_Partial_PaymentsArgs = {
  distinct_on?: Maybe<Array<Invoice_Partial_Payments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoice_Partial_Payments_Order_By>>;
  where?: Maybe<Invoice_Partial_Payments_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootInvoice_Partial_Payments_AggregateArgs = {
  distinct_on?: Maybe<Array<Invoice_Partial_Payments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoice_Partial_Payments_Order_By>>;
  where?: Maybe<Invoice_Partial_Payments_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootInvoice_Partial_Payments_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootInvoicesArgs = {
  distinct_on?: Maybe<Array<Invoices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoices_Order_By>>;
  where?: Maybe<Invoices_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootInvoices_AggregateArgs = {
  distinct_on?: Maybe<Array<Invoices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoices_Order_By>>;
  where?: Maybe<Invoices_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootInvoices_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootLessonsArgs = {
  distinct_on?: Maybe<Array<Lessons_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Order_By>>;
  where?: Maybe<Lessons_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootLessons_AggregateArgs = {
  distinct_on?: Maybe<Array<Lessons_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Order_By>>;
  where?: Maybe<Lessons_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootLessons_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootLessons_StudentsArgs = {
  distinct_on?: Maybe<Array<Lessons_Students_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Students_Order_By>>;
  where?: Maybe<Lessons_Students_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootLessons_Students_AggregateArgs = {
  distinct_on?: Maybe<Array<Lessons_Students_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Students_Order_By>>;
  where?: Maybe<Lessons_Students_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootLessons_Students_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootLevelsArgs = {
  distinct_on?: Maybe<Array<Levels_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Levels_Order_By>>;
  where?: Maybe<Levels_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootLevels_AggregateArgs = {
  distinct_on?: Maybe<Array<Levels_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Levels_Order_By>>;
  where?: Maybe<Levels_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootLevels_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootNewsArgs = {
  distinct_on?: Maybe<Array<News_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<News_Order_By>>;
  where?: Maybe<News_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootNews_AggregateArgs = {
  distinct_on?: Maybe<Array<News_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<News_Order_By>>;
  where?: Maybe<News_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootNews_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootNews_LogsArgs = {
  distinct_on?: Maybe<Array<News_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<News_Logs_Order_By>>;
  where?: Maybe<News_Logs_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootNews_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<News_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<News_Logs_Order_By>>;
  where?: Maybe<News_Logs_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootNews_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootNews_Recipients_UploadArgs = {
  distinct_on?: Maybe<Array<News_Recipients_Upload_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<News_Recipients_Upload_Order_By>>;
  where?: Maybe<News_Recipients_Upload_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootNews_Recipients_Upload_AggregateArgs = {
  distinct_on?: Maybe<Array<News_Recipients_Upload_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<News_Recipients_Upload_Order_By>>;
  where?: Maybe<News_Recipients_Upload_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootNews_Recipients_Upload_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootPass_Door_LogsArgs = {
  distinct_on?: Maybe<Array<Pass_Door_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Pass_Door_Logs_Order_By>>;
  where?: Maybe<Pass_Door_Logs_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPass_Door_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Pass_Door_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Pass_Door_Logs_Order_By>>;
  where?: Maybe<Pass_Door_Logs_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPass_Door_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootPayment_Advice_Class_TransferArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Class_Transfer_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Class_Transfer_Order_By>>;
  where?: Maybe<Payment_Advice_Class_Transfer_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPayment_Advice_Class_Transfer_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Class_Transfer_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Class_Transfer_Order_By>>;
  where?: Maybe<Payment_Advice_Class_Transfer_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPayment_Advice_Class_Transfer_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootPayment_Advice_ClassesArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Classes_Order_By>>;
  where?: Maybe<Payment_Advice_Classes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPayment_Advice_Classes_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Classes_Order_By>>;
  where?: Maybe<Payment_Advice_Classes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPayment_Advice_Classes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootPayment_Advice_Classes_By_Student_IdArgs = {
  args: Payment_Advice_Classes_By_Student_Id_Args;
  distinct_on?: Maybe<Array<Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classes_Order_By>>;
  where?: Maybe<Classes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPayment_Advice_Classes_By_Student_Id_AggregateArgs = {
  args: Payment_Advice_Classes_By_Student_Id_Args;
  distinct_on?: Maybe<Array<Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Classes_Order_By>>;
  where?: Maybe<Classes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPayment_Advice_Delete_LogsArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Delete_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Delete_Logs_Order_By>>;
  where?: Maybe<Payment_Advice_Delete_Logs_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPayment_Advice_Delete_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Delete_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Delete_Logs_Order_By>>;
  where?: Maybe<Payment_Advice_Delete_Logs_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPayment_Advice_Delete_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootPayment_Advice_FilterArgs = {
  args: Payment_Advice_Filter_Args;
  distinct_on?: Maybe<Array<Payment_Advices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advices_Order_By>>;
  where?: Maybe<Payment_Advices_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPayment_Advice_Filter_AggregateArgs = {
  args: Payment_Advice_Filter_Args;
  distinct_on?: Maybe<Array<Payment_Advices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advices_Order_By>>;
  where?: Maybe<Payment_Advices_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPayment_Advice_LogsArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Logs_Order_By>>;
  where?: Maybe<Payment_Advice_Logs_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPayment_Advice_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Logs_Order_By>>;
  where?: Maybe<Payment_Advice_Logs_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPayment_Advice_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootPayment_Advice_Term_ClassesArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Term_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Term_Classes_Order_By>>;
  where?: Maybe<Payment_Advice_Term_Classes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPayment_Advice_Term_Classes_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Term_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Term_Classes_Order_By>>;
  where?: Maybe<Payment_Advice_Term_Classes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPayment_Advice_Term_Classes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootPayment_Advice_TransfersArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Transfers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Transfers_Order_By>>;
  where?: Maybe<Payment_Advice_Transfers_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPayment_Advice_Transfers_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Transfers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Transfers_Order_By>>;
  where?: Maybe<Payment_Advice_Transfers_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPayment_Advice_Transfers_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootPayment_AdvicesArgs = {
  distinct_on?: Maybe<Array<Payment_Advices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advices_Order_By>>;
  where?: Maybe<Payment_Advices_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPayment_Advices_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advices_Order_By>>;
  where?: Maybe<Payment_Advices_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPayment_Advices_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootProgramsArgs = {
  distinct_on?: Maybe<Array<Programs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Programs_Order_By>>;
  where?: Maybe<Programs_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPrograms_AggregateArgs = {
  distinct_on?: Maybe<Array<Programs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Programs_Order_By>>;
  where?: Maybe<Programs_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPrograms_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootReceipt_FilterArgs = {
  args: Receipt_Filter_Args;
  distinct_on?: Maybe<Array<Receipts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Receipts_Order_By>>;
  where?: Maybe<Receipts_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootReceipt_Filter_AggregateArgs = {
  args: Receipt_Filter_Args;
  distinct_on?: Maybe<Array<Receipts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Receipts_Order_By>>;
  where?: Maybe<Receipts_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootReceipt_Filter_By_ClassArgs = {
  args: Receipt_Filter_By_Class_Args;
  distinct_on?: Maybe<Array<Receipts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Receipts_Order_By>>;
  where?: Maybe<Receipts_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootReceipt_Filter_By_Class_AggregateArgs = {
  args: Receipt_Filter_By_Class_Args;
  distinct_on?: Maybe<Array<Receipts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Receipts_Order_By>>;
  where?: Maybe<Receipts_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootReceiptsArgs = {
  distinct_on?: Maybe<Array<Receipts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Receipts_Order_By>>;
  where?: Maybe<Receipts_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootReceipts_AggregateArgs = {
  distinct_on?: Maybe<Array<Receipts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Receipts_Order_By>>;
  where?: Maybe<Receipts_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootReceipts_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootRefund_ClassesArgs = {
  distinct_on?: Maybe<Array<Refund_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refund_Classes_Order_By>>;
  where?: Maybe<Refund_Classes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRefund_Classes_AggregateArgs = {
  distinct_on?: Maybe<Array<Refund_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refund_Classes_Order_By>>;
  where?: Maybe<Refund_Classes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRefund_Classes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootRefund_FilterArgs = {
  args: Refund_Filter_Args;
  distinct_on?: Maybe<Array<Refunds_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refunds_Order_By>>;
  where?: Maybe<Refunds_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRefund_Filter_AggregateArgs = {
  args: Refund_Filter_Args;
  distinct_on?: Maybe<Array<Refunds_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refunds_Order_By>>;
  where?: Maybe<Refunds_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRefund_LogsArgs = {
  distinct_on?: Maybe<Array<Refund_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refund_Logs_Order_By>>;
  where?: Maybe<Refund_Logs_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRefund_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Refund_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refund_Logs_Order_By>>;
  where?: Maybe<Refund_Logs_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRefund_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootRefundsArgs = {
  distinct_on?: Maybe<Array<Refunds_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refunds_Order_By>>;
  where?: Maybe<Refunds_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRefunds_AggregateArgs = {
  distinct_on?: Maybe<Array<Refunds_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refunds_Order_By>>;
  where?: Maybe<Refunds_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRefunds_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootRegular_Academic_PricingsArgs = {
  distinct_on?: Maybe<Array<Regular_Academic_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Regular_Academic_Pricings_Order_By>>;
  where?: Maybe<Regular_Academic_Pricings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRegular_Academic_Pricings_AggregateArgs = {
  distinct_on?: Maybe<Array<Regular_Academic_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Regular_Academic_Pricings_Order_By>>;
  where?: Maybe<Regular_Academic_Pricings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRegular_Academic_Pricings_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootRegular_Program_TypesArgs = {
  distinct_on?: Maybe<Array<Regular_Program_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Regular_Program_Types_Order_By>>;
  where?: Maybe<Regular_Program_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRegular_Program_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Regular_Program_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Regular_Program_Types_Order_By>>;
  where?: Maybe<Regular_Program_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRegular_Program_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootRegular_Programme_PricingsArgs = {
  distinct_on?: Maybe<Array<Regular_Programme_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Regular_Programme_Pricings_Order_By>>;
  where?: Maybe<Regular_Programme_Pricings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRegular_Programme_Pricings_AggregateArgs = {
  distinct_on?: Maybe<Array<Regular_Programme_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Regular_Programme_Pricings_Order_By>>;
  where?: Maybe<Regular_Programme_Pricings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRegular_Programme_Pricings_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootReport_Subject_BudgetArgs = {
  distinct_on?: Maybe<Array<Report_Subject_Budget_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Report_Subject_Budget_Order_By>>;
  where?: Maybe<Report_Subject_Budget_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootReport_Subject_Budget_AggregateArgs = {
  distinct_on?: Maybe<Array<Report_Subject_Budget_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Report_Subject_Budget_Order_By>>;
  where?: Maybe<Report_Subject_Budget_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootReport_Subject_Budget_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootRequest_Transfer_ClassesArgs = {
  distinct_on?: Maybe<Array<Request_Transfer_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Request_Transfer_Classes_Order_By>>;
  where?: Maybe<Request_Transfer_Classes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRequest_Transfer_Classes_AggregateArgs = {
  distinct_on?: Maybe<Array<Request_Transfer_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Request_Transfer_Classes_Order_By>>;
  where?: Maybe<Request_Transfer_Classes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRequest_Transfer_Classes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootRolesArgs = {
  distinct_on?: Maybe<Array<Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Roles_Order_By>>;
  where?: Maybe<Roles_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRoles_AggregateArgs = {
  distinct_on?: Maybe<Array<Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Roles_Order_By>>;
  where?: Maybe<Roles_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRoles_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootSchoolsArgs = {
  distinct_on?: Maybe<Array<Schools_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Schools_Order_By>>;
  where?: Maybe<Schools_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSchools_AggregateArgs = {
  distinct_on?: Maybe<Array<Schools_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Schools_Order_By>>;
  where?: Maybe<Schools_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSchools_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootSentBroadcastArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootSentNewsArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootSessionsArgs = {
  distinct_on?: Maybe<Array<Sessions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Sessions_Order_By>>;
  where?: Maybe<Sessions_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSessions_AggregateArgs = {
  distinct_on?: Maybe<Array<Sessions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Sessions_Order_By>>;
  where?: Maybe<Sessions_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSessions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootSpecial_Programme_Class_PricingsArgs = {
  distinct_on?: Maybe<Array<Special_Programme_Class_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Special_Programme_Class_Pricings_Order_By>>;
  where?: Maybe<Special_Programme_Class_Pricings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSpecial_Programme_Class_Pricings_AggregateArgs = {
  distinct_on?: Maybe<Array<Special_Programme_Class_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Special_Programme_Class_Pricings_Order_By>>;
  where?: Maybe<Special_Programme_Class_Pricings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSpecial_Programme_Class_Pricings_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootSpecical_Program_TypesArgs = {
  distinct_on?: Maybe<Array<Specical_Program_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Specical_Program_Types_Order_By>>;
  where?: Maybe<Specical_Program_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSpecical_Program_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Specical_Program_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Specical_Program_Types_Order_By>>;
  where?: Maybe<Specical_Program_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSpecical_Program_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootStudent_ProfilesArgs = {
  distinct_on?: Maybe<Array<Student_Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Student_Profiles_Order_By>>;
  where?: Maybe<Student_Profiles_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootStudent_Profiles_AggregateArgs = {
  distinct_on?: Maybe<Array<Student_Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Student_Profiles_Order_By>>;
  where?: Maybe<Student_Profiles_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootStudent_Profiles_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootStudents_FilterArgs = {
  args: Students_Filter_Args;
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootStudents_Filter_AggregateArgs = {
  args: Students_Filter_Args;
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootStudents_List_FilterArgs = {
  args: Students_List_Filter_Args;
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootStudents_List_Filter_AggregateArgs = {
  args: Students_List_Filter_Args;
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootStudents_List_Filter_PaymentArgs = {
  args: Students_List_Filter_Payment_Args;
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootStudents_List_Filter_Payment_AggregateArgs = {
  args: Students_List_Filter_Payment_Args;
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootStudents_Programs_FilterArgs = {
  args: Students_Programs_Filter_Args;
  distinct_on?: Maybe<Array<Programs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Programs_Order_By>>;
  where?: Maybe<Programs_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootStudents_Programs_Filter_AggregateArgs = {
  args: Students_Programs_Filter_Args;
  distinct_on?: Maybe<Array<Programs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Programs_Order_By>>;
  where?: Maybe<Programs_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSubjectsArgs = {
  distinct_on?: Maybe<Array<Subjects_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Subjects_Order_By>>;
  where?: Maybe<Subjects_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSubjects_AggregateArgs = {
  distinct_on?: Maybe<Array<Subjects_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Subjects_Order_By>>;
  where?: Maybe<Subjects_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSubjects_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootSystem_SettingsArgs = {
  distinct_on?: Maybe<Array<System_Settings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<System_Settings_Order_By>>;
  where?: Maybe<System_Settings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSystem_Settings_AggregateArgs = {
  distinct_on?: Maybe<Array<System_Settings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<System_Settings_Order_By>>;
  where?: Maybe<System_Settings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSystem_Settings_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootTerm_ClassesArgs = {
  distinct_on?: Maybe<Array<Term_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Term_Classes_Order_By>>;
  where?: Maybe<Term_Classes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTerm_Classes_AggregateArgs = {
  distinct_on?: Maybe<Array<Term_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Term_Classes_Order_By>>;
  where?: Maybe<Term_Classes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTerm_Classes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootTermsArgs = {
  distinct_on?: Maybe<Array<Terms_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Terms_Order_By>>;
  where?: Maybe<Terms_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTerms_AggregateArgs = {
  distinct_on?: Maybe<Array<Terms_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Terms_Order_By>>;
  where?: Maybe<Terms_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTerms_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootThree_Times_AbsentsArgs = {
  distinct_on?: Maybe<Array<Three_Times_Absents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Three_Times_Absents_Order_By>>;
  where?: Maybe<Three_Times_Absents_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootThree_Times_Absents_AggregateArgs = {
  distinct_on?: Maybe<Array<Three_Times_Absents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Three_Times_Absents_Order_By>>;
  where?: Maybe<Three_Times_Absents_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootThree_Times_Absents_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootTransaction_LogsArgs = {
  distinct_on?: Maybe<Array<Transaction_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Transaction_Logs_Order_By>>;
  where?: Maybe<Transaction_Logs_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTransaction_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Transaction_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Transaction_Logs_Order_By>>;
  where?: Maybe<Transaction_Logs_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTransaction_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootVms_Person_GroupsArgs = {
  distinct_on?: Maybe<Array<Vms_Person_Groups_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vms_Person_Groups_Order_By>>;
  where?: Maybe<Vms_Person_Groups_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVms_Person_Groups_AggregateArgs = {
  distinct_on?: Maybe<Array<Vms_Person_Groups_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vms_Person_Groups_Order_By>>;
  where?: Maybe<Vms_Person_Groups_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVms_Person_Groups_By_PkArgs = {
  id: Scalars['uuid'];
};

/** columns and relationships of "system_settings" */
export type System_Settings = {
  __typename?: 'system_settings';
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  key: Scalars['String'];
  /** An object relationship */
  parent?: Maybe<System_Settings>;
  parentId?: Maybe<Scalars['uuid']>;
  status: Scalars['String'];
  /** An array relationship */
  system_settings: Array<System_Settings>;
  /** An aggregated array relationship */
  system_settings_aggregate: System_Settings_Aggregate;
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  userByCreatedby?: Maybe<Users>;
  value: Scalars['String'];
};


/** columns and relationships of "system_settings" */
export type System_SettingsSystem_SettingsArgs = {
  distinct_on?: Maybe<Array<System_Settings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<System_Settings_Order_By>>;
  where?: Maybe<System_Settings_Bool_Exp>;
};


/** columns and relationships of "system_settings" */
export type System_SettingsSystem_Settings_AggregateArgs = {
  distinct_on?: Maybe<Array<System_Settings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<System_Settings_Order_By>>;
  where?: Maybe<System_Settings_Bool_Exp>;
};

/** aggregated selection of "system_settings" */
export type System_Settings_Aggregate = {
  __typename?: 'system_settings_aggregate';
  aggregate?: Maybe<System_Settings_Aggregate_Fields>;
  nodes: Array<System_Settings>;
};

/** aggregate fields of "system_settings" */
export type System_Settings_Aggregate_Fields = {
  __typename?: 'system_settings_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<System_Settings_Max_Fields>;
  min?: Maybe<System_Settings_Min_Fields>;
};


/** aggregate fields of "system_settings" */
export type System_Settings_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<System_Settings_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "system_settings" */
export type System_Settings_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<System_Settings_Max_Order_By>;
  min?: Maybe<System_Settings_Min_Order_By>;
};

/** input type for inserting array relation for remote table "system_settings" */
export type System_Settings_Arr_Rel_Insert_Input = {
  data: Array<System_Settings_Insert_Input>;
  on_conflict?: Maybe<System_Settings_On_Conflict>;
};

/** Boolean expression to filter rows from the table "system_settings". All fields are combined with a logical 'AND'. */
export type System_Settings_Bool_Exp = {
  _and?: Maybe<Array<Maybe<System_Settings_Bool_Exp>>>;
  _not?: Maybe<System_Settings_Bool_Exp>;
  _or?: Maybe<Array<Maybe<System_Settings_Bool_Exp>>>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  key?: Maybe<String_Comparison_Exp>;
  parent?: Maybe<System_Settings_Bool_Exp>;
  parentId?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  system_settings?: Maybe<System_Settings_Bool_Exp>;
  type?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  userByCreatedby?: Maybe<Users_Bool_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "system_settings" */
export enum System_Settings_Constraint {
  /** unique or primary key constraint */
  SystemSettingsPkey = 'system_settings_pkey'
}

/** input type for inserting data into table "system_settings" */
export type System_Settings_Insert_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  parent?: Maybe<System_Settings_Obj_Rel_Insert_Input>;
  parentId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  system_settings?: Maybe<System_Settings_Arr_Rel_Insert_Input>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  userByCreatedby?: Maybe<Users_Obj_Rel_Insert_Input>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type System_Settings_Max_Fields = {
  __typename?: 'system_settings_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "system_settings" */
export type System_Settings_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  key?: Maybe<Order_By>;
  parentId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type System_Settings_Min_Fields = {
  __typename?: 'system_settings_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "system_settings" */
export type System_Settings_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  key?: Maybe<Order_By>;
  parentId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** response of any mutation on the table "system_settings" */
export type System_Settings_Mutation_Response = {
  __typename?: 'system_settings_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<System_Settings>;
};

/** input type for inserting object relation for remote table "system_settings" */
export type System_Settings_Obj_Rel_Insert_Input = {
  data: System_Settings_Insert_Input;
  on_conflict?: Maybe<System_Settings_On_Conflict>;
};

/** on conflict condition type for table "system_settings" */
export type System_Settings_On_Conflict = {
  constraint: System_Settings_Constraint;
  update_columns: Array<System_Settings_Update_Column>;
  where?: Maybe<System_Settings_Bool_Exp>;
};

/** ordering options when selecting data from "system_settings" */
export type System_Settings_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  key?: Maybe<Order_By>;
  parent?: Maybe<System_Settings_Order_By>;
  parentId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  system_settings_aggregate?: Maybe<System_Settings_Aggregate_Order_By>;
  type?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  userByCreatedby?: Maybe<Users_Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: "system_settings" */
export type System_Settings_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "system_settings" */
export enum System_Settings_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "system_settings" */
export type System_Settings_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "system_settings" */
export enum System_Settings_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Value = 'value'
}

/** columns and relationships of "term_classes" */
export type Term_Classes = {
  __typename?: 'term_classes';
  /** An object relationship */
  class: Classes;
  classId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An array relationship */
  lessons: Array<Lessons>;
  /** An aggregated array relationship */
  lessons_aggregate: Lessons_Aggregate;
  /** An array relationship */
  payment_advice_term_classes: Array<Payment_Advice_Term_Classes>;
  /** An aggregated array relationship */
  payment_advice_term_classes_aggregate: Payment_Advice_Term_Classes_Aggregate;
  status: Scalars['String'];
  /** An object relationship */
  term: Terms;
  termId: Scalars['uuid'];
  termName: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "term_classes" */
export type Term_ClassesLessonsArgs = {
  distinct_on?: Maybe<Array<Lessons_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Order_By>>;
  where?: Maybe<Lessons_Bool_Exp>;
};


/** columns and relationships of "term_classes" */
export type Term_ClassesLessons_AggregateArgs = {
  distinct_on?: Maybe<Array<Lessons_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Order_By>>;
  where?: Maybe<Lessons_Bool_Exp>;
};


/** columns and relationships of "term_classes" */
export type Term_ClassesPayment_Advice_Term_ClassesArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Term_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Term_Classes_Order_By>>;
  where?: Maybe<Payment_Advice_Term_Classes_Bool_Exp>;
};


/** columns and relationships of "term_classes" */
export type Term_ClassesPayment_Advice_Term_Classes_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Term_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Term_Classes_Order_By>>;
  where?: Maybe<Payment_Advice_Term_Classes_Bool_Exp>;
};

/** aggregated selection of "term_classes" */
export type Term_Classes_Aggregate = {
  __typename?: 'term_classes_aggregate';
  aggregate?: Maybe<Term_Classes_Aggregate_Fields>;
  nodes: Array<Term_Classes>;
};

/** aggregate fields of "term_classes" */
export type Term_Classes_Aggregate_Fields = {
  __typename?: 'term_classes_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Term_Classes_Max_Fields>;
  min?: Maybe<Term_Classes_Min_Fields>;
};


/** aggregate fields of "term_classes" */
export type Term_Classes_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Term_Classes_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "term_classes" */
export type Term_Classes_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Term_Classes_Max_Order_By>;
  min?: Maybe<Term_Classes_Min_Order_By>;
};

/** input type for inserting array relation for remote table "term_classes" */
export type Term_Classes_Arr_Rel_Insert_Input = {
  data: Array<Term_Classes_Insert_Input>;
  on_conflict?: Maybe<Term_Classes_On_Conflict>;
};

/** Boolean expression to filter rows from the table "term_classes". All fields are combined with a logical 'AND'. */
export type Term_Classes_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Term_Classes_Bool_Exp>>>;
  _not?: Maybe<Term_Classes_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Term_Classes_Bool_Exp>>>;
  class?: Maybe<Classes_Bool_Exp>;
  classId?: Maybe<Uuid_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  lessons?: Maybe<Lessons_Bool_Exp>;
  payment_advice_term_classes?: Maybe<Payment_Advice_Term_Classes_Bool_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  term?: Maybe<Terms_Bool_Exp>;
  termId?: Maybe<Uuid_Comparison_Exp>;
  termName?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "term_classes" */
export enum Term_Classes_Constraint {
  /** unique or primary key constraint */
  TermClassesClassIdTermIdKey = 'term_classes_classId_termId_key',
  /** unique or primary key constraint */
  TermClassesPkey = 'term_classes_pkey'
}

/** input type for inserting data into table "term_classes" */
export type Term_Classes_Insert_Input = {
  class?: Maybe<Classes_Obj_Rel_Insert_Input>;
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  lessons?: Maybe<Lessons_Arr_Rel_Insert_Input>;
  payment_advice_term_classes?: Maybe<Payment_Advice_Term_Classes_Arr_Rel_Insert_Input>;
  status?: Maybe<Scalars['String']>;
  term?: Maybe<Terms_Obj_Rel_Insert_Input>;
  termId?: Maybe<Scalars['uuid']>;
  termName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Term_Classes_Max_Fields = {
  __typename?: 'term_classes_max_fields';
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  termId?: Maybe<Scalars['uuid']>;
  termName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "term_classes" */
export type Term_Classes_Max_Order_By = {
  classId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  termId?: Maybe<Order_By>;
  termName?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Term_Classes_Min_Fields = {
  __typename?: 'term_classes_min_fields';
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  termId?: Maybe<Scalars['uuid']>;
  termName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "term_classes" */
export type Term_Classes_Min_Order_By = {
  classId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  termId?: Maybe<Order_By>;
  termName?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "term_classes" */
export type Term_Classes_Mutation_Response = {
  __typename?: 'term_classes_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Term_Classes>;
};

/** input type for inserting object relation for remote table "term_classes" */
export type Term_Classes_Obj_Rel_Insert_Input = {
  data: Term_Classes_Insert_Input;
  on_conflict?: Maybe<Term_Classes_On_Conflict>;
};

/** on conflict condition type for table "term_classes" */
export type Term_Classes_On_Conflict = {
  constraint: Term_Classes_Constraint;
  update_columns: Array<Term_Classes_Update_Column>;
  where?: Maybe<Term_Classes_Bool_Exp>;
};

/** ordering options when selecting data from "term_classes" */
export type Term_Classes_Order_By = {
  class?: Maybe<Classes_Order_By>;
  classId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lessons_aggregate?: Maybe<Lessons_Aggregate_Order_By>;
  payment_advice_term_classes_aggregate?: Maybe<Payment_Advice_Term_Classes_Aggregate_Order_By>;
  status?: Maybe<Order_By>;
  term?: Maybe<Terms_Order_By>;
  termId?: Maybe<Order_By>;
  termName?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "term_classes" */
export type Term_Classes_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "term_classes" */
export enum Term_Classes_Select_Column {
  /** column name */
  ClassId = 'classId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  TermId = 'termId',
  /** column name */
  TermName = 'termName',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "term_classes" */
export type Term_Classes_Set_Input = {
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  termId?: Maybe<Scalars['uuid']>;
  termName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "term_classes" */
export enum Term_Classes_Update_Column {
  /** column name */
  ClassId = 'classId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  TermId = 'termId',
  /** column name */
  TermName = 'termName',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** columns and relationships of "terms" */
export type Terms = {
  __typename?: 'terms';
  /** An object relationship */
  academicCalendar: Academic_Calendars;
  academicCalendarId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  credit_note_classes: Array<Credit_Note_Classes>;
  /** An aggregated array relationship */
  credit_note_classes_aggregate: Credit_Note_Classes_Aggregate;
  endDate: Scalars['timestamptz'];
  id: Scalars['uuid'];
  numberOfLessons?: Maybe<Scalars['Int']>;
  startDate: Scalars['timestamptz'];
  status: Scalars['String'];
  /** An array relationship */
  term_classes: Array<Term_Classes>;
  /** An aggregated array relationship */
  term_classes_aggregate: Term_Classes_Aggregate;
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "terms" */
export type TermsCredit_Note_ClassesArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Classes_Order_By>>;
  where?: Maybe<Credit_Note_Classes_Bool_Exp>;
};


/** columns and relationships of "terms" */
export type TermsCredit_Note_Classes_AggregateArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Classes_Order_By>>;
  where?: Maybe<Credit_Note_Classes_Bool_Exp>;
};


/** columns and relationships of "terms" */
export type TermsTerm_ClassesArgs = {
  distinct_on?: Maybe<Array<Term_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Term_Classes_Order_By>>;
  where?: Maybe<Term_Classes_Bool_Exp>;
};


/** columns and relationships of "terms" */
export type TermsTerm_Classes_AggregateArgs = {
  distinct_on?: Maybe<Array<Term_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Term_Classes_Order_By>>;
  where?: Maybe<Term_Classes_Bool_Exp>;
};

/** aggregated selection of "terms" */
export type Terms_Aggregate = {
  __typename?: 'terms_aggregate';
  aggregate?: Maybe<Terms_Aggregate_Fields>;
  nodes: Array<Terms>;
};

/** aggregate fields of "terms" */
export type Terms_Aggregate_Fields = {
  __typename?: 'terms_aggregate_fields';
  avg?: Maybe<Terms_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Terms_Max_Fields>;
  min?: Maybe<Terms_Min_Fields>;
  stddev?: Maybe<Terms_Stddev_Fields>;
  stddev_pop?: Maybe<Terms_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Terms_Stddev_Samp_Fields>;
  sum?: Maybe<Terms_Sum_Fields>;
  var_pop?: Maybe<Terms_Var_Pop_Fields>;
  var_samp?: Maybe<Terms_Var_Samp_Fields>;
  variance?: Maybe<Terms_Variance_Fields>;
};


/** aggregate fields of "terms" */
export type Terms_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Terms_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "terms" */
export type Terms_Aggregate_Order_By = {
  avg?: Maybe<Terms_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Terms_Max_Order_By>;
  min?: Maybe<Terms_Min_Order_By>;
  stddev?: Maybe<Terms_Stddev_Order_By>;
  stddev_pop?: Maybe<Terms_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Terms_Stddev_Samp_Order_By>;
  sum?: Maybe<Terms_Sum_Order_By>;
  var_pop?: Maybe<Terms_Var_Pop_Order_By>;
  var_samp?: Maybe<Terms_Var_Samp_Order_By>;
  variance?: Maybe<Terms_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "terms" */
export type Terms_Arr_Rel_Insert_Input = {
  data: Array<Terms_Insert_Input>;
  on_conflict?: Maybe<Terms_On_Conflict>;
};

/** aggregate avg on columns */
export type Terms_Avg_Fields = {
  __typename?: 'terms_avg_fields';
  numberOfLessons?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "terms" */
export type Terms_Avg_Order_By = {
  numberOfLessons?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "terms". All fields are combined with a logical 'AND'. */
export type Terms_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Terms_Bool_Exp>>>;
  _not?: Maybe<Terms_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Terms_Bool_Exp>>>;
  academicCalendar?: Maybe<Academic_Calendars_Bool_Exp>;
  academicCalendarId?: Maybe<Uuid_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  credit_note_classes?: Maybe<Credit_Note_Classes_Bool_Exp>;
  endDate?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  numberOfLessons?: Maybe<Int_Comparison_Exp>;
  startDate?: Maybe<Timestamptz_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  term_classes?: Maybe<Term_Classes_Bool_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "terms" */
export enum Terms_Constraint {
  /** unique or primary key constraint */
  TermsPkey = 'terms_pkey'
}

/** input type for incrementing integer column in table "terms" */
export type Terms_Inc_Input = {
  numberOfLessons?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "terms" */
export type Terms_Insert_Input = {
  academicCalendar?: Maybe<Academic_Calendars_Obj_Rel_Insert_Input>;
  academicCalendarId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  credit_note_classes?: Maybe<Credit_Note_Classes_Arr_Rel_Insert_Input>;
  endDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  numberOfLessons?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  term_classes?: Maybe<Term_Classes_Arr_Rel_Insert_Input>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Terms_Max_Fields = {
  __typename?: 'terms_max_fields';
  academicCalendarId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  endDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  numberOfLessons?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "terms" */
export type Terms_Max_Order_By = {
  academicCalendarId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  endDate?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  numberOfLessons?: Maybe<Order_By>;
  startDate?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Terms_Min_Fields = {
  __typename?: 'terms_min_fields';
  academicCalendarId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  endDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  numberOfLessons?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "terms" */
export type Terms_Min_Order_By = {
  academicCalendarId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  endDate?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  numberOfLessons?: Maybe<Order_By>;
  startDate?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "terms" */
export type Terms_Mutation_Response = {
  __typename?: 'terms_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Terms>;
};

/** input type for inserting object relation for remote table "terms" */
export type Terms_Obj_Rel_Insert_Input = {
  data: Terms_Insert_Input;
  on_conflict?: Maybe<Terms_On_Conflict>;
};

/** on conflict condition type for table "terms" */
export type Terms_On_Conflict = {
  constraint: Terms_Constraint;
  update_columns: Array<Terms_Update_Column>;
  where?: Maybe<Terms_Bool_Exp>;
};

/** ordering options when selecting data from "terms" */
export type Terms_Order_By = {
  academicCalendar?: Maybe<Academic_Calendars_Order_By>;
  academicCalendarId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  credit_note_classes_aggregate?: Maybe<Credit_Note_Classes_Aggregate_Order_By>;
  endDate?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  numberOfLessons?: Maybe<Order_By>;
  startDate?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  term_classes_aggregate?: Maybe<Term_Classes_Aggregate_Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "terms" */
export type Terms_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "terms" */
export enum Terms_Select_Column {
  /** column name */
  AcademicCalendarId = 'academicCalendarId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  Id = 'id',
  /** column name */
  NumberOfLessons = 'numberOfLessons',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "terms" */
export type Terms_Set_Input = {
  academicCalendarId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  endDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  numberOfLessons?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Terms_Stddev_Fields = {
  __typename?: 'terms_stddev_fields';
  numberOfLessons?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "terms" */
export type Terms_Stddev_Order_By = {
  numberOfLessons?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Terms_Stddev_Pop_Fields = {
  __typename?: 'terms_stddev_pop_fields';
  numberOfLessons?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "terms" */
export type Terms_Stddev_Pop_Order_By = {
  numberOfLessons?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Terms_Stddev_Samp_Fields = {
  __typename?: 'terms_stddev_samp_fields';
  numberOfLessons?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "terms" */
export type Terms_Stddev_Samp_Order_By = {
  numberOfLessons?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Terms_Sum_Fields = {
  __typename?: 'terms_sum_fields';
  numberOfLessons?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "terms" */
export type Terms_Sum_Order_By = {
  numberOfLessons?: Maybe<Order_By>;
};

/** update columns of table "terms" */
export enum Terms_Update_Column {
  /** column name */
  AcademicCalendarId = 'academicCalendarId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  Id = 'id',
  /** column name */
  NumberOfLessons = 'numberOfLessons',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** aggregate var_pop on columns */
export type Terms_Var_Pop_Fields = {
  __typename?: 'terms_var_pop_fields';
  numberOfLessons?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "terms" */
export type Terms_Var_Pop_Order_By = {
  numberOfLessons?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Terms_Var_Samp_Fields = {
  __typename?: 'terms_var_samp_fields';
  numberOfLessons?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "terms" */
export type Terms_Var_Samp_Order_By = {
  numberOfLessons?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Terms_Variance_Fields = {
  __typename?: 'terms_variance_fields';
  numberOfLessons?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "terms" */
export type Terms_Variance_Order_By = {
  numberOfLessons?: Maybe<Order_By>;
};

/** columns and relationships of "three_times_absents" */
export type Three_Times_Absents = {
  __typename?: 'three_times_absents';
  absents?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  class?: Maybe<Classes>;
  classId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  emailStatus?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An object relationship */
  program?: Maybe<Programs>;
  programId?: Maybe<Scalars['uuid']>;
  status: Scalars['String'];
  /** An object relationship */
  student?: Maybe<Users>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "three_times_absents" */
export type Three_Times_AbsentsAbsentsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "three_times_absents" */
export type Three_Times_Absents_Aggregate = {
  __typename?: 'three_times_absents_aggregate';
  aggregate?: Maybe<Three_Times_Absents_Aggregate_Fields>;
  nodes: Array<Three_Times_Absents>;
};

/** aggregate fields of "three_times_absents" */
export type Three_Times_Absents_Aggregate_Fields = {
  __typename?: 'three_times_absents_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Three_Times_Absents_Max_Fields>;
  min?: Maybe<Three_Times_Absents_Min_Fields>;
};


/** aggregate fields of "three_times_absents" */
export type Three_Times_Absents_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Three_Times_Absents_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "three_times_absents" */
export type Three_Times_Absents_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Three_Times_Absents_Max_Order_By>;
  min?: Maybe<Three_Times_Absents_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Three_Times_Absents_Append_Input = {
  absents?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "three_times_absents" */
export type Three_Times_Absents_Arr_Rel_Insert_Input = {
  data: Array<Three_Times_Absents_Insert_Input>;
  on_conflict?: Maybe<Three_Times_Absents_On_Conflict>;
};

/** Boolean expression to filter rows from the table "three_times_absents". All fields are combined with a logical 'AND'. */
export type Three_Times_Absents_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Three_Times_Absents_Bool_Exp>>>;
  _not?: Maybe<Three_Times_Absents_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Three_Times_Absents_Bool_Exp>>>;
  absents?: Maybe<Jsonb_Comparison_Exp>;
  class?: Maybe<Classes_Bool_Exp>;
  classId?: Maybe<Uuid_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  emailStatus?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  program?: Maybe<Programs_Bool_Exp>;
  programId?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  student?: Maybe<Users_Bool_Exp>;
  studentId?: Maybe<Uuid_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "three_times_absents" */
export enum Three_Times_Absents_Constraint {
  /** unique or primary key constraint */
  ThreeTimesAbsentsPkey = 'three_times_absents_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Three_Times_Absents_Delete_At_Path_Input = {
  absents?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Three_Times_Absents_Delete_Elem_Input = {
  absents?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Three_Times_Absents_Delete_Key_Input = {
  absents?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "three_times_absents" */
export type Three_Times_Absents_Insert_Input = {
  absents?: Maybe<Scalars['jsonb']>;
  class?: Maybe<Classes_Obj_Rel_Insert_Input>;
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailStatus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  program?: Maybe<Programs_Obj_Rel_Insert_Input>;
  programId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  student?: Maybe<Users_Obj_Rel_Insert_Input>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Three_Times_Absents_Max_Fields = {
  __typename?: 'three_times_absents_max_fields';
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailStatus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  programId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "three_times_absents" */
export type Three_Times_Absents_Max_Order_By = {
  classId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  emailStatus?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  programId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Three_Times_Absents_Min_Fields = {
  __typename?: 'three_times_absents_min_fields';
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailStatus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  programId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "three_times_absents" */
export type Three_Times_Absents_Min_Order_By = {
  classId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  emailStatus?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  programId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "three_times_absents" */
export type Three_Times_Absents_Mutation_Response = {
  __typename?: 'three_times_absents_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Three_Times_Absents>;
};

/** input type for inserting object relation for remote table "three_times_absents" */
export type Three_Times_Absents_Obj_Rel_Insert_Input = {
  data: Three_Times_Absents_Insert_Input;
  on_conflict?: Maybe<Three_Times_Absents_On_Conflict>;
};

/** on conflict condition type for table "three_times_absents" */
export type Three_Times_Absents_On_Conflict = {
  constraint: Three_Times_Absents_Constraint;
  update_columns: Array<Three_Times_Absents_Update_Column>;
  where?: Maybe<Three_Times_Absents_Bool_Exp>;
};

/** ordering options when selecting data from "three_times_absents" */
export type Three_Times_Absents_Order_By = {
  absents?: Maybe<Order_By>;
  class?: Maybe<Classes_Order_By>;
  classId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  emailStatus?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  program?: Maybe<Programs_Order_By>;
  programId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  student?: Maybe<Users_Order_By>;
  studentId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "three_times_absents" */
export type Three_Times_Absents_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Three_Times_Absents_Prepend_Input = {
  absents?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "three_times_absents" */
export enum Three_Times_Absents_Select_Column {
  /** column name */
  Absents = 'absents',
  /** column name */
  ClassId = 'classId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EmailStatus = 'emailStatus',
  /** column name */
  Id = 'id',
  /** column name */
  ProgramId = 'programId',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "three_times_absents" */
export type Three_Times_Absents_Set_Input = {
  absents?: Maybe<Scalars['jsonb']>;
  classId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  emailStatus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  programId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "three_times_absents" */
export enum Three_Times_Absents_Update_Column {
  /** column name */
  Absents = 'absents',
  /** column name */
  ClassId = 'classId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EmailStatus = 'emailStatus',
  /** column name */
  Id = 'id',
  /** column name */
  ProgramId = 'programId',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}


/** expression to compare columns of type timestamp. All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: Maybe<Scalars['timestamp']>;
  _gt?: Maybe<Scalars['timestamp']>;
  _gte?: Maybe<Scalars['timestamp']>;
  _in?: Maybe<Array<Scalars['timestamp']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamp']>;
  _lte?: Maybe<Scalars['timestamp']>;
  _neq?: Maybe<Scalars['timestamp']>;
  _nin?: Maybe<Array<Scalars['timestamp']>>;
};


/** expression to compare columns of type timestamptz. All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: Maybe<Scalars['timestamptz']>;
  _gt?: Maybe<Scalars['timestamptz']>;
  _gte?: Maybe<Scalars['timestamptz']>;
  _in?: Maybe<Array<Scalars['timestamptz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamptz']>;
  _lte?: Maybe<Scalars['timestamptz']>;
  _neq?: Maybe<Scalars['timestamptz']>;
  _nin?: Maybe<Array<Scalars['timestamptz']>>;
};


/** expression to compare columns of type timetz. All fields are combined with logical 'AND'. */
export type Timetz_Comparison_Exp = {
  _eq?: Maybe<Scalars['timetz']>;
  _gt?: Maybe<Scalars['timetz']>;
  _gte?: Maybe<Scalars['timetz']>;
  _in?: Maybe<Array<Scalars['timetz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timetz']>;
  _lte?: Maybe<Scalars['timetz']>;
  _neq?: Maybe<Scalars['timetz']>;
  _nin?: Maybe<Array<Scalars['timetz']>>;
};

/** columns and relationships of "transaction_logs" */
export type Transaction_Logs = {
  __typename?: 'transaction_logs';
  backUrlResponse?: Maybe<Scalars['jsonb']>;
  constructionResponse?: Maybe<Scalars['jsonb']>;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An object relationship */
  invoice?: Maybe<Invoices>;
  invoiceId?: Maybe<Scalars['uuid']>;
  notifyUrlResponse?: Maybe<Scalars['jsonb']>;
  orderId?: Maybe<Scalars['String']>;
  partnerBank?: Maybe<Scalars['String']>;
  /** An object relationship */
  paymentAdvice?: Maybe<Payment_Advices>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  redirectUrlResponse?: Maybe<Scalars['jsonb']>;
  requestData?: Maybe<Scalars['jsonb']>;
  status: Scalars['String'];
  transactionId?: Maybe<Scalars['String']>;
  transactionStatus?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "transaction_logs" */
export type Transaction_LogsBackUrlResponseArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "transaction_logs" */
export type Transaction_LogsConstructionResponseArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "transaction_logs" */
export type Transaction_LogsNotifyUrlResponseArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "transaction_logs" */
export type Transaction_LogsRedirectUrlResponseArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "transaction_logs" */
export type Transaction_LogsRequestDataArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "transaction_logs" */
export type Transaction_Logs_Aggregate = {
  __typename?: 'transaction_logs_aggregate';
  aggregate?: Maybe<Transaction_Logs_Aggregate_Fields>;
  nodes: Array<Transaction_Logs>;
};

/** aggregate fields of "transaction_logs" */
export type Transaction_Logs_Aggregate_Fields = {
  __typename?: 'transaction_logs_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Transaction_Logs_Max_Fields>;
  min?: Maybe<Transaction_Logs_Min_Fields>;
};


/** aggregate fields of "transaction_logs" */
export type Transaction_Logs_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Transaction_Logs_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "transaction_logs" */
export type Transaction_Logs_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Transaction_Logs_Max_Order_By>;
  min?: Maybe<Transaction_Logs_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Transaction_Logs_Append_Input = {
  backUrlResponse?: Maybe<Scalars['jsonb']>;
  constructionResponse?: Maybe<Scalars['jsonb']>;
  notifyUrlResponse?: Maybe<Scalars['jsonb']>;
  redirectUrlResponse?: Maybe<Scalars['jsonb']>;
  requestData?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "transaction_logs" */
export type Transaction_Logs_Arr_Rel_Insert_Input = {
  data: Array<Transaction_Logs_Insert_Input>;
  on_conflict?: Maybe<Transaction_Logs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "transaction_logs". All fields are combined with a logical 'AND'. */
export type Transaction_Logs_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Transaction_Logs_Bool_Exp>>>;
  _not?: Maybe<Transaction_Logs_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Transaction_Logs_Bool_Exp>>>;
  backUrlResponse?: Maybe<Jsonb_Comparison_Exp>;
  constructionResponse?: Maybe<Jsonb_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  invoice?: Maybe<Invoices_Bool_Exp>;
  invoiceId?: Maybe<Uuid_Comparison_Exp>;
  notifyUrlResponse?: Maybe<Jsonb_Comparison_Exp>;
  orderId?: Maybe<String_Comparison_Exp>;
  partnerBank?: Maybe<String_Comparison_Exp>;
  paymentAdvice?: Maybe<Payment_Advices_Bool_Exp>;
  paymentAdviceId?: Maybe<Uuid_Comparison_Exp>;
  redirectUrlResponse?: Maybe<Jsonb_Comparison_Exp>;
  requestData?: Maybe<Jsonb_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  transactionId?: Maybe<String_Comparison_Exp>;
  transactionStatus?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "transaction_logs" */
export enum Transaction_Logs_Constraint {
  /** unique or primary key constraint */
  TransactionLogsPkey = 'transaction_logs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Transaction_Logs_Delete_At_Path_Input = {
  backUrlResponse?: Maybe<Array<Maybe<Scalars['String']>>>;
  constructionResponse?: Maybe<Array<Maybe<Scalars['String']>>>;
  notifyUrlResponse?: Maybe<Array<Maybe<Scalars['String']>>>;
  redirectUrlResponse?: Maybe<Array<Maybe<Scalars['String']>>>;
  requestData?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Transaction_Logs_Delete_Elem_Input = {
  backUrlResponse?: Maybe<Scalars['Int']>;
  constructionResponse?: Maybe<Scalars['Int']>;
  notifyUrlResponse?: Maybe<Scalars['Int']>;
  redirectUrlResponse?: Maybe<Scalars['Int']>;
  requestData?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Transaction_Logs_Delete_Key_Input = {
  backUrlResponse?: Maybe<Scalars['String']>;
  constructionResponse?: Maybe<Scalars['String']>;
  notifyUrlResponse?: Maybe<Scalars['String']>;
  redirectUrlResponse?: Maybe<Scalars['String']>;
  requestData?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "transaction_logs" */
export type Transaction_Logs_Insert_Input = {
  backUrlResponse?: Maybe<Scalars['jsonb']>;
  constructionResponse?: Maybe<Scalars['jsonb']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invoice?: Maybe<Invoices_Obj_Rel_Insert_Input>;
  invoiceId?: Maybe<Scalars['uuid']>;
  notifyUrlResponse?: Maybe<Scalars['jsonb']>;
  orderId?: Maybe<Scalars['String']>;
  partnerBank?: Maybe<Scalars['String']>;
  paymentAdvice?: Maybe<Payment_Advices_Obj_Rel_Insert_Input>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  redirectUrlResponse?: Maybe<Scalars['jsonb']>;
  requestData?: Maybe<Scalars['jsonb']>;
  status?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactionStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Transaction_Logs_Max_Fields = {
  __typename?: 'transaction_logs_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invoiceId?: Maybe<Scalars['uuid']>;
  orderId?: Maybe<Scalars['String']>;
  partnerBank?: Maybe<Scalars['String']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactionStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "transaction_logs" */
export type Transaction_Logs_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invoiceId?: Maybe<Order_By>;
  orderId?: Maybe<Order_By>;
  partnerBank?: Maybe<Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  transactionId?: Maybe<Order_By>;
  transactionStatus?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Transaction_Logs_Min_Fields = {
  __typename?: 'transaction_logs_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invoiceId?: Maybe<Scalars['uuid']>;
  orderId?: Maybe<Scalars['String']>;
  partnerBank?: Maybe<Scalars['String']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactionStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "transaction_logs" */
export type Transaction_Logs_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invoiceId?: Maybe<Order_By>;
  orderId?: Maybe<Order_By>;
  partnerBank?: Maybe<Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  transactionId?: Maybe<Order_By>;
  transactionStatus?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "transaction_logs" */
export type Transaction_Logs_Mutation_Response = {
  __typename?: 'transaction_logs_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Transaction_Logs>;
};

/** input type for inserting object relation for remote table "transaction_logs" */
export type Transaction_Logs_Obj_Rel_Insert_Input = {
  data: Transaction_Logs_Insert_Input;
  on_conflict?: Maybe<Transaction_Logs_On_Conflict>;
};

/** on conflict condition type for table "transaction_logs" */
export type Transaction_Logs_On_Conflict = {
  constraint: Transaction_Logs_Constraint;
  update_columns: Array<Transaction_Logs_Update_Column>;
  where?: Maybe<Transaction_Logs_Bool_Exp>;
};

/** ordering options when selecting data from "transaction_logs" */
export type Transaction_Logs_Order_By = {
  backUrlResponse?: Maybe<Order_By>;
  constructionResponse?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invoice?: Maybe<Invoices_Order_By>;
  invoiceId?: Maybe<Order_By>;
  notifyUrlResponse?: Maybe<Order_By>;
  orderId?: Maybe<Order_By>;
  partnerBank?: Maybe<Order_By>;
  paymentAdvice?: Maybe<Payment_Advices_Order_By>;
  paymentAdviceId?: Maybe<Order_By>;
  redirectUrlResponse?: Maybe<Order_By>;
  requestData?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  transactionId?: Maybe<Order_By>;
  transactionStatus?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "transaction_logs" */
export type Transaction_Logs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Transaction_Logs_Prepend_Input = {
  backUrlResponse?: Maybe<Scalars['jsonb']>;
  constructionResponse?: Maybe<Scalars['jsonb']>;
  notifyUrlResponse?: Maybe<Scalars['jsonb']>;
  redirectUrlResponse?: Maybe<Scalars['jsonb']>;
  requestData?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "transaction_logs" */
export enum Transaction_Logs_Select_Column {
  /** column name */
  BackUrlResponse = 'backUrlResponse',
  /** column name */
  ConstructionResponse = 'constructionResponse',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceId = 'invoiceId',
  /** column name */
  NotifyUrlResponse = 'notifyUrlResponse',
  /** column name */
  OrderId = 'orderId',
  /** column name */
  PartnerBank = 'partnerBank',
  /** column name */
  PaymentAdviceId = 'paymentAdviceId',
  /** column name */
  RedirectUrlResponse = 'redirectUrlResponse',
  /** column name */
  RequestData = 'requestData',
  /** column name */
  Status = 'status',
  /** column name */
  TransactionId = 'transactionId',
  /** column name */
  TransactionStatus = 'transactionStatus',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "transaction_logs" */
export type Transaction_Logs_Set_Input = {
  backUrlResponse?: Maybe<Scalars['jsonb']>;
  constructionResponse?: Maybe<Scalars['jsonb']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invoiceId?: Maybe<Scalars['uuid']>;
  notifyUrlResponse?: Maybe<Scalars['jsonb']>;
  orderId?: Maybe<Scalars['String']>;
  partnerBank?: Maybe<Scalars['String']>;
  paymentAdviceId?: Maybe<Scalars['uuid']>;
  redirectUrlResponse?: Maybe<Scalars['jsonb']>;
  requestData?: Maybe<Scalars['jsonb']>;
  status?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactionStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "transaction_logs" */
export enum Transaction_Logs_Update_Column {
  /** column name */
  BackUrlResponse = 'backUrlResponse',
  /** column name */
  ConstructionResponse = 'constructionResponse',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceId = 'invoiceId',
  /** column name */
  NotifyUrlResponse = 'notifyUrlResponse',
  /** column name */
  OrderId = 'orderId',
  /** column name */
  PartnerBank = 'partnerBank',
  /** column name */
  PaymentAdviceId = 'paymentAdviceId',
  /** column name */
  RedirectUrlResponse = 'redirectUrlResponse',
  /** column name */
  RequestData = 'requestData',
  /** column name */
  Status = 'status',
  /** column name */
  TransactionId = 'transactionId',
  /** column name */
  TransactionStatus = 'transactionStatus',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  /** An array relationship */
  additionalClassTicketsByUpdatedby: Array<Additional_Class_Tickets>;
  /** An aggregated array relationship */
  additionalClassTicketsByUpdatedby_aggregate: Additional_Class_Tickets_Aggregate;
  /** An array relationship */
  additional_class_tickets: Array<Additional_Class_Tickets>;
  /** An aggregated array relationship */
  additional_class_tickets_aggregate: Additional_Class_Tickets_Aggregate;
  address?: Maybe<Scalars['String']>;
  attachments?: Maybe<Scalars['jsonb']>;
  avatar?: Maybe<Scalars['String']>;
  /** An object relationship */
  bank?: Maybe<Banks>;
  bankId?: Maybe<Scalars['uuid']>;
  bankNumber?: Maybe<Scalars['String']>;
  /** An array relationship */
  banks: Array<Banks>;
  /** An array relationship */
  banksByUpdatedby: Array<Banks>;
  /** An aggregated array relationship */
  banksByUpdatedby_aggregate: Banks_Aggregate;
  /** An aggregated array relationship */
  banks_aggregate: Banks_Aggregate;
  /** An object relationship */
  branch?: Maybe<Branches>;
  branchId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  broadcast_logs: Array<Broadcast_Logs>;
  /** An aggregated array relationship */
  broadcast_logs_aggregate: Broadcast_Logs_Aggregate;
  /** An array relationship */
  broadcasts: Array<Broadcasts>;
  /** An array relationship */
  broadcastsByUpdatedby: Array<Broadcasts>;
  /** An aggregated array relationship */
  broadcastsByUpdatedby_aggregate: Broadcasts_Aggregate;
  /** An aggregated array relationship */
  broadcasts_aggregate: Broadcasts_Aggregate;
  code?: Maybe<Scalars['String']>;
  cognitoId?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  creditNoteClassesByUpdatedby: Array<Credit_Note_Classes>;
  /** An aggregated array relationship */
  creditNoteClassesByUpdatedby_aggregate: Credit_Note_Classes_Aggregate;
  /** An array relationship */
  creditNoteFeesByUpdatedby: Array<Credit_Note_Fees>;
  /** An aggregated array relationship */
  creditNoteFeesByUpdatedby_aggregate: Credit_Note_Fees_Aggregate;
  /** An array relationship */
  creditNotesByCreatedby: Array<Credit_Notes>;
  /** An aggregated array relationship */
  creditNotesByCreatedby_aggregate: Credit_Notes_Aggregate;
  /** An array relationship */
  creditNotesByStudentid: Array<Credit_Notes>;
  /** An aggregated array relationship */
  creditNotesByStudentid_aggregate: Credit_Notes_Aggregate;
  /** An array relationship */
  creditNotesByUpdatedby: Array<Credit_Notes>;
  /** An aggregated array relationship */
  creditNotesByUpdatedby_aggregate: Credit_Notes_Aggregate;
  /** An array relationship */
  credit_note_classes: Array<Credit_Note_Classes>;
  /** An aggregated array relationship */
  credit_note_classes_aggregate: Credit_Note_Classes_Aggregate;
  /** An array relationship */
  credit_note_fees: Array<Credit_Note_Fees>;
  /** An aggregated array relationship */
  credit_note_fees_aggregate: Credit_Note_Fees_Aggregate;
  /** An array relationship */
  credit_note_logs: Array<Credit_Note_Logs>;
  /** An aggregated array relationship */
  credit_note_logs_aggregate: Credit_Note_Logs_Aggregate;
  /** An array relationship */
  credit_notes: Array<Credit_Notes>;
  /** An aggregated array relationship */
  credit_notes_aggregate: Credit_Notes_Aggregate;
  /** An array relationship */
  curriculums: Array<Curriculums>;
  /** An array relationship */
  curriculumsByUpdatedby: Array<Curriculums>;
  /** An aggregated array relationship */
  curriculumsByUpdatedby_aggregate: Curriculums_Aggregate;
  /** An aggregated array relationship */
  curriculums_aggregate: Curriculums_Aggregate;
  /** An array relationship */
  deposits: Array<Deposits>;
  /** An aggregated array relationship */
  deposits_aggregate: Deposits_Aggregate;
  /** An array relationship */
  discountStudents: Array<Discount_Students>;
  /** An array relationship */
  discountStudentsByUpdatedby: Array<Discount_Students>;
  /** An aggregated array relationship */
  discountStudentsByUpdatedby_aggregate: Discount_Students_Aggregate;
  /** An aggregated array relationship */
  discountStudents_aggregate: Discount_Students_Aggregate;
  /** An array relationship */
  discount_students: Array<Discount_Students>;
  /** An aggregated array relationship */
  discount_students_aggregate: Discount_Students_Aggregate;
  dob?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An array relationship */
  invoices: Array<Invoices>;
  /** An array relationship */
  invoicesByUpdatedby: Array<Invoices>;
  /** An aggregated array relationship */
  invoicesByUpdatedby_aggregate: Invoices_Aggregate;
  /** An aggregated array relationship */
  invoices_aggregate: Invoices_Aggregate;
  isVerifiedEmail: Scalars['Boolean'];
  isVerifiedPhoneNumber: Scalars['Boolean'];
  lastName: Scalars['String'];
  /** An array relationship */
  lessons: Array<Lessons>;
  /** An array relationship */
  lessonsByUpdatedby: Array<Lessons>;
  /** An aggregated array relationship */
  lessonsByUpdatedby_aggregate: Lessons_Aggregate;
  /** An array relationship */
  lessonsStudents: Array<Lessons_Students>;
  /** An aggregated array relationship */
  lessonsStudents_aggregate: Lessons_Students_Aggregate;
  /** An aggregated array relationship */
  lessons_aggregate: Lessons_Aggregate;
  levelIds?: Maybe<Scalars['jsonb']>;
  /** A computed field, executes function "users_field_levels" */
  levels?: Maybe<Array<Levels>>;
  numOfFailed?: Maybe<Scalars['Int']>;
  /** An array relationship */
  paymentAdviceClassesByUpdatedby: Array<Payment_Advice_Classes>;
  /** An aggregated array relationship */
  paymentAdviceClassesByUpdatedby_aggregate: Payment_Advice_Classes_Aggregate;
  /** An array relationship */
  paymentAdvicesByStudentid: Array<Payment_Advices>;
  /** An aggregated array relationship */
  paymentAdvicesByStudentid_aggregate: Payment_Advices_Aggregate;
  /** An array relationship */
  paymentAdvicesByUpdatedby: Array<Payment_Advices>;
  /** An aggregated array relationship */
  paymentAdvicesByUpdatedby_aggregate: Payment_Advices_Aggregate;
  /** A computed field, executes function "users_field_payment_status" */
  paymentStatus?: Maybe<Scalars['String']>;
  /** An array relationship */
  payment_advice_classes: Array<Payment_Advice_Classes>;
  /** An aggregated array relationship */
  payment_advice_classes_aggregate: Payment_Advice_Classes_Aggregate;
  /** An array relationship */
  payment_advice_logs: Array<Payment_Advice_Logs>;
  /** An aggregated array relationship */
  payment_advice_logs_aggregate: Payment_Advice_Logs_Aggregate;
  /** An array relationship */
  payment_advices: Array<Payment_Advices>;
  /** An aggregated array relationship */
  payment_advices_aggregate: Payment_Advices_Aggregate;
  personGroupId?: Maybe<Scalars['jsonb']>;
  personIds?: Maybe<Scalars['jsonb']>;
  phone: Scalars['jsonb'];
  phoneNumber?: Maybe<Scalars['String']>;
  /** An array relationship */
  receipts: Array<Receipts>;
  /** An array relationship */
  receiptsByUpdatedby: Array<Receipts>;
  /** An aggregated array relationship */
  receiptsByUpdatedby_aggregate: Receipts_Aggregate;
  /** An aggregated array relationship */
  receipts_aggregate: Receipts_Aggregate;
  /** An array relationship */
  refund_logs: Array<Refund_Logs>;
  /** An aggregated array relationship */
  refund_logs_aggregate: Refund_Logs_Aggregate;
  /** An array relationship */
  refunds: Array<Refunds>;
  /** An aggregated array relationship */
  refunds_aggregate: Refunds_Aggregate;
  /** An array relationship */
  regular_programme_pricings: Array<Regular_Programme_Pricings>;
  /** An aggregated array relationship */
  regular_programme_pricings_aggregate: Regular_Programme_Pricings_Aggregate;
  role: Scalars['String'];
  roleIds?: Maybe<Scalars['jsonb']>;
  /** A computed field, executes function "users_field_roles" */
  roles?: Maybe<Array<Roles>>;
  /** An array relationship */
  sessions: Array<Sessions>;
  /** An array relationship */
  sessionsByUpdatedby: Array<Sessions>;
  /** An aggregated array relationship */
  sessionsByUpdatedby_aggregate: Sessions_Aggregate;
  /** An aggregated array relationship */
  sessions_aggregate: Sessions_Aggregate;
  /** An array relationship */
  siblings: Array<Discount_Students>;
  /** An aggregated array relationship */
  siblings_aggregate: Discount_Students_Aggregate;
  /** An array relationship */
  special_programme_class_pricings: Array<Special_Programme_Class_Pricings>;
  /** An aggregated array relationship */
  special_programme_class_pricings_aggregate: Special_Programme_Class_Pricings_Aggregate;
  status: Scalars['String'];
  studentId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  studentProfile?: Maybe<Student_Profiles>;
  /** An array relationship */
  studentProfilesByUpdatedby: Array<Student_Profiles>;
  /** An aggregated array relationship */
  studentProfilesByUpdatedby_aggregate: Student_Profiles_Aggregate;
  /** An array relationship */
  student_profiles: Array<Student_Profiles>;
  /** An aggregated array relationship */
  student_profiles_aggregate: Student_Profiles_Aggregate;
  /** An array relationship */
  studentsWaiting: Array<Class_Students_Waiting>;
  /** An aggregated array relationship */
  studentsWaiting_aggregate: Class_Students_Waiting_Aggregate;
  subjectIds?: Maybe<Scalars['jsonb']>;
  /** A computed field, executes function "users_field_subjects" */
  subjects?: Maybe<Array<Subjects>>;
  /** An array relationship */
  systemSettingsByUpdatedby: Array<System_Settings>;
  /** An aggregated array relationship */
  systemSettingsByUpdatedby_aggregate: System_Settings_Aggregate;
  /** An array relationship */
  system_settings: Array<System_Settings>;
  /** An aggregated array relationship */
  system_settings_aggregate: System_Settings_Aggregate;
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
  username?: Maybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersAdditionalClassTicketsByUpdatedbyArgs = {
  distinct_on?: Maybe<Array<Additional_Class_Tickets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Additional_Class_Tickets_Order_By>>;
  where?: Maybe<Additional_Class_Tickets_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAdditionalClassTicketsByUpdatedby_AggregateArgs = {
  distinct_on?: Maybe<Array<Additional_Class_Tickets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Additional_Class_Tickets_Order_By>>;
  where?: Maybe<Additional_Class_Tickets_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAdditional_Class_TicketsArgs = {
  distinct_on?: Maybe<Array<Additional_Class_Tickets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Additional_Class_Tickets_Order_By>>;
  where?: Maybe<Additional_Class_Tickets_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAdditional_Class_Tickets_AggregateArgs = {
  distinct_on?: Maybe<Array<Additional_Class_Tickets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Additional_Class_Tickets_Order_By>>;
  where?: Maybe<Additional_Class_Tickets_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAttachmentsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersBanksArgs = {
  distinct_on?: Maybe<Array<Banks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Banks_Order_By>>;
  where?: Maybe<Banks_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBanksByUpdatedbyArgs = {
  distinct_on?: Maybe<Array<Banks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Banks_Order_By>>;
  where?: Maybe<Banks_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBanksByUpdatedby_AggregateArgs = {
  distinct_on?: Maybe<Array<Banks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Banks_Order_By>>;
  where?: Maybe<Banks_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBanks_AggregateArgs = {
  distinct_on?: Maybe<Array<Banks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Banks_Order_By>>;
  where?: Maybe<Banks_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBroadcast_LogsArgs = {
  distinct_on?: Maybe<Array<Broadcast_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Broadcast_Logs_Order_By>>;
  where?: Maybe<Broadcast_Logs_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBroadcast_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Broadcast_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Broadcast_Logs_Order_By>>;
  where?: Maybe<Broadcast_Logs_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBroadcastsArgs = {
  distinct_on?: Maybe<Array<Broadcasts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Broadcasts_Order_By>>;
  where?: Maybe<Broadcasts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBroadcastsByUpdatedbyArgs = {
  distinct_on?: Maybe<Array<Broadcasts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Broadcasts_Order_By>>;
  where?: Maybe<Broadcasts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBroadcastsByUpdatedby_AggregateArgs = {
  distinct_on?: Maybe<Array<Broadcasts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Broadcasts_Order_By>>;
  where?: Maybe<Broadcasts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBroadcasts_AggregateArgs = {
  distinct_on?: Maybe<Array<Broadcasts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Broadcasts_Order_By>>;
  where?: Maybe<Broadcasts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCreditNoteClassesByUpdatedbyArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Classes_Order_By>>;
  where?: Maybe<Credit_Note_Classes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCreditNoteClassesByUpdatedby_AggregateArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Classes_Order_By>>;
  where?: Maybe<Credit_Note_Classes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCreditNoteFeesByUpdatedbyArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Fees_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Fees_Order_By>>;
  where?: Maybe<Credit_Note_Fees_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCreditNoteFeesByUpdatedby_AggregateArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Fees_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Fees_Order_By>>;
  where?: Maybe<Credit_Note_Fees_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCreditNotesByCreatedbyArgs = {
  distinct_on?: Maybe<Array<Credit_Notes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Notes_Order_By>>;
  where?: Maybe<Credit_Notes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCreditNotesByCreatedby_AggregateArgs = {
  distinct_on?: Maybe<Array<Credit_Notes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Notes_Order_By>>;
  where?: Maybe<Credit_Notes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCreditNotesByStudentidArgs = {
  distinct_on?: Maybe<Array<Credit_Notes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Notes_Order_By>>;
  where?: Maybe<Credit_Notes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCreditNotesByStudentid_AggregateArgs = {
  distinct_on?: Maybe<Array<Credit_Notes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Notes_Order_By>>;
  where?: Maybe<Credit_Notes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCreditNotesByUpdatedbyArgs = {
  distinct_on?: Maybe<Array<Credit_Notes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Notes_Order_By>>;
  where?: Maybe<Credit_Notes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCreditNotesByUpdatedby_AggregateArgs = {
  distinct_on?: Maybe<Array<Credit_Notes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Notes_Order_By>>;
  where?: Maybe<Credit_Notes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCredit_Note_ClassesArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Classes_Order_By>>;
  where?: Maybe<Credit_Note_Classes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCredit_Note_Classes_AggregateArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Classes_Order_By>>;
  where?: Maybe<Credit_Note_Classes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCredit_Note_FeesArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Fees_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Fees_Order_By>>;
  where?: Maybe<Credit_Note_Fees_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCredit_Note_Fees_AggregateArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Fees_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Fees_Order_By>>;
  where?: Maybe<Credit_Note_Fees_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCredit_Note_LogsArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Logs_Order_By>>;
  where?: Maybe<Credit_Note_Logs_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCredit_Note_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Credit_Note_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Note_Logs_Order_By>>;
  where?: Maybe<Credit_Note_Logs_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCredit_NotesArgs = {
  distinct_on?: Maybe<Array<Credit_Notes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Notes_Order_By>>;
  where?: Maybe<Credit_Notes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCredit_Notes_AggregateArgs = {
  distinct_on?: Maybe<Array<Credit_Notes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credit_Notes_Order_By>>;
  where?: Maybe<Credit_Notes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCurriculumsArgs = {
  distinct_on?: Maybe<Array<Curriculums_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Curriculums_Order_By>>;
  where?: Maybe<Curriculums_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCurriculumsByUpdatedbyArgs = {
  distinct_on?: Maybe<Array<Curriculums_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Curriculums_Order_By>>;
  where?: Maybe<Curriculums_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCurriculumsByUpdatedby_AggregateArgs = {
  distinct_on?: Maybe<Array<Curriculums_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Curriculums_Order_By>>;
  where?: Maybe<Curriculums_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCurriculums_AggregateArgs = {
  distinct_on?: Maybe<Array<Curriculums_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Curriculums_Order_By>>;
  where?: Maybe<Curriculums_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersDepositsArgs = {
  distinct_on?: Maybe<Array<Deposits_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Deposits_Order_By>>;
  where?: Maybe<Deposits_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersDeposits_AggregateArgs = {
  distinct_on?: Maybe<Array<Deposits_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Deposits_Order_By>>;
  where?: Maybe<Deposits_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersDiscountStudentsArgs = {
  distinct_on?: Maybe<Array<Discount_Students_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discount_Students_Order_By>>;
  where?: Maybe<Discount_Students_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersDiscountStudentsByUpdatedbyArgs = {
  distinct_on?: Maybe<Array<Discount_Students_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discount_Students_Order_By>>;
  where?: Maybe<Discount_Students_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersDiscountStudentsByUpdatedby_AggregateArgs = {
  distinct_on?: Maybe<Array<Discount_Students_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discount_Students_Order_By>>;
  where?: Maybe<Discount_Students_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersDiscountStudents_AggregateArgs = {
  distinct_on?: Maybe<Array<Discount_Students_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discount_Students_Order_By>>;
  where?: Maybe<Discount_Students_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersDiscount_StudentsArgs = {
  distinct_on?: Maybe<Array<Discount_Students_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discount_Students_Order_By>>;
  where?: Maybe<Discount_Students_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersDiscount_Students_AggregateArgs = {
  distinct_on?: Maybe<Array<Discount_Students_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discount_Students_Order_By>>;
  where?: Maybe<Discount_Students_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersInvoicesArgs = {
  distinct_on?: Maybe<Array<Invoices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoices_Order_By>>;
  where?: Maybe<Invoices_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersInvoicesByUpdatedbyArgs = {
  distinct_on?: Maybe<Array<Invoices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoices_Order_By>>;
  where?: Maybe<Invoices_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersInvoicesByUpdatedby_AggregateArgs = {
  distinct_on?: Maybe<Array<Invoices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoices_Order_By>>;
  where?: Maybe<Invoices_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersInvoices_AggregateArgs = {
  distinct_on?: Maybe<Array<Invoices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoices_Order_By>>;
  where?: Maybe<Invoices_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLessonsArgs = {
  distinct_on?: Maybe<Array<Lessons_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Order_By>>;
  where?: Maybe<Lessons_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLessonsByUpdatedbyArgs = {
  distinct_on?: Maybe<Array<Lessons_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Order_By>>;
  where?: Maybe<Lessons_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLessonsByUpdatedby_AggregateArgs = {
  distinct_on?: Maybe<Array<Lessons_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Order_By>>;
  where?: Maybe<Lessons_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLessonsStudentsArgs = {
  distinct_on?: Maybe<Array<Lessons_Students_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Students_Order_By>>;
  where?: Maybe<Lessons_Students_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLessonsStudents_AggregateArgs = {
  distinct_on?: Maybe<Array<Lessons_Students_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Students_Order_By>>;
  where?: Maybe<Lessons_Students_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLessons_AggregateArgs = {
  distinct_on?: Maybe<Array<Lessons_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Order_By>>;
  where?: Maybe<Lessons_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLevelIdsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersLevelsArgs = {
  distinct_on?: Maybe<Array<Levels_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Levels_Order_By>>;
  where?: Maybe<Levels_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPaymentAdviceClassesByUpdatedbyArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Classes_Order_By>>;
  where?: Maybe<Payment_Advice_Classes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPaymentAdviceClassesByUpdatedby_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Classes_Order_By>>;
  where?: Maybe<Payment_Advice_Classes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPaymentAdvicesByStudentidArgs = {
  distinct_on?: Maybe<Array<Payment_Advices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advices_Order_By>>;
  where?: Maybe<Payment_Advices_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPaymentAdvicesByStudentid_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advices_Order_By>>;
  where?: Maybe<Payment_Advices_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPaymentAdvicesByUpdatedbyArgs = {
  distinct_on?: Maybe<Array<Payment_Advices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advices_Order_By>>;
  where?: Maybe<Payment_Advices_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPaymentAdvicesByUpdatedby_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advices_Order_By>>;
  where?: Maybe<Payment_Advices_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPayment_Advice_ClassesArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Classes_Order_By>>;
  where?: Maybe<Payment_Advice_Classes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPayment_Advice_Classes_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Classes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Classes_Order_By>>;
  where?: Maybe<Payment_Advice_Classes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPayment_Advice_LogsArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Logs_Order_By>>;
  where?: Maybe<Payment_Advice_Logs_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPayment_Advice_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advice_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advice_Logs_Order_By>>;
  where?: Maybe<Payment_Advice_Logs_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPayment_AdvicesArgs = {
  distinct_on?: Maybe<Array<Payment_Advices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advices_Order_By>>;
  where?: Maybe<Payment_Advices_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPayment_Advices_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Advices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Advices_Order_By>>;
  where?: Maybe<Payment_Advices_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPersonGroupIdArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersPersonIdsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersPhoneArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersReceiptsArgs = {
  distinct_on?: Maybe<Array<Receipts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Receipts_Order_By>>;
  where?: Maybe<Receipts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersReceiptsByUpdatedbyArgs = {
  distinct_on?: Maybe<Array<Receipts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Receipts_Order_By>>;
  where?: Maybe<Receipts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersReceiptsByUpdatedby_AggregateArgs = {
  distinct_on?: Maybe<Array<Receipts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Receipts_Order_By>>;
  where?: Maybe<Receipts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersReceipts_AggregateArgs = {
  distinct_on?: Maybe<Array<Receipts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Receipts_Order_By>>;
  where?: Maybe<Receipts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRefund_LogsArgs = {
  distinct_on?: Maybe<Array<Refund_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refund_Logs_Order_By>>;
  where?: Maybe<Refund_Logs_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRefund_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Refund_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refund_Logs_Order_By>>;
  where?: Maybe<Refund_Logs_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRefundsArgs = {
  distinct_on?: Maybe<Array<Refunds_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refunds_Order_By>>;
  where?: Maybe<Refunds_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRefunds_AggregateArgs = {
  distinct_on?: Maybe<Array<Refunds_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refunds_Order_By>>;
  where?: Maybe<Refunds_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRegular_Programme_PricingsArgs = {
  distinct_on?: Maybe<Array<Regular_Programme_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Regular_Programme_Pricings_Order_By>>;
  where?: Maybe<Regular_Programme_Pricings_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRegular_Programme_Pricings_AggregateArgs = {
  distinct_on?: Maybe<Array<Regular_Programme_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Regular_Programme_Pricings_Order_By>>;
  where?: Maybe<Regular_Programme_Pricings_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRoleIdsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersRolesArgs = {
  distinct_on?: Maybe<Array<Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Roles_Order_By>>;
  where?: Maybe<Roles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSessionsArgs = {
  distinct_on?: Maybe<Array<Sessions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Sessions_Order_By>>;
  where?: Maybe<Sessions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSessionsByUpdatedbyArgs = {
  distinct_on?: Maybe<Array<Sessions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Sessions_Order_By>>;
  where?: Maybe<Sessions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSessionsByUpdatedby_AggregateArgs = {
  distinct_on?: Maybe<Array<Sessions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Sessions_Order_By>>;
  where?: Maybe<Sessions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSessions_AggregateArgs = {
  distinct_on?: Maybe<Array<Sessions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Sessions_Order_By>>;
  where?: Maybe<Sessions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSiblingsArgs = {
  distinct_on?: Maybe<Array<Discount_Students_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discount_Students_Order_By>>;
  where?: Maybe<Discount_Students_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSiblings_AggregateArgs = {
  distinct_on?: Maybe<Array<Discount_Students_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discount_Students_Order_By>>;
  where?: Maybe<Discount_Students_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSpecial_Programme_Class_PricingsArgs = {
  distinct_on?: Maybe<Array<Special_Programme_Class_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Special_Programme_Class_Pricings_Order_By>>;
  where?: Maybe<Special_Programme_Class_Pricings_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSpecial_Programme_Class_Pricings_AggregateArgs = {
  distinct_on?: Maybe<Array<Special_Programme_Class_Pricings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Special_Programme_Class_Pricings_Order_By>>;
  where?: Maybe<Special_Programme_Class_Pricings_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersStudentProfilesByUpdatedbyArgs = {
  distinct_on?: Maybe<Array<Student_Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Student_Profiles_Order_By>>;
  where?: Maybe<Student_Profiles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersStudentProfilesByUpdatedby_AggregateArgs = {
  distinct_on?: Maybe<Array<Student_Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Student_Profiles_Order_By>>;
  where?: Maybe<Student_Profiles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersStudent_ProfilesArgs = {
  distinct_on?: Maybe<Array<Student_Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Student_Profiles_Order_By>>;
  where?: Maybe<Student_Profiles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersStudent_Profiles_AggregateArgs = {
  distinct_on?: Maybe<Array<Student_Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Student_Profiles_Order_By>>;
  where?: Maybe<Student_Profiles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersStudentsWaitingArgs = {
  distinct_on?: Maybe<Array<Class_Students_Waiting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Class_Students_Waiting_Order_By>>;
  where?: Maybe<Class_Students_Waiting_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersStudentsWaiting_AggregateArgs = {
  distinct_on?: Maybe<Array<Class_Students_Waiting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Class_Students_Waiting_Order_By>>;
  where?: Maybe<Class_Students_Waiting_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSubjectIdsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersSubjectsArgs = {
  distinct_on?: Maybe<Array<Subjects_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Subjects_Order_By>>;
  where?: Maybe<Subjects_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSystemSettingsByUpdatedbyArgs = {
  distinct_on?: Maybe<Array<System_Settings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<System_Settings_Order_By>>;
  where?: Maybe<System_Settings_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSystemSettingsByUpdatedby_AggregateArgs = {
  distinct_on?: Maybe<Array<System_Settings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<System_Settings_Order_By>>;
  where?: Maybe<System_Settings_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSystem_SettingsArgs = {
  distinct_on?: Maybe<Array<System_Settings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<System_Settings_Order_By>>;
  where?: Maybe<System_Settings_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSystem_Settings_AggregateArgs = {
  distinct_on?: Maybe<Array<System_Settings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<System_Settings_Order_By>>;
  where?: Maybe<System_Settings_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  avg?: Maybe<Users_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
  stddev?: Maybe<Users_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Sum_Fields>;
  var_pop?: Maybe<Users_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Var_Samp_Fields>;
  variance?: Maybe<Users_Variance_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Users_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "users" */
export type Users_Aggregate_Order_By = {
  avg?: Maybe<Users_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Users_Max_Order_By>;
  min?: Maybe<Users_Min_Order_By>;
  stddev?: Maybe<Users_Stddev_Order_By>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Order_By>;
  sum?: Maybe<Users_Sum_Order_By>;
  var_pop?: Maybe<Users_Var_Pop_Order_By>;
  var_samp?: Maybe<Users_Var_Samp_Order_By>;
  variance?: Maybe<Users_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Users_Append_Input = {
  attachments?: Maybe<Scalars['jsonb']>;
  levelIds?: Maybe<Scalars['jsonb']>;
  personGroupId?: Maybe<Scalars['jsonb']>;
  personIds?: Maybe<Scalars['jsonb']>;
  phone?: Maybe<Scalars['jsonb']>;
  roleIds?: Maybe<Scalars['jsonb']>;
  subjectIds?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  on_conflict?: Maybe<Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  __typename?: 'users_avg_fields';
  numOfFailed?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "users" */
export type Users_Avg_Order_By = {
  numOfFailed?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Users_Bool_Exp>>>;
  _not?: Maybe<Users_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Users_Bool_Exp>>>;
  additionalClassTicketsByUpdatedby?: Maybe<Additional_Class_Tickets_Bool_Exp>;
  additional_class_tickets?: Maybe<Additional_Class_Tickets_Bool_Exp>;
  address?: Maybe<String_Comparison_Exp>;
  attachments?: Maybe<Jsonb_Comparison_Exp>;
  avatar?: Maybe<String_Comparison_Exp>;
  bank?: Maybe<Banks_Bool_Exp>;
  bankId?: Maybe<Uuid_Comparison_Exp>;
  bankNumber?: Maybe<String_Comparison_Exp>;
  banks?: Maybe<Banks_Bool_Exp>;
  banksByUpdatedby?: Maybe<Banks_Bool_Exp>;
  branch?: Maybe<Branches_Bool_Exp>;
  branchId?: Maybe<Uuid_Comparison_Exp>;
  broadcast_logs?: Maybe<Broadcast_Logs_Bool_Exp>;
  broadcasts?: Maybe<Broadcasts_Bool_Exp>;
  broadcastsByUpdatedby?: Maybe<Broadcasts_Bool_Exp>;
  code?: Maybe<String_Comparison_Exp>;
  cognitoId?: Maybe<String_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  creditNoteClassesByUpdatedby?: Maybe<Credit_Note_Classes_Bool_Exp>;
  creditNoteFeesByUpdatedby?: Maybe<Credit_Note_Fees_Bool_Exp>;
  creditNotesByCreatedby?: Maybe<Credit_Notes_Bool_Exp>;
  creditNotesByStudentid?: Maybe<Credit_Notes_Bool_Exp>;
  creditNotesByUpdatedby?: Maybe<Credit_Notes_Bool_Exp>;
  credit_note_classes?: Maybe<Credit_Note_Classes_Bool_Exp>;
  credit_note_fees?: Maybe<Credit_Note_Fees_Bool_Exp>;
  credit_note_logs?: Maybe<Credit_Note_Logs_Bool_Exp>;
  credit_notes?: Maybe<Credit_Notes_Bool_Exp>;
  curriculums?: Maybe<Curriculums_Bool_Exp>;
  curriculumsByUpdatedby?: Maybe<Curriculums_Bool_Exp>;
  deposits?: Maybe<Deposits_Bool_Exp>;
  discountStudents?: Maybe<Discount_Students_Bool_Exp>;
  discountStudentsByUpdatedby?: Maybe<Discount_Students_Bool_Exp>;
  discount_students?: Maybe<Discount_Students_Bool_Exp>;
  dob?: Maybe<Timestamptz_Comparison_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  firstName?: Maybe<String_Comparison_Exp>;
  fullName?: Maybe<String_Comparison_Exp>;
  gender?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  invoices?: Maybe<Invoices_Bool_Exp>;
  invoicesByUpdatedby?: Maybe<Invoices_Bool_Exp>;
  isVerifiedEmail?: Maybe<Boolean_Comparison_Exp>;
  isVerifiedPhoneNumber?: Maybe<Boolean_Comparison_Exp>;
  lastName?: Maybe<String_Comparison_Exp>;
  lessons?: Maybe<Lessons_Bool_Exp>;
  lessonsByUpdatedby?: Maybe<Lessons_Bool_Exp>;
  lessonsStudents?: Maybe<Lessons_Students_Bool_Exp>;
  levelIds?: Maybe<Jsonb_Comparison_Exp>;
  numOfFailed?: Maybe<Int_Comparison_Exp>;
  paymentAdviceClassesByUpdatedby?: Maybe<Payment_Advice_Classes_Bool_Exp>;
  paymentAdvicesByStudentid?: Maybe<Payment_Advices_Bool_Exp>;
  paymentAdvicesByUpdatedby?: Maybe<Payment_Advices_Bool_Exp>;
  payment_advice_classes?: Maybe<Payment_Advice_Classes_Bool_Exp>;
  payment_advice_logs?: Maybe<Payment_Advice_Logs_Bool_Exp>;
  payment_advices?: Maybe<Payment_Advices_Bool_Exp>;
  personGroupId?: Maybe<Jsonb_Comparison_Exp>;
  personIds?: Maybe<Jsonb_Comparison_Exp>;
  phone?: Maybe<Jsonb_Comparison_Exp>;
  phoneNumber?: Maybe<String_Comparison_Exp>;
  receipts?: Maybe<Receipts_Bool_Exp>;
  receiptsByUpdatedby?: Maybe<Receipts_Bool_Exp>;
  refund_logs?: Maybe<Refund_Logs_Bool_Exp>;
  refunds?: Maybe<Refunds_Bool_Exp>;
  regular_programme_pricings?: Maybe<Regular_Programme_Pricings_Bool_Exp>;
  role?: Maybe<String_Comparison_Exp>;
  roleIds?: Maybe<Jsonb_Comparison_Exp>;
  sessions?: Maybe<Sessions_Bool_Exp>;
  sessionsByUpdatedby?: Maybe<Sessions_Bool_Exp>;
  siblings?: Maybe<Discount_Students_Bool_Exp>;
  special_programme_class_pricings?: Maybe<Special_Programme_Class_Pricings_Bool_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  studentId?: Maybe<Uuid_Comparison_Exp>;
  studentProfile?: Maybe<Student_Profiles_Bool_Exp>;
  studentProfilesByUpdatedby?: Maybe<Student_Profiles_Bool_Exp>;
  student_profiles?: Maybe<Student_Profiles_Bool_Exp>;
  studentsWaiting?: Maybe<Class_Students_Waiting_Bool_Exp>;
  subjectIds?: Maybe<Jsonb_Comparison_Exp>;
  systemSettingsByUpdatedby?: Maybe<System_Settings_Bool_Exp>;
  system_settings?: Maybe<System_Settings_Bool_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
  username?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint */
  UsersCognitoIdKey = 'users_cognitoId_key',
  /** unique or primary key constraint */
  UsersPkey = 'users_pkey',
  /** unique or primary key constraint */
  UsersUsernameKey = 'users_username_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Users_Delete_At_Path_Input = {
  attachments?: Maybe<Array<Maybe<Scalars['String']>>>;
  levelIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  personGroupId?: Maybe<Array<Maybe<Scalars['String']>>>;
  personIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  phone?: Maybe<Array<Maybe<Scalars['String']>>>;
  roleIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  subjectIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Users_Delete_Elem_Input = {
  attachments?: Maybe<Scalars['Int']>;
  levelIds?: Maybe<Scalars['Int']>;
  personGroupId?: Maybe<Scalars['Int']>;
  personIds?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['Int']>;
  roleIds?: Maybe<Scalars['Int']>;
  subjectIds?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Users_Delete_Key_Input = {
  attachments?: Maybe<Scalars['String']>;
  levelIds?: Maybe<Scalars['String']>;
  personGroupId?: Maybe<Scalars['String']>;
  personIds?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  roleIds?: Maybe<Scalars['String']>;
  subjectIds?: Maybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "users" */
export type Users_Inc_Input = {
  numOfFailed?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  additionalClassTicketsByUpdatedby?: Maybe<Additional_Class_Tickets_Arr_Rel_Insert_Input>;
  additional_class_tickets?: Maybe<Additional_Class_Tickets_Arr_Rel_Insert_Input>;
  address?: Maybe<Scalars['String']>;
  attachments?: Maybe<Scalars['jsonb']>;
  avatar?: Maybe<Scalars['String']>;
  bank?: Maybe<Banks_Obj_Rel_Insert_Input>;
  bankId?: Maybe<Scalars['uuid']>;
  bankNumber?: Maybe<Scalars['String']>;
  banks?: Maybe<Banks_Arr_Rel_Insert_Input>;
  banksByUpdatedby?: Maybe<Banks_Arr_Rel_Insert_Input>;
  branch?: Maybe<Branches_Obj_Rel_Insert_Input>;
  branchId?: Maybe<Scalars['uuid']>;
  broadcast_logs?: Maybe<Broadcast_Logs_Arr_Rel_Insert_Input>;
  broadcasts?: Maybe<Broadcasts_Arr_Rel_Insert_Input>;
  broadcastsByUpdatedby?: Maybe<Broadcasts_Arr_Rel_Insert_Input>;
  code?: Maybe<Scalars['String']>;
  cognitoId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  creditNoteClassesByUpdatedby?: Maybe<Credit_Note_Classes_Arr_Rel_Insert_Input>;
  creditNoteFeesByUpdatedby?: Maybe<Credit_Note_Fees_Arr_Rel_Insert_Input>;
  creditNotesByCreatedby?: Maybe<Credit_Notes_Arr_Rel_Insert_Input>;
  creditNotesByStudentid?: Maybe<Credit_Notes_Arr_Rel_Insert_Input>;
  creditNotesByUpdatedby?: Maybe<Credit_Notes_Arr_Rel_Insert_Input>;
  credit_note_classes?: Maybe<Credit_Note_Classes_Arr_Rel_Insert_Input>;
  credit_note_fees?: Maybe<Credit_Note_Fees_Arr_Rel_Insert_Input>;
  credit_note_logs?: Maybe<Credit_Note_Logs_Arr_Rel_Insert_Input>;
  credit_notes?: Maybe<Credit_Notes_Arr_Rel_Insert_Input>;
  curriculums?: Maybe<Curriculums_Arr_Rel_Insert_Input>;
  curriculumsByUpdatedby?: Maybe<Curriculums_Arr_Rel_Insert_Input>;
  deposits?: Maybe<Deposits_Arr_Rel_Insert_Input>;
  discountStudents?: Maybe<Discount_Students_Arr_Rel_Insert_Input>;
  discountStudentsByUpdatedby?: Maybe<Discount_Students_Arr_Rel_Insert_Input>;
  discount_students?: Maybe<Discount_Students_Arr_Rel_Insert_Input>;
  dob?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  invoices?: Maybe<Invoices_Arr_Rel_Insert_Input>;
  invoicesByUpdatedby?: Maybe<Invoices_Arr_Rel_Insert_Input>;
  isVerifiedEmail?: Maybe<Scalars['Boolean']>;
  isVerifiedPhoneNumber?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  lessons?: Maybe<Lessons_Arr_Rel_Insert_Input>;
  lessonsByUpdatedby?: Maybe<Lessons_Arr_Rel_Insert_Input>;
  lessonsStudents?: Maybe<Lessons_Students_Arr_Rel_Insert_Input>;
  levelIds?: Maybe<Scalars['jsonb']>;
  numOfFailed?: Maybe<Scalars['Int']>;
  paymentAdviceClassesByUpdatedby?: Maybe<Payment_Advice_Classes_Arr_Rel_Insert_Input>;
  paymentAdvicesByStudentid?: Maybe<Payment_Advices_Arr_Rel_Insert_Input>;
  paymentAdvicesByUpdatedby?: Maybe<Payment_Advices_Arr_Rel_Insert_Input>;
  payment_advice_classes?: Maybe<Payment_Advice_Classes_Arr_Rel_Insert_Input>;
  payment_advice_logs?: Maybe<Payment_Advice_Logs_Arr_Rel_Insert_Input>;
  payment_advices?: Maybe<Payment_Advices_Arr_Rel_Insert_Input>;
  personGroupId?: Maybe<Scalars['jsonb']>;
  personIds?: Maybe<Scalars['jsonb']>;
  phone?: Maybe<Scalars['jsonb']>;
  phoneNumber?: Maybe<Scalars['String']>;
  receipts?: Maybe<Receipts_Arr_Rel_Insert_Input>;
  receiptsByUpdatedby?: Maybe<Receipts_Arr_Rel_Insert_Input>;
  refund_logs?: Maybe<Refund_Logs_Arr_Rel_Insert_Input>;
  refunds?: Maybe<Refunds_Arr_Rel_Insert_Input>;
  regular_programme_pricings?: Maybe<Regular_Programme_Pricings_Arr_Rel_Insert_Input>;
  role?: Maybe<Scalars['String']>;
  roleIds?: Maybe<Scalars['jsonb']>;
  sessions?: Maybe<Sessions_Arr_Rel_Insert_Input>;
  sessionsByUpdatedby?: Maybe<Sessions_Arr_Rel_Insert_Input>;
  siblings?: Maybe<Discount_Students_Arr_Rel_Insert_Input>;
  special_programme_class_pricings?: Maybe<Special_Programme_Class_Pricings_Arr_Rel_Insert_Input>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  studentProfile?: Maybe<Student_Profiles_Obj_Rel_Insert_Input>;
  studentProfilesByUpdatedby?: Maybe<Student_Profiles_Arr_Rel_Insert_Input>;
  student_profiles?: Maybe<Student_Profiles_Arr_Rel_Insert_Input>;
  studentsWaiting?: Maybe<Class_Students_Waiting_Arr_Rel_Insert_Input>;
  subjectIds?: Maybe<Scalars['jsonb']>;
  systemSettingsByUpdatedby?: Maybe<System_Settings_Arr_Rel_Insert_Input>;
  system_settings?: Maybe<System_Settings_Arr_Rel_Insert_Input>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  username?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  address?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['uuid']>;
  bankNumber?: Maybe<Scalars['String']>;
  branchId?: Maybe<Scalars['uuid']>;
  code?: Maybe<Scalars['String']>;
  cognitoId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  dob?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  numOfFailed?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  username?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "users" */
export type Users_Max_Order_By = {
  address?: Maybe<Order_By>;
  avatar?: Maybe<Order_By>;
  bankId?: Maybe<Order_By>;
  bankNumber?: Maybe<Order_By>;
  branchId?: Maybe<Order_By>;
  code?: Maybe<Order_By>;
  cognitoId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  dob?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  firstName?: Maybe<Order_By>;
  fullName?: Maybe<Order_By>;
  gender?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lastName?: Maybe<Order_By>;
  numOfFailed?: Maybe<Order_By>;
  phoneNumber?: Maybe<Order_By>;
  role?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  username?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  address?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['uuid']>;
  bankNumber?: Maybe<Scalars['String']>;
  branchId?: Maybe<Scalars['uuid']>;
  code?: Maybe<Scalars['String']>;
  cognitoId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  dob?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  numOfFailed?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  username?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "users" */
export type Users_Min_Order_By = {
  address?: Maybe<Order_By>;
  avatar?: Maybe<Order_By>;
  bankId?: Maybe<Order_By>;
  bankNumber?: Maybe<Order_By>;
  branchId?: Maybe<Order_By>;
  code?: Maybe<Order_By>;
  cognitoId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  dob?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  firstName?: Maybe<Order_By>;
  fullName?: Maybe<Order_By>;
  gender?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lastName?: Maybe<Order_By>;
  numOfFailed?: Maybe<Order_By>;
  phoneNumber?: Maybe<Order_By>;
  role?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  username?: Maybe<Order_By>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  on_conflict?: Maybe<Users_On_Conflict>;
};

/** on conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns: Array<Users_Update_Column>;
  where?: Maybe<Users_Bool_Exp>;
};

/** ordering options when selecting data from "users" */
export type Users_Order_By = {
  additionalClassTicketsByUpdatedby_aggregate?: Maybe<Additional_Class_Tickets_Aggregate_Order_By>;
  additional_class_tickets_aggregate?: Maybe<Additional_Class_Tickets_Aggregate_Order_By>;
  address?: Maybe<Order_By>;
  attachments?: Maybe<Order_By>;
  avatar?: Maybe<Order_By>;
  bank?: Maybe<Banks_Order_By>;
  bankId?: Maybe<Order_By>;
  bankNumber?: Maybe<Order_By>;
  banksByUpdatedby_aggregate?: Maybe<Banks_Aggregate_Order_By>;
  banks_aggregate?: Maybe<Banks_Aggregate_Order_By>;
  branch?: Maybe<Branches_Order_By>;
  branchId?: Maybe<Order_By>;
  broadcast_logs_aggregate?: Maybe<Broadcast_Logs_Aggregate_Order_By>;
  broadcastsByUpdatedby_aggregate?: Maybe<Broadcasts_Aggregate_Order_By>;
  broadcasts_aggregate?: Maybe<Broadcasts_Aggregate_Order_By>;
  code?: Maybe<Order_By>;
  cognitoId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  creditNoteClassesByUpdatedby_aggregate?: Maybe<Credit_Note_Classes_Aggregate_Order_By>;
  creditNoteFeesByUpdatedby_aggregate?: Maybe<Credit_Note_Fees_Aggregate_Order_By>;
  creditNotesByCreatedby_aggregate?: Maybe<Credit_Notes_Aggregate_Order_By>;
  creditNotesByStudentid_aggregate?: Maybe<Credit_Notes_Aggregate_Order_By>;
  creditNotesByUpdatedby_aggregate?: Maybe<Credit_Notes_Aggregate_Order_By>;
  credit_note_classes_aggregate?: Maybe<Credit_Note_Classes_Aggregate_Order_By>;
  credit_note_fees_aggregate?: Maybe<Credit_Note_Fees_Aggregate_Order_By>;
  credit_note_logs_aggregate?: Maybe<Credit_Note_Logs_Aggregate_Order_By>;
  credit_notes_aggregate?: Maybe<Credit_Notes_Aggregate_Order_By>;
  curriculumsByUpdatedby_aggregate?: Maybe<Curriculums_Aggregate_Order_By>;
  curriculums_aggregate?: Maybe<Curriculums_Aggregate_Order_By>;
  deposits_aggregate?: Maybe<Deposits_Aggregate_Order_By>;
  discountStudentsByUpdatedby_aggregate?: Maybe<Discount_Students_Aggregate_Order_By>;
  discountStudents_aggregate?: Maybe<Discount_Students_Aggregate_Order_By>;
  discount_students_aggregate?: Maybe<Discount_Students_Aggregate_Order_By>;
  dob?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  firstName?: Maybe<Order_By>;
  fullName?: Maybe<Order_By>;
  gender?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invoicesByUpdatedby_aggregate?: Maybe<Invoices_Aggregate_Order_By>;
  invoices_aggregate?: Maybe<Invoices_Aggregate_Order_By>;
  isVerifiedEmail?: Maybe<Order_By>;
  isVerifiedPhoneNumber?: Maybe<Order_By>;
  lastName?: Maybe<Order_By>;
  lessonsByUpdatedby_aggregate?: Maybe<Lessons_Aggregate_Order_By>;
  lessonsStudents_aggregate?: Maybe<Lessons_Students_Aggregate_Order_By>;
  lessons_aggregate?: Maybe<Lessons_Aggregate_Order_By>;
  levelIds?: Maybe<Order_By>;
  numOfFailed?: Maybe<Order_By>;
  paymentAdviceClassesByUpdatedby_aggregate?: Maybe<Payment_Advice_Classes_Aggregate_Order_By>;
  paymentAdvicesByStudentid_aggregate?: Maybe<Payment_Advices_Aggregate_Order_By>;
  paymentAdvicesByUpdatedby_aggregate?: Maybe<Payment_Advices_Aggregate_Order_By>;
  payment_advice_classes_aggregate?: Maybe<Payment_Advice_Classes_Aggregate_Order_By>;
  payment_advice_logs_aggregate?: Maybe<Payment_Advice_Logs_Aggregate_Order_By>;
  payment_advices_aggregate?: Maybe<Payment_Advices_Aggregate_Order_By>;
  personGroupId?: Maybe<Order_By>;
  personIds?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  phoneNumber?: Maybe<Order_By>;
  receiptsByUpdatedby_aggregate?: Maybe<Receipts_Aggregate_Order_By>;
  receipts_aggregate?: Maybe<Receipts_Aggregate_Order_By>;
  refund_logs_aggregate?: Maybe<Refund_Logs_Aggregate_Order_By>;
  refunds_aggregate?: Maybe<Refunds_Aggregate_Order_By>;
  regular_programme_pricings_aggregate?: Maybe<Regular_Programme_Pricings_Aggregate_Order_By>;
  role?: Maybe<Order_By>;
  roleIds?: Maybe<Order_By>;
  sessionsByUpdatedby_aggregate?: Maybe<Sessions_Aggregate_Order_By>;
  sessions_aggregate?: Maybe<Sessions_Aggregate_Order_By>;
  siblings_aggregate?: Maybe<Discount_Students_Aggregate_Order_By>;
  special_programme_class_pricings_aggregate?: Maybe<Special_Programme_Class_Pricings_Aggregate_Order_By>;
  status?: Maybe<Order_By>;
  studentId?: Maybe<Order_By>;
  studentProfile?: Maybe<Student_Profiles_Order_By>;
  studentProfilesByUpdatedby_aggregate?: Maybe<Student_Profiles_Aggregate_Order_By>;
  student_profiles_aggregate?: Maybe<Student_Profiles_Aggregate_Order_By>;
  studentsWaiting_aggregate?: Maybe<Class_Students_Waiting_Aggregate_Order_By>;
  subjectIds?: Maybe<Order_By>;
  systemSettingsByUpdatedby_aggregate?: Maybe<System_Settings_Aggregate_Order_By>;
  system_settings_aggregate?: Maybe<System_Settings_Aggregate_Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
  username?: Maybe<Order_By>;
};

/** primary key columns input for table: "users" */
export type Users_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Users_Prepend_Input = {
  attachments?: Maybe<Scalars['jsonb']>;
  levelIds?: Maybe<Scalars['jsonb']>;
  personGroupId?: Maybe<Scalars['jsonb']>;
  personIds?: Maybe<Scalars['jsonb']>;
  phone?: Maybe<Scalars['jsonb']>;
  roleIds?: Maybe<Scalars['jsonb']>;
  subjectIds?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Attachments = 'attachments',
  /** column name */
  Avatar = 'avatar',
  /** column name */
  BankId = 'bankId',
  /** column name */
  BankNumber = 'bankNumber',
  /** column name */
  BranchId = 'branchId',
  /** column name */
  Code = 'code',
  /** column name */
  CognitoId = 'cognitoId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Dob = 'dob',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  FullName = 'fullName',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  IsVerifiedEmail = 'isVerifiedEmail',
  /** column name */
  IsVerifiedPhoneNumber = 'isVerifiedPhoneNumber',
  /** column name */
  LastName = 'lastName',
  /** column name */
  LevelIds = 'levelIds',
  /** column name */
  NumOfFailed = 'numOfFailed',
  /** column name */
  PersonGroupId = 'personGroupId',
  /** column name */
  PersonIds = 'personIds',
  /** column name */
  Phone = 'phone',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  Role = 'role',
  /** column name */
  RoleIds = 'roleIds',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  SubjectIds = 'subjectIds',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  address?: Maybe<Scalars['String']>;
  attachments?: Maybe<Scalars['jsonb']>;
  avatar?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['uuid']>;
  bankNumber?: Maybe<Scalars['String']>;
  branchId?: Maybe<Scalars['uuid']>;
  code?: Maybe<Scalars['String']>;
  cognitoId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  dob?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  isVerifiedEmail?: Maybe<Scalars['Boolean']>;
  isVerifiedPhoneNumber?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  levelIds?: Maybe<Scalars['jsonb']>;
  numOfFailed?: Maybe<Scalars['Int']>;
  personGroupId?: Maybe<Scalars['jsonb']>;
  personIds?: Maybe<Scalars['jsonb']>;
  phone?: Maybe<Scalars['jsonb']>;
  phoneNumber?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  roleIds?: Maybe<Scalars['jsonb']>;
  status?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['uuid']>;
  subjectIds?: Maybe<Scalars['jsonb']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
  username?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  __typename?: 'users_stddev_fields';
  numOfFailed?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "users" */
export type Users_Stddev_Order_By = {
  numOfFailed?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  __typename?: 'users_stddev_pop_fields';
  numOfFailed?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "users" */
export type Users_Stddev_Pop_Order_By = {
  numOfFailed?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  __typename?: 'users_stddev_samp_fields';
  numOfFailed?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "users" */
export type Users_Stddev_Samp_Order_By = {
  numOfFailed?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  __typename?: 'users_sum_fields';
  numOfFailed?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "users" */
export type Users_Sum_Order_By = {
  numOfFailed?: Maybe<Order_By>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Attachments = 'attachments',
  /** column name */
  Avatar = 'avatar',
  /** column name */
  BankId = 'bankId',
  /** column name */
  BankNumber = 'bankNumber',
  /** column name */
  BranchId = 'branchId',
  /** column name */
  Code = 'code',
  /** column name */
  CognitoId = 'cognitoId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Dob = 'dob',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  FullName = 'fullName',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  IsVerifiedEmail = 'isVerifiedEmail',
  /** column name */
  IsVerifiedPhoneNumber = 'isVerifiedPhoneNumber',
  /** column name */
  LastName = 'lastName',
  /** column name */
  LevelIds = 'levelIds',
  /** column name */
  NumOfFailed = 'numOfFailed',
  /** column name */
  PersonGroupId = 'personGroupId',
  /** column name */
  PersonIds = 'personIds',
  /** column name */
  Phone = 'phone',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  Role = 'role',
  /** column name */
  RoleIds = 'roleIds',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  SubjectIds = 'subjectIds',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Username = 'username'
}

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  __typename?: 'users_var_pop_fields';
  numOfFailed?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "users" */
export type Users_Var_Pop_Order_By = {
  numOfFailed?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  __typename?: 'users_var_samp_fields';
  numOfFailed?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "users" */
export type Users_Var_Samp_Order_By = {
  numOfFailed?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  __typename?: 'users_variance_fields';
  numOfFailed?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "users" */
export type Users_Variance_Order_By = {
  numOfFailed?: Maybe<Order_By>;
};


/** expression to compare columns of type uuid. All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: Maybe<Scalars['uuid']>;
  _gt?: Maybe<Scalars['uuid']>;
  _gte?: Maybe<Scalars['uuid']>;
  _in?: Maybe<Array<Scalars['uuid']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['uuid']>;
  _lte?: Maybe<Scalars['uuid']>;
  _neq?: Maybe<Scalars['uuid']>;
  _nin?: Maybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "vms_person_groups" */
export type Vms_Person_Groups = {
  __typename?: 'vms_person_groups';
  /** An object relationship */
  branch?: Maybe<Branches>;
  branchId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  endTime?: Maybe<Scalars['timetz']>;
  groupId?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  groupParentId?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  startTime?: Maybe<Scalars['timetz']>;
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "vms_person_groups" */
export type Vms_Person_Groups_Aggregate = {
  __typename?: 'vms_person_groups_aggregate';
  aggregate?: Maybe<Vms_Person_Groups_Aggregate_Fields>;
  nodes: Array<Vms_Person_Groups>;
};

/** aggregate fields of "vms_person_groups" */
export type Vms_Person_Groups_Aggregate_Fields = {
  __typename?: 'vms_person_groups_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Vms_Person_Groups_Max_Fields>;
  min?: Maybe<Vms_Person_Groups_Min_Fields>;
};


/** aggregate fields of "vms_person_groups" */
export type Vms_Person_Groups_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Vms_Person_Groups_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "vms_person_groups" */
export type Vms_Person_Groups_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Vms_Person_Groups_Max_Order_By>;
  min?: Maybe<Vms_Person_Groups_Min_Order_By>;
};

/** input type for inserting array relation for remote table "vms_person_groups" */
export type Vms_Person_Groups_Arr_Rel_Insert_Input = {
  data: Array<Vms_Person_Groups_Insert_Input>;
  on_conflict?: Maybe<Vms_Person_Groups_On_Conflict>;
};

/** Boolean expression to filter rows from the table "vms_person_groups". All fields are combined with a logical 'AND'. */
export type Vms_Person_Groups_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Vms_Person_Groups_Bool_Exp>>>;
  _not?: Maybe<Vms_Person_Groups_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Vms_Person_Groups_Bool_Exp>>>;
  branch?: Maybe<Branches_Bool_Exp>;
  branchId?: Maybe<Uuid_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  createdBy?: Maybe<Uuid_Comparison_Exp>;
  endTime?: Maybe<Timetz_Comparison_Exp>;
  groupId?: Maybe<String_Comparison_Exp>;
  groupName?: Maybe<String_Comparison_Exp>;
  groupParentId?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  startTime?: Maybe<Timetz_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  updatedBy?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "vms_person_groups" */
export enum Vms_Person_Groups_Constraint {
  /** unique or primary key constraint */
  VmsPersonGroupsPkey = 'vms_person_groups_pkey'
}

/** input type for inserting data into table "vms_person_groups" */
export type Vms_Person_Groups_Insert_Input = {
  branch?: Maybe<Branches_Obj_Rel_Insert_Input>;
  branchId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  endTime?: Maybe<Scalars['timetz']>;
  groupId?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  groupParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  startTime?: Maybe<Scalars['timetz']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Vms_Person_Groups_Max_Fields = {
  __typename?: 'vms_person_groups_max_fields';
  branchId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  endTime?: Maybe<Scalars['timetz']>;
  groupId?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  groupParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  startTime?: Maybe<Scalars['timetz']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "vms_person_groups" */
export type Vms_Person_Groups_Max_Order_By = {
  branchId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  endTime?: Maybe<Order_By>;
  groupId?: Maybe<Order_By>;
  groupName?: Maybe<Order_By>;
  groupParentId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  startTime?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Vms_Person_Groups_Min_Fields = {
  __typename?: 'vms_person_groups_min_fields';
  branchId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  endTime?: Maybe<Scalars['timetz']>;
  groupId?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  groupParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  startTime?: Maybe<Scalars['timetz']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "vms_person_groups" */
export type Vms_Person_Groups_Min_Order_By = {
  branchId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  endTime?: Maybe<Order_By>;
  groupId?: Maybe<Order_By>;
  groupName?: Maybe<Order_By>;
  groupParentId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  startTime?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** response of any mutation on the table "vms_person_groups" */
export type Vms_Person_Groups_Mutation_Response = {
  __typename?: 'vms_person_groups_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Vms_Person_Groups>;
};

/** input type for inserting object relation for remote table "vms_person_groups" */
export type Vms_Person_Groups_Obj_Rel_Insert_Input = {
  data: Vms_Person_Groups_Insert_Input;
  on_conflict?: Maybe<Vms_Person_Groups_On_Conflict>;
};

/** on conflict condition type for table "vms_person_groups" */
export type Vms_Person_Groups_On_Conflict = {
  constraint: Vms_Person_Groups_Constraint;
  update_columns: Array<Vms_Person_Groups_Update_Column>;
  where?: Maybe<Vms_Person_Groups_Bool_Exp>;
};

/** ordering options when selecting data from "vms_person_groups" */
export type Vms_Person_Groups_Order_By = {
  branch?: Maybe<Branches_Order_By>;
  branchId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  createdBy?: Maybe<Order_By>;
  endTime?: Maybe<Order_By>;
  groupId?: Maybe<Order_By>;
  groupName?: Maybe<Order_By>;
  groupParentId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  startTime?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  updatedBy?: Maybe<Order_By>;
};

/** primary key columns input for table: "vms_person_groups" */
export type Vms_Person_Groups_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "vms_person_groups" */
export enum Vms_Person_Groups_Select_Column {
  /** column name */
  BranchId = 'branchId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  GroupName = 'groupName',
  /** column name */
  GroupParentId = 'groupParentId',
  /** column name */
  Id = 'id',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "vms_person_groups" */
export type Vms_Person_Groups_Set_Input = {
  branchId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  endTime?: Maybe<Scalars['timetz']>;
  groupId?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  groupParentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  startTime?: Maybe<Scalars['timetz']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedBy?: Maybe<Scalars['uuid']>;
};

/** update columns of table "vms_person_groups" */
export enum Vms_Person_Groups_Update_Column {
  /** column name */
  BranchId = 'branchId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  GroupName = 'groupName',
  /** column name */
  GroupParentId = 'groupParentId',
  /** column name */
  Id = 'id',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

export type AcademicCalendarFragment = { __typename?: 'academic_calendars', id: any, name: string, year: string, status: string, updatedAt: any, updatedBy?: any | null, category: string, curriculumId: any, levelIds: any, createdBy?: any | null, createdAt: any };

export type TermsFragment = { __typename?: 'terms', id: any, startDate: any, endDate: any, numberOfLessons?: number | null };

export type CurriculumFragment = { __typename?: 'curriculums', abbreviation?: string | null, createdAt: any, createdBy?: any | null, id: any, name: string, status: string, updatedAt: any, updatedBy?: any | null };

export type LevelFragment = { __typename?: 'levels', abbreviation: string, createdAt: any, createdBy?: any | null, id: any, name: string, status: string, updatedAt: any, updatedBy?: any | null };

export type AcademicCalendarsListQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  order: Order_By;
  filter?: InputMaybe<Academic_Calendars_Bool_Exp>;
}>;


export type AcademicCalendarsListQuery = { __typename?: 'query_root', academic_calendars: Array<{ __typename?: 'academic_calendars', id: any, name: string, year: string, status: string, updatedAt: any, updatedBy?: any | null, category: string, curriculumId: any, levelIds: any, createdBy?: any | null, createdAt: any, curriculum: { __typename?: 'curriculums', abbreviation?: string | null, createdAt: any, createdBy?: any | null, id: any, name: string, status: string, updatedAt: any, updatedBy?: any | null }, levels?: Array<{ __typename?: 'levels', abbreviation: string, createdAt: any, createdBy?: any | null, id: any, name: string, status: string, updatedAt: any, updatedBy?: any | null }> | null, terms: Array<{ __typename?: 'terms', id: any, startDate: any, endDate: any, numberOfLessons?: number | null }> }>, academic_calendars_aggregate: { __typename?: 'academic_calendars_aggregate', aggregate?: { __typename?: 'academic_calendars_aggregate_fields', count?: number | null } | null } };

export type AcademicCalendarsAllQueryVariables = Exact<{
  filter?: InputMaybe<Academic_Calendars_Bool_Exp>;
}>;


export type AcademicCalendarsAllQuery = { __typename?: 'query_root', academic_calendars: Array<{ __typename?: 'academic_calendars', id: any, name: string, year: string, status: string, updatedAt: any, updatedBy?: any | null, category: string, curriculumId: any, levelIds: any, createdBy?: any | null, createdAt: any, curriculum: { __typename?: 'curriculums', abbreviation?: string | null, createdAt: any, createdBy?: any | null, id: any, name: string, status: string, updatedAt: any, updatedBy?: any | null }, levels?: Array<{ __typename?: 'levels', abbreviation: string, createdAt: any, createdBy?: any | null, id: any, name: string, status: string, updatedAt: any, updatedBy?: any | null }> | null, terms: Array<{ __typename?: 'terms', id: any, startDate: any, endDate: any, numberOfLessons?: number | null }> }> };

export type GetAcademicCalendarByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetAcademicCalendarByIdQuery = { __typename?: 'query_root', academic_calendars: Array<{ __typename?: 'academic_calendars', levelIds: any, id: any, name: string, year: string, status: string, updatedAt: any, updatedBy?: any | null, category: string, curriculumId: any, createdBy?: any | null, createdAt: any, terms: Array<{ __typename?: 'terms', academicCalendarId: any, createdAt: any, createdBy?: any | null, status: string, updatedAt: any, updatedBy?: any | null, id: any, startDate: any, endDate: any, numberOfLessons?: number | null }> }> };

export type CreateAcademicCalendarsMutationVariables = Exact<{
  form: Array<Academic_Calendars_Insert_Input> | Academic_Calendars_Insert_Input;
}>;


export type CreateAcademicCalendarsMutation = { __typename?: 'mutation_root', insert_academic_calendars?: { __typename?: 'academic_calendars_mutation_response', returning: Array<{ __typename?: 'academic_calendars', createdAt: any, createdBy?: any | null, curriculumId: any, category: string, id: any, levelIds: any, name: string, status: string }> } | null };

export type GetAttendanceListQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  where?: InputMaybe<Lessons_Bool_Exp>;
}>;


export type GetAttendanceListQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'lessons', date: any, numberWeek?: number | null, id: any, class: { __typename?: 'classes', name: string, id: any, termClasses: Array<{ __typename?: 'term_classes', termName: string }> }, students_aggregate: { __typename?: 'lessons_students_aggregate', aggregate?: { __typename?: 'lessons_students_aggregate_fields', count?: number | null } | null }, students: Array<{ __typename?: 'lessons_students', id: any }> }>, lessons_aggregate: { __typename?: 'lessons_aggregate', aggregate?: { __typename?: 'lessons_aggregate_fields', count?: number | null } | null } };

export type GetAttendanceDetailHeaderQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetAttendanceDetailHeaderQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'lessons', date: any, class: { __typename?: 'classes', name: string, id: any, classId: string, academicCalendar?: { __typename?: 'academic_calendars', year: string } | null, program: { __typename?: 'programs', id: any, curriculums?: Array<{ __typename?: 'curriculums', name: string, id: any }> | null, levels?: Array<{ __typename?: 'levels', name: string, id: any }> | null, subject: { __typename?: 'subjects', name: string, id: any } }, programTypeGeneral?: { __typename?: 'general_program_types', fullName: string, id: any } | null, programTypeRegular?: { __typename?: 'regular_program_types', fullName: string, id: any } | null, programTypeSpecial?: { __typename?: 'specical_program_types', fullName: string, id: any } | null, programTypeDoubleLesson?: { __typename?: 'double_lesson_program_types', fullName: string, id: any } | null }, classroom: { __typename?: 'classrooms', id: any, name: string, branch: { __typename?: 'branches', name: string, id: any } }, sessions: Array<{ __typename?: 'sessions', endTime: any, startTime: any, id: any, tutors?: Array<{ __typename?: 'users', fullName?: string | null, gender?: string | null, id: any }> | null }>, students: Array<{ __typename?: 'lessons_students', id: any }>, students_aggregate: { __typename?: 'lessons_students_aggregate', aggregate?: { __typename?: 'lessons_students_aggregate_fields', count?: number | null } | null } }> };

export type GetListDetailQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  where?: InputMaybe<Lessons_Students_Bool_Exp>;
}>;


export type GetListDetailQuery = { __typename?: 'query_root', lessons_students: Array<{ __typename?: 'lessons_students', entryTime?: any | null, hasAttended: boolean, id: any, remarks?: string | null, student: { __typename?: 'users', id: any, fullName?: string | null, username?: string | null } }>, lessons_students_aggregate: { __typename?: 'lessons_students_aggregate', aggregate?: { __typename?: 'lessons_students_aggregate_fields', count?: number | null } | null } };

export type UpdateAttendanceDetailMutationVariables = Exact<{
  id: Scalars['uuid'];
  set?: InputMaybe<Lessons_Students_Set_Input>;
}>;


export type UpdateAttendanceDetailMutation = { __typename?: 'mutation_root', update_lessons_students?: { __typename?: 'lessons_students_mutation_response', affected_rows: number } | null };

export type GetProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfileQuery = { __typename?: 'query_root', get_profile: Array<{ __typename?: 'get_profile', id?: any | null, lastName?: string | null, phoneNumber?: string | null, role?: string | null, dob?: any | null, email?: string | null, firstName?: string | null, gender?: string | null, username?: string | null, avatar?: string | null, isVerifiedEmail?: boolean | null, isVerifiedPhoneNumber?: boolean | null, phone?: any | null }> };

export type BanksQueryVariables = Exact<{ [key: string]: never; }>;


export type BanksQuery = { __typename?: 'query_root', banks: Array<{ __typename?: 'banks', abbreviation?: string | null, id: any, name: string }> };

export type GetClassInformationQueryVariables = Exact<{
  form: FormGetClassInformation;
}>;


export type GetClassInformationQuery = { __typename?: 'query_root', getClassInformation?: { __typename?: 'ClassInformation', total?: number | null, classStatus?: string | null, classType?: string | null, programId?: string | null, id?: string | null, lessonStartDate?: any | null, name?: string | null, terms?: Array<{ __typename?: 'TermInClassInformation', id?: string | null, lessonIds?: Array<string | null> | null, name?: string | null, pricing?: number | null, total?: number | null, lessons?: Array<any | null> | null } | null> | null, additionalLesson?: { __typename?: 'AdditionalLesson', pricing?: number | null, quantity?: number | null, total?: number | null } | null, period?: { __typename?: 'Period', endDate?: any | null, startDate?: any | null } | null } | null };

export type DeleteClassStudentsWaitingMutationVariables = Exact<{
  where: Class_Students_Waiting_Bool_Exp;
}>;


export type DeleteClassStudentsWaitingMutation = { __typename?: 'mutation_root', delete_class_students_waiting?: { __typename?: 'class_students_waiting_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'class_students_waiting', id: any, classId: any }> } | null };

export type SimpleClassFragmentFragment = { __typename?: 'classes', id: any, name: string };

export type GetClassSimpleQueryVariables = Exact<{
  where?: InputMaybe<Classes_Bool_Exp>;
}>;


export type GetClassSimpleQuery = { __typename?: 'query_root', classes: Array<{ __typename?: 'classes', id: any, name: string }> };

export type GetListClassQueryVariables = Exact<{
  where: Classes_Bool_Exp;
  lesson?: InputMaybe<Lessons_Bool_Exp>;
}>;


export type GetListClassQuery = { __typename?: 'query_root', classes: Array<{ __typename?: 'classes', id: any, name: string, classStatus: string, program: { __typename?: 'programs', subject: { __typename?: 'subjects', id: any, name: string, abbreviation: string }, curriculums?: Array<{ __typename?: 'curriculums', id: any, name: string, abbreviation?: string | null }> | null, levels?: Array<{ __typename?: 'levels', id: any, name: string, abbreviation: string }> | null }, lessons: Array<{ __typename?: 'lessons', date: any, id: any, sessions: Array<{ __typename?: 'sessions', endTime: any, startTime: any }>, classroom: { __typename?: 'classrooms', capacity: number, branch: { __typename?: 'branches', name: string, id: any, abbreviation?: string | null } }, students_aggregate: { __typename?: 'lessons_students_aggregate', aggregate?: { __typename?: 'lessons_students_aggregate_fields', count?: number | null } | null } }> }> };

export type GetClassDetailQueryVariables = Exact<{
  where: Classes_Bool_Exp;
}>;


export type GetClassDetailQuery = { __typename?: 'query_root', classes: Array<{ __typename?: 'classes', id: any, name: string, classId: string, classStatus: string, programTypeSpecial?: { __typename?: 'specical_program_types', id: any, shortName: string, fullName: string } | null, programTypeRegular?: { __typename?: 'regular_program_types', id: any, fullName: string, shortName: string } | null, programTypeGeneral?: { __typename?: 'general_program_types', fullName: string, id: any, shortName: string } | null, programTypeDoubleLesson?: { __typename?: 'double_lesson_program_types', fullName: string, id: any, shortName: string } | null, program: { __typename?: 'programs', id: any, curriculums?: Array<{ __typename?: 'curriculums', id: any, abbreviation?: string | null }> | null, levels?: Array<{ __typename?: 'levels', id: any, abbreviation: string }> | null, subject: { __typename?: 'subjects', id: any, abbreviation: string } }, lessons: Array<{ __typename?: 'lessons', id: any, numberWeek?: number | null, date: any, lessonStatus: string, termClass?: { __typename?: 'term_classes', id: any, termName: string } | null, classroom: { __typename?: 'classrooms', id: any, capacity: number, name: string, branch: { __typename?: 'branches', id: any, name: string } }, sessions: Array<{ __typename?: 'sessions', id: any, endTime: any, startTime: any, tutors?: Array<{ __typename?: 'users', fullName?: string | null, id: any }> | null }> }> }> };

export type LessonsStudentsQueryVariables = Exact<{
  where: Lessons_Students_Bool_Exp;
}>;


export type LessonsStudentsQuery = { __typename?: 'query_root', lessons_students: Array<{ __typename?: 'lessons_students', lessonStatus?: string | null, type: string, hasAttended: boolean, id: any, lessonId: any, studentId: any, entryTime?: any | null, oldLessonId?: any | null, oldLesson?: { __typename?: 'lessons', classId: any } | null, lesson: { __typename?: 'lessons', classId: any, id: any, numberWeek?: number | null, date: any, lessonStatus: string, termClass?: { __typename?: 'term_classes', id: any, termName: string } | null, classroom: { __typename?: 'classrooms', capacity: number, id: any, name: string, branch: { __typename?: 'branches', abbreviation?: string | null, id: any, name: string } }, sessions: Array<{ __typename?: 'sessions', endTime: any, id: any, startTime: any, tutors?: Array<{ __typename?: 'users', id: any, firstName: string }> | null }> } }> };

export type GetStudentSelectedClassesQueryVariables = Exact<{
  filter?: InputMaybe<Class_Students_Waiting_Bool_Exp>;
}>;


export type GetStudentSelectedClassesQuery = { __typename?: 'query_root', class_students_waiting: Array<{ __typename?: 'class_students_waiting', id: any, class: { __typename?: 'classes', classStatus: string, id: any, programId: any, name: string, program: { __typename?: 'programs', id: any, name: string } } }> };

export type CountStudentWaitingListQueryVariables = Exact<{
  where: Class_Students_Waiting_Bool_Exp;
}>;


export type CountStudentWaitingListQuery = { __typename?: 'query_root', class_students_waiting_aggregate: { __typename?: 'class_students_waiting_aggregate', aggregate?: { __typename?: 'class_students_waiting_aggregate_fields', count?: number | null } | null } };

export type GetLessonStudentDetailQueryVariables = Exact<{
  classId: Scalars['uuid'];
  studentId: Scalars['uuid'];
}>;


export type GetLessonStudentDetailQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'lessons', id: any, numberWeek?: number | null, date: any, lessonStatus: string, termClass?: { __typename?: 'term_classes', id: any, termName: string } | null, classroom: { __typename?: 'classrooms', capacity: number, id: any, name: string, branch: { __typename?: 'branches', id: any, name: string } }, sessions: Array<{ __typename?: 'sessions', id: any, endTime: any, startTime: any, tutors?: Array<{ __typename?: 'users', fullName?: string | null, id: any }> | null }>, students: Array<{ __typename?: 'lessons_students', id: any, type: string, hasAttended: boolean, lessonStatus?: string | null }> }> };

export type FilterPaidClassByStudentQueryVariables = Exact<{
  studentId?: InputMaybe<Scalars['uuid']>;
  programId?: InputMaybe<Scalars['uuid']>;
  programTypeId?: InputMaybe<Scalars['uuid']>;
}>;


export type FilterPaidClassByStudentQuery = { __typename?: 'query_root', classes: Array<{ __typename?: 'classes', id: any, name: string, programId: any, programTypeGeneralId?: any | null, programTypeSpecialId?: any | null, programTypeRegularId?: any | null, programTypeDoubleLessonId?: any | null }> };

export type GetTransferClassListQueryVariables = Exact<{
  where: Request_Transfer_Classes_Bool_Exp;
}>;


export type GetTransferClassListQuery = { __typename?: 'query_root', request_transfer_classes: Array<{ __typename?: 'request_transfer_classes', id: any, transferClassStatus: string, student: { __typename?: 'users', fullName?: string | null, username?: string | null }, fromClass: { __typename?: 'classes', id: any, name: string, programTypeGeneral?: { __typename?: 'general_program_types', fullName: string, id: any } | null, programTypeRegular?: { __typename?: 'regular_program_types', fullName: string, id: any } | null, programTypeSpecial?: { __typename?: 'specical_program_types', id: any, fullName: string } | null, programTypeDoubleLesson?: { __typename?: 'double_lesson_program_types', fullName: string, id: any } | null }, toClass: { __typename?: 'classes', name: string, id: any, startDate?: any | null } }> };

export type TransferClassMutationVariables = Exact<{
  form?: InputMaybe<FormRequestTransferClass>;
}>;


export type TransferClassMutation = { __typename?: 'mutation_root', requestTransferClass?: string | null };

export type CancelTransferClassMutationVariables = Exact<{
  form: FormCancelTransferClass;
}>;


export type CancelTransferClassMutation = { __typename?: 'mutation_root', cancelTransferClass?: boolean | null };

export type BroadcastsFragmentFragment = { __typename?: 'broadcasts', broadcastStatus: string, createdAt: any, filterRecipient?: any | null, createdBy?: any | null, id: any, recipientType?: string | null, status: string, via: any, updatedAt: any, updatedBy?: any | null, title: string, subject?: string | null, content?: string | null, broadcastLogs: Array<{ __typename?: 'broadcast_logs', isViewed: boolean }>, createdUser?: { __typename?: 'users', id: any, fullName?: string | null } | null, updatedUser?: { __typename?: 'users', id: any, fullName?: string | null } | null };

export type GetListBroadcastQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<Broadcasts_Bool_Exp>;
}>;


export type GetListBroadcastQuery = { __typename?: 'query_root', broadcasts: Array<{ __typename?: 'broadcasts', broadcastStatus: string, createdAt: any, filterRecipient?: any | null, createdBy?: any | null, id: any, recipientType?: string | null, status: string, via: any, updatedAt: any, updatedBy?: any | null, title: string, subject?: string | null, content?: string | null, broadcastLogs: Array<{ __typename?: 'broadcast_logs', isViewed: boolean }>, createdUser?: { __typename?: 'users', id: any, fullName?: string | null } | null, updatedUser?: { __typename?: 'users', id: any, fullName?: string | null } | null }>, broadcasts_aggregate: { __typename?: 'broadcasts_aggregate', aggregate?: { __typename?: 'broadcasts_aggregate_fields', count?: number | null } | null } };

export type GetBroadcastLogQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<Broadcast_Logs_Bool_Exp>;
}>;


export type GetBroadcastLogQuery = { __typename?: 'query_root', broadcast_logs: Array<{ __typename?: 'broadcast_logs', smsStatus?: string | null, status: string, updatedAt: any, updatedBy?: any | null, broadcastId: any, createdAt: any, createdBy?: any | null, emailStatus?: string | null, id: any, notificationStatus?: string | null, recipientId: any, recipient: { __typename?: 'users', id: any, fullName?: string | null, firstName: string, lastName: string, email?: string | null, phoneNumber?: string | null, username?: string | null, role: string } }>, broadcast_logs_aggregate: { __typename?: 'broadcast_logs_aggregate', aggregate?: { __typename?: 'broadcast_logs_aggregate_fields', count?: number | null } | null } };

export type Upload_New_RecipientsMutationVariables = Exact<{
  objects?: Array<News_Recipients_Upload_Insert_Input> | News_Recipients_Upload_Insert_Input;
}>;


export type Upload_New_RecipientsMutation = { __typename?: 'mutation_root', insert_news_recipients_upload?: { __typename?: 'news_recipients_upload_mutation_response', returning: Array<{ __typename?: 'news_recipients_upload', id: any }> } | null };

export type Create_BroadcastMutationVariables = Exact<{
  objects?: Array<Broadcasts_Insert_Input> | Broadcasts_Insert_Input;
}>;


export type Create_BroadcastMutation = { __typename?: 'mutation_root', insert_broadcasts?: { __typename?: 'broadcasts_mutation_response', returning: Array<{ __typename?: 'broadcasts', broadcastStatus: string, createdAt: any, filterRecipient?: any | null, createdBy?: any | null, id: any, recipientType?: string | null, status: string, via: any, updatedAt: any, updatedBy?: any | null, title: string, subject?: string | null, content?: string | null, broadcastLogs: Array<{ __typename?: 'broadcast_logs', isViewed: boolean }>, createdUser?: { __typename?: 'users', id: any, fullName?: string | null } | null, updatedUser?: { __typename?: 'users', id: any, fullName?: string | null } | null }> } | null };

export type Update_BroadcastMutationVariables = Exact<{
  _eq?: InputMaybe<Scalars['uuid']>;
  _set?: InputMaybe<Broadcasts_Set_Input>;
}>;


export type Update_BroadcastMutation = { __typename?: 'mutation_root', update_broadcasts?: { __typename?: 'broadcasts_mutation_response', returning: Array<{ __typename?: 'broadcasts', broadcastStatus: string, createdAt: any, filterRecipient?: any | null, createdBy?: any | null, id: any, recipientType?: string | null, status: string, via: any, updatedAt: any, updatedBy?: any | null, title: string, subject?: string | null, content?: string | null, broadcastLogs: Array<{ __typename?: 'broadcast_logs', isViewed: boolean }>, createdUser?: { __typename?: 'users', id: any, fullName?: string | null } | null, updatedUser?: { __typename?: 'users', id: any, fullName?: string | null } | null }> } | null };

export type SentBroadcastMutationVariables = Exact<{
  id: Scalars['String'];
  isResend?: InputMaybe<Scalars['Boolean']>;
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type SentBroadcastMutation = { __typename?: 'mutation_root', sentBroadcast: any };

export type NewsFragmentFragment = { __typename?: 'news', coverUrl?: string | null, createdAt: any, createdBy?: any | null, filterRecipient: any, hashtags: any, id: any, message?: string | null, newsStatus: string, recipientType?: string | null, status: string, subject?: string | null, title?: string | null, type: any, updatedAt: any, numOpens?: number | null, numClicks?: number | null, createdUser?: { __typename?: 'users', email?: string | null, fullName?: string | null, id: any, username?: string | null } | null, newsLogs_aggregate: { __typename?: 'news_logs_aggregate', aggregate?: { __typename?: 'news_logs_aggregate_fields', count?: number | null } | null }, newsLogs: Array<{ __typename?: 'news_logs', isViewed: boolean }> };

export type GetListNewsFeedQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<News_Bool_Exp>;
}>;


export type GetListNewsFeedQuery = { __typename?: 'query_root', news: Array<{ __typename?: 'news', coverUrl?: string | null, createdAt: any, createdBy?: any | null, filterRecipient: any, hashtags: any, id: any, message?: string | null, newsStatus: string, recipientType?: string | null, status: string, subject?: string | null, title?: string | null, type: any, updatedAt: any, numOpens?: number | null, numClicks?: number | null, createdUser?: { __typename?: 'users', email?: string | null, fullName?: string | null, id: any, username?: string | null } | null, newsLogs_aggregate: { __typename?: 'news_logs_aggregate', aggregate?: { __typename?: 'news_logs_aggregate_fields', count?: number | null } | null }, newsLogs: Array<{ __typename?: 'news_logs', isViewed: boolean }> }>, news_aggregate: { __typename?: 'news_aggregate', aggregate?: { __typename?: 'news_aggregate_fields', count?: number | null } | null } };

export type GetListAnnouncementQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetListAnnouncementQuery = { __typename?: 'query_root', news: Array<{ __typename?: 'news', coverUrl?: string | null, createdAt: any, createdBy?: any | null, filterRecipient: any, hashtags: any, id: any, message?: string | null, newsStatus: string, recipientType?: string | null, status: string, subject?: string | null, title?: string | null, type: any, updatedAt: any, numOpens?: number | null, numClicks?: number | null, createdUser?: { __typename?: 'users', email?: string | null, fullName?: string | null, id: any, username?: string | null } | null, newsLogs_aggregate: { __typename?: 'news_logs_aggregate', aggregate?: { __typename?: 'news_logs_aggregate_fields', count?: number | null } | null }, newsLogs: Array<{ __typename?: 'news_logs', isViewed: boolean }> }>, broadcasts: Array<{ __typename?: 'broadcasts', broadcastStatus: string, createdAt: any, filterRecipient?: any | null, createdBy?: any | null, id: any, recipientType?: string | null, status: string, via: any, updatedAt: any, updatedBy?: any | null, title: string, subject?: string | null, content?: string | null, broadcastLogs: Array<{ __typename?: 'broadcast_logs', isViewed: boolean }>, createdUser?: { __typename?: 'users', id: any, fullName?: string | null } | null, updatedUser?: { __typename?: 'users', id: any, fullName?: string | null } | null }> };

export type GetBroadcastLogAndNewsLogQueryVariables = Exact<{
  studentId: Scalars['uuid'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetBroadcastLogAndNewsLogQuery = { __typename?: 'query_root', broadcast_logs: Array<{ __typename?: 'broadcast_logs', emailResponse?: any | null, emailStatus?: string | null, id: any, notificationResponse?: any | null, notificationStatus?: string | null, smsResponse?: any | null, smsStatus?: string | null, status: string, createdAt: any, broadcast: { __typename?: 'broadcasts', broadcastStatus: string, createdAt: any, filterRecipient?: any | null, createdBy?: any | null, id: any, recipientType?: string | null, status: string, via: any, updatedAt: any, updatedBy?: any | null, title: string, subject?: string | null, content?: string | null, broadcastLogs: Array<{ __typename?: 'broadcast_logs', isViewed: boolean }>, createdUser?: { __typename?: 'users', id: any, fullName?: string | null } | null, updatedUser?: { __typename?: 'users', id: any, fullName?: string | null } | null } }>, news_logs: Array<{ __typename?: 'news_logs', news: { __typename?: 'news', coverUrl?: string | null, createdAt: any, createdBy?: any | null, filterRecipient: any, hashtags: any, id: any, message?: string | null, newsStatus: string, recipientType?: string | null, status: string, subject?: string | null, title?: string | null, type: any, updatedAt: any, numOpens?: number | null, numClicks?: number | null, createdUser?: { __typename?: 'users', email?: string | null, fullName?: string | null, id: any, username?: string | null } | null, newsLogs_aggregate: { __typename?: 'news_logs_aggregate', aggregate?: { __typename?: 'news_logs_aggregate_fields', count?: number | null } | null }, newsLogs: Array<{ __typename?: 'news_logs', isViewed: boolean }> } }> };

export type Create_NewsMutationVariables = Exact<{
  objects?: Array<News_Insert_Input> | News_Insert_Input;
}>;


export type Create_NewsMutation = { __typename?: 'mutation_root', insert_news?: { __typename?: 'news_mutation_response', returning: Array<{ __typename?: 'news', coverUrl?: string | null, createdAt: any, createdBy?: any | null, filterRecipient: any, hashtags: any, id: any, message?: string | null, newsStatus: string, recipientType?: string | null, status: string, subject?: string | null, title?: string | null, type: any, updatedAt: any, numOpens?: number | null, numClicks?: number | null, createdUser?: { __typename?: 'users', email?: string | null, fullName?: string | null, id: any, username?: string | null } | null, newsLogs_aggregate: { __typename?: 'news_logs_aggregate', aggregate?: { __typename?: 'news_logs_aggregate_fields', count?: number | null } | null }, newsLogs: Array<{ __typename?: 'news_logs', isViewed: boolean }> }> } | null };

export type Update_NewsMutationVariables = Exact<{
  _eq?: InputMaybe<Scalars['uuid']>;
  _set?: InputMaybe<News_Set_Input>;
}>;


export type Update_NewsMutation = { __typename?: 'mutation_root', update_news?: { __typename?: 'news_mutation_response', returning: Array<{ __typename?: 'news', coverUrl?: string | null, createdAt: any, createdBy?: any | null, filterRecipient: any, hashtags: any, id: any, message?: string | null, newsStatus: string, recipientType?: string | null, status: string, subject?: string | null, title?: string | null, type: any, updatedAt: any, numOpens?: number | null, numClicks?: number | null, createdUser?: { __typename?: 'users', email?: string | null, fullName?: string | null, id: any, username?: string | null } | null, newsLogs_aggregate: { __typename?: 'news_logs_aggregate', aggregate?: { __typename?: 'news_logs_aggregate_fields', count?: number | null } | null }, newsLogs: Array<{ __typename?: 'news_logs', isViewed: boolean }> }> } | null };

export type SentNewsMutationVariables = Exact<{
  id: Scalars['String'];
  isResend?: InputMaybe<Scalars['Boolean']>;
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type SentNewsMutation = { __typename?: 'mutation_root', sentNews: any };

export type UpdateBroadcastLogsMutationVariables = Exact<{
  where: Broadcast_Logs_Bool_Exp;
}>;


export type UpdateBroadcastLogsMutation = { __typename?: 'mutation_root', update_broadcast_logs?: { __typename?: 'broadcast_logs_mutation_response', returning: Array<{ __typename?: 'broadcast_logs', isViewed: boolean, status: string }> } | null };

export type UpdateNewsLogsMutationVariables = Exact<{
  where: News_Logs_Bool_Exp;
}>;


export type UpdateNewsLogsMutation = { __typename?: 'mutation_root', update_news_logs?: { __typename?: 'news_logs_mutation_response', returning: Array<{ __typename?: 'news_logs', isViewed: boolean, status: string }> } | null };

export type OnBroadcastAddedSubscriptionVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type OnBroadcastAddedSubscription = { __typename?: 'subscription_root', broadcast_logs_aggregate: { __typename?: 'broadcast_logs_aggregate', aggregate?: { __typename?: 'broadcast_logs_aggregate_fields', count?: number | null } | null } };

export type OnNewsAddedSubscriptionVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type OnNewsAddedSubscription = { __typename?: 'subscription_root', news_logs_aggregate: { __typename?: 'news_logs_aggregate', aggregate?: { __typename?: 'news_logs_aggregate_fields', count?: number | null } | null } };

export type CreditNoteFragmentFragment = { __typename?: 'credit_notes', id: any, name: string, createdAt: any, creditNoteStatus: string, type: string, summary?: any | null, updatedAt: any, student?: { __typename?: 'users', fullName?: string | null, id: any, username?: string | null } | null, creditNoteClass?: { __typename?: 'credit_note_classes', id: any, startDate?: any | null, endDate?: any | null, lessonIds?: any | null, class?: { __typename?: 'classes', id: any, name: string } | null } | null };

export type GetSuspensionListQueryVariables = Exact<{
  args: Credit_Note_Filter_Args;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  where?: InputMaybe<Credit_Notes_Bool_Exp>;
}>;


export type GetSuspensionListQuery = { __typename?: 'query_root', credit_note_filter: Array<{ __typename?: 'credit_notes', id: any, name: string, createdAt: any, creditNoteStatus: string, type: string, summary?: any | null, updatedAt: any, student?: { __typename?: 'users', fullName?: string | null, id: any, username?: string | null } | null, creditNoteClass?: { __typename?: 'credit_note_classes', id: any, startDate?: any | null, endDate?: any | null, lessonIds?: any | null, class?: { __typename?: 'classes', id: any, name: string } | null } | null }>, credit_note_filter_aggregate: { __typename?: 'credit_notes_aggregate', aggregate?: { __typename?: 'credit_notes_aggregate_fields', count?: number | null } | null } };

export type FilterCreditNoteQueryVariables = Exact<{
  filter?: InputMaybe<Credit_Notes_Bool_Exp>;
}>;


export type FilterCreditNoteQuery = { __typename?: 'query_root', credit_notes: Array<{ __typename?: 'credit_notes', id: any, name: string, createdAt: any, creditNoteStatus: string, type: string, summary?: any | null, updatedAt: any, student?: { __typename?: 'users', fullName?: string | null, id: any, username?: string | null } | null, creditNoteClass?: { __typename?: 'credit_note_classes', id: any, startDate?: any | null, endDate?: any | null, lessonIds?: any | null, class?: { __typename?: 'classes', id: any, name: string } | null } | null }> };

export type CreateCreditNoteMutationVariables = Exact<{
  form: FormCreateCreditNote;
}>;


export type CreateCreditNoteMutation = { __typename?: 'mutation_root', createCreditNote?: string | null };

export type GetClassInformationForCreditNoteQueryVariables = Exact<{
  form: FormGetClassInformationForCreditNote;
}>;


export type GetClassInformationForCreditNoteQuery = { __typename?: 'query_root', getClassInformationForCreditNote?: { __typename?: 'ClassInformationCreditNote', id?: string | null, name?: string | null, terms?: Array<{ __typename?: 'TermInClassInformation', id?: string | null, lessons?: Array<any | null> | null, name?: string | null, total?: number | null, pricing?: number | null, lessonIds?: Array<string | null> | null } | null> | null } | null };

export type UpdateCreditNoteMutationVariables = Exact<{
  form: FormUpdateCreditNote;
  id: Scalars['String'];
}>;


export type UpdateCreditNoteMutation = { __typename?: 'mutation_root', updateCreditNote?: string | null };

export type UpdateCreditNotesMutationVariables = Exact<{
  _set: Credit_Notes_Set_Input;
  where: Credit_Notes_Bool_Exp;
}>;


export type UpdateCreditNotesMutation = { __typename?: 'mutation_root', update_credit_notes?: { __typename?: 'credit_notes_mutation_response', affected_rows: number } | null };

export type ChangeCreditNoteStatusMutationVariables = Exact<{
  form: FormChangeCreditNoteStatus;
  id: Scalars['String'];
}>;


export type ChangeCreditNoteStatusMutation = { __typename?: 'mutation_root', changeCreditNoteStatus?: string | null };

export type GetCreditNotesQueryVariables = Exact<{
  where?: InputMaybe<Credit_Notes_Bool_Exp>;
}>;


export type GetCreditNotesQuery = { __typename?: 'query_root', credit_notes: Array<{ __typename?: 'credit_notes', studentId?: any | null, type: string, name: string, reason?: string | null, remarks?: string | null, creditNoteStatus: string, creditNoteClassId?: any | null, creditNoteFeeId?: any | null, createdAt: any, createdBy?: any | null, id: any, link?: string | null, summary?: any | null, updatedBy?: any | null, updatedAt: any, student?: { __typename?: 'users', id: any, fullName?: string | null, email?: string | null, phoneNumber?: string | null, username?: string | null } | null, creditNoteClass?: { __typename?: 'credit_note_classes', endDate?: any | null, startDate?: any | null, lessonIds?: any | null, termName?: string | null, termId?: any | null, id: any, classId?: any | null, term?: { __typename?: 'terms', endDate: any, startDate: any } | null, class?: { __typename?: 'classes', name: string, id: any, program: { __typename?: 'programs', id: any, name: string, curriculums?: Array<{ __typename?: 'curriculums', id: any, abbreviation?: string | null }> | null, subject: { __typename?: 'subjects', id: any, name: string }, levels?: Array<{ __typename?: 'levels', id: any, abbreviation: string }> | null }, lessons_aggregate: { __typename?: 'lessons_aggregate', aggregate?: { __typename?: 'lessons_aggregate_fields', count?: number | null } | null } } | null } | null, creditNoteFee?: { __typename?: 'credit_note_fees', receiptId: any, id: any, overpaidAmount?: any | null, numberOfLesson?: any | null, unitPriceOfClass?: any | null, receipt: { __typename?: 'receipts', id: any, name: string, invoice: { __typename?: 'invoices', id: any, paymentAdviceId: any, total: any, pa: { __typename?: 'payment_advices', id: any, paymentSummaryStatic?: any | null } } } } | null }> };

export type GetApproveByQueryVariables = Exact<{
  where: Users_Bool_Exp;
}>;


export type GetApproveByQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, fullName?: string | null }> };

export type DuplicateCreditNoteMutationVariables = Exact<{
  creditNoteId: Scalars['String'];
}>;


export type DuplicateCreditNoteMutation = { __typename?: 'mutation_root', duplicateCreditNote?: string | null };

export type DiscountModelFragment = { __typename?: 'discounts', id: any, name: string, amount: any, description?: string | null, order?: number | null, metadata?: any | null };

export type GetDiscountsQueryVariables = Exact<{
  filter?: InputMaybe<Discounts_Bool_Exp>;
}>;


export type GetDiscountsQuery = { __typename?: 'query_root', discounts: Array<{ __typename?: 'discounts', id: any, name: string, amount: any, description?: string | null, order?: number | null, metadata?: any | null }> };

export type UpdatePeriodDiscountMutationVariables = Exact<{
  id: Scalars['uuid'];
  metadata: Scalars['jsonb'];
}>;


export type UpdatePeriodDiscountMutation = { __typename?: 'mutation_root', update_discounts?: { __typename?: 'discounts_mutation_response', returning: Array<{ __typename?: 'discounts', id: any, name: string, amount: any, description?: string | null, order?: number | null, metadata?: any | null }> } | null };

export type GetRegularProgrammePricingsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<Regular_Programme_Pricings_Bool_Exp>;
}>;


export type GetRegularProgrammePricingsQuery = { __typename?: 'query_root', regular_programme_pricings: Array<{ __typename?: 'regular_programme_pricings', id: any, updatedAt: any, pricePerLesson: any, curriculum: { __typename?: 'curriculums', id: any, name: string, abbreviation?: string | null }, regular_program_type: { __typename?: 'regular_program_types', id: any, fullName: string }, updater?: { __typename?: 'users', id: any, fullName?: string | null, avatar?: string | null } | null }>, regular_programme_pricings_aggregate: { __typename?: 'regular_programme_pricings_aggregate', aggregate?: { __typename?: 'regular_programme_pricings_aggregate_fields', count?: number | null } | null } };

export type GetSpecialProgrammeClassPricingsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<Special_Programme_Class_Pricings_Bool_Exp>;
}>;


export type GetSpecialProgrammeClassPricingsQuery = { __typename?: 'query_root', special_programme_class_pricings: Array<{ __typename?: 'special_programme_class_pricings', pricePerStudent: any, id: any, studentType: string, updatedAt: any, class: { __typename?: 'classes', id: any, name: string, programTypeSpecial?: { __typename?: 'specical_program_types', id: any, fullName: string } | null }, updater?: { __typename?: 'users', id: any, fullName?: string | null, avatar?: string | null } | null }>, special_programme_class_pricings_aggregate: { __typename?: 'special_programme_class_pricings_aggregate', aggregate?: { __typename?: 'special_programme_class_pricings_aggregate_fields', count?: number | null } | null } };

export type GetDetailInvoicePaperQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetDetailInvoicePaperQuery = { __typename?: 'query_root', getDetailInvoice?: { __typename?: 'InvoiceModel', dueDate?: any | null, id?: string | null, isRegistrationFee?: boolean | null, issueDate?: any | null, name?: string | null, notes?: string | null, link?: string | null, paymentStatus?: string | null, remarks?: string | null, branch?: { __typename?: 'BranchModel', id?: string | null, address?: string | null, name?: string | null } | null, transferBill?: { __typename?: 'TransferBill', transferDate?: any | null, reason?: string | null, className?: string | null, mutualTerms?: Array<string | null> | null, classBills?: Array<{ __typename?: 'ClassBillInfo', classFee?: number | null, terms?: Array<string | null> | null, passedLessons?: number | null, paidLessons?: number | null } | null> | null } | null, classInformation?: { __typename?: 'ClassBill', total?: number | null, data?: Array<{ __typename?: 'ClassDetail', subject?: string | null, classType?: string | null, curriculums?: Array<string | null> | null, levels?: Array<string | null> | null, branch?: string | null, id?: string | null, name?: string | null, additionalDiscount?: number | null, total?: number | null, totalDiscount?: number | null, additionalLesson?: { __typename?: 'AdditionalLesson', pricing?: number | null, quantity?: number | null, total?: number | null } | null, firstSession?: { __typename?: 'Session', startTime?: any | null, endTime?: any | null } | null, period?: { __typename?: 'Period', endDate?: any | null, startDate?: any | null } | null, terms?: Array<{ __typename?: 'TermDetail', academicYear?: string | null, endDate?: any | null, lessons?: Array<any | null> | null, pricing?: number | null, startDate?: any | null, name?: string | null } | null> | null, discounts?: Array<{ __typename?: 'DiscountClass', amount?: number | null, code?: string | null, id?: string | null, name?: string | null, unit?: string | null } | null> | null } | null> | null } | null, deduction?: { __typename?: 'OutFee', total?: number | null, data?: Array<{ __typename?: 'Fee', amount?: number | null, name?: string | null } | null> | null } | null, otherPayments?: { __typename?: 'OutFee', total?: number | null, data?: Array<{ __typename?: 'Fee', amount?: number | null, name?: string | null } | null> | null } | null, deposit?: { __typename?: 'OutFee', total?: number | null, data?: Array<{ __typename?: 'Fee', amount?: number | null, name?: string | null } | null> | null } | null, student?: { __typename?: 'StudentModel', email?: string | null, id?: string | null, fullName?: string | null, username?: string | null, phoneNumber?: string | null, studentId?: string | null, studentProfile?: { __typename?: 'StudentProfileModel', willPayLater?: boolean | null, school?: { __typename?: 'MasterDataAtPaymentAdvice', id?: string | null, name?: string | null } | null } | null } | null, summary?: { __typename?: 'Summary', classFee?: number | null, deduction?: number | null, deposit?: number | null, gst?: number | null, gstConfig?: number | null, otherPayments?: number | null, registrationFee?: number | null, totalAfterGst?: number | null, totalBeforeGst?: number | null, totalPaid?: number | null, totalPayable?: number | null } | null } | null };

export type BranchesListQueryVariables = Exact<{
  search: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  order: Order_By;
}>;


export type BranchesListQuery = { __typename?: 'query_root', branches: Array<{ __typename?: 'branches', abbreviation?: string | null, address?: string | null, city?: string | null, country?: string | null, createdAt: any, createdBy?: any | null, id: any, name: string, postalCode?: string | null, status: string, updatedAt: any, updatedBy?: any | null, classrooms_aggregate: { __typename?: 'classrooms_aggregate', aggregate?: { __typename?: 'classrooms_aggregate_fields', count?: number | null } | null } }>, branches_aggregate: { __typename?: 'branches_aggregate', aggregate?: { __typename?: 'branches_aggregate_fields', count?: number | null } | null } };

export type FirstBranchQueryVariables = Exact<{ [key: string]: never; }>;


export type FirstBranchQuery = { __typename?: 'query_root', branches: Array<{ __typename?: 'branches', abbreviation?: string | null, address?: string | null, city?: string | null, country?: string | null, createdAt: any, createdBy?: any | null, id: any, name: string, postalCode?: string | null, status: string, updatedAt: any, updatedBy?: any | null, classrooms_aggregate: { __typename?: 'classrooms_aggregate', aggregate?: { __typename?: 'classrooms_aggregate_fields', count?: number | null } | null } }> };

export type GetAllBranchesQueryVariables = Exact<{
  filter?: InputMaybe<Branches_Bool_Exp>;
}>;


export type GetAllBranchesQuery = { __typename?: 'query_root', branches: Array<{ __typename?: 'branches', abbreviation?: string | null, address?: string | null, city?: string | null, country?: string | null, createdAt: any, createdBy?: any | null, id: any, name: string, postalCode?: string | null, status: string, updatedAt: any, updatedBy?: any | null, classrooms_aggregate: { __typename?: 'classrooms_aggregate', aggregate?: { __typename?: 'classrooms_aggregate_fields', count?: number | null } | null } }> };

export type ClassroomsListQueryVariables = Exact<{
  id: Scalars['uuid'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  order: Order_By;
}>;


export type ClassroomsListQuery = { __typename?: 'query_root', classrooms: Array<{ __typename?: 'classrooms', branchId: any, capacity: number, createdAt: any, createdBy?: any | null, id: any, name: string, status: string, updatedAt: any, updatedBy?: any | null }>, classrooms_aggregate: { __typename?: 'classrooms_aggregate', aggregate?: { __typename?: 'classrooms_aggregate_fields', count?: number | null } | null } };

export type GetAllClassroomsQueryVariables = Exact<{
  filter?: InputMaybe<Classrooms_Bool_Exp>;
}>;


export type GetAllClassroomsQuery = { __typename?: 'query_root', classrooms: Array<{ __typename?: 'classrooms', branchId: any, capacity: number, createdAt: any, createdBy?: any | null, id: any, name: string, status: string, updatedAt: any, updatedBy?: any | null }> };

export type GetBranchByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetBranchByIdQuery = { __typename?: 'query_root', branches: Array<{ __typename?: 'branches', abbreviation?: string | null, address?: string | null, city?: string | null, country?: string | null, createdAt: any, createdBy?: any | null, id: any, name: string, postalCode?: string | null, status: string, updatedAt: any, updatedBy?: any | null, classrooms_aggregate: { __typename?: 'classrooms_aggregate', aggregate?: { __typename?: 'classrooms_aggregate_fields', count?: number | null } | null } }> };

export type CurriculumsLevelsQueryVariables = Exact<{
  filter?: InputMaybe<Curriculums_Levels_Bool_Exp>;
}>;


export type CurriculumsLevelsQuery = { __typename?: 'query_root', curriculums_levels: Array<{ __typename?: 'curriculums_levels', curriculumId: any, id: any, curriculum: { __typename?: 'curriculums', name: string, id: any, abbreviation?: string | null }, level: { __typename?: 'levels', name: string, id: any, abbreviation: string } }> };

export type LevelsListQueryVariables = Exact<{ [key: string]: never; }>;


export type LevelsListQuery = { __typename?: 'query_root', levels: Array<{ __typename?: 'levels', id: any, name: string, abbreviation: string, createdAt: any, createdBy?: any | null, status: string, updatedAt: any, updatedBy?: any | null }> };

export type CurriculumsListQueryVariables = Exact<{ [key: string]: never; }>;


export type CurriculumsListQuery = { __typename?: 'query_root', curriculums: Array<{ __typename?: 'curriculums', id: any, name: string, abbreviation?: string | null, createdAt: any, createdBy?: any | null, status: string, updatedAt: any, updatedBy?: any | null }> };

export type SubjectsListQueryVariables = Exact<{ [key: string]: never; }>;


export type SubjectsListQuery = { __typename?: 'query_root', subjects: Array<{ __typename?: 'subjects', abbreviation: string, createdAt: any, createdBy?: any | null, id: any, name: string, status: string, updatedAt: any, updatedBy?: any | null }> };

export type FilterUserQueryVariables = Exact<{
  filter?: InputMaybe<Users_Bool_Exp>;
  order?: InputMaybe<Array<Users_Order_By> | Users_Order_By>;
}>;


export type FilterUserQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, role: string, email?: string | null, firstName: string, lastName: string, avatar?: string | null, isVerifiedEmail: boolean, isVerifiedPhoneNumber: boolean, phone: any, phoneNumber?: string | null, status: string, address?: string | null, username?: string | null, roleIds?: any | null, levels?: Array<{ __typename?: 'levels', id: any, name: string, abbreviation: string }> | null, subjects?: Array<{ __typename?: 'subjects', id: any, name: string }> | null, roles?: Array<{ __typename?: 'roles', id: any, name: string, role?: string | null }> | null, studentProfile?: { __typename?: 'student_profiles', id: any, school?: { __typename?: 'schools', id: any, name: string } | null, curriculum?: { __typename?: 'curriculums', id: any, name: string, abbreviation?: string | null } | null, level?: { __typename?: 'levels', id: any, name: string, abbreviation: string } | null } | null }> };

export type SchoolModelFragment = { __typename?: 'schools', id: any, name: string };

export type StudentProfileModelFragment = { __typename?: 'student_profiles', id: any, school?: { __typename?: 'schools', id: any, name: string } | null, curriculum?: { __typename?: 'curriculums', id: any, name: string, abbreviation?: string | null } | null, level?: { __typename?: 'levels', id: any, name: string, abbreviation: string } | null };

export type GetInfoClassesByStatusQueryVariables = Exact<{
  status: Scalars['String'];
}>;


export type GetInfoClassesByStatusQuery = { __typename?: 'query_root', classes: Array<{ __typename?: 'classes', classStatus: string, id: any, lessons: Array<{ __typename?: 'lessons', date: any, students_aggregate: { __typename?: 'lessons_students_aggregate', aggregate?: { __typename?: 'lessons_students_aggregate_fields', count?: number | null } | null } }>, program: { __typename?: 'programs', id: any, name: string }, programTypeGeneral?: { __typename?: 'general_program_types', id: any, fullName: string } | null, programTypeDoubleLesson?: { __typename?: 'double_lesson_program_types', id: any, fullName: string } | null, programTypeRegular?: { __typename?: 'regular_program_types', id: any, fullName: string } | null, programTypeSpecial?: { __typename?: 'specical_program_types', id: any, fullName: string } | null }> };

export type GetInfoClassesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInfoClassesQuery = { __typename?: 'query_root', classes: Array<{ __typename?: 'classes', classStatus: string, id: any, lessons: Array<{ __typename?: 'lessons', date: any, students_aggregate: { __typename?: 'lessons_students_aggregate', aggregate?: { __typename?: 'lessons_students_aggregate_fields', count?: number | null } | null } }>, program: { __typename?: 'programs', id: any, name: string }, programTypeGeneral?: { __typename?: 'general_program_types', id: any, fullName: string } | null, programTypeRegular?: { __typename?: 'regular_program_types', id: any, fullName: string } | null, programTypeSpecial?: { __typename?: 'specical_program_types', id: any, fullName: string } | null, programTypeDoubleLesson?: { __typename?: 'double_lesson_program_types', fullName: string, id: any } | null }> };

export type GetInformationClassesQueryVariables = Exact<{
  limit: Scalars['Int'];
}>;


export type GetInformationClassesQuery = { __typename?: 'query_root', classes: Array<{ __typename?: 'classes', classStatus: string, id: any, lessons: Array<{ __typename?: 'lessons', classId: any, createdBy?: any | null, createdAt: any, students_aggregate: { __typename?: 'lessons_students_aggregate', aggregate?: { __typename?: 'lessons_students_aggregate_fields', count?: number | null } | null } }>, program: { __typename?: 'programs', id: any, name: string }, programTypeGeneral?: { __typename?: 'general_program_types', id: any, fullName: string } | null, programTypeRegular?: { __typename?: 'regular_program_types', id: any, fullName: string } | null, programTypeSpecial?: { __typename?: 'specical_program_types', id: any, fullName: string } | null }> };

export type GetCountSpecialClassesQueryVariables = Exact<{
  programId: Scalars['String'];
}>;


export type GetCountSpecialClassesQuery = { __typename?: 'query_root', countSpecialClasses?: any | null };

export type GetListClassesByProgramTypeQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  programType: Scalars['String'];
  programId: Scalars['uuid'];
  classStatus?: InputMaybe<Scalars['String']>;
  filterClasses?: InputMaybe<Classes_Bool_Exp>;
}>;


export type GetListClassesByProgramTypeQuery = { __typename?: 'query_root', classes: Array<{ __typename?: 'classes', classStatus: string, id: any, status: string, totalLoop?: any | null, updatedAt: any, updatedBy?: any | null, waitingTime?: any | null, remark?: string | null, name: string, classId: string, startDate?: any | null, lessons: Array<{ __typename?: 'lessons', students_aggregate: { __typename?: 'lessons_students_aggregate', aggregate?: { __typename?: 'lessons_students_aggregate_fields', count?: number | null } | null } }>, program: { __typename?: 'programs', id: any, name: string }, programTypeGeneral?: { __typename?: 'general_program_types', id: any, fullName: string } | null, programTypeRegular?: { __typename?: 'regular_program_types', id: any, fullName: string } | null, programTypeSpecial?: { __typename?: 'specical_program_types', id: any, fullName: string } | null }>, classes_aggregate: { __typename?: 'classes_aggregate', aggregate?: { __typename?: 'classes_aggregate_fields', count?: number | null } | null } };

export type GetListSpecialProgramTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListSpecialProgramTypeQuery = { __typename?: 'query_root', specical_program_types: Array<{ __typename?: 'specical_program_types', id: any, fullName: string, shortName: string }> };

export type GetClassesAggregateQueryVariables = Exact<{
  programId: Scalars['uuid'];
  programTypeSpecialId?: InputMaybe<Scalars['uuid']>;
}>;


export type GetClassesAggregateQuery = { __typename?: 'query_root', classes_aggregate: { __typename?: 'classes_aggregate', aggregate?: { __typename?: 'classes_aggregate_fields', count?: number | null } | null } };

export type ExtendWaitingPeriodMutationVariables = Exact<{
  form: FormExtendWaitingPeriod;
}>;


export type ExtendWaitingPeriodMutation = { __typename?: 'mutation_root', extendWaitingPeriod?: any | null };

export type UpdateAcademicCalendarsMutationVariables = Exact<{
  id: Scalars['uuid'];
  form?: InputMaybe<Academic_Calendars_Set_Input>;
}>;


export type UpdateAcademicCalendarsMutation = { __typename?: 'mutation_root', update_academic_calendars?: { __typename?: 'academic_calendars_mutation_response', returning: Array<{ __typename?: 'academic_calendars', createdAt: any, createdBy?: any | null, curriculumId: any, id: any, levelIds: any, name: string, status: string }> } | null };

export type CreateTermsMutationVariables = Exact<{
  form: Array<Terms_Insert_Input> | Terms_Insert_Input;
}>;


export type CreateTermsMutation = { __typename?: 'mutation_root', insert_terms?: { __typename?: 'terms_mutation_response', returning: Array<{ __typename?: 'terms', createdBy?: any | null, createdAt: any, academicCalendarId: any, status: string, updatedAt: any, updatedBy?: any | null, id: any, startDate: any, endDate: any, numberOfLessons?: number | null }> } | null };

export type UpdateTermsMutationVariables = Exact<{
  id: Scalars['uuid'];
  form?: InputMaybe<Terms_Set_Input>;
}>;


export type UpdateTermsMutation = { __typename?: 'mutation_root', update_terms?: { __typename?: 'terms_mutation_response', returning: Array<{ __typename?: 'terms', id: any, endDate: any, createdBy?: any | null, createdAt: any, academicCalendarId: any, numberOfLessons?: number | null, startDate: any, status: string, updatedAt: any, updatedBy?: any | null }> } | null };

export type ClassesListQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  searchString: Scalars['String'];
  classStatus: Scalars['String'];
  order: Order_By;
  filterProgram?: InputMaybe<Programs_Bool_Exp>;
  filterProgramType?: InputMaybe<Classes_Bool_Exp>;
  status: Scalars['String'];
  year?: InputMaybe<Scalars['String']>;
}>;


export type ClassesListQuery = { __typename?: 'query_root', class_filter_by_filling_status: Array<{ __typename?: 'classes', enrolledClass?: number | null, classStatus: string, academicCalendarId?: any | null, id: any, status: string, totalLoop?: any | null, updatedAt: any, updatedBy?: any | null, waitingTime?: any | null, remark?: string | null, name: string, classId: string, startDate?: any | null, year?: string | null, lessons: Array<{ __typename?: 'lessons', date: any, classroom: { __typename?: 'classrooms', capacity: number, name: string, id: any }, students_aggregate: { __typename?: 'lessons_students_aggregate', aggregate?: { __typename?: 'lessons_students_aggregate_fields', count?: number | null } | null } }>, studentsWaiting_aggregate: { __typename?: 'class_students_waiting_aggregate', aggregate?: { __typename?: 'class_students_waiting_aggregate_fields', count?: number | null } | null }, program: { __typename?: 'programs', id: any, name: string }, programTypeRegular?: { __typename?: 'regular_program_types', id: any, fullName: string } | null, programTypeGeneral?: { __typename?: 'general_program_types', id: any, fullName: string } | null, programTypeSpecial?: { __typename?: 'specical_program_types', id: any, fullName: string } | null, academicCalendar?: { __typename?: 'academic_calendars', id: any, year: string } | null }>, class_filter_by_filling_status_aggregate: { __typename?: 'classes_aggregate', aggregate?: { __typename?: 'classes_aggregate_fields', count?: number | null } | null } };

export type UserClassesListQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  searchString: Scalars['String'];
  order: Order_By;
  classStatus: Scalars['String'];
  filterProgram?: InputMaybe<Programs_Bool_Exp>;
  filterProgramType?: InputMaybe<Classes_Bool_Exp>;
  status?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
}>;


export type UserClassesListQuery = { __typename?: 'query_root', classes: Array<{ __typename?: 'classes', enrolledClass?: number | null, classStatus: string, academicCalendarId?: any | null, id: any, status: string, totalLoop?: any | null, updatedAt: any, updatedBy?: any | null, waitingTime?: any | null, remark?: string | null, name: string, classId: string, startDate?: any | null, year?: string | null, lessons: Array<{ __typename?: 'lessons', date: any, classroom: { __typename?: 'classrooms', capacity: number, name: string, id: any }, students_aggregate: { __typename?: 'lessons_students_aggregate', aggregate?: { __typename?: 'lessons_students_aggregate_fields', count?: number | null } | null } }>, studentsWaiting_aggregate: { __typename?: 'class_students_waiting_aggregate', aggregate?: { __typename?: 'class_students_waiting_aggregate_fields', count?: number | null } | null }, program: { __typename?: 'programs', id: any, name: string }, programTypeRegular?: { __typename?: 'regular_program_types', id: any, fullName: string } | null, programTypeGeneral?: { __typename?: 'general_program_types', id: any, fullName: string } | null, programTypeSpecial?: { __typename?: 'specical_program_types', id: any, fullName: string } | null, academicCalendar?: { __typename?: 'academic_calendars', id: any, year: string } | null }>, classes_aggregate: { __typename?: 'classes_aggregate', aggregate?: { __typename?: 'classes_aggregate_fields', count?: number | null } | null } };

export type GetClassByPkQueryVariables = Exact<{
  id: Scalars['uuid'];
  studentId: Scalars['uuid'];
  filterLesson?: InputMaybe<Lessons_Bool_Exp>;
}>;


export type GetClassByPkQuery = { __typename?: 'query_root', classes_by_pk?: { __typename?: 'classes', id: any, name: string, classId: string, classStatus: string, createdAt: any, lessonType: string, enrolledClass?: number | null, remark?: string | null, startDate?: any | null, program: { __typename?: 'programs', id: any, name: string, category?: string | null, curriculums?: Array<{ __typename?: 'curriculums', id: any, name: string, abbreviation?: string | null }> | null, levels?: Array<{ __typename?: 'levels', id: any, name: string, abbreviation: string }> | null, subject: { __typename?: 'subjects', abbreviation: string, name: string, id: any } }, programTypeGeneral?: { __typename?: 'general_program_types', id: any, shortName: string, fullName: string } | null, programTypeRegular?: { __typename?: 'regular_program_types', id: any, fullName: string, shortName: string } | null, programTypeSpecial?: { __typename?: 'specical_program_types', id: any, fullName: string, shortName: string } | null, lessons: Array<{ __typename?: 'lessons', date: any, id: any, lessonStatus: string, orderPriority: any, numberWeek?: number | null, sessions: Array<{ __typename?: 'sessions', id: any, endTime: any, startTime: any }>, classroom: { __typename?: 'classrooms', branch: { __typename?: 'branches', abbreviation?: string | null, name: string, id: any } }, termClass?: { __typename?: 'term_classes', classId: any, createdAt: any, termName: string } | null }> } | null, lessons_students: Array<{ __typename?: 'lessons_students', hasAttended: boolean, id: any, lessonId: any, lessonStatus?: string | null, studentId: any, type: string, entryTime?: any | null, oldLessonId?: any | null, oldLesson?: { __typename?: 'lessons', classId: any } | null, lesson: { __typename?: 'lessons', classId: any, id: any, date: any, lessonStatus: string, class: { __typename?: 'classes', name: string }, sessions: Array<{ __typename?: 'sessions', startTime: any, endTime: any }>, classroom: { __typename?: 'classrooms', branch: { __typename?: 'branches', name: string, abbreviation?: string | null, id: any } } } }> };

export type AddClassMutationVariables = Exact<{
  form: FormCreateClass;
}>;


export type AddClassMutation = { __typename?: 'mutation_root', addClass?: string | null };

export type AddLessonMutationVariables = Exact<{
  classId: Scalars['String'];
  form: FormCreateLesson;
}>;


export type AddLessonMutation = { __typename?: 'mutation_root', addLesson?: string | null };

export type GetClassroomAvailableQueryVariables = Exact<{
  form?: InputMaybe<FormGetClassroomAvailable>;
}>;


export type GetClassroomAvailableQuery = { __typename?: 'query_root', getClassroomAvailable?: Array<string | null> | null };

export type LessonsByClassIdQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  order: Order_By;
  classId: Scalars['uuid'];
}>;


export type LessonsByClassIdQuery = { __typename?: 'query_root', lessons: Array<{ __typename?: 'lessons', id: any, lessonStatus: string, numberWeek?: number | null, date: any, termClass?: { __typename?: 'term_classes', id: any, termId: any, termName: string, term: { __typename?: 'terms', id: any } } | null, sessions: Array<{ __typename?: 'sessions', id: any, startTime: any, endTime: any, tutors?: Array<{ __typename?: 'users', id: any, firstName: string, lastName: string }> | null }>, classroom: { __typename?: 'classrooms', capacity: number, name: string, id: any, branch: { __typename?: 'branches', name: string, id: any } }, replacement_aggregate: { __typename?: 'lessons_students_aggregate', aggregate?: { __typename?: 'lessons_students_aggregate_fields', count?: number | null } | null }, students_aggregate: { __typename?: 'lessons_students_aggregate', aggregate?: { __typename?: 'lessons_students_aggregate_fields', count?: number | null } | null } }>, lessons_aggregate: { __typename?: 'lessons_aggregate', aggregate?: { __typename?: 'lessons_aggregate_fields', count?: number | null } | null } };

export type LessonsAggregateSubQueryVariables = Exact<{
  classId: Scalars['uuid'];
}>;


export type LessonsAggregateSubQuery = { __typename?: 'query_root', lessons_aggregate: { __typename?: 'lessons_aggregate', aggregate?: { __typename?: 'lessons_aggregate_fields', count?: number | null } | null } };

export type CancelLessonMutationVariables = Exact<{
  lessonId: Scalars['String'];
}>;


export type CancelLessonMutation = { __typename?: 'mutation_root', cancelLesson?: string | null };

export type GetBranchesWithAllClassRoomQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBranchesWithAllClassRoomQuery = { __typename?: 'query_root', branches: Array<{ __typename?: 'branches', abbreviation?: string | null, name: string, id: any, classrooms: Array<{ __typename?: 'classrooms', id: any, name: string, capacity: number }> }> };

export type ChangeClassroomForLessonMutationVariables = Exact<{
  classroomID: Scalars['String'];
  lessonID: Scalars['String'];
}>;


export type ChangeClassroomForLessonMutation = { __typename?: 'mutation_root', changeClassroomForLesson?: string | null };

export type UpdateSessionMutationVariables = Exact<{
  tutors: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  sessionID: Scalars['String'];
}>;


export type UpdateSessionMutation = { __typename?: 'mutation_root', updateSession?: string | null };

export type AddStudentToLessonMutationVariables = Exact<{
  lessonId: Scalars['String'];
  studentId: Scalars['String'];
  type: Scalars['String'];
  oriLessonId?: InputMaybe<Scalars['String']>;
  oldLessonId?: InputMaybe<Scalars['String']>;
}>;


export type AddStudentToLessonMutation = { __typename?: 'mutation_root', addStudentToLesson?: string | null };

export type LessonsStudentsListQueryVariables = Exact<{
  lessonId: Scalars['uuid'];
}>;


export type LessonsStudentsListQuery = { __typename?: 'query_root', lessons_students: Array<{ __typename?: 'lessons_students', id: any, type: string, status: string, student: { __typename?: 'users', firstName: string, lastName: string, studentId?: any | null, username?: string | null, id: any, studentProfile?: { __typename?: 'student_profiles', id: any, school?: { __typename?: 'schools', id: any, name: string } | null, curriculum?: { __typename?: 'curriculums', id: any, name: string, abbreviation?: string | null } | null, level?: { __typename?: 'levels', id: any, name: string, abbreviation: string } | null } | null } }> };

export type DeleteLessonsStudentMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteLessonsStudentMutation = { __typename?: 'mutation_root', delete_lessons_students?: { __typename?: 'lessons_students_mutation_response', affected_rows: number } | null };

export type UpdateClassesMutationVariables = Exact<{
  id: Scalars['uuid'];
  status: Scalars['String'];
}>;


export type UpdateClassesMutation = { __typename?: 'mutation_root', update_classes?: { __typename?: 'classes_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'classes', classStatus: string, id: any, classId: string }> } | null };

export type ClassStudentsWaitingQueryVariables = Exact<{
  classID: Scalars['uuid'];
}>;


export type ClassStudentsWaitingQuery = { __typename?: 'query_root', class_students_waiting: Array<{ __typename?: 'class_students_waiting', waitingStatus: string, id: any, paymentStatus: string, status: string, classId: any, student: { __typename?: 'users', id: any, firstName: string, lastName: string, username?: string | null, studentId?: any | null, studentProfile?: { __typename?: 'student_profiles', willPayLater: boolean, id: any, school?: { __typename?: 'schools', id: any, name: string } | null, curriculum?: { __typename?: 'curriculums', id: any, name: string, abbreviation?: string | null } | null, level?: { __typename?: 'levels', id: any, name: string, abbreviation: string } | null } | null } }> };

export type AddStudentToWaitingListMutationVariables = Exact<{
  classID: Scalars['String'];
  studentIds: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;


export type AddStudentToWaitingListMutation = { __typename?: 'mutation_root', addStudentToWaitingList?: string | null };

export type ChangeClassStatusMutationVariables = Exact<{
  classId: Scalars['String'];
  form: FormChangeClassStatus;
}>;


export type ChangeClassStatusMutation = { __typename?: 'mutation_root', changeClassStatus?: string | null };

export type DeleteClassStudentsWaitingByPkMutationVariables = Exact<{
  classId: Scalars['String'];
  studentId: Scalars['String'];
}>;


export type DeleteClassStudentsWaitingByPkMutation = { __typename?: 'mutation_root', deleteStudentInWaitingList?: string | null };

export type UpdateClassroomMutationVariables = Exact<{
  classroomId: Scalars['String'];
  form: FormCreateClassroom;
}>;


export type UpdateClassroomMutation = { __typename?: 'mutation_root', updateClassroom?: string | null };

export type FilterUserWithPaginationQueryVariables = Exact<{
  filter?: InputMaybe<Users_Bool_Exp>;
  order?: InputMaybe<Array<Users_Order_By> | Users_Order_By>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type FilterUserWithPaginationQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, role: string, email?: string | null, firstName: string, lastName: string, fullName?: string | null, avatar?: string | null, isVerifiedEmail: boolean, isVerifiedPhoneNumber: boolean, phone: any, phoneNumber?: string | null, status: string, address?: string | null, username?: string | null, paymentStatus?: string | null, studentProfile?: { __typename?: 'student_profiles', id: any, school?: { __typename?: 'schools', id: any, name: string } | null, curriculum?: { __typename?: 'curriculums', id: any, name: string, abbreviation?: string | null } | null, level?: { __typename?: 'levels', id: any, name: string, abbreviation: string } | null } | null, lessonsStudents: Array<{ __typename?: 'lessons_students', type: string, studentId: any, id: any, lessonId: any }>, studentsWaiting: Array<{ __typename?: 'class_students_waiting', id: any, status: string, waitingStatus: string, classId: any }> }>, users_aggregate: { __typename?: 'users_aggregate', aggregate?: { __typename?: 'users_aggregate_fields', count?: number | null } | null } };

export type GetSchoolsListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSchoolsListQuery = { __typename?: 'query_root', schools: Array<{ __typename?: 'schools', id: any, name: string }> };

export type StepStudentInformationMutationVariables = Exact<{
  studentId: Scalars['String'];
  form: FormStudentInformation;
}>;


export type StepStudentInformationMutation = { __typename?: 'mutation_root', stepStudentInformation?: string | null };

export type ListClassesCreateStudentQueryVariables = Exact<{
  args: Payment_Advice_Classes_By_Student_Id_Args;
  filter?: InputMaybe<Classes_Bool_Exp>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type ListClassesCreateStudentQuery = { __typename?: 'query_root', payment_advice_classes_by_student_id: Array<{ __typename?: 'classes', id: any, status: string, classStatus: string, name: string, programId: any, remark?: string | null, waitingTime?: any | null, studentsWaiting_aggregate: { __typename?: 'class_students_waiting_aggregate', aggregate?: { __typename?: 'class_students_waiting_aggregate_fields', count?: number | null } | null }, lessons: Array<{ __typename?: 'lessons', date: any, id: any, sessions: Array<{ __typename?: 'sessions', startTime: any, endTime: any, id: any, tutors?: Array<{ __typename?: 'users', firstName: string, lastName: string, id: any }> | null }>, students_aggregate: { __typename?: 'lessons_students_aggregate', aggregate?: { __typename?: 'lessons_students_aggregate_fields', count?: number | null } | null }, classroom: { __typename?: 'classrooms', id: any, capacity: number } }> }>, payment_advice_classes_by_student_id_aggregate: { __typename?: 'classes_aggregate', aggregate?: { __typename?: 'classes_aggregate_fields', count?: number | null } | null } };

export type GetListStatusStudentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListStatusStudentQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, status: string }> };

export type ActiveStatusOfStudentMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type ActiveStatusOfStudentMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', status: string, studentId?: any | null, id: any } | null };

export type GetListLevelStudentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListLevelStudentQuery = { __typename?: 'query_root', levels: Array<{ __typename?: 'levels', name: string, id: any, abbreviation: string }> };

export type GetListLevelCurriculumStudentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListLevelCurriculumStudentQuery = { __typename?: 'query_root', curriculums_levels: Array<{ __typename?: 'curriculums_levels', curriculumId: any, levelId: any, curriculum: { __typename?: 'curriculums', id: any, name: string, abbreviation?: string | null }, level: { __typename?: 'levels', id: any, name: string, abbreviation: string } }> };

export type GetListCurriculumStudentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListCurriculumStudentQuery = { __typename?: 'query_root', curriculums: Array<{ __typename?: 'curriculums', id: any, name: string, abbreviation?: string | null }> };

export type AutoCompleteSearchStudentQueryVariables = Exact<{
  form?: InputMaybe<Users_Bool_Exp>;
}>;


export type AutoCompleteSearchStudentQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, firstName: string, lastName: string, username?: string | null, studentProfile?: { __typename?: 'student_profiles', id: any, school?: { __typename?: 'schools', id: any, name: string } | null } | null }> };

export type GetListUsersQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetListUsersQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, phone: any, phoneNumber?: string | null, email?: string | null, firstName: string, lastName: string, role: string, dob?: any | null, gender?: string | null, address?: string | null, status: string, code?: string | null, username?: string | null, fullName?: string | null, isVerifiedEmail: boolean, isVerifiedPhoneNumber: boolean, studentProfile?: { __typename?: 'student_profiles', id: any, parents?: any | null, firstParent?: any | null, subscribe: boolean } | null, roles?: Array<{ __typename?: 'roles', name: string, role?: string | null }> | null }>, users_aggregate: { __typename?: 'users_aggregate', aggregate?: { __typename?: 'users_aggregate_fields', count?: number | null } | null } };

export type CreateStudentMutationVariables = Exact<{
  form: CreateStudentForm;
}>;


export type CreateStudentMutation = { __typename?: 'mutation_root', createStudent?: string | null };

export type StepFamilyInformationMutationVariables = Exact<{
  form: FormFamilyInformation;
  studentId: Scalars['String'];
}>;


export type StepFamilyInformationMutation = { __typename?: 'mutation_root', stepFamilyInformation?: string | null };

export type StepProgramAndClassMutationVariables = Exact<{
  studentId: Scalars['String'];
  form: FormProgramAndClass;
}>;


export type StepProgramAndClassMutation = { __typename?: 'mutation_root', stepProgramAndClass?: string | null };

export type GetStudentDetailQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetStudentDetailQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', id: any, address?: string | null, avatar?: string | null, code?: string | null, createdAt: any, dob?: any | null, email?: string | null, firstName: string, gender?: string | null, lastName: string, phone: any, username?: string | null, status: string, paymentStatus?: string | null, studentsWaiting_aggregate: { __typename?: 'class_students_waiting_aggregate', aggregate?: { __typename?: 'class_students_waiting_aggregate_fields', count?: number | null } | null }, studentsWaiting: Array<{ __typename?: 'class_students_waiting', id: any, status: string, waitingStatus: string, classId: any, class: { __typename?: 'classes', id: any, status: string, classStatus: string, name: string, programId: any, remark?: string | null, waitingTime?: any | null, lessons: Array<{ __typename?: 'lessons', date: any, id: any, sessions: Array<{ __typename?: 'sessions', startTime: any, endTime: any, id: any, tutors?: Array<{ __typename?: 'users', firstName: string, lastName: string, id: any }> | null }>, students_aggregate: { __typename?: 'lessons_students_aggregate', aggregate?: { __typename?: 'lessons_students_aggregate_fields', count?: number | null } | null }, classroom: { __typename?: 'classrooms', id: any, capacity: number } }> } }>, siblings: Array<{ __typename?: 'discount_students', id: any, referenceId?: any | null, relationships?: string | null, studentId: any, reference?: { __typename?: 'users', id: any, firstName: string, email?: string | null, gender?: string | null, phone: any, lastName: string, studentProfile?: { __typename?: 'student_profiles', id: any, curriculum?: { __typename?: 'curriculums', abbreviation?: string | null, id: any, name: string } | null, level?: { __typename?: 'levels', abbreviation: string, id: any, name: string } | null } | null } | null }>, discountStudents: Array<{ __typename?: 'discount_students', id: any, student: { __typename?: 'users', id: any, firstName: string, email?: string | null, gender?: string | null, lastName: string, studentId?: any | null, studentProfile?: { __typename?: 'student_profiles', id: any, curriculum?: { __typename?: 'curriculums', abbreviation?: string | null, id: any, name: string } | null, level?: { __typename?: 'levels', abbreviation: string, id: any, name: string } | null } | null }, discount: { __typename?: 'discounts', id: any, code?: string | null } }>, studentProfile?: { __typename?: 'student_profiles', id: any, payLaterReason?: string | null, willPayLater: boolean, billing?: any | null, curriculumId?: any | null, levelId?: any | null, schoolId?: any | null, payOnline: boolean, status: string, subscribe: boolean, payment?: any | null, parents?: any | null, mailling?: any | null, emergencyContact?: any | null, currentStep?: string | null, curriculum?: { __typename?: 'curriculums', id: any, abbreviation?: string | null } | null, level?: { __typename?: 'levels', id: any, abbreviation: string } | null, school?: { __typename?: 'schools', id: any, name: string } | null } | null } | null };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteUserMutation = { __typename?: 'mutation_root', deleteUser?: string | null };

export type FilterProgramStudentQueryVariables = Exact<{
  args: Students_Programs_Filter_Args;
  filter?: InputMaybe<Programs_Bool_Exp>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type FilterProgramStudentQuery = { __typename?: 'query_root', students_programs_filter: Array<{ __typename?: 'programs', id: any, name: string, curriculums?: Array<{ __typename?: 'curriculums', abbreviation?: string | null, id: any }> | null, levels?: Array<{ __typename?: 'levels', abbreviation: string, id: any }> | null, subject: { __typename?: 'subjects', name: string, abbreviation: string, id: any } }>, students_programs_filter_aggregate: { __typename?: 'programs_aggregate', aggregate?: { __typename?: 'programs_aggregate_fields', count?: number | null } | null } };

export type FilterClassStudentQueryVariables = Exact<{
  form: FilterClassList;
  studentId: Scalars['String'];
}>;


export type FilterClassStudentQuery = { __typename?: 'query_root', filterClassByStudentId?: { __typename?: 'PaginationClassModel', data?: Array<{ __typename?: 'ClassModel', academicYear?: string | null, classStatus?: string | null, id?: string | null, name?: string | null, paymentStatus?: string | null, currentStudentStatus?: string | null, programCategory?: string | null, programType?: string | null, startDate?: any | null, classPaymentStatus?: { __typename?: 'ClassPaymentStatusModel', statusPaid?: Array<string | null> | null, statusUnpaid?: Array<string | null> | null } | null } | null> | null, pagination?: { __typename?: 'PaginationInfo', nextPageToken?: string | null, page?: number | null, totalPages?: number | null, totalPerPage?: number | null, total: number } | null } | null };

export type UpdateStudentMutationVariables = Exact<{
  form: UpdateStudentForm;
  studentId: Scalars['String'];
}>;


export type UpdateStudentMutation = { __typename?: 'mutation_root', updateStudent?: string | null };

export type RemoveStudentFromLessonMutationVariables = Exact<{
  lessonId: Scalars['String'];
  studentId: Scalars['String'];
}>;


export type RemoveStudentFromLessonMutation = { __typename?: 'mutation_root', removeStudentFromLesson?: string | null };

export type EditAvatarMutationVariables = Exact<{
  id: Scalars['uuid'];
  imgUrl: Scalars['String'];
}>;


export type EditAvatarMutation = { __typename?: 'mutation_root', update_users?: { __typename?: 'users_mutation_response', affected_rows: number } | null };

export type EditProfileMutationVariables = Exact<{
  id: Scalars['uuid'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  gender: Scalars['String'];
  dob: Scalars['timestamptz'];
}>;


export type EditProfileMutation = { __typename?: 'mutation_root', update_users?: { __typename?: 'users_mutation_response', affected_rows: number } | null };

export type ChangeUserAttributeMutationVariables = Exact<{
  form: ChangeUserAttributeInput;
}>;


export type ChangeUserAttributeMutation = { __typename?: 'mutation_root', changeUserAttribute?: string | null };

export type VerifyUserAttributeMutationVariables = Exact<{
  form: VerifyUserAttributeInput;
}>;


export type VerifyUserAttributeMutation = { __typename?: 'mutation_root', verifyUserAttribute?: string | null };

export type ResendVerificationCodeUserMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ResendVerificationCodeUserMutation = { __typename?: 'mutation_root', resendVerificationCodeUser?: string | null };

export type ResetUserPasswordMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ResetUserPasswordMutation = { __typename?: 'mutation_root', resetUserPassword?: string | null };

export type GetVerificationCodeMutationVariables = Exact<{
  form: GetVerificationCodeForm;
}>;


export type GetVerificationCodeMutation = { __typename?: 'mutation_root', getVerificationCode?: string | null };

export type ValidateClassesCapacityMutationVariables = Exact<{
  form: Array<InputMaybe<FormClassInformation>> | InputMaybe<FormClassInformation>;
}>;


export type ValidateClassesCapacityMutation = { __typename?: 'mutation_root', validateClassesCapacity?: boolean | null };

export type GetPaymentAdviceLogsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  paId: Scalars['uuid'];
}>;


export type GetPaymentAdviceLogsQuery = { __typename?: 'query_root', payment_advice_logs: Array<{ __typename?: 'payment_advice_logs', createdAt: any, createdBy: any, valueAfter?: any | null, valueBefore?: any | null, id: any, updatedAt: any, type: string, user: { __typename?: 'users', fullName?: string | null, role: string, id: any }, paymentAdvice: { __typename?: 'payment_advices', id: any, name: string, paymentStatus: string } }>, payment_advice_logs_aggregate: { __typename?: 'payment_advice_logs_aggregate', aggregate?: { __typename?: 'payment_advice_logs_aggregate_fields', count?: number | null } | null } };

export type GetCreditNoteLogsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  cnId: Scalars['uuid'];
}>;


export type GetCreditNoteLogsQuery = { __typename?: 'query_root', credit_note_logs: Array<{ __typename?: 'credit_note_logs', createdAt: any, createdBy?: any | null, id: any, type: string, valueAfter?: any | null, valueBefore?: any | null, updatedAt: any, user?: { __typename?: 'users', role: string, fullName?: string | null, id: any } | null, creditNote: { __typename?: 'credit_notes', id: any, name: string } }>, credit_note_logs_aggregate: { __typename?: 'credit_note_logs_aggregate', aggregate?: { __typename?: 'credit_note_logs_aggregate_fields', count?: number | null } | null } };

export type GetRefundLogsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  rfId: Scalars['uuid'];
}>;


export type GetRefundLogsQuery = { __typename?: 'query_root', refund_logs: Array<{ __typename?: 'refund_logs', id: any, refundId: any, createdBy?: any | null, createdAt: any, valueAfter?: any | null, valueBefore?: any | null, type: string, updatedAt: any, user?: { __typename?: 'users', id: any, fullName?: string | null, role: string } | null, refund: { __typename?: 'refunds', id: any, name: string } }>, refund_logs_aggregate: { __typename?: 'refund_logs_aggregate', aggregate?: { __typename?: 'refund_logs_aggregate_fields', count?: number | null } | null } };

export type GetRefundLogsDetailQueryVariables = Exact<{
  where?: InputMaybe<Refund_Logs_Bool_Exp>;
}>;


export type GetRefundLogsDetailQuery = { __typename?: 'query_root', refund_logs: Array<{ __typename?: 'refund_logs', id: any, updatedAt: any, type: string, valueAfter?: any | null, valueBefore?: any | null, user?: { __typename?: 'users', id: any, fullName?: string | null, role: string } | null, refund: { __typename?: 'refunds', id: any, name: string } }> };

export type GetCreditNoteLogsDetailQueryVariables = Exact<{
  where?: InputMaybe<Credit_Note_Logs_Bool_Exp>;
}>;


export type GetCreditNoteLogsDetailQuery = { __typename?: 'query_root', credit_note_logs: Array<{ __typename?: 'credit_note_logs', id: any, updatedAt: any, type: string, valueAfter?: any | null, valueBefore?: any | null, user?: { __typename?: 'users', id: any, fullName?: string | null, role: string } | null, creditNote: { __typename?: 'credit_notes', id: any, name: string } }> };

export type GetPaymentAdviceLogsDetailQueryVariables = Exact<{
  where?: InputMaybe<Payment_Advice_Logs_Bool_Exp>;
}>;


export type GetPaymentAdviceLogsDetailQuery = { __typename?: 'query_root', payment_advice_logs: Array<{ __typename?: 'payment_advice_logs', id: any, updatedAt: any, type: string, valueAfter?: any | null, valueBefore?: any | null, user: { __typename?: 'users', id: any, fullName?: string | null, role: string }, paymentAdvice: { __typename?: 'payment_advices', id: any, name: string, paymentStatus: string } }> };

export type PaymentAdvicesFragmentFragment = { __typename?: 'payment_advices', branchId?: any | null, classInformation?: any | null, createdAt: any, createdBy?: any | null, deduction?: any | null, deposit?: any | null, dueDate?: any | null, id: any, isOverdueAtPaid?: boolean | null, isRegistrationFee?: boolean | null, issueDate?: any | null, name: string, otherPayments?: any | null, paidAt?: any | null, paymentStatus: string, paymentSummaryStatic?: any | null, registrationFeeConfig?: any | null, remarks?: string | null, status: string, notes?: string | null, updatedAt: any, updatedBy?: any | null, studentId?: any | null, student?: { __typename?: 'users', address?: string | null, avatar?: string | null, code?: string | null, cognitoId?: string | null, createdAt: any, createdBy?: any | null, dob?: any | null, email?: string | null, firstName: string, fullName?: string | null, gender?: string | null, id: any, isVerifiedEmail: boolean, isVerifiedPhoneNumber: boolean, lastName: string, paymentStatus?: string | null, username?: string | null, updatedBy?: any | null, updatedAt: any } | null };

export type PaymentAdviceModelFragmentFragment = { __typename?: 'PaymentAdviceModel', dueDate?: any | null, id?: string | null, isRegistrationFee?: boolean | null, issueDate?: any | null, name?: string | null, paymentStatus?: string | null, remarks?: string | null, notes?: string | null, branch?: { __typename?: 'BranchModel', id?: string | null, address?: string | null, name?: string | null } | null, classInformation?: { __typename?: 'ClassFee', total?: number | null, data?: Array<{ __typename?: 'ClassData', id?: string | null, lessonStartDate?: any | null, classStatus?: string | null, classType?: string | null, name?: string | null, total?: number | null, additionalLesson?: { __typename?: 'AdditionalLesson', pricing?: number | null, quantity?: number | null, total?: number | null } | null, terms?: Array<{ __typename?: 'TermData', id?: string | null, lessonIds?: Array<string | null> | null, name?: string | null, pricing?: number | null, total?: number | null } | null> | null } | null> | null } | null, deduction?: { __typename?: 'OutFee', total?: number | null, data?: Array<{ __typename?: 'Fee', amount?: number | null, name?: string | null } | null> | null } | null, otherPayments?: { __typename?: 'OutFee', total?: number | null, data?: Array<{ __typename?: 'Fee', amount?: number | null, name?: string | null } | null> | null } | null, deposit?: { __typename?: 'OutFee', total?: number | null, data?: Array<{ __typename?: 'Fee', amount?: number | null, name?: string | null } | null> | null } | null, student?: { __typename?: 'StudentModel', email?: string | null, id?: string | null, fullName?: string | null, username?: string | null, phoneNumber?: string | null, studentId?: string | null, studentProfile?: { __typename?: 'StudentProfileModel', willPayLater?: boolean | null, school?: { __typename?: 'MasterDataAtPaymentAdvice', id?: string | null, name?: string | null } | null } | null } | null, summary?: { __typename?: 'Summary', classFee?: number | null, deduction?: number | null, deposit?: number | null, gst?: number | null, gstConfig?: number | null, otherPayments?: number | null, registrationFee?: number | null, totalAfterGst?: number | null, totalBeforeGst?: number | null, totalPaid?: number | null, totalPayable?: number | null } | null };

export type CreatePaymentAdviceMutationVariables = Exact<{
  form: FormPaymentAdvice;
}>;


export type CreatePaymentAdviceMutation = { __typename?: 'mutation_root', createPaymentAdvice?: { __typename?: 'PaymentAdviceModel', dueDate?: any | null, id?: string | null, isRegistrationFee?: boolean | null, issueDate?: any | null, name?: string | null, paymentStatus?: string | null, remarks?: string | null, notes?: string | null, branch?: { __typename?: 'BranchModel', id?: string | null, address?: string | null, name?: string | null } | null, classInformation?: { __typename?: 'ClassFee', total?: number | null, data?: Array<{ __typename?: 'ClassData', id?: string | null, lessonStartDate?: any | null, classStatus?: string | null, classType?: string | null, name?: string | null, total?: number | null, additionalLesson?: { __typename?: 'AdditionalLesson', pricing?: number | null, quantity?: number | null, total?: number | null } | null, terms?: Array<{ __typename?: 'TermData', id?: string | null, lessonIds?: Array<string | null> | null, name?: string | null, pricing?: number | null, total?: number | null } | null> | null } | null> | null } | null, deduction?: { __typename?: 'OutFee', total?: number | null, data?: Array<{ __typename?: 'Fee', amount?: number | null, name?: string | null } | null> | null } | null, otherPayments?: { __typename?: 'OutFee', total?: number | null, data?: Array<{ __typename?: 'Fee', amount?: number | null, name?: string | null } | null> | null } | null, deposit?: { __typename?: 'OutFee', total?: number | null, data?: Array<{ __typename?: 'Fee', amount?: number | null, name?: string | null } | null> | null } | null, student?: { __typename?: 'StudentModel', email?: string | null, id?: string | null, fullName?: string | null, username?: string | null, phoneNumber?: string | null, studentId?: string | null, studentProfile?: { __typename?: 'StudentProfileModel', willPayLater?: boolean | null, school?: { __typename?: 'MasterDataAtPaymentAdvice', id?: string | null, name?: string | null } | null } | null } | null, summary?: { __typename?: 'Summary', classFee?: number | null, deduction?: number | null, deposit?: number | null, gst?: number | null, gstConfig?: number | null, otherPayments?: number | null, registrationFee?: number | null, totalAfterGst?: number | null, totalBeforeGst?: number | null, totalPaid?: number | null, totalPayable?: number | null } | null } | null };

export type UpdatePaymentAdviceMutationVariables = Exact<{
  saveForm: Scalars['Boolean'];
  id: Scalars['String'];
  form: FormPaymentAdvice;
}>;


export type UpdatePaymentAdviceMutation = { __typename?: 'mutation_root', updatePaymentAdvice?: { __typename?: 'PaymentAdviceModel', id?: string | null, dueDate?: any | null, isRegistrationFee?: boolean | null, issueDate?: any | null, name?: string | null, paymentStatus?: string | null, remarks?: string | null, notes?: string | null, branch?: { __typename?: 'BranchModel', address?: string | null, id?: string | null, name?: string | null } | null, classInformation?: { __typename?: 'ClassFee', total?: number | null, data?: Array<{ __typename?: 'ClassData', classStatus?: string | null, classType?: string | null, id?: string | null, lessonStartDate?: any | null, name?: string | null, additionalDiscount?: number | null, total?: number | null, totalDiscount?: number | null, additionalLesson?: { __typename?: 'AdditionalLesson', pricing?: number | null, quantity?: number | null, total?: number | null } | null, period?: { __typename?: 'Period', endDate?: any | null, startDate?: any | null } | null, terms?: Array<{ __typename?: 'TermData', id?: string | null, lessonIds?: Array<string | null> | null, lessons?: Array<any | null> | null, name?: string | null, pricing?: number | null, total?: number | null } | null> | null, discounts?: Array<{ __typename?: 'DiscountClass', amount?: number | null, code?: string | null, id?: string | null, name?: string | null, unit?: string | null } | null> | null } | null> | null } | null, deduction?: { __typename?: 'OutFee', total?: number | null, data?: Array<{ __typename?: 'Fee', amount?: number | null, name?: string | null } | null> | null } | null, deposit?: { __typename?: 'OutFee', total?: number | null, data?: Array<{ __typename?: 'Fee', amount?: number | null, name?: string | null } | null> | null } | null, otherPayments?: { __typename?: 'OutFee', total?: number | null, data?: Array<{ __typename?: 'Fee', amount?: number | null, name?: string | null } | null> | null } | null, student?: { __typename?: 'StudentModel', email?: string | null, fullName?: string | null, id?: string | null, phoneNumber?: string | null, studentId?: string | null, username?: string | null, studentProfile?: { __typename?: 'StudentProfileModel', willPayLater?: boolean | null, school?: { __typename?: 'MasterDataAtPaymentAdvice', id?: string | null, name?: string | null } | null } | null } | null, summary?: { __typename?: 'Summary', classFee?: number | null, deduction?: number | null, deposit?: number | null, gst?: number | null, otherPayments?: number | null, registrationFee?: number | null, totalAfterGst?: number | null, totalBeforeGst?: number | null, totalPayable?: number | null } | null } | null };

export type TransferBillFragmentFragment = { __typename?: 'TransferBill', transferDate?: any | null, reason?: string | null, className?: string | null, mutualTerms?: Array<string | null> | null, classBills?: Array<{ __typename?: 'ClassBillInfo', classFee?: number | null, terms?: Array<string | null> | null, passedLessons?: number | null, paidLessons?: number | null } | null> | null };

export type GetDetailPaymentAdviceQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetDetailPaymentAdviceQuery = { __typename?: 'query_root', getDetailPaymentAdvice?: { __typename?: 'PaymentAdviceModel', id?: string | null, dueDate?: any | null, isRegistrationFee?: boolean | null, issueDate?: any | null, name?: string | null, notes?: string | null, qrCodeLink?: string | null, qrExpiryDate?: any | null, paymentStatus?: string | null, remarks?: string | null, branch?: { __typename?: 'BranchModel', address?: string | null, id?: string | null, name?: string | null } | null, classInformation?: { __typename?: 'ClassFee', total?: number | null, data?: Array<{ __typename?: 'ClassData', classStatus?: string | null, classType?: string | null, programId?: string | null, id?: string | null, lessonStartDate?: any | null, name?: string | null, additionalDiscount?: number | null, total?: number | null, totalDiscount?: number | null, additionalLesson?: { __typename?: 'AdditionalLesson', pricing?: number | null, quantity?: number | null, total?: number | null } | null, period?: { __typename?: 'Period', endDate?: any | null, startDate?: any | null } | null, terms?: Array<{ __typename?: 'TermData', id?: string | null, lessonIds?: Array<string | null> | null, lessons?: Array<any | null> | null, name?: string | null, pricing?: number | null, total?: number | null } | null> | null, discounts?: Array<{ __typename?: 'DiscountClass', amount?: number | null, code?: string | null, id?: string | null, name?: string | null, unit?: string | null } | null> | null } | null> | null } | null, deduction?: { __typename?: 'OutFee', total?: number | null, data?: Array<{ __typename?: 'Fee', amount?: number | null, name?: string | null } | null> | null } | null, deposit?: { __typename?: 'OutFee', total?: number | null, data?: Array<{ __typename?: 'Fee', amount?: number | null, name?: string | null } | null> | null } | null, otherPayments?: { __typename?: 'OutFee', total?: number | null, data?: Array<{ __typename?: 'Fee', amount?: number | null, name?: string | null } | null> | null } | null, student?: { __typename?: 'StudentModel', email?: string | null, fullName?: string | null, id?: string | null, phoneNumber?: string | null, studentId?: string | null, username?: string | null, studentProfile?: { __typename?: 'StudentProfileModel', willPayLater?: boolean | null, school?: { __typename?: 'MasterDataAtPaymentAdvice', id?: string | null, name?: string | null } | null } | null } | null, transferBill?: { __typename?: 'TransferBill', transferDate?: any | null, reason?: string | null, className?: string | null, mutualTerms?: Array<string | null> | null, classBills?: Array<{ __typename?: 'ClassBillInfo', classFee?: number | null, terms?: Array<string | null> | null, passedLessons?: number | null, paidLessons?: number | null } | null> | null } | null, summary?: { __typename?: 'Summary', classFee?: number | null, deduction?: number | null, deposit?: number | null, gst?: number | null, otherPayments?: number | null, registrationFee?: number | null, totalAfterGst?: number | null, totalBeforeGst?: number | null, totalPayable?: number | null } | null } | null };

export type GetDetailPaymentAdvicePaperQueryVariables = Exact<{
  id: Scalars['String'];
  invoiceId?: InputMaybe<Scalars['String']>;
}>;


export type GetDetailPaymentAdvicePaperQuery = { __typename?: 'query_root', getDetailPaymentAdvicePaper?: { __typename?: 'InvoiceModel', dueDate?: any | null, id?: string | null, isRegistrationFee?: boolean | null, issueDate?: any | null, name?: string | null, notes?: string | null, link?: string | null, qrCodeLink?: string | null, qrReferenceNo?: string | null, qrExpiryDate?: any | null, paymentStatus?: string | null, remarks?: string | null, branch?: { __typename?: 'BranchModel', id?: string | null, address?: string | null, name?: string | null } | null, transferBill?: { __typename?: 'TransferBill', transferDate?: any | null, reason?: string | null, className?: string | null, mutualTerms?: Array<string | null> | null, classBills?: Array<{ __typename?: 'ClassBillInfo', classFee?: number | null, terms?: Array<string | null> | null, passedLessons?: number | null, paidLessons?: number | null } | null> | null } | null, classInformation?: { __typename?: 'ClassBill', total?: number | null, data?: Array<{ __typename?: 'ClassDetail', subject?: string | null, classType?: string | null, curriculums?: Array<string | null> | null, levels?: Array<string | null> | null, branch?: string | null, id?: string | null, name?: string | null, lessonStartDate?: any | null, additionalDiscount?: number | null, total?: number | null, totalDiscount?: number | null, additionalLesson?: { __typename?: 'AdditionalLesson', pricing?: number | null, quantity?: number | null, total?: number | null } | null, firstSession?: { __typename?: 'Session', startTime?: any | null, endTime?: any | null } | null, period?: { __typename?: 'Period', endDate?: any | null, startDate?: any | null } | null, terms?: Array<{ __typename?: 'TermDetail', academicYear?: string | null, endDate?: any | null, lessons?: Array<any | null> | null, pricing?: number | null, startDate?: any | null, name?: string | null } | null> | null, discounts?: Array<{ __typename?: 'DiscountClass', amount?: number | null, code?: string | null, id?: string | null, name?: string | null, unit?: string | null } | null> | null } | null> | null } | null, deduction?: { __typename?: 'OutFee', total?: number | null, data?: Array<{ __typename?: 'Fee', amount?: number | null, name?: string | null } | null> | null } | null, otherPayments?: { __typename?: 'OutFee', total?: number | null, data?: Array<{ __typename?: 'Fee', amount?: number | null, name?: string | null } | null> | null } | null, deposit?: { __typename?: 'OutFee', total?: number | null, data?: Array<{ __typename?: 'Fee', amount?: number | null, name?: string | null } | null> | null } | null, partials?: { __typename?: 'Partial', total?: number | null, data?: Array<{ __typename?: 'PartialModel', amount?: number | null, bankName?: string | null, cardNumber?: string | null, creditNote?: any | null, cardType?: string | null, id?: string | null, order?: number | null, paymentMethod?: string | null, branch?: { __typename?: 'BranchModel', address?: string | null, id?: string | null, name?: string | null } | null } | null> | null } | null, student?: { __typename?: 'StudentModel', email?: string | null, id?: string | null, fullName?: string | null, username?: string | null, phoneNumber?: string | null, studentId?: string | null, studentProfile?: { __typename?: 'StudentProfileModel', willPayLater?: boolean | null, school?: { __typename?: 'MasterDataAtPaymentAdvice', id?: string | null, name?: string | null } | null } | null } | null, summary?: { __typename?: 'Summary', classFee?: number | null, deduction?: number | null, deposit?: number | null, gst?: number | null, gstConfig?: number | null, otherPayments?: number | null, registrationFee?: number | null, totalAfterGst?: number | null, totalBeforeGst?: number | null, totalPaid?: number | null, totalPayable?: number | null } | null } | null };

export type MasterDataAtPaymentAdviceFragmentFragment = { __typename?: 'BranchModel', id?: string | null, address?: string | null, name?: string | null };

export type ClassFeeFragmentFragment = { __typename?: 'ClassFee', total?: number | null, data?: Array<{ __typename?: 'ClassData', id?: string | null, lessonStartDate?: any | null, classStatus?: string | null, classType?: string | null, name?: string | null, total?: number | null, additionalLesson?: { __typename?: 'AdditionalLesson', pricing?: number | null, quantity?: number | null, total?: number | null } | null, terms?: Array<{ __typename?: 'TermData', id?: string | null, lessonIds?: Array<string | null> | null, name?: string | null, pricing?: number | null, total?: number | null } | null> | null } | null> | null };

export type OutFeeFragmentFragment = { __typename?: 'OutFee', total?: number | null, data?: Array<{ __typename?: 'Fee', amount?: number | null, name?: string | null } | null> | null };

export type GeneralFeeFragmentFragment = { __typename?: 'GeneralFee', total?: number | null, data?: Array<{ __typename?: 'DataFee', amount?: number | null, name?: string | null, id?: string | null } | null> | null };

export type StudentModelFragmentFragment = { __typename?: 'StudentModel', email?: string | null, id?: string | null, fullName?: string | null, username?: string | null, phoneNumber?: string | null, studentId?: string | null, studentProfile?: { __typename?: 'StudentProfileModel', willPayLater?: boolean | null, school?: { __typename?: 'MasterDataAtPaymentAdvice', id?: string | null, name?: string | null } | null } | null };

export type SummaryFragmentFragment = { __typename?: 'Summary', classFee?: number | null, deduction?: number | null, deposit?: number | null, gst?: number | null, gstConfig?: number | null, otherPayments?: number | null, registrationFee?: number | null, totalAfterGst?: number | null, totalBeforeGst?: number | null, totalPaid?: number | null, totalPayable?: number | null };

export type UpdatePaymentAdvicesMutationVariables = Exact<{
  id: Scalars['uuid'];
  form?: InputMaybe<Payment_Advices_Set_Input>;
}>;


export type UpdatePaymentAdvicesMutation = { __typename?: 'mutation_root', update_payment_advices?: { __typename?: 'payment_advices_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'payment_advices', branchId?: any | null, classInformation?: any | null, createdAt: any, createdBy?: any | null, deduction?: any | null, deposit?: any | null, dueDate?: any | null, id: any, isOverdueAtPaid?: boolean | null, isRegistrationFee?: boolean | null, issueDate?: any | null, name: string, otherPayments?: any | null, paidAt?: any | null, paymentStatus: string, paymentSummaryStatic?: any | null, registrationFeeConfig?: any | null, remarks?: string | null, status: string, notes?: string | null, updatedAt: any, updatedBy?: any | null, studentId?: any | null, student?: { __typename?: 'users', address?: string | null, avatar?: string | null, code?: string | null, cognitoId?: string | null, createdAt: any, createdBy?: any | null, dob?: any | null, email?: string | null, firstName: string, fullName?: string | null, gender?: string | null, id: any, isVerifiedEmail: boolean, isVerifiedPhoneNumber: boolean, lastName: string, paymentStatus?: string | null, username?: string | null, updatedBy?: any | null, updatedAt: any } | null }> } | null };

export type PaymentAdvicesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Payment_Advices_Bool_Exp>;
}>;


export type PaymentAdvicesQuery = { __typename?: 'query_root', payment_advices: Array<{ __typename?: 'payment_advices', qrReferenceNo?: string | null, branchId?: any | null, classInformation?: any | null, createdAt: any, createdBy?: any | null, deduction?: any | null, deposit?: any | null, dueDate?: any | null, id: any, isOverdueAtPaid?: boolean | null, isRegistrationFee?: boolean | null, issueDate?: any | null, name: string, otherPayments?: any | null, paidAt?: any | null, paymentStatus: string, paymentSummaryStatic?: any | null, registrationFeeConfig?: any | null, remarks?: string | null, status: string, notes?: string | null, updatedAt: any, updatedBy?: any | null, studentId?: any | null, student?: { __typename?: 'users', address?: string | null, avatar?: string | null, code?: string | null, cognitoId?: string | null, createdAt: any, createdBy?: any | null, dob?: any | null, email?: string | null, firstName: string, fullName?: string | null, gender?: string | null, id: any, isVerifiedEmail: boolean, isVerifiedPhoneNumber: boolean, lastName: string, paymentStatus?: string | null, username?: string | null, updatedBy?: any | null, updatedAt: any } | null }>, payment_advices_aggregate: { __typename?: 'payment_advices_aggregate', aggregate?: { __typename?: 'payment_advices_aggregate_fields', count?: number | null } | null } };

export type PaymentAdviceFilterQueryVariables = Exact<{
  args: Payment_Advice_Filter_Args;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  where?: InputMaybe<Payment_Advices_Bool_Exp>;
}>;


export type PaymentAdviceFilterQuery = { __typename?: 'query_root', payment_advice_filter: Array<{ __typename?: 'payment_advices', branchId?: any | null, classInformation?: any | null, createdAt: any, createdBy?: any | null, deduction?: any | null, deposit?: any | null, dueDate?: any | null, id: any, isOverdueAtPaid?: boolean | null, isRegistrationFee?: boolean | null, issueDate?: any | null, name: string, otherPayments?: any | null, paidAt?: any | null, paymentStatus: string, paymentSummaryStatic?: any | null, registrationFeeConfig?: any | null, remarks?: string | null, status: string, notes?: string | null, updatedAt: any, updatedBy?: any | null, studentId?: any | null, student?: { __typename?: 'users', address?: string | null, avatar?: string | null, code?: string | null, cognitoId?: string | null, createdAt: any, createdBy?: any | null, dob?: any | null, email?: string | null, firstName: string, fullName?: string | null, gender?: string | null, id: any, isVerifiedEmail: boolean, isVerifiedPhoneNumber: boolean, lastName: string, paymentStatus?: string | null, username?: string | null, updatedBy?: any | null, updatedAt: any } | null }>, payment_advice_filter_aggregate: { __typename?: 'payment_advices_aggregate', aggregate?: { __typename?: 'payment_advices_aggregate_fields', count?: number | null } | null } };

export type GetPaymentInvoiceListQueryVariables = Exact<{
  args: Invoice_Filter_Args;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  where?: InputMaybe<Invoices_Bool_Exp>;
}>;


export type GetPaymentInvoiceListQuery = { __typename?: 'query_root', invoice_filter: Array<{ __typename?: 'invoices', id: any, createdAt: any, name: string, invoiceStatus?: string | null, total: any, pa: { __typename?: 'payment_advices', id: any, dueDate?: any | null, student?: { __typename?: 'users', fullName?: string | null, id: any, username?: string | null, subjects?: Array<{ __typename?: 'subjects', id: any, name: string }> | null, studentProfile?: { __typename?: 'student_profiles', id: any, curriculum?: { __typename?: 'curriculums', abbreviation?: string | null, id: any } | null } | null } | null } }>, invoice_filter_aggregate: { __typename?: 'invoices_aggregate', aggregate?: { __typename?: 'invoices_aggregate_fields', count?: number | null } | null } };

export type GetInvoicesQueryVariables = Exact<{
  where?: InputMaybe<Invoices_Bool_Exp>;
  date?: InputMaybe<Scalars['timestamptz']>;
  filterClass?: InputMaybe<Payment_Advice_Classes_Bool_Exp>;
}>;


export type GetInvoicesQuery = { __typename?: 'query_root', invoices: Array<{ __typename?: 'invoices', pa: { __typename?: 'payment_advices', paymentAdviceClasses: Array<{ __typename?: 'payment_advice_classes', class: { __typename?: 'classes', id: any, name: string, startDate?: any | null, classStatus: string, lessonType: string, createdAt: any, program: { __typename?: 'programs', id: any, name: string, category?: string | null, subject: { __typename?: 'subjects', id: any, name: string, abbreviation: string } }, programTypeGeneral?: { __typename?: 'general_program_types', id: any, shortName: string, fullName: string } | null, programTypeRegular?: { __typename?: 'regular_program_types', id: any, fullName: string, shortName: string } | null, programTypeSpecial?: { __typename?: 'specical_program_types', id: any, fullName: string, shortName: string } | null, lessons: Array<{ __typename?: 'lessons', id: any, date: any, lessonStatus: string, orderPriority: any, termClass?: { __typename?: 'term_classes', termName: string } | null, classroom: { __typename?: 'classrooms', branch: { __typename?: 'branches', id: any, name: string, abbreviation?: string | null } }, sessions: Array<{ __typename?: 'sessions', id: any, endTime: any, startTime: any, orderPriority: any }> }> }, paymentAdviceTermClasses: Array<{ __typename?: 'payment_advice_term_classes', termClass?: { __typename?: 'term_classes', termName: string } | null }> }> } }> };

export type GetInvoiceByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetInvoiceByIdQuery = { __typename?: 'query_root', invoices: Array<{ __typename?: 'invoices', name: string, createdAt: any, invoiceStatus?: string | null, notes?: string | null, isGeneratedReceipt?: boolean | null, link?: string | null, pa: { __typename?: 'payment_advices', id: any, student?: { __typename?: 'users', id: any, studentProfile?: { __typename?: 'student_profiles', payment?: any | null, id: any } | null } | null } }> };

export type GetInvoiceByPaIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetInvoiceByPaIdQuery = { __typename?: 'query_root', invoices: Array<{ __typename?: 'invoices', name: string, createdAt: any, invoiceStatus?: string | null, notes?: string | null, isGeneratedReceipt?: boolean | null, link?: string | null, id: any, pa: { __typename?: 'payment_advices', id: any, student?: { __typename?: 'users', id: any, studentProfile?: { __typename?: 'student_profiles', payment?: any | null, id: any } | null } | null } }> };

export type GetPaymentReceiptListQueryVariables = Exact<{
  args: Receipt_Filter_Args;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Receipts_Bool_Exp>;
}>;


export type GetPaymentReceiptListQuery = { __typename?: 'query_root', receipt_filter: Array<{ __typename?: 'receipts', id: any, link?: string | null, invoiceId: any, name: string, status: string, receiptDate?: any | null, createdAt: any, invoice: { __typename?: 'invoices', id: any, paymentAdviceId: any, total: any, createdAt: any, pa: { __typename?: 'payment_advices', id: any, dueDate?: any | null, student?: { __typename?: 'users', id: any, fullName?: string | null, username?: string | null } | null } } }>, receipt_filter_aggregate: { __typename?: 'receipts_aggregate', aggregate?: { __typename?: 'receipts_aggregate_fields', count?: number | null } | null } };

export type FilterReceiptListQueryVariables = Exact<{
  filter?: InputMaybe<Receipts_Bool_Exp>;
}>;


export type FilterReceiptListQuery = { __typename?: 'query_root', receipts: Array<{ __typename?: 'receipts', id: any, link?: string | null, invoiceId: any, name: string, status: string, createdAt: any, receiptDate?: any | null, invoice: { __typename?: 'invoices', id: any, paymentAdviceId: any, total: any, createdAt: any, pa: { __typename?: 'payment_advices', id: any, paymentSummaryStatic?: any | null, dueDate?: any | null, student?: { __typename?: 'users', id: any, fullName?: string | null, username?: string | null } | null } } }> };

export type GetPaymentAdviceByPkQueryVariables = Exact<{
  paymentAdviceId: Scalars['uuid'];
}>;


export type GetPaymentAdviceByPkQuery = { __typename?: 'query_root', payment_advices_by_pk?: { __typename?: 'payment_advices', paymentAdviceClasses: Array<{ __typename?: 'payment_advice_classes', class: { __typename?: 'classes', id: any, lessons: Array<{ __typename?: 'lessons', id: any }> } }> } | null, invoices_aggregate: { __typename?: 'invoices_aggregate', aggregate?: { __typename?: 'invoices_aggregate_fields', count?: number | null } | null } };

export type CreateInvoiceMutationVariables = Exact<{
  form: FormCreateInvoice;
}>;


export type CreateInvoiceMutation = { __typename?: 'mutation_root', createInvoice?: string | null };

export type GetReceiptByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetReceiptByIdQuery = { __typename?: 'query_root', receipts: Array<{ __typename?: 'receipts', id: any, name: string, updatedAt: any, invoiceId: any, link?: string | null, status: string, createdAt: any, receiptDate?: any | null, invoice: { __typename?: 'invoices', id: any, notes?: string | null, paymentAdviceId: any } }> };

export type GetReceiptByInvoiceIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetReceiptByInvoiceIdQuery = { __typename?: 'query_root', receipts: Array<{ __typename?: 'receipts', id: any, name: string, updatedAt: any, invoiceId: any, link?: string | null, status: string, createdAt: any }> };

export type GetReceiptByPaIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetReceiptByPaIdQuery = { __typename?: 'query_root', receipts: Array<{ __typename?: 'receipts', id: any, name: string, updatedAt: any, invoiceId: any, link?: string | null, status: string, createdAt: any }> };

export type CreateReceiptMutationVariables = Exact<{
  invoiceId: Scalars['String'];
}>;


export type CreateReceiptMutation = { __typename?: 'mutation_root', createReceipt?: string | null };

export type UpdateStatusInvoiceMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type UpdateStatusInvoiceMutation = { __typename?: 'mutation_root', update_invoices?: { __typename?: 'invoices_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'invoices', id: any, name: string }> } | null };

export type UpdateInvoicesMutationVariables = Exact<{
  id: Scalars['uuid'];
  form?: InputMaybe<Invoices_Set_Input>;
}>;


export type UpdateInvoicesMutation = { __typename?: 'mutation_root', update_invoices?: { __typename?: 'invoices_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'invoices', id: any }> } | null };

export type GetDataRefundListFilerQueryVariables = Exact<{
  args: Refund_Filter_Args;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  where?: InputMaybe<Refunds_Bool_Exp>;
}>;


export type GetDataRefundListFilerQuery = { __typename?: 'query_root', refund_filter: Array<{ __typename?: 'refunds', id: any, name: string, createdAt: any, type: string, summary: any, refundStatus: string, issuedBy: any, refundClass: Array<{ __typename?: 'refund_classes', id: any, lastLessonDate: any, class: { __typename?: 'classes', id: any, name: string } }>, student?: { __typename?: 'users', username?: string | null, fullName?: string | null, id: any } | null }>, refund_filter_aggregate: { __typename?: 'refunds_aggregate', aggregate?: { __typename?: 'refunds_aggregate_fields', count?: number | null } | null } };

export type GetDataWithdrawalListFilerQueryVariables = Exact<{
  args: Refund_Filter_Args;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  where?: InputMaybe<Refunds_Bool_Exp>;
}>;


export type GetDataWithdrawalListFilerQuery = { __typename?: 'query_root', refund_filter: Array<{ __typename?: 'refunds', id: any, name: string, createdAt: any, type: string, refundStatus: string, refundClass: Array<{ __typename?: 'refund_classes', id: any, lastLessonDate: any, class: { __typename?: 'classes', id: any, name: string } }>, student?: { __typename?: 'users', username?: string | null, fullName?: string | null, id: any, studentProfile?: { __typename?: 'student_profiles', id: any, curriculum?: { __typename?: 'curriculums', abbreviation?: string | null, id: any } | null, level?: { __typename?: 'levels', abbreviation: string, id: any } | null, school?: { __typename?: 'schools', name: string, id: any } | null } | null } | null }>, refund_filter_aggregate: { __typename?: 'refunds_aggregate', aggregate?: { __typename?: 'refunds_aggregate_fields', count?: number | null } | null } };

export type CreateRefundMutationVariables = Exact<{
  form: FormCreateRefund;
}>;


export type CreateRefundMutation = { __typename?: 'mutation_root', createRefund?: string | null };

export type CreatePaymentAdvicePaperMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type CreatePaymentAdvicePaperMutation = { __typename?: 'mutation_root', createPaymentAdvicePaper?: { __typename?: 'PaymentAdvicePaperModel', id?: string | null, name?: string | null } | null };

export type CreatePartialPaymentMutationVariables = Exact<{
  form: FormInvoicePartialPayment;
}>;


export type CreatePartialPaymentMutation = { __typename?: 'mutation_root', createInvoicePartialPayment?: string | null };

export type GetPaymentSettingQueryVariables = Exact<{
  stType?: InputMaybe<Scalars['String']>;
}>;


export type GetPaymentSettingQuery = { __typename?: 'query_root', system_settings: Array<{ __typename?: 'system_settings', key: string, id: any, parentId?: any | null, type: string, value: string, parent?: { __typename?: 'system_settings', id: any, type: string, key: string, value: string } | null }> };

export type UpdatePaymentSettingMutationVariables = Exact<{
  id: Scalars['uuid'];
  value: Scalars['String'];
}>;


export type UpdatePaymentSettingMutation = { __typename?: 'mutation_root', update_system_settings?: { __typename?: 'system_settings_mutation_response', returning: Array<{ __typename?: 'system_settings', id: any, value: string, key: string }> } | null };

export type UpdateRegularProgrammePricingsMutationVariables = Exact<{
  id: Scalars['uuid'];
  userid: Scalars['uuid'];
  value: Scalars['numeric'];
}>;


export type UpdateRegularProgrammePricingsMutation = { __typename?: 'mutation_root', update_regular_programme_pricings?: { __typename?: 'regular_programme_pricings_mutation_response', returning: Array<{ __typename?: 'regular_programme_pricings', id: any }> } | null };

export type UpdateSpecialProgrammeClassPricingsMutationVariables = Exact<{
  id: Scalars['uuid'];
  userid: Scalars['uuid'];
  value: Scalars['numeric'];
}>;


export type UpdateSpecialProgrammeClassPricingsMutation = { __typename?: 'mutation_root', update_special_programme_class_pricings?: { __typename?: 'special_programme_class_pricings_mutation_response', returning: Array<{ __typename?: 'special_programme_class_pricings', id: any }> } | null };

export type ProgramsModelFragment = { __typename?: 'programs', id: any, name: string, curriculumIds: any, levelIds: any, tutorIds: any, subjectId: any, category?: string | null, numberOfDLClasses?: number | null, numberOfGeneralClasses?: number | null, numberOfSpecialClasses?: number | null, numberOfWLWDClasses?: number | null, numberOfWLWEClasses?: number | null, enrolledStudents?: number | null, levels?: Array<{ __typename?: 'levels', id: any, name: string, abbreviation: string }> | null, tutors?: Array<{ __typename?: 'users', id: any, code?: string | null }> | null, curriculums?: Array<{ __typename?: 'curriculums', id: any, name: string, abbreviation?: string | null }> | null, subject: { __typename?: 'subjects', id: any, name: string } };

export type GeneraProgramTypeModelFragment = { __typename?: 'general_program_types', id: any, shortName: string, fullName: string, status: string };

export type GetAllGeneralProgramTypeQueryVariables = Exact<{
  filter?: InputMaybe<General_Program_Types_Bool_Exp>;
}>;


export type GetAllGeneralProgramTypeQuery = { __typename?: 'query_root', general_program_types: Array<{ __typename?: 'general_program_types', id: any, shortName: string, fullName: string, status: string }> };

export type SpecialProgramTypeModelFragment = { __typename?: 'specical_program_types', id: any, shortName: string, fullName: string, status: string };

export type GetAllSpecialProgramTypeQueryVariables = Exact<{
  filter?: InputMaybe<Specical_Program_Types_Bool_Exp>;
}>;


export type GetAllSpecialProgramTypeQuery = { __typename?: 'query_root', specical_program_types: Array<{ __typename?: 'specical_program_types', id: any, shortName: string, fullName: string, status: string }> };

export type RegularProgramTypeModelFragment = { __typename?: 'regular_program_types', id: any, shortName: string, fullName: string, status: string };

export type GetAllRegularProgramTypeQueryVariables = Exact<{
  filter?: InputMaybe<Regular_Program_Types_Bool_Exp>;
}>;


export type GetAllRegularProgramTypeQuery = { __typename?: 'query_root', regular_program_types: Array<{ __typename?: 'regular_program_types', id: any, shortName: string, fullName: string, status: string }> };

export type GetProgramByStudentIdQueryVariables = Exact<{
  academic_year?: InputMaybe<Scalars['String']>;
  student_id: Scalars['uuid'];
}>;


export type GetProgramByStudentIdQuery = { __typename?: 'query_root', students_programs_filter: Array<{ __typename?: 'programs', id: any, name: string, curriculums?: Array<{ __typename?: 'curriculums', id: any, abbreviation?: string | null }> | null, levels?: Array<{ __typename?: 'levels', id: any, abbreviation: string }> | null, subject: { __typename?: 'subjects', id: any, name: string, abbreviation: string } }> };

export type CreateProgramMutationVariables = Exact<{
  form: Array<Programs_Insert_Input> | Programs_Insert_Input;
}>;


export type CreateProgramMutation = { __typename?: 'mutation_root', insert_programs?: { __typename?: 'programs_mutation_response', returning: Array<{ __typename?: 'programs', createdAt: any, id: any, name: string, levelIds: any, createdBy?: any | null, curriculumFiles: any, curriculumIds: any, note?: string | null, status: string, subjectId: any, tutorIds: any, updatedAt: any, updatedBy?: any | null }> } | null };

export type UpdateProgramMutationVariables = Exact<{
  id: Scalars['uuid'];
  form?: InputMaybe<Programs_Set_Input>;
}>;


export type UpdateProgramMutation = { __typename?: 'mutation_root', update_programs?: { __typename?: 'programs_mutation_response', returning: Array<{ __typename?: 'programs', createdAt: any, id: any, name: string, levelIds: any, createdBy?: any | null, curriculumFiles: any, curriculumIds: any, note?: string | null, status: string, subjectId: any, tutorIds: any, updatedAt: any, updatedBy?: any | null }> } | null };

export type ProgramsListQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  order: Order_By;
  filter?: InputMaybe<Programs_Bool_Exp>;
}>;


export type ProgramsListQuery = { __typename?: 'query_root', programs: Array<{ __typename?: 'programs', id: any, name: string, curriculumIds: any, levelIds: any, tutorIds: any, subjectId: any, category?: string | null, numberOfDLClasses?: number | null, numberOfGeneralClasses?: number | null, numberOfSpecialClasses?: number | null, numberOfWLWDClasses?: number | null, numberOfWLWEClasses?: number | null, enrolledStudents?: number | null, levels?: Array<{ __typename?: 'levels', id: any, name: string, abbreviation: string }> | null, tutors?: Array<{ __typename?: 'users', id: any, code?: string | null }> | null, curriculums?: Array<{ __typename?: 'curriculums', id: any, name: string, abbreviation?: string | null }> | null, subject: { __typename?: 'subjects', id: any, name: string } }>, programs_aggregate: { __typename?: 'programs_aggregate', aggregate?: { __typename?: 'programs_aggregate_fields', count?: number | null } | null } };

export type GetAllProgramsQueryVariables = Exact<{
  filter?: InputMaybe<Programs_Bool_Exp>;
}>;


export type GetAllProgramsQuery = { __typename?: 'query_root', programs: Array<{ __typename?: 'programs', id: any, name: string, curriculumIds: any, levelIds: any, tutorIds: any, subjectId: any, category?: string | null, numberOfDLClasses?: number | null, numberOfGeneralClasses?: number | null, numberOfSpecialClasses?: number | null, numberOfWLWDClasses?: number | null, numberOfWLWEClasses?: number | null, enrolledStudents?: number | null, levels?: Array<{ __typename?: 'levels', id: any, name: string, abbreviation: string }> | null, tutors?: Array<{ __typename?: 'users', id: any, code?: string | null }> | null, curriculums?: Array<{ __typename?: 'curriculums', id: any, name: string, abbreviation?: string | null }> | null, subject: { __typename?: 'subjects', id: any, name: string } }> };

export type GetProgramByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetProgramByIdQuery = { __typename?: 'query_root', programs: Array<{ __typename?: 'programs', id: any, programId?: string | null, name: string, curriculumIds: any, curriculumFiles: any, levelIds: any, tutorIds: any, subjectId: any, note?: string | null, numberOfWLWEClasses?: number | null, numberOfWLWDClasses?: number | null, numberOfDLClasses?: number | null, enrolledStudents?: number | null, category?: string | null, numberOfSpecialClasses?: number | null, numberOfGeneralClasses?: number | null, levels?: Array<{ __typename?: 'levels', id: any, name: string }> | null, tutors?: Array<{ __typename?: 'users', id: any, firstName: string, lastName: string, avatar?: string | null }> | null, curriculums?: Array<{ __typename?: 'curriculums', id: any, name: string, abbreviation?: string | null }> | null, subject: { __typename?: 'subjects', id: any, name: string } }> };

export type RegularProgramTypesListQueryVariables = Exact<{ [key: string]: never; }>;


export type RegularProgramTypesListQuery = { __typename?: 'query_root', regular_program_types: Array<{ __typename?: 'regular_program_types', id: any, fullName: string, shortName: string, code: string }> };

export type SpecicalProgramTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type SpecicalProgramTypesQuery = { __typename?: 'query_root', specical_program_types: Array<{ __typename?: 'specical_program_types', shortName: string, id: any, fullName: string }> };

export type UpdateRegularProgramTypesMutationVariables = Exact<{
  id: Scalars['uuid'];
  value: Scalars['String'];
}>;


export type UpdateRegularProgramTypesMutation = { __typename?: 'mutation_root', update_regular_program_types?: { __typename?: 'regular_program_types_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'regular_program_types', id: any, fullName: string, shortName: string }> } | null };

export type UpdateSpecicalProgramTypesMutationVariables = Exact<{
  id: Scalars['uuid'];
  shortName: Scalars['String'];
  fullName: Scalars['String'];
}>;


export type UpdateSpecicalProgramTypesMutation = { __typename?: 'mutation_root', update_specical_program_types?: { __typename?: 'specical_program_types_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'specical_program_types', id: any, fullName: string, shortName: string }> } | null };

export type UpdateGeneralProgramTypesMutationVariables = Exact<{
  id: Scalars['uuid'];
  value: Scalars['String'];
}>;


export type UpdateGeneralProgramTypesMutation = { __typename?: 'mutation_root', update_general_program_types?: { __typename?: 'general_program_types_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'general_program_types', id: any, fullName: string, shortName: string }> } | null };

export type InsertSpecicalProgramTypesMutationVariables = Exact<{
  shortName: Scalars['String'];
  fullName: Scalars['String'];
}>;


export type InsertSpecicalProgramTypesMutation = { __typename?: 'mutation_root', insert_specical_program_types?: { __typename?: 'specical_program_types_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'specical_program_types', fullName: string, id: any, shortName: string }> } | null };

export type ClassFilterByStudentQueryVariables = Exact<{
  studentId: Scalars['String'];
}>;


export type ClassFilterByStudentQuery = { __typename?: 'query_root', getListClassNotRefundByStudent?: Array<{ __typename?: 'ClassOfStudent', id?: string | null, name?: string | null } | null> | null };

export type UpdateRefundMutationVariables = Exact<{
  form: FormRefund;
  id: Scalars['String'];
  saveForm: Scalars['Boolean'];
}>;


export type UpdateRefundMutation = { __typename?: 'mutation_root', updateRefund?: { __typename?: 'RefundModel', name?: string | null, noticeDate?: any | null, reason?: string | null, refundStatus?: string | null, remarks?: string | null, type?: string | null, student?: { __typename?: 'StudentModel', email?: string | null, fullName?: string | null, id?: string | null, phoneNumber?: string | null, studentId?: string | null, username?: string | null, studentProfile?: { __typename?: 'StudentProfileModel', school?: { __typename?: 'MasterDataAtPaymentAdvice', id?: string | null, name?: string | null } | null } | null } | null, studentFeedback?: { __typename?: 'StudentFeedbackModel', improvement?: string | null, joiningOtherSubjects?: boolean | null, rate?: string | null, rateReason?: string | null, returnReason?: string | null, studiedTime?: string | null, willReturn?: boolean | null } | null, summary?: { __typename?: 'RefundSummary', creditNote?: number | null, deposit?: number | null, totalAfterGst?: number | null, totalRefundable?: number | null } | null, payeeDetails?: { __typename?: 'PayeeDetailsModel', accountNumber?: string | null, bankName?: string | null, country?: string | null, nameAsOfBank?: string | null, postalCode?: string | null, remarks?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', code?: string | null, number?: string | null } | null } | null, refundClass?: Array<{ __typename?: 'ClassInformationModel', classId?: string | null, classTotal?: number | null, lastLessonDate?: any | null, leftLessonAmount?: number | null, leftLessonNo?: number | null, lessonDates?: Array<any | null> | null, name?: string | null, oweLessonNo?: number | null, receiptId?: string | null, unitPrice?: number | null, deduction?: { __typename?: 'OutFee', total?: number | null, data?: Array<{ __typename?: 'Fee', amount?: number | null, name?: string | null } | null> | null } | null, otherPayments?: { __typename?: 'OutFee', total?: number | null, data?: Array<{ __typename?: 'Fee', amount?: number | null, name?: string | null } | null> | null } | null, summary?: { __typename?: 'SubTotal', gst?: number | null, gstConfig?: number | null, subTotalAfterGst?: number | null, totalBeforGst?: number | null } | null } | null> | null, issuedBy?: { __typename?: 'IssuedByModel', attachments?: Array<string | null> | null, chequeNo?: string | null, paymentMethod?: string | null, transactionId?: string | null } | null, deposit?: { __typename?: 'GeneralFee', total?: number | null, data?: Array<{ __typename?: 'DataFee', amount?: number | null, id?: string | null, name?: string | null } | null> | null } | null, creditNote?: { __typename?: 'GeneralFee', total?: number | null, data?: Array<{ __typename?: 'DataFee', amount?: number | null, id?: string | null, name?: string | null } | null> | null } | null } | null };

export type GetDetailRefundQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetDetailRefundQuery = { __typename?: 'query_root', getDetailRefund?: { __typename?: 'RefundModel', name?: string | null, noticeDate?: any | null, reason?: string | null, refundStatus?: string | null, remarks?: string | null, type?: string | null, student?: { __typename?: 'StudentModel', email?: string | null, fullName?: string | null, id?: string | null, phoneNumber?: string | null, studentId?: string | null, username?: string | null, studentProfile?: { __typename?: 'StudentProfileModel', school?: { __typename?: 'MasterDataAtPaymentAdvice', id?: string | null, name?: string | null } | null } | null } | null, studentFeedback?: { __typename?: 'StudentFeedbackModel', improvement?: string | null, joiningOtherSubjects?: boolean | null, rate?: string | null, rateReason?: string | null, returnReason?: string | null, studiedTime?: string | null, willReturn?: boolean | null } | null, summary?: { __typename?: 'RefundSummary', creditNote?: number | null, deposit?: number | null, totalAfterGst?: number | null, totalRefundable?: number | null } | null, payeeDetails?: { __typename?: 'PayeeDetailsModel', accountNumber?: string | null, bankName?: string | null, country?: string | null, nameAsOfBank?: string | null, postalCode?: string | null, remarks?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', code?: string | null, number?: string | null } | null } | null, refundClass?: Array<{ __typename?: 'ClassInformationModel', classId?: string | null, classTotal?: number | null, lastLessonDate?: any | null, leftLessonAmount?: number | null, leftLessonNo?: number | null, lessonDates?: Array<any | null> | null, name?: string | null, oweLessonNo?: number | null, receiptId?: string | null, unitPrice?: number | null, deduction?: { __typename?: 'OutFee', total?: number | null, data?: Array<{ __typename?: 'Fee', amount?: number | null, name?: string | null } | null> | null } | null, otherPayments?: { __typename?: 'OutFee', total?: number | null, data?: Array<{ __typename?: 'Fee', amount?: number | null, name?: string | null } | null> | null } | null, summary?: { __typename?: 'SubTotal', gst?: number | null, gstConfig?: number | null, subTotalAfterGst?: number | null, totalBeforGst?: number | null } | null } | null> | null, issuedBy?: { __typename?: 'IssuedByModel', attachments?: Array<string | null> | null, chequeNo?: string | null, paymentMethod?: string | null, transactionId?: string | null } | null, deposit?: { __typename?: 'GeneralFee', total?: number | null, data?: Array<{ __typename?: 'DataFee', amount?: number | null, id?: string | null, name?: string | null } | null> | null } | null, creditNote?: { __typename?: 'GeneralFee', total?: number | null, data?: Array<{ __typename?: 'DataFee', amount?: number | null, id?: string | null, name?: string | null } | null> | null } | null } | null };

export type GetClassInformationForRefundQueryVariables = Exact<{
  form: FormWithdrawalClass;
  noticeDate: Scalars['DateTime'];
}>;


export type GetClassInformationForRefundQuery = { __typename?: 'query_root', getClassInformationForRefund?: { __typename?: 'WithdrawalClass', classId?: string | null, lastLessonDate?: any | null, lessonDates?: Array<any | null> | null, leftLessonNo?: number | null, oweLessonNo?: number | null, name?: string | null } | null };

export type ChangeRefundStatusMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ChangeRefundStatusMutation = { __typename?: 'mutation_root', changeRefundStatus?: string | null };

export type UpdateRefundOnClientMutationVariables = Exact<{
  where?: Refunds_Bool_Exp;
  _set?: InputMaybe<Refunds_Set_Input>;
}>;


export type UpdateRefundOnClientMutation = { __typename?: 'mutation_root', update_refunds?: { __typename?: 'refunds_mutation_response', returning: Array<{ __typename?: 'refunds', id: any }> } | null };

export type DepositsQueryVariables = Exact<{
  where?: InputMaybe<Deposits_Bool_Exp>;
}>;


export type DepositsQuery = { __typename?: 'query_root', deposits: Array<{ __typename?: 'deposits', id: any, name: string, amount: any }> };

export type ReceiptFilterByClassQueryVariables = Exact<{
  args: Receipt_Filter_By_Class_Args;
}>;


export type ReceiptFilterByClassQuery = { __typename?: 'query_root', receipt_filter_by_class: Array<{ __typename?: 'receipts', id: any, name: string }> };

export type GetDepositByStudentQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  where?: InputMaybe<Deposits_Bool_Exp>;
}>;


export type GetDepositByStudentQuery = { __typename?: 'query_root', deposits: Array<{ __typename?: 'deposits', amount: any, createdAt: any, createdBy?: any | null, depositStatus: string, id: any, name: string, receiptId?: any | null, status: string, receipt?: { __typename?: 'receipts', name: string, id: any } | null }>, deposits_aggregate: { __typename?: 'deposits_aggregate', aggregate?: { __typename?: 'deposits_aggregate_fields', count?: number | null } | null } };

export type ReportRevenueBreakDownQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Receipts_Bool_Exp>;
}>;


export type ReportRevenueBreakDownQuery = { __typename?: 'query_root', receipts: Array<{ __typename?: 'receipts', invoice: { __typename?: 'invoices', pa: { __typename?: 'payment_advices', paymentStatus: string, paymentSummaryStatic?: any | null, createdAt: any, paymentAdviceClasses: Array<{ __typename?: 'payment_advice_classes', class: { __typename?: 'classes', programTypeGeneralId?: any | null, program: { __typename?: 'programs', subject: { __typename?: 'subjects', id: any, name: string }, curriculums?: Array<{ __typename?: 'curriculums', id: any, name: string, abbreviation?: string | null, nameOfReport?: string | null }> | null } }, paymentAdviceTermClasses: Array<{ __typename?: 'payment_advice_term_classes', termClass?: { __typename?: 'term_classes', termName: string } | null }> }> } } }>, receipts_aggregate: { __typename?: 'receipts_aggregate', aggregate?: { __typename?: 'receipts_aggregate_fields', count?: number | null } | null } };

export type ReportSubjectsCurriculumsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportSubjectsCurriculumsQuery = { __typename?: 'query_root', subjects: Array<{ __typename?: 'subjects', id: any, name: string, abbreviation: string, programs: Array<{ __typename?: 'programs', curriculums?: Array<{ __typename?: 'curriculums', id: any, name: string, nameOfReport?: string | null, abbreviation?: string | null }> | null }> }> };

export type ReportCurriculumsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportCurriculumsQuery = { __typename?: 'query_root', curriculums: Array<{ __typename?: 'curriculums', id: any, name: string, abbreviation?: string | null, nameOfReport?: string | null, createdAt: any, createdBy?: any | null, status: string, updatedAt: any, updatedBy?: any | null }> };

export type ReportGetActiveStudentsQueryVariables = Exact<{
  where?: InputMaybe<Student_Profiles_Bool_Exp>;
}>;


export type ReportGetActiveStudentsQuery = { __typename?: 'query_root', student_profiles_aggregate: { __typename?: 'student_profiles_aggregate', aggregate?: { __typename?: 'student_profiles_aggregate_fields', count?: number | null } | null } };

export type ReportSubjectBudgetListQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportSubjectBudgetListQuery = { __typename?: 'query_root', report_subject_budget: Array<{ __typename?: 'report_subject_budget', budget: any, curriculum?: { __typename?: 'curriculums', id: any, abbreviation?: string | null, name: string } | null, subject?: { __typename?: 'subjects', id: any, name: string } | null }> };

export type GetReportSubjectBudgetQueryVariables = Exact<{
  where: Report_Subject_Budget_Bool_Exp;
}>;


export type GetReportSubjectBudgetQuery = { __typename?: 'query_root', report_subject_budget: Array<{ __typename?: 'report_subject_budget', id: any, budget: any, curriculum?: { __typename?: 'curriculums', name: string } | null, subject?: { __typename?: 'subjects', name: string } | null }> };

export type CreateSubjectBudgetMutationVariables = Exact<{
  object: Report_Subject_Budget_Insert_Input;
}>;


export type CreateSubjectBudgetMutation = { __typename?: 'mutation_root', insert_report_subject_budget_one?: { __typename?: 'report_subject_budget', budget: any, subject?: { __typename?: 'subjects', name: string } | null, curriculum?: { __typename?: 'curriculums', name: string } | null } | null };

export type UpdateSubjectBudgetMutationVariables = Exact<{
  where: Report_Subject_Budget_Bool_Exp;
  object?: InputMaybe<Report_Subject_Budget_Set_Input>;
}>;


export type UpdateSubjectBudgetMutation = { __typename?: 'mutation_root', update_report_subject_budget?: { __typename?: 'report_subject_budget_mutation_response', returning: Array<{ __typename?: 'report_subject_budget', budget: any }> } | null };

export type SystemSettingModelFragment = { __typename?: 'system_settings', key: string, id: any, type: string, value: string };

export type SystemSettingModelFinalFragment = { __typename?: 'system_settings', parentId?: any | null, key: string, id: any, type: string, value: string, parent?: { __typename?: 'system_settings', key: string, id: any, type: string, value: string } | null };

export type GetSystemSettingsQueryVariables = Exact<{
  filter?: InputMaybe<System_Settings_Bool_Exp>;
}>;


export type GetSystemSettingsQuery = { __typename?: 'query_root', system_settings: Array<{ __typename?: 'system_settings', parentId?: any | null, key: string, id: any, type: string, value: string, parent?: { __typename?: 'system_settings', key: string, id: any, type: string, value: string } | null }> };

export type DeleteStudentMutationVariables = Exact<{
  studentId: Scalars['uuid'];
}>;


export type DeleteStudentMutation = { __typename?: 'mutation_root', update_users?: { __typename?: 'users_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'users', fullName?: string | null }> } | null };

export type UpdateStudentToVmsMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type UpdateStudentToVmsMutation = { __typename?: 'mutation_root', updateStudentToVms?: string | null };

export type ForceChangeUserPasswordMutationVariables = Exact<{
  form: FormChangeUserPassword;
}>;


export type ForceChangeUserPasswordMutation = { __typename?: 'mutation_root', changeUserPassword?: string | null };

export type SuggestionUsernameMutationVariables = Exact<{
  form: SuggestionForm;
}>;


export type SuggestionUsernameMutation = { __typename?: 'mutation_root', suggestionUsername?: string | null };

export type ChangeUsernameMutationVariables = Exact<{
  form: FormChangeUsername;
}>;


export type ChangeUsernameMutation = { __typename?: 'mutation_root', changeUsername?: string | null };

export type GetUserRolesQueryVariables = Exact<{
  where?: InputMaybe<Users_Bool_Exp>;
}>;


export type GetUserRolesQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', role: string }> };

export type GetRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRolesQuery = { __typename?: 'query_root', roles: Array<{ __typename?: 'roles', abbreviation?: string | null, id: any, name: string, role?: string | null }> };

export type GetUserByIdAfterQueryVariables = Exact<{
  idUser: Scalars['uuid'];
}>;


export type GetUserByIdAfterQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', email?: string | null, phone: any, id: any, username?: string | null, studentProfile?: { __typename?: 'student_profiles', payOnline: boolean } | null } | null };

export type GetGantryUserRecordsMutationVariables = Exact<{
  form: GantryUserRecordsForm;
}>;


export type GetGantryUserRecordsMutation = { __typename?: 'mutation_root', getGantryUserRecords?: { __typename?: 'GantryUserRecordsModel', code?: string | null, msg?: string | null, data?: { __typename?: 'GantryUserRecordData', pageNo?: number | null, pageSize?: number | null, total?: number | null, list?: Array<{ __typename?: 'GantryUserRecordEvent', eventId?: string | null, eventType?: number | null, eventTime?: string | null, personId?: string | null, personName?: string | null, doorName?: string | null, doorIndexCode?: string | null, cardNo?: string | null, checkInAndOutType?: number | null, picUri?: string | null, deviceTime?: string | null, temperatureData?: string | null, temperatureStatus?: number | null, wearMaskStatus?: number | null } | null> | null } | null } | null };

export type ForgotPasswordMutationVariables = Exact<{
  studentEmail: Scalars['String'];
}>;


export type ForgotPasswordMutation = { __typename?: 'mutation_root', forgotStudentPassword?: { __typename?: 'ForgotPasswordModel', email?: string | null, username?: string | null, status?: string | null } | null };

export type ConfirmPasswordMutationVariables = Exact<{
  code: Scalars['String'];
  newPassword: Scalars['String'];
  username: Scalars['String'];
}>;


export type ConfirmPasswordMutation = { __typename?: 'mutation_root', confirmStudentForgotPassword?: string | null };

export const AcademicCalendarFragmentDoc = gql`
    fragment AcademicCalendar on academic_calendars {
  id
  name
  year
  status
  updatedAt
  updatedBy
  category
  curriculumId
  levelIds
  createdBy
  createdAt
}
    `;
export const TermsFragmentDoc = gql`
    fragment Terms on terms {
  id
  startDate
  endDate
  numberOfLessons
}
    `;
export const CurriculumFragmentDoc = gql`
    fragment Curriculum on curriculums {
  abbreviation
  createdAt
  createdBy
  id
  name
  status
  updatedAt
  updatedBy
}
    `;
export const LevelFragmentDoc = gql`
    fragment Level on levels {
  abbreviation
  createdAt
  createdBy
  id
  name
  status
  updatedAt
  updatedBy
}
    `;
export const BroadcastsFragmentFragmentDoc = gql`
    fragment broadcastsFragment on broadcasts {
  broadcastStatus
  createdAt
  filterRecipient
  createdBy
  id
  recipientType
  status
  via
  updatedAt
  updatedBy
  broadcastLogs {
    isViewed
  }
  createdUser {
    id
    fullName
  }
  updatedUser {
    id
    fullName
  }
  title
  subject
  content
}
    `;
export const NewsFragmentFragmentDoc = gql`
    fragment newsFragment on news {
  coverUrl
  createdAt
  createdBy
  createdUser {
    email
    fullName
    id
    username
  }
  newsLogs_aggregate {
    aggregate {
      count
    }
  }
  newsLogs {
    isViewed
  }
  filterRecipient
  hashtags
  id
  message
  newsStatus
  recipientType
  status
  subject
  title
  type
  updatedAt
  numOpens
  numClicks
}
    `;
export const SimpleClassFragmentFragmentDoc = gql`
    fragment SimpleClassFragment on classes {
  id
  name
}
    `;
export const CreditNoteFragmentFragmentDoc = gql`
    fragment CreditNoteFragment on credit_notes {
  id
  name
  createdAt
  creditNoteStatus
  student {
    fullName
    id
    username
  }
  type
  summary
  updatedAt
  creditNoteClass {
    id
    class {
      ...SimpleClassFragment
    }
    startDate
    endDate
    lessonIds
  }
}
    ${SimpleClassFragmentFragmentDoc}`;
export const DiscountModelFragmentDoc = gql`
    fragment discountModel on discounts {
  id
  name
  amount
  description
  order
  metadata
}
    `;
export const SchoolModelFragmentDoc = gql`
    fragment schoolModel on schools {
  id
  name
}
    `;
export const StudentProfileModelFragmentDoc = gql`
    fragment studentProfileModel on student_profiles {
  id
  school {
    ...schoolModel
  }
  curriculum {
    id
    name
    abbreviation
  }
  level {
    id
    name
    abbreviation
  }
}
    ${SchoolModelFragmentDoc}`;
export const PaymentAdvicesFragmentFragmentDoc = gql`
    fragment paymentAdvicesFragment on payment_advices {
  branchId
  classInformation
  createdAt
  createdBy
  deduction
  deposit
  dueDate
  id
  isOverdueAtPaid
  isRegistrationFee
  issueDate
  name
  otherPayments
  paidAt
  paymentStatus
  paymentSummaryStatic
  registrationFeeConfig
  remarks
  status
  notes
  student {
    address
    avatar
    code
    cognitoId
    createdAt
    createdBy
    dob
    email
    firstName
    fullName
    gender
    id
    isVerifiedEmail
    isVerifiedPhoneNumber
    lastName
    paymentStatus
    username
    updatedBy
    updatedAt
  }
  updatedAt
  updatedBy
  studentId
}
    `;
export const MasterDataAtPaymentAdviceFragmentFragmentDoc = gql`
    fragment MasterDataAtPaymentAdviceFragment on BranchModel {
  id
  address
  name
}
    `;
export const ClassFeeFragmentFragmentDoc = gql`
    fragment ClassFeeFragment on ClassFee {
  data {
    additionalLesson {
      pricing
      quantity
      total
    }
    id
    lessonStartDate
    classStatus
    classType
    name
    terms {
      id
      lessonIds
      name
      pricing
      total
    }
    total
  }
  total
}
    `;
export const OutFeeFragmentFragmentDoc = gql`
    fragment OutFeeFragment on OutFee {
  data {
    amount
    name
  }
  total
}
    `;
export const StudentModelFragmentFragmentDoc = gql`
    fragment StudentModelFragment on StudentModel {
  email
  id
  fullName
  username
  phoneNumber
  studentId
  studentProfile {
    willPayLater
    school {
      id
      name
    }
  }
}
    `;
export const SummaryFragmentFragmentDoc = gql`
    fragment SummaryFragment on Summary {
  classFee
  deduction
  deposit
  gst
  gstConfig
  otherPayments
  registrationFee
  totalAfterGst
  totalBeforeGst
  totalPaid
  totalPayable
}
    `;
export const PaymentAdviceModelFragmentFragmentDoc = gql`
    fragment paymentAdviceModelFragment on PaymentAdviceModel {
  branch {
    ...MasterDataAtPaymentAdviceFragment
  }
  classInformation {
    ...ClassFeeFragment
  }
  deduction {
    ...OutFeeFragment
  }
  dueDate
  id
  isRegistrationFee
  issueDate
  name
  otherPayments {
    ...OutFeeFragment
  }
  deposit {
    ...OutFeeFragment
  }
  paymentStatus
  student {
    ...StudentModelFragment
  }
  summary {
    ...SummaryFragment
  }
  remarks
  notes
}
    ${MasterDataAtPaymentAdviceFragmentFragmentDoc}
${ClassFeeFragmentFragmentDoc}
${OutFeeFragmentFragmentDoc}
${StudentModelFragmentFragmentDoc}
${SummaryFragmentFragmentDoc}`;
export const TransferBillFragmentFragmentDoc = gql`
    fragment TransferBillFragment on TransferBill {
  transferDate
  reason
  className
  mutualTerms
  classBills {
    classFee
    terms
    passedLessons
    paidLessons
  }
}
    `;
export const GeneralFeeFragmentFragmentDoc = gql`
    fragment GeneralFeeFragment on GeneralFee {
  data {
    amount
    name
    id
  }
  total
}
    `;
export const ProgramsModelFragmentDoc = gql`
    fragment programsModel on programs {
  id
  name
  curriculumIds
  levelIds
  tutorIds
  subjectId
  category
  levels {
    id
    name
    abbreviation
  }
  tutors {
    id
    code
  }
  curriculums {
    id
    name
    abbreviation
  }
  subject {
    id
    name
  }
  numberOfDLClasses
  numberOfGeneralClasses
  numberOfSpecialClasses
  numberOfWLWDClasses
  numberOfWLWEClasses
  enrolledStudents
}
    `;
export const GeneraProgramTypeModelFragmentDoc = gql`
    fragment generaProgramTypeModel on general_program_types {
  id
  shortName
  fullName
  status
}
    `;
export const SpecialProgramTypeModelFragmentDoc = gql`
    fragment specialProgramTypeModel on specical_program_types {
  id
  shortName
  fullName
  status
}
    `;
export const RegularProgramTypeModelFragmentDoc = gql`
    fragment regularProgramTypeModel on regular_program_types {
  id
  shortName
  fullName
  status
}
    `;
export const SystemSettingModelFragmentDoc = gql`
    fragment systemSettingModel on system_settings {
  key
  id
  type
  value
}
    `;
export const SystemSettingModelFinalFragmentDoc = gql`
    fragment systemSettingModelFinal on system_settings {
  ...systemSettingModel
  parentId
  parent {
    ...systemSettingModel
  }
}
    ${SystemSettingModelFragmentDoc}`;
export const AcademicCalendarsListDocument = gql`
    query academicCalendarsList($limit: Int!, $offset: Int!, $order: order_by!, $filter: academic_calendars_bool_exp) {
  academic_calendars(
    where: $filter
    limit: $limit
    offset: $offset
    order_by: {name: $order}
  ) {
    ...AcademicCalendar
    curriculum {
      ...Curriculum
    }
    levels {
      ...Level
    }
    terms(order_by: {endDate: asc}) {
      ...Terms
    }
  }
  academic_calendars_aggregate(where: $filter) {
    aggregate {
      count
    }
  }
}
    ${AcademicCalendarFragmentDoc}
${CurriculumFragmentDoc}
${LevelFragmentDoc}
${TermsFragmentDoc}`;

/**
 * __useAcademicCalendarsListQuery__
 *
 * To run a query within a React component, call `useAcademicCalendarsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicCalendarsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicCalendarsListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order: // value for 'order'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAcademicCalendarsListQuery(baseOptions: Apollo.QueryHookOptions<AcademicCalendarsListQuery, AcademicCalendarsListQueryVariables>) {
        return Apollo.useQuery<AcademicCalendarsListQuery, AcademicCalendarsListQueryVariables>(AcademicCalendarsListDocument, baseOptions);
      }
export function useAcademicCalendarsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AcademicCalendarsListQuery, AcademicCalendarsListQueryVariables>) {
          return Apollo.useLazyQuery<AcademicCalendarsListQuery, AcademicCalendarsListQueryVariables>(AcademicCalendarsListDocument, baseOptions);
        }
export type AcademicCalendarsListQueryHookResult = ReturnType<typeof useAcademicCalendarsListQuery>;
export type AcademicCalendarsListLazyQueryHookResult = ReturnType<typeof useAcademicCalendarsListLazyQuery>;
export type AcademicCalendarsListQueryResult = Apollo.QueryResult<AcademicCalendarsListQuery, AcademicCalendarsListQueryVariables>;
export const AcademicCalendarsAllDocument = gql`
    query academicCalendarsAll($filter: academic_calendars_bool_exp) {
  academic_calendars(where: $filter) {
    ...AcademicCalendar
    curriculum {
      ...Curriculum
    }
    levels {
      ...Level
    }
    terms(order_by: {endDate: asc}) {
      ...Terms
    }
  }
}
    ${AcademicCalendarFragmentDoc}
${CurriculumFragmentDoc}
${LevelFragmentDoc}
${TermsFragmentDoc}`;

/**
 * __useAcademicCalendarsAllQuery__
 *
 * To run a query within a React component, call `useAcademicCalendarsAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicCalendarsAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicCalendarsAllQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAcademicCalendarsAllQuery(baseOptions?: Apollo.QueryHookOptions<AcademicCalendarsAllQuery, AcademicCalendarsAllQueryVariables>) {
        return Apollo.useQuery<AcademicCalendarsAllQuery, AcademicCalendarsAllQueryVariables>(AcademicCalendarsAllDocument, baseOptions);
      }
export function useAcademicCalendarsAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AcademicCalendarsAllQuery, AcademicCalendarsAllQueryVariables>) {
          return Apollo.useLazyQuery<AcademicCalendarsAllQuery, AcademicCalendarsAllQueryVariables>(AcademicCalendarsAllDocument, baseOptions);
        }
export type AcademicCalendarsAllQueryHookResult = ReturnType<typeof useAcademicCalendarsAllQuery>;
export type AcademicCalendarsAllLazyQueryHookResult = ReturnType<typeof useAcademicCalendarsAllLazyQuery>;
export type AcademicCalendarsAllQueryResult = Apollo.QueryResult<AcademicCalendarsAllQuery, AcademicCalendarsAllQueryVariables>;
export const GetAcademicCalendarByIdDocument = gql`
    query getAcademicCalendarById($id: uuid!) {
  academic_calendars(where: {id: {_eq: $id}, status: {_neq: "deleted"}}) {
    ...AcademicCalendar
    levelIds
    terms {
      ...Terms
      academicCalendarId
      createdAt
      createdBy
      status
      updatedAt
      updatedBy
    }
  }
}
    ${AcademicCalendarFragmentDoc}
${TermsFragmentDoc}`;

/**
 * __useGetAcademicCalendarByIdQuery__
 *
 * To run a query within a React component, call `useGetAcademicCalendarByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAcademicCalendarByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAcademicCalendarByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAcademicCalendarByIdQuery(baseOptions: Apollo.QueryHookOptions<GetAcademicCalendarByIdQuery, GetAcademicCalendarByIdQueryVariables>) {
        return Apollo.useQuery<GetAcademicCalendarByIdQuery, GetAcademicCalendarByIdQueryVariables>(GetAcademicCalendarByIdDocument, baseOptions);
      }
export function useGetAcademicCalendarByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAcademicCalendarByIdQuery, GetAcademicCalendarByIdQueryVariables>) {
          return Apollo.useLazyQuery<GetAcademicCalendarByIdQuery, GetAcademicCalendarByIdQueryVariables>(GetAcademicCalendarByIdDocument, baseOptions);
        }
export type GetAcademicCalendarByIdQueryHookResult = ReturnType<typeof useGetAcademicCalendarByIdQuery>;
export type GetAcademicCalendarByIdLazyQueryHookResult = ReturnType<typeof useGetAcademicCalendarByIdLazyQuery>;
export type GetAcademicCalendarByIdQueryResult = Apollo.QueryResult<GetAcademicCalendarByIdQuery, GetAcademicCalendarByIdQueryVariables>;
export const CreateAcademicCalendarsDocument = gql`
    mutation createAcademicCalendars($form: [academic_calendars_insert_input!]!) {
  insert_academic_calendars(objects: $form) {
    returning {
      createdAt
      createdBy
      curriculumId
      category
      id
      levelIds
      name
      status
    }
  }
}
    `;
export type CreateAcademicCalendarsMutationFn = Apollo.MutationFunction<CreateAcademicCalendarsMutation, CreateAcademicCalendarsMutationVariables>;

/**
 * __useCreateAcademicCalendarsMutation__
 *
 * To run a mutation, you first call `useCreateAcademicCalendarsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAcademicCalendarsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAcademicCalendarsMutation, { data, loading, error }] = useCreateAcademicCalendarsMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useCreateAcademicCalendarsMutation(baseOptions?: Apollo.MutationHookOptions<CreateAcademicCalendarsMutation, CreateAcademicCalendarsMutationVariables>) {
        return Apollo.useMutation<CreateAcademicCalendarsMutation, CreateAcademicCalendarsMutationVariables>(CreateAcademicCalendarsDocument, baseOptions);
      }
export type CreateAcademicCalendarsMutationHookResult = ReturnType<typeof useCreateAcademicCalendarsMutation>;
export type CreateAcademicCalendarsMutationResult = Apollo.MutationResult<CreateAcademicCalendarsMutation>;
export type CreateAcademicCalendarsMutationOptions = Apollo.BaseMutationOptions<CreateAcademicCalendarsMutation, CreateAcademicCalendarsMutationVariables>;
export const GetAttendanceListDocument = gql`
    query getAttendanceList($offset: Int!, $limit: Int!, $where: lessons_bool_exp) {
  lessons(
    limit: $limit
    offset: $offset
    where: $where
    order_by: {createdAt: desc}
  ) {
    class {
      name
      termClasses {
        termName
      }
      id
    }
    date
    numberWeek
    students_aggregate {
      aggregate {
        count(columns: id)
      }
    }
    students(where: {hasAttended: {_eq: true}}) {
      id
    }
    id
  }
  lessons_aggregate(where: $where, order_by: {createdAt: desc}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetAttendanceListQuery__
 *
 * To run a query within a React component, call `useGetAttendanceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendanceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendanceListQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAttendanceListQuery(baseOptions: Apollo.QueryHookOptions<GetAttendanceListQuery, GetAttendanceListQueryVariables>) {
        return Apollo.useQuery<GetAttendanceListQuery, GetAttendanceListQueryVariables>(GetAttendanceListDocument, baseOptions);
      }
export function useGetAttendanceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttendanceListQuery, GetAttendanceListQueryVariables>) {
          return Apollo.useLazyQuery<GetAttendanceListQuery, GetAttendanceListQueryVariables>(GetAttendanceListDocument, baseOptions);
        }
export type GetAttendanceListQueryHookResult = ReturnType<typeof useGetAttendanceListQuery>;
export type GetAttendanceListLazyQueryHookResult = ReturnType<typeof useGetAttendanceListLazyQuery>;
export type GetAttendanceListQueryResult = Apollo.QueryResult<GetAttendanceListQuery, GetAttendanceListQueryVariables>;
export const GetAttendanceDetailHeaderDocument = gql`
    query getAttendanceDetailHeader($id: uuid!) {
  lessons(where: {id: {_eq: $id}}) {
    class {
      academicCalendar {
        year
      }
      program {
        id
        curriculums {
          name
          id
        }
        levels {
          name
          id
        }
        subject {
          name
          id
        }
      }
      programTypeGeneral {
        fullName
        id
      }
      programTypeRegular {
        fullName
        id
      }
      programTypeSpecial {
        fullName
        id
      }
      programTypeDoubleLesson {
        fullName
        id
      }
      name
      id
      classId
    }
    classroom {
      id
      branch {
        name
        id
      }
      name
    }
    date
    sessions {
      endTime
      startTime
      id
      tutors {
        fullName
        gender
        id
      }
    }
    students(where: {hasAttended: {_eq: true}}) {
      id
    }
    students_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetAttendanceDetailHeaderQuery__
 *
 * To run a query within a React component, call `useGetAttendanceDetailHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendanceDetailHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendanceDetailHeaderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAttendanceDetailHeaderQuery(baseOptions: Apollo.QueryHookOptions<GetAttendanceDetailHeaderQuery, GetAttendanceDetailHeaderQueryVariables>) {
        return Apollo.useQuery<GetAttendanceDetailHeaderQuery, GetAttendanceDetailHeaderQueryVariables>(GetAttendanceDetailHeaderDocument, baseOptions);
      }
export function useGetAttendanceDetailHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttendanceDetailHeaderQuery, GetAttendanceDetailHeaderQueryVariables>) {
          return Apollo.useLazyQuery<GetAttendanceDetailHeaderQuery, GetAttendanceDetailHeaderQueryVariables>(GetAttendanceDetailHeaderDocument, baseOptions);
        }
export type GetAttendanceDetailHeaderQueryHookResult = ReturnType<typeof useGetAttendanceDetailHeaderQuery>;
export type GetAttendanceDetailHeaderLazyQueryHookResult = ReturnType<typeof useGetAttendanceDetailHeaderLazyQuery>;
export type GetAttendanceDetailHeaderQueryResult = Apollo.QueryResult<GetAttendanceDetailHeaderQuery, GetAttendanceDetailHeaderQueryVariables>;
export const GetListDetailDocument = gql`
    query getListDetail($offset: Int!, $limit: Int!, $where: lessons_students_bool_exp) {
  lessons_students(
    limit: $limit
    offset: $offset
    where: $where
    order_by: {createdAt: asc, student: {fullName: asc}}
  ) {
    entryTime
    hasAttended
    id
    remarks
    student {
      id
      fullName
      username
    }
  }
  lessons_students_aggregate(
    limit: $limit
    offset: $offset
    where: $where
    order_by: {createdAt: asc, student: {fullName: asc}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetListDetailQuery__
 *
 * To run a query within a React component, call `useGetListDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListDetailQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetListDetailQuery(baseOptions: Apollo.QueryHookOptions<GetListDetailQuery, GetListDetailQueryVariables>) {
        return Apollo.useQuery<GetListDetailQuery, GetListDetailQueryVariables>(GetListDetailDocument, baseOptions);
      }
export function useGetListDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListDetailQuery, GetListDetailQueryVariables>) {
          return Apollo.useLazyQuery<GetListDetailQuery, GetListDetailQueryVariables>(GetListDetailDocument, baseOptions);
        }
export type GetListDetailQueryHookResult = ReturnType<typeof useGetListDetailQuery>;
export type GetListDetailLazyQueryHookResult = ReturnType<typeof useGetListDetailLazyQuery>;
export type GetListDetailQueryResult = Apollo.QueryResult<GetListDetailQuery, GetListDetailQueryVariables>;
export const UpdateAttendanceDetailDocument = gql`
    mutation updateAttendanceDetail($id: uuid!, $set: lessons_students_set_input) {
  update_lessons_students(where: {id: {_eq: $id}}, _set: $set) {
    affected_rows
  }
}
    `;
export type UpdateAttendanceDetailMutationFn = Apollo.MutationFunction<UpdateAttendanceDetailMutation, UpdateAttendanceDetailMutationVariables>;

/**
 * __useUpdateAttendanceDetailMutation__
 *
 * To run a mutation, you first call `useUpdateAttendanceDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttendanceDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAttendanceDetailMutation, { data, loading, error }] = useUpdateAttendanceDetailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdateAttendanceDetailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAttendanceDetailMutation, UpdateAttendanceDetailMutationVariables>) {
        return Apollo.useMutation<UpdateAttendanceDetailMutation, UpdateAttendanceDetailMutationVariables>(UpdateAttendanceDetailDocument, baseOptions);
      }
export type UpdateAttendanceDetailMutationHookResult = ReturnType<typeof useUpdateAttendanceDetailMutation>;
export type UpdateAttendanceDetailMutationResult = Apollo.MutationResult<UpdateAttendanceDetailMutation>;
export type UpdateAttendanceDetailMutationOptions = Apollo.BaseMutationOptions<UpdateAttendanceDetailMutation, UpdateAttendanceDetailMutationVariables>;
export const GetProfileDocument = gql`
    query getProfile {
  get_profile {
    id
    lastName
    phoneNumber
    role
    dob
    email
    firstName
    gender
    username
    avatar
    isVerifiedEmail
    isVerifiedPhoneNumber
    phone
  }
}
    `;

/**
 * __useGetProfileQuery__
 *
 * To run a query within a React component, call `useGetProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetProfileQuery, GetProfileQueryVariables>) {
        return Apollo.useQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, baseOptions);
      }
export function useGetProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfileQuery, GetProfileQueryVariables>) {
          return Apollo.useLazyQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, baseOptions);
        }
export type GetProfileQueryHookResult = ReturnType<typeof useGetProfileQuery>;
export type GetProfileLazyQueryHookResult = ReturnType<typeof useGetProfileLazyQuery>;
export type GetProfileQueryResult = Apollo.QueryResult<GetProfileQuery, GetProfileQueryVariables>;
export const BanksDocument = gql`
    query banks {
  banks {
    abbreviation
    id
    name
  }
}
    `;

/**
 * __useBanksQuery__
 *
 * To run a query within a React component, call `useBanksQuery` and pass it any options that fit your needs.
 * When your component renders, `useBanksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBanksQuery({
 *   variables: {
 *   },
 * });
 */
export function useBanksQuery(baseOptions?: Apollo.QueryHookOptions<BanksQuery, BanksQueryVariables>) {
        return Apollo.useQuery<BanksQuery, BanksQueryVariables>(BanksDocument, baseOptions);
      }
export function useBanksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BanksQuery, BanksQueryVariables>) {
          return Apollo.useLazyQuery<BanksQuery, BanksQueryVariables>(BanksDocument, baseOptions);
        }
export type BanksQueryHookResult = ReturnType<typeof useBanksQuery>;
export type BanksLazyQueryHookResult = ReturnType<typeof useBanksLazyQuery>;
export type BanksQueryResult = Apollo.QueryResult<BanksQuery, BanksQueryVariables>;
export const GetClassInformationDocument = gql`
    query getClassInformation($form: FormGetClassInformation!) {
  getClassInformation(form: $form) {
    total
    terms {
      id
      lessonIds
      name
      pricing
      total
      lessons
    }
    additionalLesson {
      pricing
      quantity
      total
    }
    period {
      endDate
      startDate
    }
    classStatus
    classType
    programId
    id
    lessonStartDate
    name
  }
}
    `;

/**
 * __useGetClassInformationQuery__
 *
 * To run a query within a React component, call `useGetClassInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassInformationQuery({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useGetClassInformationQuery(baseOptions: Apollo.QueryHookOptions<GetClassInformationQuery, GetClassInformationQueryVariables>) {
        return Apollo.useQuery<GetClassInformationQuery, GetClassInformationQueryVariables>(GetClassInformationDocument, baseOptions);
      }
export function useGetClassInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassInformationQuery, GetClassInformationQueryVariables>) {
          return Apollo.useLazyQuery<GetClassInformationQuery, GetClassInformationQueryVariables>(GetClassInformationDocument, baseOptions);
        }
export type GetClassInformationQueryHookResult = ReturnType<typeof useGetClassInformationQuery>;
export type GetClassInformationLazyQueryHookResult = ReturnType<typeof useGetClassInformationLazyQuery>;
export type GetClassInformationQueryResult = Apollo.QueryResult<GetClassInformationQuery, GetClassInformationQueryVariables>;
export const DeleteClassStudentsWaitingDocument = gql`
    mutation deleteClassStudentsWaiting($where: class_students_waiting_bool_exp!) {
  delete_class_students_waiting(where: $where) {
    affected_rows
    returning {
      id
      classId
    }
  }
}
    `;
export type DeleteClassStudentsWaitingMutationFn = Apollo.MutationFunction<DeleteClassStudentsWaitingMutation, DeleteClassStudentsWaitingMutationVariables>;

/**
 * __useDeleteClassStudentsWaitingMutation__
 *
 * To run a mutation, you first call `useDeleteClassStudentsWaitingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClassStudentsWaitingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClassStudentsWaitingMutation, { data, loading, error }] = useDeleteClassStudentsWaitingMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteClassStudentsWaitingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClassStudentsWaitingMutation, DeleteClassStudentsWaitingMutationVariables>) {
        return Apollo.useMutation<DeleteClassStudentsWaitingMutation, DeleteClassStudentsWaitingMutationVariables>(DeleteClassStudentsWaitingDocument, baseOptions);
      }
export type DeleteClassStudentsWaitingMutationHookResult = ReturnType<typeof useDeleteClassStudentsWaitingMutation>;
export type DeleteClassStudentsWaitingMutationResult = Apollo.MutationResult<DeleteClassStudentsWaitingMutation>;
export type DeleteClassStudentsWaitingMutationOptions = Apollo.BaseMutationOptions<DeleteClassStudentsWaitingMutation, DeleteClassStudentsWaitingMutationVariables>;
export const GetClassSimpleDocument = gql`
    query getClassSimple($where: classes_bool_exp) {
  classes(where: $where) {
    ...SimpleClassFragment
  }
}
    ${SimpleClassFragmentFragmentDoc}`;

/**
 * __useGetClassSimpleQuery__
 *
 * To run a query within a React component, call `useGetClassSimpleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassSimpleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassSimpleQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetClassSimpleQuery(baseOptions?: Apollo.QueryHookOptions<GetClassSimpleQuery, GetClassSimpleQueryVariables>) {
        return Apollo.useQuery<GetClassSimpleQuery, GetClassSimpleQueryVariables>(GetClassSimpleDocument, baseOptions);
      }
export function useGetClassSimpleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassSimpleQuery, GetClassSimpleQueryVariables>) {
          return Apollo.useLazyQuery<GetClassSimpleQuery, GetClassSimpleQueryVariables>(GetClassSimpleDocument, baseOptions);
        }
export type GetClassSimpleQueryHookResult = ReturnType<typeof useGetClassSimpleQuery>;
export type GetClassSimpleLazyQueryHookResult = ReturnType<typeof useGetClassSimpleLazyQuery>;
export type GetClassSimpleQueryResult = Apollo.QueryResult<GetClassSimpleQuery, GetClassSimpleQueryVariables>;
export const GetListClassDocument = gql`
    query getListClass($where: classes_bool_exp!, $lesson: lessons_bool_exp) {
  classes(where: $where) {
    id
    name
    program {
      subject {
        id
        name
        abbreviation
      }
      curriculums {
        id
        name
        abbreviation
      }
      levels {
        id
        name
        abbreviation
      }
    }
    classStatus
    lessons(where: $lesson, limit: 1) {
      date
      id
      sessions {
        endTime
        startTime
      }
      classroom {
        capacity
        branch {
          name
          id
          abbreviation
        }
      }
      students_aggregate {
        aggregate {
          count
        }
      }
    }
  }
}
    `;

/**
 * __useGetListClassQuery__
 *
 * To run a query within a React component, call `useGetListClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListClassQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListClassQuery({
 *   variables: {
 *      where: // value for 'where'
 *      lesson: // value for 'lesson'
 *   },
 * });
 */
export function useGetListClassQuery(baseOptions: Apollo.QueryHookOptions<GetListClassQuery, GetListClassQueryVariables>) {
        return Apollo.useQuery<GetListClassQuery, GetListClassQueryVariables>(GetListClassDocument, baseOptions);
      }
export function useGetListClassLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListClassQuery, GetListClassQueryVariables>) {
          return Apollo.useLazyQuery<GetListClassQuery, GetListClassQueryVariables>(GetListClassDocument, baseOptions);
        }
export type GetListClassQueryHookResult = ReturnType<typeof useGetListClassQuery>;
export type GetListClassLazyQueryHookResult = ReturnType<typeof useGetListClassLazyQuery>;
export type GetListClassQueryResult = Apollo.QueryResult<GetListClassQuery, GetListClassQueryVariables>;
export const GetClassDetailDocument = gql`
    query getClassDetail($where: classes_bool_exp!) {
  classes(where: $where) {
    id
    name
    classId
    classStatus
    programTypeSpecial {
      id
      shortName
      fullName
    }
    programTypeRegular {
      id
      fullName
      shortName
    }
    programTypeGeneral {
      fullName
      id
      shortName
    }
    programTypeDoubleLesson {
      fullName
      id
      shortName
    }
    program {
      id
      curriculums {
        id
        abbreviation
      }
      levels {
        id
        abbreviation
      }
      subject {
        id
        abbreviation
      }
    }
    lessons(order_by: {date: asc}) {
      id
      termClass {
        id
        termName
      }
      numberWeek
      date
      classroom {
        branch {
          id
          name
        }
        id
        capacity
        name
      }
      sessions {
        id
        endTime
        startTime
        tutors {
          fullName
          id
        }
      }
      lessonStatus
    }
  }
}
    `;

/**
 * __useGetClassDetailQuery__
 *
 * To run a query within a React component, call `useGetClassDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassDetailQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetClassDetailQuery(baseOptions: Apollo.QueryHookOptions<GetClassDetailQuery, GetClassDetailQueryVariables>) {
        return Apollo.useQuery<GetClassDetailQuery, GetClassDetailQueryVariables>(GetClassDetailDocument, baseOptions);
      }
export function useGetClassDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassDetailQuery, GetClassDetailQueryVariables>) {
          return Apollo.useLazyQuery<GetClassDetailQuery, GetClassDetailQueryVariables>(GetClassDetailDocument, baseOptions);
        }
export type GetClassDetailQueryHookResult = ReturnType<typeof useGetClassDetailQuery>;
export type GetClassDetailLazyQueryHookResult = ReturnType<typeof useGetClassDetailLazyQuery>;
export type GetClassDetailQueryResult = Apollo.QueryResult<GetClassDetailQuery, GetClassDetailQueryVariables>;
export const LessonsStudentsDocument = gql`
    query lessonsStudents($where: lessons_students_bool_exp!) {
  lessons_students(
    where: $where
    order_by: {lesson: {termClass: {term: {startDate: asc}}}}
  ) {
    lessonStatus
    type
    hasAttended
    id
    lessonId
    lessonStatus
    studentId
    type
    entryTime
    oldLessonId
    oldLesson {
      classId
    }
    lesson {
      classId
      id
      numberWeek
      termClass {
        id
        termName
      }
      date
      classroom {
        branch {
          abbreviation
          id
          name
        }
        capacity
        id
        name
      }
      sessions {
        endTime
        id
        startTime
        tutors {
          id
          firstName
        }
      }
      lessonStatus
    }
  }
}
    `;

/**
 * __useLessonsStudentsQuery__
 *
 * To run a query within a React component, call `useLessonsStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLessonsStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLessonsStudentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLessonsStudentsQuery(baseOptions: Apollo.QueryHookOptions<LessonsStudentsQuery, LessonsStudentsQueryVariables>) {
        return Apollo.useQuery<LessonsStudentsQuery, LessonsStudentsQueryVariables>(LessonsStudentsDocument, baseOptions);
      }
export function useLessonsStudentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LessonsStudentsQuery, LessonsStudentsQueryVariables>) {
          return Apollo.useLazyQuery<LessonsStudentsQuery, LessonsStudentsQueryVariables>(LessonsStudentsDocument, baseOptions);
        }
export type LessonsStudentsQueryHookResult = ReturnType<typeof useLessonsStudentsQuery>;
export type LessonsStudentsLazyQueryHookResult = ReturnType<typeof useLessonsStudentsLazyQuery>;
export type LessonsStudentsQueryResult = Apollo.QueryResult<LessonsStudentsQuery, LessonsStudentsQueryVariables>;
export const GetStudentSelectedClassesDocument = gql`
    query getStudentSelectedClasses($filter: class_students_waiting_bool_exp) {
  class_students_waiting(where: $filter) {
    id
    class {
      classStatus
      id
      programId
      program {
        id
        name
      }
      name
    }
  }
}
    `;

/**
 * __useGetStudentSelectedClassesQuery__
 *
 * To run a query within a React component, call `useGetStudentSelectedClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentSelectedClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentSelectedClassesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetStudentSelectedClassesQuery(baseOptions?: Apollo.QueryHookOptions<GetStudentSelectedClassesQuery, GetStudentSelectedClassesQueryVariables>) {
        return Apollo.useQuery<GetStudentSelectedClassesQuery, GetStudentSelectedClassesQueryVariables>(GetStudentSelectedClassesDocument, baseOptions);
      }
export function useGetStudentSelectedClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentSelectedClassesQuery, GetStudentSelectedClassesQueryVariables>) {
          return Apollo.useLazyQuery<GetStudentSelectedClassesQuery, GetStudentSelectedClassesQueryVariables>(GetStudentSelectedClassesDocument, baseOptions);
        }
export type GetStudentSelectedClassesQueryHookResult = ReturnType<typeof useGetStudentSelectedClassesQuery>;
export type GetStudentSelectedClassesLazyQueryHookResult = ReturnType<typeof useGetStudentSelectedClassesLazyQuery>;
export type GetStudentSelectedClassesQueryResult = Apollo.QueryResult<GetStudentSelectedClassesQuery, GetStudentSelectedClassesQueryVariables>;
export const CountStudentWaitingListDocument = gql`
    query countStudentWaitingList($where: class_students_waiting_bool_exp!) {
  class_students_waiting_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useCountStudentWaitingListQuery__
 *
 * To run a query within a React component, call `useCountStudentWaitingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountStudentWaitingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountStudentWaitingListQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountStudentWaitingListQuery(baseOptions: Apollo.QueryHookOptions<CountStudentWaitingListQuery, CountStudentWaitingListQueryVariables>) {
        return Apollo.useQuery<CountStudentWaitingListQuery, CountStudentWaitingListQueryVariables>(CountStudentWaitingListDocument, baseOptions);
      }
export function useCountStudentWaitingListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountStudentWaitingListQuery, CountStudentWaitingListQueryVariables>) {
          return Apollo.useLazyQuery<CountStudentWaitingListQuery, CountStudentWaitingListQueryVariables>(CountStudentWaitingListDocument, baseOptions);
        }
export type CountStudentWaitingListQueryHookResult = ReturnType<typeof useCountStudentWaitingListQuery>;
export type CountStudentWaitingListLazyQueryHookResult = ReturnType<typeof useCountStudentWaitingListLazyQuery>;
export type CountStudentWaitingListQueryResult = Apollo.QueryResult<CountStudentWaitingListQuery, CountStudentWaitingListQueryVariables>;
export const GetLessonStudentDetailDocument = gql`
    query getLessonStudentDetail($classId: uuid!, $studentId: uuid!) {
  lessons(where: {classId: {_eq: $classId}}) {
    id
    termClass {
      id
      termName
    }
    numberWeek
    date
    classroom {
      branch {
        id
        name
      }
      capacity
      id
      name
    }
    sessions {
      id
      endTime
      startTime
      tutors {
        fullName
        id
      }
    }
    lessonStatus
    students(where: {studentId: {_eq: $studentId}}) {
      id
      type
      hasAttended
      lessonStatus
    }
  }
}
    `;

/**
 * __useGetLessonStudentDetailQuery__
 *
 * To run a query within a React component, call `useGetLessonStudentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLessonStudentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLessonStudentDetailQuery({
 *   variables: {
 *      classId: // value for 'classId'
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetLessonStudentDetailQuery(baseOptions: Apollo.QueryHookOptions<GetLessonStudentDetailQuery, GetLessonStudentDetailQueryVariables>) {
        return Apollo.useQuery<GetLessonStudentDetailQuery, GetLessonStudentDetailQueryVariables>(GetLessonStudentDetailDocument, baseOptions);
      }
export function useGetLessonStudentDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLessonStudentDetailQuery, GetLessonStudentDetailQueryVariables>) {
          return Apollo.useLazyQuery<GetLessonStudentDetailQuery, GetLessonStudentDetailQueryVariables>(GetLessonStudentDetailDocument, baseOptions);
        }
export type GetLessonStudentDetailQueryHookResult = ReturnType<typeof useGetLessonStudentDetailQuery>;
export type GetLessonStudentDetailLazyQueryHookResult = ReturnType<typeof useGetLessonStudentDetailLazyQuery>;
export type GetLessonStudentDetailQueryResult = Apollo.QueryResult<GetLessonStudentDetailQuery, GetLessonStudentDetailQueryVariables>;
export const FilterPaidClassByStudentDocument = gql`
    query filterPaidClassByStudent($studentId: uuid, $programId: uuid, $programTypeId: uuid) {
  classes(
    where: {lessons: {students: {studentId: {_eq: $studentId}, type: {_eq: "enrolled"}}}, _or: [{programTypeGeneralId: {_eq: $programTypeId}}, {programTypeSpecialId: {_eq: $programTypeId}}, {programTypeRegularId: {_eq: $programTypeId}}], classStatus: {_eq: "open"}, programId: {_eq: $programId}}
  ) {
    id
    name
    programId
    programTypeGeneralId
    programTypeSpecialId
    programTypeRegularId
    programTypeDoubleLessonId
  }
}
    `;

/**
 * __useFilterPaidClassByStudentQuery__
 *
 * To run a query within a React component, call `useFilterPaidClassByStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterPaidClassByStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterPaidClassByStudentQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      programId: // value for 'programId'
 *      programTypeId: // value for 'programTypeId'
 *   },
 * });
 */
export function useFilterPaidClassByStudentQuery(baseOptions?: Apollo.QueryHookOptions<FilterPaidClassByStudentQuery, FilterPaidClassByStudentQueryVariables>) {
        return Apollo.useQuery<FilterPaidClassByStudentQuery, FilterPaidClassByStudentQueryVariables>(FilterPaidClassByStudentDocument, baseOptions);
      }
export function useFilterPaidClassByStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterPaidClassByStudentQuery, FilterPaidClassByStudentQueryVariables>) {
          return Apollo.useLazyQuery<FilterPaidClassByStudentQuery, FilterPaidClassByStudentQueryVariables>(FilterPaidClassByStudentDocument, baseOptions);
        }
export type FilterPaidClassByStudentQueryHookResult = ReturnType<typeof useFilterPaidClassByStudentQuery>;
export type FilterPaidClassByStudentLazyQueryHookResult = ReturnType<typeof useFilterPaidClassByStudentLazyQuery>;
export type FilterPaidClassByStudentQueryResult = Apollo.QueryResult<FilterPaidClassByStudentQuery, FilterPaidClassByStudentQueryVariables>;
export const GetTransferClassListDocument = gql`
    query getTransferClassList($where: request_transfer_classes_bool_exp!) {
  request_transfer_classes(where: $where) {
    id
    student {
      fullName
      username
    }
    fromClass {
      id
      name
      programTypeGeneral {
        fullName
        id
      }
      programTypeRegular {
        fullName
        id
      }
      programTypeSpecial {
        id
        fullName
      }
      programTypeDoubleLesson {
        fullName
        id
      }
    }
    toClass {
      name
      id
      startDate
    }
    transferClassStatus
  }
}
    `;

/**
 * __useGetTransferClassListQuery__
 *
 * To run a query within a React component, call `useGetTransferClassListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransferClassListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransferClassListQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetTransferClassListQuery(baseOptions: Apollo.QueryHookOptions<GetTransferClassListQuery, GetTransferClassListQueryVariables>) {
        return Apollo.useQuery<GetTransferClassListQuery, GetTransferClassListQueryVariables>(GetTransferClassListDocument, baseOptions);
      }
export function useGetTransferClassListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransferClassListQuery, GetTransferClassListQueryVariables>) {
          return Apollo.useLazyQuery<GetTransferClassListQuery, GetTransferClassListQueryVariables>(GetTransferClassListDocument, baseOptions);
        }
export type GetTransferClassListQueryHookResult = ReturnType<typeof useGetTransferClassListQuery>;
export type GetTransferClassListLazyQueryHookResult = ReturnType<typeof useGetTransferClassListLazyQuery>;
export type GetTransferClassListQueryResult = Apollo.QueryResult<GetTransferClassListQuery, GetTransferClassListQueryVariables>;
export const TransferClassDocument = gql`
    mutation transferClass($form: FormRequestTransferClass = {fromClassId: "", studentId: "", toClassId: ""}) {
  requestTransferClass(form: $form)
}
    `;
export type TransferClassMutationFn = Apollo.MutationFunction<TransferClassMutation, TransferClassMutationVariables>;

/**
 * __useTransferClassMutation__
 *
 * To run a mutation, you first call `useTransferClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferClassMutation, { data, loading, error }] = useTransferClassMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useTransferClassMutation(baseOptions?: Apollo.MutationHookOptions<TransferClassMutation, TransferClassMutationVariables>) {
        return Apollo.useMutation<TransferClassMutation, TransferClassMutationVariables>(TransferClassDocument, baseOptions);
      }
export type TransferClassMutationHookResult = ReturnType<typeof useTransferClassMutation>;
export type TransferClassMutationResult = Apollo.MutationResult<TransferClassMutation>;
export type TransferClassMutationOptions = Apollo.BaseMutationOptions<TransferClassMutation, TransferClassMutationVariables>;
export const CancelTransferClassDocument = gql`
    mutation cancelTransferClass($form: FormCancelTransferClass!) {
  cancelTransferClass(form: $form)
}
    `;
export type CancelTransferClassMutationFn = Apollo.MutationFunction<CancelTransferClassMutation, CancelTransferClassMutationVariables>;

/**
 * __useCancelTransferClassMutation__
 *
 * To run a mutation, you first call `useCancelTransferClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelTransferClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelTransferClassMutation, { data, loading, error }] = useCancelTransferClassMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useCancelTransferClassMutation(baseOptions?: Apollo.MutationHookOptions<CancelTransferClassMutation, CancelTransferClassMutationVariables>) {
        return Apollo.useMutation<CancelTransferClassMutation, CancelTransferClassMutationVariables>(CancelTransferClassDocument, baseOptions);
      }
export type CancelTransferClassMutationHookResult = ReturnType<typeof useCancelTransferClassMutation>;
export type CancelTransferClassMutationResult = Apollo.MutationResult<CancelTransferClassMutation>;
export type CancelTransferClassMutationOptions = Apollo.BaseMutationOptions<CancelTransferClassMutation, CancelTransferClassMutationVariables>;
export const GetListBroadcastDocument = gql`
    query getListBroadcast($offset: Int, $limit: Int, $filters: broadcasts_bool_exp) {
  broadcasts(
    limit: $limit
    offset: $offset
    where: $filters
    order_by: {createdAt: desc}
  ) {
    ...broadcastsFragment
  }
  broadcasts_aggregate(where: $filters) {
    aggregate {
      count
    }
  }
}
    ${BroadcastsFragmentFragmentDoc}`;

/**
 * __useGetListBroadcastQuery__
 *
 * To run a query within a React component, call `useGetListBroadcastQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListBroadcastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListBroadcastQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetListBroadcastQuery(baseOptions?: Apollo.QueryHookOptions<GetListBroadcastQuery, GetListBroadcastQueryVariables>) {
        return Apollo.useQuery<GetListBroadcastQuery, GetListBroadcastQueryVariables>(GetListBroadcastDocument, baseOptions);
      }
export function useGetListBroadcastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListBroadcastQuery, GetListBroadcastQueryVariables>) {
          return Apollo.useLazyQuery<GetListBroadcastQuery, GetListBroadcastQueryVariables>(GetListBroadcastDocument, baseOptions);
        }
export type GetListBroadcastQueryHookResult = ReturnType<typeof useGetListBroadcastQuery>;
export type GetListBroadcastLazyQueryHookResult = ReturnType<typeof useGetListBroadcastLazyQuery>;
export type GetListBroadcastQueryResult = Apollo.QueryResult<GetListBroadcastQuery, GetListBroadcastQueryVariables>;
export const GetBroadcastLogDocument = gql`
    query getBroadcastLog($offset: Int, $limit: Int, $filters: broadcast_logs_bool_exp) {
  broadcast_logs(
    limit: $limit
    offset: $offset
    where: $filters
    order_by: {createdAt: desc}
  ) {
    smsStatus
    status
    updatedAt
    updatedBy
    broadcastId
    createdAt
    createdBy
    emailStatus
    id
    notificationStatus
    recipient {
      id
      fullName
      firstName
      lastName
      email
      phoneNumber
      username
      role
    }
    recipientId
  }
  broadcast_logs_aggregate(where: $filters) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetBroadcastLogQuery__
 *
 * To run a query within a React component, call `useGetBroadcastLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBroadcastLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBroadcastLogQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetBroadcastLogQuery(baseOptions?: Apollo.QueryHookOptions<GetBroadcastLogQuery, GetBroadcastLogQueryVariables>) {
        return Apollo.useQuery<GetBroadcastLogQuery, GetBroadcastLogQueryVariables>(GetBroadcastLogDocument, baseOptions);
      }
export function useGetBroadcastLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBroadcastLogQuery, GetBroadcastLogQueryVariables>) {
          return Apollo.useLazyQuery<GetBroadcastLogQuery, GetBroadcastLogQueryVariables>(GetBroadcastLogDocument, baseOptions);
        }
export type GetBroadcastLogQueryHookResult = ReturnType<typeof useGetBroadcastLogQuery>;
export type GetBroadcastLogLazyQueryHookResult = ReturnType<typeof useGetBroadcastLogLazyQuery>;
export type GetBroadcastLogQueryResult = Apollo.QueryResult<GetBroadcastLogQuery, GetBroadcastLogQueryVariables>;
export const Upload_New_RecipientsDocument = gql`
    mutation UPLOAD_NEW_RECIPIENTS($objects: [news_recipients_upload_insert_input!]! = {}) {
  insert_news_recipients_upload(objects: $objects) {
    returning {
      id
    }
  }
}
    `;
export type Upload_New_RecipientsMutationFn = Apollo.MutationFunction<Upload_New_RecipientsMutation, Upload_New_RecipientsMutationVariables>;

/**
 * __useUpload_New_RecipientsMutation__
 *
 * To run a mutation, you first call `useUpload_New_RecipientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpload_New_RecipientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadNewRecipientsMutation, { data, loading, error }] = useUpload_New_RecipientsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpload_New_RecipientsMutation(baseOptions?: Apollo.MutationHookOptions<Upload_New_RecipientsMutation, Upload_New_RecipientsMutationVariables>) {
        return Apollo.useMutation<Upload_New_RecipientsMutation, Upload_New_RecipientsMutationVariables>(Upload_New_RecipientsDocument, baseOptions);
      }
export type Upload_New_RecipientsMutationHookResult = ReturnType<typeof useUpload_New_RecipientsMutation>;
export type Upload_New_RecipientsMutationResult = Apollo.MutationResult<Upload_New_RecipientsMutation>;
export type Upload_New_RecipientsMutationOptions = Apollo.BaseMutationOptions<Upload_New_RecipientsMutation, Upload_New_RecipientsMutationVariables>;
export const Create_BroadcastDocument = gql`
    mutation CREATE_BROADCAST($objects: [broadcasts_insert_input!]! = {}) {
  insert_broadcasts(objects: $objects) {
    returning {
      ...broadcastsFragment
    }
  }
}
    ${BroadcastsFragmentFragmentDoc}`;
export type Create_BroadcastMutationFn = Apollo.MutationFunction<Create_BroadcastMutation, Create_BroadcastMutationVariables>;

/**
 * __useCreate_BroadcastMutation__
 *
 * To run a mutation, you first call `useCreate_BroadcastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreate_BroadcastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBroadcastMutation, { data, loading, error }] = useCreate_BroadcastMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useCreate_BroadcastMutation(baseOptions?: Apollo.MutationHookOptions<Create_BroadcastMutation, Create_BroadcastMutationVariables>) {
        return Apollo.useMutation<Create_BroadcastMutation, Create_BroadcastMutationVariables>(Create_BroadcastDocument, baseOptions);
      }
export type Create_BroadcastMutationHookResult = ReturnType<typeof useCreate_BroadcastMutation>;
export type Create_BroadcastMutationResult = Apollo.MutationResult<Create_BroadcastMutation>;
export type Create_BroadcastMutationOptions = Apollo.BaseMutationOptions<Create_BroadcastMutation, Create_BroadcastMutationVariables>;
export const Update_BroadcastDocument = gql`
    mutation UPDATE_BROADCAST($_eq: uuid = "", $_set: broadcasts_set_input = {}) {
  update_broadcasts(where: {id: {_eq: $_eq}}, _set: $_set) {
    returning {
      ...broadcastsFragment
    }
  }
}
    ${BroadcastsFragmentFragmentDoc}`;
export type Update_BroadcastMutationFn = Apollo.MutationFunction<Update_BroadcastMutation, Update_BroadcastMutationVariables>;

/**
 * __useUpdate_BroadcastMutation__
 *
 * To run a mutation, you first call `useUpdate_BroadcastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_BroadcastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBroadcastMutation, { data, loading, error }] = useUpdate_BroadcastMutation({
 *   variables: {
 *      _eq: // value for '_eq'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdate_BroadcastMutation(baseOptions?: Apollo.MutationHookOptions<Update_BroadcastMutation, Update_BroadcastMutationVariables>) {
        return Apollo.useMutation<Update_BroadcastMutation, Update_BroadcastMutationVariables>(Update_BroadcastDocument, baseOptions);
      }
export type Update_BroadcastMutationHookResult = ReturnType<typeof useUpdate_BroadcastMutation>;
export type Update_BroadcastMutationResult = Apollo.MutationResult<Update_BroadcastMutation>;
export type Update_BroadcastMutationOptions = Apollo.BaseMutationOptions<Update_BroadcastMutation, Update_BroadcastMutationVariables>;
export const SentBroadcastDocument = gql`
    mutation sentBroadcast($id: String!, $isResend: Boolean, $recipients: [String]) {
  sentBroadcast(
    form: {broadcastId: $id, isResend: $isResend, recipients: $recipients}
  )
}
    `;
export type SentBroadcastMutationFn = Apollo.MutationFunction<SentBroadcastMutation, SentBroadcastMutationVariables>;

/**
 * __useSentBroadcastMutation__
 *
 * To run a mutation, you first call `useSentBroadcastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSentBroadcastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sentBroadcastMutation, { data, loading, error }] = useSentBroadcastMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isResend: // value for 'isResend'
 *      recipients: // value for 'recipients'
 *   },
 * });
 */
export function useSentBroadcastMutation(baseOptions?: Apollo.MutationHookOptions<SentBroadcastMutation, SentBroadcastMutationVariables>) {
        return Apollo.useMutation<SentBroadcastMutation, SentBroadcastMutationVariables>(SentBroadcastDocument, baseOptions);
      }
export type SentBroadcastMutationHookResult = ReturnType<typeof useSentBroadcastMutation>;
export type SentBroadcastMutationResult = Apollo.MutationResult<SentBroadcastMutation>;
export type SentBroadcastMutationOptions = Apollo.BaseMutationOptions<SentBroadcastMutation, SentBroadcastMutationVariables>;
export const GetListNewsFeedDocument = gql`
    query getListNewsFeed($offset: Int, $limit: Int, $filters: news_bool_exp) {
  news(
    limit: $limit
    offset: $offset
    where: $filters
    order_by: {createdAt: desc}
  ) {
    ...newsFragment
  }
  news_aggregate(where: $filters) {
    aggregate {
      count
    }
  }
}
    ${NewsFragmentFragmentDoc}`;

/**
 * __useGetListNewsFeedQuery__
 *
 * To run a query within a React component, call `useGetListNewsFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListNewsFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListNewsFeedQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetListNewsFeedQuery(baseOptions?: Apollo.QueryHookOptions<GetListNewsFeedQuery, GetListNewsFeedQueryVariables>) {
        return Apollo.useQuery<GetListNewsFeedQuery, GetListNewsFeedQueryVariables>(GetListNewsFeedDocument, baseOptions);
      }
export function useGetListNewsFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListNewsFeedQuery, GetListNewsFeedQueryVariables>) {
          return Apollo.useLazyQuery<GetListNewsFeedQuery, GetListNewsFeedQueryVariables>(GetListNewsFeedDocument, baseOptions);
        }
export type GetListNewsFeedQueryHookResult = ReturnType<typeof useGetListNewsFeedQuery>;
export type GetListNewsFeedLazyQueryHookResult = ReturnType<typeof useGetListNewsFeedLazyQuery>;
export type GetListNewsFeedQueryResult = Apollo.QueryResult<GetListNewsFeedQuery, GetListNewsFeedQueryVariables>;
export const GetListAnnouncementDocument = gql`
    query getListAnnouncement($offset: Int, $limit: Int) {
  news(
    limit: $limit
    offset: $offset
    where: {newsStatus: {_eq: "sent"}, status: {_neq: "deleted"}}
    order_by: {updatedAt: desc}
  ) {
    ...newsFragment
  }
  broadcasts(
    limit: $limit
    offset: $offset
    where: {broadcastStatus: {_eq: "sent"}, status: {_neq: "deleted"}, via: {_contains: "notification"}}
    order_by: {updatedAt: desc}
  ) {
    ...broadcastsFragment
  }
}
    ${NewsFragmentFragmentDoc}
${BroadcastsFragmentFragmentDoc}`;

/**
 * __useGetListAnnouncementQuery__
 *
 * To run a query within a React component, call `useGetListAnnouncementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListAnnouncementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListAnnouncementQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetListAnnouncementQuery(baseOptions?: Apollo.QueryHookOptions<GetListAnnouncementQuery, GetListAnnouncementQueryVariables>) {
        return Apollo.useQuery<GetListAnnouncementQuery, GetListAnnouncementQueryVariables>(GetListAnnouncementDocument, baseOptions);
      }
export function useGetListAnnouncementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListAnnouncementQuery, GetListAnnouncementQueryVariables>) {
          return Apollo.useLazyQuery<GetListAnnouncementQuery, GetListAnnouncementQueryVariables>(GetListAnnouncementDocument, baseOptions);
        }
export type GetListAnnouncementQueryHookResult = ReturnType<typeof useGetListAnnouncementQuery>;
export type GetListAnnouncementLazyQueryHookResult = ReturnType<typeof useGetListAnnouncementLazyQuery>;
export type GetListAnnouncementQueryResult = Apollo.QueryResult<GetListAnnouncementQuery, GetListAnnouncementQueryVariables>;
export const GetBroadcastLogAndNewsLogDocument = gql`
    query getBroadcastLogAndNewsLog($studentId: uuid!, $offset: Int, $limit: Int) {
  broadcast_logs(
    limit: $limit
    offset: $offset
    order_by: {broadcast: {createdAt: desc}}
    where: {recipientId: {_eq: $studentId}, broadcast: {status: {_neq: "deleted"}, via: {_contains: "notification"}}}
  ) {
    emailResponse
    emailStatus
    id
    notificationResponse
    notificationStatus
    smsResponse
    smsStatus
    status
    createdAt
    broadcast {
      ...broadcastsFragment
    }
  }
  news_logs(
    limit: $limit
    offset: $offset
    order_by: {createdAt: desc}
    where: {recipientId: {_eq: $studentId}, hasNewfeed: {_eq: true}, news: {status: {_neq: "deleted"}}}
  ) {
    news {
      ...newsFragment
    }
  }
}
    ${BroadcastsFragmentFragmentDoc}
${NewsFragmentFragmentDoc}`;

/**
 * __useGetBroadcastLogAndNewsLogQuery__
 *
 * To run a query within a React component, call `useGetBroadcastLogAndNewsLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBroadcastLogAndNewsLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBroadcastLogAndNewsLogQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetBroadcastLogAndNewsLogQuery(baseOptions: Apollo.QueryHookOptions<GetBroadcastLogAndNewsLogQuery, GetBroadcastLogAndNewsLogQueryVariables>) {
        return Apollo.useQuery<GetBroadcastLogAndNewsLogQuery, GetBroadcastLogAndNewsLogQueryVariables>(GetBroadcastLogAndNewsLogDocument, baseOptions);
      }
export function useGetBroadcastLogAndNewsLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBroadcastLogAndNewsLogQuery, GetBroadcastLogAndNewsLogQueryVariables>) {
          return Apollo.useLazyQuery<GetBroadcastLogAndNewsLogQuery, GetBroadcastLogAndNewsLogQueryVariables>(GetBroadcastLogAndNewsLogDocument, baseOptions);
        }
export type GetBroadcastLogAndNewsLogQueryHookResult = ReturnType<typeof useGetBroadcastLogAndNewsLogQuery>;
export type GetBroadcastLogAndNewsLogLazyQueryHookResult = ReturnType<typeof useGetBroadcastLogAndNewsLogLazyQuery>;
export type GetBroadcastLogAndNewsLogQueryResult = Apollo.QueryResult<GetBroadcastLogAndNewsLogQuery, GetBroadcastLogAndNewsLogQueryVariables>;
export const Create_NewsDocument = gql`
    mutation CREATE_NEWS($objects: [news_insert_input!]! = {}) {
  insert_news(objects: $objects) {
    returning {
      ...newsFragment
    }
  }
}
    ${NewsFragmentFragmentDoc}`;
export type Create_NewsMutationFn = Apollo.MutationFunction<Create_NewsMutation, Create_NewsMutationVariables>;

/**
 * __useCreate_NewsMutation__
 *
 * To run a mutation, you first call `useCreate_NewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreate_NewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewsMutation, { data, loading, error }] = useCreate_NewsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useCreate_NewsMutation(baseOptions?: Apollo.MutationHookOptions<Create_NewsMutation, Create_NewsMutationVariables>) {
        return Apollo.useMutation<Create_NewsMutation, Create_NewsMutationVariables>(Create_NewsDocument, baseOptions);
      }
export type Create_NewsMutationHookResult = ReturnType<typeof useCreate_NewsMutation>;
export type Create_NewsMutationResult = Apollo.MutationResult<Create_NewsMutation>;
export type Create_NewsMutationOptions = Apollo.BaseMutationOptions<Create_NewsMutation, Create_NewsMutationVariables>;
export const Update_NewsDocument = gql`
    mutation UPDATE_NEWS($_eq: uuid = "", $_set: news_set_input = {}) {
  update_news(where: {id: {_eq: $_eq}}, _set: $_set) {
    returning {
      ...newsFragment
    }
  }
}
    ${NewsFragmentFragmentDoc}`;
export type Update_NewsMutationFn = Apollo.MutationFunction<Update_NewsMutation, Update_NewsMutationVariables>;

/**
 * __useUpdate_NewsMutation__
 *
 * To run a mutation, you first call `useUpdate_NewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_NewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewsMutation, { data, loading, error }] = useUpdate_NewsMutation({
 *   variables: {
 *      _eq: // value for '_eq'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdate_NewsMutation(baseOptions?: Apollo.MutationHookOptions<Update_NewsMutation, Update_NewsMutationVariables>) {
        return Apollo.useMutation<Update_NewsMutation, Update_NewsMutationVariables>(Update_NewsDocument, baseOptions);
      }
export type Update_NewsMutationHookResult = ReturnType<typeof useUpdate_NewsMutation>;
export type Update_NewsMutationResult = Apollo.MutationResult<Update_NewsMutation>;
export type Update_NewsMutationOptions = Apollo.BaseMutationOptions<Update_NewsMutation, Update_NewsMutationVariables>;
export const SentNewsDocument = gql`
    mutation sentNews($id: String!, $isResend: Boolean, $recipients: [String]) {
  sentNews(form: {newsId: $id, isResend: $isResend, recipientIds: $recipients})
}
    `;
export type SentNewsMutationFn = Apollo.MutationFunction<SentNewsMutation, SentNewsMutationVariables>;

/**
 * __useSentNewsMutation__
 *
 * To run a mutation, you first call `useSentNewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSentNewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sentNewsMutation, { data, loading, error }] = useSentNewsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isResend: // value for 'isResend'
 *      recipients: // value for 'recipients'
 *   },
 * });
 */
export function useSentNewsMutation(baseOptions?: Apollo.MutationHookOptions<SentNewsMutation, SentNewsMutationVariables>) {
        return Apollo.useMutation<SentNewsMutation, SentNewsMutationVariables>(SentNewsDocument, baseOptions);
      }
export type SentNewsMutationHookResult = ReturnType<typeof useSentNewsMutation>;
export type SentNewsMutationResult = Apollo.MutationResult<SentNewsMutation>;
export type SentNewsMutationOptions = Apollo.BaseMutationOptions<SentNewsMutation, SentNewsMutationVariables>;
export const UpdateBroadcastLogsDocument = gql`
    mutation updateBroadcastLogs($where: broadcast_logs_bool_exp!) {
  update_broadcast_logs(where: $where, _set: {isViewed: true}) {
    returning {
      isViewed
      status
    }
  }
}
    `;
export type UpdateBroadcastLogsMutationFn = Apollo.MutationFunction<UpdateBroadcastLogsMutation, UpdateBroadcastLogsMutationVariables>;

/**
 * __useUpdateBroadcastLogsMutation__
 *
 * To run a mutation, you first call `useUpdateBroadcastLogsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBroadcastLogsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBroadcastLogsMutation, { data, loading, error }] = useUpdateBroadcastLogsMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateBroadcastLogsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBroadcastLogsMutation, UpdateBroadcastLogsMutationVariables>) {
        return Apollo.useMutation<UpdateBroadcastLogsMutation, UpdateBroadcastLogsMutationVariables>(UpdateBroadcastLogsDocument, baseOptions);
      }
export type UpdateBroadcastLogsMutationHookResult = ReturnType<typeof useUpdateBroadcastLogsMutation>;
export type UpdateBroadcastLogsMutationResult = Apollo.MutationResult<UpdateBroadcastLogsMutation>;
export type UpdateBroadcastLogsMutationOptions = Apollo.BaseMutationOptions<UpdateBroadcastLogsMutation, UpdateBroadcastLogsMutationVariables>;
export const UpdateNewsLogsDocument = gql`
    mutation updateNewsLogs($where: news_logs_bool_exp!) {
  update_news_logs(where: $where, _set: {isViewed: true}) {
    returning {
      isViewed
      status
    }
  }
}
    `;
export type UpdateNewsLogsMutationFn = Apollo.MutationFunction<UpdateNewsLogsMutation, UpdateNewsLogsMutationVariables>;

/**
 * __useUpdateNewsLogsMutation__
 *
 * To run a mutation, you first call `useUpdateNewsLogsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNewsLogsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewsLogsMutation, { data, loading, error }] = useUpdateNewsLogsMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateNewsLogsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNewsLogsMutation, UpdateNewsLogsMutationVariables>) {
        return Apollo.useMutation<UpdateNewsLogsMutation, UpdateNewsLogsMutationVariables>(UpdateNewsLogsDocument, baseOptions);
      }
export type UpdateNewsLogsMutationHookResult = ReturnType<typeof useUpdateNewsLogsMutation>;
export type UpdateNewsLogsMutationResult = Apollo.MutationResult<UpdateNewsLogsMutation>;
export type UpdateNewsLogsMutationOptions = Apollo.BaseMutationOptions<UpdateNewsLogsMutation, UpdateNewsLogsMutationVariables>;
export const OnBroadcastAddedDocument = gql`
    subscription OnBroadcastAdded($id: uuid!) {
  broadcast_logs_aggregate(
    where: {recipientId: {_eq: $id}, notificationResponse: {_is_null: false}, isViewed: {_eq: false}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useOnBroadcastAddedSubscription__
 *
 * To run a query within a React component, call `useOnBroadcastAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnBroadcastAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnBroadcastAddedSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnBroadcastAddedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnBroadcastAddedSubscription, OnBroadcastAddedSubscriptionVariables>) {
        return Apollo.useSubscription<OnBroadcastAddedSubscription, OnBroadcastAddedSubscriptionVariables>(OnBroadcastAddedDocument, baseOptions);
      }
export type OnBroadcastAddedSubscriptionHookResult = ReturnType<typeof useOnBroadcastAddedSubscription>;
export type OnBroadcastAddedSubscriptionResult = Apollo.SubscriptionResult<OnBroadcastAddedSubscription>;
export const OnNewsAddedDocument = gql`
    subscription OnNewsAdded($id: uuid!) {
  news_logs_aggregate(
    where: {recipientId: {_eq: $id}, isViewed: {_eq: false}, hasNewfeed: {_eq: true}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useOnNewsAddedSubscription__
 *
 * To run a query within a React component, call `useOnNewsAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnNewsAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnNewsAddedSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnNewsAddedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnNewsAddedSubscription, OnNewsAddedSubscriptionVariables>) {
        return Apollo.useSubscription<OnNewsAddedSubscription, OnNewsAddedSubscriptionVariables>(OnNewsAddedDocument, baseOptions);
      }
export type OnNewsAddedSubscriptionHookResult = ReturnType<typeof useOnNewsAddedSubscription>;
export type OnNewsAddedSubscriptionResult = Apollo.SubscriptionResult<OnNewsAddedSubscription>;
export const GetSuspensionListDocument = gql`
    query getSuspensionList($args: credit_note_filter_args!, $offset: Int!, $limit: Int!, $where: credit_notes_bool_exp) {
  credit_note_filter(
    args: $args
    limit: $limit
    offset: $offset
    where: $where
    order_by: {createdAt: desc}
  ) {
    ...CreditNoteFragment
  }
  credit_note_filter_aggregate(args: $args, where: $where) {
    aggregate {
      count
    }
  }
}
    ${CreditNoteFragmentFragmentDoc}`;

/**
 * __useGetSuspensionListQuery__
 *
 * To run a query within a React component, call `useGetSuspensionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuspensionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuspensionListQuery({
 *   variables: {
 *      args: // value for 'args'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetSuspensionListQuery(baseOptions: Apollo.QueryHookOptions<GetSuspensionListQuery, GetSuspensionListQueryVariables>) {
        return Apollo.useQuery<GetSuspensionListQuery, GetSuspensionListQueryVariables>(GetSuspensionListDocument, baseOptions);
      }
export function useGetSuspensionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuspensionListQuery, GetSuspensionListQueryVariables>) {
          return Apollo.useLazyQuery<GetSuspensionListQuery, GetSuspensionListQueryVariables>(GetSuspensionListDocument, baseOptions);
        }
export type GetSuspensionListQueryHookResult = ReturnType<typeof useGetSuspensionListQuery>;
export type GetSuspensionListLazyQueryHookResult = ReturnType<typeof useGetSuspensionListLazyQuery>;
export type GetSuspensionListQueryResult = Apollo.QueryResult<GetSuspensionListQuery, GetSuspensionListQueryVariables>;
export const FilterCreditNoteDocument = gql`
    query filterCreditNote($filter: credit_notes_bool_exp) {
  credit_notes(where: $filter) {
    ...CreditNoteFragment
  }
}
    ${CreditNoteFragmentFragmentDoc}`;

/**
 * __useFilterCreditNoteQuery__
 *
 * To run a query within a React component, call `useFilterCreditNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterCreditNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterCreditNoteQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFilterCreditNoteQuery(baseOptions?: Apollo.QueryHookOptions<FilterCreditNoteQuery, FilterCreditNoteQueryVariables>) {
        return Apollo.useQuery<FilterCreditNoteQuery, FilterCreditNoteQueryVariables>(FilterCreditNoteDocument, baseOptions);
      }
export function useFilterCreditNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterCreditNoteQuery, FilterCreditNoteQueryVariables>) {
          return Apollo.useLazyQuery<FilterCreditNoteQuery, FilterCreditNoteQueryVariables>(FilterCreditNoteDocument, baseOptions);
        }
export type FilterCreditNoteQueryHookResult = ReturnType<typeof useFilterCreditNoteQuery>;
export type FilterCreditNoteLazyQueryHookResult = ReturnType<typeof useFilterCreditNoteLazyQuery>;
export type FilterCreditNoteQueryResult = Apollo.QueryResult<FilterCreditNoteQuery, FilterCreditNoteQueryVariables>;
export const CreateCreditNoteDocument = gql`
    mutation createCreditNote($form: FormCreateCreditNote!) {
  createCreditNote(form: $form)
}
    `;
export type CreateCreditNoteMutationFn = Apollo.MutationFunction<CreateCreditNoteMutation, CreateCreditNoteMutationVariables>;

/**
 * __useCreateCreditNoteMutation__
 *
 * To run a mutation, you first call `useCreateCreditNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreditNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreditNoteMutation, { data, loading, error }] = useCreateCreditNoteMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useCreateCreditNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateCreditNoteMutation, CreateCreditNoteMutationVariables>) {
        return Apollo.useMutation<CreateCreditNoteMutation, CreateCreditNoteMutationVariables>(CreateCreditNoteDocument, baseOptions);
      }
export type CreateCreditNoteMutationHookResult = ReturnType<typeof useCreateCreditNoteMutation>;
export type CreateCreditNoteMutationResult = Apollo.MutationResult<CreateCreditNoteMutation>;
export type CreateCreditNoteMutationOptions = Apollo.BaseMutationOptions<CreateCreditNoteMutation, CreateCreditNoteMutationVariables>;
export const GetClassInformationForCreditNoteDocument = gql`
    query getClassInformationForCreditNote($form: FormGetClassInformationForCreditNote!) {
  getClassInformationForCreditNote(form: $form) {
    id
    name
    terms {
      id
      lessons
      name
      total
      pricing
      lessonIds
    }
  }
}
    `;

/**
 * __useGetClassInformationForCreditNoteQuery__
 *
 * To run a query within a React component, call `useGetClassInformationForCreditNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassInformationForCreditNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassInformationForCreditNoteQuery({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useGetClassInformationForCreditNoteQuery(baseOptions: Apollo.QueryHookOptions<GetClassInformationForCreditNoteQuery, GetClassInformationForCreditNoteQueryVariables>) {
        return Apollo.useQuery<GetClassInformationForCreditNoteQuery, GetClassInformationForCreditNoteQueryVariables>(GetClassInformationForCreditNoteDocument, baseOptions);
      }
export function useGetClassInformationForCreditNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassInformationForCreditNoteQuery, GetClassInformationForCreditNoteQueryVariables>) {
          return Apollo.useLazyQuery<GetClassInformationForCreditNoteQuery, GetClassInformationForCreditNoteQueryVariables>(GetClassInformationForCreditNoteDocument, baseOptions);
        }
export type GetClassInformationForCreditNoteQueryHookResult = ReturnType<typeof useGetClassInformationForCreditNoteQuery>;
export type GetClassInformationForCreditNoteLazyQueryHookResult = ReturnType<typeof useGetClassInformationForCreditNoteLazyQuery>;
export type GetClassInformationForCreditNoteQueryResult = Apollo.QueryResult<GetClassInformationForCreditNoteQuery, GetClassInformationForCreditNoteQueryVariables>;
export const UpdateCreditNoteDocument = gql`
    mutation updateCreditNote($form: FormUpdateCreditNote!, $id: String!) {
  updateCreditNote(form: $form, id: $id)
}
    `;
export type UpdateCreditNoteMutationFn = Apollo.MutationFunction<UpdateCreditNoteMutation, UpdateCreditNoteMutationVariables>;

/**
 * __useUpdateCreditNoteMutation__
 *
 * To run a mutation, you first call `useUpdateCreditNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreditNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreditNoteMutation, { data, loading, error }] = useUpdateCreditNoteMutation({
 *   variables: {
 *      form: // value for 'form'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateCreditNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreditNoteMutation, UpdateCreditNoteMutationVariables>) {
        return Apollo.useMutation<UpdateCreditNoteMutation, UpdateCreditNoteMutationVariables>(UpdateCreditNoteDocument, baseOptions);
      }
export type UpdateCreditNoteMutationHookResult = ReturnType<typeof useUpdateCreditNoteMutation>;
export type UpdateCreditNoteMutationResult = Apollo.MutationResult<UpdateCreditNoteMutation>;
export type UpdateCreditNoteMutationOptions = Apollo.BaseMutationOptions<UpdateCreditNoteMutation, UpdateCreditNoteMutationVariables>;
export const UpdateCreditNotesDocument = gql`
    mutation updateCreditNotes($_set: credit_notes_set_input!, $where: credit_notes_bool_exp!) {
  update_credit_notes(where: $where, _set: $_set) {
    affected_rows
  }
}
    `;
export type UpdateCreditNotesMutationFn = Apollo.MutationFunction<UpdateCreditNotesMutation, UpdateCreditNotesMutationVariables>;

/**
 * __useUpdateCreditNotesMutation__
 *
 * To run a mutation, you first call `useUpdateCreditNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreditNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreditNotesMutation, { data, loading, error }] = useUpdateCreditNotesMutation({
 *   variables: {
 *      _set: // value for '_set'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateCreditNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreditNotesMutation, UpdateCreditNotesMutationVariables>) {
        return Apollo.useMutation<UpdateCreditNotesMutation, UpdateCreditNotesMutationVariables>(UpdateCreditNotesDocument, baseOptions);
      }
export type UpdateCreditNotesMutationHookResult = ReturnType<typeof useUpdateCreditNotesMutation>;
export type UpdateCreditNotesMutationResult = Apollo.MutationResult<UpdateCreditNotesMutation>;
export type UpdateCreditNotesMutationOptions = Apollo.BaseMutationOptions<UpdateCreditNotesMutation, UpdateCreditNotesMutationVariables>;
export const ChangeCreditNoteStatusDocument = gql`
    mutation changeCreditNoteStatus($form: FormChangeCreditNoteStatus!, $id: String!) {
  changeCreditNoteStatus(form: $form, id: $id)
}
    `;
export type ChangeCreditNoteStatusMutationFn = Apollo.MutationFunction<ChangeCreditNoteStatusMutation, ChangeCreditNoteStatusMutationVariables>;

/**
 * __useChangeCreditNoteStatusMutation__
 *
 * To run a mutation, you first call `useChangeCreditNoteStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCreditNoteStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCreditNoteStatusMutation, { data, loading, error }] = useChangeCreditNoteStatusMutation({
 *   variables: {
 *      form: // value for 'form'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChangeCreditNoteStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeCreditNoteStatusMutation, ChangeCreditNoteStatusMutationVariables>) {
        return Apollo.useMutation<ChangeCreditNoteStatusMutation, ChangeCreditNoteStatusMutationVariables>(ChangeCreditNoteStatusDocument, baseOptions);
      }
export type ChangeCreditNoteStatusMutationHookResult = ReturnType<typeof useChangeCreditNoteStatusMutation>;
export type ChangeCreditNoteStatusMutationResult = Apollo.MutationResult<ChangeCreditNoteStatusMutation>;
export type ChangeCreditNoteStatusMutationOptions = Apollo.BaseMutationOptions<ChangeCreditNoteStatusMutation, ChangeCreditNoteStatusMutationVariables>;
export const GetCreditNotesDocument = gql`
    query getCreditNotes($where: credit_notes_bool_exp) {
  credit_notes(where: $where) {
    studentId
    student {
      id
      fullName
      email
      phoneNumber
      username
    }
    type
    name
    reason
    remarks
    creditNoteStatus
    creditNoteClassId
    creditNoteFeeId
    createdAt
    createdBy
    id
    link
    creditNoteClass {
      endDate
      startDate
      lessonIds
      termName
      termId
      id
      classId
      term {
        endDate
        startDate
      }
      class {
        name
        id
        program {
          id
          name
          curriculums {
            id
            abbreviation
          }
          subject {
            id
            name
          }
          levels {
            id
            abbreviation
          }
        }
        lessons_aggregate {
          aggregate {
            count
          }
        }
      }
    }
    creditNoteFee {
      receipt {
        id
        name
        invoice {
          id
          paymentAdviceId
          total
          pa {
            id
            paymentSummaryStatic
          }
        }
      }
      receiptId
      id
      overpaidAmount
      numberOfLesson
      unitPriceOfClass
    }
    summary
    creditNoteStatus
    remarks
    updatedBy
    updatedAt
  }
}
    `;

/**
 * __useGetCreditNotesQuery__
 *
 * To run a query within a React component, call `useGetCreditNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditNotesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetCreditNotesQuery(baseOptions?: Apollo.QueryHookOptions<GetCreditNotesQuery, GetCreditNotesQueryVariables>) {
        return Apollo.useQuery<GetCreditNotesQuery, GetCreditNotesQueryVariables>(GetCreditNotesDocument, baseOptions);
      }
export function useGetCreditNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditNotesQuery, GetCreditNotesQueryVariables>) {
          return Apollo.useLazyQuery<GetCreditNotesQuery, GetCreditNotesQueryVariables>(GetCreditNotesDocument, baseOptions);
        }
export type GetCreditNotesQueryHookResult = ReturnType<typeof useGetCreditNotesQuery>;
export type GetCreditNotesLazyQueryHookResult = ReturnType<typeof useGetCreditNotesLazyQuery>;
export type GetCreditNotesQueryResult = Apollo.QueryResult<GetCreditNotesQuery, GetCreditNotesQueryVariables>;
export const GetApproveByDocument = gql`
    query getApproveBY($where: users_bool_exp!) {
  users(where: $where) {
    id
    fullName
  }
}
    `;

/**
 * __useGetApproveByQuery__
 *
 * To run a query within a React component, call `useGetApproveByQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApproveByQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApproveByQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetApproveByQuery(baseOptions: Apollo.QueryHookOptions<GetApproveByQuery, GetApproveByQueryVariables>) {
        return Apollo.useQuery<GetApproveByQuery, GetApproveByQueryVariables>(GetApproveByDocument, baseOptions);
      }
export function useGetApproveByLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApproveByQuery, GetApproveByQueryVariables>) {
          return Apollo.useLazyQuery<GetApproveByQuery, GetApproveByQueryVariables>(GetApproveByDocument, baseOptions);
        }
export type GetApproveByQueryHookResult = ReturnType<typeof useGetApproveByQuery>;
export type GetApproveByLazyQueryHookResult = ReturnType<typeof useGetApproveByLazyQuery>;
export type GetApproveByQueryResult = Apollo.QueryResult<GetApproveByQuery, GetApproveByQueryVariables>;
export const DuplicateCreditNoteDocument = gql`
    mutation duplicateCreditNote($creditNoteId: String!) {
  duplicateCreditNote(creditNoteId: $creditNoteId)
}
    `;
export type DuplicateCreditNoteMutationFn = Apollo.MutationFunction<DuplicateCreditNoteMutation, DuplicateCreditNoteMutationVariables>;

/**
 * __useDuplicateCreditNoteMutation__
 *
 * To run a mutation, you first call `useDuplicateCreditNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateCreditNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateCreditNoteMutation, { data, loading, error }] = useDuplicateCreditNoteMutation({
 *   variables: {
 *      creditNoteId: // value for 'creditNoteId'
 *   },
 * });
 */
export function useDuplicateCreditNoteMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateCreditNoteMutation, DuplicateCreditNoteMutationVariables>) {
        return Apollo.useMutation<DuplicateCreditNoteMutation, DuplicateCreditNoteMutationVariables>(DuplicateCreditNoteDocument, baseOptions);
      }
export type DuplicateCreditNoteMutationHookResult = ReturnType<typeof useDuplicateCreditNoteMutation>;
export type DuplicateCreditNoteMutationResult = Apollo.MutationResult<DuplicateCreditNoteMutation>;
export type DuplicateCreditNoteMutationOptions = Apollo.BaseMutationOptions<DuplicateCreditNoteMutation, DuplicateCreditNoteMutationVariables>;
export const GetDiscountsDocument = gql`
    query getDiscounts($filter: discounts_bool_exp) {
  discounts(where: $filter, order_by: {order: asc}) {
    ...discountModel
  }
}
    ${DiscountModelFragmentDoc}`;

/**
 * __useGetDiscountsQuery__
 *
 * To run a query within a React component, call `useGetDiscountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetDiscountsQuery(baseOptions?: Apollo.QueryHookOptions<GetDiscountsQuery, GetDiscountsQueryVariables>) {
        return Apollo.useQuery<GetDiscountsQuery, GetDiscountsQueryVariables>(GetDiscountsDocument, baseOptions);
      }
export function useGetDiscountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscountsQuery, GetDiscountsQueryVariables>) {
          return Apollo.useLazyQuery<GetDiscountsQuery, GetDiscountsQueryVariables>(GetDiscountsDocument, baseOptions);
        }
export type GetDiscountsQueryHookResult = ReturnType<typeof useGetDiscountsQuery>;
export type GetDiscountsLazyQueryHookResult = ReturnType<typeof useGetDiscountsLazyQuery>;
export type GetDiscountsQueryResult = Apollo.QueryResult<GetDiscountsQuery, GetDiscountsQueryVariables>;
export const UpdatePeriodDiscountDocument = gql`
    mutation updatePeriodDiscount($id: uuid!, $metadata: jsonb!) {
  update_discounts(where: {id: {_eq: $id}}, _set: {metadata: $metadata}) {
    returning {
      ...discountModel
    }
  }
}
    ${DiscountModelFragmentDoc}`;
export type UpdatePeriodDiscountMutationFn = Apollo.MutationFunction<UpdatePeriodDiscountMutation, UpdatePeriodDiscountMutationVariables>;

/**
 * __useUpdatePeriodDiscountMutation__
 *
 * To run a mutation, you first call `useUpdatePeriodDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePeriodDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePeriodDiscountMutation, { data, loading, error }] = useUpdatePeriodDiscountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useUpdatePeriodDiscountMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePeriodDiscountMutation, UpdatePeriodDiscountMutationVariables>) {
        return Apollo.useMutation<UpdatePeriodDiscountMutation, UpdatePeriodDiscountMutationVariables>(UpdatePeriodDiscountDocument, baseOptions);
      }
export type UpdatePeriodDiscountMutationHookResult = ReturnType<typeof useUpdatePeriodDiscountMutation>;
export type UpdatePeriodDiscountMutationResult = Apollo.MutationResult<UpdatePeriodDiscountMutation>;
export type UpdatePeriodDiscountMutationOptions = Apollo.BaseMutationOptions<UpdatePeriodDiscountMutation, UpdatePeriodDiscountMutationVariables>;
export const GetRegularProgrammePricingsDocument = gql`
    query getRegularProgrammePricings($offset: Int, $limit: Int, $filters: regular_programme_pricings_bool_exp) {
  regular_programme_pricings(
    limit: $limit
    offset: $offset
    where: $filters
    order_by: {curriculum: {abbreviation: asc}, regular_program_type: {fullName: asc}, createdAt: asc}
  ) {
    id
    curriculum {
      id
      name
      abbreviation
    }
    regular_program_type {
      id
      fullName
    }
    updater {
      id
      fullName
      avatar
    }
    updatedAt
    pricePerLesson
  }
  regular_programme_pricings_aggregate(where: $filters) {
    aggregate {
      count(columns: id)
    }
  }
}
    `;

/**
 * __useGetRegularProgrammePricingsQuery__
 *
 * To run a query within a React component, call `useGetRegularProgrammePricingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegularProgrammePricingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegularProgrammePricingsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetRegularProgrammePricingsQuery(baseOptions?: Apollo.QueryHookOptions<GetRegularProgrammePricingsQuery, GetRegularProgrammePricingsQueryVariables>) {
        return Apollo.useQuery<GetRegularProgrammePricingsQuery, GetRegularProgrammePricingsQueryVariables>(GetRegularProgrammePricingsDocument, baseOptions);
      }
export function useGetRegularProgrammePricingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegularProgrammePricingsQuery, GetRegularProgrammePricingsQueryVariables>) {
          return Apollo.useLazyQuery<GetRegularProgrammePricingsQuery, GetRegularProgrammePricingsQueryVariables>(GetRegularProgrammePricingsDocument, baseOptions);
        }
export type GetRegularProgrammePricingsQueryHookResult = ReturnType<typeof useGetRegularProgrammePricingsQuery>;
export type GetRegularProgrammePricingsLazyQueryHookResult = ReturnType<typeof useGetRegularProgrammePricingsLazyQuery>;
export type GetRegularProgrammePricingsQueryResult = Apollo.QueryResult<GetRegularProgrammePricingsQuery, GetRegularProgrammePricingsQueryVariables>;
export const GetSpecialProgrammeClassPricingsDocument = gql`
    query getSpecialProgrammeClassPricings($offset: Int, $limit: Int, $filters: special_programme_class_pricings_bool_exp) {
  special_programme_class_pricings(
    limit: $limit
    offset: $offset
    where: $filters
    order_by: {class: {programTypeSpecial: {fullName: asc}, name: asc}, createdAt: asc}
  ) {
    class {
      id
      name
      programTypeSpecial {
        id
        fullName
      }
    }
    pricePerStudent
    id
    studentType
    updatedAt
    updater {
      id
      fullName
      avatar
    }
  }
  special_programme_class_pricings_aggregate(where: $filters) {
    aggregate {
      count(columns: id)
    }
  }
}
    `;

/**
 * __useGetSpecialProgrammeClassPricingsQuery__
 *
 * To run a query within a React component, call `useGetSpecialProgrammeClassPricingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecialProgrammeClassPricingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecialProgrammeClassPricingsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetSpecialProgrammeClassPricingsQuery(baseOptions?: Apollo.QueryHookOptions<GetSpecialProgrammeClassPricingsQuery, GetSpecialProgrammeClassPricingsQueryVariables>) {
        return Apollo.useQuery<GetSpecialProgrammeClassPricingsQuery, GetSpecialProgrammeClassPricingsQueryVariables>(GetSpecialProgrammeClassPricingsDocument, baseOptions);
      }
export function useGetSpecialProgrammeClassPricingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpecialProgrammeClassPricingsQuery, GetSpecialProgrammeClassPricingsQueryVariables>) {
          return Apollo.useLazyQuery<GetSpecialProgrammeClassPricingsQuery, GetSpecialProgrammeClassPricingsQueryVariables>(GetSpecialProgrammeClassPricingsDocument, baseOptions);
        }
export type GetSpecialProgrammeClassPricingsQueryHookResult = ReturnType<typeof useGetSpecialProgrammeClassPricingsQuery>;
export type GetSpecialProgrammeClassPricingsLazyQueryHookResult = ReturnType<typeof useGetSpecialProgrammeClassPricingsLazyQuery>;
export type GetSpecialProgrammeClassPricingsQueryResult = Apollo.QueryResult<GetSpecialProgrammeClassPricingsQuery, GetSpecialProgrammeClassPricingsQueryVariables>;
export const GetDetailInvoicePaperDocument = gql`
    query getDetailInvoicePaper($id: String!) {
  getDetailInvoice(id: $id) {
    branch {
      ...MasterDataAtPaymentAdviceFragment
    }
    transferBill {
      ...TransferBillFragment
    }
    classInformation {
      total
      data {
        subject
        classType
        curriculums
        levels
        additionalLesson {
          pricing
          quantity
          total
        }
        firstSession {
          startTime
          endTime
        }
        branch
        id
        name
        period {
          endDate
          startDate
        }
        terms {
          academicYear
          endDate
          lessons
          pricing
          startDate
          name
        }
        discounts {
          amount
          code
          id
          name
          unit
        }
        additionalDiscount
        total
        totalDiscount
      }
    }
    deduction {
      ...OutFeeFragment
    }
    dueDate
    id
    isRegistrationFee
    issueDate
    name
    notes
    link
    otherPayments {
      ...OutFeeFragment
    }
    deposit {
      ...OutFeeFragment
    }
    paymentStatus
    student {
      ...StudentModelFragment
    }
    summary {
      ...SummaryFragment
    }
    remarks
  }
}
    ${MasterDataAtPaymentAdviceFragmentFragmentDoc}
${TransferBillFragmentFragmentDoc}
${OutFeeFragmentFragmentDoc}
${StudentModelFragmentFragmentDoc}
${SummaryFragmentFragmentDoc}`;

/**
 * __useGetDetailInvoicePaperQuery__
 *
 * To run a query within a React component, call `useGetDetailInvoicePaperQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailInvoicePaperQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailInvoicePaperQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDetailInvoicePaperQuery(baseOptions: Apollo.QueryHookOptions<GetDetailInvoicePaperQuery, GetDetailInvoicePaperQueryVariables>) {
        return Apollo.useQuery<GetDetailInvoicePaperQuery, GetDetailInvoicePaperQueryVariables>(GetDetailInvoicePaperDocument, baseOptions);
      }
export function useGetDetailInvoicePaperLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDetailInvoicePaperQuery, GetDetailInvoicePaperQueryVariables>) {
          return Apollo.useLazyQuery<GetDetailInvoicePaperQuery, GetDetailInvoicePaperQueryVariables>(GetDetailInvoicePaperDocument, baseOptions);
        }
export type GetDetailInvoicePaperQueryHookResult = ReturnType<typeof useGetDetailInvoicePaperQuery>;
export type GetDetailInvoicePaperLazyQueryHookResult = ReturnType<typeof useGetDetailInvoicePaperLazyQuery>;
export type GetDetailInvoicePaperQueryResult = Apollo.QueryResult<GetDetailInvoicePaperQuery, GetDetailInvoicePaperQueryVariables>;
export const BranchesListDocument = gql`
    query branchesList($search: String!, $offset: Int, $limit: Int, $order: order_by!) {
  branches(
    where: {name: {_ilike: $search}}
    limit: $limit
    offset: $offset
    order_by: {name: $order}
  ) {
    classrooms_aggregate {
      aggregate {
        count
      }
    }
    abbreviation
    address
    city
    country
    createdAt
    createdBy
    id
    name
    postalCode
    status
    updatedAt
    updatedBy
  }
  branches_aggregate(where: {name: {_ilike: $search}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useBranchesListQuery__
 *
 * To run a query within a React component, call `useBranchesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBranchesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBranchesListQuery({
 *   variables: {
 *      search: // value for 'search'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useBranchesListQuery(baseOptions: Apollo.QueryHookOptions<BranchesListQuery, BranchesListQueryVariables>) {
        return Apollo.useQuery<BranchesListQuery, BranchesListQueryVariables>(BranchesListDocument, baseOptions);
      }
export function useBranchesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BranchesListQuery, BranchesListQueryVariables>) {
          return Apollo.useLazyQuery<BranchesListQuery, BranchesListQueryVariables>(BranchesListDocument, baseOptions);
        }
export type BranchesListQueryHookResult = ReturnType<typeof useBranchesListQuery>;
export type BranchesListLazyQueryHookResult = ReturnType<typeof useBranchesListLazyQuery>;
export type BranchesListQueryResult = Apollo.QueryResult<BranchesListQuery, BranchesListQueryVariables>;
export const FirstBranchDocument = gql`
    query firstBranch {
  branches(offset: 0, limit: 1) {
    classrooms_aggregate {
      aggregate {
        count
      }
    }
    abbreviation
    address
    city
    country
    createdAt
    createdBy
    id
    name
    postalCode
    status
    updatedAt
    updatedBy
  }
}
    `;

/**
 * __useFirstBranchQuery__
 *
 * To run a query within a React component, call `useFirstBranchQuery` and pass it any options that fit your needs.
 * When your component renders, `useFirstBranchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFirstBranchQuery({
 *   variables: {
 *   },
 * });
 */
export function useFirstBranchQuery(baseOptions?: Apollo.QueryHookOptions<FirstBranchQuery, FirstBranchQueryVariables>) {
        return Apollo.useQuery<FirstBranchQuery, FirstBranchQueryVariables>(FirstBranchDocument, baseOptions);
      }
export function useFirstBranchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FirstBranchQuery, FirstBranchQueryVariables>) {
          return Apollo.useLazyQuery<FirstBranchQuery, FirstBranchQueryVariables>(FirstBranchDocument, baseOptions);
        }
export type FirstBranchQueryHookResult = ReturnType<typeof useFirstBranchQuery>;
export type FirstBranchLazyQueryHookResult = ReturnType<typeof useFirstBranchLazyQuery>;
export type FirstBranchQueryResult = Apollo.QueryResult<FirstBranchQuery, FirstBranchQueryVariables>;
export const GetAllBranchesDocument = gql`
    query getAllBranches($filter: branches_bool_exp) {
  branches(where: $filter) {
    classrooms_aggregate {
      aggregate {
        count
      }
    }
    abbreviation
    address
    city
    country
    createdAt
    createdBy
    id
    name
    postalCode
    status
    updatedAt
    updatedBy
  }
}
    `;

/**
 * __useGetAllBranchesQuery__
 *
 * To run a query within a React component, call `useGetAllBranchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBranchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBranchesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAllBranchesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllBranchesQuery, GetAllBranchesQueryVariables>) {
        return Apollo.useQuery<GetAllBranchesQuery, GetAllBranchesQueryVariables>(GetAllBranchesDocument, baseOptions);
      }
export function useGetAllBranchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllBranchesQuery, GetAllBranchesQueryVariables>) {
          return Apollo.useLazyQuery<GetAllBranchesQuery, GetAllBranchesQueryVariables>(GetAllBranchesDocument, baseOptions);
        }
export type GetAllBranchesQueryHookResult = ReturnType<typeof useGetAllBranchesQuery>;
export type GetAllBranchesLazyQueryHookResult = ReturnType<typeof useGetAllBranchesLazyQuery>;
export type GetAllBranchesQueryResult = Apollo.QueryResult<GetAllBranchesQuery, GetAllBranchesQueryVariables>;
export const ClassroomsListDocument = gql`
    query classroomsList($id: uuid!, $offset: Int, $limit: Int, $order: order_by!) {
  classrooms(
    limit: $limit
    offset: $offset
    order_by: {name: $order}
    where: {branchId: {_eq: $id}}
  ) {
    branchId
    capacity
    createdAt
    createdBy
    id
    name
    status
    updatedAt
    updatedBy
  }
  classrooms_aggregate(where: {branchId: {_eq: $id}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useClassroomsListQuery__
 *
 * To run a query within a React component, call `useClassroomsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassroomsListQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useClassroomsListQuery(baseOptions: Apollo.QueryHookOptions<ClassroomsListQuery, ClassroomsListQueryVariables>) {
        return Apollo.useQuery<ClassroomsListQuery, ClassroomsListQueryVariables>(ClassroomsListDocument, baseOptions);
      }
export function useClassroomsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassroomsListQuery, ClassroomsListQueryVariables>) {
          return Apollo.useLazyQuery<ClassroomsListQuery, ClassroomsListQueryVariables>(ClassroomsListDocument, baseOptions);
        }
export type ClassroomsListQueryHookResult = ReturnType<typeof useClassroomsListQuery>;
export type ClassroomsListLazyQueryHookResult = ReturnType<typeof useClassroomsListLazyQuery>;
export type ClassroomsListQueryResult = Apollo.QueryResult<ClassroomsListQuery, ClassroomsListQueryVariables>;
export const GetAllClassroomsDocument = gql`
    query getAllClassrooms($filter: classrooms_bool_exp) {
  classrooms(where: $filter) {
    branchId
    capacity
    createdAt
    createdBy
    id
    name
    status
    updatedAt
    updatedBy
  }
}
    `;

/**
 * __useGetAllClassroomsQuery__
 *
 * To run a query within a React component, call `useGetAllClassroomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllClassroomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllClassroomsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAllClassroomsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllClassroomsQuery, GetAllClassroomsQueryVariables>) {
        return Apollo.useQuery<GetAllClassroomsQuery, GetAllClassroomsQueryVariables>(GetAllClassroomsDocument, baseOptions);
      }
export function useGetAllClassroomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllClassroomsQuery, GetAllClassroomsQueryVariables>) {
          return Apollo.useLazyQuery<GetAllClassroomsQuery, GetAllClassroomsQueryVariables>(GetAllClassroomsDocument, baseOptions);
        }
export type GetAllClassroomsQueryHookResult = ReturnType<typeof useGetAllClassroomsQuery>;
export type GetAllClassroomsLazyQueryHookResult = ReturnType<typeof useGetAllClassroomsLazyQuery>;
export type GetAllClassroomsQueryResult = Apollo.QueryResult<GetAllClassroomsQuery, GetAllClassroomsQueryVariables>;
export const GetBranchByIdDocument = gql`
    query getBranchByID($id: uuid!) {
  branches(where: {id: {_eq: $id}}) {
    classrooms_aggregate {
      aggregate {
        count
      }
    }
    abbreviation
    address
    city
    country
    createdAt
    createdBy
    id
    name
    postalCode
    status
    updatedAt
    updatedBy
  }
}
    `;

/**
 * __useGetBranchByIdQuery__
 *
 * To run a query within a React component, call `useGetBranchByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBranchByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBranchByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBranchByIdQuery(baseOptions: Apollo.QueryHookOptions<GetBranchByIdQuery, GetBranchByIdQueryVariables>) {
        return Apollo.useQuery<GetBranchByIdQuery, GetBranchByIdQueryVariables>(GetBranchByIdDocument, baseOptions);
      }
export function useGetBranchByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBranchByIdQuery, GetBranchByIdQueryVariables>) {
          return Apollo.useLazyQuery<GetBranchByIdQuery, GetBranchByIdQueryVariables>(GetBranchByIdDocument, baseOptions);
        }
export type GetBranchByIdQueryHookResult = ReturnType<typeof useGetBranchByIdQuery>;
export type GetBranchByIdLazyQueryHookResult = ReturnType<typeof useGetBranchByIdLazyQuery>;
export type GetBranchByIdQueryResult = Apollo.QueryResult<GetBranchByIdQuery, GetBranchByIdQueryVariables>;
export const CurriculumsLevelsDocument = gql`
    query curriculumsLevels($filter: curriculums_levels_bool_exp = {}) {
  curriculums_levels(where: $filter) {
    curriculumId
    id
    curriculum {
      name
      id
      abbreviation
    }
    level {
      name
      id
      abbreviation
    }
  }
}
    `;

/**
 * __useCurriculumsLevelsQuery__
 *
 * To run a query within a React component, call `useCurriculumsLevelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurriculumsLevelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurriculumsLevelsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCurriculumsLevelsQuery(baseOptions?: Apollo.QueryHookOptions<CurriculumsLevelsQuery, CurriculumsLevelsQueryVariables>) {
        return Apollo.useQuery<CurriculumsLevelsQuery, CurriculumsLevelsQueryVariables>(CurriculumsLevelsDocument, baseOptions);
      }
export function useCurriculumsLevelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurriculumsLevelsQuery, CurriculumsLevelsQueryVariables>) {
          return Apollo.useLazyQuery<CurriculumsLevelsQuery, CurriculumsLevelsQueryVariables>(CurriculumsLevelsDocument, baseOptions);
        }
export type CurriculumsLevelsQueryHookResult = ReturnType<typeof useCurriculumsLevelsQuery>;
export type CurriculumsLevelsLazyQueryHookResult = ReturnType<typeof useCurriculumsLevelsLazyQuery>;
export type CurriculumsLevelsQueryResult = Apollo.QueryResult<CurriculumsLevelsQuery, CurriculumsLevelsQueryVariables>;
export const LevelsListDocument = gql`
    query levelsList {
  levels {
    id
    name
    abbreviation
    createdAt
    createdBy
    status
    updatedAt
    updatedBy
  }
}
    `;

/**
 * __useLevelsListQuery__
 *
 * To run a query within a React component, call `useLevelsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLevelsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLevelsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useLevelsListQuery(baseOptions?: Apollo.QueryHookOptions<LevelsListQuery, LevelsListQueryVariables>) {
        return Apollo.useQuery<LevelsListQuery, LevelsListQueryVariables>(LevelsListDocument, baseOptions);
      }
export function useLevelsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LevelsListQuery, LevelsListQueryVariables>) {
          return Apollo.useLazyQuery<LevelsListQuery, LevelsListQueryVariables>(LevelsListDocument, baseOptions);
        }
export type LevelsListQueryHookResult = ReturnType<typeof useLevelsListQuery>;
export type LevelsListLazyQueryHookResult = ReturnType<typeof useLevelsListLazyQuery>;
export type LevelsListQueryResult = Apollo.QueryResult<LevelsListQuery, LevelsListQueryVariables>;
export const CurriculumsListDocument = gql`
    query curriculumsList {
  curriculums {
    id
    name
    abbreviation
    createdAt
    createdBy
    status
    updatedAt
    updatedBy
  }
}
    `;

/**
 * __useCurriculumsListQuery__
 *
 * To run a query within a React component, call `useCurriculumsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurriculumsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurriculumsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurriculumsListQuery(baseOptions?: Apollo.QueryHookOptions<CurriculumsListQuery, CurriculumsListQueryVariables>) {
        return Apollo.useQuery<CurriculumsListQuery, CurriculumsListQueryVariables>(CurriculumsListDocument, baseOptions);
      }
export function useCurriculumsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurriculumsListQuery, CurriculumsListQueryVariables>) {
          return Apollo.useLazyQuery<CurriculumsListQuery, CurriculumsListQueryVariables>(CurriculumsListDocument, baseOptions);
        }
export type CurriculumsListQueryHookResult = ReturnType<typeof useCurriculumsListQuery>;
export type CurriculumsListLazyQueryHookResult = ReturnType<typeof useCurriculumsListLazyQuery>;
export type CurriculumsListQueryResult = Apollo.QueryResult<CurriculumsListQuery, CurriculumsListQueryVariables>;
export const SubjectsListDocument = gql`
    query subjectsList {
  subjects {
    abbreviation
    createdAt
    createdBy
    id
    name
    status
    updatedAt
    updatedBy
  }
}
    `;

/**
 * __useSubjectsListQuery__
 *
 * To run a query within a React component, call `useSubjectsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubjectsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubjectsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubjectsListQuery(baseOptions?: Apollo.QueryHookOptions<SubjectsListQuery, SubjectsListQueryVariables>) {
        return Apollo.useQuery<SubjectsListQuery, SubjectsListQueryVariables>(SubjectsListDocument, baseOptions);
      }
export function useSubjectsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubjectsListQuery, SubjectsListQueryVariables>) {
          return Apollo.useLazyQuery<SubjectsListQuery, SubjectsListQueryVariables>(SubjectsListDocument, baseOptions);
        }
export type SubjectsListQueryHookResult = ReturnType<typeof useSubjectsListQuery>;
export type SubjectsListLazyQueryHookResult = ReturnType<typeof useSubjectsListLazyQuery>;
export type SubjectsListQueryResult = Apollo.QueryResult<SubjectsListQuery, SubjectsListQueryVariables>;
export const FilterUserDocument = gql`
    query filterUser($filter: users_bool_exp, $order: [users_order_by!]) {
  users(where: $filter, order_by: $order) {
    id
    role
    email
    firstName
    lastName
    avatar
    isVerifiedEmail
    isVerifiedPhoneNumber
    phone
    phoneNumber
    status
    address
    username
    roleIds
    levels {
      id
      name
      abbreviation
    }
    subjects {
      id
      name
    }
    roles {
      id
      name
      role
    }
    studentProfile {
      id
      school {
        id
        name
      }
      curriculum {
        id
        name
        abbreviation
      }
      level {
        id
        name
        abbreviation
      }
    }
  }
}
    `;

/**
 * __useFilterUserQuery__
 *
 * To run a query within a React component, call `useFilterUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterUserQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useFilterUserQuery(baseOptions?: Apollo.QueryHookOptions<FilterUserQuery, FilterUserQueryVariables>) {
        return Apollo.useQuery<FilterUserQuery, FilterUserQueryVariables>(FilterUserDocument, baseOptions);
      }
export function useFilterUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterUserQuery, FilterUserQueryVariables>) {
          return Apollo.useLazyQuery<FilterUserQuery, FilterUserQueryVariables>(FilterUserDocument, baseOptions);
        }
export type FilterUserQueryHookResult = ReturnType<typeof useFilterUserQuery>;
export type FilterUserLazyQueryHookResult = ReturnType<typeof useFilterUserLazyQuery>;
export type FilterUserQueryResult = Apollo.QueryResult<FilterUserQuery, FilterUserQueryVariables>;
export const GetInfoClassesByStatusDocument = gql`
    query getInfoClassesByStatus($status: String!) {
  classes(where: {classStatus: {_eq: $status}}) {
    lessons(
      where: {_or: [{date: {_gt: "NOW()"}}, {orderPriority: {_eq: "0"}}], _and: {status: {_eq: "active"}}}
      limit: 2
      order_by: {date: asc}
    ) {
      students_aggregate(
        where: {status: {_eq: "active"}, _or: [{type: {_eq: "transferred"}}, {type: {_eq: "enrolled"}}]}
      ) {
        aggregate {
          count
        }
      }
      date
    }
    classStatus
    program {
      id
      name
    }
    programTypeGeneral {
      id
      fullName
    }
    programTypeDoubleLesson {
      id
      fullName
    }
    programTypeRegular {
      id
      fullName
    }
    programTypeSpecial {
      id
      fullName
    }
    programTypeDoubleLesson {
      fullName
      id
    }
    id
  }
}
    `;

/**
 * __useGetInfoClassesByStatusQuery__
 *
 * To run a query within a React component, call `useGetInfoClassesByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInfoClassesByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInfoClassesByStatusQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetInfoClassesByStatusQuery(baseOptions: Apollo.QueryHookOptions<GetInfoClassesByStatusQuery, GetInfoClassesByStatusQueryVariables>) {
        return Apollo.useQuery<GetInfoClassesByStatusQuery, GetInfoClassesByStatusQueryVariables>(GetInfoClassesByStatusDocument, baseOptions);
      }
export function useGetInfoClassesByStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInfoClassesByStatusQuery, GetInfoClassesByStatusQueryVariables>) {
          return Apollo.useLazyQuery<GetInfoClassesByStatusQuery, GetInfoClassesByStatusQueryVariables>(GetInfoClassesByStatusDocument, baseOptions);
        }
export type GetInfoClassesByStatusQueryHookResult = ReturnType<typeof useGetInfoClassesByStatusQuery>;
export type GetInfoClassesByStatusLazyQueryHookResult = ReturnType<typeof useGetInfoClassesByStatusLazyQuery>;
export type GetInfoClassesByStatusQueryResult = Apollo.QueryResult<GetInfoClassesByStatusQuery, GetInfoClassesByStatusQueryVariables>;
export const GetInfoClassesDocument = gql`
    query getInfoClasses {
  classes {
    lessons(
      where: {_or: [{date: {_gt: "NOW()"}}, {orderPriority: {_eq: "0"}}], _and: {status: {_eq: "active"}}}
      limit: 2
      order_by: {date: asc}
    ) {
      students_aggregate(
        where: {status: {_eq: "active"}, _or: [{type: {_eq: "transferred"}}, {type: {_eq: "enrolled"}}]}
      ) {
        aggregate {
          count
        }
      }
      date
    }
    classStatus
    program {
      id
      name
    }
    programTypeGeneral {
      id
      fullName
    }
    programTypeRegular {
      id
      fullName
    }
    programTypeSpecial {
      id
      fullName
    }
    programTypeDoubleLesson {
      fullName
      id
    }
    id
  }
}
    `;

/**
 * __useGetInfoClassesQuery__
 *
 * To run a query within a React component, call `useGetInfoClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInfoClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInfoClassesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInfoClassesQuery(baseOptions?: Apollo.QueryHookOptions<GetInfoClassesQuery, GetInfoClassesQueryVariables>) {
        return Apollo.useQuery<GetInfoClassesQuery, GetInfoClassesQueryVariables>(GetInfoClassesDocument, baseOptions);
      }
export function useGetInfoClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInfoClassesQuery, GetInfoClassesQueryVariables>) {
          return Apollo.useLazyQuery<GetInfoClassesQuery, GetInfoClassesQueryVariables>(GetInfoClassesDocument, baseOptions);
        }
export type GetInfoClassesQueryHookResult = ReturnType<typeof useGetInfoClassesQuery>;
export type GetInfoClassesLazyQueryHookResult = ReturnType<typeof useGetInfoClassesLazyQuery>;
export type GetInfoClassesQueryResult = Apollo.QueryResult<GetInfoClassesQuery, GetInfoClassesQueryVariables>;
export const GetInformationClassesDocument = gql`
    query getInformationClasses($limit: Int!) {
  classes {
    lessons(where: {date: {_gt: "NOW()"}}, limit: $limit) {
      students_aggregate {
        aggregate {
          count
        }
      }
      classId
      createdBy
      createdAt
    }
    classStatus
    program {
      id
      name
    }
    programTypeGeneral {
      id
      fullName
    }
    programTypeRegular {
      id
      fullName
    }
    programTypeSpecial {
      id
      fullName
    }
    id
  }
}
    `;

/**
 * __useGetInformationClassesQuery__
 *
 * To run a query within a React component, call `useGetInformationClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInformationClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInformationClassesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetInformationClassesQuery(baseOptions: Apollo.QueryHookOptions<GetInformationClassesQuery, GetInformationClassesQueryVariables>) {
        return Apollo.useQuery<GetInformationClassesQuery, GetInformationClassesQueryVariables>(GetInformationClassesDocument, baseOptions);
      }
export function useGetInformationClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInformationClassesQuery, GetInformationClassesQueryVariables>) {
          return Apollo.useLazyQuery<GetInformationClassesQuery, GetInformationClassesQueryVariables>(GetInformationClassesDocument, baseOptions);
        }
export type GetInformationClassesQueryHookResult = ReturnType<typeof useGetInformationClassesQuery>;
export type GetInformationClassesLazyQueryHookResult = ReturnType<typeof useGetInformationClassesLazyQuery>;
export type GetInformationClassesQueryResult = Apollo.QueryResult<GetInformationClassesQuery, GetInformationClassesQueryVariables>;
export const GetCountSpecialClassesDocument = gql`
    query getCountSpecialClasses($programId: String!) {
  countSpecialClasses(programId: $programId)
}
    `;

/**
 * __useGetCountSpecialClassesQuery__
 *
 * To run a query within a React component, call `useGetCountSpecialClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountSpecialClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountSpecialClassesQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useGetCountSpecialClassesQuery(baseOptions: Apollo.QueryHookOptions<GetCountSpecialClassesQuery, GetCountSpecialClassesQueryVariables>) {
        return Apollo.useQuery<GetCountSpecialClassesQuery, GetCountSpecialClassesQueryVariables>(GetCountSpecialClassesDocument, baseOptions);
      }
export function useGetCountSpecialClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountSpecialClassesQuery, GetCountSpecialClassesQueryVariables>) {
          return Apollo.useLazyQuery<GetCountSpecialClassesQuery, GetCountSpecialClassesQueryVariables>(GetCountSpecialClassesDocument, baseOptions);
        }
export type GetCountSpecialClassesQueryHookResult = ReturnType<typeof useGetCountSpecialClassesQuery>;
export type GetCountSpecialClassesLazyQueryHookResult = ReturnType<typeof useGetCountSpecialClassesLazyQuery>;
export type GetCountSpecialClassesQueryResult = Apollo.QueryResult<GetCountSpecialClassesQuery, GetCountSpecialClassesQueryVariables>;
export const GetListClassesByProgramTypeDocument = gql`
    query getListClassesByProgramType($limit: Int!, $offset: Int!, $programType: String!, $programId: uuid!, $classStatus: String, $filterClasses: classes_bool_exp) {
  classes(limit: $limit, offset: $offset, where: $filterClasses) {
    lessons(where: {_and: [{status: {_eq: "active"}}, {orderPriority: {_eq: "0"}}]}) {
      students_aggregate(
        where: {status: {_eq: "active"}, _or: [{type: {_eq: "transferred"}}, {type: {_eq: "enrolled"}}]}
      ) {
        aggregate {
          count
        }
      }
    }
    classStatus
    program {
      id
      name
    }
    programTypeGeneral {
      id
      fullName
    }
    programTypeRegular {
      id
      fullName
    }
    programTypeSpecial {
      id
      fullName
    }
    id
    status
    totalLoop
    updatedAt
    updatedBy
    waitingTime
    remark
    name
    classId
    startDate
  }
  classes_aggregate(where: $filterClasses) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetListClassesByProgramTypeQuery__
 *
 * To run a query within a React component, call `useGetListClassesByProgramTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListClassesByProgramTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListClassesByProgramTypeQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      programType: // value for 'programType'
 *      programId: // value for 'programId'
 *      classStatus: // value for 'classStatus'
 *      filterClasses: // value for 'filterClasses'
 *   },
 * });
 */
export function useGetListClassesByProgramTypeQuery(baseOptions: Apollo.QueryHookOptions<GetListClassesByProgramTypeQuery, GetListClassesByProgramTypeQueryVariables>) {
        return Apollo.useQuery<GetListClassesByProgramTypeQuery, GetListClassesByProgramTypeQueryVariables>(GetListClassesByProgramTypeDocument, baseOptions);
      }
export function useGetListClassesByProgramTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListClassesByProgramTypeQuery, GetListClassesByProgramTypeQueryVariables>) {
          return Apollo.useLazyQuery<GetListClassesByProgramTypeQuery, GetListClassesByProgramTypeQueryVariables>(GetListClassesByProgramTypeDocument, baseOptions);
        }
export type GetListClassesByProgramTypeQueryHookResult = ReturnType<typeof useGetListClassesByProgramTypeQuery>;
export type GetListClassesByProgramTypeLazyQueryHookResult = ReturnType<typeof useGetListClassesByProgramTypeLazyQuery>;
export type GetListClassesByProgramTypeQueryResult = Apollo.QueryResult<GetListClassesByProgramTypeQuery, GetListClassesByProgramTypeQueryVariables>;
export const GetListSpecialProgramTypeDocument = gql`
    query getListSpecialProgramType {
  specical_program_types {
    id
    fullName
    shortName
  }
}
    `;

/**
 * __useGetListSpecialProgramTypeQuery__
 *
 * To run a query within a React component, call `useGetListSpecialProgramTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListSpecialProgramTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListSpecialProgramTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetListSpecialProgramTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetListSpecialProgramTypeQuery, GetListSpecialProgramTypeQueryVariables>) {
        return Apollo.useQuery<GetListSpecialProgramTypeQuery, GetListSpecialProgramTypeQueryVariables>(GetListSpecialProgramTypeDocument, baseOptions);
      }
export function useGetListSpecialProgramTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListSpecialProgramTypeQuery, GetListSpecialProgramTypeQueryVariables>) {
          return Apollo.useLazyQuery<GetListSpecialProgramTypeQuery, GetListSpecialProgramTypeQueryVariables>(GetListSpecialProgramTypeDocument, baseOptions);
        }
export type GetListSpecialProgramTypeQueryHookResult = ReturnType<typeof useGetListSpecialProgramTypeQuery>;
export type GetListSpecialProgramTypeLazyQueryHookResult = ReturnType<typeof useGetListSpecialProgramTypeLazyQuery>;
export type GetListSpecialProgramTypeQueryResult = Apollo.QueryResult<GetListSpecialProgramTypeQuery, GetListSpecialProgramTypeQueryVariables>;
export const GetClassesAggregateDocument = gql`
    query getClassesAggregate($programId: uuid!, $programTypeSpecialId: uuid) {
  classes_aggregate(
    where: {_and: [{programId: {_eq: $programId}}, {programTypeSpecialId: {_eq: $programTypeSpecialId}}]}
  ) {
    aggregate {
      count(columns: classId)
    }
  }
}
    `;

/**
 * __useGetClassesAggregateQuery__
 *
 * To run a query within a React component, call `useGetClassesAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassesAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassesAggregateQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *      programTypeSpecialId: // value for 'programTypeSpecialId'
 *   },
 * });
 */
export function useGetClassesAggregateQuery(baseOptions: Apollo.QueryHookOptions<GetClassesAggregateQuery, GetClassesAggregateQueryVariables>) {
        return Apollo.useQuery<GetClassesAggregateQuery, GetClassesAggregateQueryVariables>(GetClassesAggregateDocument, baseOptions);
      }
export function useGetClassesAggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassesAggregateQuery, GetClassesAggregateQueryVariables>) {
          return Apollo.useLazyQuery<GetClassesAggregateQuery, GetClassesAggregateQueryVariables>(GetClassesAggregateDocument, baseOptions);
        }
export type GetClassesAggregateQueryHookResult = ReturnType<typeof useGetClassesAggregateQuery>;
export type GetClassesAggregateLazyQueryHookResult = ReturnType<typeof useGetClassesAggregateLazyQuery>;
export type GetClassesAggregateQueryResult = Apollo.QueryResult<GetClassesAggregateQuery, GetClassesAggregateQueryVariables>;
export const ExtendWaitingPeriodDocument = gql`
    mutation extendWaitingPeriod($form: FormExtendWaitingPeriod!) {
  extendWaitingPeriod(form: $form)
}
    `;
export type ExtendWaitingPeriodMutationFn = Apollo.MutationFunction<ExtendWaitingPeriodMutation, ExtendWaitingPeriodMutationVariables>;

/**
 * __useExtendWaitingPeriodMutation__
 *
 * To run a mutation, you first call `useExtendWaitingPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtendWaitingPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extendWaitingPeriodMutation, { data, loading, error }] = useExtendWaitingPeriodMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useExtendWaitingPeriodMutation(baseOptions?: Apollo.MutationHookOptions<ExtendWaitingPeriodMutation, ExtendWaitingPeriodMutationVariables>) {
        return Apollo.useMutation<ExtendWaitingPeriodMutation, ExtendWaitingPeriodMutationVariables>(ExtendWaitingPeriodDocument, baseOptions);
      }
export type ExtendWaitingPeriodMutationHookResult = ReturnType<typeof useExtendWaitingPeriodMutation>;
export type ExtendWaitingPeriodMutationResult = Apollo.MutationResult<ExtendWaitingPeriodMutation>;
export type ExtendWaitingPeriodMutationOptions = Apollo.BaseMutationOptions<ExtendWaitingPeriodMutation, ExtendWaitingPeriodMutationVariables>;
export const UpdateAcademicCalendarsDocument = gql`
    mutation updateAcademicCalendars($id: uuid!, $form: academic_calendars_set_input) {
  update_academic_calendars(where: {id: {_eq: $id}}, _set: $form) {
    returning {
      createdAt
      createdBy
      curriculumId
      id
      levelIds
      name
      status
    }
  }
}
    `;
export type UpdateAcademicCalendarsMutationFn = Apollo.MutationFunction<UpdateAcademicCalendarsMutation, UpdateAcademicCalendarsMutationVariables>;

/**
 * __useUpdateAcademicCalendarsMutation__
 *
 * To run a mutation, you first call `useUpdateAcademicCalendarsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAcademicCalendarsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAcademicCalendarsMutation, { data, loading, error }] = useUpdateAcademicCalendarsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      form: // value for 'form'
 *   },
 * });
 */
export function useUpdateAcademicCalendarsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAcademicCalendarsMutation, UpdateAcademicCalendarsMutationVariables>) {
        return Apollo.useMutation<UpdateAcademicCalendarsMutation, UpdateAcademicCalendarsMutationVariables>(UpdateAcademicCalendarsDocument, baseOptions);
      }
export type UpdateAcademicCalendarsMutationHookResult = ReturnType<typeof useUpdateAcademicCalendarsMutation>;
export type UpdateAcademicCalendarsMutationResult = Apollo.MutationResult<UpdateAcademicCalendarsMutation>;
export type UpdateAcademicCalendarsMutationOptions = Apollo.BaseMutationOptions<UpdateAcademicCalendarsMutation, UpdateAcademicCalendarsMutationVariables>;
export const CreateTermsDocument = gql`
    mutation createTerms($form: [terms_insert_input!]!) {
  insert_terms(objects: $form) {
    returning {
      ...Terms
      createdBy
      createdAt
      academicCalendarId
      status
      updatedAt
      updatedBy
    }
  }
}
    ${TermsFragmentDoc}`;
export type CreateTermsMutationFn = Apollo.MutationFunction<CreateTermsMutation, CreateTermsMutationVariables>;

/**
 * __useCreateTermsMutation__
 *
 * To run a mutation, you first call `useCreateTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTermsMutation, { data, loading, error }] = useCreateTermsMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useCreateTermsMutation(baseOptions?: Apollo.MutationHookOptions<CreateTermsMutation, CreateTermsMutationVariables>) {
        return Apollo.useMutation<CreateTermsMutation, CreateTermsMutationVariables>(CreateTermsDocument, baseOptions);
      }
export type CreateTermsMutationHookResult = ReturnType<typeof useCreateTermsMutation>;
export type CreateTermsMutationResult = Apollo.MutationResult<CreateTermsMutation>;
export type CreateTermsMutationOptions = Apollo.BaseMutationOptions<CreateTermsMutation, CreateTermsMutationVariables>;
export const UpdateTermsDocument = gql`
    mutation updateTerms($id: uuid!, $form: terms_set_input) {
  update_terms(where: {id: {_eq: $id}}, _set: $form) {
    returning {
      id
      endDate
      createdBy
      createdAt
      academicCalendarId
      numberOfLessons
      startDate
      status
      updatedAt
      updatedBy
    }
  }
}
    `;
export type UpdateTermsMutationFn = Apollo.MutationFunction<UpdateTermsMutation, UpdateTermsMutationVariables>;

/**
 * __useUpdateTermsMutation__
 *
 * To run a mutation, you first call `useUpdateTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTermsMutation, { data, loading, error }] = useUpdateTermsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      form: // value for 'form'
 *   },
 * });
 */
export function useUpdateTermsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTermsMutation, UpdateTermsMutationVariables>) {
        return Apollo.useMutation<UpdateTermsMutation, UpdateTermsMutationVariables>(UpdateTermsDocument, baseOptions);
      }
export type UpdateTermsMutationHookResult = ReturnType<typeof useUpdateTermsMutation>;
export type UpdateTermsMutationResult = Apollo.MutationResult<UpdateTermsMutation>;
export type UpdateTermsMutationOptions = Apollo.BaseMutationOptions<UpdateTermsMutation, UpdateTermsMutationVariables>;
export const ClassesListDocument = gql`
    query classesList($limit: Int!, $offset: Int!, $searchString: String!, $classStatus: String!, $order: order_by!, $filterProgram: programs_bool_exp, $filterProgramType: classes_bool_exp, $status: String!, $year: String) {
  class_filter_by_filling_status(
    args: {filling_status: $status}
    limit: $limit
    offset: $offset
    where: {classStatus: {_eq: $classStatus}, program: $filterProgram, _and: [$filterProgramType, {_or: [{name: {_ilike: $searchString}}, {program: {name: {_ilike: $searchString}}}]}, {_or: [{year: {_eq: $year}}, {academicCalendar: {year: {_eq: $year}}}]}], status: {_neq: "deleted"}}
    order_by: {startDate: $order}
  ) {
    enrolledClass
    lessons(where: {_and: [{status: {_eq: "active"}}, {orderPriority: {_eq: "0"}}]}) {
      date
      classroom {
        capacity
        name
        id
      }
      students_aggregate(
        where: {status: {_eq: "active"}, _or: [{type: {_eq: "transferred"}}, {type: {_eq: "enrolled"}}]}
      ) {
        aggregate {
          count
        }
      }
    }
    classStatus
    studentsWaiting_aggregate {
      aggregate {
        count
      }
    }
    program {
      id
      name
    }
    programTypeRegular {
      id
      fullName
    }
    programTypeGeneral {
      id
      fullName
    }
    programTypeSpecial {
      id
      fullName
    }
    academicCalendar {
      id
      year
    }
    academicCalendarId
    id
    status
    totalLoop
    updatedAt
    updatedBy
    waitingTime
    remark
    name
    classId
    startDate
    year
  }
  class_filter_by_filling_status_aggregate(
    args: {filling_status: $status}
    where: {classStatus: {_eq: $classStatus}, program: $filterProgram, _or: [{name: {_ilike: $searchString}}, {program: {name: {_ilike: $searchString}}}], _and: [$filterProgramType, {_or: [{name: {_ilike: $searchString}}, {program: {name: {_ilike: $searchString}}}]}, {_or: [{year: {_eq: $year}}, {academicCalendar: {year: {_eq: $year}}}]}], status: {_neq: "deleted"}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useClassesListQuery__
 *
 * To run a query within a React component, call `useClassesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassesListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      searchString: // value for 'searchString'
 *      classStatus: // value for 'classStatus'
 *      order: // value for 'order'
 *      filterProgram: // value for 'filterProgram'
 *      filterProgramType: // value for 'filterProgramType'
 *      status: // value for 'status'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useClassesListQuery(baseOptions: Apollo.QueryHookOptions<ClassesListQuery, ClassesListQueryVariables>) {
        return Apollo.useQuery<ClassesListQuery, ClassesListQueryVariables>(ClassesListDocument, baseOptions);
      }
export function useClassesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassesListQuery, ClassesListQueryVariables>) {
          return Apollo.useLazyQuery<ClassesListQuery, ClassesListQueryVariables>(ClassesListDocument, baseOptions);
        }
export type ClassesListQueryHookResult = ReturnType<typeof useClassesListQuery>;
export type ClassesListLazyQueryHookResult = ReturnType<typeof useClassesListLazyQuery>;
export type ClassesListQueryResult = Apollo.QueryResult<ClassesListQuery, ClassesListQueryVariables>;
export const UserClassesListDocument = gql`
    query UserClassesList($limit: Int!, $offset: Int!, $searchString: String!, $order: order_by!, $classStatus: String!, $filterProgram: programs_bool_exp, $filterProgramType: classes_bool_exp, $status: [String!], $year: String) {
  classes(
    limit: $limit
    offset: $offset
    where: {classStatus: {_neq: $classStatus, _in: $status}, program: $filterProgram, _and: [$filterProgramType, {_or: [{name: {_ilike: $searchString}}, {program: {name: {_ilike: $searchString}}}]}, {_or: [{year: {_eq: $year}}, {academicCalendar: {year: {_eq: $year}}}]}], status: {_neq: "deleted"}}
    order_by: {startDate: $order}
  ) {
    enrolledClass
    lessons(where: {_and: [{status: {_eq: "active"}}, {orderPriority: {_eq: "0"}}]}) {
      date
      classroom {
        capacity
        name
        id
      }
      students_aggregate(
        where: {status: {_eq: "active"}, _or: [{type: {_eq: "transferred"}}, {type: {_eq: "enrolled"}}]}
      ) {
        aggregate {
          count
        }
      }
    }
    classStatus
    studentsWaiting_aggregate {
      aggregate {
        count
      }
    }
    program {
      id
      name
    }
    programTypeRegular {
      id
      fullName
    }
    programTypeGeneral {
      id
      fullName
    }
    programTypeSpecial {
      id
      fullName
    }
    academicCalendar {
      id
      year
    }
    academicCalendarId
    id
    status
    totalLoop
    updatedAt
    updatedBy
    waitingTime
    remark
    name
    classId
    startDate
    year
  }
  classes_aggregate(
    where: {classStatus: {_neq: $classStatus, _in: $status}, program: $filterProgram, _or: [{name: {_ilike: $searchString}}, {program: {name: {_ilike: $searchString}}}], _and: [$filterProgramType, {_or: [{name: {_ilike: $searchString}}, {program: {name: {_ilike: $searchString}}}]}, {_or: [{year: {_eq: $year}}, {academicCalendar: {year: {_eq: $year}}}]}], status: {_neq: "deleted"}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useUserClassesListQuery__
 *
 * To run a query within a React component, call `useUserClassesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserClassesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserClassesListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      searchString: // value for 'searchString'
 *      order: // value for 'order'
 *      classStatus: // value for 'classStatus'
 *      filterProgram: // value for 'filterProgram'
 *      filterProgramType: // value for 'filterProgramType'
 *      status: // value for 'status'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useUserClassesListQuery(baseOptions: Apollo.QueryHookOptions<UserClassesListQuery, UserClassesListQueryVariables>) {
        return Apollo.useQuery<UserClassesListQuery, UserClassesListQueryVariables>(UserClassesListDocument, baseOptions);
      }
export function useUserClassesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserClassesListQuery, UserClassesListQueryVariables>) {
          return Apollo.useLazyQuery<UserClassesListQuery, UserClassesListQueryVariables>(UserClassesListDocument, baseOptions);
        }
export type UserClassesListQueryHookResult = ReturnType<typeof useUserClassesListQuery>;
export type UserClassesListLazyQueryHookResult = ReturnType<typeof useUserClassesListLazyQuery>;
export type UserClassesListQueryResult = Apollo.QueryResult<UserClassesListQuery, UserClassesListQueryVariables>;
export const GetClassByPkDocument = gql`
    query getClassByPk($id: uuid!, $studentId: uuid!, $filterLesson: lessons_bool_exp) {
  classes_by_pk(id: $id) {
    id
    name
    classId
    classStatus
    createdAt
    lessonType
    enrolledClass
    remark
    startDate
    program {
      id
      name
      curriculums {
        id
        name
        abbreviation
      }
      levels {
        id
        name
        abbreviation
      }
      subject {
        abbreviation
        name
        id
      }
      category
    }
    programTypeGeneral {
      id
      shortName
      fullName
    }
    programTypeRegular {
      id
      fullName
      shortName
    }
    programTypeSpecial {
      id
      fullName
      shortName
    }
    lessons(order_by: {date: asc}, where: $filterLesson) {
      date
      id
      lessonStatus
      orderPriority
      sessions {
        id
        endTime
        startTime
      }
      classroom {
        branch {
          abbreviation
          name
          id
        }
      }
      termClass {
        classId
        createdAt
        termName
      }
      numberWeek
    }
  }
  lessons_students(where: {studentId: {_eq: $studentId}}) {
    hasAttended
    id
    lessonId
    lessonStatus
    studentId
    type
    entryTime
    oldLessonId
    oldLesson {
      classId
    }
    lesson {
      classId
      class {
        name
      }
      id
      date
      lessonStatus
      sessions {
        startTime
        endTime
      }
      classroom {
        branch {
          name
          abbreviation
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetClassByPkQuery__
 *
 * To run a query within a React component, call `useGetClassByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassByPkQuery({
 *   variables: {
 *      id: // value for 'id'
 *      studentId: // value for 'studentId'
 *      filterLesson: // value for 'filterLesson'
 *   },
 * });
 */
export function useGetClassByPkQuery(baseOptions: Apollo.QueryHookOptions<GetClassByPkQuery, GetClassByPkQueryVariables>) {
        return Apollo.useQuery<GetClassByPkQuery, GetClassByPkQueryVariables>(GetClassByPkDocument, baseOptions);
      }
export function useGetClassByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassByPkQuery, GetClassByPkQueryVariables>) {
          return Apollo.useLazyQuery<GetClassByPkQuery, GetClassByPkQueryVariables>(GetClassByPkDocument, baseOptions);
        }
export type GetClassByPkQueryHookResult = ReturnType<typeof useGetClassByPkQuery>;
export type GetClassByPkLazyQueryHookResult = ReturnType<typeof useGetClassByPkLazyQuery>;
export type GetClassByPkQueryResult = Apollo.QueryResult<GetClassByPkQuery, GetClassByPkQueryVariables>;
export const AddClassDocument = gql`
    mutation addClass($form: FormCreateClass!) {
  addClass(form: $form)
}
    `;
export type AddClassMutationFn = Apollo.MutationFunction<AddClassMutation, AddClassMutationVariables>;

/**
 * __useAddClassMutation__
 *
 * To run a mutation, you first call `useAddClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClassMutation, { data, loading, error }] = useAddClassMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useAddClassMutation(baseOptions?: Apollo.MutationHookOptions<AddClassMutation, AddClassMutationVariables>) {
        return Apollo.useMutation<AddClassMutation, AddClassMutationVariables>(AddClassDocument, baseOptions);
      }
export type AddClassMutationHookResult = ReturnType<typeof useAddClassMutation>;
export type AddClassMutationResult = Apollo.MutationResult<AddClassMutation>;
export type AddClassMutationOptions = Apollo.BaseMutationOptions<AddClassMutation, AddClassMutationVariables>;
export const AddLessonDocument = gql`
    mutation addLesson($classId: String!, $form: FormCreateLesson!) {
  addLesson(classId: $classId, form: $form)
}
    `;
export type AddLessonMutationFn = Apollo.MutationFunction<AddLessonMutation, AddLessonMutationVariables>;

/**
 * __useAddLessonMutation__
 *
 * To run a mutation, you first call `useAddLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLessonMutation, { data, loading, error }] = useAddLessonMutation({
 *   variables: {
 *      classId: // value for 'classId'
 *      form: // value for 'form'
 *   },
 * });
 */
export function useAddLessonMutation(baseOptions?: Apollo.MutationHookOptions<AddLessonMutation, AddLessonMutationVariables>) {
        return Apollo.useMutation<AddLessonMutation, AddLessonMutationVariables>(AddLessonDocument, baseOptions);
      }
export type AddLessonMutationHookResult = ReturnType<typeof useAddLessonMutation>;
export type AddLessonMutationResult = Apollo.MutationResult<AddLessonMutation>;
export type AddLessonMutationOptions = Apollo.BaseMutationOptions<AddLessonMutation, AddLessonMutationVariables>;
export const GetClassroomAvailableDocument = gql`
    query getClassroomAvailable($form: FormGetClassroomAvailable) {
  getClassroomAvailable(form: $form)
}
    `;

/**
 * __useGetClassroomAvailableQuery__
 *
 * To run a query within a React component, call `useGetClassroomAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassroomAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassroomAvailableQuery({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useGetClassroomAvailableQuery(baseOptions?: Apollo.QueryHookOptions<GetClassroomAvailableQuery, GetClassroomAvailableQueryVariables>) {
        return Apollo.useQuery<GetClassroomAvailableQuery, GetClassroomAvailableQueryVariables>(GetClassroomAvailableDocument, baseOptions);
      }
export function useGetClassroomAvailableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassroomAvailableQuery, GetClassroomAvailableQueryVariables>) {
          return Apollo.useLazyQuery<GetClassroomAvailableQuery, GetClassroomAvailableQueryVariables>(GetClassroomAvailableDocument, baseOptions);
        }
export type GetClassroomAvailableQueryHookResult = ReturnType<typeof useGetClassroomAvailableQuery>;
export type GetClassroomAvailableLazyQueryHookResult = ReturnType<typeof useGetClassroomAvailableLazyQuery>;
export type GetClassroomAvailableQueryResult = Apollo.QueryResult<GetClassroomAvailableQuery, GetClassroomAvailableQueryVariables>;
export const LessonsByClassIdDocument = gql`
    query lessonsByClassID($limit: Int!, $offset: Int!, $order: order_by!, $classId: uuid!) {
  lessons(
    limit: $limit
    offset: $offset
    order_by: {date: $order}
    where: {classId: {_eq: $classId}}
  ) {
    id
    lessonStatus
    termClass {
      id
      termId
      termName
      term {
        id
      }
    }
    numberWeek
    date
    sessions {
      id
      startTime
      endTime
      tutors {
        id
        firstName
        lastName
      }
    }
    classroom {
      capacity
      name
      id
      branch {
        name
        id
      }
    }
    replacement_aggregate: students_aggregate(where: {type: {_eq: "replacement"}}) {
      aggregate {
        count
      }
    }
    students_aggregate(
      where: {_or: [{type: {_eq: "transferred"}}, {type: {_eq: "enrolled"}}]}
    ) {
      aggregate {
        count(columns: id)
      }
    }
  }
  lessons_aggregate(where: {classId: {_eq: $classId}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useLessonsByClassIdQuery__
 *
 * To run a query within a React component, call `useLessonsByClassIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLessonsByClassIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLessonsByClassIdQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order: // value for 'order'
 *      classId: // value for 'classId'
 *   },
 * });
 */
export function useLessonsByClassIdQuery(baseOptions: Apollo.QueryHookOptions<LessonsByClassIdQuery, LessonsByClassIdQueryVariables>) {
        return Apollo.useQuery<LessonsByClassIdQuery, LessonsByClassIdQueryVariables>(LessonsByClassIdDocument, baseOptions);
      }
export function useLessonsByClassIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LessonsByClassIdQuery, LessonsByClassIdQueryVariables>) {
          return Apollo.useLazyQuery<LessonsByClassIdQuery, LessonsByClassIdQueryVariables>(LessonsByClassIdDocument, baseOptions);
        }
export type LessonsByClassIdQueryHookResult = ReturnType<typeof useLessonsByClassIdQuery>;
export type LessonsByClassIdLazyQueryHookResult = ReturnType<typeof useLessonsByClassIdLazyQuery>;
export type LessonsByClassIdQueryResult = Apollo.QueryResult<LessonsByClassIdQuery, LessonsByClassIdQueryVariables>;
export const LessonsAggregateSubDocument = gql`
    query lessonsAggregateSub($classId: uuid!) {
  lessons_aggregate(
    where: {lessonStatus: {_neq: "cancel"}, classId: {_eq: $classId}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useLessonsAggregateSubQuery__
 *
 * To run a query within a React component, call `useLessonsAggregateSubQuery` and pass it any options that fit your needs.
 * When your component renders, `useLessonsAggregateSubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLessonsAggregateSubQuery({
 *   variables: {
 *      classId: // value for 'classId'
 *   },
 * });
 */
export function useLessonsAggregateSubQuery(baseOptions: Apollo.QueryHookOptions<LessonsAggregateSubQuery, LessonsAggregateSubQueryVariables>) {
        return Apollo.useQuery<LessonsAggregateSubQuery, LessonsAggregateSubQueryVariables>(LessonsAggregateSubDocument, baseOptions);
      }
export function useLessonsAggregateSubLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LessonsAggregateSubQuery, LessonsAggregateSubQueryVariables>) {
          return Apollo.useLazyQuery<LessonsAggregateSubQuery, LessonsAggregateSubQueryVariables>(LessonsAggregateSubDocument, baseOptions);
        }
export type LessonsAggregateSubQueryHookResult = ReturnType<typeof useLessonsAggregateSubQuery>;
export type LessonsAggregateSubLazyQueryHookResult = ReturnType<typeof useLessonsAggregateSubLazyQuery>;
export type LessonsAggregateSubQueryResult = Apollo.QueryResult<LessonsAggregateSubQuery, LessonsAggregateSubQueryVariables>;
export const CancelLessonDocument = gql`
    mutation cancelLesson($lessonId: String!) {
  cancelLesson(lessonId: $lessonId)
}
    `;
export type CancelLessonMutationFn = Apollo.MutationFunction<CancelLessonMutation, CancelLessonMutationVariables>;

/**
 * __useCancelLessonMutation__
 *
 * To run a mutation, you first call `useCancelLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelLessonMutation, { data, loading, error }] = useCancelLessonMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useCancelLessonMutation(baseOptions?: Apollo.MutationHookOptions<CancelLessonMutation, CancelLessonMutationVariables>) {
        return Apollo.useMutation<CancelLessonMutation, CancelLessonMutationVariables>(CancelLessonDocument, baseOptions);
      }
export type CancelLessonMutationHookResult = ReturnType<typeof useCancelLessonMutation>;
export type CancelLessonMutationResult = Apollo.MutationResult<CancelLessonMutation>;
export type CancelLessonMutationOptions = Apollo.BaseMutationOptions<CancelLessonMutation, CancelLessonMutationVariables>;
export const GetBranchesWithAllClassRoomDocument = gql`
    query getBranchesWithAllClassRoom {
  branches {
    abbreviation
    name
    classrooms {
      id
      name
      capacity
    }
    id
  }
}
    `;

/**
 * __useGetBranchesWithAllClassRoomQuery__
 *
 * To run a query within a React component, call `useGetBranchesWithAllClassRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBranchesWithAllClassRoomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBranchesWithAllClassRoomQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBranchesWithAllClassRoomQuery(baseOptions?: Apollo.QueryHookOptions<GetBranchesWithAllClassRoomQuery, GetBranchesWithAllClassRoomQueryVariables>) {
        return Apollo.useQuery<GetBranchesWithAllClassRoomQuery, GetBranchesWithAllClassRoomQueryVariables>(GetBranchesWithAllClassRoomDocument, baseOptions);
      }
export function useGetBranchesWithAllClassRoomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBranchesWithAllClassRoomQuery, GetBranchesWithAllClassRoomQueryVariables>) {
          return Apollo.useLazyQuery<GetBranchesWithAllClassRoomQuery, GetBranchesWithAllClassRoomQueryVariables>(GetBranchesWithAllClassRoomDocument, baseOptions);
        }
export type GetBranchesWithAllClassRoomQueryHookResult = ReturnType<typeof useGetBranchesWithAllClassRoomQuery>;
export type GetBranchesWithAllClassRoomLazyQueryHookResult = ReturnType<typeof useGetBranchesWithAllClassRoomLazyQuery>;
export type GetBranchesWithAllClassRoomQueryResult = Apollo.QueryResult<GetBranchesWithAllClassRoomQuery, GetBranchesWithAllClassRoomQueryVariables>;
export const ChangeClassroomForLessonDocument = gql`
    mutation changeClassroomForLesson($classroomID: String!, $lessonID: String!) {
  changeClassroomForLesson(classroomId: $classroomID, lessonId: $lessonID)
}
    `;
export type ChangeClassroomForLessonMutationFn = Apollo.MutationFunction<ChangeClassroomForLessonMutation, ChangeClassroomForLessonMutationVariables>;

/**
 * __useChangeClassroomForLessonMutation__
 *
 * To run a mutation, you first call `useChangeClassroomForLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeClassroomForLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeClassroomForLessonMutation, { data, loading, error }] = useChangeClassroomForLessonMutation({
 *   variables: {
 *      classroomID: // value for 'classroomID'
 *      lessonID: // value for 'lessonID'
 *   },
 * });
 */
export function useChangeClassroomForLessonMutation(baseOptions?: Apollo.MutationHookOptions<ChangeClassroomForLessonMutation, ChangeClassroomForLessonMutationVariables>) {
        return Apollo.useMutation<ChangeClassroomForLessonMutation, ChangeClassroomForLessonMutationVariables>(ChangeClassroomForLessonDocument, baseOptions);
      }
export type ChangeClassroomForLessonMutationHookResult = ReturnType<typeof useChangeClassroomForLessonMutation>;
export type ChangeClassroomForLessonMutationResult = Apollo.MutationResult<ChangeClassroomForLessonMutation>;
export type ChangeClassroomForLessonMutationOptions = Apollo.BaseMutationOptions<ChangeClassroomForLessonMutation, ChangeClassroomForLessonMutationVariables>;
export const UpdateSessionDocument = gql`
    mutation updateSession($tutors: [String]!, $sessionID: String!) {
  updateSession(form: {tutorIds: $tutors}, sessionId: $sessionID)
}
    `;
export type UpdateSessionMutationFn = Apollo.MutationFunction<UpdateSessionMutation, UpdateSessionMutationVariables>;

/**
 * __useUpdateSessionMutation__
 *
 * To run a mutation, you first call `useUpdateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSessionMutation, { data, loading, error }] = useUpdateSessionMutation({
 *   variables: {
 *      tutors: // value for 'tutors'
 *      sessionID: // value for 'sessionID'
 *   },
 * });
 */
export function useUpdateSessionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSessionMutation, UpdateSessionMutationVariables>) {
        return Apollo.useMutation<UpdateSessionMutation, UpdateSessionMutationVariables>(UpdateSessionDocument, baseOptions);
      }
export type UpdateSessionMutationHookResult = ReturnType<typeof useUpdateSessionMutation>;
export type UpdateSessionMutationResult = Apollo.MutationResult<UpdateSessionMutation>;
export type UpdateSessionMutationOptions = Apollo.BaseMutationOptions<UpdateSessionMutation, UpdateSessionMutationVariables>;
export const AddStudentToLessonDocument = gql`
    mutation addStudentToLesson($lessonId: String!, $studentId: String!, $type: String!, $oriLessonId: String, $oldLessonId: String) {
  addStudentToLesson(
    form: {lessonId: $lessonId, studentId: $studentId, type: $type, oldLessonId: $oldLessonId, oriLessonId: $oriLessonId}
  )
}
    `;
export type AddStudentToLessonMutationFn = Apollo.MutationFunction<AddStudentToLessonMutation, AddStudentToLessonMutationVariables>;

/**
 * __useAddStudentToLessonMutation__
 *
 * To run a mutation, you first call `useAddStudentToLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStudentToLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStudentToLessonMutation, { data, loading, error }] = useAddStudentToLessonMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      studentId: // value for 'studentId'
 *      type: // value for 'type'
 *      oriLessonId: // value for 'oriLessonId'
 *      oldLessonId: // value for 'oldLessonId'
 *   },
 * });
 */
export function useAddStudentToLessonMutation(baseOptions?: Apollo.MutationHookOptions<AddStudentToLessonMutation, AddStudentToLessonMutationVariables>) {
        return Apollo.useMutation<AddStudentToLessonMutation, AddStudentToLessonMutationVariables>(AddStudentToLessonDocument, baseOptions);
      }
export type AddStudentToLessonMutationHookResult = ReturnType<typeof useAddStudentToLessonMutation>;
export type AddStudentToLessonMutationResult = Apollo.MutationResult<AddStudentToLessonMutation>;
export type AddStudentToLessonMutationOptions = Apollo.BaseMutationOptions<AddStudentToLessonMutation, AddStudentToLessonMutationVariables>;
export const LessonsStudentsListDocument = gql`
    query lessonsStudentsList($lessonId: uuid!) {
  lessons_students(where: {lessonId: {_eq: $lessonId}, status: {_eq: "active"}}) {
    id
    type
    status
    student {
      firstName
      lastName
      studentId
      username
      id
      studentProfile {
        ...studentProfileModel
      }
    }
  }
}
    ${StudentProfileModelFragmentDoc}`;

/**
 * __useLessonsStudentsListQuery__
 *
 * To run a query within a React component, call `useLessonsStudentsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLessonsStudentsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLessonsStudentsListQuery({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useLessonsStudentsListQuery(baseOptions: Apollo.QueryHookOptions<LessonsStudentsListQuery, LessonsStudentsListQueryVariables>) {
        return Apollo.useQuery<LessonsStudentsListQuery, LessonsStudentsListQueryVariables>(LessonsStudentsListDocument, baseOptions);
      }
export function useLessonsStudentsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LessonsStudentsListQuery, LessonsStudentsListQueryVariables>) {
          return Apollo.useLazyQuery<LessonsStudentsListQuery, LessonsStudentsListQueryVariables>(LessonsStudentsListDocument, baseOptions);
        }
export type LessonsStudentsListQueryHookResult = ReturnType<typeof useLessonsStudentsListQuery>;
export type LessonsStudentsListLazyQueryHookResult = ReturnType<typeof useLessonsStudentsListLazyQuery>;
export type LessonsStudentsListQueryResult = Apollo.QueryResult<LessonsStudentsListQuery, LessonsStudentsListQueryVariables>;
export const DeleteLessonsStudentDocument = gql`
    mutation deleteLessonsStudent($id: uuid!) {
  delete_lessons_students(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteLessonsStudentMutationFn = Apollo.MutationFunction<DeleteLessonsStudentMutation, DeleteLessonsStudentMutationVariables>;

/**
 * __useDeleteLessonsStudentMutation__
 *
 * To run a mutation, you first call `useDeleteLessonsStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLessonsStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLessonsStudentMutation, { data, loading, error }] = useDeleteLessonsStudentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLessonsStudentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLessonsStudentMutation, DeleteLessonsStudentMutationVariables>) {
        return Apollo.useMutation<DeleteLessonsStudentMutation, DeleteLessonsStudentMutationVariables>(DeleteLessonsStudentDocument, baseOptions);
      }
export type DeleteLessonsStudentMutationHookResult = ReturnType<typeof useDeleteLessonsStudentMutation>;
export type DeleteLessonsStudentMutationResult = Apollo.MutationResult<DeleteLessonsStudentMutation>;
export type DeleteLessonsStudentMutationOptions = Apollo.BaseMutationOptions<DeleteLessonsStudentMutation, DeleteLessonsStudentMutationVariables>;
export const UpdateClassesDocument = gql`
    mutation updateClasses($id: uuid!, $status: String!) {
  update_classes(where: {id: {_eq: $id}}, _set: {classStatus: $status}) {
    returning {
      classStatus
      id
      classId
    }
    affected_rows
  }
}
    `;
export type UpdateClassesMutationFn = Apollo.MutationFunction<UpdateClassesMutation, UpdateClassesMutationVariables>;

/**
 * __useUpdateClassesMutation__
 *
 * To run a mutation, you first call `useUpdateClassesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClassesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClassesMutation, { data, loading, error }] = useUpdateClassesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateClassesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClassesMutation, UpdateClassesMutationVariables>) {
        return Apollo.useMutation<UpdateClassesMutation, UpdateClassesMutationVariables>(UpdateClassesDocument, baseOptions);
      }
export type UpdateClassesMutationHookResult = ReturnType<typeof useUpdateClassesMutation>;
export type UpdateClassesMutationResult = Apollo.MutationResult<UpdateClassesMutation>;
export type UpdateClassesMutationOptions = Apollo.BaseMutationOptions<UpdateClassesMutation, UpdateClassesMutationVariables>;
export const ClassStudentsWaitingDocument = gql`
    query classStudentsWaiting($classID: uuid!) {
  class_students_waiting(where: {classId: {_eq: $classID}}) {
    student {
      id
      firstName
      lastName
      username
      studentId
      studentProfile {
        willPayLater
        ...studentProfileModel
      }
    }
    waitingStatus
    id
    paymentStatus
    status
    classId
  }
}
    ${StudentProfileModelFragmentDoc}`;

/**
 * __useClassStudentsWaitingQuery__
 *
 * To run a query within a React component, call `useClassStudentsWaitingQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassStudentsWaitingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassStudentsWaitingQuery({
 *   variables: {
 *      classID: // value for 'classID'
 *   },
 * });
 */
export function useClassStudentsWaitingQuery(baseOptions: Apollo.QueryHookOptions<ClassStudentsWaitingQuery, ClassStudentsWaitingQueryVariables>) {
        return Apollo.useQuery<ClassStudentsWaitingQuery, ClassStudentsWaitingQueryVariables>(ClassStudentsWaitingDocument, baseOptions);
      }
export function useClassStudentsWaitingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassStudentsWaitingQuery, ClassStudentsWaitingQueryVariables>) {
          return Apollo.useLazyQuery<ClassStudentsWaitingQuery, ClassStudentsWaitingQueryVariables>(ClassStudentsWaitingDocument, baseOptions);
        }
export type ClassStudentsWaitingQueryHookResult = ReturnType<typeof useClassStudentsWaitingQuery>;
export type ClassStudentsWaitingLazyQueryHookResult = ReturnType<typeof useClassStudentsWaitingLazyQuery>;
export type ClassStudentsWaitingQueryResult = Apollo.QueryResult<ClassStudentsWaitingQuery, ClassStudentsWaitingQueryVariables>;
export const AddStudentToWaitingListDocument = gql`
    mutation addStudentToWaitingList($classID: String!, $studentIds: [String]!) {
  addStudentToWaitingList(classId: $classID, form: {studentIds: $studentIds})
}
    `;
export type AddStudentToWaitingListMutationFn = Apollo.MutationFunction<AddStudentToWaitingListMutation, AddStudentToWaitingListMutationVariables>;

/**
 * __useAddStudentToWaitingListMutation__
 *
 * To run a mutation, you first call `useAddStudentToWaitingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStudentToWaitingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStudentToWaitingListMutation, { data, loading, error }] = useAddStudentToWaitingListMutation({
 *   variables: {
 *      classID: // value for 'classID'
 *      studentIds: // value for 'studentIds'
 *   },
 * });
 */
export function useAddStudentToWaitingListMutation(baseOptions?: Apollo.MutationHookOptions<AddStudentToWaitingListMutation, AddStudentToWaitingListMutationVariables>) {
        return Apollo.useMutation<AddStudentToWaitingListMutation, AddStudentToWaitingListMutationVariables>(AddStudentToWaitingListDocument, baseOptions);
      }
export type AddStudentToWaitingListMutationHookResult = ReturnType<typeof useAddStudentToWaitingListMutation>;
export type AddStudentToWaitingListMutationResult = Apollo.MutationResult<AddStudentToWaitingListMutation>;
export type AddStudentToWaitingListMutationOptions = Apollo.BaseMutationOptions<AddStudentToWaitingListMutation, AddStudentToWaitingListMutationVariables>;
export const ChangeClassStatusDocument = gql`
    mutation changeClassStatus($classId: String!, $form: FormChangeClassStatus!) {
  changeClassStatus(classId: $classId, form: $form)
}
    `;
export type ChangeClassStatusMutationFn = Apollo.MutationFunction<ChangeClassStatusMutation, ChangeClassStatusMutationVariables>;

/**
 * __useChangeClassStatusMutation__
 *
 * To run a mutation, you first call `useChangeClassStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeClassStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeClassStatusMutation, { data, loading, error }] = useChangeClassStatusMutation({
 *   variables: {
 *      classId: // value for 'classId'
 *      form: // value for 'form'
 *   },
 * });
 */
export function useChangeClassStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeClassStatusMutation, ChangeClassStatusMutationVariables>) {
        return Apollo.useMutation<ChangeClassStatusMutation, ChangeClassStatusMutationVariables>(ChangeClassStatusDocument, baseOptions);
      }
export type ChangeClassStatusMutationHookResult = ReturnType<typeof useChangeClassStatusMutation>;
export type ChangeClassStatusMutationResult = Apollo.MutationResult<ChangeClassStatusMutation>;
export type ChangeClassStatusMutationOptions = Apollo.BaseMutationOptions<ChangeClassStatusMutation, ChangeClassStatusMutationVariables>;
export const DeleteClassStudentsWaitingByPkDocument = gql`
    mutation deleteClassStudentsWaitingByPk($classId: String!, $studentId: String!) {
  deleteStudentInWaitingList(classId: $classId, form: {studentId: $studentId})
}
    `;
export type DeleteClassStudentsWaitingByPkMutationFn = Apollo.MutationFunction<DeleteClassStudentsWaitingByPkMutation, DeleteClassStudentsWaitingByPkMutationVariables>;

/**
 * __useDeleteClassStudentsWaitingByPkMutation__
 *
 * To run a mutation, you first call `useDeleteClassStudentsWaitingByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClassStudentsWaitingByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClassStudentsWaitingByPkMutation, { data, loading, error }] = useDeleteClassStudentsWaitingByPkMutation({
 *   variables: {
 *      classId: // value for 'classId'
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useDeleteClassStudentsWaitingByPkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClassStudentsWaitingByPkMutation, DeleteClassStudentsWaitingByPkMutationVariables>) {
        return Apollo.useMutation<DeleteClassStudentsWaitingByPkMutation, DeleteClassStudentsWaitingByPkMutationVariables>(DeleteClassStudentsWaitingByPkDocument, baseOptions);
      }
export type DeleteClassStudentsWaitingByPkMutationHookResult = ReturnType<typeof useDeleteClassStudentsWaitingByPkMutation>;
export type DeleteClassStudentsWaitingByPkMutationResult = Apollo.MutationResult<DeleteClassStudentsWaitingByPkMutation>;
export type DeleteClassStudentsWaitingByPkMutationOptions = Apollo.BaseMutationOptions<DeleteClassStudentsWaitingByPkMutation, DeleteClassStudentsWaitingByPkMutationVariables>;
export const UpdateClassroomDocument = gql`
    mutation updateClassroom($classroomId: String!, $form: FormCreateClassroom!) {
  updateClassroom(classroomId: $classroomId, form: $form)
}
    `;
export type UpdateClassroomMutationFn = Apollo.MutationFunction<UpdateClassroomMutation, UpdateClassroomMutationVariables>;

/**
 * __useUpdateClassroomMutation__
 *
 * To run a mutation, you first call `useUpdateClassroomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClassroomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClassroomMutation, { data, loading, error }] = useUpdateClassroomMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      form: // value for 'form'
 *   },
 * });
 */
export function useUpdateClassroomMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClassroomMutation, UpdateClassroomMutationVariables>) {
        return Apollo.useMutation<UpdateClassroomMutation, UpdateClassroomMutationVariables>(UpdateClassroomDocument, baseOptions);
      }
export type UpdateClassroomMutationHookResult = ReturnType<typeof useUpdateClassroomMutation>;
export type UpdateClassroomMutationResult = Apollo.MutationResult<UpdateClassroomMutation>;
export type UpdateClassroomMutationOptions = Apollo.BaseMutationOptions<UpdateClassroomMutation, UpdateClassroomMutationVariables>;
export const FilterUserWithPaginationDocument = gql`
    query filterUserWithPagination($filter: users_bool_exp, $order: [users_order_by!], $limit: Int!, $offset: Int!) {
  users(limit: $limit, offset: $offset, where: $filter, order_by: $order) {
    id
    role
    email
    firstName
    lastName
    fullName
    avatar
    isVerifiedEmail
    isVerifiedPhoneNumber
    phone
    phoneNumber
    status
    address
    username
    paymentStatus
    studentProfile {
      ...studentProfileModel
    }
    lessonsStudents {
      type
      studentId
      id
      lessonId
    }
    studentsWaiting {
      id
      status
      waitingStatus
      classId
    }
  }
  users_aggregate(where: $filter) {
    aggregate {
      count
    }
  }
}
    ${StudentProfileModelFragmentDoc}`;

/**
 * __useFilterUserWithPaginationQuery__
 *
 * To run a query within a React component, call `useFilterUserWithPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterUserWithPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterUserWithPaginationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFilterUserWithPaginationQuery(baseOptions: Apollo.QueryHookOptions<FilterUserWithPaginationQuery, FilterUserWithPaginationQueryVariables>) {
        return Apollo.useQuery<FilterUserWithPaginationQuery, FilterUserWithPaginationQueryVariables>(FilterUserWithPaginationDocument, baseOptions);
      }
export function useFilterUserWithPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterUserWithPaginationQuery, FilterUserWithPaginationQueryVariables>) {
          return Apollo.useLazyQuery<FilterUserWithPaginationQuery, FilterUserWithPaginationQueryVariables>(FilterUserWithPaginationDocument, baseOptions);
        }
export type FilterUserWithPaginationQueryHookResult = ReturnType<typeof useFilterUserWithPaginationQuery>;
export type FilterUserWithPaginationLazyQueryHookResult = ReturnType<typeof useFilterUserWithPaginationLazyQuery>;
export type FilterUserWithPaginationQueryResult = Apollo.QueryResult<FilterUserWithPaginationQuery, FilterUserWithPaginationQueryVariables>;
export const GetSchoolsListDocument = gql`
    query getSchoolsList {
  schools {
    ...schoolModel
  }
}
    ${SchoolModelFragmentDoc}`;

/**
 * __useGetSchoolsListQuery__
 *
 * To run a query within a React component, call `useGetSchoolsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSchoolsListQuery(baseOptions?: Apollo.QueryHookOptions<GetSchoolsListQuery, GetSchoolsListQueryVariables>) {
        return Apollo.useQuery<GetSchoolsListQuery, GetSchoolsListQueryVariables>(GetSchoolsListDocument, baseOptions);
      }
export function useGetSchoolsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolsListQuery, GetSchoolsListQueryVariables>) {
          return Apollo.useLazyQuery<GetSchoolsListQuery, GetSchoolsListQueryVariables>(GetSchoolsListDocument, baseOptions);
        }
export type GetSchoolsListQueryHookResult = ReturnType<typeof useGetSchoolsListQuery>;
export type GetSchoolsListLazyQueryHookResult = ReturnType<typeof useGetSchoolsListLazyQuery>;
export type GetSchoolsListQueryResult = Apollo.QueryResult<GetSchoolsListQuery, GetSchoolsListQueryVariables>;
export const StepStudentInformationDocument = gql`
    mutation stepStudentInformation($studentId: String!, $form: FormStudentInformation!) {
  stepStudentInformation(form: $form, studentId: $studentId)
}
    `;
export type StepStudentInformationMutationFn = Apollo.MutationFunction<StepStudentInformationMutation, StepStudentInformationMutationVariables>;

/**
 * __useStepStudentInformationMutation__
 *
 * To run a mutation, you first call `useStepStudentInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStepStudentInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stepStudentInformationMutation, { data, loading, error }] = useStepStudentInformationMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      form: // value for 'form'
 *   },
 * });
 */
export function useStepStudentInformationMutation(baseOptions?: Apollo.MutationHookOptions<StepStudentInformationMutation, StepStudentInformationMutationVariables>) {
        return Apollo.useMutation<StepStudentInformationMutation, StepStudentInformationMutationVariables>(StepStudentInformationDocument, baseOptions);
      }
export type StepStudentInformationMutationHookResult = ReturnType<typeof useStepStudentInformationMutation>;
export type StepStudentInformationMutationResult = Apollo.MutationResult<StepStudentInformationMutation>;
export type StepStudentInformationMutationOptions = Apollo.BaseMutationOptions<StepStudentInformationMutation, StepStudentInformationMutationVariables>;
export const ListClassesCreateStudentDocument = gql`
    query listClassesCreateStudent($args: payment_advice_classes_by_student_id_args!, $filter: classes_bool_exp, $limit: Int!, $offset: Int!) {
  payment_advice_classes_by_student_id(
    args: $args
    where: $filter
    limit: $limit
    offset: $offset
  ) {
    id
    status
    classStatus
    name
    programId
    remark
    waitingTime
    studentsWaiting_aggregate {
      aggregate {
        count
      }
    }
    lessons(where: {date: {_gte: "NOW()"}}, limit: 1) {
      sessions {
        tutors {
          firstName
          lastName
          id
        }
        startTime
        endTime
        id
      }
      students_aggregate(
        where: {status: {_eq: "active"}, _or: [{type: {_eq: "transferred"}}, {type: {_eq: "enrolled"}}]}
      ) {
        aggregate {
          count
        }
      }
      classroom {
        id
        capacity
      }
      date
      id
    }
  }
  payment_advice_classes_by_student_id_aggregate(args: $args, where: $filter) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useListClassesCreateStudentQuery__
 *
 * To run a query within a React component, call `useListClassesCreateStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useListClassesCreateStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListClassesCreateStudentQuery({
 *   variables: {
 *      args: // value for 'args'
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useListClassesCreateStudentQuery(baseOptions: Apollo.QueryHookOptions<ListClassesCreateStudentQuery, ListClassesCreateStudentQueryVariables>) {
        return Apollo.useQuery<ListClassesCreateStudentQuery, ListClassesCreateStudentQueryVariables>(ListClassesCreateStudentDocument, baseOptions);
      }
export function useListClassesCreateStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListClassesCreateStudentQuery, ListClassesCreateStudentQueryVariables>) {
          return Apollo.useLazyQuery<ListClassesCreateStudentQuery, ListClassesCreateStudentQueryVariables>(ListClassesCreateStudentDocument, baseOptions);
        }
export type ListClassesCreateStudentQueryHookResult = ReturnType<typeof useListClassesCreateStudentQuery>;
export type ListClassesCreateStudentLazyQueryHookResult = ReturnType<typeof useListClassesCreateStudentLazyQuery>;
export type ListClassesCreateStudentQueryResult = Apollo.QueryResult<ListClassesCreateStudentQuery, ListClassesCreateStudentQueryVariables>;
export const GetListStatusStudentDocument = gql`
    query getListStatusStudent {
  users(distinct_on: status, where: {status: {_neq: "deleted"}}) {
    id
    status
  }
}
    `;

/**
 * __useGetListStatusStudentQuery__
 *
 * To run a query within a React component, call `useGetListStatusStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListStatusStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListStatusStudentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetListStatusStudentQuery(baseOptions?: Apollo.QueryHookOptions<GetListStatusStudentQuery, GetListStatusStudentQueryVariables>) {
        return Apollo.useQuery<GetListStatusStudentQuery, GetListStatusStudentQueryVariables>(GetListStatusStudentDocument, baseOptions);
      }
export function useGetListStatusStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListStatusStudentQuery, GetListStatusStudentQueryVariables>) {
          return Apollo.useLazyQuery<GetListStatusStudentQuery, GetListStatusStudentQueryVariables>(GetListStatusStudentDocument, baseOptions);
        }
export type GetListStatusStudentQueryHookResult = ReturnType<typeof useGetListStatusStudentQuery>;
export type GetListStatusStudentLazyQueryHookResult = ReturnType<typeof useGetListStatusStudentLazyQuery>;
export type GetListStatusStudentQueryResult = Apollo.QueryResult<GetListStatusStudentQuery, GetListStatusStudentQueryVariables>;
export const ActiveStatusOfStudentDocument = gql`
    mutation activeStatusOfStudent($id: uuid!) {
  update_users_by_pk(pk_columns: {id: $id}, _set: {status: "active"}) {
    status
    studentId
    id
  }
}
    `;
export type ActiveStatusOfStudentMutationFn = Apollo.MutationFunction<ActiveStatusOfStudentMutation, ActiveStatusOfStudentMutationVariables>;

/**
 * __useActiveStatusOfStudentMutation__
 *
 * To run a mutation, you first call `useActiveStatusOfStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActiveStatusOfStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activeStatusOfStudentMutation, { data, loading, error }] = useActiveStatusOfStudentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActiveStatusOfStudentMutation(baseOptions?: Apollo.MutationHookOptions<ActiveStatusOfStudentMutation, ActiveStatusOfStudentMutationVariables>) {
        return Apollo.useMutation<ActiveStatusOfStudentMutation, ActiveStatusOfStudentMutationVariables>(ActiveStatusOfStudentDocument, baseOptions);
      }
export type ActiveStatusOfStudentMutationHookResult = ReturnType<typeof useActiveStatusOfStudentMutation>;
export type ActiveStatusOfStudentMutationResult = Apollo.MutationResult<ActiveStatusOfStudentMutation>;
export type ActiveStatusOfStudentMutationOptions = Apollo.BaseMutationOptions<ActiveStatusOfStudentMutation, ActiveStatusOfStudentMutationVariables>;
export const GetListLevelStudentDocument = gql`
    query getListLevelStudent {
  levels {
    name
    id
    abbreviation
  }
}
    `;

/**
 * __useGetListLevelStudentQuery__
 *
 * To run a query within a React component, call `useGetListLevelStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListLevelStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListLevelStudentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetListLevelStudentQuery(baseOptions?: Apollo.QueryHookOptions<GetListLevelStudentQuery, GetListLevelStudentQueryVariables>) {
        return Apollo.useQuery<GetListLevelStudentQuery, GetListLevelStudentQueryVariables>(GetListLevelStudentDocument, baseOptions);
      }
export function useGetListLevelStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListLevelStudentQuery, GetListLevelStudentQueryVariables>) {
          return Apollo.useLazyQuery<GetListLevelStudentQuery, GetListLevelStudentQueryVariables>(GetListLevelStudentDocument, baseOptions);
        }
export type GetListLevelStudentQueryHookResult = ReturnType<typeof useGetListLevelStudentQuery>;
export type GetListLevelStudentLazyQueryHookResult = ReturnType<typeof useGetListLevelStudentLazyQuery>;
export type GetListLevelStudentQueryResult = Apollo.QueryResult<GetListLevelStudentQuery, GetListLevelStudentQueryVariables>;
export const GetListLevelCurriculumStudentDocument = gql`
    query getListLevelCurriculumStudent {
  curriculums_levels {
    curriculumId
    levelId
    curriculum {
      id
      name
      abbreviation
    }
    level {
      id
      name
      abbreviation
    }
  }
}
    `;

/**
 * __useGetListLevelCurriculumStudentQuery__
 *
 * To run a query within a React component, call `useGetListLevelCurriculumStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListLevelCurriculumStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListLevelCurriculumStudentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetListLevelCurriculumStudentQuery(baseOptions?: Apollo.QueryHookOptions<GetListLevelCurriculumStudentQuery, GetListLevelCurriculumStudentQueryVariables>) {
        return Apollo.useQuery<GetListLevelCurriculumStudentQuery, GetListLevelCurriculumStudentQueryVariables>(GetListLevelCurriculumStudentDocument, baseOptions);
      }
export function useGetListLevelCurriculumStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListLevelCurriculumStudentQuery, GetListLevelCurriculumStudentQueryVariables>) {
          return Apollo.useLazyQuery<GetListLevelCurriculumStudentQuery, GetListLevelCurriculumStudentQueryVariables>(GetListLevelCurriculumStudentDocument, baseOptions);
        }
export type GetListLevelCurriculumStudentQueryHookResult = ReturnType<typeof useGetListLevelCurriculumStudentQuery>;
export type GetListLevelCurriculumStudentLazyQueryHookResult = ReturnType<typeof useGetListLevelCurriculumStudentLazyQuery>;
export type GetListLevelCurriculumStudentQueryResult = Apollo.QueryResult<GetListLevelCurriculumStudentQuery, GetListLevelCurriculumStudentQueryVariables>;
export const GetListCurriculumStudentDocument = gql`
    query getListCurriculumStudent {
  curriculums {
    id
    name
    abbreviation
  }
}
    `;

/**
 * __useGetListCurriculumStudentQuery__
 *
 * To run a query within a React component, call `useGetListCurriculumStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListCurriculumStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListCurriculumStudentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetListCurriculumStudentQuery(baseOptions?: Apollo.QueryHookOptions<GetListCurriculumStudentQuery, GetListCurriculumStudentQueryVariables>) {
        return Apollo.useQuery<GetListCurriculumStudentQuery, GetListCurriculumStudentQueryVariables>(GetListCurriculumStudentDocument, baseOptions);
      }
export function useGetListCurriculumStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListCurriculumStudentQuery, GetListCurriculumStudentQueryVariables>) {
          return Apollo.useLazyQuery<GetListCurriculumStudentQuery, GetListCurriculumStudentQueryVariables>(GetListCurriculumStudentDocument, baseOptions);
        }
export type GetListCurriculumStudentQueryHookResult = ReturnType<typeof useGetListCurriculumStudentQuery>;
export type GetListCurriculumStudentLazyQueryHookResult = ReturnType<typeof useGetListCurriculumStudentLazyQuery>;
export type GetListCurriculumStudentQueryResult = Apollo.QueryResult<GetListCurriculumStudentQuery, GetListCurriculumStudentQueryVariables>;
export const AutoCompleteSearchStudentDocument = gql`
    query autoCompleteSearchStudent($form: users_bool_exp) {
  users(where: $form) {
    id
    firstName
    lastName
    username
    studentProfile {
      id
      school {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAutoCompleteSearchStudentQuery__
 *
 * To run a query within a React component, call `useAutoCompleteSearchStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutoCompleteSearchStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutoCompleteSearchStudentQuery({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useAutoCompleteSearchStudentQuery(baseOptions?: Apollo.QueryHookOptions<AutoCompleteSearchStudentQuery, AutoCompleteSearchStudentQueryVariables>) {
        return Apollo.useQuery<AutoCompleteSearchStudentQuery, AutoCompleteSearchStudentQueryVariables>(AutoCompleteSearchStudentDocument, baseOptions);
      }
export function useAutoCompleteSearchStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutoCompleteSearchStudentQuery, AutoCompleteSearchStudentQueryVariables>) {
          return Apollo.useLazyQuery<AutoCompleteSearchStudentQuery, AutoCompleteSearchStudentQueryVariables>(AutoCompleteSearchStudentDocument, baseOptions);
        }
export type AutoCompleteSearchStudentQueryHookResult = ReturnType<typeof useAutoCompleteSearchStudentQuery>;
export type AutoCompleteSearchStudentLazyQueryHookResult = ReturnType<typeof useAutoCompleteSearchStudentLazyQuery>;
export type AutoCompleteSearchStudentQueryResult = Apollo.QueryResult<AutoCompleteSearchStudentQuery, AutoCompleteSearchStudentQueryVariables>;
export const GetListUsersDocument = gql`
    query getListUsers($offset: Int, $filter: users_bool_exp, $limit: Int) {
  users(
    order_by: {createdAt: desc}
    where: $filter
    limit: $limit
    offset: $offset
  ) {
    id
    studentProfile {
      id
      parents
      firstParent
      subscribe
    }
    phone
    phoneNumber
    email
    firstName
    lastName
    role
    dob
    gender
    address
    status
    code
    username
    fullName
    isVerifiedEmail
    isVerifiedPhoneNumber
    roles {
      name
      role
    }
  }
  users_aggregate(order_by: {createdAt: desc}, where: $filter) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetListUsersQuery__
 *
 * To run a query within a React component, call `useGetListUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListUsersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetListUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetListUsersQuery, GetListUsersQueryVariables>) {
        return Apollo.useQuery<GetListUsersQuery, GetListUsersQueryVariables>(GetListUsersDocument, baseOptions);
      }
export function useGetListUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListUsersQuery, GetListUsersQueryVariables>) {
          return Apollo.useLazyQuery<GetListUsersQuery, GetListUsersQueryVariables>(GetListUsersDocument, baseOptions);
        }
export type GetListUsersQueryHookResult = ReturnType<typeof useGetListUsersQuery>;
export type GetListUsersLazyQueryHookResult = ReturnType<typeof useGetListUsersLazyQuery>;
export type GetListUsersQueryResult = Apollo.QueryResult<GetListUsersQuery, GetListUsersQueryVariables>;
export const CreateStudentDocument = gql`
    mutation CreateStudent($form: CreateStudentForm!) {
  createStudent(form: $form)
}
    `;
export type CreateStudentMutationFn = Apollo.MutationFunction<CreateStudentMutation, CreateStudentMutationVariables>;

/**
 * __useCreateStudentMutation__
 *
 * To run a mutation, you first call `useCreateStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStudentMutation, { data, loading, error }] = useCreateStudentMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useCreateStudentMutation(baseOptions?: Apollo.MutationHookOptions<CreateStudentMutation, CreateStudentMutationVariables>) {
        return Apollo.useMutation<CreateStudentMutation, CreateStudentMutationVariables>(CreateStudentDocument, baseOptions);
      }
export type CreateStudentMutationHookResult = ReturnType<typeof useCreateStudentMutation>;
export type CreateStudentMutationResult = Apollo.MutationResult<CreateStudentMutation>;
export type CreateStudentMutationOptions = Apollo.BaseMutationOptions<CreateStudentMutation, CreateStudentMutationVariables>;
export const StepFamilyInformationDocument = gql`
    mutation StepFamilyInformation($form: FormFamilyInformation!, $studentId: String!) {
  stepFamilyInformation(form: $form, studentId: $studentId)
}
    `;
export type StepFamilyInformationMutationFn = Apollo.MutationFunction<StepFamilyInformationMutation, StepFamilyInformationMutationVariables>;

/**
 * __useStepFamilyInformationMutation__
 *
 * To run a mutation, you first call `useStepFamilyInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStepFamilyInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stepFamilyInformationMutation, { data, loading, error }] = useStepFamilyInformationMutation({
 *   variables: {
 *      form: // value for 'form'
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useStepFamilyInformationMutation(baseOptions?: Apollo.MutationHookOptions<StepFamilyInformationMutation, StepFamilyInformationMutationVariables>) {
        return Apollo.useMutation<StepFamilyInformationMutation, StepFamilyInformationMutationVariables>(StepFamilyInformationDocument, baseOptions);
      }
export type StepFamilyInformationMutationHookResult = ReturnType<typeof useStepFamilyInformationMutation>;
export type StepFamilyInformationMutationResult = Apollo.MutationResult<StepFamilyInformationMutation>;
export type StepFamilyInformationMutationOptions = Apollo.BaseMutationOptions<StepFamilyInformationMutation, StepFamilyInformationMutationVariables>;
export const StepProgramAndClassDocument = gql`
    mutation stepProgramAndClass($studentId: String!, $form: FormProgramAndClass!) {
  stepProgramAndClass(form: $form, studentId: $studentId)
}
    `;
export type StepProgramAndClassMutationFn = Apollo.MutationFunction<StepProgramAndClassMutation, StepProgramAndClassMutationVariables>;

/**
 * __useStepProgramAndClassMutation__
 *
 * To run a mutation, you first call `useStepProgramAndClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStepProgramAndClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stepProgramAndClassMutation, { data, loading, error }] = useStepProgramAndClassMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      form: // value for 'form'
 *   },
 * });
 */
export function useStepProgramAndClassMutation(baseOptions?: Apollo.MutationHookOptions<StepProgramAndClassMutation, StepProgramAndClassMutationVariables>) {
        return Apollo.useMutation<StepProgramAndClassMutation, StepProgramAndClassMutationVariables>(StepProgramAndClassDocument, baseOptions);
      }
export type StepProgramAndClassMutationHookResult = ReturnType<typeof useStepProgramAndClassMutation>;
export type StepProgramAndClassMutationResult = Apollo.MutationResult<StepProgramAndClassMutation>;
export type StepProgramAndClassMutationOptions = Apollo.BaseMutationOptions<StepProgramAndClassMutation, StepProgramAndClassMutationVariables>;
export const GetStudentDetailDocument = gql`
    query getStudentDetail($id: uuid!) {
  users_by_pk(id: $id) {
    id
    address
    avatar
    code
    createdAt
    dob
    email
    firstName
    gender
    lastName
    phone
    username
    status
    paymentStatus
    studentsWaiting_aggregate {
      aggregate {
        count
      }
    }
    studentsWaiting {
      id
      status
      waitingStatus
      classId
      class {
        id
        status
        classStatus
        name
        programId
        remark
        waitingTime
        lessons(where: {date: {_gte: "NOW()"}}, limit: 1) {
          sessions {
            tutors {
              firstName
              lastName
              id
            }
            startTime
            endTime
            id
          }
          students_aggregate(
            where: {status: {_eq: "active"}, _or: [{type: {_eq: "transferred"}}, {type: {_eq: "enrolled"}}]}
          ) {
            aggregate {
              count
            }
          }
          classroom {
            id
            capacity
          }
          date
          id
        }
      }
    }
    siblings {
      id
      referenceId
      relationships
      studentId
      reference {
        id
        firstName
        email
        gender
        phone
        lastName
        studentProfile {
          id
          curriculum {
            abbreviation
            id
            name
          }
          level {
            abbreviation
            id
            name
          }
        }
      }
    }
    discountStudents {
      id
      student {
        id
        firstName
        email
        gender
        lastName
        studentId
        studentProfile {
          id
          curriculum {
            abbreviation
            id
            name
          }
          level {
            abbreviation
            id
            name
          }
        }
      }
      discount {
        id
        code
      }
    }
    studentProfile {
      id
      payLaterReason
      willPayLater
      billing
      curriculumId
      curriculum {
        id
        abbreviation
      }
      levelId
      level {
        id
        abbreviation
      }
      schoolId
      school {
        id
        name
      }
      payOnline
      status
      subscribe
      payment
      parents
      mailling
      emergencyContact
      currentStep
    }
  }
}
    `;

/**
 * __useGetStudentDetailQuery__
 *
 * To run a query within a React component, call `useGetStudentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStudentDetailQuery(baseOptions: Apollo.QueryHookOptions<GetStudentDetailQuery, GetStudentDetailQueryVariables>) {
        return Apollo.useQuery<GetStudentDetailQuery, GetStudentDetailQueryVariables>(GetStudentDetailDocument, baseOptions);
      }
export function useGetStudentDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentDetailQuery, GetStudentDetailQueryVariables>) {
          return Apollo.useLazyQuery<GetStudentDetailQuery, GetStudentDetailQueryVariables>(GetStudentDetailDocument, baseOptions);
        }
export type GetStudentDetailQueryHookResult = ReturnType<typeof useGetStudentDetailQuery>;
export type GetStudentDetailLazyQueryHookResult = ReturnType<typeof useGetStudentDetailLazyQuery>;
export type GetStudentDetailQueryResult = Apollo.QueryResult<GetStudentDetailQuery, GetStudentDetailQueryVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($id: String!) {
  deleteUser(form: {id: $id})
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, baseOptions);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const FilterProgramStudentDocument = gql`
    query filterProgramStudent($args: students_programs_filter_args!, $filter: programs_bool_exp, $offset: Int!, $limit: Int!) {
  students_programs_filter(
    args: $args
    offset: $offset
    limit: $limit
    where: $filter
  ) {
    id
    name
    curriculums {
      abbreviation
      id
    }
    levels {
      abbreviation
      id
    }
    subject {
      name
      abbreviation
      id
    }
  }
  students_programs_filter_aggregate(args: $args, where: $filter) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useFilterProgramStudentQuery__
 *
 * To run a query within a React component, call `useFilterProgramStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterProgramStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterProgramStudentQuery({
 *   variables: {
 *      args: // value for 'args'
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFilterProgramStudentQuery(baseOptions: Apollo.QueryHookOptions<FilterProgramStudentQuery, FilterProgramStudentQueryVariables>) {
        return Apollo.useQuery<FilterProgramStudentQuery, FilterProgramStudentQueryVariables>(FilterProgramStudentDocument, baseOptions);
      }
export function useFilterProgramStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterProgramStudentQuery, FilterProgramStudentQueryVariables>) {
          return Apollo.useLazyQuery<FilterProgramStudentQuery, FilterProgramStudentQueryVariables>(FilterProgramStudentDocument, baseOptions);
        }
export type FilterProgramStudentQueryHookResult = ReturnType<typeof useFilterProgramStudentQuery>;
export type FilterProgramStudentLazyQueryHookResult = ReturnType<typeof useFilterProgramStudentLazyQuery>;
export type FilterProgramStudentQueryResult = Apollo.QueryResult<FilterProgramStudentQuery, FilterProgramStudentQueryVariables>;
export const FilterClassStudentDocument = gql`
    query filterClassStudent($form: FilterClassList!, $studentId: String!) {
  filterClassByStudentId(form: $form, studentId: $studentId) {
    data {
      academicYear
      classStatus
      id
      name
      paymentStatus
      currentStudentStatus
      classPaymentStatus {
        statusPaid
        statusUnpaid
      }
      programCategory
      programType
      startDate
    }
    pagination {
      nextPageToken
      page
      totalPages
      totalPerPage
      total
    }
  }
}
    `;

/**
 * __useFilterClassStudentQuery__
 *
 * To run a query within a React component, call `useFilterClassStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterClassStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterClassStudentQuery({
 *   variables: {
 *      form: // value for 'form'
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useFilterClassStudentQuery(baseOptions: Apollo.QueryHookOptions<FilterClassStudentQuery, FilterClassStudentQueryVariables>) {
        return Apollo.useQuery<FilterClassStudentQuery, FilterClassStudentQueryVariables>(FilterClassStudentDocument, baseOptions);
      }
export function useFilterClassStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterClassStudentQuery, FilterClassStudentQueryVariables>) {
          return Apollo.useLazyQuery<FilterClassStudentQuery, FilterClassStudentQueryVariables>(FilterClassStudentDocument, baseOptions);
        }
export type FilterClassStudentQueryHookResult = ReturnType<typeof useFilterClassStudentQuery>;
export type FilterClassStudentLazyQueryHookResult = ReturnType<typeof useFilterClassStudentLazyQuery>;
export type FilterClassStudentQueryResult = Apollo.QueryResult<FilterClassStudentQuery, FilterClassStudentQueryVariables>;
export const UpdateStudentDocument = gql`
    mutation updateStudent($form: UpdateStudentForm!, $studentId: String!) {
  updateStudent(form: $form, studentId: $studentId)
}
    `;
export type UpdateStudentMutationFn = Apollo.MutationFunction<UpdateStudentMutation, UpdateStudentMutationVariables>;

/**
 * __useUpdateStudentMutation__
 *
 * To run a mutation, you first call `useUpdateStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentMutation, { data, loading, error }] = useUpdateStudentMutation({
 *   variables: {
 *      form: // value for 'form'
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useUpdateStudentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentMutation, UpdateStudentMutationVariables>) {
        return Apollo.useMutation<UpdateStudentMutation, UpdateStudentMutationVariables>(UpdateStudentDocument, baseOptions);
      }
export type UpdateStudentMutationHookResult = ReturnType<typeof useUpdateStudentMutation>;
export type UpdateStudentMutationResult = Apollo.MutationResult<UpdateStudentMutation>;
export type UpdateStudentMutationOptions = Apollo.BaseMutationOptions<UpdateStudentMutation, UpdateStudentMutationVariables>;
export const RemoveStudentFromLessonDocument = gql`
    mutation removeStudentFromLesson($lessonId: String!, $studentId: String!) {
  removeStudentFromLesson(form: {lessonId: $lessonId, studentId: $studentId})
}
    `;
export type RemoveStudentFromLessonMutationFn = Apollo.MutationFunction<RemoveStudentFromLessonMutation, RemoveStudentFromLessonMutationVariables>;

/**
 * __useRemoveStudentFromLessonMutation__
 *
 * To run a mutation, you first call `useRemoveStudentFromLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStudentFromLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStudentFromLessonMutation, { data, loading, error }] = useRemoveStudentFromLessonMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useRemoveStudentFromLessonMutation(baseOptions?: Apollo.MutationHookOptions<RemoveStudentFromLessonMutation, RemoveStudentFromLessonMutationVariables>) {
        return Apollo.useMutation<RemoveStudentFromLessonMutation, RemoveStudentFromLessonMutationVariables>(RemoveStudentFromLessonDocument, baseOptions);
      }
export type RemoveStudentFromLessonMutationHookResult = ReturnType<typeof useRemoveStudentFromLessonMutation>;
export type RemoveStudentFromLessonMutationResult = Apollo.MutationResult<RemoveStudentFromLessonMutation>;
export type RemoveStudentFromLessonMutationOptions = Apollo.BaseMutationOptions<RemoveStudentFromLessonMutation, RemoveStudentFromLessonMutationVariables>;
export const EditAvatarDocument = gql`
    mutation editAvatar($id: uuid!, $imgUrl: String!) {
  update_users(where: {id: {_eq: $id}}, _set: {avatar: $imgUrl}) {
    affected_rows
  }
}
    `;
export type EditAvatarMutationFn = Apollo.MutationFunction<EditAvatarMutation, EditAvatarMutationVariables>;

/**
 * __useEditAvatarMutation__
 *
 * To run a mutation, you first call `useEditAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAvatarMutation, { data, loading, error }] = useEditAvatarMutation({
 *   variables: {
 *      id: // value for 'id'
 *      imgUrl: // value for 'imgUrl'
 *   },
 * });
 */
export function useEditAvatarMutation(baseOptions?: Apollo.MutationHookOptions<EditAvatarMutation, EditAvatarMutationVariables>) {
        return Apollo.useMutation<EditAvatarMutation, EditAvatarMutationVariables>(EditAvatarDocument, baseOptions);
      }
export type EditAvatarMutationHookResult = ReturnType<typeof useEditAvatarMutation>;
export type EditAvatarMutationResult = Apollo.MutationResult<EditAvatarMutation>;
export type EditAvatarMutationOptions = Apollo.BaseMutationOptions<EditAvatarMutation, EditAvatarMutationVariables>;
export const EditProfileDocument = gql`
    mutation editProfile($id: uuid!, $firstName: String!, $lastName: String!, $gender: String!, $dob: timestamptz!) {
  update_users(
    where: {id: {_eq: $id}}
    _set: {firstName: $firstName, lastName: $lastName, gender: $gender, dob: $dob}
  ) {
    affected_rows
  }
}
    `;
export type EditProfileMutationFn = Apollo.MutationFunction<EditProfileMutation, EditProfileMutationVariables>;

/**
 * __useEditProfileMutation__
 *
 * To run a mutation, you first call `useEditProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProfileMutation, { data, loading, error }] = useEditProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      gender: // value for 'gender'
 *      dob: // value for 'dob'
 *   },
 * });
 */
export function useEditProfileMutation(baseOptions?: Apollo.MutationHookOptions<EditProfileMutation, EditProfileMutationVariables>) {
        return Apollo.useMutation<EditProfileMutation, EditProfileMutationVariables>(EditProfileDocument, baseOptions);
      }
export type EditProfileMutationHookResult = ReturnType<typeof useEditProfileMutation>;
export type EditProfileMutationResult = Apollo.MutationResult<EditProfileMutation>;
export type EditProfileMutationOptions = Apollo.BaseMutationOptions<EditProfileMutation, EditProfileMutationVariables>;
export const ChangeUserAttributeDocument = gql`
    mutation changeUserAttribute($form: ChangeUserAttributeInput!) {
  changeUserAttribute(form: $form)
}
    `;
export type ChangeUserAttributeMutationFn = Apollo.MutationFunction<ChangeUserAttributeMutation, ChangeUserAttributeMutationVariables>;

/**
 * __useChangeUserAttributeMutation__
 *
 * To run a mutation, you first call `useChangeUserAttributeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUserAttributeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUserAttributeMutation, { data, loading, error }] = useChangeUserAttributeMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useChangeUserAttributeMutation(baseOptions?: Apollo.MutationHookOptions<ChangeUserAttributeMutation, ChangeUserAttributeMutationVariables>) {
        return Apollo.useMutation<ChangeUserAttributeMutation, ChangeUserAttributeMutationVariables>(ChangeUserAttributeDocument, baseOptions);
      }
export type ChangeUserAttributeMutationHookResult = ReturnType<typeof useChangeUserAttributeMutation>;
export type ChangeUserAttributeMutationResult = Apollo.MutationResult<ChangeUserAttributeMutation>;
export type ChangeUserAttributeMutationOptions = Apollo.BaseMutationOptions<ChangeUserAttributeMutation, ChangeUserAttributeMutationVariables>;
export const VerifyUserAttributeDocument = gql`
    mutation verifyUserAttribute($form: VerifyUserAttributeInput!) {
  verifyUserAttribute(form: $form)
}
    `;
export type VerifyUserAttributeMutationFn = Apollo.MutationFunction<VerifyUserAttributeMutation, VerifyUserAttributeMutationVariables>;

/**
 * __useVerifyUserAttributeMutation__
 *
 * To run a mutation, you first call `useVerifyUserAttributeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyUserAttributeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyUserAttributeMutation, { data, loading, error }] = useVerifyUserAttributeMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useVerifyUserAttributeMutation(baseOptions?: Apollo.MutationHookOptions<VerifyUserAttributeMutation, VerifyUserAttributeMutationVariables>) {
        return Apollo.useMutation<VerifyUserAttributeMutation, VerifyUserAttributeMutationVariables>(VerifyUserAttributeDocument, baseOptions);
      }
export type VerifyUserAttributeMutationHookResult = ReturnType<typeof useVerifyUserAttributeMutation>;
export type VerifyUserAttributeMutationResult = Apollo.MutationResult<VerifyUserAttributeMutation>;
export type VerifyUserAttributeMutationOptions = Apollo.BaseMutationOptions<VerifyUserAttributeMutation, VerifyUserAttributeMutationVariables>;
export const ResendVerificationCodeUserDocument = gql`
    mutation resendVerificationCodeUser($id: String!) {
  resendVerificationCodeUser(id: $id)
}
    `;
export type ResendVerificationCodeUserMutationFn = Apollo.MutationFunction<ResendVerificationCodeUserMutation, ResendVerificationCodeUserMutationVariables>;

/**
 * __useResendVerificationCodeUserMutation__
 *
 * To run a mutation, you first call `useResendVerificationCodeUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendVerificationCodeUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendVerificationCodeUserMutation, { data, loading, error }] = useResendVerificationCodeUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendVerificationCodeUserMutation(baseOptions?: Apollo.MutationHookOptions<ResendVerificationCodeUserMutation, ResendVerificationCodeUserMutationVariables>) {
        return Apollo.useMutation<ResendVerificationCodeUserMutation, ResendVerificationCodeUserMutationVariables>(ResendVerificationCodeUserDocument, baseOptions);
      }
export type ResendVerificationCodeUserMutationHookResult = ReturnType<typeof useResendVerificationCodeUserMutation>;
export type ResendVerificationCodeUserMutationResult = Apollo.MutationResult<ResendVerificationCodeUserMutation>;
export type ResendVerificationCodeUserMutationOptions = Apollo.BaseMutationOptions<ResendVerificationCodeUserMutation, ResendVerificationCodeUserMutationVariables>;
export const ResetUserPasswordDocument = gql`
    mutation resetUserPassword($id: String!) {
  resetUserPassword(id: $id)
}
    `;
export type ResetUserPasswordMutationFn = Apollo.MutationFunction<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;

/**
 * __useResetUserPasswordMutation__
 *
 * To run a mutation, you first call `useResetUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserPasswordMutation, { data, loading, error }] = useResetUserPasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResetUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>) {
        return Apollo.useMutation<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>(ResetUserPasswordDocument, baseOptions);
      }
export type ResetUserPasswordMutationHookResult = ReturnType<typeof useResetUserPasswordMutation>;
export type ResetUserPasswordMutationResult = Apollo.MutationResult<ResetUserPasswordMutation>;
export type ResetUserPasswordMutationOptions = Apollo.BaseMutationOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;
export const GetVerificationCodeDocument = gql`
    mutation getVerificationCode($form: GetVerificationCodeForm!) {
  getVerificationCode(form: $form)
}
    `;
export type GetVerificationCodeMutationFn = Apollo.MutationFunction<GetVerificationCodeMutation, GetVerificationCodeMutationVariables>;

/**
 * __useGetVerificationCodeMutation__
 *
 * To run a mutation, you first call `useGetVerificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetVerificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getVerificationCodeMutation, { data, loading, error }] = useGetVerificationCodeMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useGetVerificationCodeMutation(baseOptions?: Apollo.MutationHookOptions<GetVerificationCodeMutation, GetVerificationCodeMutationVariables>) {
        return Apollo.useMutation<GetVerificationCodeMutation, GetVerificationCodeMutationVariables>(GetVerificationCodeDocument, baseOptions);
      }
export type GetVerificationCodeMutationHookResult = ReturnType<typeof useGetVerificationCodeMutation>;
export type GetVerificationCodeMutationResult = Apollo.MutationResult<GetVerificationCodeMutation>;
export type GetVerificationCodeMutationOptions = Apollo.BaseMutationOptions<GetVerificationCodeMutation, GetVerificationCodeMutationVariables>;
export const ValidateClassesCapacityDocument = gql`
    mutation validateClassesCapacity($form: [FormClassInformation]!) {
  validateClassesCapacity(form: $form)
}
    `;
export type ValidateClassesCapacityMutationFn = Apollo.MutationFunction<ValidateClassesCapacityMutation, ValidateClassesCapacityMutationVariables>;

/**
 * __useValidateClassesCapacityMutation__
 *
 * To run a mutation, you first call `useValidateClassesCapacityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateClassesCapacityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateClassesCapacityMutation, { data, loading, error }] = useValidateClassesCapacityMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useValidateClassesCapacityMutation(baseOptions?: Apollo.MutationHookOptions<ValidateClassesCapacityMutation, ValidateClassesCapacityMutationVariables>) {
        return Apollo.useMutation<ValidateClassesCapacityMutation, ValidateClassesCapacityMutationVariables>(ValidateClassesCapacityDocument, baseOptions);
      }
export type ValidateClassesCapacityMutationHookResult = ReturnType<typeof useValidateClassesCapacityMutation>;
export type ValidateClassesCapacityMutationResult = Apollo.MutationResult<ValidateClassesCapacityMutation>;
export type ValidateClassesCapacityMutationOptions = Apollo.BaseMutationOptions<ValidateClassesCapacityMutation, ValidateClassesCapacityMutationVariables>;
export const GetPaymentAdviceLogsDocument = gql`
    query getPaymentAdviceLogs($offset: Int, $limit: Int, $paId: uuid!) {
  payment_advice_logs(
    offset: $offset
    limit: $limit
    order_by: {updatedAt: desc}
    where: {paymentAdviceId: {_eq: $paId}}
  ) {
    createdAt
    createdBy
    valueAfter
    valueBefore
    id
    updatedAt
    type
    user {
      fullName
      role
      id
    }
    paymentAdvice {
      id
      name
      paymentStatus
    }
  }
  payment_advice_logs_aggregate(where: {paymentAdviceId: {_eq: $paId}}) {
    aggregate {
      count(columns: id)
    }
  }
}
    `;

/**
 * __useGetPaymentAdviceLogsQuery__
 *
 * To run a query within a React component, call `useGetPaymentAdviceLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentAdviceLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentAdviceLogsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      paId: // value for 'paId'
 *   },
 * });
 */
export function useGetPaymentAdviceLogsQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentAdviceLogsQuery, GetPaymentAdviceLogsQueryVariables>) {
        return Apollo.useQuery<GetPaymentAdviceLogsQuery, GetPaymentAdviceLogsQueryVariables>(GetPaymentAdviceLogsDocument, baseOptions);
      }
export function useGetPaymentAdviceLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentAdviceLogsQuery, GetPaymentAdviceLogsQueryVariables>) {
          return Apollo.useLazyQuery<GetPaymentAdviceLogsQuery, GetPaymentAdviceLogsQueryVariables>(GetPaymentAdviceLogsDocument, baseOptions);
        }
export type GetPaymentAdviceLogsQueryHookResult = ReturnType<typeof useGetPaymentAdviceLogsQuery>;
export type GetPaymentAdviceLogsLazyQueryHookResult = ReturnType<typeof useGetPaymentAdviceLogsLazyQuery>;
export type GetPaymentAdviceLogsQueryResult = Apollo.QueryResult<GetPaymentAdviceLogsQuery, GetPaymentAdviceLogsQueryVariables>;
export const GetCreditNoteLogsDocument = gql`
    query getCreditNoteLogs($offset: Int, $limit: Int, $cnId: uuid!) {
  credit_note_logs(
    offset: $offset
    limit: $limit
    order_by: {updatedAt: desc}
    where: {creditNoteId: {_eq: $cnId}}
  ) {
    createdAt
    createdBy
    id
    user {
      role
      fullName
      id
    }
    creditNote {
      id
      name
    }
    type
    valueAfter
    valueBefore
    updatedAt
  }
  credit_note_logs_aggregate(where: {creditNoteId: {_eq: $cnId}}) {
    aggregate {
      count(columns: id)
    }
  }
}
    `;

/**
 * __useGetCreditNoteLogsQuery__
 *
 * To run a query within a React component, call `useGetCreditNoteLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditNoteLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditNoteLogsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      cnId: // value for 'cnId'
 *   },
 * });
 */
export function useGetCreditNoteLogsQuery(baseOptions: Apollo.QueryHookOptions<GetCreditNoteLogsQuery, GetCreditNoteLogsQueryVariables>) {
        return Apollo.useQuery<GetCreditNoteLogsQuery, GetCreditNoteLogsQueryVariables>(GetCreditNoteLogsDocument, baseOptions);
      }
export function useGetCreditNoteLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditNoteLogsQuery, GetCreditNoteLogsQueryVariables>) {
          return Apollo.useLazyQuery<GetCreditNoteLogsQuery, GetCreditNoteLogsQueryVariables>(GetCreditNoteLogsDocument, baseOptions);
        }
export type GetCreditNoteLogsQueryHookResult = ReturnType<typeof useGetCreditNoteLogsQuery>;
export type GetCreditNoteLogsLazyQueryHookResult = ReturnType<typeof useGetCreditNoteLogsLazyQuery>;
export type GetCreditNoteLogsQueryResult = Apollo.QueryResult<GetCreditNoteLogsQuery, GetCreditNoteLogsQueryVariables>;
export const GetRefundLogsDocument = gql`
    query getRefundLogs($offset: Int, $limit: Int, $rfId: uuid!) {
  refund_logs(
    offset: $offset
    limit: $limit
    order_by: {updatedAt: desc}
    where: {refundId: {_eq: $rfId}}
  ) {
    id
    refundId
    createdBy
    createdAt
    valueAfter
    valueBefore
    type
    user {
      id
      fullName
      role
    }
    refund {
      id
      name
    }
    updatedAt
  }
  refund_logs_aggregate(where: {refundId: {_eq: $rfId}}) {
    aggregate {
      count(columns: id)
    }
  }
}
    `;

/**
 * __useGetRefundLogsQuery__
 *
 * To run a query within a React component, call `useGetRefundLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRefundLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRefundLogsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      rfId: // value for 'rfId'
 *   },
 * });
 */
export function useGetRefundLogsQuery(baseOptions: Apollo.QueryHookOptions<GetRefundLogsQuery, GetRefundLogsQueryVariables>) {
        return Apollo.useQuery<GetRefundLogsQuery, GetRefundLogsQueryVariables>(GetRefundLogsDocument, baseOptions);
      }
export function useGetRefundLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRefundLogsQuery, GetRefundLogsQueryVariables>) {
          return Apollo.useLazyQuery<GetRefundLogsQuery, GetRefundLogsQueryVariables>(GetRefundLogsDocument, baseOptions);
        }
export type GetRefundLogsQueryHookResult = ReturnType<typeof useGetRefundLogsQuery>;
export type GetRefundLogsLazyQueryHookResult = ReturnType<typeof useGetRefundLogsLazyQuery>;
export type GetRefundLogsQueryResult = Apollo.QueryResult<GetRefundLogsQuery, GetRefundLogsQueryVariables>;
export const GetRefundLogsDetailDocument = gql`
    query getRefundLogsDetail($where: refund_logs_bool_exp) {
  refund_logs(where: $where) {
    id
    updatedAt
    type
    user {
      id
      fullName
      role
    }
    refund {
      id
      name
    }
    valueAfter
    valueBefore
  }
}
    `;

/**
 * __useGetRefundLogsDetailQuery__
 *
 * To run a query within a React component, call `useGetRefundLogsDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRefundLogsDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRefundLogsDetailQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetRefundLogsDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetRefundLogsDetailQuery, GetRefundLogsDetailQueryVariables>) {
        return Apollo.useQuery<GetRefundLogsDetailQuery, GetRefundLogsDetailQueryVariables>(GetRefundLogsDetailDocument, baseOptions);
      }
export function useGetRefundLogsDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRefundLogsDetailQuery, GetRefundLogsDetailQueryVariables>) {
          return Apollo.useLazyQuery<GetRefundLogsDetailQuery, GetRefundLogsDetailQueryVariables>(GetRefundLogsDetailDocument, baseOptions);
        }
export type GetRefundLogsDetailQueryHookResult = ReturnType<typeof useGetRefundLogsDetailQuery>;
export type GetRefundLogsDetailLazyQueryHookResult = ReturnType<typeof useGetRefundLogsDetailLazyQuery>;
export type GetRefundLogsDetailQueryResult = Apollo.QueryResult<GetRefundLogsDetailQuery, GetRefundLogsDetailQueryVariables>;
export const GetCreditNoteLogsDetailDocument = gql`
    query getCreditNoteLogsDetail($where: credit_note_logs_bool_exp) {
  credit_note_logs(where: $where) {
    id
    updatedAt
    type
    user {
      id
      fullName
      role
    }
    creditNote {
      id
      name
    }
    valueAfter
    valueBefore
  }
}
    `;

/**
 * __useGetCreditNoteLogsDetailQuery__
 *
 * To run a query within a React component, call `useGetCreditNoteLogsDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditNoteLogsDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditNoteLogsDetailQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetCreditNoteLogsDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetCreditNoteLogsDetailQuery, GetCreditNoteLogsDetailQueryVariables>) {
        return Apollo.useQuery<GetCreditNoteLogsDetailQuery, GetCreditNoteLogsDetailQueryVariables>(GetCreditNoteLogsDetailDocument, baseOptions);
      }
export function useGetCreditNoteLogsDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditNoteLogsDetailQuery, GetCreditNoteLogsDetailQueryVariables>) {
          return Apollo.useLazyQuery<GetCreditNoteLogsDetailQuery, GetCreditNoteLogsDetailQueryVariables>(GetCreditNoteLogsDetailDocument, baseOptions);
        }
export type GetCreditNoteLogsDetailQueryHookResult = ReturnType<typeof useGetCreditNoteLogsDetailQuery>;
export type GetCreditNoteLogsDetailLazyQueryHookResult = ReturnType<typeof useGetCreditNoteLogsDetailLazyQuery>;
export type GetCreditNoteLogsDetailQueryResult = Apollo.QueryResult<GetCreditNoteLogsDetailQuery, GetCreditNoteLogsDetailQueryVariables>;
export const GetPaymentAdviceLogsDetailDocument = gql`
    query getPaymentAdviceLogsDetail($where: payment_advice_logs_bool_exp) {
  payment_advice_logs(where: $where) {
    id
    updatedAt
    type
    user {
      id
      fullName
      role
    }
    valueAfter
    valueBefore
    paymentAdvice {
      id
      name
      paymentStatus
    }
  }
}
    `;

/**
 * __useGetPaymentAdviceLogsDetailQuery__
 *
 * To run a query within a React component, call `useGetPaymentAdviceLogsDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentAdviceLogsDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentAdviceLogsDetailQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetPaymentAdviceLogsDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentAdviceLogsDetailQuery, GetPaymentAdviceLogsDetailQueryVariables>) {
        return Apollo.useQuery<GetPaymentAdviceLogsDetailQuery, GetPaymentAdviceLogsDetailQueryVariables>(GetPaymentAdviceLogsDetailDocument, baseOptions);
      }
export function useGetPaymentAdviceLogsDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentAdviceLogsDetailQuery, GetPaymentAdviceLogsDetailQueryVariables>) {
          return Apollo.useLazyQuery<GetPaymentAdviceLogsDetailQuery, GetPaymentAdviceLogsDetailQueryVariables>(GetPaymentAdviceLogsDetailDocument, baseOptions);
        }
export type GetPaymentAdviceLogsDetailQueryHookResult = ReturnType<typeof useGetPaymentAdviceLogsDetailQuery>;
export type GetPaymentAdviceLogsDetailLazyQueryHookResult = ReturnType<typeof useGetPaymentAdviceLogsDetailLazyQuery>;
export type GetPaymentAdviceLogsDetailQueryResult = Apollo.QueryResult<GetPaymentAdviceLogsDetailQuery, GetPaymentAdviceLogsDetailQueryVariables>;
export const CreatePaymentAdviceDocument = gql`
    mutation createPaymentAdvice($form: FormPaymentAdvice!) {
  createPaymentAdvice(form: $form) {
    ...paymentAdviceModelFragment
  }
}
    ${PaymentAdviceModelFragmentFragmentDoc}`;
export type CreatePaymentAdviceMutationFn = Apollo.MutationFunction<CreatePaymentAdviceMutation, CreatePaymentAdviceMutationVariables>;

/**
 * __useCreatePaymentAdviceMutation__
 *
 * To run a mutation, you first call `useCreatePaymentAdviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentAdviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentAdviceMutation, { data, loading, error }] = useCreatePaymentAdviceMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useCreatePaymentAdviceMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentAdviceMutation, CreatePaymentAdviceMutationVariables>) {
        return Apollo.useMutation<CreatePaymentAdviceMutation, CreatePaymentAdviceMutationVariables>(CreatePaymentAdviceDocument, baseOptions);
      }
export type CreatePaymentAdviceMutationHookResult = ReturnType<typeof useCreatePaymentAdviceMutation>;
export type CreatePaymentAdviceMutationResult = Apollo.MutationResult<CreatePaymentAdviceMutation>;
export type CreatePaymentAdviceMutationOptions = Apollo.BaseMutationOptions<CreatePaymentAdviceMutation, CreatePaymentAdviceMutationVariables>;
export const UpdatePaymentAdviceDocument = gql`
    mutation updatePaymentAdvice($saveForm: Boolean!, $id: String!, $form: FormPaymentAdvice!) {
  updatePaymentAdvice(form: $form, id: $id, saveForm: $saveForm) {
    id
    branch {
      address
      id
      name
    }
    classInformation {
      data {
        additionalLesson {
          pricing
          quantity
          total
        }
        classStatus
        classType
        id
        lessonStartDate
        name
        period {
          endDate
          startDate
        }
        terms {
          id
          lessonIds
          lessons
          name
          pricing
          total
        }
        discounts {
          amount
          code
          id
          name
          unit
        }
        additionalDiscount
        total
        totalDiscount
      }
      total
    }
    deduction {
      data {
        amount
        name
      }
      total
    }
    deposit {
      data {
        amount
        name
      }
      total
    }
    dueDate
    isRegistrationFee
    issueDate
    name
    otherPayments {
      data {
        amount
        name
      }
      total
    }
    paymentStatus
    remarks
    notes
    student {
      email
      fullName
      id
      phoneNumber
      studentId
      studentProfile {
        willPayLater
        school {
          id
          name
        }
      }
      username
    }
    summary {
      classFee
      deduction
      deposit
      gst
      otherPayments
      registrationFee
      totalAfterGst
      totalBeforeGst
      totalPayable
    }
  }
}
    `;
export type UpdatePaymentAdviceMutationFn = Apollo.MutationFunction<UpdatePaymentAdviceMutation, UpdatePaymentAdviceMutationVariables>;

/**
 * __useUpdatePaymentAdviceMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentAdviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentAdviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentAdviceMutation, { data, loading, error }] = useUpdatePaymentAdviceMutation({
 *   variables: {
 *      saveForm: // value for 'saveForm'
 *      id: // value for 'id'
 *      form: // value for 'form'
 *   },
 * });
 */
export function useUpdatePaymentAdviceMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentAdviceMutation, UpdatePaymentAdviceMutationVariables>) {
        return Apollo.useMutation<UpdatePaymentAdviceMutation, UpdatePaymentAdviceMutationVariables>(UpdatePaymentAdviceDocument, baseOptions);
      }
export type UpdatePaymentAdviceMutationHookResult = ReturnType<typeof useUpdatePaymentAdviceMutation>;
export type UpdatePaymentAdviceMutationResult = Apollo.MutationResult<UpdatePaymentAdviceMutation>;
export type UpdatePaymentAdviceMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentAdviceMutation, UpdatePaymentAdviceMutationVariables>;
export const GetDetailPaymentAdviceDocument = gql`
    query getDetailPaymentAdvice($id: String!) {
  getDetailPaymentAdvice(id: $id) {
    id
    branch {
      address
      id
      name
    }
    classInformation {
      data {
        additionalLesson {
          pricing
          quantity
          total
        }
        classStatus
        classType
        programId
        id
        lessonStartDate
        name
        period {
          endDate
          startDate
        }
        terms {
          id
          lessonIds
          lessons
          name
          pricing
          total
        }
        discounts {
          amount
          code
          id
          name
          unit
        }
        additionalDiscount
        total
        totalDiscount
      }
      total
    }
    deduction {
      data {
        amount
        name
      }
      total
    }
    deposit {
      data {
        amount
        name
      }
      total
    }
    dueDate
    isRegistrationFee
    issueDate
    name
    notes
    qrCodeLink
    qrExpiryDate
    otherPayments {
      data {
        amount
        name
      }
      total
    }
    paymentStatus
    remarks
    student {
      email
      fullName
      id
      phoneNumber
      studentId
      studentProfile {
        willPayLater
        school {
          id
          name
        }
      }
      username
    }
    transferBill {
      ...TransferBillFragment
    }
    summary {
      classFee
      deduction
      deposit
      gst
      otherPayments
      registrationFee
      totalAfterGst
      totalBeforeGst
      totalPayable
    }
  }
}
    ${TransferBillFragmentFragmentDoc}`;

/**
 * __useGetDetailPaymentAdviceQuery__
 *
 * To run a query within a React component, call `useGetDetailPaymentAdviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailPaymentAdviceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailPaymentAdviceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDetailPaymentAdviceQuery(baseOptions: Apollo.QueryHookOptions<GetDetailPaymentAdviceQuery, GetDetailPaymentAdviceQueryVariables>) {
        return Apollo.useQuery<GetDetailPaymentAdviceQuery, GetDetailPaymentAdviceQueryVariables>(GetDetailPaymentAdviceDocument, baseOptions);
      }
export function useGetDetailPaymentAdviceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDetailPaymentAdviceQuery, GetDetailPaymentAdviceQueryVariables>) {
          return Apollo.useLazyQuery<GetDetailPaymentAdviceQuery, GetDetailPaymentAdviceQueryVariables>(GetDetailPaymentAdviceDocument, baseOptions);
        }
export type GetDetailPaymentAdviceQueryHookResult = ReturnType<typeof useGetDetailPaymentAdviceQuery>;
export type GetDetailPaymentAdviceLazyQueryHookResult = ReturnType<typeof useGetDetailPaymentAdviceLazyQuery>;
export type GetDetailPaymentAdviceQueryResult = Apollo.QueryResult<GetDetailPaymentAdviceQuery, GetDetailPaymentAdviceQueryVariables>;
export const GetDetailPaymentAdvicePaperDocument = gql`
    query getDetailPaymentAdvicePaper($id: String!, $invoiceId: String) {
  getDetailPaymentAdvicePaper(id: $id, invoiceId: $invoiceId) {
    branch {
      ...MasterDataAtPaymentAdviceFragment
    }
    transferBill {
      ...TransferBillFragment
    }
    classInformation {
      total
      data {
        subject
        classType
        curriculums
        levels
        additionalLesson {
          pricing
          quantity
          total
        }
        firstSession {
          startTime
          endTime
        }
        branch
        id
        name
        lessonStartDate
        period {
          endDate
          startDate
        }
        terms {
          academicYear
          endDate
          lessons
          pricing
          startDate
          name
        }
        discounts {
          amount
          code
          id
          name
          unit
        }
        additionalDiscount
        total
        totalDiscount
      }
    }
    deduction {
      ...OutFeeFragment
    }
    dueDate
    id
    isRegistrationFee
    issueDate
    name
    notes
    link
    qrCodeLink
    qrReferenceNo
    qrExpiryDate
    otherPayments {
      ...OutFeeFragment
    }
    deposit {
      ...OutFeeFragment
    }
    partials {
      data {
        branch {
          address
          id
          name
        }
        amount
        bankName
        cardNumber
        creditNote
        cardType
        id
        order
        paymentMethod
      }
      total
    }
    paymentStatus
    student {
      ...StudentModelFragment
    }
    summary {
      ...SummaryFragment
    }
    remarks
  }
}
    ${MasterDataAtPaymentAdviceFragmentFragmentDoc}
${TransferBillFragmentFragmentDoc}
${OutFeeFragmentFragmentDoc}
${StudentModelFragmentFragmentDoc}
${SummaryFragmentFragmentDoc}`;

/**
 * __useGetDetailPaymentAdvicePaperQuery__
 *
 * To run a query within a React component, call `useGetDetailPaymentAdvicePaperQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailPaymentAdvicePaperQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailPaymentAdvicePaperQuery({
 *   variables: {
 *      id: // value for 'id'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetDetailPaymentAdvicePaperQuery(baseOptions: Apollo.QueryHookOptions<GetDetailPaymentAdvicePaperQuery, GetDetailPaymentAdvicePaperQueryVariables>) {
        return Apollo.useQuery<GetDetailPaymentAdvicePaperQuery, GetDetailPaymentAdvicePaperQueryVariables>(GetDetailPaymentAdvicePaperDocument, baseOptions);
      }
export function useGetDetailPaymentAdvicePaperLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDetailPaymentAdvicePaperQuery, GetDetailPaymentAdvicePaperQueryVariables>) {
          return Apollo.useLazyQuery<GetDetailPaymentAdvicePaperQuery, GetDetailPaymentAdvicePaperQueryVariables>(GetDetailPaymentAdvicePaperDocument, baseOptions);
        }
export type GetDetailPaymentAdvicePaperQueryHookResult = ReturnType<typeof useGetDetailPaymentAdvicePaperQuery>;
export type GetDetailPaymentAdvicePaperLazyQueryHookResult = ReturnType<typeof useGetDetailPaymentAdvicePaperLazyQuery>;
export type GetDetailPaymentAdvicePaperQueryResult = Apollo.QueryResult<GetDetailPaymentAdvicePaperQuery, GetDetailPaymentAdvicePaperQueryVariables>;
export const UpdatePaymentAdvicesDocument = gql`
    mutation updatePaymentAdvices($id: uuid!, $form: payment_advices_set_input) {
  update_payment_advices(where: {id: {_eq: $id}}, _set: $form) {
    affected_rows
    returning {
      ...paymentAdvicesFragment
    }
  }
}
    ${PaymentAdvicesFragmentFragmentDoc}`;
export type UpdatePaymentAdvicesMutationFn = Apollo.MutationFunction<UpdatePaymentAdvicesMutation, UpdatePaymentAdvicesMutationVariables>;

/**
 * __useUpdatePaymentAdvicesMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentAdvicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentAdvicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentAdvicesMutation, { data, loading, error }] = useUpdatePaymentAdvicesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      form: // value for 'form'
 *   },
 * });
 */
export function useUpdatePaymentAdvicesMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentAdvicesMutation, UpdatePaymentAdvicesMutationVariables>) {
        return Apollo.useMutation<UpdatePaymentAdvicesMutation, UpdatePaymentAdvicesMutationVariables>(UpdatePaymentAdvicesDocument, baseOptions);
      }
export type UpdatePaymentAdvicesMutationHookResult = ReturnType<typeof useUpdatePaymentAdvicesMutation>;
export type UpdatePaymentAdvicesMutationResult = Apollo.MutationResult<UpdatePaymentAdvicesMutation>;
export type UpdatePaymentAdvicesMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentAdvicesMutation, UpdatePaymentAdvicesMutationVariables>;
export const PaymentAdvicesDocument = gql`
    query paymentAdvices($limit: Int, $offset: Int, $filter: payment_advices_bool_exp) {
  payment_advices(
    limit: $limit
    offset: $offset
    order_by: {issueDate: desc}
    where: $filter
  ) {
    ...paymentAdvicesFragment
    qrReferenceNo
  }
  payment_advices_aggregate(where: $filter) {
    aggregate {
      count(columns: id)
    }
  }
}
    ${PaymentAdvicesFragmentFragmentDoc}`;

/**
 * __usePaymentAdvicesQuery__
 *
 * To run a query within a React component, call `usePaymentAdvicesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentAdvicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentAdvicesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePaymentAdvicesQuery(baseOptions?: Apollo.QueryHookOptions<PaymentAdvicesQuery, PaymentAdvicesQueryVariables>) {
        return Apollo.useQuery<PaymentAdvicesQuery, PaymentAdvicesQueryVariables>(PaymentAdvicesDocument, baseOptions);
      }
export function usePaymentAdvicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentAdvicesQuery, PaymentAdvicesQueryVariables>) {
          return Apollo.useLazyQuery<PaymentAdvicesQuery, PaymentAdvicesQueryVariables>(PaymentAdvicesDocument, baseOptions);
        }
export type PaymentAdvicesQueryHookResult = ReturnType<typeof usePaymentAdvicesQuery>;
export type PaymentAdvicesLazyQueryHookResult = ReturnType<typeof usePaymentAdvicesLazyQuery>;
export type PaymentAdvicesQueryResult = Apollo.QueryResult<PaymentAdvicesQuery, PaymentAdvicesQueryVariables>;
export const PaymentAdviceFilterDocument = gql`
    query paymentAdviceFilter($args: payment_advice_filter_args!, $limit: Int!, $offset: Int!, $where: payment_advices_bool_exp) {
  payment_advice_filter(
    args: $args
    limit: $limit
    offset: $offset
    where: $where
    order_by: {createdAt: desc}
  ) {
    ...paymentAdvicesFragment
  }
  payment_advice_filter_aggregate(args: $args, where: $where) {
    aggregate {
      count(columns: id)
    }
  }
}
    ${PaymentAdvicesFragmentFragmentDoc}`;

/**
 * __usePaymentAdviceFilterQuery__
 *
 * To run a query within a React component, call `usePaymentAdviceFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentAdviceFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentAdviceFilterQuery({
 *   variables: {
 *      args: // value for 'args'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePaymentAdviceFilterQuery(baseOptions: Apollo.QueryHookOptions<PaymentAdviceFilterQuery, PaymentAdviceFilterQueryVariables>) {
        return Apollo.useQuery<PaymentAdviceFilterQuery, PaymentAdviceFilterQueryVariables>(PaymentAdviceFilterDocument, baseOptions);
      }
export function usePaymentAdviceFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentAdviceFilterQuery, PaymentAdviceFilterQueryVariables>) {
          return Apollo.useLazyQuery<PaymentAdviceFilterQuery, PaymentAdviceFilterQueryVariables>(PaymentAdviceFilterDocument, baseOptions);
        }
export type PaymentAdviceFilterQueryHookResult = ReturnType<typeof usePaymentAdviceFilterQuery>;
export type PaymentAdviceFilterLazyQueryHookResult = ReturnType<typeof usePaymentAdviceFilterLazyQuery>;
export type PaymentAdviceFilterQueryResult = Apollo.QueryResult<PaymentAdviceFilterQuery, PaymentAdviceFilterQueryVariables>;
export const GetPaymentInvoiceListDocument = gql`
    query getPaymentInvoiceList($args: invoice_filter_args!, $limit: Int!, $offset: Int!, $where: invoices_bool_exp) {
  invoice_filter(
    args: $args
    limit: $limit
    offset: $offset
    where: $where
    order_by: {createdAt: desc}
  ) {
    id
    createdAt
    name
    invoiceStatus
    total
    pa {
      id
      dueDate
      student {
        fullName
        id
        username
        subjects {
          id
          name
        }
        studentProfile {
          id
          curriculum {
            abbreviation
            id
          }
        }
      }
    }
  }
  invoice_filter_aggregate(args: $args, where: $where) {
    aggregate {
      count(columns: id)
    }
  }
}
    `;

/**
 * __useGetPaymentInvoiceListQuery__
 *
 * To run a query within a React component, call `useGetPaymentInvoiceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentInvoiceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentInvoiceListQuery({
 *   variables: {
 *      args: // value for 'args'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetPaymentInvoiceListQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentInvoiceListQuery, GetPaymentInvoiceListQueryVariables>) {
        return Apollo.useQuery<GetPaymentInvoiceListQuery, GetPaymentInvoiceListQueryVariables>(GetPaymentInvoiceListDocument, baseOptions);
      }
export function useGetPaymentInvoiceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentInvoiceListQuery, GetPaymentInvoiceListQueryVariables>) {
          return Apollo.useLazyQuery<GetPaymentInvoiceListQuery, GetPaymentInvoiceListQueryVariables>(GetPaymentInvoiceListDocument, baseOptions);
        }
export type GetPaymentInvoiceListQueryHookResult = ReturnType<typeof useGetPaymentInvoiceListQuery>;
export type GetPaymentInvoiceListLazyQueryHookResult = ReturnType<typeof useGetPaymentInvoiceListLazyQuery>;
export type GetPaymentInvoiceListQueryResult = Apollo.QueryResult<GetPaymentInvoiceListQuery, GetPaymentInvoiceListQueryVariables>;
export const GetInvoicesDocument = gql`
    query getInvoices($where: invoices_bool_exp, $date: timestamptz, $filterClass: payment_advice_classes_bool_exp) {
  invoices(where: $where) {
    pa {
      paymentAdviceClasses(where: $filterClass) {
        class {
          id
          name
          startDate
          classStatus
          lessonType
          createdAt
          program {
            id
            name
            category
            subject {
              id
              name
              abbreviation
            }
          }
          programTypeGeneral {
            id
            shortName
            fullName
          }
          programTypeRegular {
            id
            fullName
            shortName
          }
          programTypeSpecial {
            id
            fullName
            shortName
          }
          lessons(where: {date: {_gte: $date}}) {
            id
            date
            lessonStatus
            orderPriority
            termClass {
              termName
            }
            classroom {
              branch {
                id
                name
                abbreviation
              }
            }
            sessions {
              id
              endTime
              startTime
              orderPriority
            }
          }
        }
        paymentAdviceTermClasses {
          termClass {
            termName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetInvoicesQuery__
 *
 * To run a query within a React component, call `useGetInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      date: // value for 'date'
 *      filterClass: // value for 'filterClass'
 *   },
 * });
 */
export function useGetInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
        return Apollo.useQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, baseOptions);
      }
export function useGetInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
          return Apollo.useLazyQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, baseOptions);
        }
export type GetInvoicesQueryHookResult = ReturnType<typeof useGetInvoicesQuery>;
export type GetInvoicesLazyQueryHookResult = ReturnType<typeof useGetInvoicesLazyQuery>;
export type GetInvoicesQueryResult = Apollo.QueryResult<GetInvoicesQuery, GetInvoicesQueryVariables>;
export const GetInvoiceByIdDocument = gql`
    query getInvoiceById($id: uuid!) {
  invoices(where: {id: {_eq: $id}}) {
    name
    createdAt
    invoiceStatus
    notes
    isGeneratedReceipt
    link
    pa {
      id
      student {
        id
        studentProfile {
          payment
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetInvoiceByIdQuery__
 *
 * To run a query within a React component, call `useGetInvoiceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInvoiceByIdQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceByIdQuery, GetInvoiceByIdQueryVariables>) {
        return Apollo.useQuery<GetInvoiceByIdQuery, GetInvoiceByIdQueryVariables>(GetInvoiceByIdDocument, baseOptions);
      }
export function useGetInvoiceByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceByIdQuery, GetInvoiceByIdQueryVariables>) {
          return Apollo.useLazyQuery<GetInvoiceByIdQuery, GetInvoiceByIdQueryVariables>(GetInvoiceByIdDocument, baseOptions);
        }
export type GetInvoiceByIdQueryHookResult = ReturnType<typeof useGetInvoiceByIdQuery>;
export type GetInvoiceByIdLazyQueryHookResult = ReturnType<typeof useGetInvoiceByIdLazyQuery>;
export type GetInvoiceByIdQueryResult = Apollo.QueryResult<GetInvoiceByIdQuery, GetInvoiceByIdQueryVariables>;
export const GetInvoiceByPaIdDocument = gql`
    query getInvoiceByPaId($id: uuid!) {
  invoices(where: {paymentAdviceId: {_eq: $id}}) {
    name
    createdAt
    invoiceStatus
    notes
    isGeneratedReceipt
    link
    id
    pa {
      id
      student {
        id
        studentProfile {
          payment
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetInvoiceByPaIdQuery__
 *
 * To run a query within a React component, call `useGetInvoiceByPaIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceByPaIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceByPaIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInvoiceByPaIdQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceByPaIdQuery, GetInvoiceByPaIdQueryVariables>) {
        return Apollo.useQuery<GetInvoiceByPaIdQuery, GetInvoiceByPaIdQueryVariables>(GetInvoiceByPaIdDocument, baseOptions);
      }
export function useGetInvoiceByPaIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceByPaIdQuery, GetInvoiceByPaIdQueryVariables>) {
          return Apollo.useLazyQuery<GetInvoiceByPaIdQuery, GetInvoiceByPaIdQueryVariables>(GetInvoiceByPaIdDocument, baseOptions);
        }
export type GetInvoiceByPaIdQueryHookResult = ReturnType<typeof useGetInvoiceByPaIdQuery>;
export type GetInvoiceByPaIdLazyQueryHookResult = ReturnType<typeof useGetInvoiceByPaIdLazyQuery>;
export type GetInvoiceByPaIdQueryResult = Apollo.QueryResult<GetInvoiceByPaIdQuery, GetInvoiceByPaIdQueryVariables>;
export const GetPaymentReceiptListDocument = gql`
    query getPaymentReceiptList($args: receipt_filter_args!, $limit: Int, $offset: Int, $where: receipts_bool_exp) {
  receipt_filter(
    args: $args
    limit: $limit
    offset: $offset
    where: $where
    order_by: {createdAt: desc}
  ) {
    id
    link
    invoiceId
    name
    status
    receiptDate
    createdAt
    invoice {
      id
      paymentAdviceId
      total
      pa {
        id
        student {
          id
          fullName
          username
        }
        dueDate
      }
      createdAt
    }
  }
  receipt_filter_aggregate(args: $args, where: $where) {
    aggregate {
      count(columns: id)
    }
  }
}
    `;

/**
 * __useGetPaymentReceiptListQuery__
 *
 * To run a query within a React component, call `useGetPaymentReceiptListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentReceiptListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentReceiptListQuery({
 *   variables: {
 *      args: // value for 'args'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetPaymentReceiptListQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentReceiptListQuery, GetPaymentReceiptListQueryVariables>) {
        return Apollo.useQuery<GetPaymentReceiptListQuery, GetPaymentReceiptListQueryVariables>(GetPaymentReceiptListDocument, baseOptions);
      }
export function useGetPaymentReceiptListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentReceiptListQuery, GetPaymentReceiptListQueryVariables>) {
          return Apollo.useLazyQuery<GetPaymentReceiptListQuery, GetPaymentReceiptListQueryVariables>(GetPaymentReceiptListDocument, baseOptions);
        }
export type GetPaymentReceiptListQueryHookResult = ReturnType<typeof useGetPaymentReceiptListQuery>;
export type GetPaymentReceiptListLazyQueryHookResult = ReturnType<typeof useGetPaymentReceiptListLazyQuery>;
export type GetPaymentReceiptListQueryResult = Apollo.QueryResult<GetPaymentReceiptListQuery, GetPaymentReceiptListQueryVariables>;
export const FilterReceiptListDocument = gql`
    query filterReceiptList($filter: receipts_bool_exp) {
  receipts(where: $filter) {
    id
    link
    invoiceId
    name
    status
    createdAt
    receiptDate
    invoice {
      id
      paymentAdviceId
      total
      pa {
        id
        paymentSummaryStatic
        student {
          id
          fullName
          username
        }
        dueDate
      }
      createdAt
    }
  }
}
    `;

/**
 * __useFilterReceiptListQuery__
 *
 * To run a query within a React component, call `useFilterReceiptListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterReceiptListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterReceiptListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFilterReceiptListQuery(baseOptions?: Apollo.QueryHookOptions<FilterReceiptListQuery, FilterReceiptListQueryVariables>) {
        return Apollo.useQuery<FilterReceiptListQuery, FilterReceiptListQueryVariables>(FilterReceiptListDocument, baseOptions);
      }
export function useFilterReceiptListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterReceiptListQuery, FilterReceiptListQueryVariables>) {
          return Apollo.useLazyQuery<FilterReceiptListQuery, FilterReceiptListQueryVariables>(FilterReceiptListDocument, baseOptions);
        }
export type FilterReceiptListQueryHookResult = ReturnType<typeof useFilterReceiptListQuery>;
export type FilterReceiptListLazyQueryHookResult = ReturnType<typeof useFilterReceiptListLazyQuery>;
export type FilterReceiptListQueryResult = Apollo.QueryResult<FilterReceiptListQuery, FilterReceiptListQueryVariables>;
export const GetPaymentAdviceByPkDocument = gql`
    query getPaymentAdviceByPk($paymentAdviceId: uuid!) {
  payment_advices_by_pk(id: $paymentAdviceId) {
    paymentAdviceClasses {
      class {
        id
        lessons {
          id
        }
      }
    }
  }
  invoices_aggregate(where: {paymentAdviceId: {_eq: $paymentAdviceId}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetPaymentAdviceByPkQuery__
 *
 * To run a query within a React component, call `useGetPaymentAdviceByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentAdviceByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentAdviceByPkQuery({
 *   variables: {
 *      paymentAdviceId: // value for 'paymentAdviceId'
 *   },
 * });
 */
export function useGetPaymentAdviceByPkQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentAdviceByPkQuery, GetPaymentAdviceByPkQueryVariables>) {
        return Apollo.useQuery<GetPaymentAdviceByPkQuery, GetPaymentAdviceByPkQueryVariables>(GetPaymentAdviceByPkDocument, baseOptions);
      }
export function useGetPaymentAdviceByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentAdviceByPkQuery, GetPaymentAdviceByPkQueryVariables>) {
          return Apollo.useLazyQuery<GetPaymentAdviceByPkQuery, GetPaymentAdviceByPkQueryVariables>(GetPaymentAdviceByPkDocument, baseOptions);
        }
export type GetPaymentAdviceByPkQueryHookResult = ReturnType<typeof useGetPaymentAdviceByPkQuery>;
export type GetPaymentAdviceByPkLazyQueryHookResult = ReturnType<typeof useGetPaymentAdviceByPkLazyQuery>;
export type GetPaymentAdviceByPkQueryResult = Apollo.QueryResult<GetPaymentAdviceByPkQuery, GetPaymentAdviceByPkQueryVariables>;
export const CreateInvoiceDocument = gql`
    mutation createInvoice($form: FormCreateInvoice!) {
  createInvoice(form: $form)
}
    `;
export type CreateInvoiceMutationFn = Apollo.MutationFunction<CreateInvoiceMutation, CreateInvoiceMutationVariables>;

/**
 * __useCreateInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceMutation, { data, loading, error }] = useCreateInvoiceMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useCreateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvoiceMutation, CreateInvoiceMutationVariables>) {
        return Apollo.useMutation<CreateInvoiceMutation, CreateInvoiceMutationVariables>(CreateInvoiceDocument, baseOptions);
      }
export type CreateInvoiceMutationHookResult = ReturnType<typeof useCreateInvoiceMutation>;
export type CreateInvoiceMutationResult = Apollo.MutationResult<CreateInvoiceMutation>;
export type CreateInvoiceMutationOptions = Apollo.BaseMutationOptions<CreateInvoiceMutation, CreateInvoiceMutationVariables>;
export const GetReceiptByIdDocument = gql`
    query getReceiptByID($id: uuid!) {
  receipts(where: {id: {_eq: $id}}) {
    id
    name
    updatedAt
    invoiceId
    link
    status
    createdAt
    receiptDate
    invoice {
      id
      notes
      paymentAdviceId
    }
  }
}
    `;

/**
 * __useGetReceiptByIdQuery__
 *
 * To run a query within a React component, call `useGetReceiptByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceiptByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceiptByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReceiptByIdQuery(baseOptions: Apollo.QueryHookOptions<GetReceiptByIdQuery, GetReceiptByIdQueryVariables>) {
        return Apollo.useQuery<GetReceiptByIdQuery, GetReceiptByIdQueryVariables>(GetReceiptByIdDocument, baseOptions);
      }
export function useGetReceiptByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReceiptByIdQuery, GetReceiptByIdQueryVariables>) {
          return Apollo.useLazyQuery<GetReceiptByIdQuery, GetReceiptByIdQueryVariables>(GetReceiptByIdDocument, baseOptions);
        }
export type GetReceiptByIdQueryHookResult = ReturnType<typeof useGetReceiptByIdQuery>;
export type GetReceiptByIdLazyQueryHookResult = ReturnType<typeof useGetReceiptByIdLazyQuery>;
export type GetReceiptByIdQueryResult = Apollo.QueryResult<GetReceiptByIdQuery, GetReceiptByIdQueryVariables>;
export const GetReceiptByInvoiceIdDocument = gql`
    query getReceiptByInvoiceID($id: uuid!) {
  receipts(where: {invoiceId: {_eq: $id}}) {
    id
    name
    updatedAt
    invoiceId
    link
    status
    createdAt
  }
}
    `;

/**
 * __useGetReceiptByInvoiceIdQuery__
 *
 * To run a query within a React component, call `useGetReceiptByInvoiceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceiptByInvoiceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceiptByInvoiceIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReceiptByInvoiceIdQuery(baseOptions: Apollo.QueryHookOptions<GetReceiptByInvoiceIdQuery, GetReceiptByInvoiceIdQueryVariables>) {
        return Apollo.useQuery<GetReceiptByInvoiceIdQuery, GetReceiptByInvoiceIdQueryVariables>(GetReceiptByInvoiceIdDocument, baseOptions);
      }
export function useGetReceiptByInvoiceIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReceiptByInvoiceIdQuery, GetReceiptByInvoiceIdQueryVariables>) {
          return Apollo.useLazyQuery<GetReceiptByInvoiceIdQuery, GetReceiptByInvoiceIdQueryVariables>(GetReceiptByInvoiceIdDocument, baseOptions);
        }
export type GetReceiptByInvoiceIdQueryHookResult = ReturnType<typeof useGetReceiptByInvoiceIdQuery>;
export type GetReceiptByInvoiceIdLazyQueryHookResult = ReturnType<typeof useGetReceiptByInvoiceIdLazyQuery>;
export type GetReceiptByInvoiceIdQueryResult = Apollo.QueryResult<GetReceiptByInvoiceIdQuery, GetReceiptByInvoiceIdQueryVariables>;
export const GetReceiptByPaIdDocument = gql`
    query getReceiptByPAId($id: uuid!) {
  receipts(where: {invoice: {paymentAdviceId: {_eq: $id}}}) {
    id
    name
    updatedAt
    invoiceId
    link
    status
    createdAt
  }
}
    `;

/**
 * __useGetReceiptByPaIdQuery__
 *
 * To run a query within a React component, call `useGetReceiptByPaIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceiptByPaIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceiptByPaIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReceiptByPaIdQuery(baseOptions: Apollo.QueryHookOptions<GetReceiptByPaIdQuery, GetReceiptByPaIdQueryVariables>) {
        return Apollo.useQuery<GetReceiptByPaIdQuery, GetReceiptByPaIdQueryVariables>(GetReceiptByPaIdDocument, baseOptions);
      }
export function useGetReceiptByPaIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReceiptByPaIdQuery, GetReceiptByPaIdQueryVariables>) {
          return Apollo.useLazyQuery<GetReceiptByPaIdQuery, GetReceiptByPaIdQueryVariables>(GetReceiptByPaIdDocument, baseOptions);
        }
export type GetReceiptByPaIdQueryHookResult = ReturnType<typeof useGetReceiptByPaIdQuery>;
export type GetReceiptByPaIdLazyQueryHookResult = ReturnType<typeof useGetReceiptByPaIdLazyQuery>;
export type GetReceiptByPaIdQueryResult = Apollo.QueryResult<GetReceiptByPaIdQuery, GetReceiptByPaIdQueryVariables>;
export const CreateReceiptDocument = gql`
    mutation createReceipt($invoiceId: String!) {
  createReceipt(invoiceId: $invoiceId)
}
    `;
export type CreateReceiptMutationFn = Apollo.MutationFunction<CreateReceiptMutation, CreateReceiptMutationVariables>;

/**
 * __useCreateReceiptMutation__
 *
 * To run a mutation, you first call `useCreateReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReceiptMutation, { data, loading, error }] = useCreateReceiptMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useCreateReceiptMutation(baseOptions?: Apollo.MutationHookOptions<CreateReceiptMutation, CreateReceiptMutationVariables>) {
        return Apollo.useMutation<CreateReceiptMutation, CreateReceiptMutationVariables>(CreateReceiptDocument, baseOptions);
      }
export type CreateReceiptMutationHookResult = ReturnType<typeof useCreateReceiptMutation>;
export type CreateReceiptMutationResult = Apollo.MutationResult<CreateReceiptMutation>;
export type CreateReceiptMutationOptions = Apollo.BaseMutationOptions<CreateReceiptMutation, CreateReceiptMutationVariables>;
export const UpdateStatusInvoiceDocument = gql`
    mutation updateStatusInvoice($id: uuid!) {
  update_invoices(_set: {invoiceStatus: "voided"}, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      id
      name
    }
  }
}
    `;
export type UpdateStatusInvoiceMutationFn = Apollo.MutationFunction<UpdateStatusInvoiceMutation, UpdateStatusInvoiceMutationVariables>;

/**
 * __useUpdateStatusInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateStatusInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStatusInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStatusInvoiceMutation, { data, loading, error }] = useUpdateStatusInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateStatusInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStatusInvoiceMutation, UpdateStatusInvoiceMutationVariables>) {
        return Apollo.useMutation<UpdateStatusInvoiceMutation, UpdateStatusInvoiceMutationVariables>(UpdateStatusInvoiceDocument, baseOptions);
      }
export type UpdateStatusInvoiceMutationHookResult = ReturnType<typeof useUpdateStatusInvoiceMutation>;
export type UpdateStatusInvoiceMutationResult = Apollo.MutationResult<UpdateStatusInvoiceMutation>;
export type UpdateStatusInvoiceMutationOptions = Apollo.BaseMutationOptions<UpdateStatusInvoiceMutation, UpdateStatusInvoiceMutationVariables>;
export const UpdateInvoicesDocument = gql`
    mutation updateInvoices($id: uuid!, $form: invoices_set_input) {
  update_invoices(where: {id: {_eq: $id}}, _set: $form) {
    affected_rows
    returning {
      id
    }
  }
}
    `;
export type UpdateInvoicesMutationFn = Apollo.MutationFunction<UpdateInvoicesMutation, UpdateInvoicesMutationVariables>;

/**
 * __useUpdateInvoicesMutation__
 *
 * To run a mutation, you first call `useUpdateInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoicesMutation, { data, loading, error }] = useUpdateInvoicesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      form: // value for 'form'
 *   },
 * });
 */
export function useUpdateInvoicesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoicesMutation, UpdateInvoicesMutationVariables>) {
        return Apollo.useMutation<UpdateInvoicesMutation, UpdateInvoicesMutationVariables>(UpdateInvoicesDocument, baseOptions);
      }
export type UpdateInvoicesMutationHookResult = ReturnType<typeof useUpdateInvoicesMutation>;
export type UpdateInvoicesMutationResult = Apollo.MutationResult<UpdateInvoicesMutation>;
export type UpdateInvoicesMutationOptions = Apollo.BaseMutationOptions<UpdateInvoicesMutation, UpdateInvoicesMutationVariables>;
export const GetDataRefundListFilerDocument = gql`
    query getDataRefundListFiler($args: refund_filter_args!, $limit: Int!, $offset: Int!, $where: refunds_bool_exp) {
  refund_filter(
    args: $args
    limit: $limit
    offset: $offset
    where: $where
    order_by: {createdAt: desc}
  ) {
    id
    name
    createdAt
    refundClass {
      id
      lastLessonDate
      class {
        ...SimpleClassFragment
      }
    }
    student {
      username
      fullName
      id
    }
    type
    summary
    refundStatus
    issuedBy
  }
  refund_filter_aggregate(args: $args, where: $where) {
    aggregate {
      count(columns: id)
    }
  }
}
    ${SimpleClassFragmentFragmentDoc}`;

/**
 * __useGetDataRefundListFilerQuery__
 *
 * To run a query within a React component, call `useGetDataRefundListFilerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataRefundListFilerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataRefundListFilerQuery({
 *   variables: {
 *      args: // value for 'args'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetDataRefundListFilerQuery(baseOptions: Apollo.QueryHookOptions<GetDataRefundListFilerQuery, GetDataRefundListFilerQueryVariables>) {
        return Apollo.useQuery<GetDataRefundListFilerQuery, GetDataRefundListFilerQueryVariables>(GetDataRefundListFilerDocument, baseOptions);
      }
export function useGetDataRefundListFilerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataRefundListFilerQuery, GetDataRefundListFilerQueryVariables>) {
          return Apollo.useLazyQuery<GetDataRefundListFilerQuery, GetDataRefundListFilerQueryVariables>(GetDataRefundListFilerDocument, baseOptions);
        }
export type GetDataRefundListFilerQueryHookResult = ReturnType<typeof useGetDataRefundListFilerQuery>;
export type GetDataRefundListFilerLazyQueryHookResult = ReturnType<typeof useGetDataRefundListFilerLazyQuery>;
export type GetDataRefundListFilerQueryResult = Apollo.QueryResult<GetDataRefundListFilerQuery, GetDataRefundListFilerQueryVariables>;
export const GetDataWithdrawalListFilerDocument = gql`
    query getDataWithdrawalListFiler($args: refund_filter_args!, $limit: Int!, $offset: Int!, $where: refunds_bool_exp) {
  refund_filter(
    args: $args
    limit: $limit
    offset: $offset
    where: $where
    order_by: {createdAt: desc}
  ) {
    id
    name
    createdAt
    refundClass {
      id
      lastLessonDate
      class {
        ...SimpleClassFragment
      }
    }
    student {
      username
      fullName
      id
      studentProfile {
        id
        curriculum {
          abbreviation
          id
        }
        level {
          abbreviation
          id
        }
        school {
          name
          id
        }
      }
    }
    type
    refundStatus
  }
  refund_filter_aggregate(args: $args, where: $where) {
    aggregate {
      count(columns: id)
    }
  }
}
    ${SimpleClassFragmentFragmentDoc}`;

/**
 * __useGetDataWithdrawalListFilerQuery__
 *
 * To run a query within a React component, call `useGetDataWithdrawalListFilerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataWithdrawalListFilerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataWithdrawalListFilerQuery({
 *   variables: {
 *      args: // value for 'args'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetDataWithdrawalListFilerQuery(baseOptions: Apollo.QueryHookOptions<GetDataWithdrawalListFilerQuery, GetDataWithdrawalListFilerQueryVariables>) {
        return Apollo.useQuery<GetDataWithdrawalListFilerQuery, GetDataWithdrawalListFilerQueryVariables>(GetDataWithdrawalListFilerDocument, baseOptions);
      }
export function useGetDataWithdrawalListFilerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataWithdrawalListFilerQuery, GetDataWithdrawalListFilerQueryVariables>) {
          return Apollo.useLazyQuery<GetDataWithdrawalListFilerQuery, GetDataWithdrawalListFilerQueryVariables>(GetDataWithdrawalListFilerDocument, baseOptions);
        }
export type GetDataWithdrawalListFilerQueryHookResult = ReturnType<typeof useGetDataWithdrawalListFilerQuery>;
export type GetDataWithdrawalListFilerLazyQueryHookResult = ReturnType<typeof useGetDataWithdrawalListFilerLazyQuery>;
export type GetDataWithdrawalListFilerQueryResult = Apollo.QueryResult<GetDataWithdrawalListFilerQuery, GetDataWithdrawalListFilerQueryVariables>;
export const CreateRefundDocument = gql`
    mutation CreateRefund($form: FormCreateRefund!) {
  createRefund(form: $form)
}
    `;
export type CreateRefundMutationFn = Apollo.MutationFunction<CreateRefundMutation, CreateRefundMutationVariables>;

/**
 * __useCreateRefundMutation__
 *
 * To run a mutation, you first call `useCreateRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRefundMutation, { data, loading, error }] = useCreateRefundMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useCreateRefundMutation(baseOptions?: Apollo.MutationHookOptions<CreateRefundMutation, CreateRefundMutationVariables>) {
        return Apollo.useMutation<CreateRefundMutation, CreateRefundMutationVariables>(CreateRefundDocument, baseOptions);
      }
export type CreateRefundMutationHookResult = ReturnType<typeof useCreateRefundMutation>;
export type CreateRefundMutationResult = Apollo.MutationResult<CreateRefundMutation>;
export type CreateRefundMutationOptions = Apollo.BaseMutationOptions<CreateRefundMutation, CreateRefundMutationVariables>;
export const CreatePaymentAdvicePaperDocument = gql`
    mutation CreatePaymentAdvicePaper($id: String!) {
  createPaymentAdvicePaper(id: $id) {
    id
    name
  }
}
    `;
export type CreatePaymentAdvicePaperMutationFn = Apollo.MutationFunction<CreatePaymentAdvicePaperMutation, CreatePaymentAdvicePaperMutationVariables>;

/**
 * __useCreatePaymentAdvicePaperMutation__
 *
 * To run a mutation, you first call `useCreatePaymentAdvicePaperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentAdvicePaperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentAdvicePaperMutation, { data, loading, error }] = useCreatePaymentAdvicePaperMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreatePaymentAdvicePaperMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentAdvicePaperMutation, CreatePaymentAdvicePaperMutationVariables>) {
        return Apollo.useMutation<CreatePaymentAdvicePaperMutation, CreatePaymentAdvicePaperMutationVariables>(CreatePaymentAdvicePaperDocument, baseOptions);
      }
export type CreatePaymentAdvicePaperMutationHookResult = ReturnType<typeof useCreatePaymentAdvicePaperMutation>;
export type CreatePaymentAdvicePaperMutationResult = Apollo.MutationResult<CreatePaymentAdvicePaperMutation>;
export type CreatePaymentAdvicePaperMutationOptions = Apollo.BaseMutationOptions<CreatePaymentAdvicePaperMutation, CreatePaymentAdvicePaperMutationVariables>;
export const CreatePartialPaymentDocument = gql`
    mutation createPartialPayment($form: FormInvoicePartialPayment!) {
  createInvoicePartialPayment(form: $form)
}
    `;
export type CreatePartialPaymentMutationFn = Apollo.MutationFunction<CreatePartialPaymentMutation, CreatePartialPaymentMutationVariables>;

/**
 * __useCreatePartialPaymentMutation__
 *
 * To run a mutation, you first call `useCreatePartialPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePartialPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPartialPaymentMutation, { data, loading, error }] = useCreatePartialPaymentMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useCreatePartialPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePartialPaymentMutation, CreatePartialPaymentMutationVariables>) {
        return Apollo.useMutation<CreatePartialPaymentMutation, CreatePartialPaymentMutationVariables>(CreatePartialPaymentDocument, baseOptions);
      }
export type CreatePartialPaymentMutationHookResult = ReturnType<typeof useCreatePartialPaymentMutation>;
export type CreatePartialPaymentMutationResult = Apollo.MutationResult<CreatePartialPaymentMutation>;
export type CreatePartialPaymentMutationOptions = Apollo.BaseMutationOptions<CreatePartialPaymentMutation, CreatePartialPaymentMutationVariables>;
export const GetPaymentSettingDocument = gql`
    query getPaymentSetting($stType: String) {
  system_settings(where: {type: {_eq: $stType}}) {
    key
    id
    parentId
    parent {
      id
      type
      key
      value
    }
    type
    value
  }
}
    `;

/**
 * __useGetPaymentSettingQuery__
 *
 * To run a query within a React component, call `useGetPaymentSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentSettingQuery({
 *   variables: {
 *      stType: // value for 'stType'
 *   },
 * });
 */
export function useGetPaymentSettingQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentSettingQuery, GetPaymentSettingQueryVariables>) {
        return Apollo.useQuery<GetPaymentSettingQuery, GetPaymentSettingQueryVariables>(GetPaymentSettingDocument, baseOptions);
      }
export function useGetPaymentSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentSettingQuery, GetPaymentSettingQueryVariables>) {
          return Apollo.useLazyQuery<GetPaymentSettingQuery, GetPaymentSettingQueryVariables>(GetPaymentSettingDocument, baseOptions);
        }
export type GetPaymentSettingQueryHookResult = ReturnType<typeof useGetPaymentSettingQuery>;
export type GetPaymentSettingLazyQueryHookResult = ReturnType<typeof useGetPaymentSettingLazyQuery>;
export type GetPaymentSettingQueryResult = Apollo.QueryResult<GetPaymentSettingQuery, GetPaymentSettingQueryVariables>;
export const UpdatePaymentSettingDocument = gql`
    mutation updatePaymentSetting($id: uuid!, $value: String!) {
  update_system_settings(where: {id: {_eq: $id}}, _set: {value: $value}) {
    returning {
      id
      value
      key
    }
  }
}
    `;
export type UpdatePaymentSettingMutationFn = Apollo.MutationFunction<UpdatePaymentSettingMutation, UpdatePaymentSettingMutationVariables>;

/**
 * __useUpdatePaymentSettingMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentSettingMutation, { data, loading, error }] = useUpdatePaymentSettingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdatePaymentSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentSettingMutation, UpdatePaymentSettingMutationVariables>) {
        return Apollo.useMutation<UpdatePaymentSettingMutation, UpdatePaymentSettingMutationVariables>(UpdatePaymentSettingDocument, baseOptions);
      }
export type UpdatePaymentSettingMutationHookResult = ReturnType<typeof useUpdatePaymentSettingMutation>;
export type UpdatePaymentSettingMutationResult = Apollo.MutationResult<UpdatePaymentSettingMutation>;
export type UpdatePaymentSettingMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentSettingMutation, UpdatePaymentSettingMutationVariables>;
export const UpdateRegularProgrammePricingsDocument = gql`
    mutation updateRegularProgrammePricings($id: uuid!, $userid: uuid!, $value: numeric!) {
  update_regular_programme_pricings(
    where: {id: {_eq: $id}}
    _set: {pricePerLesson: $value, updatedBy: $userid}
  ) {
    returning {
      id
    }
  }
}
    `;
export type UpdateRegularProgrammePricingsMutationFn = Apollo.MutationFunction<UpdateRegularProgrammePricingsMutation, UpdateRegularProgrammePricingsMutationVariables>;

/**
 * __useUpdateRegularProgrammePricingsMutation__
 *
 * To run a mutation, you first call `useUpdateRegularProgrammePricingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegularProgrammePricingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegularProgrammePricingsMutation, { data, loading, error }] = useUpdateRegularProgrammePricingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userid: // value for 'userid'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateRegularProgrammePricingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegularProgrammePricingsMutation, UpdateRegularProgrammePricingsMutationVariables>) {
        return Apollo.useMutation<UpdateRegularProgrammePricingsMutation, UpdateRegularProgrammePricingsMutationVariables>(UpdateRegularProgrammePricingsDocument, baseOptions);
      }
export type UpdateRegularProgrammePricingsMutationHookResult = ReturnType<typeof useUpdateRegularProgrammePricingsMutation>;
export type UpdateRegularProgrammePricingsMutationResult = Apollo.MutationResult<UpdateRegularProgrammePricingsMutation>;
export type UpdateRegularProgrammePricingsMutationOptions = Apollo.BaseMutationOptions<UpdateRegularProgrammePricingsMutation, UpdateRegularProgrammePricingsMutationVariables>;
export const UpdateSpecialProgrammeClassPricingsDocument = gql`
    mutation updateSpecialProgrammeClassPricings($id: uuid!, $userid: uuid!, $value: numeric!) {
  update_special_programme_class_pricings(
    where: {id: {_eq: $id}}
    _set: {pricePerStudent: $value, updatedBy: $userid}
  ) {
    returning {
      id
    }
  }
}
    `;
export type UpdateSpecialProgrammeClassPricingsMutationFn = Apollo.MutationFunction<UpdateSpecialProgrammeClassPricingsMutation, UpdateSpecialProgrammeClassPricingsMutationVariables>;

/**
 * __useUpdateSpecialProgrammeClassPricingsMutation__
 *
 * To run a mutation, you first call `useUpdateSpecialProgrammeClassPricingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpecialProgrammeClassPricingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpecialProgrammeClassPricingsMutation, { data, loading, error }] = useUpdateSpecialProgrammeClassPricingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userid: // value for 'userid'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateSpecialProgrammeClassPricingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpecialProgrammeClassPricingsMutation, UpdateSpecialProgrammeClassPricingsMutationVariables>) {
        return Apollo.useMutation<UpdateSpecialProgrammeClassPricingsMutation, UpdateSpecialProgrammeClassPricingsMutationVariables>(UpdateSpecialProgrammeClassPricingsDocument, baseOptions);
      }
export type UpdateSpecialProgrammeClassPricingsMutationHookResult = ReturnType<typeof useUpdateSpecialProgrammeClassPricingsMutation>;
export type UpdateSpecialProgrammeClassPricingsMutationResult = Apollo.MutationResult<UpdateSpecialProgrammeClassPricingsMutation>;
export type UpdateSpecialProgrammeClassPricingsMutationOptions = Apollo.BaseMutationOptions<UpdateSpecialProgrammeClassPricingsMutation, UpdateSpecialProgrammeClassPricingsMutationVariables>;
export const GetAllGeneralProgramTypeDocument = gql`
    query getAllGeneralProgramType($filter: general_program_types_bool_exp) {
  general_program_types(where: $filter) {
    ...generaProgramTypeModel
  }
}
    ${GeneraProgramTypeModelFragmentDoc}`;

/**
 * __useGetAllGeneralProgramTypeQuery__
 *
 * To run a query within a React component, call `useGetAllGeneralProgramTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllGeneralProgramTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllGeneralProgramTypeQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAllGeneralProgramTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetAllGeneralProgramTypeQuery, GetAllGeneralProgramTypeQueryVariables>) {
        return Apollo.useQuery<GetAllGeneralProgramTypeQuery, GetAllGeneralProgramTypeQueryVariables>(GetAllGeneralProgramTypeDocument, baseOptions);
      }
export function useGetAllGeneralProgramTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllGeneralProgramTypeQuery, GetAllGeneralProgramTypeQueryVariables>) {
          return Apollo.useLazyQuery<GetAllGeneralProgramTypeQuery, GetAllGeneralProgramTypeQueryVariables>(GetAllGeneralProgramTypeDocument, baseOptions);
        }
export type GetAllGeneralProgramTypeQueryHookResult = ReturnType<typeof useGetAllGeneralProgramTypeQuery>;
export type GetAllGeneralProgramTypeLazyQueryHookResult = ReturnType<typeof useGetAllGeneralProgramTypeLazyQuery>;
export type GetAllGeneralProgramTypeQueryResult = Apollo.QueryResult<GetAllGeneralProgramTypeQuery, GetAllGeneralProgramTypeQueryVariables>;
export const GetAllSpecialProgramTypeDocument = gql`
    query getAllSpecialProgramType($filter: specical_program_types_bool_exp) {
  specical_program_types(where: $filter) {
    ...specialProgramTypeModel
  }
}
    ${SpecialProgramTypeModelFragmentDoc}`;

/**
 * __useGetAllSpecialProgramTypeQuery__
 *
 * To run a query within a React component, call `useGetAllSpecialProgramTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSpecialProgramTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSpecialProgramTypeQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAllSpecialProgramTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSpecialProgramTypeQuery, GetAllSpecialProgramTypeQueryVariables>) {
        return Apollo.useQuery<GetAllSpecialProgramTypeQuery, GetAllSpecialProgramTypeQueryVariables>(GetAllSpecialProgramTypeDocument, baseOptions);
      }
export function useGetAllSpecialProgramTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSpecialProgramTypeQuery, GetAllSpecialProgramTypeQueryVariables>) {
          return Apollo.useLazyQuery<GetAllSpecialProgramTypeQuery, GetAllSpecialProgramTypeQueryVariables>(GetAllSpecialProgramTypeDocument, baseOptions);
        }
export type GetAllSpecialProgramTypeQueryHookResult = ReturnType<typeof useGetAllSpecialProgramTypeQuery>;
export type GetAllSpecialProgramTypeLazyQueryHookResult = ReturnType<typeof useGetAllSpecialProgramTypeLazyQuery>;
export type GetAllSpecialProgramTypeQueryResult = Apollo.QueryResult<GetAllSpecialProgramTypeQuery, GetAllSpecialProgramTypeQueryVariables>;
export const GetAllRegularProgramTypeDocument = gql`
    query getAllRegularProgramType($filter: regular_program_types_bool_exp) {
  regular_program_types(where: $filter) {
    ...regularProgramTypeModel
  }
}
    ${RegularProgramTypeModelFragmentDoc}`;

/**
 * __useGetAllRegularProgramTypeQuery__
 *
 * To run a query within a React component, call `useGetAllRegularProgramTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRegularProgramTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRegularProgramTypeQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAllRegularProgramTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRegularProgramTypeQuery, GetAllRegularProgramTypeQueryVariables>) {
        return Apollo.useQuery<GetAllRegularProgramTypeQuery, GetAllRegularProgramTypeQueryVariables>(GetAllRegularProgramTypeDocument, baseOptions);
      }
export function useGetAllRegularProgramTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRegularProgramTypeQuery, GetAllRegularProgramTypeQueryVariables>) {
          return Apollo.useLazyQuery<GetAllRegularProgramTypeQuery, GetAllRegularProgramTypeQueryVariables>(GetAllRegularProgramTypeDocument, baseOptions);
        }
export type GetAllRegularProgramTypeQueryHookResult = ReturnType<typeof useGetAllRegularProgramTypeQuery>;
export type GetAllRegularProgramTypeLazyQueryHookResult = ReturnType<typeof useGetAllRegularProgramTypeLazyQuery>;
export type GetAllRegularProgramTypeQueryResult = Apollo.QueryResult<GetAllRegularProgramTypeQuery, GetAllRegularProgramTypeQueryVariables>;
export const GetProgramByStudentIdDocument = gql`
    query getProgramByStudentId($academic_year: String, $student_id: uuid!) {
  students_programs_filter(
    args: {academic_year: $academic_year, student_id: $student_id}
  ) {
    id
    name
    curriculums {
      id
      abbreviation
    }
    levels {
      id
      abbreviation
    }
    subject {
      id
      name
      abbreviation
    }
  }
}
    `;

/**
 * __useGetProgramByStudentIdQuery__
 *
 * To run a query within a React component, call `useGetProgramByStudentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramByStudentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramByStudentIdQuery({
 *   variables: {
 *      academic_year: // value for 'academic_year'
 *      student_id: // value for 'student_id'
 *   },
 * });
 */
export function useGetProgramByStudentIdQuery(baseOptions: Apollo.QueryHookOptions<GetProgramByStudentIdQuery, GetProgramByStudentIdQueryVariables>) {
        return Apollo.useQuery<GetProgramByStudentIdQuery, GetProgramByStudentIdQueryVariables>(GetProgramByStudentIdDocument, baseOptions);
      }
export function useGetProgramByStudentIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgramByStudentIdQuery, GetProgramByStudentIdQueryVariables>) {
          return Apollo.useLazyQuery<GetProgramByStudentIdQuery, GetProgramByStudentIdQueryVariables>(GetProgramByStudentIdDocument, baseOptions);
        }
export type GetProgramByStudentIdQueryHookResult = ReturnType<typeof useGetProgramByStudentIdQuery>;
export type GetProgramByStudentIdLazyQueryHookResult = ReturnType<typeof useGetProgramByStudentIdLazyQuery>;
export type GetProgramByStudentIdQueryResult = Apollo.QueryResult<GetProgramByStudentIdQuery, GetProgramByStudentIdQueryVariables>;
export const CreateProgramDocument = gql`
    mutation createProgram($form: [programs_insert_input!]!) {
  insert_programs(objects: $form) {
    returning {
      createdAt
      id
      name
      levelIds
      createdBy
      curriculumFiles
      curriculumIds
      note
      status
      subjectId
      tutorIds
      updatedAt
      updatedBy
    }
  }
}
    `;
export type CreateProgramMutationFn = Apollo.MutationFunction<CreateProgramMutation, CreateProgramMutationVariables>;

/**
 * __useCreateProgramMutation__
 *
 * To run a mutation, you first call `useCreateProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProgramMutation, { data, loading, error }] = useCreateProgramMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useCreateProgramMutation(baseOptions?: Apollo.MutationHookOptions<CreateProgramMutation, CreateProgramMutationVariables>) {
        return Apollo.useMutation<CreateProgramMutation, CreateProgramMutationVariables>(CreateProgramDocument, baseOptions);
      }
export type CreateProgramMutationHookResult = ReturnType<typeof useCreateProgramMutation>;
export type CreateProgramMutationResult = Apollo.MutationResult<CreateProgramMutation>;
export type CreateProgramMutationOptions = Apollo.BaseMutationOptions<CreateProgramMutation, CreateProgramMutationVariables>;
export const UpdateProgramDocument = gql`
    mutation updateProgram($id: uuid!, $form: programs_set_input) {
  update_programs(where: {id: {_eq: $id}}, _set: $form) {
    returning {
      createdAt
      id
      name
      levelIds
      createdBy
      curriculumFiles
      curriculumIds
      note
      status
      subjectId
      tutorIds
      updatedAt
      updatedBy
    }
  }
}
    `;
export type UpdateProgramMutationFn = Apollo.MutationFunction<UpdateProgramMutation, UpdateProgramMutationVariables>;

/**
 * __useUpdateProgramMutation__
 *
 * To run a mutation, you first call `useUpdateProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgramMutation, { data, loading, error }] = useUpdateProgramMutation({
 *   variables: {
 *      id: // value for 'id'
 *      form: // value for 'form'
 *   },
 * });
 */
export function useUpdateProgramMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProgramMutation, UpdateProgramMutationVariables>) {
        return Apollo.useMutation<UpdateProgramMutation, UpdateProgramMutationVariables>(UpdateProgramDocument, baseOptions);
      }
export type UpdateProgramMutationHookResult = ReturnType<typeof useUpdateProgramMutation>;
export type UpdateProgramMutationResult = Apollo.MutationResult<UpdateProgramMutation>;
export type UpdateProgramMutationOptions = Apollo.BaseMutationOptions<UpdateProgramMutation, UpdateProgramMutationVariables>;
export const ProgramsListDocument = gql`
    query programsList($limit: Int!, $offset: Int!, $order: order_by!, $filter: programs_bool_exp) {
  programs(
    limit: $limit
    offset: $offset
    where: $filter
    order_by: {name: $order}
  ) {
    ...programsModel
  }
  programs_aggregate(where: $filter) {
    aggregate {
      count
    }
  }
}
    ${ProgramsModelFragmentDoc}`;

/**
 * __useProgramsListQuery__
 *
 * To run a query within a React component, call `useProgramsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramsListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order: // value for 'order'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProgramsListQuery(baseOptions: Apollo.QueryHookOptions<ProgramsListQuery, ProgramsListQueryVariables>) {
        return Apollo.useQuery<ProgramsListQuery, ProgramsListQueryVariables>(ProgramsListDocument, baseOptions);
      }
export function useProgramsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramsListQuery, ProgramsListQueryVariables>) {
          return Apollo.useLazyQuery<ProgramsListQuery, ProgramsListQueryVariables>(ProgramsListDocument, baseOptions);
        }
export type ProgramsListQueryHookResult = ReturnType<typeof useProgramsListQuery>;
export type ProgramsListLazyQueryHookResult = ReturnType<typeof useProgramsListLazyQuery>;
export type ProgramsListQueryResult = Apollo.QueryResult<ProgramsListQuery, ProgramsListQueryVariables>;
export const GetAllProgramsDocument = gql`
    query getAllPrograms($filter: programs_bool_exp) {
  programs(where: $filter) {
    ...programsModel
  }
}
    ${ProgramsModelFragmentDoc}`;

/**
 * __useGetAllProgramsQuery__
 *
 * To run a query within a React component, call `useGetAllProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProgramsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAllProgramsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProgramsQuery, GetAllProgramsQueryVariables>) {
        return Apollo.useQuery<GetAllProgramsQuery, GetAllProgramsQueryVariables>(GetAllProgramsDocument, baseOptions);
      }
export function useGetAllProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProgramsQuery, GetAllProgramsQueryVariables>) {
          return Apollo.useLazyQuery<GetAllProgramsQuery, GetAllProgramsQueryVariables>(GetAllProgramsDocument, baseOptions);
        }
export type GetAllProgramsQueryHookResult = ReturnType<typeof useGetAllProgramsQuery>;
export type GetAllProgramsLazyQueryHookResult = ReturnType<typeof useGetAllProgramsLazyQuery>;
export type GetAllProgramsQueryResult = Apollo.QueryResult<GetAllProgramsQuery, GetAllProgramsQueryVariables>;
export const GetProgramByIdDocument = gql`
    query getProgramById($id: uuid!) {
  programs(where: {id: {_eq: $id}, status: {_neq: "deleted"}}) {
    id
    programId
    name
    curriculumIds
    curriculumFiles
    levelIds
    tutorIds
    subjectId
    note
    levels {
      id
      name
    }
    tutors {
      id
      firstName
      lastName
      avatar
    }
    curriculums {
      id
      name
      abbreviation
    }
    subject {
      id
      name
    }
    numberOfWLWEClasses
    numberOfWLWDClasses
    numberOfDLClasses
    enrolledStudents
    category
    numberOfSpecialClasses
    numberOfGeneralClasses
  }
}
    `;

/**
 * __useGetProgramByIdQuery__
 *
 * To run a query within a React component, call `useGetProgramByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProgramByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProgramByIdQuery, GetProgramByIdQueryVariables>) {
        return Apollo.useQuery<GetProgramByIdQuery, GetProgramByIdQueryVariables>(GetProgramByIdDocument, baseOptions);
      }
export function useGetProgramByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgramByIdQuery, GetProgramByIdQueryVariables>) {
          return Apollo.useLazyQuery<GetProgramByIdQuery, GetProgramByIdQueryVariables>(GetProgramByIdDocument, baseOptions);
        }
export type GetProgramByIdQueryHookResult = ReturnType<typeof useGetProgramByIdQuery>;
export type GetProgramByIdLazyQueryHookResult = ReturnType<typeof useGetProgramByIdLazyQuery>;
export type GetProgramByIdQueryResult = Apollo.QueryResult<GetProgramByIdQuery, GetProgramByIdQueryVariables>;
export const RegularProgramTypesListDocument = gql`
    query regularProgramTypesList {
  regular_program_types(where: {status: {_eq: "active"}}) {
    id
    fullName
    shortName
    code
  }
}
    `;

/**
 * __useRegularProgramTypesListQuery__
 *
 * To run a query within a React component, call `useRegularProgramTypesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegularProgramTypesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegularProgramTypesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegularProgramTypesListQuery(baseOptions?: Apollo.QueryHookOptions<RegularProgramTypesListQuery, RegularProgramTypesListQueryVariables>) {
        return Apollo.useQuery<RegularProgramTypesListQuery, RegularProgramTypesListQueryVariables>(RegularProgramTypesListDocument, baseOptions);
      }
export function useRegularProgramTypesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegularProgramTypesListQuery, RegularProgramTypesListQueryVariables>) {
          return Apollo.useLazyQuery<RegularProgramTypesListQuery, RegularProgramTypesListQueryVariables>(RegularProgramTypesListDocument, baseOptions);
        }
export type RegularProgramTypesListQueryHookResult = ReturnType<typeof useRegularProgramTypesListQuery>;
export type RegularProgramTypesListLazyQueryHookResult = ReturnType<typeof useRegularProgramTypesListLazyQuery>;
export type RegularProgramTypesListQueryResult = Apollo.QueryResult<RegularProgramTypesListQuery, RegularProgramTypesListQueryVariables>;
export const SpecicalProgramTypesDocument = gql`
    query specicalProgramTypes {
  specical_program_types(where: {status: {_eq: "active"}}) {
    shortName
    id
    fullName
  }
}
    `;

/**
 * __useSpecicalProgramTypesQuery__
 *
 * To run a query within a React component, call `useSpecicalProgramTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecicalProgramTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecicalProgramTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpecicalProgramTypesQuery(baseOptions?: Apollo.QueryHookOptions<SpecicalProgramTypesQuery, SpecicalProgramTypesQueryVariables>) {
        return Apollo.useQuery<SpecicalProgramTypesQuery, SpecicalProgramTypesQueryVariables>(SpecicalProgramTypesDocument, baseOptions);
      }
export function useSpecicalProgramTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpecicalProgramTypesQuery, SpecicalProgramTypesQueryVariables>) {
          return Apollo.useLazyQuery<SpecicalProgramTypesQuery, SpecicalProgramTypesQueryVariables>(SpecicalProgramTypesDocument, baseOptions);
        }
export type SpecicalProgramTypesQueryHookResult = ReturnType<typeof useSpecicalProgramTypesQuery>;
export type SpecicalProgramTypesLazyQueryHookResult = ReturnType<typeof useSpecicalProgramTypesLazyQuery>;
export type SpecicalProgramTypesQueryResult = Apollo.QueryResult<SpecicalProgramTypesQuery, SpecicalProgramTypesQueryVariables>;
export const UpdateRegularProgramTypesDocument = gql`
    mutation updateRegularProgramTypes($id: uuid!, $value: String!) {
  update_regular_program_types(where: {id: {_eq: $id}}, _set: {fullName: $value}) {
    affected_rows
    returning {
      id
      fullName
      shortName
    }
  }
}
    `;
export type UpdateRegularProgramTypesMutationFn = Apollo.MutationFunction<UpdateRegularProgramTypesMutation, UpdateRegularProgramTypesMutationVariables>;

/**
 * __useUpdateRegularProgramTypesMutation__
 *
 * To run a mutation, you first call `useUpdateRegularProgramTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegularProgramTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegularProgramTypesMutation, { data, loading, error }] = useUpdateRegularProgramTypesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateRegularProgramTypesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegularProgramTypesMutation, UpdateRegularProgramTypesMutationVariables>) {
        return Apollo.useMutation<UpdateRegularProgramTypesMutation, UpdateRegularProgramTypesMutationVariables>(UpdateRegularProgramTypesDocument, baseOptions);
      }
export type UpdateRegularProgramTypesMutationHookResult = ReturnType<typeof useUpdateRegularProgramTypesMutation>;
export type UpdateRegularProgramTypesMutationResult = Apollo.MutationResult<UpdateRegularProgramTypesMutation>;
export type UpdateRegularProgramTypesMutationOptions = Apollo.BaseMutationOptions<UpdateRegularProgramTypesMutation, UpdateRegularProgramTypesMutationVariables>;
export const UpdateSpecicalProgramTypesDocument = gql`
    mutation updateSpecicalProgramTypes($id: uuid!, $shortName: String!, $fullName: String!) {
  update_specical_program_types(
    where: {id: {_eq: $id}}
    _set: {shortName: $shortName, fullName: $fullName}
  ) {
    affected_rows
    returning {
      id
      fullName
      shortName
    }
  }
}
    `;
export type UpdateSpecicalProgramTypesMutationFn = Apollo.MutationFunction<UpdateSpecicalProgramTypesMutation, UpdateSpecicalProgramTypesMutationVariables>;

/**
 * __useUpdateSpecicalProgramTypesMutation__
 *
 * To run a mutation, you first call `useUpdateSpecicalProgramTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpecicalProgramTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpecicalProgramTypesMutation, { data, loading, error }] = useUpdateSpecicalProgramTypesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      shortName: // value for 'shortName'
 *      fullName: // value for 'fullName'
 *   },
 * });
 */
export function useUpdateSpecicalProgramTypesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpecicalProgramTypesMutation, UpdateSpecicalProgramTypesMutationVariables>) {
        return Apollo.useMutation<UpdateSpecicalProgramTypesMutation, UpdateSpecicalProgramTypesMutationVariables>(UpdateSpecicalProgramTypesDocument, baseOptions);
      }
export type UpdateSpecicalProgramTypesMutationHookResult = ReturnType<typeof useUpdateSpecicalProgramTypesMutation>;
export type UpdateSpecicalProgramTypesMutationResult = Apollo.MutationResult<UpdateSpecicalProgramTypesMutation>;
export type UpdateSpecicalProgramTypesMutationOptions = Apollo.BaseMutationOptions<UpdateSpecicalProgramTypesMutation, UpdateSpecicalProgramTypesMutationVariables>;
export const UpdateGeneralProgramTypesDocument = gql`
    mutation updateGeneralProgramTypes($id: uuid!, $value: String!) {
  update_general_program_types(where: {id: {_eq: $id}}, _set: {fullName: $value}) {
    affected_rows
    returning {
      id
      fullName
      shortName
    }
  }
}
    `;
export type UpdateGeneralProgramTypesMutationFn = Apollo.MutationFunction<UpdateGeneralProgramTypesMutation, UpdateGeneralProgramTypesMutationVariables>;

/**
 * __useUpdateGeneralProgramTypesMutation__
 *
 * To run a mutation, you first call `useUpdateGeneralProgramTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGeneralProgramTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGeneralProgramTypesMutation, { data, loading, error }] = useUpdateGeneralProgramTypesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateGeneralProgramTypesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGeneralProgramTypesMutation, UpdateGeneralProgramTypesMutationVariables>) {
        return Apollo.useMutation<UpdateGeneralProgramTypesMutation, UpdateGeneralProgramTypesMutationVariables>(UpdateGeneralProgramTypesDocument, baseOptions);
      }
export type UpdateGeneralProgramTypesMutationHookResult = ReturnType<typeof useUpdateGeneralProgramTypesMutation>;
export type UpdateGeneralProgramTypesMutationResult = Apollo.MutationResult<UpdateGeneralProgramTypesMutation>;
export type UpdateGeneralProgramTypesMutationOptions = Apollo.BaseMutationOptions<UpdateGeneralProgramTypesMutation, UpdateGeneralProgramTypesMutationVariables>;
export const InsertSpecicalProgramTypesDocument = gql`
    mutation insertSpecicalProgramTypes($shortName: String!, $fullName: String!) {
  insert_specical_program_types(
    objects: {fullName: $fullName, shortName: $shortName}
  ) {
    affected_rows
    returning {
      fullName
      id
      shortName
    }
  }
}
    `;
export type InsertSpecicalProgramTypesMutationFn = Apollo.MutationFunction<InsertSpecicalProgramTypesMutation, InsertSpecicalProgramTypesMutationVariables>;

/**
 * __useInsertSpecicalProgramTypesMutation__
 *
 * To run a mutation, you first call `useInsertSpecicalProgramTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertSpecicalProgramTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertSpecicalProgramTypesMutation, { data, loading, error }] = useInsertSpecicalProgramTypesMutation({
 *   variables: {
 *      shortName: // value for 'shortName'
 *      fullName: // value for 'fullName'
 *   },
 * });
 */
export function useInsertSpecicalProgramTypesMutation(baseOptions?: Apollo.MutationHookOptions<InsertSpecicalProgramTypesMutation, InsertSpecicalProgramTypesMutationVariables>) {
        return Apollo.useMutation<InsertSpecicalProgramTypesMutation, InsertSpecicalProgramTypesMutationVariables>(InsertSpecicalProgramTypesDocument, baseOptions);
      }
export type InsertSpecicalProgramTypesMutationHookResult = ReturnType<typeof useInsertSpecicalProgramTypesMutation>;
export type InsertSpecicalProgramTypesMutationResult = Apollo.MutationResult<InsertSpecicalProgramTypesMutation>;
export type InsertSpecicalProgramTypesMutationOptions = Apollo.BaseMutationOptions<InsertSpecicalProgramTypesMutation, InsertSpecicalProgramTypesMutationVariables>;
export const ClassFilterByStudentDocument = gql`
    query classFilterByStudent($studentId: String!) {
  getListClassNotRefundByStudent(studentId: $studentId) {
    id
    name
  }
}
    `;

/**
 * __useClassFilterByStudentQuery__
 *
 * To run a query within a React component, call `useClassFilterByStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassFilterByStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassFilterByStudentQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useClassFilterByStudentQuery(baseOptions: Apollo.QueryHookOptions<ClassFilterByStudentQuery, ClassFilterByStudentQueryVariables>) {
        return Apollo.useQuery<ClassFilterByStudentQuery, ClassFilterByStudentQueryVariables>(ClassFilterByStudentDocument, baseOptions);
      }
export function useClassFilterByStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassFilterByStudentQuery, ClassFilterByStudentQueryVariables>) {
          return Apollo.useLazyQuery<ClassFilterByStudentQuery, ClassFilterByStudentQueryVariables>(ClassFilterByStudentDocument, baseOptions);
        }
export type ClassFilterByStudentQueryHookResult = ReturnType<typeof useClassFilterByStudentQuery>;
export type ClassFilterByStudentLazyQueryHookResult = ReturnType<typeof useClassFilterByStudentLazyQuery>;
export type ClassFilterByStudentQueryResult = Apollo.QueryResult<ClassFilterByStudentQuery, ClassFilterByStudentQueryVariables>;
export const UpdateRefundDocument = gql`
    mutation updateRefund($form: FormRefund!, $id: String!, $saveForm: Boolean!) {
  updateRefund(form: $form, id: $id, saveForm: $saveForm) {
    name
    noticeDate
    reason
    refundStatus
    remarks
    student {
      email
      fullName
      id
      phoneNumber
      studentId
      studentProfile {
        school {
          id
          name
        }
      }
      username
    }
    studentFeedback {
      improvement
      joiningOtherSubjects
      rate
      rateReason
      returnReason
      studiedTime
      willReturn
    }
    summary {
      creditNote
      deposit
      totalAfterGst
      totalRefundable
    }
    type
    payeeDetails {
      accountNumber
      bankName
      country
      nameAsOfBank
      phoneNumber {
        code
        number
      }
      postalCode
      remarks
    }
    refundClass {
      classId
      classTotal
      deduction {
        data {
          amount
          name
        }
        total
      }
      lastLessonDate
      leftLessonAmount
      leftLessonNo
      lessonDates
      name
      otherPayments {
        data {
          amount
          name
        }
        total
      }
      oweLessonNo
      receiptId
      summary {
        gst
        gstConfig
        subTotalAfterGst
        totalBeforGst
      }
      unitPrice
    }
    issuedBy {
      attachments
      chequeNo
      paymentMethod
      transactionId
    }
    deposit {
      data {
        amount
        id
        name
      }
      total
    }
    creditNote {
      data {
        amount
        id
        name
      }
      total
    }
  }
}
    `;
export type UpdateRefundMutationFn = Apollo.MutationFunction<UpdateRefundMutation, UpdateRefundMutationVariables>;

/**
 * __useUpdateRefundMutation__
 *
 * To run a mutation, you first call `useUpdateRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRefundMutation, { data, loading, error }] = useUpdateRefundMutation({
 *   variables: {
 *      form: // value for 'form'
 *      id: // value for 'id'
 *      saveForm: // value for 'saveForm'
 *   },
 * });
 */
export function useUpdateRefundMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRefundMutation, UpdateRefundMutationVariables>) {
        return Apollo.useMutation<UpdateRefundMutation, UpdateRefundMutationVariables>(UpdateRefundDocument, baseOptions);
      }
export type UpdateRefundMutationHookResult = ReturnType<typeof useUpdateRefundMutation>;
export type UpdateRefundMutationResult = Apollo.MutationResult<UpdateRefundMutation>;
export type UpdateRefundMutationOptions = Apollo.BaseMutationOptions<UpdateRefundMutation, UpdateRefundMutationVariables>;
export const GetDetailRefundDocument = gql`
    query getDetailRefund($id: String!) {
  getDetailRefund(id: $id) {
    name
    noticeDate
    reason
    refundStatus
    remarks
    student {
      email
      fullName
      id
      phoneNumber
      studentId
      studentProfile {
        school {
          id
          name
        }
      }
      username
    }
    studentFeedback {
      improvement
      joiningOtherSubjects
      rate
      rateReason
      returnReason
      studiedTime
      willReturn
    }
    summary {
      creditNote
      deposit
      totalAfterGst
      totalRefundable
    }
    type
    payeeDetails {
      accountNumber
      bankName
      country
      nameAsOfBank
      phoneNumber {
        code
        number
      }
      postalCode
      remarks
    }
    refundClass {
      classId
      classTotal
      deduction {
        data {
          amount
          name
        }
        total
      }
      lastLessonDate
      leftLessonAmount
      leftLessonNo
      lessonDates
      name
      otherPayments {
        data {
          amount
          name
        }
        total
      }
      oweLessonNo
      receiptId
      summary {
        gst
        gstConfig
        subTotalAfterGst
        totalBeforGst
      }
      unitPrice
    }
    issuedBy {
      attachments
      chequeNo
      paymentMethod
      transactionId
    }
    deposit {
      data {
        amount
        id
        name
      }
      total
    }
    creditNote {
      data {
        amount
        id
        name
      }
      total
    }
  }
}
    `;

/**
 * __useGetDetailRefundQuery__
 *
 * To run a query within a React component, call `useGetDetailRefundQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailRefundQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailRefundQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDetailRefundQuery(baseOptions: Apollo.QueryHookOptions<GetDetailRefundQuery, GetDetailRefundQueryVariables>) {
        return Apollo.useQuery<GetDetailRefundQuery, GetDetailRefundQueryVariables>(GetDetailRefundDocument, baseOptions);
      }
export function useGetDetailRefundLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDetailRefundQuery, GetDetailRefundQueryVariables>) {
          return Apollo.useLazyQuery<GetDetailRefundQuery, GetDetailRefundQueryVariables>(GetDetailRefundDocument, baseOptions);
        }
export type GetDetailRefundQueryHookResult = ReturnType<typeof useGetDetailRefundQuery>;
export type GetDetailRefundLazyQueryHookResult = ReturnType<typeof useGetDetailRefundLazyQuery>;
export type GetDetailRefundQueryResult = Apollo.QueryResult<GetDetailRefundQuery, GetDetailRefundQueryVariables>;
export const GetClassInformationForRefundDocument = gql`
    query getClassInformationForRefund($form: FormWithdrawalClass!, $noticeDate: DateTime!) {
  getClassInformationForRefund(form: $form, noticeDate: $noticeDate) {
    classId
    lastLessonDate
    lessonDates
    leftLessonNo
    oweLessonNo
    name
  }
}
    `;

/**
 * __useGetClassInformationForRefundQuery__
 *
 * To run a query within a React component, call `useGetClassInformationForRefundQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassInformationForRefundQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassInformationForRefundQuery({
 *   variables: {
 *      form: // value for 'form'
 *      noticeDate: // value for 'noticeDate'
 *   },
 * });
 */
export function useGetClassInformationForRefundQuery(baseOptions: Apollo.QueryHookOptions<GetClassInformationForRefundQuery, GetClassInformationForRefundQueryVariables>) {
        return Apollo.useQuery<GetClassInformationForRefundQuery, GetClassInformationForRefundQueryVariables>(GetClassInformationForRefundDocument, baseOptions);
      }
export function useGetClassInformationForRefundLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassInformationForRefundQuery, GetClassInformationForRefundQueryVariables>) {
          return Apollo.useLazyQuery<GetClassInformationForRefundQuery, GetClassInformationForRefundQueryVariables>(GetClassInformationForRefundDocument, baseOptions);
        }
export type GetClassInformationForRefundQueryHookResult = ReturnType<typeof useGetClassInformationForRefundQuery>;
export type GetClassInformationForRefundLazyQueryHookResult = ReturnType<typeof useGetClassInformationForRefundLazyQuery>;
export type GetClassInformationForRefundQueryResult = Apollo.QueryResult<GetClassInformationForRefundQuery, GetClassInformationForRefundQueryVariables>;
export const ChangeRefundStatusDocument = gql`
    mutation changeRefundStatus($id: String!) {
  changeRefundStatus(id: $id)
}
    `;
export type ChangeRefundStatusMutationFn = Apollo.MutationFunction<ChangeRefundStatusMutation, ChangeRefundStatusMutationVariables>;

/**
 * __useChangeRefundStatusMutation__
 *
 * To run a mutation, you first call `useChangeRefundStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeRefundStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeRefundStatusMutation, { data, loading, error }] = useChangeRefundStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChangeRefundStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeRefundStatusMutation, ChangeRefundStatusMutationVariables>) {
        return Apollo.useMutation<ChangeRefundStatusMutation, ChangeRefundStatusMutationVariables>(ChangeRefundStatusDocument, baseOptions);
      }
export type ChangeRefundStatusMutationHookResult = ReturnType<typeof useChangeRefundStatusMutation>;
export type ChangeRefundStatusMutationResult = Apollo.MutationResult<ChangeRefundStatusMutation>;
export type ChangeRefundStatusMutationOptions = Apollo.BaseMutationOptions<ChangeRefundStatusMutation, ChangeRefundStatusMutationVariables>;
export const UpdateRefundOnClientDocument = gql`
    mutation updateRefundOnClient($where: refunds_bool_exp! = {}, $_set: refunds_set_input = {}) {
  update_refunds(where: $where, _set: $_set) {
    returning {
      id
    }
  }
}
    `;
export type UpdateRefundOnClientMutationFn = Apollo.MutationFunction<UpdateRefundOnClientMutation, UpdateRefundOnClientMutationVariables>;

/**
 * __useUpdateRefundOnClientMutation__
 *
 * To run a mutation, you first call `useUpdateRefundOnClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRefundOnClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRefundOnClientMutation, { data, loading, error }] = useUpdateRefundOnClientMutation({
 *   variables: {
 *      where: // value for 'where'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateRefundOnClientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRefundOnClientMutation, UpdateRefundOnClientMutationVariables>) {
        return Apollo.useMutation<UpdateRefundOnClientMutation, UpdateRefundOnClientMutationVariables>(UpdateRefundOnClientDocument, baseOptions);
      }
export type UpdateRefundOnClientMutationHookResult = ReturnType<typeof useUpdateRefundOnClientMutation>;
export type UpdateRefundOnClientMutationResult = Apollo.MutationResult<UpdateRefundOnClientMutation>;
export type UpdateRefundOnClientMutationOptions = Apollo.BaseMutationOptions<UpdateRefundOnClientMutation, UpdateRefundOnClientMutationVariables>;
export const DepositsDocument = gql`
    query deposits($where: deposits_bool_exp) {
  deposits(where: $where) {
    id
    name
    amount
  }
}
    `;

/**
 * __useDepositsQuery__
 *
 * To run a query within a React component, call `useDepositsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepositsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepositsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDepositsQuery(baseOptions?: Apollo.QueryHookOptions<DepositsQuery, DepositsQueryVariables>) {
        return Apollo.useQuery<DepositsQuery, DepositsQueryVariables>(DepositsDocument, baseOptions);
      }
export function useDepositsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DepositsQuery, DepositsQueryVariables>) {
          return Apollo.useLazyQuery<DepositsQuery, DepositsQueryVariables>(DepositsDocument, baseOptions);
        }
export type DepositsQueryHookResult = ReturnType<typeof useDepositsQuery>;
export type DepositsLazyQueryHookResult = ReturnType<typeof useDepositsLazyQuery>;
export type DepositsQueryResult = Apollo.QueryResult<DepositsQuery, DepositsQueryVariables>;
export const ReceiptFilterByClassDocument = gql`
    query receiptFilterByClass($args: receipt_filter_by_class_args!) {
  receipt_filter_by_class(args: $args) {
    id
    name
  }
}
    `;

/**
 * __useReceiptFilterByClassQuery__
 *
 * To run a query within a React component, call `useReceiptFilterByClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useReceiptFilterByClassQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReceiptFilterByClassQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useReceiptFilterByClassQuery(baseOptions: Apollo.QueryHookOptions<ReceiptFilterByClassQuery, ReceiptFilterByClassQueryVariables>) {
        return Apollo.useQuery<ReceiptFilterByClassQuery, ReceiptFilterByClassQueryVariables>(ReceiptFilterByClassDocument, baseOptions);
      }
export function useReceiptFilterByClassLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReceiptFilterByClassQuery, ReceiptFilterByClassQueryVariables>) {
          return Apollo.useLazyQuery<ReceiptFilterByClassQuery, ReceiptFilterByClassQueryVariables>(ReceiptFilterByClassDocument, baseOptions);
        }
export type ReceiptFilterByClassQueryHookResult = ReturnType<typeof useReceiptFilterByClassQuery>;
export type ReceiptFilterByClassLazyQueryHookResult = ReturnType<typeof useReceiptFilterByClassLazyQuery>;
export type ReceiptFilterByClassQueryResult = Apollo.QueryResult<ReceiptFilterByClassQuery, ReceiptFilterByClassQueryVariables>;
export const GetDepositByStudentDocument = gql`
    query getDepositByStudent($limit: Int!, $offset: Int!, $where: deposits_bool_exp) {
  deposits(
    limit: $limit
    offset: $offset
    where: $where
    order_by: {createdAt: desc}
  ) {
    amount
    createdAt
    createdBy
    depositStatus
    id
    name
    receipt {
      name
      id
    }
    receiptId
    status
  }
  deposits_aggregate(where: $where) {
    aggregate {
      count(columns: id)
    }
  }
}
    `;

/**
 * __useGetDepositByStudentQuery__
 *
 * To run a query within a React component, call `useGetDepositByStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDepositByStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDepositByStudentQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetDepositByStudentQuery(baseOptions: Apollo.QueryHookOptions<GetDepositByStudentQuery, GetDepositByStudentQueryVariables>) {
        return Apollo.useQuery<GetDepositByStudentQuery, GetDepositByStudentQueryVariables>(GetDepositByStudentDocument, baseOptions);
      }
export function useGetDepositByStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDepositByStudentQuery, GetDepositByStudentQueryVariables>) {
          return Apollo.useLazyQuery<GetDepositByStudentQuery, GetDepositByStudentQueryVariables>(GetDepositByStudentDocument, baseOptions);
        }
export type GetDepositByStudentQueryHookResult = ReturnType<typeof useGetDepositByStudentQuery>;
export type GetDepositByStudentLazyQueryHookResult = ReturnType<typeof useGetDepositByStudentLazyQuery>;
export type GetDepositByStudentQueryResult = Apollo.QueryResult<GetDepositByStudentQuery, GetDepositByStudentQueryVariables>;
export const ReportRevenueBreakDownDocument = gql`
    query reportRevenueBreakDown($limit: Int, $offset: Int, $where: receipts_bool_exp) {
  receipts(
    limit: $limit
    offset: $offset
    where: $where
    order_by: {createdAt: desc}
  ) {
    invoice {
      pa {
        paymentStatus
        paymentSummaryStatic
        paymentAdviceClasses {
          class {
            programTypeGeneralId
            program {
              subject {
                id
                name
              }
              curriculums {
                id
                name
                abbreviation
                nameOfReport
              }
            }
          }
          paymentAdviceTermClasses {
            termClass {
              termName
            }
          }
        }
        createdAt
      }
    }
  }
  receipts_aggregate(where: $where) {
    aggregate {
      count(columns: id)
    }
  }
}
    `;

/**
 * __useReportRevenueBreakDownQuery__
 *
 * To run a query within a React component, call `useReportRevenueBreakDownQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportRevenueBreakDownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportRevenueBreakDownQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useReportRevenueBreakDownQuery(baseOptions?: Apollo.QueryHookOptions<ReportRevenueBreakDownQuery, ReportRevenueBreakDownQueryVariables>) {
        return Apollo.useQuery<ReportRevenueBreakDownQuery, ReportRevenueBreakDownQueryVariables>(ReportRevenueBreakDownDocument, baseOptions);
      }
export function useReportRevenueBreakDownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportRevenueBreakDownQuery, ReportRevenueBreakDownQueryVariables>) {
          return Apollo.useLazyQuery<ReportRevenueBreakDownQuery, ReportRevenueBreakDownQueryVariables>(ReportRevenueBreakDownDocument, baseOptions);
        }
export type ReportRevenueBreakDownQueryHookResult = ReturnType<typeof useReportRevenueBreakDownQuery>;
export type ReportRevenueBreakDownLazyQueryHookResult = ReturnType<typeof useReportRevenueBreakDownLazyQuery>;
export type ReportRevenueBreakDownQueryResult = Apollo.QueryResult<ReportRevenueBreakDownQuery, ReportRevenueBreakDownQueryVariables>;
export const ReportSubjectsCurriculumsDocument = gql`
    query reportSubjectsCurriculums {
  subjects(order_by: {name: asc}) {
    id
    name
    abbreviation
    programs {
      curriculums {
        id
        name
        nameOfReport
        abbreviation
      }
    }
  }
}
    `;

/**
 * __useReportSubjectsCurriculumsQuery__
 *
 * To run a query within a React component, call `useReportSubjectsCurriculumsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportSubjectsCurriculumsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportSubjectsCurriculumsQuery({
 *   variables: {
 *   },
 * });
 */
export function useReportSubjectsCurriculumsQuery(baseOptions?: Apollo.QueryHookOptions<ReportSubjectsCurriculumsQuery, ReportSubjectsCurriculumsQueryVariables>) {
        return Apollo.useQuery<ReportSubjectsCurriculumsQuery, ReportSubjectsCurriculumsQueryVariables>(ReportSubjectsCurriculumsDocument, baseOptions);
      }
export function useReportSubjectsCurriculumsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportSubjectsCurriculumsQuery, ReportSubjectsCurriculumsQueryVariables>) {
          return Apollo.useLazyQuery<ReportSubjectsCurriculumsQuery, ReportSubjectsCurriculumsQueryVariables>(ReportSubjectsCurriculumsDocument, baseOptions);
        }
export type ReportSubjectsCurriculumsQueryHookResult = ReturnType<typeof useReportSubjectsCurriculumsQuery>;
export type ReportSubjectsCurriculumsLazyQueryHookResult = ReturnType<typeof useReportSubjectsCurriculumsLazyQuery>;
export type ReportSubjectsCurriculumsQueryResult = Apollo.QueryResult<ReportSubjectsCurriculumsQuery, ReportSubjectsCurriculumsQueryVariables>;
export const ReportCurriculumsDocument = gql`
    query reportCurriculums {
  curriculums {
    id
    name
    abbreviation
    nameOfReport
    createdAt
    createdBy
    status
    updatedAt
    updatedBy
  }
}
    `;

/**
 * __useReportCurriculumsQuery__
 *
 * To run a query within a React component, call `useReportCurriculumsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCurriculumsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCurriculumsQuery({
 *   variables: {
 *   },
 * });
 */
export function useReportCurriculumsQuery(baseOptions?: Apollo.QueryHookOptions<ReportCurriculumsQuery, ReportCurriculumsQueryVariables>) {
        return Apollo.useQuery<ReportCurriculumsQuery, ReportCurriculumsQueryVariables>(ReportCurriculumsDocument, baseOptions);
      }
export function useReportCurriculumsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportCurriculumsQuery, ReportCurriculumsQueryVariables>) {
          return Apollo.useLazyQuery<ReportCurriculumsQuery, ReportCurriculumsQueryVariables>(ReportCurriculumsDocument, baseOptions);
        }
export type ReportCurriculumsQueryHookResult = ReturnType<typeof useReportCurriculumsQuery>;
export type ReportCurriculumsLazyQueryHookResult = ReturnType<typeof useReportCurriculumsLazyQuery>;
export type ReportCurriculumsQueryResult = Apollo.QueryResult<ReportCurriculumsQuery, ReportCurriculumsQueryVariables>;
export const ReportGetActiveStudentsDocument = gql`
    query reportGetActiveStudents($where: student_profiles_bool_exp) {
  student_profiles_aggregate(where: $where) {
    aggregate {
      count(columns: id)
    }
  }
}
    `;

/**
 * __useReportGetActiveStudentsQuery__
 *
 * To run a query within a React component, call `useReportGetActiveStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportGetActiveStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportGetActiveStudentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useReportGetActiveStudentsQuery(baseOptions?: Apollo.QueryHookOptions<ReportGetActiveStudentsQuery, ReportGetActiveStudentsQueryVariables>) {
        return Apollo.useQuery<ReportGetActiveStudentsQuery, ReportGetActiveStudentsQueryVariables>(ReportGetActiveStudentsDocument, baseOptions);
      }
export function useReportGetActiveStudentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportGetActiveStudentsQuery, ReportGetActiveStudentsQueryVariables>) {
          return Apollo.useLazyQuery<ReportGetActiveStudentsQuery, ReportGetActiveStudentsQueryVariables>(ReportGetActiveStudentsDocument, baseOptions);
        }
export type ReportGetActiveStudentsQueryHookResult = ReturnType<typeof useReportGetActiveStudentsQuery>;
export type ReportGetActiveStudentsLazyQueryHookResult = ReturnType<typeof useReportGetActiveStudentsLazyQuery>;
export type ReportGetActiveStudentsQueryResult = Apollo.QueryResult<ReportGetActiveStudentsQuery, ReportGetActiveStudentsQueryVariables>;
export const ReportSubjectBudgetListDocument = gql`
    query reportSubjectBudgetList {
  report_subject_budget {
    curriculum {
      id
      abbreviation
      name
    }
    subject {
      id
      name
    }
    budget
  }
}
    `;

/**
 * __useReportSubjectBudgetListQuery__
 *
 * To run a query within a React component, call `useReportSubjectBudgetListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportSubjectBudgetListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportSubjectBudgetListQuery({
 *   variables: {
 *   },
 * });
 */
export function useReportSubjectBudgetListQuery(baseOptions?: Apollo.QueryHookOptions<ReportSubjectBudgetListQuery, ReportSubjectBudgetListQueryVariables>) {
        return Apollo.useQuery<ReportSubjectBudgetListQuery, ReportSubjectBudgetListQueryVariables>(ReportSubjectBudgetListDocument, baseOptions);
      }
export function useReportSubjectBudgetListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportSubjectBudgetListQuery, ReportSubjectBudgetListQueryVariables>) {
          return Apollo.useLazyQuery<ReportSubjectBudgetListQuery, ReportSubjectBudgetListQueryVariables>(ReportSubjectBudgetListDocument, baseOptions);
        }
export type ReportSubjectBudgetListQueryHookResult = ReturnType<typeof useReportSubjectBudgetListQuery>;
export type ReportSubjectBudgetListLazyQueryHookResult = ReturnType<typeof useReportSubjectBudgetListLazyQuery>;
export type ReportSubjectBudgetListQueryResult = Apollo.QueryResult<ReportSubjectBudgetListQuery, ReportSubjectBudgetListQueryVariables>;
export const GetReportSubjectBudgetDocument = gql`
    query getReportSubjectBudget($where: report_subject_budget_bool_exp!) {
  report_subject_budget(where: $where) {
    id
    curriculum {
      name
    }
    subject {
      name
    }
    budget
  }
}
    `;

/**
 * __useGetReportSubjectBudgetQuery__
 *
 * To run a query within a React component, call `useGetReportSubjectBudgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportSubjectBudgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportSubjectBudgetQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetReportSubjectBudgetQuery(baseOptions: Apollo.QueryHookOptions<GetReportSubjectBudgetQuery, GetReportSubjectBudgetQueryVariables>) {
        return Apollo.useQuery<GetReportSubjectBudgetQuery, GetReportSubjectBudgetQueryVariables>(GetReportSubjectBudgetDocument, baseOptions);
      }
export function useGetReportSubjectBudgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportSubjectBudgetQuery, GetReportSubjectBudgetQueryVariables>) {
          return Apollo.useLazyQuery<GetReportSubjectBudgetQuery, GetReportSubjectBudgetQueryVariables>(GetReportSubjectBudgetDocument, baseOptions);
        }
export type GetReportSubjectBudgetQueryHookResult = ReturnType<typeof useGetReportSubjectBudgetQuery>;
export type GetReportSubjectBudgetLazyQueryHookResult = ReturnType<typeof useGetReportSubjectBudgetLazyQuery>;
export type GetReportSubjectBudgetQueryResult = Apollo.QueryResult<GetReportSubjectBudgetQuery, GetReportSubjectBudgetQueryVariables>;
export const CreateSubjectBudgetDocument = gql`
    mutation createSubjectBudget($object: report_subject_budget_insert_input!) {
  insert_report_subject_budget_one(object: $object) {
    subject {
      name
    }
    curriculum {
      name
    }
    budget
  }
}
    `;
export type CreateSubjectBudgetMutationFn = Apollo.MutationFunction<CreateSubjectBudgetMutation, CreateSubjectBudgetMutationVariables>;

/**
 * __useCreateSubjectBudgetMutation__
 *
 * To run a mutation, you first call `useCreateSubjectBudgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubjectBudgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubjectBudgetMutation, { data, loading, error }] = useCreateSubjectBudgetMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useCreateSubjectBudgetMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubjectBudgetMutation, CreateSubjectBudgetMutationVariables>) {
        return Apollo.useMutation<CreateSubjectBudgetMutation, CreateSubjectBudgetMutationVariables>(CreateSubjectBudgetDocument, baseOptions);
      }
export type CreateSubjectBudgetMutationHookResult = ReturnType<typeof useCreateSubjectBudgetMutation>;
export type CreateSubjectBudgetMutationResult = Apollo.MutationResult<CreateSubjectBudgetMutation>;
export type CreateSubjectBudgetMutationOptions = Apollo.BaseMutationOptions<CreateSubjectBudgetMutation, CreateSubjectBudgetMutationVariables>;
export const UpdateSubjectBudgetDocument = gql`
    mutation updateSubjectBudget($where: report_subject_budget_bool_exp!, $object: report_subject_budget_set_input) {
  update_report_subject_budget(where: $where, _set: $object) {
    returning {
      budget
    }
  }
}
    `;
export type UpdateSubjectBudgetMutationFn = Apollo.MutationFunction<UpdateSubjectBudgetMutation, UpdateSubjectBudgetMutationVariables>;

/**
 * __useUpdateSubjectBudgetMutation__
 *
 * To run a mutation, you first call `useUpdateSubjectBudgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubjectBudgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubjectBudgetMutation, { data, loading, error }] = useUpdateSubjectBudgetMutation({
 *   variables: {
 *      where: // value for 'where'
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpdateSubjectBudgetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubjectBudgetMutation, UpdateSubjectBudgetMutationVariables>) {
        return Apollo.useMutation<UpdateSubjectBudgetMutation, UpdateSubjectBudgetMutationVariables>(UpdateSubjectBudgetDocument, baseOptions);
      }
export type UpdateSubjectBudgetMutationHookResult = ReturnType<typeof useUpdateSubjectBudgetMutation>;
export type UpdateSubjectBudgetMutationResult = Apollo.MutationResult<UpdateSubjectBudgetMutation>;
export type UpdateSubjectBudgetMutationOptions = Apollo.BaseMutationOptions<UpdateSubjectBudgetMutation, UpdateSubjectBudgetMutationVariables>;
export const GetSystemSettingsDocument = gql`
    query getSystemSettings($filter: system_settings_bool_exp) {
  system_settings(where: $filter) {
    ...systemSettingModelFinal
  }
}
    ${SystemSettingModelFinalFragmentDoc}`;

/**
 * __useGetSystemSettingsQuery__
 *
 * To run a query within a React component, call `useGetSystemSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemSettingsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSystemSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>) {
        return Apollo.useQuery<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>(GetSystemSettingsDocument, baseOptions);
      }
export function useGetSystemSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>) {
          return Apollo.useLazyQuery<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>(GetSystemSettingsDocument, baseOptions);
        }
export type GetSystemSettingsQueryHookResult = ReturnType<typeof useGetSystemSettingsQuery>;
export type GetSystemSettingsLazyQueryHookResult = ReturnType<typeof useGetSystemSettingsLazyQuery>;
export type GetSystemSettingsQueryResult = Apollo.QueryResult<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>;
export const DeleteStudentDocument = gql`
    mutation deleteStudent($studentId: uuid!) {
  update_users(where: {id: {_eq: $studentId}}, _set: {status: "deleted"}) {
    affected_rows
    returning {
      fullName
    }
  }
}
    `;
export type DeleteStudentMutationFn = Apollo.MutationFunction<DeleteStudentMutation, DeleteStudentMutationVariables>;

/**
 * __useDeleteStudentMutation__
 *
 * To run a mutation, you first call `useDeleteStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStudentMutation, { data, loading, error }] = useDeleteStudentMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useDeleteStudentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStudentMutation, DeleteStudentMutationVariables>) {
        return Apollo.useMutation<DeleteStudentMutation, DeleteStudentMutationVariables>(DeleteStudentDocument, baseOptions);
      }
export type DeleteStudentMutationHookResult = ReturnType<typeof useDeleteStudentMutation>;
export type DeleteStudentMutationResult = Apollo.MutationResult<DeleteStudentMutation>;
export type DeleteStudentMutationOptions = Apollo.BaseMutationOptions<DeleteStudentMutation, DeleteStudentMutationVariables>;
export const UpdateStudentToVmsDocument = gql`
    mutation updateStudentToVms($userId: String!) {
  updateStudentToVms(studentId: $userId)
}
    `;
export type UpdateStudentToVmsMutationFn = Apollo.MutationFunction<UpdateStudentToVmsMutation, UpdateStudentToVmsMutationVariables>;

/**
 * __useUpdateStudentToVmsMutation__
 *
 * To run a mutation, you first call `useUpdateStudentToVmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentToVmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentToVmsMutation, { data, loading, error }] = useUpdateStudentToVmsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateStudentToVmsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentToVmsMutation, UpdateStudentToVmsMutationVariables>) {
        return Apollo.useMutation<UpdateStudentToVmsMutation, UpdateStudentToVmsMutationVariables>(UpdateStudentToVmsDocument, baseOptions);
      }
export type UpdateStudentToVmsMutationHookResult = ReturnType<typeof useUpdateStudentToVmsMutation>;
export type UpdateStudentToVmsMutationResult = Apollo.MutationResult<UpdateStudentToVmsMutation>;
export type UpdateStudentToVmsMutationOptions = Apollo.BaseMutationOptions<UpdateStudentToVmsMutation, UpdateStudentToVmsMutationVariables>;
export const ForceChangeUserPasswordDocument = gql`
    mutation forceChangeUserPassword($form: FormChangeUserPassword!) {
  changeUserPassword(form: $form)
}
    `;
export type ForceChangeUserPasswordMutationFn = Apollo.MutationFunction<ForceChangeUserPasswordMutation, ForceChangeUserPasswordMutationVariables>;

/**
 * __useForceChangeUserPasswordMutation__
 *
 * To run a mutation, you first call `useForceChangeUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceChangeUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceChangeUserPasswordMutation, { data, loading, error }] = useForceChangeUserPasswordMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useForceChangeUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForceChangeUserPasswordMutation, ForceChangeUserPasswordMutationVariables>) {
        return Apollo.useMutation<ForceChangeUserPasswordMutation, ForceChangeUserPasswordMutationVariables>(ForceChangeUserPasswordDocument, baseOptions);
      }
export type ForceChangeUserPasswordMutationHookResult = ReturnType<typeof useForceChangeUserPasswordMutation>;
export type ForceChangeUserPasswordMutationResult = Apollo.MutationResult<ForceChangeUserPasswordMutation>;
export type ForceChangeUserPasswordMutationOptions = Apollo.BaseMutationOptions<ForceChangeUserPasswordMutation, ForceChangeUserPasswordMutationVariables>;
export const SuggestionUsernameDocument = gql`
    mutation suggestionUsername($form: SuggestionForm!) {
  suggestionUsername(form: $form)
}
    `;
export type SuggestionUsernameMutationFn = Apollo.MutationFunction<SuggestionUsernameMutation, SuggestionUsernameMutationVariables>;

/**
 * __useSuggestionUsernameMutation__
 *
 * To run a mutation, you first call `useSuggestionUsernameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuggestionUsernameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suggestionUsernameMutation, { data, loading, error }] = useSuggestionUsernameMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useSuggestionUsernameMutation(baseOptions?: Apollo.MutationHookOptions<SuggestionUsernameMutation, SuggestionUsernameMutationVariables>) {
        return Apollo.useMutation<SuggestionUsernameMutation, SuggestionUsernameMutationVariables>(SuggestionUsernameDocument, baseOptions);
      }
export type SuggestionUsernameMutationHookResult = ReturnType<typeof useSuggestionUsernameMutation>;
export type SuggestionUsernameMutationResult = Apollo.MutationResult<SuggestionUsernameMutation>;
export type SuggestionUsernameMutationOptions = Apollo.BaseMutationOptions<SuggestionUsernameMutation, SuggestionUsernameMutationVariables>;
export const ChangeUsernameDocument = gql`
    mutation changeUsername($form: FormChangeUsername!) {
  changeUsername(form: $form)
}
    `;
export type ChangeUsernameMutationFn = Apollo.MutationFunction<ChangeUsernameMutation, ChangeUsernameMutationVariables>;

/**
 * __useChangeUsernameMutation__
 *
 * To run a mutation, you first call `useChangeUsernameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUsernameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUsernameMutation, { data, loading, error }] = useChangeUsernameMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useChangeUsernameMutation(baseOptions?: Apollo.MutationHookOptions<ChangeUsernameMutation, ChangeUsernameMutationVariables>) {
        return Apollo.useMutation<ChangeUsernameMutation, ChangeUsernameMutationVariables>(ChangeUsernameDocument, baseOptions);
      }
export type ChangeUsernameMutationHookResult = ReturnType<typeof useChangeUsernameMutation>;
export type ChangeUsernameMutationResult = Apollo.MutationResult<ChangeUsernameMutation>;
export type ChangeUsernameMutationOptions = Apollo.BaseMutationOptions<ChangeUsernameMutation, ChangeUsernameMutationVariables>;
export const GetUserRolesDocument = gql`
    query getUserRoles($where: users_bool_exp) {
  users(distinct_on: role, where: $where) {
    role
  }
}
    `;

/**
 * __useGetUserRolesQuery__
 *
 * To run a query within a React component, call `useGetUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRolesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetUserRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserRolesQuery, GetUserRolesQueryVariables>) {
        return Apollo.useQuery<GetUserRolesQuery, GetUserRolesQueryVariables>(GetUserRolesDocument, baseOptions);
      }
export function useGetUserRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserRolesQuery, GetUserRolesQueryVariables>) {
          return Apollo.useLazyQuery<GetUserRolesQuery, GetUserRolesQueryVariables>(GetUserRolesDocument, baseOptions);
        }
export type GetUserRolesQueryHookResult = ReturnType<typeof useGetUserRolesQuery>;
export type GetUserRolesLazyQueryHookResult = ReturnType<typeof useGetUserRolesLazyQuery>;
export type GetUserRolesQueryResult = Apollo.QueryResult<GetUserRolesQuery, GetUserRolesQueryVariables>;
export const GetRolesDocument = gql`
    query getRoles {
  roles {
    abbreviation
    id
    name
    role
  }
}
    `;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
        return Apollo.useQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, baseOptions);
      }
export function useGetRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          return Apollo.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, baseOptions);
        }
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<GetRolesQuery, GetRolesQueryVariables>;
export const GetUserByIdAfterDocument = gql`
    query getUserByIdAfter($idUser: uuid!) {
  users_by_pk(id: $idUser) {
    email
    phone
    id
    username
    studentProfile {
      payOnline
    }
  }
}
    `;

/**
 * __useGetUserByIdAfterQuery__
 *
 * To run a query within a React component, call `useGetUserByIdAfterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByIdAfterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByIdAfterQuery({
 *   variables: {
 *      idUser: // value for 'idUser'
 *   },
 * });
 */
export function useGetUserByIdAfterQuery(baseOptions: Apollo.QueryHookOptions<GetUserByIdAfterQuery, GetUserByIdAfterQueryVariables>) {
        return Apollo.useQuery<GetUserByIdAfterQuery, GetUserByIdAfterQueryVariables>(GetUserByIdAfterDocument, baseOptions);
      }
export function useGetUserByIdAfterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByIdAfterQuery, GetUserByIdAfterQueryVariables>) {
          return Apollo.useLazyQuery<GetUserByIdAfterQuery, GetUserByIdAfterQueryVariables>(GetUserByIdAfterDocument, baseOptions);
        }
export type GetUserByIdAfterQueryHookResult = ReturnType<typeof useGetUserByIdAfterQuery>;
export type GetUserByIdAfterLazyQueryHookResult = ReturnType<typeof useGetUserByIdAfterLazyQuery>;
export type GetUserByIdAfterQueryResult = Apollo.QueryResult<GetUserByIdAfterQuery, GetUserByIdAfterQueryVariables>;
export const GetGantryUserRecordsDocument = gql`
    mutation getGantryUserRecords($form: GantryUserRecordsForm!) {
  getGantryUserRecords(form: $form) {
    code
    msg
    data {
      pageNo
      pageSize
      total
      list {
        eventId
        eventType
        eventTime
        personId
        personName
        doorName
        doorIndexCode
        cardNo
        checkInAndOutType
        picUri
        deviceTime
        temperatureData
        temperatureStatus
        wearMaskStatus
      }
    }
  }
}
    `;
export type GetGantryUserRecordsMutationFn = Apollo.MutationFunction<GetGantryUserRecordsMutation, GetGantryUserRecordsMutationVariables>;

/**
 * __useGetGantryUserRecordsMutation__
 *
 * To run a mutation, you first call `useGetGantryUserRecordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetGantryUserRecordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getGantryUserRecordsMutation, { data, loading, error }] = useGetGantryUserRecordsMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useGetGantryUserRecordsMutation(baseOptions?: Apollo.MutationHookOptions<GetGantryUserRecordsMutation, GetGantryUserRecordsMutationVariables>) {
        return Apollo.useMutation<GetGantryUserRecordsMutation, GetGantryUserRecordsMutationVariables>(GetGantryUserRecordsDocument, baseOptions);
      }
export type GetGantryUserRecordsMutationHookResult = ReturnType<typeof useGetGantryUserRecordsMutation>;
export type GetGantryUserRecordsMutationResult = Apollo.MutationResult<GetGantryUserRecordsMutation>;
export type GetGantryUserRecordsMutationOptions = Apollo.BaseMutationOptions<GetGantryUserRecordsMutation, GetGantryUserRecordsMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($studentEmail: String!) {
  forgotStudentPassword(studentEmail: $studentEmail) {
    email
    username
    status
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      studentEmail: // value for 'studentEmail'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, baseOptions);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const ConfirmPasswordDocument = gql`
    mutation confirmPassword($code: String!, $newPassword: String!, $username: String!) {
  confirmStudentForgotPassword(
    confirmationCode: $code
    newPassword: $newPassword
    username: $username
  )
}
    `;
export type ConfirmPasswordMutationFn = Apollo.MutationFunction<ConfirmPasswordMutation, ConfirmPasswordMutationVariables>;

/**
 * __useConfirmPasswordMutation__
 *
 * To run a mutation, you first call `useConfirmPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmPasswordMutation, { data, loading, error }] = useConfirmPasswordMutation({
 *   variables: {
 *      code: // value for 'code'
 *      newPassword: // value for 'newPassword'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useConfirmPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmPasswordMutation, ConfirmPasswordMutationVariables>) {
        return Apollo.useMutation<ConfirmPasswordMutation, ConfirmPasswordMutationVariables>(ConfirmPasswordDocument, baseOptions);
      }
export type ConfirmPasswordMutationHookResult = ReturnType<typeof useConfirmPasswordMutation>;
export type ConfirmPasswordMutationResult = Apollo.MutationResult<ConfirmPasswordMutation>;
export type ConfirmPasswordMutationOptions = Apollo.BaseMutationOptions<ConfirmPasswordMutation, ConfirmPasswordMutationVariables>;